/* tslint:disable */
/* eslint-disable */
/**
 * Curewiki Matching Service
 * The Curewiki matching service API - Collecting user attributes and interacting with the user chat   Don\'t forget to add the prefix (**match**)  Some other useful links:   - [Identity service (local)](http://127.0.0.1:4005/docs)  - [Matching service (local)](http://127.0.0.1:4006/docs)  - [Test Matching service (local)](http://127.0.0.1:4008/docs)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptExistingTeamInviteBody
 */
export interface AcceptExistingTeamInviteBody {
    /**
     * 
     * @type {string}
     * @memberof AcceptExistingTeamInviteBody
     */
    'tokenValue': string;
}
/**
 * 
 * @export
 * @interface AcceptExistingUserInviteBody
 */
export interface AcceptExistingUserInviteBody {
    /**
     * 
     * @type {string}
     * @memberof AcceptExistingUserInviteBody
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptExistingUserInviteBody
     */
    'teamRole'?: string;
}
/**
 * 
 * @export
 * @interface AcceptMilestoneTokenBody
 */
export interface AcceptMilestoneTokenBody {
    /**
     * 
     * @type {Language}
     * @memberof AcceptMilestoneTokenBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof AcceptMilestoneTokenBody
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptMilestoneTokenBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptMilestoneTokenBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptMilestoneTokenBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptMilestoneTokenBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptMilestoneTokenBody
     */
    'theme': AcceptMilestoneTokenBodyThemeEnum;
    /**
     * 
     * @type {string}
     * @memberof AcceptMilestoneTokenBody
     */
    'country': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AcceptMilestoneTokenBody
     */
    'diseases': Array<string>;
}

export const AcceptMilestoneTokenBodyThemeEnum = {
    Curewiki: 'Curewiki',
    YesWeCancer: 'YesWeCancer',
    Bhs: 'BHS',
    Pce: 'PCE',
    Pec: 'PEC'
} as const;

export type AcceptMilestoneTokenBodyThemeEnum = typeof AcceptMilestoneTokenBodyThemeEnum[keyof typeof AcceptMilestoneTokenBodyThemeEnum];

/**
 * 
 * @export
 * @interface AcceptMilestoneTokenExistingBody
 */
export interface AcceptMilestoneTokenExistingBody {
    /**
     * 
     * @type {string}
     * @memberof AcceptMilestoneTokenExistingBody
     */
    'tokenValue': string;
}
/**
 * 
 * @export
 * @interface AcceptNewUserInviteBody
 */
export interface AcceptNewUserInviteBody {
    /**
     * 
     * @type {Language}
     * @memberof AcceptNewUserInviteBody
     */
    'language': Language;
    /**
     * 
     * @type {ThemeType}
     * @memberof AcceptNewUserInviteBody
     */
    'theme': ThemeType;
    /**
     * 
     * @type {Gender}
     * @memberof AcceptNewUserInviteBody
     */
    'gender'?: Gender;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'teamRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'birthDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AcceptNewUserInviteBody
     */
    'diseases'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'hospital'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AcceptanceFlow = {
    Manual: 'manual',
    AutoApprove: 'autoApprove',
    Redirect: 'redirect',
    ExternalContact: 'externalContact'
} as const;

export type AcceptanceFlow = typeof AcceptanceFlow[keyof typeof AcceptanceFlow];


/**
 * 
 * @export
 * @enum {string}
 */

export const AccessRequestStatus = {
    None: 'none',
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type AccessRequestStatus = typeof AccessRequestStatus[keyof typeof AccessRequestStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ActivityType = {
    Create: 'create',
    Deactivate: 'deactivate',
    Feedback: 'feedback',
    Comment: 'comment',
    Validate: 'validate',
    Synced: 'synced',
    Deleted: 'deleted',
    Completed: 'completed',
    Restored: 'restored',
    RequestCriteria: 'requestCriteria',
    AddEffect: 'addEffect',
    RemoveEffect: 'removeEffect',
    SplitApproved: 'split_approved',
    SplitRejected: 'split_rejected',
    SplitTreeEdited: 'split_tree_edited',
    SplitTextEdited: 'split_text_edited',
    SplitAtomAdded: 'split_atom_added',
    SplitCohortEdited: 'split_cohort_edited',
    SplitAtomRemoved: 'split_atom_removed',
    MergeAccepted: 'merge_accepted',
    MergeRejected: 'merge_rejected',
    LibraryPromoted: 'library_promoted',
    CohortApproved: 'cohort_approved',
    CohortRejected: 'cohort_rejected',
    IcdHintApproved: 'icd_hint_approved',
    IcdHintRejected: 'icd_hint_rejected',
    PrescreenConfirmed: 'prescreen_confirmed',
    PrescreenOverturned: 'prescreen_overturned',
    OntologyApproved: 'ontology_approved',
    OntologyRejected: 'ontology_rejected',
    JudgeFlaggedEdit: 'judge_flagged_edit',
    ConversionRecomputed: 'conversion_recomputed',
    ReviewUndone: 'review_undone',
    CanonicalTypeRenamed: 'canonical_type_renamed',
    CanonicalTypeMerged: 'canonical_type_merged',
    CanonicalTypeCreated: 'canonical_type_created',
    DependencyProposalApproved: 'dependency_proposal_approved',
    DependencyProposalRejected: 'dependency_proposal_rejected',
    PredicateDeactivated: 'predicate_deactivated',
    PredicateActivated: 'predicate_activated',
    PredicateChangeSuggested: 'predicate_change_suggested'
} as const;

export type ActivityType = typeof ActivityType[keyof typeof ActivityType];


/**
 * 
 * @export
 * @interface AddCategoryDiseaseBody
 */
export interface AddCategoryDiseaseBody {
    /**
     * 
     * @type {string}
     * @memberof AddCategoryDiseaseBody
     */
    'diseaseId': string;
}
/**
 * 
 * @export
 * @interface AddQuestionCategoryBody
 */
export interface AddQuestionCategoryBody {
    /**
     * 
     * @type {string}
     * @memberof AddQuestionCategoryBody
     */
    'categoryId': string;
}
/**
 * 
 * @export
 * @interface AdminOverviewView
 */
export interface AdminOverviewView {
    /**
     * 
     * @type {string}
     * @memberof AdminOverviewView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOverviewView
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOverviewView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOverviewView
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface AdminTrialAccessListView
 */
export interface AdminTrialAccessListView {
    /**
     * 
     * @type {Array<AdminTrialAccessView>}
     * @memberof AdminTrialAccessListView
     */
    'items': Array<AdminTrialAccessView>;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessListView
     */
    'nextPageToken'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminTrialAccessListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AdminTrialAccessView
 */
export interface AdminTrialAccessView {
    /**
     * 
     * @type {Language}
     * @memberof AdminTrialAccessView
     */
    'language': Language;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof AdminTrialAccessView
     */
    'status': AccessRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'matchingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'teamName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'teamLeadName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'organizationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'researchSiteName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'requestMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'role': AdminTrialAccessViewRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTrialAccessView
     */
    'isExistingTrial': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTrialAccessView
     */
    'isManaged': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'createdAt': string;
    /**
     * 
     * @type {TrialAccessLocation}
     * @memberof AdminTrialAccessView
     */
    'location'?: TrialAccessLocation;
}

export const AdminTrialAccessViewRoleEnum = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type AdminTrialAccessViewRoleEnum = typeof AdminTrialAccessViewRoleEnum[keyof typeof AdminTrialAccessViewRoleEnum];

/**
 * 
 * @export
 * @interface AdvanceMilestoneView
 */
export interface AdvanceMilestoneView {
    /**
     * 
     * @type {boolean}
     * @memberof AdvanceMilestoneView
     */
    'advanced': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvanceMilestoneView
     */
    'milestoneName'?: string | null;
}
/**
 * 
 * @export
 * @interface AiProcessorView
 */
export interface AiProcessorView {
    /**
     * 
     * @type {string}
     * @memberof AiProcessorView
     */
    'modelName': string;
    /**
     * 
     * @type {string}
     * @memberof AiProcessorView
     */
    'provider': string;
}
/**
 * 
 * @export
 * @interface AnonymousClaimBody
 */
export interface AnonymousClaimBody {
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface AnonymousLoginView
 */
export interface AnonymousLoginView {
    /**
     * 
     * @type {string}
     * @memberof AnonymousLoginView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousLoginView
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousLoginView
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousLoginView
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface AnonymousSignUpBody
 */
export interface AnonymousSignUpBody {
    /**
     * 
     * @type {Language}
     * @memberof AnonymousSignUpBody
     */
    'language': Language;
    /**
     * 
     * @type {ThemeType}
     * @memberof AnonymousSignUpBody
     */
    'theme'?: ThemeType;
}


/**
 * 
 * @export
 * @interface AnswerChatBody
 */
export interface AnswerChatBody {
    /**
     * 
     * @type {Language}
     * @memberof AnswerChatBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof AnswerChatBody
     */
    'value': string;
    /**
     * 
     * @type {boolean}
     * @memberof AnswerChatBody
     */
    'isCustomValue'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AnswerType = {
    Boolean: 'boolean',
    Number: 'number',
    String: 'string',
    Date: 'date',
    Options: 'options',
    MultipleOptions: 'multipleOptions'
} as const;

export type AnswerType = typeof AnswerType[keyof typeof AnswerType];


/**
 * 
 * @export
 * @interface ApproveLocationChangeBody
 */
export interface ApproveLocationChangeBody {
    /**
     * 
     * @type {string}
     * @memberof ApproveLocationChangeBody
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface AssignMandateBody
 */
export interface AssignMandateBody {
    /**
     * 
     * @type {string}
     * @memberof AssignMandateBody
     */
    'teamId': string;
}
/**
 * 
 * @export
 * @interface AtomPrescreenDecisionBody
 */
export interface AtomPrescreenDecisionBody {
    /**
     * 
     * @type {PrescreenDecision}
     * @memberof AtomPrescreenDecisionBody
     */
    'prescreenDecision': PrescreenDecision;
    /**
     * 
     * @type {string}
     * @memberof AtomPrescreenDecisionBody
     */
    'predicateId': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AttributeFilter = {
    Hidden: 'hidden',
    Visible: 'visible',
    All: 'all',
    Profile: 'profile'
} as const;

export type AttributeFilter = typeof AttributeFilter[keyof typeof AttributeFilter];


/**
 * 
 * @export
 * @interface AttributeView
 */
export interface AttributeView {
    /**
     * 
     * @type {AnswerType}
     * @memberof AttributeView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof AttributeView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof AttributeView
     */
    'questionText': string;
    /**
     * 
     * @type {string}
     * @memberof AttributeView
     */
    'translationKey': string;
    /**
     * 
     * @type {string}
     * @memberof AttributeView
     */
    'answer': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BehalfOf = {
    Myself: 'myself',
    Child: 'child',
    Patient: 'patient',
    Friend: 'friend',
    Parent: 'parent',
    Partner: 'partner',
    Other: 'other'
} as const;

export type BehalfOf = typeof BehalfOf[keyof typeof BehalfOf];


/**
 * 
 * @export
 * @enum {string}
 */

export const BillingType = {
    Free: 'free',
    Premium: 'premium'
} as const;

export type BillingType = typeof BillingType[keyof typeof BillingType];


/**
 * 
 * @export
 * @interface BlastRadiusDiseaseView
 */
export interface BlastRadiusDiseaseView {
    /**
     * 
     * @type {string}
     * @memberof BlastRadiusDiseaseView
     */
    'icdCode': string;
    /**
     * 
     * @type {string}
     * @memberof BlastRadiusDiseaseView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CategoryContextTranslationView
 */
export interface CategoryContextTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof CategoryContextTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof CategoryContextTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof CategoryContextTranslationView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof CategoryContextTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryContextTranslationView
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryContextTranslationView
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface CategoryContextTranslationsBody
 */
export interface CategoryContextTranslationsBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof CategoryContextTranslationsBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface CategoryCreateBody
 */
export interface CategoryCreateBody {
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'parentCategoryId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryCreateBody
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'context'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'type': CategoryCreateBodyTypeEnum;
    /**
     * ICD-10 ranges (e.g. [\"C00-C96\"]) that gate this block to matching patients in the standard flow.
     * @type {Array<string>}
     * @memberof CategoryCreateBody
     */
    'icdRanges'?: Array<string>;
}

export const CategoryCreateBodyTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type CategoryCreateBodyTypeEnum = typeof CategoryCreateBodyTypeEnum[keyof typeof CategoryCreateBodyTypeEnum];

/**
 * 
 * @export
 * @interface CategoryDetailsView
 */
export interface CategoryDetailsView {
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'shortName': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'parentCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'context'?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryDetailsView
     */
    'contextKey'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'type': CategoryDetailsViewTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CategoryDetailsView
     */
    'priority': number;
}

export const CategoryDetailsViewTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type CategoryDetailsViewTypeEnum = typeof CategoryDetailsViewTypeEnum[keyof typeof CategoryDetailsViewTypeEnum];

/**
 * 
 * @export
 * @interface CategoryDiseaseView
 */
export interface CategoryDiseaseView {
    /**
     * 
     * @type {string}
     * @memberof CategoryDiseaseView
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDiseaseView
     */
    'diseaseId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDiseaseView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDiseaseView
     */
    'icdCode': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CategoryOrderBy = {
    ShortName: 'shortName',
    TrialCount: 'trialCount'
} as const;

export type CategoryOrderBy = typeof CategoryOrderBy[keyof typeof CategoryOrderBy];


/**
 * 
 * @export
 * @interface CategoryQuestionView
 */
export interface CategoryQuestionView {
    /**
     * 
     * @type {AnswerType}
     * @memberof CategoryQuestionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {QuestionType}
     * @memberof CategoryQuestionView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {string}
     * @memberof CategoryQuestionView
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryQuestionView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryQuestionView
     */
    'questionText': string;
}


/**
 * 
 * @export
 * @interface CategorySearchView
 */
export interface CategorySearchView {
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'shortName': string;
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'parentCategory'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategorySearchView
     */
    'diseases': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategorySearchView
     */
    'icdCodes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'type': CategorySearchViewTypeEnum;
}

export const CategorySearchViewTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type CategorySearchViewTypeEnum = typeof CategorySearchViewTypeEnum[keyof typeof CategorySearchViewTypeEnum];

/**
 * 
 * @export
 * @interface CategoryTreeView
 */
export interface CategoryTreeView {
    /**
     * 
     * @type {Array<NestedCategoryView>}
     * @memberof CategoryTreeView
     */
    'topLevelCategories': Array<NestedCategoryView>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CategoryType = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type CategoryType = typeof CategoryType[keyof typeof CategoryType];


/**
 * 
 * @export
 * @interface CategoryUpdateBody
 */
export interface CategoryUpdateBody {
    /**
     * 
     * @type {number}
     * @memberof CategoryUpdateBody
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdateBody
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdateBody
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatEntryDestination = {
    MyTrials: 'myTrials',
    Trial: 'trial',
    TrialUpdates: 'trialUpdates',
    Support: 'support',
    Volunteers: 'volunteers',
    Collaborators: 'collaborators',
    Survey: 'survey',
    MySurveys: 'mySurveys',
    Research: 'research',
    Panel: 'panel',
    WidenSearch: 'widenSearch'
} as const;

export type ChatEntryDestination = typeof ChatEntryDestination[keyof typeof ChatEntryDestination];


/**
 * 
 * @export
 * @interface ChatEntryView
 */
export interface ChatEntryView {
    /**
     * 
     * @type {AnswerType}
     * @memberof ChatEntryView
     */
    'answerType'?: AnswerType;
    /**
     * 
     * @type {MessageType}
     * @memberof ChatEntryView
     */
    'messageType': MessageType;
    /**
     * 
     * @type {ChatStatus}
     * @memberof ChatEntryView
     */
    'status': ChatStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof ChatEntryView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'chatEntryId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'unit': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'questionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'text': string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatEntryView
     */
    'isSkippable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatEntryView
     */
    'isPhysician': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatEntryView
     */
    'isDiversityQuestion': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'answer'?: string | null;
    /**
     * 
     * @type {ContextView}
     * @memberof ChatEntryView
     */
    'context'?: ContextView | null;
    /**
     * 
     * @type {Array<OptionView>}
     * @memberof ChatEntryView
     */
    'options'?: Array<OptionView>;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'questionContext'?: string | null;
}


/**
 * 
 * @export
 * @interface ChatProgressView
 */
export interface ChatProgressView {
    /**
     * `answered / total` for the tier at `currentPhaseIndex`, scoped to that one tier so the fraction matches the name the client renders beside it. Both null unless that tier is flagged `exhaustive` — anything else is demand-driven and has nothing to count.
     * @type {number}
     * @memberof ChatProgressView
     */
    'currentPhaseAnswered'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatProgressView
     */
    'currentPhaseTotal'?: number | null;
    /**
     * Every tier with a question in this patient\'s scope, in `Tier.order`. Resolved in the patient\'s language from `Tier.nameHashedKey`, so the client renders them as given. `currentPhaseIndex` marks the position in this list: earlier tiers are done, later ones are not started.
     * @type {Array<string>}
     * @memberof ChatProgressView
     */
    'phaseNames': Array<string>;
    /**
     * Position in `phaseNames` of the tier currently being asked from, or null when no tier is open. `finished` tells the end of the chat from its start. An index rather than a name: `Tier.name` carries no unique constraint, and two tiers can collide once translated.
     * @type {number}
     * @memberof ChatProgressView
     */
    'currentPhaseIndex'?: number | null;
    /**
     * True once the patient has nothing left to ask. A null `currentPhaseIndex` alone does not say this: it is also null before the first engine pass, when no tier has started yet.
     * @type {boolean}
     * @memberof ChatProgressView
     */
    'finished': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatStatus = {
    Unseen: 'unseen',
    Seen: 'seen',
    Skipped: 'skipped',
    Answered: 'answered'
} as const;

export type ChatStatus = typeof ChatStatus[keyof typeof ChatStatus];


/**
 * 
 * @export
 * @interface ChatbotMonthView
 */
export interface ChatbotMonthView {
    /**
     * 
     * @type {string}
     * @memberof ChatbotMonthView
     */
    'month': string;
    /**
     * 
     * @type {number}
     * @memberof ChatbotMonthView
     */
    'answeredCount': number;
    /**
     * 
     * @type {number}
     * @memberof ChatbotMonthView
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof ChatbotMonthView
     */
    'skippedRate': number;
}
/**
 * 
 * @export
 * @interface ChatbotQuestionView
 */
export interface ChatbotQuestionView {
    /**
     * 
     * @type {string}
     * @memberof ChatbotQuestionView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatbotQuestionView
     */
    'questionText': string;
    /**
     * 
     * @type {string}
     * @memberof ChatbotQuestionView
     */
    'questionType': string;
    /**
     * 
     * @type {string}
     * @memberof ChatbotQuestionView
     */
    'answerType': string;
    /**
     * 
     * @type {string}
     * @memberof ChatbotQuestionView
     */
    'generationType': string;
    /**
     * 
     * @type {number}
     * @memberof ChatbotQuestionView
     */
    'answeredCount': number;
    /**
     * 
     * @type {number}
     * @memberof ChatbotQuestionView
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof ChatbotQuestionView
     */
    'trialCount': number;
    /**
     * 
     * @type {number}
     * @memberof ChatbotQuestionView
     */
    'icdCount': number;
}
/**
 * 
 * @export
 * @interface ChatbotView
 */
export interface ChatbotView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof ChatbotView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {Array<ChatbotMonthView>}
     * @memberof ChatbotView
     */
    'byMonth': Array<ChatbotMonthView>;
    /**
     * 
     * @type {number}
     * @memberof ChatbotView
     */
    'answeredCount': number;
    /**
     * 
     * @type {number}
     * @memberof ChatbotView
     */
    'skippedCount': number;
    /**
     * 
     * @type {Array<ChatbotQuestionView>}
     * @memberof ChatbotView
     */
    'questions': Array<ChatbotQuestionView>;
    /**
     * 
     * @type {number}
     * @memberof ChatbotView
     */
    'hiddenQuestionCount': number;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof ChatbotView
     */
    'bySkipReason': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof ChatbotView
     */
    'byAnswer': ReportingTieredBreakdownView;
}


/**
 * 
 * @export
 * @interface CheckoutView
 */
export interface CheckoutView {
    /**
     * 
     * @type {string}
     * @memberof CheckoutView
     */
    'checkoutUrl': string;
}
/**
 * 
 * @export
 * @interface CohortIcdHintView
 */
export interface CohortIcdHintView {
    /**
     * 
     * @type {string}
     * @memberof CohortIcdHintView
     */
    'icdCode': string;
    /**
     * 
     * @type {string}
     * @memberof CohortIcdHintView
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface CohortView
 */
export interface CohortView {
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof CohortView
     */
    'cohortStatus'?: PipelineReviewStatus;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof CohortView
     */
    'icdHintStatus'?: PipelineReviewStatus;
    /**
     * The axes this row still has a reviewer\'s verdict to take back, from the ledger. A terminal status is not enough on its own: a row its step auto-approved, or one decided before the ledger recorded axes, has nothing to reverse.
     * @type {Array<string>}
     * @memberof CohortView
     */
    'undoableAxes': Array<CohortViewUndoableAxesEnum>;
    /**
     * The cohort\'s audit trail, newest first — the only place a reviewer\'s adjust reason and the label it replaced survive. Populated by the detail endpoint alone; the list returns an empty array to keep the payload small.
     * @type {Array<CriteriaActivityView>}
     * @memberof CohortView
     */
    'activities': Array<CriteriaActivityView>;
    /**
     * 
     * @type {string}
     * @memberof CohortView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CohortView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CohortView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CohortView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof CohortView
     */
    'label': string;
    /**
     * Why the cohort was flagged — the judge\'s rationale for this cohort.
     * @type {string}
     * @memberof CohortView
     */
    'cohortReviewReason'?: string | null;
    /**
     * The passage of source text the judge\'s verdict rests on, verbatim, for the reviewer surface to highlight. Present on agreed cohorts too, where it is the sentence the cohort comes from. Null when the judge had no passage to point at or the cohort was added by hand.
     * @type {string}
     * @memberof CohortView
     */
    'cohortReviewSourceQuote'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CohortView
     */
    'populationIcdHints'?: Array<string> | null;
    /**
     * The same hints with their catalog names, in the same order. Kept alongside the bare codes rather than replacing them: `populationIcdHints` is the shape the update body takes back, so an editor round-trips it unchanged while the display reads names from here.
     * @type {Array<CohortIcdHintView>}
     * @memberof CohortView
     */
    'icdHints': Array<CohortIcdHintView>;
    /**
     * Why the hints were flagged — an unresolved code, or the judge\'s rationale.
     * @type {string}
     * @memberof CohortView
     */
    'icdHintReviewReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CohortView
     */
    'sortOrder': number;
}

export const CohortViewUndoableAxesEnum = {
    Legacy: 'legacy',
    Step1: 'step-1',
    Step2: 'step-2',
    Step3: 'step-3',
    Step4: 'step-4',
    Step5: 'step-5',
    Step6: 'step-6',
    Step7: 'step-7',
    Step8: 'step-8'
} as const;

export type CohortViewUndoableAxesEnum = typeof CohortViewUndoableAxesEnum[keyof typeof CohortViewUndoableAxesEnum];

/**
 * 
 * @export
 * @interface CohortsCreateBody
 */
export interface CohortsCreateBody {
    /**
     * 
     * @type {string}
     * @memberof CohortsCreateBody
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof CohortsCreateBody
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof CohortsCreateBody
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface CohortsUpdateBody
 */
export interface CohortsUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof CohortsUpdateBody
     */
    'icdHintStatus'?: CohortsUpdateBodyIcdHintStatusEnum;
    /**
     * 
     * @type {FeedbackType}
     * @memberof CohortsUpdateBody
     */
    'feedbackType'?: FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof CohortsUpdateBody
     */
    'cohortStatus'?: CohortsUpdateBodyCohortStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CohortsUpdateBody
     */
    'populationIcdHints'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CohortsUpdateBody
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CohortsUpdateBody
     */
    'notes'?: string;
}

export const CohortsUpdateBodyIcdHintStatusEnum = {
    Approved: 'approved',
    Unreviewed: 'unreviewed'
} as const;

export type CohortsUpdateBodyIcdHintStatusEnum = typeof CohortsUpdateBodyIcdHintStatusEnum[keyof typeof CohortsUpdateBodyIcdHintStatusEnum];
export const CohortsUpdateBodyCohortStatusEnum = {
    Unreviewed: 'unreviewed',
    NeedsAttention: 'needs_attention',
    AutoApproved: 'auto_approved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type CohortsUpdateBodyCohortStatusEnum = typeof CohortsUpdateBodyCohortStatusEnum[keyof typeof CohortsUpdateBodyCohortStatusEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const CommunicationKey = {
    ResetPassword: 'resetPassword',
    SetPassword: 'setPassword',
    VerifyEmail: 'verifyEmail',
    Invite: 'invite',
    VolunteerAcceptedManagedTrial: 'volunteerAcceptedManagedTrial',
    RequestTrialCriteriaDigest: 'requestTrialCriteriaDigest',
    RequestBooster: 'requestBooster',
    ExternalContactMatch: 'externalContactMatch',
    FullMatch: 'fullMatch',
    FullMatchPanel: 'fullMatchPanel',
    NoMatch: 'noMatch',
    NewQuestions: 'newQuestions',
    NewTrial: 'newTrial',
    SurveyReminder: 'surveyReminder',
    NewSurvey: 'newSurvey',
    FirstSurveyReminder: 'firstSurveyReminder',
    SecondSurveyReminder: 'secondSurveyReminder',
    FirstSurveyReactivation: 'firstSurveyReactivation',
    SecondSurveyReactivation: 'secondSurveyReactivation',
    NewTrialHealthy: 'newTrialHealthy',
    NewTrialUnhealthy: 'newTrialUnhealthy',
    TrialAccessApproved: 'trialAccessApproved',
    TrialAccessRejected: 'trialAccessRejected',
    CriteriaExplanation: 'criteriaExplanation',
    PatientReachOutMissingAnswers: 'patientReachOutMissingAnswers',
    PatientReachOutMissingAnswersPanel: 'patientReachOutMissingAnswersPanel',
    PatientReachOutVerified: 'patientReachOutVerified',
    PatientReachOutVerifiedPanel: 'patientReachOutVerifiedPanel',
    AccountClaim: 'accountClaim',
    TrialManagerWelcome: 'trialManagerWelcome',
    AccessRequestConfirmation: 'accessRequestConfirmation',
    NewAccessRequest: 'newAccessRequest',
    PendingLocationPatients: 'pendingLocationPatients',
    AutoApproveOverview: 'autoApproveOverview',
    PendingPanelPatients: 'pendingPanelPatients',
    WeeklyTopSponsor: 'weeklyTopSponsor',
    MilestoneConfirmation: 'milestoneConfirmation',
    MilestoneUpdate: 'milestoneUpdate',
    PendingLocationUpdate: 'pendingLocationUpdate',
    ContactFormInquiry: 'contactFormInquiry'
} as const;

export type CommunicationKey = typeof CommunicationKey[keyof typeof CommunicationKey];


/**
 * 
 * @export
 * @interface CompleteRecordShareAuthorisationBody
 */
export interface CompleteRecordShareAuthorisationBody {
    /**
     * The query parameters the partner sent back, as relayed by the callback route.
     * @type {{ [key: string]: string; }}
     * @memberof CompleteRecordShareAuthorisationBody
     */
    'params': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CompleteRecordShareIdentityBody
 */
export interface CompleteRecordShareIdentityBody {
    /**
     * The query parameters the partner sent back, as relayed by the callback route.
     * @type {{ [key: string]: string; }}
     * @memberof CompleteRecordShareIdentityBody
     */
    'params': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CompletionPercentageView
 */
export interface CompletionPercentageView {
    /**
     * 
     * @type {number}
     * @memberof CompletionPercentageView
     */
    'completionPercentage': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConfidenceLevel = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;

export type ConfidenceLevel = typeof ConfidenceLevel[keyof typeof ConfidenceLevel];


/**
 * 
 * @export
 * @interface ConfigurationView
 */
export interface ConfigurationView {
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationView
     */
    'isMaintenanceEnabled': boolean;
    /**
     * `widenedSearchEnabled`: the web shows the widened search offer and setting only while it is on.
     * @type {boolean}
     * @memberof ConfigurationView
     */
    'isWidenedSearchEnabled': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConsentStatus = {
    Active: 'active',
    Withdrawn: 'withdrawn'
} as const;

export type ConsentStatus = typeof ConsentStatus[keyof typeof ConsentStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ConsentType = {
    CompanionEnrollment: 'companion_enrollment',
    MedicalDataGdpr9: 'medical_data_gdpr9',
    RecordShare: 'record_share'
} as const;

export type ConsentType = typeof ConsentType[keyof typeof ConsentType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ContactFormTopic = {
    General: 'general',
    MissingDisease: 'missingDisease'
} as const;

export type ContactFormTopic = typeof ContactFormTopic[keyof typeof ContactFormTopic];


/**
 * 
 * @export
 * @interface ContactUpdateBody
 */
export interface ContactUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof ContactUpdateBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUpdateBody
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUpdateBody
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUpdateBody
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface ContactView
 */
export interface ContactView {
    /**
     * 
     * @type {string}
     * @memberof ContactView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ContactView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactView
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ContextView
 */
export interface ContextView {
    /**
     * 
     * @type {ChatEntryDestination}
     * @memberof ContextView
     */
    'destination': ChatEntryDestination;
    /**
     * 
     * @type {string}
     * @memberof ContextView
     */
    'id'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ConversionProposer = {
    Human: 'human',
    Llm: 'llm',
    Validator: 'validator'
} as const;

export type ConversionProposer = typeof ConversionProposer[keyof typeof ConversionProposer];


/**
 * 
 * @export
 * @enum {string}
 */

export const ConversionRuleStatus = {
    Queued: 'queued',
    Active: 'active',
    Superseded: 'superseded',
    Rejected: 'rejected'
} as const;

export type ConversionRuleStatus = typeof ConversionRuleStatus[keyof typeof ConversionRuleStatus];


/**
 * 
 * @export
 * @interface ConversionRuleTestCase
 */
export interface ConversionRuleTestCase {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ConversionRuleTestCase
     */
    'inputs': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ConversionRuleTestCase
     */
    'expected': number;
}
/**
 * 
 * @export
 * @interface ConversionRuleView
 */
export interface ConversionRuleView {
    /**
     * 
     * @type {ConversionType}
     * @memberof ConversionRuleView
     */
    'type': ConversionType;
    /**
     * 
     * @type {Array<ConversionRuleTestCase>}
     * @memberof ConversionRuleView
     */
    'testCases': Array<ConversionRuleTestCase>;
    /**
     * 
     * @type {ConversionRuleStatus}
     * @memberof ConversionRuleView
     */
    'status': ConversionRuleStatus;
    /**
     * 
     * @type {ConversionProposer}
     * @memberof ConversionRuleView
     */
    'proposedBy': ConversionProposer;
    /**
     * Previous versions that this rule superseded, ordered newest-first. Only populated on active rules.
     * @type {Array<ConversionRuleView>}
     * @memberof ConversionRuleView
     */
    'previousVersions'?: Array<ConversionRuleView>;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'sourceUnit': string;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'standardUnit': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversionRuleView
     */
    'inputs': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'formula': string;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'provenance': string;
    /**
     * 
     * @type {number}
     * @memberof ConversionRuleView
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'reviewedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleView
     */
    'reviewedAt'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ConversionType = {
    Dimensional: 'dimensional',
    Molar: 'molar',
    Affine: 'affine',
    Custom: 'custom'
} as const;

export type ConversionType = typeof ConversionType[keyof typeof ConversionType];


/**
 * 
 * @export
 * @interface CoordinateView
 */
export interface CoordinateView {
    /**
     * 
     * @type {number}
     * @memberof CoordinateView
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof CoordinateView
     */
    'long': number;
}
/**
 * 
 * @export
 * @interface CreateDependentBody
 */
export interface CreateDependentBody {
    /**
     * 
     * @type {BehalfOf}
     * @memberof CreateDependentBody
     */
    'relation': BehalfOf;
    /**
     * 
     * @type {string}
     * @memberof CreateDependentBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDependentBody
     */
    'lastName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDependentBody
     */
    'diseases': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateDependentBody
     */
    'country': string;
}


/**
 * 
 * @export
 * @interface CreateRecordShareBody
 */
export interface CreateRecordShareBody {
    /**
     * 
     * @type {RecordProviderId}
     * @memberof CreateRecordShareBody
     */
    'providerId': RecordProviderId;
}


/**
 * 
 * @export
 * @interface CreateUserConsentBody
 */
export interface CreateUserConsentBody {
    /**
     * 
     * @type {Array<ShareCategory>}
     * @memberof CreateUserConsentBody
     */
    'shareCategories'?: Array<ShareCategory>;
    /**
     * 
     * @type {string}
     * @memberof CreateUserConsentBody
     */
    'type': CreateUserConsentBodyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserConsentBody
     */
    'referenceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserConsentBody
     */
    'locale': string;
}

export const CreateUserConsentBodyTypeEnum = {
    CompanionEnrollment: 'companion_enrollment',
    MedicalDataGdpr9: 'medical_data_gdpr9',
    RecordShare: 'record_share'
} as const;

export type CreateUserConsentBodyTypeEnum = typeof CreateUserConsentBodyTypeEnum[keyof typeof CreateUserConsentBodyTypeEnum];

/**
 * 
 * @export
 * @interface CriteriaActivityView
 */
export interface CriteriaActivityView {
    /**
     * 
     * @type {ActivityType}
     * @memberof CriteriaActivityView
     */
    'type': ActivityType;
    /**
     * 
     * @type {FeedbackType}
     * @memberof CriteriaActivityView
     */
    'feedbackType'?: FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'comment'?: string | null;
    /**
     * The source text a legacy criteria request or feedback event was raised against.
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'criteriaText'?: string | null;
    /**
     * The wording an edit replaced — what the pipeline proposed before a reviewer corrected it. The edited record carries the wording in force, so this is the only place the superseded text survives. Null for events that record a decision and nothing else.
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'proposedCriteriaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'userId'?: string | null;
}


/**
 * 
 * @export
 * @interface CriteriaCommentBody
 */
export interface CriteriaCommentBody {
    /**
     * 
     * @type {string}
     * @memberof CriteriaCommentBody
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface CriteriaDependencyView
 */
export interface CriteriaDependencyView {
    /**
     * 
     * @type {DependencyType}
     * @memberof CriteriaDependencyView
     */
    'type': DependencyType;
    /**
     * 
     * @type {string}
     * @memberof CriteriaDependencyView
     */
    'questionText': string;
    /**
     * 
     * @type {DependencyValue}
     * @memberof CriteriaDependencyView
     */
    'value'?: DependencyValue;
}


/**
 * 
 * @export
 * @interface CriteriaFeedbackBody
 */
export interface CriteriaFeedbackBody {
    /**
     * 
     * @type {FeedbackType}
     * @memberof CriteriaFeedbackBody
     */
    'feedbackType': FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof CriteriaFeedbackBody
     */
    'feedback': string;
}


/**
 * 
 * @export
 * @interface CriteriaMoveBody
 */
export interface CriteriaMoveBody {
    /**
     * 
     * @type {number}
     * @memberof CriteriaMoveBody
     */
    'newPosition': number;
}
/**
 * 
 * @export
 * @interface CriteriaRequestBody
 */
export interface CriteriaRequestBody {
    /**
     * 
     * @type {AnswerType}
     * @memberof CriteriaRequestBody
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof CriteriaRequestBody
     */
    'criteriaText': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaRequestBody
     */
    'questionText': string;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaRequestBody
     */
    'value'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CriteriaRequestBody
     */
    'minThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CriteriaRequestBody
     */
    'maxThreshold'?: number;
    /**
     * 
     * @type {string}
     * @memberof CriteriaRequestBody
     */
    'unit'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CriteriaStatus = {
    Proposed: 'proposed',
    Validated: 'validated',
    Static: 'static',
    Denied: 'denied',
    Deleted: 'deleted',
    Flagged: 'flagged',
    AutoAccepted: 'auto_accepted'
} as const;

export type CriteriaStatus = typeof CriteriaStatus[keyof typeof CriteriaStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const CriteriaType = {
    Inclusion: 'inclusion',
    Exclusion: 'exclusion'
} as const;

export type CriteriaType = typeof CriteriaType[keyof typeof CriteriaType];


/**
 * 
 * @export
 * @interface CriteriaUpdateBody
 */
export interface CriteriaUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof CriteriaUpdateBody
     */
    'originalCriteriaText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaUpdateBody
     */
    'status'?: CriteriaUpdateBodyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CriteriaUpdateBody
     */
    'questionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaUpdateBody
     */
    'value'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CriteriaUpdateBody
     */
    'minThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CriteriaUpdateBody
     */
    'maxThreshold'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CriteriaUpdateBody
     */
    'otherValues'?: Array<string>;
}

export const CriteriaUpdateBodyStatusEnum = {
    Proposed: 'proposed',
    Validated: 'validated',
    Static: 'static',
    Denied: 'denied',
    Deleted: 'deleted',
    Flagged: 'flagged',
    AutoAccepted: 'auto_accepted'
} as const;

export type CriteriaUpdateBodyStatusEnum = typeof CriteriaUpdateBodyStatusEnum[keyof typeof CriteriaUpdateBodyStatusEnum];

/**
 * 
 * @export
 * @interface CriterionNodeView
 */
export interface CriterionNodeView {
    /**
     * 
     * @type {NodeOperator}
     * @memberof CriterionNodeView
     */
    'operator': NodeOperator;
    /**
     * 
     * @type {string}
     * @memberof CriterionNodeView
     */
    'id': string;
    /**
     * Null on the root. Every other node names its structural parent.
     * @type {string}
     * @memberof CriterionNodeView
     */
    'parentId'?: string | null;
    /**
     * Order among this node\'s own siblings — not an index into the whole tree.
     * @type {number}
     * @memberof CriterionNodeView
     */
    'position': number;
}


/**
 * 
 * @export
 * @interface CriterionTreeBody
 */
export interface CriterionTreeBody {
    /**
     * 
     * @type {Array<CriterionTreeNodeBody>}
     * @memberof CriterionTreeBody
     */
    'nodes': Array<CriterionTreeNodeBody>;
    /**
     * 
     * @type {Array<CriterionTreePredicateBody>}
     * @memberof CriterionTreeBody
     */
    'predicates': Array<CriterionTreePredicateBody>;
    /**
     * Stored atoms the reviewer drops from the criterion. Explicit rather than inferred from what `predicates` leaves out, so an incomplete payload still fails coverage. At least one atom must stay in `predicates`: to drop them all, reject the criterion.
     * @type {Array<string>}
     * @memberof CriterionTreeBody
     */
    'removedPredicateIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CriterionTreeNodeBody
 */
export interface CriterionTreeNodeBody {
    /**
     * 
     * @type {NodeOperator}
     * @memberof CriterionTreeNodeBody
     */
    'operator': NodeOperator;
    /**
     * Index into this same `nodes` array of the parent node. Null on the single root. A node may only reference an earlier index, so parents always precede their children — the same invariant Step 3\'s LLM contract enforces.
     * @type {number}
     * @memberof CriterionTreeNodeBody
     */
    'parentIndex'?: number | null;
}


/**
 * 
 * @export
 * @interface CriterionTreePredicateBody
 */
export interface CriterionTreePredicateBody {
    /**
     * The atom this entry is. Absent means a new one, which only a split can produce — `splitFromPredicateId` then says which atom it was cut from.
     * @type {string}
     * @memberof CriterionTreePredicateBody
     */
    'predicateId'?: string;
    /**
     * The atom a new entry was split off, and the only way to create one: a reviewer corrects an under-split, they do not author a statement the source text never carried. The new atom inherits its `criteriaType` from here. Ignored when `predicateId` is set.
     * @type {string}
     * @memberof CriterionTreePredicateBody
     */
    'splitFromPredicateId'?: string;
    /**
     * Index into the `nodes` array of the node this predicate hangs off.
     * @type {number}
     * @memberof CriterionTreePredicateBody
     */
    'nodeIndex': number;
    /**
     * Corrected wording for this atom. Omitted — as an ordinary regroup omits it — keeps the pipeline\'s text. Stored trimmed, and a value equal to the stored one is not an edit, so neither can produce a spurious audit row.  Empty is refused: an atom leaves through `removedPredicateIds`, not a blank text field. Regrouping cannot fix a badly worded split, and every later step reads this text, which is why the reviewer gets to correct it inside this window.  Required on a new atom.
     * @type {string}
     * @memberof CriterionTreePredicateBody
     */
    'rewrittenText'?: string;
    /**
     * The cohort this statement applies to, or null for the whole trial. Omitted keeps the pipeline\'s tag, which is what an ordinary regroup sends — so null and absent differ here, unlike `rewrittenText`: untagging an atom is a real decision and has to be expressible.  The tag lives on the atom because a criterion\'s OR branches can address different arms. Must name a cohort of the same trial.
     * @type {string}
     * @memberof CriterionTreePredicateBody
     */
    'cohortId'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrentFlowDetails
 */
export interface CurrentFlowDetails {
    /**
     * 
     * @type {ResearchType}
     * @memberof CurrentFlowDetails
     */
    'researchType': ResearchType;
    /**
     * 
     * @type {string}
     * @memberof CurrentFlowDetails
     */
    'id': string;
}


/**
 * 
 * @export
 * @interface CurrentFlowView
 */
export interface CurrentFlowView {
    /**
     * 
     * @type {CurrentFlowDetails}
     * @memberof CurrentFlowView
     */
    'flow'?: CurrentFlowDetails;
}
/**
 * 
 * @export
 * @interface CustomerPortalView
 */
export interface CustomerPortalView {
    /**
     * 
     * @type {string}
     * @memberof CustomerPortalView
     */
    'customerPortalUrl': string;
}
/**
 * 
 * @export
 * @interface DelayIndexView
 */
export interface DelayIndexView {
    /**
     * 
     * @type {number}
     * @memberof DelayIndexView
     */
    'totalDelayInDays': number;
    /**
     * 
     * @type {number}
     * @memberof DelayIndexView
     */
    'totalTrials': number;
    /**
     * 
     * @type {number}
     * @memberof DelayIndexView
     */
    'totalDelayedTrials': number;
    /**
     * 
     * @type {number}
     * @memberof DelayIndexView
     */
    'totalDelayedTrialsPercentage': number;
}
/**
 * 
 * @export
 * @interface DependencyFixView
 */
export interface DependencyFixView {
    /**
     * Pass as `after` on the next call. Null when the run is done.
     * @type {string}
     * @memberof DependencyFixView
     */
    'nextCursor': string | null;
    /**
     * 
     * @type {number}
     * @memberof DependencyFixView
     */
    'processed': number;
    /**
     * 
     * @type {number}
     * @memberof DependencyFixView
     */
    'written': number;
    /**
     * 
     * @type {number}
     * @memberof DependencyFixView
     */
    'skipped': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DependencyOperator = {
    And: 'and',
    Or: 'or'
} as const;

export type DependencyOperator = typeof DependencyOperator[keyof typeof DependencyOperator];


/**
 * 
 * @export
 * @interface DependencyProposalGenerationModelView
 */
export interface DependencyProposalGenerationModelView {
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalGenerationModelView
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalGenerationModelView
     */
    'modelName': string;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalGenerationModelView
     */
    'promptVersion': string;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalGenerationModelView
     */
    'generatedAt': string;
}
/**
 * 
 * @export
 * @interface DependencyProposalReviewBody
 */
export interface DependencyProposalReviewBody {
    /**
     * 
     * @type {DependencyProposalStatus}
     * @memberof DependencyProposalReviewBody
     */
    'status': DependencyProposalStatus;
    /**
     * 
     * @type {DependencyOperator}
     * @memberof DependencyProposalReviewBody
     */
    'operator'?: DependencyOperator;
}


/**
 * `approved` or `rejected`; any other value is a 400.
 * @export
 * @enum {string}
 */

export const DependencyProposalStatus = {
    Proposed: 'proposed',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type DependencyProposalStatus = typeof DependencyProposalStatus[keyof typeof DependencyProposalStatus];


/**
 * 
 * @export
 * @interface DependencyProposalView
 */
export interface DependencyProposalView {
    /**
     * 
     * @type {DependencyType}
     * @memberof DependencyProposalView
     */
    'type': DependencyType;
    /**
     * 
     * @type {DependencyOperator}
     * @memberof DependencyProposalView
     */
    'operator': DependencyOperator;
    /**
     * 
     * @type {DependencyProposalStatus}
     * @memberof DependencyProposalView
     */
    'status': DependencyProposalStatus;
    /**
     * 
     * @type {DependencyProposalGenerationModelView}
     * @memberof DependencyProposalView
     */
    'generationModel': DependencyProposalGenerationModelView;
    /**
     * 
     * @type {QuestionType}
     * @memberof DependencyProposalView
     */
    'sourceQuestionType': QuestionType;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalView
     */
    'id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DependencyProposalView
     */
    'parameters': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalView
     */
    'rationale': string;
    /**
     * The live dependency this approval created; null until approved or once that row is deleted.
     * @type {string}
     * @memberof DependencyProposalView
     */
    'dependencyId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalView
     */
    'sourceId': string;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalView
     */
    'targetId': string;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalView
     */
    'sourceText': string;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalView
     */
    'targetText': string;
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalView
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DependencyType = {
    GreaterThan: 'greaterThan',
    DateToMonths: 'dateToMonths',
    DateToYears: 'dateToYears',
    Address: 'address',
    BmiCalculation: 'bmiCalculation',
    DiseaseProcessor: 'diseaseProcessor',
    HospitalProcessor: 'hospitalProcessor',
    EqualTo: 'equalTo',
    Dependency: 'dependency',
    NumericThreshold: 'numericThreshold',
    HasDisease: 'hasDisease',
    OptionToNumber: 'optionToNumber',
    ImpliesTrue: 'impliesTrue'
} as const;

export type DependencyType = typeof DependencyType[keyof typeof DependencyType];


/**
 * 
 * @export
 * @interface DependencyUpdateBody
 */
export interface DependencyUpdateBody {
    /**
     * 
     * @type {DependencyOperator}
     * @memberof DependencyUpdateBody
     */
    'operator'?: DependencyOperator;
    /**
     * 
     * @type {Array<string>}
     * @memberof DependencyUpdateBody
     */
    'parameters': Array<string>;
}


/**
 * 
 * @export
 * @interface DependencyValue
 */
export interface DependencyValue {
    /**
     * 
     * @type {number}
     * @memberof DependencyValue
     */
    'greaterThan'?: number;
    /**
     * 
     * @type {string}
     * @memberof DependencyValue
     */
    'equalTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DependencyValue
     */
    'requiredValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof DependencyValue
     */
    'notApplicableValue'?: string;
}
/**
 * 
 * @export
 * @interface DigestBody
 */
export interface DigestBody {
    /**
     * 
     * @type {number}
     * @memberof DigestBody
     */
    'frequencySeconds': number;
}
/**
 * 
 * @export
 * @interface DigestView
 */
export interface DigestView {
    /**
     * 
     * @type {number}
     * @memberof DigestView
     */
    'frequencySeconds': number;
}
/**
 * 
 * @export
 * @interface DiseaseCreateBody
 */
export interface DiseaseCreateBody {
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateBody
     */
    'icdCode': string;
}
/**
 * 
 * @export
 * @interface DiseaseCreateView
 */
export interface DiseaseCreateView {
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateView
     */
    'icdCode': string;
}
/**
 * 
 * @export
 * @interface DiseaseNameCreate
 */
export interface DiseaseNameCreate {
    /**
     * 
     * @type {Language}
     * @memberof DiseaseNameCreate
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof DiseaseNameCreate
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface DiseaseNameUpdateQuery
 */
export interface DiseaseNameUpdateQuery {
    /**
     * 
     * @type {string}
     * @memberof DiseaseNameUpdateQuery
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DiseaseNameView
 */
export interface DiseaseNameView {
    /**
     * 
     * @type {Language}
     * @memberof DiseaseNameView
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof DiseaseNameView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseNameView
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface DiseaseTranslationView
 */
export interface DiseaseTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof DiseaseTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof DiseaseTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof DiseaseTranslationView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof DiseaseTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseTranslationView
     */
    'diseaseId': string;
}


/**
 * 
 * @export
 * @interface DiseaseTranslationsBody
 */
export interface DiseaseTranslationsBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof DiseaseTranslationsBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface DiseaseTrialsCountView
 */
export interface DiseaseTrialsCountView {
    /**
     * 
     * @type {number}
     * @memberof DiseaseTrialsCountView
     */
    'trialCount': number;
}
/**
 * 
 * @export
 * @interface DiseaseV2View
 */
export interface DiseaseV2View {
    /**
     * 
     * @type {string}
     * @memberof DiseaseV2View
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseV2View
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseV2View
     */
    'icdCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiseaseV2View
     */
    'names': Array<string>;
    /**
     * 
     * @type {Array<DiseaseV2ViewChild>}
     * @memberof DiseaseV2View
     */
    'children': Array<DiseaseV2ViewChild>;
}
/**
 * 
 * @export
 * @interface DiseaseV2ViewChild
 */
export interface DiseaseV2ViewChild {
    /**
     * 
     * @type {string}
     * @memberof DiseaseV2ViewChild
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseV2ViewChild
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseV2ViewChild
     */
    'icdCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiseaseV2ViewChild
     */
    'names': Array<string>;
}
/**
 * 
 * @export
 * @interface DiseaseView
 */
export interface DiseaseView {
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'icdId': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'icdCode': string;
    /**
     * 
     * @type {number}
     * @memberof DiseaseView
     */
    'trialCount': number;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'parentCategoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'parentCategoryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'categoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'categoryName'?: string;
}
/**
 * 
 * @export
 * @interface EditRuleBody
 */
export interface EditRuleBody {
    /**
     * 
     * @type {ConversionType}
     * @memberof EditRuleBody
     */
    'type'?: ConversionType;
    /**
     * 
     * @type {Array<ConversionRuleTestCase>}
     * @memberof EditRuleBody
     */
    'testCases'?: Array<ConversionRuleTestCase>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditRuleBody
     */
    'inputs'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditRuleBody
     */
    'formula'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditRuleBody
     */
    'provenance'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const EffectType = {
    AutoApprove: 'autoApprove',
    Redirect: 'redirect',
    ExternalContact: 'externalContact'
} as const;

export type EffectType = typeof EffectType[keyof typeof EffectType];


/**
 * 
 * @export
 * @interface EffectView
 */
export interface EffectView {
    /**
     * 
     * @type {EffectType}
     * @memberof EffectView
     */
    'type': EffectType;
    /**
     * 
     * @type {string}
     * @memberof EffectView
     */
    'url'?: string;
    /**
     * 
     * @type {ContactView}
     * @memberof EffectView
     */
    'contact'?: ContactView;
    /**
     * 
     * @type {boolean}
     * @memberof EffectView
     */
    'showContactDetails'?: boolean;
}


/**
 * Pre-screens are current only when `applied`.
 * @export
 * @enum {string}
 */

export const EvaluationOutcome = {
    Pending: 'pending',
    Applied: 'applied',
    Deferred: 'deferred',
    Failed: 'failed'
} as const;

export type EvaluationOutcome = typeof EvaluationOutcome[keyof typeof EvaluationOutcome];


/**
 * 
 * @export
 * @enum {string}
 */

export const FeasibilitySuggestion = {
    Keep: 'KEEP',
    Skip: 'SKIP',
    SiteVerified: 'SITE_VERIFIED',
    Review: 'REVIEW'
} as const;

export type FeasibilitySuggestion = typeof FeasibilitySuggestion[keyof typeof FeasibilitySuggestion];


/**
 * 
 * @export
 * @enum {string}
 */

export const FeedbackType = {
    WrongCriterion: 'wrongCriterion',
    WrongQuestion: 'wrongQuestion',
    WrongExpectedValue: 'wrongExpectedValue',
    WrongMinThreshold: 'wrongMinThreshold',
    WrongMaxThreshold: 'wrongMaxThreshold',
    WrongUnit: 'wrongUnit',
    Other: 'other',
    NotACohort: 'notACohort',
    DuplicateCohort: 'duplicateCohort',
    WrongCohortLabel: 'wrongCohortLabel',
    UnderSplit: 'underSplit',
    OverSplit: 'overSplit',
    WrongStructure: 'wrongStructure',
    NotACriterion: 'notACriterion',
    WrongLibraryItem: 'wrongLibraryItem',
    WrongValue: 'wrongValue',
    WrongPolarity: 'wrongPolarity',
    WrongTemporal: 'wrongTemporal',
    NotExtractable: 'notExtractable',
    WrongCodes: 'wrongCodes',
    IncompleteCodes: 'incompleteCodes',
    CodesNotNeeded: 'codesNotNeeded'
} as const;

export type FeedbackType = typeof FeedbackType[keyof typeof FeedbackType];


/**
 * 
 * @export
 * @enum {string}
 */

export const Gender = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];


/**
 * 
 * @export
 * @enum {string}
 */

export const GenerationType = {
    Standard: 'standard',
    Researcher: 'researcher',
    AiGenerated: 'aiGenerated',
    Aggregated: 'aggregated'
} as const;

export type GenerationType = typeof GenerationType[keyof typeof GenerationType];


/**
 * 
 * @export
 * @interface GeocodePatientRegionsBody
 */
export interface GeocodePatientRegionsBody {
    /**
     * Continue after this cursor (the nextCursor of the previous run). Pending pairs are walked in a fixed order, so a run that starts after the cursor moves past pairs the geocoder could not resolve instead of retrying them first. Omit to start from the beginning.
     * @type {string}
     * @memberof GeocodePatientRegionsBody
     */
    'after'?: string;
    /**
     * Pairs to geocode in this run, at most 200.
     * @type {number}
     * @memberof GeocodePatientRegionsBody
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface GeocodePatientRegionsView
 */
export interface GeocodePatientRegionsView {
    /**
     * 
     * @type {string}
     * @memberof GeocodePatientRegionsView
     */
    'nextCursor'?: string;
    /**
     * 
     * @type {number}
     * @memberof GeocodePatientRegionsView
     */
    'candidatePairs': number;
    /**
     * 
     * @type {number}
     * @memberof GeocodePatientRegionsView
     */
    'alreadyGeocoded': number;
    /**
     * 
     * @type {number}
     * @memberof GeocodePatientRegionsView
     */
    'geocoded': number;
    /**
     * 
     * @type {number}
     * @memberof GeocodePatientRegionsView
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof GeocodePatientRegionsView
     */
    'remaining': number;
}
/**
 * 
 * @export
 * @interface GetQuestionsBody
 */
export interface GetQuestionsBody {
    /**
     * 
     * @type {number}
     * @memberof GetQuestionsBody
     */
    'limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetQuestionsBody
     */
    'offset'?: number | null;
    /**
     * 
     * @type {Array<QuestionType>}
     * @memberof GetQuestionsBody
     */
    'questionTypes'?: Array<QuestionType>;
    /**
     * 
     * @type {Array<GenerationType>}
     * @memberof GetQuestionsBody
     */
    'generationTypes'?: Array<GenerationType>;
    /**
     * 
     * @type {Array<VisibilityType>}
     * @memberof GetQuestionsBody
     */
    'visibilityTypes'?: Array<VisibilityType>;
    /**
     * 
     * @type {OrderDirection}
     * @memberof GetQuestionsBody
     */
    'orderDirection'?: OrderDirection;
    /**
     * 
     * @type {QuestionOrderBy}
     * @memberof GetQuestionsBody
     */
    'orderBy'?: QuestionOrderBy;
    /**
     * 
     * @type {Array<AnswerType>}
     * @memberof GetQuestionsBody
     */
    'answerTypes'?: Array<AnswerType>;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionsBody
     */
    'icdCategoryIds'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionsBody
     */
    'searchString'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionsBody
     */
    'orderByIcdSpecificCount'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetQuestionsBody
     */
    'starterCategoryIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetQuestionsBody
     */
    'tagCategoryIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionsBody
     */
    'currentVersionOnly': boolean | null;
}


/**
 * 
 * @export
 * @interface GetTrialsBody
 */
export interface GetTrialsBody {
    /**
     * 
     * @type {number}
     * @memberof GetTrialsBody
     */
    'limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetTrialsBody
     */
    'offset'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrialsBody
     */
    'searchString'?: string | null;
    /**
     * 
     * @type {OrderDirection}
     * @memberof GetTrialsBody
     */
    'orderDirection'?: OrderDirection;
    /**
     * 
     * @type {TrialOrderBy}
     * @memberof GetTrialsBody
     */
    'orderBy'?: TrialOrderBy;
    /**
     * 
     * @type {ManagementStatus}
     * @memberof GetTrialsBody
     */
    'managedByFilter'?: ManagementStatus;
    /**
     * 
     * @type {string}
     * @memberof GetTrialsBody
     */
    'icdCategoryIds'?: string;
    /**
     * 
     * @type {Array<OverallTrialStatus>}
     * @memberof GetTrialsBody
     */
    'overallStatuses'?: Array<OverallTrialStatus>;
    /**
     * 
     * @type {Array<MatchingTrialStatus>}
     * @memberof GetTrialsBody
     */
    'matchingStatuses'?: Array<MatchingTrialStatus>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrialsBody
     */
    'locationString'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrialsBody
     */
    'countriesFilter'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetTrialsBody
     */
    'diseaseFilter'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrialsBody
     */
    'leadSponsorFilter'?: Array<string>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GetUserTrialsOrderBy = {
    Distance: 'distance',
    RemainingQuestions: 'remainingQuestions'
} as const;

export type GetUserTrialsOrderBy = typeof GetUserTrialsOrderBy[keyof typeof GetUserTrialsOrderBy];


/**
 * 
 * @export
 * @interface GoogleLoginBody
 */
export interface GoogleLoginBody {
    /**
     * 
     * @type {Language}
     * @memberof GoogleLoginBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof GoogleLoginBody
     */
    'idToken': string;
}


/**
 * 
 * @export
 * @interface GoogleSignUpBody
 */
export interface GoogleSignUpBody {
    /**
     * 
     * @type {Language}
     * @memberof GoogleSignUpBody
     */
    'language': Language;
    /**
     * 
     * @type {ThemeType}
     * @memberof GoogleSignUpBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {Role}
     * @memberof GoogleSignUpBody
     */
    'role'?: Role;
    /**
     * 
     * @type {string}
     * @memberof GoogleSignUpBody
     */
    'idToken': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const HistoryType = {
    Seen: 'seen',
    Unseen: 'unseen',
    All: 'all',
    Answered: 'answered',
    Unanswered: 'unanswered'
} as const;

export type HistoryType = typeof HistoryType[keyof typeof HistoryType];


/**
 * 
 * @export
 * @interface HospitalCenterCreate
 */
export interface HospitalCenterCreate {
    /**
     * 
     * @type {Language}
     * @memberof HospitalCenterCreate
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterCreate
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterCreate
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterCreate
     */
    'zip': string;
}


/**
 * 
 * @export
 * @interface HospitalCenterUpdateQuery
 */
export interface HospitalCenterUpdateQuery {
    /**
     * 
     * @type {boolean}
     * @memberof HospitalCenterUpdateQuery
     */
    'isStandard': boolean;
}
/**
 * 
 * @export
 * @interface HospitalCenterView
 */
export interface HospitalCenterView {
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'country': string;
    /**
     * 
     * @type {boolean}
     * @memberof HospitalCenterView
     */
    'isStandard': boolean;
}
/**
 * 
 * @export
 * @interface HospitalMergeBody
 */
export interface HospitalMergeBody {
    /**
     * 
     * @type {string}
     * @memberof HospitalMergeBody
     */
    'targetHospitalId': string;
}
/**
 * 
 * @export
 * @interface HospitalNameCreate
 */
export interface HospitalNameCreate {
    /**
     * 
     * @type {Language}
     * @memberof HospitalNameCreate
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof HospitalNameCreate
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface HospitalNameUpdateQuery
 */
export interface HospitalNameUpdateQuery {
    /**
     * 
     * @type {string}
     * @memberof HospitalNameUpdateQuery
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface HospitalNameView
 */
export interface HospitalNameView {
    /**
     * 
     * @type {Language}
     * @memberof HospitalNameView
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof HospitalNameView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalNameView
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface HospitalTranslationView
 */
export interface HospitalTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof HospitalTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof HospitalTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof HospitalTranslationView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof HospitalTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalTranslationView
     */
    'hospitalId': string;
}


/**
 * 
 * @export
 * @interface HospitalTranslationsBody
 */
export interface HospitalTranslationsBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof HospitalTranslationsBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface HospitalView
 */
export interface HospitalView {
    /**
     * 
     * @type {string}
     * @memberof HospitalView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalView
     */
    'hospitalEntityId': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalView
     */
    'hospitalEntityName': string;
}
/**
 * 
 * @export
 * @interface IcdDiseaseView
 */
export interface IcdDiseaseView {
    /**
     * 
     * @type {string}
     * @memberof IcdDiseaseView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IcdDiseaseView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IcdDiseaseView
     */
    'icdCode': string;
}
/**
 * `ingested` when the run stored at least one Fact; `already_ingested` when it stored none (a replay, or a scope that licensed nothing).
 * @export
 * @enum {string}
 */

export const IngestOutcome = {
    Ingested: 'ingested',
    AlreadyIngested: 'already_ingested'
} as const;

export type IngestOutcome = typeof IngestOutcome[keyof typeof IngestOutcome];


/**
 * 
 * @export
 * @interface IngestRecordBody
 */
export interface IngestRecordBody {
    /**
     * The share whose consent authorises this retrieval. The scope comes from that consent record, never from this request — a caller cannot widen what the patient agreed to share.
     * @type {string}
     * @memberof IngestRecordBody
     */
    'shareId': string;
}
/**
 * 
 * @export
 * @interface IngestRecordView
 */
export interface IngestRecordView {
    /**
     * 
     * @type {IngestOutcome}
     * @memberof IngestRecordView
     */
    'outcome': IngestOutcome;
    /**
     * 
     * @type {EvaluationOutcome}
     * @memberof IngestRecordView
     */
    'evaluation': EvaluationOutcome;
    /**
     * Rows written this run. Zero on a replay — the Facts are already there.
     * @type {number}
     * @memberof IngestRecordView
     */
    'factsPersisted': number;
    /**
     * Answers written from Facts. Zero while the Fact→question map is empty.
     * @type {number}
     * @memberof IngestRecordView
     */
    'written': number;
    /**
     * 
     * @type {number}
     * @memberof IngestRecordView
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof IngestRecordView
     */
    'unmapped': number;
    /**
     * Set when the user has not finished onboarding, so no answer could be written. The Facts are stored; re-run once onboarding is complete.
     * @type {boolean}
     * @memberof IngestRecordView
     */
    'deferred'?: boolean;
    /**
     * Resources discarded because the consent scope did not license them.
     * @type {number}
     * @memberof IngestRecordView
     */
    'unconsentedDropped': number;
    /**
     * 
     * @type {Array<RecordMappingIssueView>}
     * @memberof IngestRecordView
     */
    'issues': Array<RecordMappingIssueView>;
}


/**
 * 
 * @export
 * @interface InsightsConfigView
 */
export interface InsightsConfigView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof InsightsConfigView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {string}
     * @memberof InsightsConfigView
     */
    'reportUrl': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const InsightsTier = {
    Free: 'free',
    Paid: 'paid',
    Custom: 'custom'
} as const;

export type InsightsTier = typeof InsightsTier[keyof typeof InsightsTier];


/**
 * 
 * @export
 * @interface InsightsTierView
 */
export interface InsightsTierView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof InsightsTierView
     */
    'tier': InsightsTier;
}


/**
 * 
 * @export
 * @interface InviteBody
 */
export interface InviteBody {
    /**
     * 
     * @type {ThemeType}
     * @memberof InviteBody
     */
    'theme': ThemeType;
    /**
     * 
     * @type {string}
     * @memberof InviteBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof InviteBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof InviteBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof InviteBody
     */
    'role': InviteBodyRoleEnum;
}

export const InviteBodyRoleEnum = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type InviteBodyRoleEnum = typeof InviteBodyRoleEnum[keyof typeof InviteBodyRoleEnum];

/**
 * 
 * @export
 * @interface InviteListView
 */
export interface InviteListView {
    /**
     * 
     * @type {Array<InviteView>}
     * @memberof InviteListView
     */
    'items': Array<InviteView>;
    /**
     * 
     * @type {string}
     * @memberof InviteListView
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface InviteTrialData
 */
export interface InviteTrialData {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof InviteTrialData
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof InviteTrialData
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof InviteTrialData
     */
    'matchingId': string;
    /**
     * 
     * @type {string}
     * @memberof InviteTrialData
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @interface InviteView
 */
export interface InviteView {
    /**
     * 
     * @type {Language}
     * @memberof InviteView
     */
    'language': Language;
    /**
     * 
     * @type {TokenType}
     * @memberof InviteView
     */
    'tokenType': TokenType;
    /**
     * 
     * @type {Role}
     * @memberof InviteView
     */
    'role': Role;
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof InviteView
     */
    'permissions': Array<TrialPermissionEnum>;
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof InviteView
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'teamRole': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'inviteUrl': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'companyRole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'country'?: string | null;
}


/**
 * 
 * @export
 * @interface LabeledDelayItem
 */
export interface LabeledDelayItem {
    /**
     * 
     * @type {string}
     * @memberof LabeledDelayItem
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof LabeledDelayItem
     */
    'totalDelayTime': number;
}
/**
 * 
 * @export
 * @interface LandingAbroadView
 */
export interface LandingAbroadView {
    /**
     * 
     * @type {number}
     * @memberof LandingAbroadView
     */
    'potentialMatches': number;
    /**
     * 
     * @type {number}
     * @memberof LandingAbroadView
     */
    'confirmedMatches': number;
    /**
     * 
     * @type {boolean}
     * @memberof LandingAbroadView
     */
    'isPartial': boolean;
}
/**
 * 
 * @export
 * @interface LandingMonthView
 */
export interface LandingMonthView {
    /**
     * 
     * @type {string}
     * @memberof LandingMonthView
     */
    'month': string;
    /**
     * 
     * @type {number}
     * @memberof LandingMonthView
     */
    'newUsers': number;
    /**
     * 
     * @type {number}
     * @memberof LandingMonthView
     */
    'cumulativeUsers': number;
    /**
     * 
     * @type {boolean}
     * @memberof LandingMonthView
     */
    'isPartial': boolean;
}
/**
 * 
 * @export
 * @interface LandingPatientsView
 */
export interface LandingPatientsView {
    /**
     * 
     * @type {number}
     * @memberof LandingPatientsView
     */
    'totalPatients': number;
}
/**
 * 
 * @export
 * @interface LandingProfileView
 */
export interface LandingProfileView {
    /**
     * 
     * @type {LandingScopeType}
     * @memberof LandingProfileView
     */
    'type': LandingScopeType;
    /**
     * 
     * @type {string}
     * @memberof LandingProfileView
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof LandingProfileView
     */
    'label': string;
}


/**
 * 
 * @export
 * @interface LandingRadiusView
 */
export interface LandingRadiusView {
    /**
     * 
     * @type {number}
     * @memberof LandingRadiusView
     */
    'radiusKm': number;
    /**
     * 
     * @type {number}
     * @memberof LandingRadiusView
     */
    'patientCount': number;
}
/**
 * 
 * @export
 * @interface LandingRegionView
 */
export interface LandingRegionView {
    /**
     * 
     * @type {string}
     * @memberof LandingRegionView
     */
    'city'?: string;
    /**
     * 
     * @type {number}
     * @memberof LandingRegionView
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof LandingRegionView
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof LandingRegionView
     */
    'patientCount': number;
    /**
     * 
     * @type {number}
     * @memberof LandingRegionView
     */
    'distanceKm': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LandingScopeType = {
    Partner: 'partner',
    Site: 'site',
    Global: 'global'
} as const;

export type LandingScopeType = typeof LandingScopeType[keyof typeof LandingScopeType];


/**
 * 
 * @export
 * @interface LandingScopeView
 */
export interface LandingScopeView {
    /**
     * 
     * @type {LandingScopeType}
     * @memberof LandingScopeView
     */
    'type': LandingScopeType;
    /**
     * 
     * @type {string}
     * @memberof LandingScopeView
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingScopeView
     */
    'label'?: string;
}


/**
 * 
 * @export
 * @interface LandingSitePointView
 */
export interface LandingSitePointView {
    /**
     * 
     * @type {string}
     * @memberof LandingSitePointView
     */
    'facility'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingSitePointView
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingSitePointView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof LandingSitePointView
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof LandingSitePointView
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof LandingSitePointView
     */
    'activeTrialCount': number;
}
/**
 * 
 * @export
 * @interface LandingSiteView
 */
export interface LandingSiteView {
    /**
     * 
     * @type {string}
     * @memberof LandingSiteView
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingSiteView
     */
    'country'?: string;
    /**
     * 
     * @type {number}
     * @memberof LandingSiteView
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingSiteView
     */
    'longitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandingSiteView
     */
    'facility': string;
    /**
     * 
     * @type {Array<LandingRadiusView>}
     * @memberof LandingSiteView
     */
    'patientsNearby': Array<LandingRadiusView>;
    /**
     * 
     * @type {Array<LandingRegionView>}
     * @memberof LandingSiteView
     */
    'nearbyRegions': Array<LandingRegionView>;
}
/**
 * 
 * @export
 * @interface LandingSitesView
 */
export interface LandingSitesView {
    /**
     * 
     * @type {number}
     * @memberof LandingSitesView
     */
    'siteCount': number;
    /**
     * 
     * @type {number}
     * @memberof LandingSitesView
     */
    'countryCount': number;
}
/**
 * 
 * @export
 * @interface LandingTrialRowView
 */
export interface LandingTrialRowView {
    /**
     * 
     * @type {string}
     * @memberof LandingTrialRowView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof LandingTrialRowView
     */
    'nctCode': string;
    /**
     * 
     * @type {string}
     * @memberof LandingTrialRowView
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof LandingTrialRowView
     */
    'sponsor': string;
    /**
     * 
     * @type {string}
     * @memberof LandingTrialRowView
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof LandingTrialRowView
     */
    'potentialMatches': number;
    /**
     * 
     * @type {number}
     * @memberof LandingTrialRowView
     */
    'confirmedMatches': number;
    /**
     * 
     * @type {boolean}
     * @memberof LandingTrialRowView
     */
    'isPartial': boolean;
    /**
     * 
     * @type {LandingAbroadView}
     * @memberof LandingTrialRowView
     */
    'abroad': LandingAbroadView;
    /**
     * 
     * @type {number}
     * @memberof LandingTrialRowView
     */
    'siteCount': number;
    /**
     * 
     * @type {number}
     * @memberof LandingTrialRowView
     */
    'countryCount': number;
}
/**
 * 
 * @export
 * @interface LandingTrialsView
 */
export interface LandingTrialsView {
    /**
     * 
     * @type {number}
     * @memberof LandingTrialsView
     */
    'totalTrials': number;
    /**
     * 
     * @type {number}
     * @memberof LandingTrialsView
     */
    'activeTrials': number;
    /**
     * 
     * @type {number}
     * @memberof LandingTrialsView
     */
    'potentialMatches': number;
    /**
     * 
     * @type {number}
     * @memberof LandingTrialsView
     */
    'confirmedMatches': number;
    /**
     * 
     * @type {boolean}
     * @memberof LandingTrialsView
     */
    'isPartial': boolean;
    /**
     * 
     * @type {LandingAbroadView}
     * @memberof LandingTrialsView
     */
    'abroad': LandingAbroadView;
}
/**
 * 
 * @export
 * @interface LandingUsersView
 */
export interface LandingUsersView {
    /**
     * 
     * @type {Array<string>}
     * @memberof LandingUsersView
     */
    'sources': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LandingUsersView
     */
    'totalUsers': number;
    /**
     * 
     * @type {boolean}
     * @memberof LandingUsersView
     */
    'isPartial': boolean;
    /**
     * 
     * @type {Array<LandingMonthView>}
     * @memberof LandingUsersView
     */
    'byMonth': Array<LandingMonthView>;
}
/**
 * 
 * @export
 * @interface LandingView
 */
export interface LandingView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof LandingView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {Array<LandingProfileView>}
     * @memberof LandingView
     */
    'profiles'?: Array<LandingProfileView>;
    /**
     * 
     * @type {LandingSitesView}
     * @memberof LandingView
     */
    'sites'?: LandingSitesView;
    /**
     * 
     * @type {LandingPatientsView}
     * @memberof LandingView
     */
    'patients'?: LandingPatientsView;
    /**
     * 
     * @type {LandingUsersView}
     * @memberof LandingView
     */
    'users'?: LandingUsersView;
    /**
     * 
     * @type {LandingSiteView}
     * @memberof LandingView
     */
    'site'?: LandingSiteView;
    /**
     * 
     * @type {LandingScopeView}
     * @memberof LandingView
     */
    'scope': LandingScopeView;
    /**
     * 
     * @type {LandingTrialsView}
     * @memberof LandingView
     */
    'trials': LandingTrialsView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof LandingView
     */
    'byTherapeuticArea': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof LandingView
     */
    'bySponsor': ReportingTieredBreakdownView;
    /**
     * 
     * @type {Array<TrialCountrySitesView>}
     * @memberof LandingView
     */
    'byCountry': Array<TrialCountrySitesView>;
    /**
     * 
     * @type {Array<LandingSitePointView>}
     * @memberof LandingView
     */
    'sitePoints': Array<LandingSitePointView>;
    /**
     * 
     * @type {Array<LandingTrialRowView>}
     * @memberof LandingView
     */
    'trialList': Array<LandingTrialRowView>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const Language = {
    En: 'en',
    Es: 'es',
    Nl: 'nl',
    Fr: 'fr',
    De: 'de',
    Cs: 'cs',
    It: 'it',
    Pt: 'pt',
    Pl: 'pl'
} as const;

export type Language = typeof Language[keyof typeof Language];


/**
 * 
 * @export
 * @interface LeadBody
 */
export interface LeadBody {
    /**
     * 
     * @type {string}
     * @memberof LeadBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LeadBody
     */
    'fbp'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadBody
     */
    'fbc'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadBody
     */
    'eventId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadBody
     */
    'sourceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadBody
     */
    'userAgent'?: string;
}
/**
 * 
 * @export
 * @interface LeadResponsible
 */
export interface LeadResponsible {
    /**
     * 
     * @type {string}
     * @memberof LeadResponsible
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsible
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsible
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsible
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface LeadResponsibleView
 */
export interface LeadResponsibleView {
    /**
     * 
     * @type {string}
     * @memberof LeadResponsibleView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsibleView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsibleView
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LibraryDecision = {
    MapToExisting: 'MAP_TO_EXISTING',
    FlagForReview: 'FLAG_FOR_REVIEW',
    QueueForLibrary: 'QUEUE_FOR_LIBRARY'
} as const;

export type LibraryDecision = typeof LibraryDecision[keyof typeof LibraryDecision];


/**
 * 
 * @export
 * @interface LinkedAccountView
 */
export interface LinkedAccountView {
    /**
     * 
     * @type {BehalfOf}
     * @memberof LinkedAccountView
     */
    'relation': BehalfOf;
    /**
     * 
     * @type {string}
     * @memberof LinkedAccountView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedAccountView
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedAccountView
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedAccountView
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface LinkedAccountsView
 */
export interface LinkedAccountsView {
    /**
     * 
     * @type {Array<LinkedAccountView>}
     * @memberof LinkedAccountsView
     */
    'linkedAccounts': Array<LinkedAccountView>;
}
/**
 * 
 * @export
 * @interface ListAdminOverviewView
 */
export interface ListAdminOverviewView {
    /**
     * 
     * @type {Array<AdminOverviewView>}
     * @memberof ListAdminOverviewView
     */
    'items': Array<AdminOverviewView>;
    /**
     * 
     * @type {number}
     * @memberof ListAdminOverviewView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListAttributeView
 */
export interface ListAttributeView {
    /**
     * 
     * @type {Array<AttributeView>}
     * @memberof ListAttributeView
     */
    'items': Array<AttributeView>;
    /**
     * 
     * @type {number}
     * @memberof ListAttributeView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCategoryContextTranslationView
 */
export interface ListCategoryContextTranslationView {
    /**
     * 
     * @type {Array<CategoryContextTranslationView>}
     * @memberof ListCategoryContextTranslationView
     */
    'items': Array<CategoryContextTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListCategoryContextTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCategoryDiseaseView
 */
export interface ListCategoryDiseaseView {
    /**
     * 
     * @type {Array<CategoryDiseaseView>}
     * @memberof ListCategoryDiseaseView
     */
    'items': Array<CategoryDiseaseView>;
    /**
     * 
     * @type {number}
     * @memberof ListCategoryDiseaseView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCategoryQuestionView
 */
export interface ListCategoryQuestionView {
    /**
     * 
     * @type {Array<CategoryQuestionView>}
     * @memberof ListCategoryQuestionView
     */
    'items': Array<CategoryQuestionView>;
    /**
     * 
     * @type {number}
     * @memberof ListCategoryQuestionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCategorySearchView
 */
export interface ListCategorySearchView {
    /**
     * 
     * @type {Array<CategorySearchView>}
     * @memberof ListCategorySearchView
     */
    'items': Array<CategorySearchView>;
    /**
     * 
     * @type {number}
     * @memberof ListCategorySearchView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListChatEntryView
 */
export interface ListChatEntryView {
    /**
     * 
     * @type {Array<ChatEntryView>}
     * @memberof ListChatEntryView
     */
    'items': Array<ChatEntryView>;
    /**
     * 
     * @type {number}
     * @memberof ListChatEntryView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCohortView
 */
export interface ListCohortView {
    /**
     * 
     * @type {Array<CohortView>}
     * @memberof ListCohortView
     */
    'items': Array<CohortView>;
    /**
     * 
     * @type {number}
     * @memberof ListCohortView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListContactView
 */
export interface ListContactView {
    /**
     * 
     * @type {Array<ContactView>}
     * @memberof ListContactView
     */
    'items': Array<ContactView>;
    /**
     * 
     * @type {number}
     * @memberof ListContactView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListConversionRuleView
 */
export interface ListConversionRuleView {
    /**
     * 
     * @type {Array<ConversionRuleView>}
     * @memberof ListConversionRuleView
     */
    'items': Array<ConversionRuleView>;
    /**
     * 
     * @type {number}
     * @memberof ListConversionRuleView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCriteriaActivityView
 */
export interface ListCriteriaActivityView {
    /**
     * 
     * @type {Array<CriteriaActivityView>}
     * @memberof ListCriteriaActivityView
     */
    'items': Array<CriteriaActivityView>;
    /**
     * 
     * @type {number}
     * @memberof ListCriteriaActivityView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListDependencyProposalView
 */
export interface ListDependencyProposalView {
    /**
     * 
     * @type {Array<DependencyProposalView>}
     * @memberof ListDependencyProposalView
     */
    'items': Array<DependencyProposalView>;
    /**
     * 
     * @type {number}
     * @memberof ListDependencyProposalView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListDiseaseNameView
 */
export interface ListDiseaseNameView {
    /**
     * 
     * @type {Array<DiseaseNameView>}
     * @memberof ListDiseaseNameView
     */
    'items': Array<DiseaseNameView>;
    /**
     * 
     * @type {number}
     * @memberof ListDiseaseNameView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListDiseaseTranslationView
 */
export interface ListDiseaseTranslationView {
    /**
     * 
     * @type {Array<DiseaseTranslationView>}
     * @memberof ListDiseaseTranslationView
     */
    'items': Array<DiseaseTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListDiseaseTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListDiseaseV2View
 */
export interface ListDiseaseV2View {
    /**
     * 
     * @type {Array<DiseaseV2View>}
     * @memberof ListDiseaseV2View
     */
    'items': Array<DiseaseV2View>;
    /**
     * 
     * @type {number}
     * @memberof ListDiseaseV2View
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListDiseaseView
 */
export interface ListDiseaseView {
    /**
     * 
     * @type {Array<DiseaseView>}
     * @memberof ListDiseaseView
     */
    'items': Array<DiseaseView>;
    /**
     * 
     * @type {number}
     * @memberof ListDiseaseView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListHospitalCenterView
 */
export interface ListHospitalCenterView {
    /**
     * 
     * @type {Array<HospitalCenterView>}
     * @memberof ListHospitalCenterView
     */
    'items': Array<HospitalCenterView>;
    /**
     * 
     * @type {number}
     * @memberof ListHospitalCenterView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListHospitalNameView
 */
export interface ListHospitalNameView {
    /**
     * 
     * @type {Array<HospitalNameView>}
     * @memberof ListHospitalNameView
     */
    'items': Array<HospitalNameView>;
    /**
     * 
     * @type {number}
     * @memberof ListHospitalNameView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListHospitalTranslationView
 */
export interface ListHospitalTranslationView {
    /**
     * 
     * @type {Array<HospitalTranslationView>}
     * @memberof ListHospitalTranslationView
     */
    'items': Array<HospitalTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListHospitalTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListHospitalView
 */
export interface ListHospitalView {
    /**
     * 
     * @type {Array<HospitalView>}
     * @memberof ListHospitalView
     */
    'items': Array<HospitalView>;
    /**
     * 
     * @type {number}
     * @memberof ListHospitalView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListIcdDiseaseView
 */
export interface ListIcdDiseaseView {
    /**
     * 
     * @type {Array<IcdDiseaseView>}
     * @memberof ListIcdDiseaseView
     */
    'items': Array<IcdDiseaseView>;
    /**
     * 
     * @type {number}
     * @memberof ListIcdDiseaseView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListLabeledDelayItem
 */
export interface ListLabeledDelayItem {
    /**
     * 
     * @type {Array<LabeledDelayItem>}
     * @memberof ListLabeledDelayItem
     */
    'items': Array<LabeledDelayItem>;
    /**
     * 
     * @type {number}
     * @memberof ListLabeledDelayItem
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListMatchedSetPatientView
 */
export interface ListMatchedSetPatientView {
    /**
     * 
     * @type {Array<MatchedSetPatientView>}
     * @memberof ListMatchedSetPatientView
     */
    'items': Array<MatchedSetPatientView>;
    /**
     * 
     * @type {number}
     * @memberof ListMatchedSetPatientView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListMatchedSetSliceView
 */
export interface ListMatchedSetSliceView {
    /**
     * 
     * @type {Array<MatchedSetSliceView>}
     * @memberof ListMatchedSetSliceView
     */
    'items': Array<MatchedSetSliceView>;
    /**
     * 
     * @type {number}
     * @memberof ListMatchedSetSliceView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListMatchedSetTrialView
 */
export interface ListMatchedSetTrialView {
    /**
     * 
     * @type {Array<MatchedSetTrialView>}
     * @memberof ListMatchedSetTrialView
     */
    'items': Array<MatchedSetTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListMatchedSetTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListMilestoneListView
 */
export interface ListMilestoneListView {
    /**
     * 
     * @type {Array<MilestoneListView>}
     * @memberof ListMilestoneListView
     */
    'items': Array<MilestoneListView>;
    /**
     * 
     * @type {number}
     * @memberof ListMilestoneListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListOriginalCriterionView
 */
export interface ListOriginalCriterionView {
    /**
     * 
     * @type {Array<OriginalCriterionView>}
     * @memberof ListOriginalCriterionView
     */
    'items': Array<OriginalCriterionView>;
    /**
     * 
     * @type {number}
     * @memberof ListOriginalCriterionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPanelView
 */
export interface ListPanelView {
    /**
     * 
     * @type {Array<PanelView>}
     * @memberof ListPanelView
     */
    'items': Array<PanelView>;
    /**
     * 
     * @type {number}
     * @memberof ListPanelView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListParityDivergenceView
 */
export interface ListParityDivergenceView {
    /**
     * 
     * @type {Array<ParityDivergenceView>}
     * @memberof ListParityDivergenceView
     */
    'items': Array<ParityDivergenceView>;
    /**
     * 
     * @type {number}
     * @memberof ListParityDivergenceView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListParityGroupedTrialView
 */
export interface ListParityGroupedTrialView {
    /**
     * 
     * @type {Array<ParityGroupedTrialView>}
     * @memberof ListParityGroupedTrialView
     */
    'items': Array<ParityGroupedTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListParityGroupedTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListParityRoutingEventView
 */
export interface ListParityRoutingEventView {
    /**
     * 
     * @type {Array<ParityRoutingEventView>}
     * @memberof ListParityRoutingEventView
     */
    'items': Array<ParityRoutingEventView>;
    /**
     * 
     * @type {number}
     * @memberof ListParityRoutingEventView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListParityRoutingView
 */
export interface ListParityRoutingView {
    /**
     * 
     * @type {Array<ParityRoutingView>}
     * @memberof ListParityRoutingView
     */
    'items': Array<ParityRoutingView>;
    /**
     * 
     * @type {number}
     * @memberof ListParityRoutingView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListParitySliceView
 */
export interface ListParitySliceView {
    /**
     * 
     * @type {Array<ParitySliceView>}
     * @memberof ListParitySliceView
     */
    'items': Array<ParitySliceView>;
    /**
     * 
     * @type {number}
     * @memberof ListParitySliceView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListParityTrialSliceView
 */
export interface ListParityTrialSliceView {
    /**
     * 
     * @type {Array<ParityTrialSliceView>}
     * @memberof ListParityTrialSliceView
     */
    'items': Array<ParityTrialSliceView>;
    /**
     * 
     * @type {number}
     * @memberof ListParityTrialSliceView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListParityTrialView
 */
export interface ListParityTrialView {
    /**
     * 
     * @type {Array<ParityTrialView>}
     * @memberof ListParityTrialView
     */
    'items': Array<ParityTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListParityTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPendingLocationChangeView
 */
export interface ListPendingLocationChangeView {
    /**
     * 
     * @type {Array<PendingLocationChangeView>}
     * @memberof ListPendingLocationChangeView
     */
    'items': Array<PendingLocationChangeView>;
    /**
     * 
     * @type {number}
     * @memberof ListPendingLocationChangeView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPredicateLibraryItemSimilarView
 */
export interface ListPredicateLibraryItemSimilarView {
    /**
     * 
     * @type {Array<PredicateLibraryItemSimilarView>}
     * @memberof ListPredicateLibraryItemSimilarView
     */
    'items': Array<PredicateLibraryItemSimilarView>;
    /**
     * 
     * @type {number}
     * @memberof ListPredicateLibraryItemSimilarView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPredicateLibraryItemView
 */
export interface ListPredicateLibraryItemView {
    /**
     * 
     * @type {Array<PredicateLibraryItemView>}
     * @memberof ListPredicateLibraryItemView
     */
    'items': Array<PredicateLibraryItemView>;
    /**
     * 
     * @type {number}
     * @memberof ListPredicateLibraryItemView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPredicateLibraryQueueView
 */
export interface ListPredicateLibraryQueueView {
    /**
     * 
     * @type {Array<PredicateLibraryQueueView>}
     * @memberof ListPredicateLibraryQueueView
     */
    'items': Array<PredicateLibraryQueueView>;
    /**
     * 
     * @type {number}
     * @memberof ListPredicateLibraryQueueView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPredicatePipelineTrialView
 */
export interface ListPredicatePipelineTrialView {
    /**
     * 
     * @type {Array<PredicatePipelineTrialView>}
     * @memberof ListPredicatePipelineTrialView
     */
    'items': Array<PredicatePipelineTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListPredicatePipelineTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPredicateQuestionView
 */
export interface ListPredicateQuestionView {
    /**
     * 
     * @type {Array<PredicateQuestionView>}
     * @memberof ListPredicateQuestionView
     */
    'items': Array<PredicateQuestionView>;
    /**
     * 
     * @type {number}
     * @memberof ListPredicateQuestionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListProjectionDetailView
 */
export interface ListProjectionDetailView {
    /**
     * 
     * @type {Array<ProjectionDetailView>}
     * @memberof ListProjectionDetailView
     */
    'items': Array<ProjectionDetailView>;
    /**
     * 
     * @type {number}
     * @memberof ListProjectionDetailView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPublicLocationView
 */
export interface ListPublicLocationView {
    /**
     * 
     * @type {Array<PublicLocationView>}
     * @memberof ListPublicLocationView
     */
    'items': Array<PublicLocationView>;
    /**
     * 
     * @type {number}
     * @memberof ListPublicLocationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionCategoryView
 */
export interface ListQuestionCategoryView {
    /**
     * 
     * @type {Array<QuestionCategoryView>}
     * @memberof ListQuestionCategoryView
     */
    'items': Array<QuestionCategoryView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionCategoryView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionContextTranslationView
 */
export interface ListQuestionContextTranslationView {
    /**
     * 
     * @type {Array<QuestionContextTranslationView>}
     * @memberof ListQuestionContextTranslationView
     */
    'items': Array<QuestionContextTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionContextTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionOptionView
 */
export interface ListQuestionOptionView {
    /**
     * 
     * @type {Array<QuestionOptionView>}
     * @memberof ListQuestionOptionView
     */
    'items': Array<QuestionOptionView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionOptionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionTranslationView
 */
export interface ListQuestionTranslationView {
    /**
     * 
     * @type {Array<QuestionTranslationView>}
     * @memberof ListQuestionTranslationView
     */
    'items': Array<QuestionTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionView
 */
export interface ListQuestionView {
    /**
     * 
     * @type {Array<QuestionView>}
     * @memberof ListQuestionView
     */
    'items': Array<QuestionView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSliceCountryView
 */
export interface ListSliceCountryView {
    /**
     * 
     * @type {Array<SliceCountryView>}
     * @memberof ListSliceCountryView
     */
    'items': Array<SliceCountryView>;
    /**
     * 
     * @type {number}
     * @memberof ListSliceCountryView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSliceReadinessTrialView
 */
export interface ListSliceReadinessTrialView {
    /**
     * 
     * @type {Array<SliceReadinessTrialView>}
     * @memberof ListSliceReadinessTrialView
     */
    'items': Array<SliceReadinessTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListSliceReadinessTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSliceReadinessView
 */
export interface ListSliceReadinessView {
    /**
     * 
     * @type {Array<SliceReadinessView>}
     * @memberof ListSliceReadinessView
     */
    'items': Array<SliceReadinessView>;
    /**
     * 
     * @type {number}
     * @memberof ListSliceReadinessView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSponsorView
 */
export interface ListSponsorView {
    /**
     * 
     * @type {Array<SponsorView>}
     * @memberof ListSponsorView
     */
    'items': Array<SponsorView>;
    /**
     * 
     * @type {number}
     * @memberof ListSponsorView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSurveyQuestionView
 */
export interface ListSurveyQuestionView {
    /**
     * 
     * @type {Array<SurveyQuestionView>}
     * @memberof ListSurveyQuestionView
     */
    'items': Array<SurveyQuestionView>;
    /**
     * 
     * @type {number}
     * @memberof ListSurveyQuestionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSurveyResponseView
 */
export interface ListSurveyResponseView {
    /**
     * 
     * @type {Array<SurveyResponseView>}
     * @memberof ListSurveyResponseView
     */
    'items': Array<SurveyResponseView>;
    /**
     * 
     * @type {number}
     * @memberof ListSurveyResponseView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSurveyTranslationView
 */
export interface ListSurveyTranslationView {
    /**
     * 
     * @type {Array<SurveyTranslationView>}
     * @memberof ListSurveyTranslationView
     */
    'items': Array<SurveyTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListSurveyTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSurveyView
 */
export interface ListSurveyView {
    /**
     * 
     * @type {Array<SurveyView>}
     * @memberof ListSurveyView
     */
    'items': Array<SurveyView>;
    /**
     * 
     * @type {number}
     * @memberof ListSurveyView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTeamPanelView
 */
export interface ListTeamPanelView {
    /**
     * 
     * @type {Array<TeamPanelView>}
     * @memberof ListTeamPanelView
     */
    'items': Array<TeamPanelView>;
    /**
     * 
     * @type {number}
     * @memberof ListTeamPanelView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTeamReportingScopeAuditLogEntryView
 */
export interface ListTeamReportingScopeAuditLogEntryView {
    /**
     * 
     * @type {Array<TeamReportingScopeAuditLogEntryView>}
     * @memberof ListTeamReportingScopeAuditLogEntryView
     */
    'items': Array<TeamReportingScopeAuditLogEntryView>;
    /**
     * 
     * @type {number}
     * @memberof ListTeamReportingScopeAuditLogEntryView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTeamTrialView
 */
export interface ListTeamTrialView {
    /**
     * 
     * @type {Array<TeamTrialView>}
     * @memberof ListTeamTrialView
     */
    'items': Array<TeamTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListTeamTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTierView
 */
export interface ListTierView {
    /**
     * 
     * @type {Array<TierView>}
     * @memberof ListTierView
     */
    'items': Array<TierView>;
    /**
     * 
     * @type {number}
     * @memberof ListTierView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialAcceptedView
 */
export interface ListTrialAcceptedView {
    /**
     * 
     * @type {Array<TrialAcceptedView>}
     * @memberof ListTrialAcceptedView
     */
    'items': Array<TrialAcceptedView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialAcceptedView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialActivityView
 */
export interface ListTrialActivityView {
    /**
     * 
     * @type {Array<TrialActivityView>}
     * @memberof ListTrialActivityView
     */
    'items': Array<TrialActivityView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialActivityView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialAtomicPredicateView
 */
export interface ListTrialAtomicPredicateView {
    /**
     * 
     * @type {Array<TrialAtomicPredicateView>}
     * @memberof ListTrialAtomicPredicateView
     */
    'items': Array<TrialAtomicPredicateView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialAtomicPredicateView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialContactView
 */
export interface ListTrialContactView {
    /**
     * 
     * @type {Array<TrialContactView>}
     * @memberof ListTrialContactView
     */
    'items': Array<TrialContactView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialContactView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialCriteriaView
 */
export interface ListTrialCriteriaView {
    /**
     * 
     * @type {Array<TrialCriteriaView>}
     * @memberof ListTrialCriteriaView
     */
    'items': Array<TrialCriteriaView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialCriteriaView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialEnrolledView
 */
export interface ListTrialEnrolledView {
    /**
     * 
     * @type {Array<TrialEnrolledView>}
     * @memberof ListTrialEnrolledView
     */
    'items': Array<TrialEnrolledView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialEnrolledView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialLocationView
 */
export interface ListTrialLocationView {
    /**
     * 
     * @type {Array<TrialLocationView>}
     * @memberof ListTrialLocationView
     */
    'items': Array<TrialLocationView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialLocationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialMatchView
 */
export interface ListTrialMatchView {
    /**
     * 
     * @type {Array<TrialMatchView>}
     * @memberof ListTrialMatchView
     */
    'items': Array<TrialMatchView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialMatchView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialPredicateView
 */
export interface ListTrialPredicateView {
    /**
     * 
     * @type {Array<TrialPredicateView>}
     * @memberof ListTrialPredicateView
     */
    'items': Array<TrialPredicateView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialPredicateView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialPublicView
 */
export interface ListTrialPublicView {
    /**
     * 
     * @type {Array<TrialPublicView>}
     * @memberof ListTrialPublicView
     */
    'items': Array<TrialPublicView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialPublicView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialTranslationView
 */
export interface ListTrialTranslationView {
    /**
     * 
     * @type {Array<TrialTranslationView>}
     * @memberof ListTrialTranslationView
     */
    'items': Array<TrialTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialView
 */
export interface ListTrialView {
    /**
     * 
     * @type {Array<TrialView>}
     * @memberof ListTrialView
     */
    'items': Array<TrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialVolunteerActivityUsersView
 */
export interface ListTrialVolunteerActivityUsersView {
    /**
     * 
     * @type {Array<TrialVolunteerActivityUsersView>}
     * @memberof ListTrialVolunteerActivityUsersView
     */
    'items': Array<TrialVolunteerActivityUsersView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialVolunteerActivityUsersView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialVolunteerActivityView
 */
export interface ListTrialVolunteerActivityView {
    /**
     * 
     * @type {Array<TrialVolunteerActivityView>}
     * @memberof ListTrialVolunteerActivityView
     */
    'items': Array<TrialVolunteerActivityView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialVolunteerActivityView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListUniqueLocationView
 */
export interface ListUniqueLocationView {
    /**
     * 
     * @type {Array<UniqueLocationView>}
     * @memberof ListUniqueLocationView
     */
    'items': Array<UniqueLocationView>;
    /**
     * 
     * @type {number}
     * @memberof ListUniqueLocationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListUserPanelView
 */
export interface ListUserPanelView {
    /**
     * 
     * @type {Array<UserPanelView>}
     * @memberof ListUserPanelView
     */
    'items': Array<UserPanelView>;
    /**
     * 
     * @type {number}
     * @memberof ListUserPanelView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListUserSurveyView
 */
export interface ListUserSurveyView {
    /**
     * 
     * @type {Array<UserSurveyView>}
     * @memberof ListUserSurveyView
     */
    'items': Array<UserSurveyView>;
    /**
     * 
     * @type {number}
     * @memberof ListUserSurveyView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListUserTrialLocationView
 */
export interface ListUserTrialLocationView {
    /**
     * 
     * @type {Array<UserTrialLocationView>}
     * @memberof ListUserTrialLocationView
     */
    'items': Array<UserTrialLocationView>;
    /**
     * 
     * @type {number}
     * @memberof ListUserTrialLocationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListUserTrialView
 */
export interface ListUserTrialView {
    /**
     * 
     * @type {Array<UserTrialView>}
     * @memberof ListUserTrialView
     */
    'items': Array<UserTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListUserTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface LocationChangeFieldView
 */
export interface LocationChangeFieldView {
    /**
     * 
     * @type {string}
     * @memberof LocationChangeFieldView
     */
    'field': string;
    /**
     * 
     * @type {object}
     * @memberof LocationChangeFieldView
     */
    'oldValue': object;
    /**
     * 
     * @type {object}
     * @memberof LocationChangeFieldView
     */
    'newValue': object;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LocationChangeType = {
    Create: 'create',
    Update: 'update',
    Remove: 'remove'
} as const;

export type LocationChangeType = typeof LocationChangeType[keyof typeof LocationChangeType];


/**
 * 
 * @export
 * @interface LocationContactAddBody
 */
export interface LocationContactAddBody {
    /**
     * 
     * @type {string}
     * @memberof LocationContactAddBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LocationContactAddBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LocationContactAddBody
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface LocationContactUpdateBody
 */
export interface LocationContactUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof LocationContactUpdateBody
     */
    'contactId': string;
}
/**
 * 
 * @export
 * @interface LocationDetailView
 */
export interface LocationDetailView {
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @interface LocationEffectBody
 */
export interface LocationEffectBody {
    /**
     * 
     * @type {EffectType}
     * @memberof LocationEffectBody
     */
    'type': EffectType;
    /**
     * 
     * @type {boolean}
     * @memberof LocationEffectBody
     */
    'withDirectMessage': boolean;
    /**
     * 
     * @type {string}
     * @memberof LocationEffectBody
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationEffectBody
     */
    'contactId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationEffectBody
     */
    'showContactDetails'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const LocationLockReason = {
    WidenSearch: 'widenSearch',
    OutsideEurope: 'outsideEurope'
} as const;

export type LocationLockReason = typeof LocationLockReason[keyof typeof LocationLockReason];


/**
 * 
 * @export
 * @enum {string}
 */

export const LocationRecruitmentStatus = {
    Active: 'active',
    Closed: 'closed'
} as const;

export type LocationRecruitmentStatus = typeof LocationRecruitmentStatus[keyof typeof LocationRecruitmentStatus];


/**
 * 
 * @export
 * @interface LocationSimpleView
 */
export interface LocationSimpleView {
    /**
     * 
     * @type {string}
     * @memberof LocationSimpleView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof LocationSimpleView
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface LocationUpdateBody
 */
export interface LocationUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof LocationUpdateBody
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationUpdateBody
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationUpdateBody
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationUpdateBody
     */
    'facility'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationUpdateBody
     */
    'showContactDetails'?: boolean;
}
/**
 * 
 * @export
 * @interface LocationView
 */
export interface LocationView {
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'facility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'locationStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationView
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationView
     */
    'showContactDetails': boolean;
    /**
     * 
     * @type {EffectView}
     * @memberof LocationView
     */
    'effect'?: EffectView;
}
/**
 * 
 * @export
 * @interface LoginBody
 */
export interface LoginBody {
    /**
     * 
     * @type {Language}
     * @memberof LoginBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    'password': string;
}


/**
 * 
 * @export
 * @interface LoginView
 */
export interface LoginView {
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof LoginView
     */
    'teamPermissions'?: Array<TeamPermissionEnum>;
    /**
     * 
     * @type {Array<PanelPermissionEnum>}
     * @memberof LoginView
     */
    'panelPermissions'?: Array<PanelPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'refreshToken': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'teamId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'intercomHash'?: string | null;
    /**
     * 
     * @type {Array<ReducedTeamView>}
     * @memberof LoginView
     */
    'teams'?: Array<ReducedTeamView> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ManagementStatus = {
    None: 'none',
    Researcher: 'researcher',
    Curewiki: 'curewiki',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type ManagementStatus = typeof ManagementStatus[keyof typeof ManagementStatus];


/**
 * 
 * @export
 * @interface MandateLocationView
 */
export interface MandateLocationView {
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MandatePermissionEnum = {
    Trialread: 'trial:read',
    Trialwrite: 'trial:write',
    Teamwrite: 'team:write'
} as const;

export type MandatePermissionEnum = typeof MandatePermissionEnum[keyof typeof MandatePermissionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const MandateStatus = {
    Default: 'default',
    Paid: 'paid'
} as const;

export type MandateStatus = typeof MandateStatus[keyof typeof MandateStatus];


/**
 * 
 * @export
 * @interface MandateView
 */
export interface MandateView {
    /**
     * 
     * @type {MandateStatus}
     * @memberof MandateView
     */
    'status': MandateStatus;
    /**
     * 
     * @type {string}
     * @memberof MandateView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof MandateView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MandateView
     */
    'trialTitle': string;
    /**
     * 
     * @type {MandateLocationView}
     * @memberof MandateView
     */
    'location': MandateLocationView;
    /**
     * 
     * @type {string}
     * @memberof MandateView
     */
    'nextUnassignDate'?: string | null;
}


/**
 * 
 * @export
 * @interface MatchedSetPatientView
 */
export interface MatchedSetPatientView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof MatchedSetPatientView
     */
    'legacyStatus'?: UserTrialStatus;
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof MatchedSetPatientView
     */
    'engineStatus'?: UserTrialStatus;
    /**
     * 
     * @type {RolloutStage}
     * @memberof MatchedSetPatientView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetPatientView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetPatientView
     */
    'disease': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetPatientView
     */
    'diseaseName': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetPatientView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetPatientView
     */
    'capturedAt': string;
}


/**
 * 
 * @export
 * @interface MatchedSetSliceView
 */
export interface MatchedSetSliceView {
    /**
     * 
     * @type {RolloutStage}
     * @memberof MatchedSetSliceView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetSliceView
     */
    'disease': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetSliceView
     */
    'diseaseName': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetSliceView
     */
    'country': string;
    /**
     * The newest capture among the slice\'s trials. Capture runs only at `shadow`, so once the slice moves on this date stops advancing: the counts are the shadow phase\'s final read.
     * @type {string}
     * @memberof MatchedSetSliceView
     */
    'lastCapturedAt': string;
    /**
     * Patients compared in the latest run — the denominator for `agreementPercent`.
     * @type {number}
     * @memberof MatchedSetSliceView
     */
    'totalCompared': number;
    /**
     * Matched by both — agreement.
     * @type {number}
     * @memberof MatchedSetSliceView
     */
    'overlap': number;
    /**
     * Matched by legacy, dropped by the engine — **patients we would lose**.
     * @type {number}
     * @memberof MatchedSetSliceView
     */
    'legacyOnly': number;
    /**
     * Matched by the engine only — patients we would gain.
     * @type {number}
     * @memberof MatchedSetSliceView
     */
    'engineOnly': number;
    /**
     * Matched by neither — agreement, and the bulk of the rows.
     * @type {number}
     * @memberof MatchedSetSliceView
     */
    'neither': number;
    /**
     * `(overlap + neither) / totalCompared` — how often the two engines reached the same verdict, agreeing to match and agreeing to decline alike. 0 when nothing was compared.
     * @type {number}
     * @memberof MatchedSetSliceView
     */
    'agreementPercent': number;
    /**
     * The run was captured within ten seconds of a stage change for its slice, while other processes could still serve the previous stage. Its counts may be off; a regenerate replaces them. On a slice row: true when any of its trials\' runs were.
     * @type {boolean}
     * @memberof MatchedSetSliceView
     */
    'capturedDuringStageChange': boolean;
}


/**
 * 
 * @export
 * @interface MatchedSetTrialView
 */
export interface MatchedSetTrialView {
    /**
     * 
     * @type {RolloutStage}
     * @memberof MatchedSetTrialView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetTrialView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetTrialView
     */
    'nctId': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetTrialView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetTrialView
     */
    'disease': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetTrialView
     */
    'diseaseName': string;
    /**
     * 
     * @type {string}
     * @memberof MatchedSetTrialView
     */
    'country': string;
    /**
     * When this trial\'s cohort was last captured — a stale trial reads differently.
     * @type {string}
     * @memberof MatchedSetTrialView
     */
    'capturedAt': string;
    /**
     * Patients compared in the latest run — the denominator for `agreementPercent`.
     * @type {number}
     * @memberof MatchedSetTrialView
     */
    'totalCompared': number;
    /**
     * Matched by both — agreement.
     * @type {number}
     * @memberof MatchedSetTrialView
     */
    'overlap': number;
    /**
     * Matched by legacy, dropped by the engine — **patients we would lose**.
     * @type {number}
     * @memberof MatchedSetTrialView
     */
    'legacyOnly': number;
    /**
     * Matched by the engine only — patients we would gain.
     * @type {number}
     * @memberof MatchedSetTrialView
     */
    'engineOnly': number;
    /**
     * Matched by neither — agreement, and the bulk of the rows.
     * @type {number}
     * @memberof MatchedSetTrialView
     */
    'neither': number;
    /**
     * `(overlap + neither) / totalCompared` — how often the two engines reached the same verdict, agreeing to match and agreeing to decline alike. 0 when nothing was compared.
     * @type {number}
     * @memberof MatchedSetTrialView
     */
    'agreementPercent': number;
    /**
     * The run was captured within ten seconds of a stage change for its slice, while other processes could still serve the previous stage. Its counts may be off; a regenerate replaces them. On a slice row: true when any of its trials\' runs were.
     * @type {boolean}
     * @memberof MatchedSetTrialView
     */
    'capturedDuringStageChange': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MatchingTrialStatus = {
    Processing: 'processing',
    Proposed: 'proposed',
    Active: 'active',
    Completed: 'completed',
    Deleted: 'deleted'
} as const;

export type MatchingTrialStatus = typeof MatchingTrialStatus[keyof typeof MatchingTrialStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const MessageType = {
    Question: 'question',
    Notification: 'notification',
    Link: 'link',
    Action: 'action',
    RequestEmail: 'requestEmail'
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];


/**
 * 
 * @export
 * @interface MetadataView
 */
export interface MetadataView {
    /**
     * 
     * @type {string}
     * @memberof MetadataView
     */
    'metadata': string;
    /**
     * 
     * @type {string}
     * @memberof MetadataView
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface MigrateSponsorToTrialManagerBody
 */
export interface MigrateSponsorToTrialManagerBody {
    /**
     * Map of trial IDs to location IDs
     * @type {object}
     * @memberof MigrateSponsorToTrialManagerBody
     */
    'trialLocations': object;
}
/**
 * 
 * @export
 * @interface MilestoneAddTranslationBody
 */
export interface MilestoneAddTranslationBody {
    /**
     * 
     * @type {Language}
     * @memberof MilestoneAddTranslationBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof MilestoneAddTranslationBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneAddTranslationBody
     */
    'description'?: string;
}


/**
 * 
 * @export
 * @interface MilestoneAttachmentUrlView
 */
export interface MilestoneAttachmentUrlView {
    /**
     * 
     * @type {string}
     * @memberof MilestoneAttachmentUrlView
     */
    'downloadUrl': string;
}
/**
 * 
 * @export
 * @interface MilestoneAttachmentView
 */
export interface MilestoneAttachmentView {
    /**
     * 
     * @type {Language}
     * @memberof MilestoneAttachmentView
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof MilestoneAttachmentView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneAttachmentView
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneAttachmentView
     */
    'contentType': string;
    /**
     * 
     * @type {number}
     * @memberof MilestoneAttachmentView
     */
    'fileSize': number;
    /**
     * 
     * @type {string}
     * @memberof MilestoneAttachmentView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneAttachmentView
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface MilestoneDetailView
 */
export interface MilestoneDetailView {
    /**
     * 
     * @type {number}
     * @memberof MilestoneDetailView
     */
    'position': number;
    /**
     * 
     * @type {number}
     * @memberof MilestoneDetailView
     */
    'daysAfterEnrollment': number;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDetailView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDetailView
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MilestoneDetailView
     */
    'links'?: Array<string>;
    /**
     * 
     * @type {Array<MilestoneProgramAttachmentView>}
     * @memberof MilestoneDetailView
     */
    'attachments'?: Array<MilestoneProgramAttachmentView>;
}
/**
 * 
 * @export
 * @interface MilestoneLinkBody
 */
export interface MilestoneLinkBody {
    /**
     * 
     * @type {Language}
     * @memberof MilestoneLinkBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof MilestoneLinkBody
     */
    'link': string;
}


/**
 * 
 * @export
 * @interface MilestoneLinkUpdateBody
 */
export interface MilestoneLinkUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof MilestoneLinkUpdateBody
     */
    'link'?: string;
}
/**
 * 
 * @export
 * @interface MilestoneLinkView
 */
export interface MilestoneLinkView {
    /**
     * 
     * @type {Language}
     * @memberof MilestoneLinkView
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof MilestoneLinkView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneLinkView
     */
    'link': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneLinkView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneLinkView
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface MilestoneListView
 */
export interface MilestoneListView {
    /**
     * 
     * @type {string}
     * @memberof MilestoneListView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneListView
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof MilestoneListView
     */
    'daysAfterEnrollment': number;
    /**
     * 
     * @type {number}
     * @memberof MilestoneListView
     */
    'linksCount': number;
    /**
     * 
     * @type {number}
     * @memberof MilestoneListView
     */
    'attachmentsCount': number;
    /**
     * 
     * @type {string}
     * @memberof MilestoneListView
     */
    'status': MilestoneListViewStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof MilestoneListView
     */
    'languages': Array<MilestoneListViewLanguagesEnum>;
    /**
     * 
     * @type {string}
     * @memberof MilestoneListView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneListView
     */
    'updatedAt': string;
}

export const MilestoneListViewStatusEnum = {
    Draft: 'draft',
    Active: 'active'
} as const;

export type MilestoneListViewStatusEnum = typeof MilestoneListViewStatusEnum[keyof typeof MilestoneListViewStatusEnum];
export const MilestoneListViewLanguagesEnum = {
    En: 'en',
    Es: 'es',
    Nl: 'nl',
    Fr: 'fr',
    De: 'de',
    Cs: 'cs',
    It: 'it',
    Pt: 'pt',
    Pl: 'pl'
} as const;

export type MilestoneListViewLanguagesEnum = typeof MilestoneListViewLanguagesEnum[keyof typeof MilestoneListViewLanguagesEnum];

/**
 * 
 * @export
 * @interface MilestoneProgramAttachmentView
 */
export interface MilestoneProgramAttachmentView {
    /**
     * 
     * @type {string}
     * @memberof MilestoneProgramAttachmentView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneProgramAttachmentView
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneProgramAttachmentView
     */
    's3Key': string;
}
/**
 * 
 * @export
 * @interface MilestoneProgramOverviewView
 */
export interface MilestoneProgramOverviewView {
    /**
     * 
     * @type {Array<MilestoneDetailView>}
     * @memberof MilestoneProgramOverviewView
     */
    'milestones': Array<MilestoneDetailView>;
    /**
     * 
     * @type {number}
     * @memberof MilestoneProgramOverviewView
     */
    'currentPosition'?: number;
}
/**
 * 
 * @export
 * @interface MilestoneTokenView
 */
export interface MilestoneTokenView {
    /**
     * 
     * @type {string}
     * @memberof MilestoneTokenView
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneTokenView
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneTokenView
     */
    'trialId': string;
}
/**
 * 
 * @export
 * @interface MilestoneTranslationInput
 */
export interface MilestoneTranslationInput {
    /**
     * 
     * @type {Language}
     * @memberof MilestoneTranslationInput
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationInput
     */
    'description'?: string;
}


/**
 * 
 * @export
 * @interface MilestoneTranslationUpdateBody
 */
export interface MilestoneTranslationUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationUpdateBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationUpdateBody
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface MilestoneTranslationView
 */
export interface MilestoneTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof MilestoneTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationView
     */
    'description'?: string;
}


/**
 * 
 * @export
 * @interface MilestoneUpdateBody
 */
export interface MilestoneUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof MilestoneUpdateBody
     */
    'status'?: MilestoneUpdateBodyStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof MilestoneUpdateBody
     */
    'daysAfterEnrollment'?: number;
}

export const MilestoneUpdateBodyStatusEnum = {
    Draft: 'draft',
    Active: 'active'
} as const;

export type MilestoneUpdateBodyStatusEnum = typeof MilestoneUpdateBodyStatusEnum[keyof typeof MilestoneUpdateBodyStatusEnum];

/**
 * 
 * @export
 * @interface MilestoneUploadAttachmentBody
 */
export interface MilestoneUploadAttachmentBody {
    /**
     * 
     * @type {Language}
     * @memberof MilestoneUploadAttachmentBody
     */
    'language': Language;
}


/**
 * 
 * @export
 * @interface MilestoneView
 */
export interface MilestoneView {
    /**
     * 
     * @type {string}
     * @memberof MilestoneView
     */
    'id': string;
    /**
     * 
     * @type {Array<MilestoneTranslationView>}
     * @memberof MilestoneView
     */
    'translations': Array<MilestoneTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof MilestoneView
     */
    'daysAfterEnrollment': number;
    /**
     * 
     * @type {Array<MilestoneLinkView>}
     * @memberof MilestoneView
     */
    'links': Array<MilestoneLinkView>;
    /**
     * 
     * @type {Array<MilestoneAttachmentView>}
     * @memberof MilestoneView
     */
    'attachments': Array<MilestoneAttachmentView>;
    /**
     * 
     * @type {string}
     * @memberof MilestoneView
     */
    'status': MilestoneViewStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof MilestoneView
     */
    'languages': Array<MilestoneViewLanguagesEnum>;
    /**
     * 
     * @type {string}
     * @memberof MilestoneView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneView
     */
    'updatedAt': string;
}

export const MilestoneViewStatusEnum = {
    Draft: 'draft',
    Active: 'active'
} as const;

export type MilestoneViewStatusEnum = typeof MilestoneViewStatusEnum[keyof typeof MilestoneViewStatusEnum];
export const MilestoneViewLanguagesEnum = {
    En: 'en',
    Es: 'es',
    Nl: 'nl',
    Fr: 'fr',
    De: 'de',
    Cs: 'cs',
    It: 'it',
    Pt: 'pt',
    Pl: 'pl'
} as const;

export type MilestoneViewLanguagesEnum = typeof MilestoneViewLanguagesEnum[keyof typeof MilestoneViewLanguagesEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const MySurveyCommandType = {
    Start: 'start',
    Stop: 'stop'
} as const;

export type MySurveyCommandType = typeof MySurveyCommandType[keyof typeof MySurveyCommandType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MyTrialCommandType = {
    Start: 'start',
    Stop: 'stop'
} as const;

export type MyTrialCommandType = typeof MyTrialCommandType[keyof typeof MyTrialCommandType];


/**
 * 
 * @export
 * @interface NestedCategoryView
 */
export interface NestedCategoryView {
    /**
     * 
     * @type {string}
     * @memberof NestedCategoryView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCategoryView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCategoryView
     */
    'shortName': string;
    /**
     * 
     * @type {Array<NestedCategoryView>}
     * @memberof NestedCategoryView
     */
    'subCategories': Array<NestedCategoryView>;
    /**
     * 
     * @type {string}
     * @memberof NestedCategoryView
     */
    'type': NestedCategoryViewTypeEnum;
}

export const NestedCategoryViewTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type NestedCategoryViewTypeEnum = typeof NestedCategoryViewTypeEnum[keyof typeof NestedCategoryViewTypeEnum];

/**
 * 
 * @export
 * @interface NewDiseaseTranslationsBody
 */
export interface NewDiseaseTranslationsBody {
    /**
     * 
     * @type {Language}
     * @memberof NewDiseaseTranslationsBody
     */
    'language': Language;
    /**
     * 
     * @type {number}
     * @memberof NewDiseaseTranslationsBody
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewDiseaseTranslationsBody
     */
    'offset'?: number;
}


/**
 * 
 * @export
 * @interface NewLanguageBody
 */
export interface NewLanguageBody {
    /**
     * 
     * @type {Language}
     * @memberof NewLanguageBody
     */
    'language': Language;
    /**
     * 
     * @type {boolean}
     * @memberof NewLanguageBody
     */
    'regenerate'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NewLanguageBody
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewLanguageBody
     */
    'offset'?: number;
}


/**
 * How this node combines its direct children — predicates and child nodes alike.
 * @export
 * @enum {string}
 */

export const NodeOperator = {
    And: 'AND',
    Or: 'OR'
} as const;

export type NodeOperator = typeof NodeOperator[keyof typeof NodeOperator];


/**
 * 
 * @export
 * @interface NotificationCountView
 */
export interface NotificationCountView {
    /**
     * 
     * @type {number}
     * @memberof NotificationCountView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface NotificationListView
 */
export interface NotificationListView {
    /**
     * 
     * @type {Array<NotificationView>}
     * @memberof NotificationListView
     */
    'items': Array<NotificationView>;
    /**
     * 
     * @type {string}
     * @memberof NotificationListView
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface NotificationReadBody
 */
export interface NotificationReadBody {
    /**
     * 
     * @type {string}
     * @memberof NotificationReadBody
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationReadBody
     */
    'end': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationStatus = {
    Read: 'read',
    Unread: 'unread'
} as const;

export type NotificationStatus = typeof NotificationStatus[keyof typeof NotificationStatus];


/**
 * 
 * @export
 * @interface NotificationView
 */
export interface NotificationView {
    /**
     * 
     * @type {NotificationStatus}
     * @memberof NotificationView
     */
    'status': NotificationStatus;
    /**
     * 
     * @type {string}
     * @memberof NotificationView
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationView
     */
    'text': string;
    /**
     * 
     * @type {ContextView}
     * @memberof NotificationView
     */
    'context': ContextView;
    /**
     * 
     * @type {string}
     * @memberof NotificationView
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OntologySystem = {
    Icd10: 'ICD10',
    Snomed: 'SNOMED',
    Loinc: 'LOINC',
    RxNorm: 'RxNorm',
    Atc: 'ATC',
    Cvx: 'CVX'
} as const;

export type OntologySystem = typeof OntologySystem[keyof typeof OntologySystem];


/**
 * 
 * @export
 * @interface OptionView
 */
export interface OptionView {
    /**
     * 
     * @type {Language}
     * @memberof OptionView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof OptionView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof OptionView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof OptionView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof OptionView
     */
    'key': string;
    /**
     * 
     * @type {boolean}
     * @memberof OptionView
     */
    'requireCustomValue'?: boolean | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderDirection = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type OrderDirection = typeof OrderDirection[keyof typeof OrderDirection];


/**
 * 
 * @export
 * @interface OriginalCriteriaUpdateBody
 */
export interface OriginalCriteriaUpdateBody {
    /**
     * A corrected boolean tree, replacing the stored one wholesale. Omitted = keep the pipeline\'s tree. Only meaningful alongside `splitStatus`: an edit is part of resolving the split, which keeps the write inside the window where Step 4 has not yet consumed anything.
     * @type {CriterionTreeBody}
     * @memberof OriginalCriteriaUpdateBody
     */
    'tree'?: CriterionTreeBody;
    /**
     * Prescreen decisions the reviewer changed on this criterion\'s atoms. Only alongside an approval, which also confirms every atom still waiting on a prescreen review. Each id must be a live atom of this criterion that already carries a decision.
     * @type {Array<AtomPrescreenDecisionBody>}
     * @memberof OriginalCriteriaUpdateBody
     */
    'decisions'?: Array<AtomPrescreenDecisionBody>;
    /**
     * 
     * @type {FeedbackType}
     * @memberof OriginalCriteriaUpdateBody
     */
    'feedbackType'?: FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaUpdateBody
     */
    'splitStatus': OriginalCriteriaUpdateBodySplitStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaUpdateBody
     */
    'notes'?: string;
}

export const OriginalCriteriaUpdateBodySplitStatusEnum = {
    Unreviewed: 'unreviewed',
    NeedsAttention: 'needs_attention',
    AutoApproved: 'auto_approved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type OriginalCriteriaUpdateBodySplitStatusEnum = typeof OriginalCriteriaUpdateBodySplitStatusEnum[keyof typeof OriginalCriteriaUpdateBodySplitStatusEnum];

/**
 * 
 * @export
 * @interface OriginalCriterionView
 */
export interface OriginalCriterionView {
    /**
     * 
     * @type {CriteriaType}
     * @memberof OriginalCriterionView
     */
    'criteriaType': CriteriaType;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof OriginalCriterionView
     */
    'splitStatus': PipelineReviewStatus;
    /**
     * 
     * @type {ConfidenceLevel}
     * @memberof OriginalCriterionView
     */
    'splitConfidence'?: ConfidenceLevel;
    /**
     * The criterion\'s boolean logic tree (`form: original`), flat and root-first. Returned by the list endpoint too, not just detail: the review surface draws a tree per criterion, so detail-only would force a request per card. It is 1..3 rows for almost every criterion, so the payload cost is negligible.
     * @type {Array<CriterionNodeView>}
     * @memberof OriginalCriterionView
     */
    'nodes': Array<CriterionNodeView>;
    /**
     * The axes this row still has a reviewer\'s verdict to take back, from the ledger. A terminal status is not enough on its own: a row its step auto-approved, or one decided before the ledger recorded axes, has nothing to reverse.
     * @type {Array<string>}
     * @memberof OriginalCriterionView
     */
    'undoableAxes': Array<OriginalCriterionViewUndoableAxesEnum>;
    /**
     * Audit trail for HITL flow (a). Populated only on the detail endpoint; the list endpoint returns an empty array to keep payloads small.
     * @type {Array<CriteriaActivityView>}
     * @memberof OriginalCriterionView
     */
    'activities': Array<CriteriaActivityView>;
    /**
     * 
     * @type {string}
     * @memberof OriginalCriterionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OriginalCriterionView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OriginalCriterionView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof OriginalCriterionView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof OriginalCriterionView
     */
    'rawText': string;
    /**
     * 
     * @type {number}
     * @memberof OriginalCriterionView
     */
    'position': number;
    /**
     * Why the split wants a careful read, such as an operator the pipeline corrected. Null when clean.
     * @type {string}
     * @memberof OriginalCriterionView
     */
    'splitReviewReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OriginalCriterionView
     */
    'atomicCount': number;
}

export const OriginalCriterionViewUndoableAxesEnum = {
    Legacy: 'legacy',
    Step1: 'step-1',
    Step2: 'step-2',
    Step3: 'step-3',
    Step4: 'step-4',
    Step5: 'step-5',
    Step6: 'step-6',
    Step7: 'step-7',
    Step8: 'step-8'
} as const;

export type OriginalCriterionViewUndoableAxesEnum = typeof OriginalCriterionViewUndoableAxesEnum[keyof typeof OriginalCriterionViewUndoableAxesEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const OverallTrialStatus = {
    ActiveNotRecruiting: 'ACTIVE_NOT_RECRUITING',
    Completed: 'COMPLETED',
    EnrollingByInvitation: 'ENROLLING_BY_INVITATION',
    NotYetRecruiting: 'NOT_YET_RECRUITING',
    Recruiting: 'RECRUITING',
    Suspended: 'SUSPENDED',
    Terminated: 'TERMINATED',
    Withdrawn: 'WITHDRAWN',
    Available: 'AVAILABLE',
    NoLongerAvailable: 'NO_LONGER_AVAILABLE',
    TemporarilyNotAvailable: 'TEMPORARILY_NOT_AVAILABLE',
    ApprovedForMarketing: 'APPROVED_FOR_MARKETING',
    Withheld: 'WITHHELD',
    Unknown: 'UNKNOWN'
} as const;

export type OverallTrialStatus = typeof OverallTrialStatus[keyof typeof OverallTrialStatus];


/**
 * 
 * @export
 * @interface PageViewBody
 */
export interface PageViewBody {
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'fbp'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'fbc'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'clientIp'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'sourceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageViewBody
     */
    'fullUrl': string;
}
/**
 * 
 * @export
 * @interface PanelAssignTeamBody
 */
export interface PanelAssignTeamBody {
    /**
     * 
     * @type {string}
     * @memberof PanelAssignTeamBody
     */
    'teamId'?: string | null;
}
/**
 * 
 * @export
 * @interface PanelCreateBody
 */
export interface PanelCreateBody {
    /**
     * 
     * @type {Array<Language>}
     * @memberof PanelCreateBody
     */
    'languages': Array<Language>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'title': Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'purpose': Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'participantsWillDo'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'dateAndTime'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'format'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'preparationRequired'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'timeCommitment'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'compensation'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'followUp'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'resultSharing'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelCreateBody
     */
    'confidentiality'?: Array<TranslationBody>;
    /**
     * 
     * @type {string}
     * @memberof PanelCreateBody
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof PanelCreateBody
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface PanelDetailsView
 */
export interface PanelDetailsView {
    /**
     * 
     * @type {Array<Language>}
     * @memberof PanelDetailsView
     */
    'languages': Array<Language>;
    /**
     * 
     * @type {MatchingTrialStatus}
     * @memberof PanelDetailsView
     */
    'status': MatchingTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'id': string;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'title': Array<TranslationView>;
    /**
     * 
     * @type {Array<SponsorView>}
     * @memberof PanelDetailsView
     */
    'sponsors': Array<SponsorView>;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'purpose': Array<TranslationView>;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'participantsWillDo'?: Array<TranslationView> | null;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'dateAndTime'?: Array<TranslationView> | null;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'format'?: Array<TranslationView> | null;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'preparationRequired'?: Array<TranslationView> | null;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'timeCommitment'?: Array<TranslationView> | null;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'compensation'?: Array<TranslationView> | null;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'followUp'?: Array<TranslationView> | null;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'resultSharing'?: Array<TranslationView> | null;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof PanelDetailsView
     */
    'confidentiality'?: Array<TranslationView> | null;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'teamId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'teamName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'nextReachOutVerified'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelDetailsView
     */
    'nextReachOutMissingAnswers'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PanelOrderBy = {
    Title: 'title'
} as const;

export type PanelOrderBy = typeof PanelOrderBy[keyof typeof PanelOrderBy];


/**
 * 
 * @export
 * @enum {string}
 */

export const PanelPermissionEnum = {
    Write: 'panel:write',
    Funnel: 'panel:funnel',
    Contacts: 'panel:contacts'
} as const;

export type PanelPermissionEnum = typeof PanelPermissionEnum[keyof typeof PanelPermissionEnum];


/**
 * 
 * @export
 * @interface PanelUpdateBody
 */
export interface PanelUpdateBody {
    /**
     * 
     * @type {Array<Language>}
     * @memberof PanelUpdateBody
     */
    'languages'?: Array<Language>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'title': Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'purpose'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'participantsWillDo'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'dateAndTime'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'format'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'preparationRequired'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'timeCommitment'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'compensation'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'followUp'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'resultSharing'?: Array<TranslationBody>;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof PanelUpdateBody
     */
    'confidentiality'?: Array<TranslationBody>;
    /**
     * 
     * @type {string}
     * @memberof PanelUpdateBody
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanelUpdateBody
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface PanelView
 */
export interface PanelView {
    /**
     * 
     * @type {Array<Language>}
     * @memberof PanelView
     */
    'languages': Array<Language>;
    /**
     * 
     * @type {MatchingTrialStatus}
     * @memberof PanelView
     */
    'status': MatchingTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'title': string;
    /**
     * 
     * @type {Array<SponsorView>}
     * @memberof PanelView
     */
    'sponsors': Array<SponsorView>;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'purpose': string;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'participantsWillDo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'dateAndTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'preparationRequired'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'timeCommitment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'compensation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'followUp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'resultSharing'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'confidentiality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof PanelView
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof PanelView
     */
    'confirmedUserTrialCount': number;
}


/**
 * 
 * @export
 * @interface ParityDivergenceView
 */
export interface ParityDivergenceView {
    /**
     * 
     * @type {RolloutStage}
     * @memberof ParityDivergenceView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {ParityDivergenceViewWalkerTuple}
     * @memberof ParityDivergenceView
     */
    'walkerTuple': ParityDivergenceViewWalkerTuple | null;
    /**
     * 
     * @type {ParityDivergenceViewBitmapTuple}
     * @memberof ParityDivergenceView
     */
    'bitmapTuple': ParityDivergenceViewBitmapTuple | null;
    /**
     * 
     * @type {string}
     * @memberof ParityDivergenceView
     */
    'id': string;
    /**
     * Null on `matchUser`/`diffOnlyUser`, which record per trial without a user.
     * @type {string}
     * @memberof ParityDivergenceView
     */
    'userId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ParityDivergenceView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ParityDivergenceView
     */
    'disease': string;
    /**
     * Display label for `disease` — always present, the slice is a `Disease` row.
     * @type {string}
     * @memberof ParityDivergenceView
     */
    'diseaseName': string;
    /**
     * 
     * @type {string}
     * @memberof ParityDivergenceView
     */
    'country': string;
    /**
     * 
     * @type {boolean}
     * @memberof ParityDivergenceView
     */
    'isMismatch': boolean;
}


/**
 * Null for a walker survivor the bitmap never returned — itself a divergence.
 * @export
 * @interface ParityDivergenceViewBitmapTuple
 */
export interface ParityDivergenceViewBitmapTuple {
    /**
     * Which cohort the user qualified through. Null for a trial-wide criterion or an empty trial.
     * @type {string}
     * @memberof ParityDivergenceViewBitmapTuple
     */
    'matchedCohort': string | null;
    /**
     * 
     * @type {string}
     * @memberof ParityDivergenceViewBitmapTuple
     */
    'trialStatus': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityDivergenceViewBitmapTuple
     */
    'satisfiedLegIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityDivergenceViewBitmapTuple
     */
    'failedLegIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityDivergenceViewBitmapTuple
     */
    'gapLegIds': Array<string>;
}
/**
 * Null for a bitmap survivor the walker never returned — itself a divergence.  `ValidateIf` rather than a bare `ValidateNested`: nested validation rejects `null` outright (\"must be either object or array\"), so a one-sided survivor would fail response validation and 500 the endpoint that exists to show it.
 * @export
 * @interface ParityDivergenceViewWalkerTuple
 */
export interface ParityDivergenceViewWalkerTuple {
    /**
     * Which cohort the user qualified through. Null for a trial-wide criterion or an empty trial.
     * @type {string}
     * @memberof ParityDivergenceViewWalkerTuple
     */
    'matchedCohort': string | null;
    /**
     * 
     * @type {string}
     * @memberof ParityDivergenceViewWalkerTuple
     */
    'trialStatus': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityDivergenceViewWalkerTuple
     */
    'satisfiedLegIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityDivergenceViewWalkerTuple
     */
    'failedLegIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityDivergenceViewWalkerTuple
     */
    'gapLegIds': Array<string>;
}
/**
 * 
 * @export
 * @interface ParityGroupedTrialView
 */
export interface ParityGroupedTrialView {
    /**
     * 
     * @type {string}
     * @memberof ParityGroupedTrialView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof ParityGroupedTrialView
     */
    'nctId': string;
    /**
     * 
     * @type {string}
     * @memberof ParityGroupedTrialView
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ParityGroupedTrialView
     */
    'comparisons': number;
    /**
     * 
     * @type {number}
     * @memberof ParityGroupedTrialView
     */
    'mismatchCount': number;
    /**
     * 
     * @type {number}
     * @memberof ParityGroupedTrialView
     */
    'ratio': number;
    /**
     * 
     * @type {Array<ParityTrialSliceView>}
     * @memberof ParityGroupedTrialView
     */
    'slices': Array<ParityTrialSliceView>;
}
/**
 * 
 * @export
 * @interface ParityRoutingEventView
 */
export interface ParityRoutingEventView {
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingEventView
     */
    'diseaseId'?: string;
    /**
     * Absent = the change was made country-wide, via the wildcard.
     * @type {string}
     * @memberof ParityRoutingEventView
     */
    'disease'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingEventView
     */
    'diseaseName'?: string;
    /**
     * 
     * @type {RolloutStage}
     * @memberof ParityRoutingEventView
     */
    'fromStage'?: RolloutStage;
    /**
     * 
     * @type {RolloutStage}
     * @memberof ParityRoutingEventView
     */
    'toStage'?: RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingEventView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingEventView
     */
    'country': string;
    /**
     * A Firebase uid, not a uuid — see `ParityRoutingEvent.actorId`.
     * @type {string}
     * @memberof ParityRoutingEventView
     */
    'actorId': string;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingEventView
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface ParityRoutingView
 */
export interface ParityRoutingView {
    /**
     * Absent = every disease in this country. A per-disease row overrides the wildcard.
     * @type {string}
     * @memberof ParityRoutingView
     */
    'diseaseId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingView
     */
    'disease'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingView
     */
    'diseaseName'?: string;
    /**
     * 
     * @type {RolloutStage}
     * @memberof ParityRoutingView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingView
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface ParitySliceView
 */
export interface ParitySliceView {
    /**
     * 
     * @type {RolloutStage}
     * @memberof ParitySliceView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof ParitySliceView
     */
    'disease': string;
    /**
     * Display label for `disease` — always present, the slice is a `Disease` row.
     * @type {string}
     * @memberof ParitySliceView
     */
    'diseaseName': string;
    /**
     * 
     * @type {string}
     * @memberof ParitySliceView
     */
    'country': string;
    /**
     * Trial counts, never summed comparisons — a trial spanning slices contributes rows under each, so a sum across trials would double-count the shared ones.
     * @type {number}
     * @memberof ParitySliceView
     */
    'trialCount': number;
    /**
     * 
     * @type {number}
     * @memberof ParitySliceView
     */
    'trialsWithMismatches': number;
}


/**
 * 
 * @export
 * @interface ParityTrialSliceView
 */
export interface ParityTrialSliceView {
    /**
     * 
     * @type {RolloutStage}
     * @memberof ParityTrialSliceView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof ParityTrialSliceView
     */
    'disease': string;
    /**
     * Display label for `disease` — always present, the slice is a `Disease` row.
     * @type {string}
     * @memberof ParityTrialSliceView
     */
    'diseaseName': string;
    /**
     * 
     * @type {string}
     * @memberof ParityTrialSliceView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof ParityTrialSliceView
     */
    'comparisons': number;
    /**
     * 
     * @type {number}
     * @memberof ParityTrialSliceView
     */
    'mismatchCount': number;
    /**
     * 
     * @type {number}
     * @memberof ParityTrialSliceView
     */
    'ratio': number;
}


/**
 * 
 * @export
 * @interface ParityTrialView
 */
export interface ParityTrialView {
    /**
     * 
     * @type {RolloutStage}
     * @memberof ParityTrialView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof ParityTrialView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof ParityTrialView
     */
    'nctId': string;
    /**
     * 
     * @type {string}
     * @memberof ParityTrialView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ParityTrialView
     */
    'disease': string;
    /**
     * Display label for `disease` — always present, the slice is a `Disease` row.
     * @type {string}
     * @memberof ParityTrialView
     */
    'diseaseName': string;
    /**
     * 
     * @type {string}
     * @memberof ParityTrialView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof ParityTrialView
     */
    'comparisons': number;
    /**
     * 
     * @type {number}
     * @memberof ParityTrialView
     */
    'mismatchCount': number;
    /**
     * 
     * @type {number}
     * @memberof ParityTrialView
     */
    'ratio': number;
}


/**
 * 
 * @export
 * @interface ParityTupleView
 */
export interface ParityTupleView {
    /**
     * Which cohort the user qualified through. Null for a trial-wide criterion or an empty trial.
     * @type {string}
     * @memberof ParityTupleView
     */
    'matchedCohort': string | null;
    /**
     * 
     * @type {string}
     * @memberof ParityTupleView
     */
    'trialStatus': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityTupleView
     */
    'satisfiedLegIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityTupleView
     */
    'failedLegIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParityTupleView
     */
    'gapLegIds': Array<string>;
}
/**
 * 
 * @export
 * @interface PatientGeographyPointView
 */
export interface PatientGeographyPointView {
    /**
     * 
     * @type {string}
     * @memberof PatientGeographyPointView
     */
    'city'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientGeographyPointView
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientGeographyPointView
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientGeographyPointView
     */
    'countryLatitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientGeographyPointView
     */
    'countryLongitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientGeographyPointView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof PatientGeographyPointView
     */
    'patientCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof PatientGeographyPointView
     */
    'rolledUpToCountry': boolean;
}
/**
 * 
 * @export
 * @interface PatientGeographyView
 */
export interface PatientGeographyView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof PatientGeographyView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {Array<PatientGeographyPointView>}
     * @memberof PatientGeographyView
     */
    'points': Array<PatientGeographyPointView>;
}


/**
 * 
 * @export
 * @interface PatientOverviewGlobalView
 */
export interface PatientOverviewGlobalView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof PatientOverviewGlobalView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'byBmi'?: ReportingTieredBreakdownView;
    /**
     * 
     * @type {number}
     * @memberof PatientOverviewGlobalView
     */
    'totalPatients': number;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'byCountry': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'byGender': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'byAgeGroup': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'byHealthStatus': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'bySmoking': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'byLanguage': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'byTherapeuticArea': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof PatientOverviewGlobalView
     */
    'byDisease': ReportingTieredBreakdownView;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PatientRejectionReason = {
    NotFittingCriteria: 'notFittingCriteria',
    Other: 'other'
} as const;

export type PatientRejectionReason = typeof PatientRejectionReason[keyof typeof PatientRejectionReason];


/**
 * 
 * @export
 * @interface PatientSignUpBody
 */
export interface PatientSignUpBody {
    /**
     * 
     * @type {Language}
     * @memberof PatientSignUpBody
     */
    'language': Language;
    /**
     * 
     * @type {Gender}
     * @memberof PatientSignUpBody
     */
    'gender'?: Gender;
    /**
     * 
     * @type {ThemeType}
     * @memberof PatientSignUpBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {BehalfOf}
     * @memberof PatientSignUpBody
     */
    'behalfOf'?: BehalfOf;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'password': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientSignUpBody
     */
    'diseases': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'hospital'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'source'?: string;
    /**
     * 
     * @type {PatientSignUpBodyCAPI}
     * @memberof PatientSignUpBody
     */
    'capiData'?: PatientSignUpBodyCAPI;
}


/**
 * 
 * @export
 * @interface PatientSignUpBodyCAPI
 */
export interface PatientSignUpBodyCAPI {
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBodyCAPI
     */
    'sourceUrl': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBodyCAPI
     */
    'eventId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBodyCAPI
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBodyCAPI
     */
    'clientIp'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBodyCAPI
     */
    'fbc'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBodyCAPI
     */
    'fbp'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PendingLocationChangeStatus = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type PendingLocationChangeStatus = typeof PendingLocationChangeStatus[keyof typeof PendingLocationChangeStatus];


/**
 * 
 * @export
 * @interface PendingLocationChangeView
 */
export interface PendingLocationChangeView {
    /**
     * 
     * @type {LocationChangeType}
     * @memberof PendingLocationChangeView
     */
    'changeType': LocationChangeType;
    /**
     * 
     * @type {PendingLocationChangeStatus}
     * @memberof PendingLocationChangeView
     */
    'status': PendingLocationChangeStatus;
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeView
     */
    'trialId': string;
    /**
     * 
     * @type {LocationView}
     * @memberof PendingLocationChangeView
     */
    'existingLocation'?: LocationView | null;
    /**
     * 
     * @type {ProposedLocationDataView}
     * @memberof PendingLocationChangeView
     */
    'proposedData'?: ProposedLocationDataView;
    /**
     * 
     * @type {Array<LocationChangeFieldView>}
     * @memberof PendingLocationChangeView
     */
    'changes'?: Array<LocationChangeFieldView>;
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeView
     */
    'detectedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeView
     */
    'respondedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeView
     */
    'respondedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeView
     */
    'respondedByTeamName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeView
     */
    'responseComment'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeView
     */
    'sourceVersionDate'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PendingLocationChangesOrderBy = {
    DetectedAt: 'detectedAt',
    ChangeType: 'changeType',
    Status: 'status'
} as const;

export type PendingLocationChangesOrderBy = typeof PendingLocationChangesOrderBy[keyof typeof PendingLocationChangesOrderBy];


/**
 * ICD-hint review lifecycle (flow-e). Null until Step 2 resolves the hints.
 * @export
 * @enum {string}
 */

export const PipelineReviewStatus = {
    Unreviewed: 'unreviewed',
    NeedsAttention: 'needs_attention',
    AutoApproved: 'auto_approved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type PipelineReviewStatus = typeof PipelineReviewStatus[keyof typeof PipelineReviewStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const PipelineStartSkipReason = {
    NotRecruiting: 'not_recruiting',
    NoSourceText: 'no_source_text'
} as const;

export type PipelineStartSkipReason = typeof PipelineStartSkipReason[keyof typeof PipelineStartSkipReason];


/**
 * 
 * @export
 * @interface PipelineStartSkippedTrialView
 */
export interface PipelineStartSkippedTrialView {
    /**
     * 
     * @type {PipelineStartSkipReason}
     * @memberof PipelineStartSkippedTrialView
     */
    'reason': PipelineStartSkipReason;
    /**
     * 
     * @type {string}
     * @memberof PipelineStartSkippedTrialView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineStartSkippedTrialView
     */
    'nct': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PipelineStep = {
    Legacy: 'legacy',
    Step1: 'step-1',
    Step2: 'step-2',
    Step3: 'step-3',
    Step4: 'step-4',
    Step5: 'step-5',
    Step6: 'step-6',
    Step7: 'step-7',
    Step8: 'step-8'
} as const;

export type PipelineStep = typeof PipelineStep[keyof typeof PipelineStep];


/**
 * 
 * @export
 * @enum {string}
 */

export const PipelineTrialState = {
    NeedsReview: 'needs_review',
    InProgress: 'in_progress',
    Failed: 'failed',
    Done: 'done'
} as const;

export type PipelineTrialState = typeof PipelineTrialState[keyof typeof PipelineTrialState];


/**
 * 
 * @export
 * @enum {string}
 */

export const Polarity = {
    Require: 'REQUIRE',
    Exclude: 'EXCLUDE'
} as const;

export type Polarity = typeof Polarity[keyof typeof Polarity];


/**
 * 
 * @export
 * @enum {string}
 */

export const PredicateAnswerType = {
    Number: 'number',
    Boolean: 'boolean',
    Enum: 'enum',
    String: 'string',
    Date: 'date'
} as const;

export type PredicateAnswerType = typeof PredicateAnswerType[keyof typeof PredicateAnswerType];


/**
 * Which reviewer action this row needs, derived from the row itself. The one field the pane branches on — `libraryDecisionReason` is LLM prose and must never be parsed.
 * @export
 * @enum {string}
 */

export const PredicateLibraryGap = {
    NewConcept: 'new_concept',
    MissingProjection: 'missing_projection',
    InvalidValue: 'invalid_value',
    WindowDisagreement: 'window_disagreement',
    NoAgreement: 'no_agreement',
    ConversionPending: 'conversion_pending',
    None: 'none'
} as const;

export type PredicateLibraryGap = typeof PredicateLibraryGap[keyof typeof PredicateLibraryGap];


/**
 * 
 * @export
 * @interface PredicateLibraryItemCreateBody
 */
export interface PredicateLibraryItemCreateBody {
    /**
     * Required, null included, when `canonicalType` has no tier mapping — checked in the handler like the tier. Null means the type has no ontology. Ignored for a mapped type.
     * @type {OntologySystem}
     * @memberof PredicateLibraryItemCreateBody
     */
    'ontologySystem'?: OntologySystem | null;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemCreateBody
     */
    'canonicalType': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemCreateBody
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemCreateBody
     */
    'unit'?: string;
    /**
     * The `ever` projection\'s answer shape, and the default later projections of this concept inherit.
     * @type {string}
     * @memberof PredicateLibraryItemCreateBody
     */
    'answerType': PredicateLibraryItemCreateBodyAnswerTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PredicateLibraryItemCreateBody
     */
    'prescreenable': boolean;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemCreateBody
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemCreateBody
     */
    'ontologyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemCreateBody
     */
    'existingTierId'?: string;
    /**
     * 
     * @type {PredicateLibraryItemNewTier}
     * @memberof PredicateLibraryItemCreateBody
     */
    'newTier'?: PredicateLibraryItemNewTier;
    /**
     * Why the taxonomy needs a new canonical type. Required when `canonicalType` has no tier mapping, checked in the handler like the tier, and kept on the audit row. Ignored for a mapped type.
     * @type {string}
     * @memberof PredicateLibraryItemCreateBody
     */
    'reason'?: string;
}

export const PredicateLibraryItemCreateBodyAnswerTypeEnum = {
    Number: 'number',
    Boolean: 'boolean',
    Enum: 'enum',
    String: 'string',
    Date: 'date'
} as const;

export type PredicateLibraryItemCreateBodyAnswerTypeEnum = typeof PredicateLibraryItemCreateBodyAnswerTypeEnum[keyof typeof PredicateLibraryItemCreateBodyAnswerTypeEnum];

/**
 * 
 * @export
 * @interface PredicateLibraryItemNewTier
 */
export interface PredicateLibraryItemNewTier {
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemNewTier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemNewTier
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface PredicateLibraryItemSimilarView
 */
export interface PredicateLibraryItemSimilarView {
    /**
     * 
     * @type {OntologySystem}
     * @memberof PredicateLibraryItemSimilarView
     */
    'ontologySystem'?: OntologySystem;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'canonicalType': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'canonicalField': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'displayName': string;
    /**
     * Null for a canonical type nobody has tiered yet — such a concept is asked last.
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'tierId'?: string | null;
    /**
     * Denormalised for the library table, so it renders a tier without a second request.
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'tierName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemSimilarView
     */
    'ontologyCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PredicateLibraryItemSimilarView
     */
    'isDeprecated': boolean;
    /**
     * How much of the library leans on this concept. Deprecating never rewrites predicates, so these are the warning shown before retiring one — and what makes a zero-usage row visibly droppable.
     * @type {number}
     * @memberof PredicateLibraryItemSimilarView
     */
    'predicateCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateLibraryItemSimilarView
     */
    'trialCount': number;
    /**
     * Live (non-deprecated) projections.
     * @type {number}
     * @memberof PredicateLibraryItemSimilarView
     */
    'projectionCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateLibraryItemSimilarView
     */
    'questionCount': number;
    /**
     * 1 for the same field after normalising, down to 0.4, the least an item needs to be offered.
     * @type {number}
     * @memberof PredicateLibraryItemSimilarView
     */
    'score': number;
}


/**
 * 
 * @export
 * @interface PredicateLibraryItemUpdateBody
 */
export interface PredicateLibraryItemUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemUpdateBody
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemUpdateBody
     */
    'ontologyCode'?: string | null;
}
/**
 * 
 * @export
 * @interface PredicateLibraryItemView
 */
export interface PredicateLibraryItemView {
    /**
     * 
     * @type {OntologySystem}
     * @memberof PredicateLibraryItemView
     */
    'ontologySystem'?: OntologySystem;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'canonicalType': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'canonicalField': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'displayName': string;
    /**
     * Null for a canonical type nobody has tiered yet — such a concept is asked last.
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'tierId'?: string | null;
    /**
     * Denormalised for the library table, so it renders a tier without a second request.
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'tierName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemView
     */
    'ontologyCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PredicateLibraryItemView
     */
    'isDeprecated': boolean;
    /**
     * How much of the library leans on this concept. Deprecating never rewrites predicates, so these are the warning shown before retiring one — and what makes a zero-usage row visibly droppable.
     * @type {number}
     * @memberof PredicateLibraryItemView
     */
    'predicateCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateLibraryItemView
     */
    'trialCount': number;
    /**
     * Live (non-deprecated) projections.
     * @type {number}
     * @memberof PredicateLibraryItemView
     */
    'projectionCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateLibraryItemView
     */
    'questionCount': number;
}


/**
 * 
 * @export
 * @interface PredicateLibraryQueueView
 */
export interface PredicateLibraryQueueView {
    /**
     * 
     * @type {PredicateLibraryGap}
     * @memberof PredicateLibraryQueueView
     */
    'gap': PredicateLibraryGap;
    /**
     * 
     * @type {ProjectionType}
     * @memberof PredicateLibraryQueueView
     */
    'projectionType'?: ProjectionType;
    /**
     * 
     * @type {TemporalBoundsUnit}
     * @memberof PredicateLibraryQueueView
     */
    'windowUnit'?: TemporalBoundsUnit;
    /**
     * The group\'s identity, as a string the client can key on. Composite everywhere else, so anything that has to name one group - an expansion, a create form, a refetch - would otherwise rebuild the same tuple by hand at each call site.
     * @type {string}
     * @memberof PredicateLibraryQueueView
     */
    'key': string;
    /**
     * Proposed on a `new_concept` group; the assigned category\'s own on a `missing_projection` one.
     * @type {string}
     * @memberof PredicateLibraryQueueView
     */
    'canonicalType': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryQueueView
     */
    'field': string;
    /**
     * Part of a concept\'s natural key, so it is part of the `new_concept` group\'s key too - the same type and field in two units are two categories, and one creation cannot serve both.
     * @type {string}
     * @memberof PredicateLibraryQueueView
     */
    'unit'?: string | null;
    /**
     * The category whose projection is missing. Null on a `new_concept` group - there isn\'t one.
     * @type {string}
     * @memberof PredicateLibraryQueueView
     */
    'predicateLibraryItemId'?: string | null;
    /**
     * The window a proposed `count` is asked over. Null for every other type - there the window rides on each predicate as a matching filter and belongs to no projection, so grouping by it would split one projection into one group per trial.
     * @type {number}
     * @memberof PredicateLibraryQueueView
     */
    'windowValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PredicateLibraryQueueView
     */
    'predicateCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateLibraryQueueView
     */
    'trialCount': number;
    /**
     * The library row that answers this group now exists, so nothing is left to create - only the blocked predicates to repoint. Creating never repoints, so the group would otherwise sit here unchanged after the work was done and invite a second reviewer creating it again.
     * @type {boolean}
     * @memberof PredicateLibraryQueueView
     */
    'isResolved': boolean;
    /**
     * The category (`new_concept`) or projection (`missing_projection`) that resolved it, once one has.
     * @type {string}
     * @memberof PredicateLibraryQueueView
     */
    'resolvedId'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PredicateOperator = {
    Eq: 'eq',
    Neq: 'neq',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte',
    In: 'in',
    NotIn: 'not_in',
    Between: 'between',
    Contains: 'contains',
    Exists: 'exists',
    NotExists: 'not_exists'
} as const;

export type PredicateOperator = typeof PredicateOperator[keyof typeof PredicateOperator];


/**
 * 
 * @export
 * @interface PredicatePipelineAutoApproveBody
 */
export interface PredicatePipelineAutoApproveBody {
    /**
     * 
     * @type {Array<PredicatePipelineAutoApproveStepBody>}
     * @memberof PredicatePipelineAutoApproveBody
     */
    'steps': Array<PredicatePipelineAutoApproveStepBody>;
}
/**
 * 
 * @export
 * @interface PredicatePipelineAutoApproveStepBody
 */
export interface PredicatePipelineAutoApproveStepBody {
    /**
     * 
     * @type {PipelineStep}
     * @memberof PredicatePipelineAutoApproveStepBody
     */
    'step': PipelineStep;
    /**
     * 
     * @type {boolean}
     * @memberof PredicatePipelineAutoApproveStepBody
     */
    'autoApprove': boolean;
}


/**
 * 
 * @export
 * @interface PredicatePipelineAutoApproveStepView
 */
export interface PredicatePipelineAutoApproveStepView {
    /**
     * 
     * @type {PipelineStep}
     * @memberof PredicatePipelineAutoApproveStepView
     */
    'step': PipelineStep;
    /**
     * 
     * @type {boolean}
     * @memberof PredicatePipelineAutoApproveStepView
     */
    'autoApprove': boolean;
    /**
     * False only when the step stamps `TrialPredicate.status` (Step 4) and `MATCHABLE_STATUSES` leaves out `auto_approved`, so the engine could not match the rows the switch approves. The endpoint refuses that write, so the settings UI reads this and disables the control instead of offering a 400.
     * @type {boolean}
     * @memberof PredicatePipelineAutoApproveStepView
     */
    'isAvailable': boolean;
}


/**
 * 
 * @export
 * @interface PredicatePipelineAutoApproveView
 */
export interface PredicatePipelineAutoApproveView {
    /**
     * 
     * @type {Array<PredicatePipelineAutoApproveStepView>}
     * @memberof PredicatePipelineAutoApproveView
     */
    'steps': Array<PredicatePipelineAutoApproveStepView>;
}
/**
 * 
 * @export
 * @interface PredicatePipelinePendingItemView
 */
export interface PredicatePipelinePendingItemView {
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelinePendingItemView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelinePendingItemView
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface PredicatePipelineSetIssueView
 */
export interface PredicatePipelineSetIssueView {
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineSetIssueView
     */
    'text': string;
    /**
     * The passage of source text the issue rests on, verbatim, for the reviewer surface to highlight. Null for an issue about the output itself rather than about a passage.
     * @type {string}
     * @memberof PredicatePipelineSetIssueView
     */
    'sourceQuote': string | null;
}
/**
 * 
 * @export
 * @interface PredicatePipelineStartSliceView
 */
export interface PredicatePipelineStartSliceView {
    /**
     * 
     * @type {number}
     * @memberof PredicatePipelineStartSliceView
     */
    'queued': number;
    /**
     * 
     * @type {Array<PipelineStartSkippedTrialView>}
     * @memberof PredicatePipelineStartSliceView
     */
    'skipped': Array<PipelineStartSkippedTrialView>;
}
/**
 * 
 * @export
 * @interface PredicatePipelineStepView
 */
export interface PredicatePipelineStepView {
    /**
     * 
     * @type {PipelineStep}
     * @memberof PredicatePipelineStepView
     */
    'step': PipelineStep;
    /**
     * 
     * @type {StepClaimStatus}
     * @memberof PredicatePipelineStepView
     */
    'claimStatus': StepClaimStatus;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineStepView
     */
    'claimUpdatedAt': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PredicatePipelineStepView
     */
    'gateOpen': boolean;
    /**
     * 
     * @type {number}
     * @memberof PredicatePipelineStepView
     */
    'pendingCount': number;
    /**
     * 
     * @type {Array<PredicatePipelinePendingItemView>}
     * @memberof PredicatePipelineStepView
     */
    'pendingItems': Array<PredicatePipelinePendingItemView>;
    /**
     * Problems with the step\'s output as a whole (a cohort the extraction missed, two that overlap). They apply to every row the step produced, so they belong above the list rather than repeated on each row.
     * @type {Array<PredicatePipelineSetIssueView>}
     * @memberof PredicatePipelineStepView
     */
    'setIssues': Array<PredicatePipelineSetIssueView>;
}


/**
 * 
 * @export
 * @interface PredicatePipelineStepsView
 */
export interface PredicatePipelineStepsView {
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineStepsView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineStepsView
     */
    'nct': string;
    /**
     * 
     * @type {PredicatePipelineTrialContextView}
     * @memberof PredicatePipelineStepsView
     */
    'trial': PredicatePipelineTrialContextView;
    /**
     * 
     * @type {Array<PredicatePipelineStepView>}
     * @memberof PredicatePipelineStepsView
     */
    'steps': Array<PredicatePipelineStepView>;
}
/**
 * 
 * @export
 * @interface PredicatePipelineTrialContextView
 */
export interface PredicatePipelineTrialContextView {
    /**
     * 
     * @type {OverallTrialStatus}
     * @memberof PredicatePipelineTrialContextView
     */
    'overallStatus': OverallTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineTrialContextView
     */
    'officialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineTrialContextView
     */
    'rawBriefSummary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineTrialContextView
     */
    'detailedDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineTrialContextView
     */
    'rawEligibilityText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineTrialContextView
     */
    'url': string;
}


/**
 * 
 * @export
 * @interface PredicatePipelineTrialView
 */
export interface PredicatePipelineTrialView {
    /**
     * 
     * @type {PipelineStep}
     * @memberof PredicatePipelineTrialView
     */
    'currentStep': PipelineStep;
    /**
     * 
     * @type {PipelineTrialState}
     * @memberof PredicatePipelineTrialView
     */
    'state': PipelineTrialState;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineTrialView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineTrialView
     */
    'nct': string;
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineTrialView
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof PredicatePipelineTrialView
     */
    'sourceStale': boolean;
}


/**
 * 
 * @export
 * @interface PredicateQuestionCategoryView
 */
export interface PredicateQuestionCategoryView {
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionCategoryView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionCategoryView
     */
    'canonicalType': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionCategoryView
     */
    'canonicalField': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionCategoryView
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionCategoryView
     */
    'unit'?: string | null;
}
/**
 * 
 * @export
 * @interface PredicateQuestionDependencySourceView
 */
export interface PredicateQuestionDependencySourceView {
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionDependencySourceView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionDependencySourceView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionDependencySourceView
     */
    'type': PredicateQuestionDependencySourceViewTypeEnum;
}

export const PredicateQuestionDependencySourceViewTypeEnum = {
    GreaterThan: 'greaterThan',
    DateToMonths: 'dateToMonths',
    DateToYears: 'dateToYears',
    Address: 'address',
    BmiCalculation: 'bmiCalculation',
    DiseaseProcessor: 'diseaseProcessor',
    HospitalProcessor: 'hospitalProcessor',
    EqualTo: 'equalTo',
    Dependency: 'dependency',
    NumericThreshold: 'numericThreshold',
    HasDisease: 'hasDisease',
    OptionToNumber: 'optionToNumber',
    ImpliesTrue: 'impliesTrue'
} as const;

export type PredicateQuestionDependencySourceViewTypeEnum = typeof PredicateQuestionDependencySourceViewTypeEnum[keyof typeof PredicateQuestionDependencySourceViewTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const PredicateQuestionOrderBy = {
    UpdatedAt: 'updatedAt',
    TrialCount: 'trialCount'
} as const;

export type PredicateQuestionOrderBy = typeof PredicateQuestionOrderBy[keyof typeof PredicateQuestionOrderBy];


/**
 * 
 * @export
 * @interface PredicateQuestionView
 */
export interface PredicateQuestionView {
    /**
     * 
     * @type {QuestionType}
     * @memberof PredicateQuestionView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof PredicateQuestionView
     */
    'visibilityType': VisibilityType;
    /**
     * 
     * @type {AnswerType}
     * @memberof PredicateQuestionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {GenerationType}
     * @memberof PredicateQuestionView
     */
    'generationType': GenerationType;
    /**
     * 
     * @type {PredicateQuestionCategoryView}
     * @memberof PredicateQuestionView
     */
    'predicateLibraryItem': PredicateQuestionCategoryView;
    /**
     * 
     * @type {ProjectionView}
     * @memberof PredicateQuestionView
     */
    'projection'?: ProjectionView | null;
    /**
     * Other questions this one\'s answer is computed or gated on — empty for a plain question.
     * @type {Array<PredicateQuestionDependencySourceView>}
     * @memberof PredicateQuestionView
     */
    'dependsOn': Array<PredicateQuestionDependencySourceView>;
    /**
     * Other questions computed or gated on this one\'s answer — empty for a leaf question.
     * @type {Array<PredicateQuestionDependencySourceView>}
     * @memberof PredicateQuestionView
     */
    'dependedOnBy': Array<PredicateQuestionDependencySourceView>;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionView
     */
    'rationale'?: string | null;
    /**
     * Original criterion text from a few of the predicates pointing here — \"Criteria behind it\". Capped, same spirit as the 5-sample cap the generator itself uses, so a question shared by hundreds of trials stays one cheap query.
     * @type {Array<string>}
     * @memberof PredicateQuestionView
     */
    'sampleCriteria': Array<string>;
    /**
     * How much of the library leans on this question — the reviewer\'s blast radius.
     * @type {number}
     * @memberof PredicateQuestionView
     */
    'predicateCount': number;
    /**
     * AI-proposed gates on this question still waiting for a reviewer.
     * @type {number}
     * @memberof PredicateQuestionView
     */
    'pendingDependencyProposalCount': number;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PredicateQuestionView
     */
    'isActive': boolean;
    /**
     * 
     * @type {Array<QuestionCategoryOverview>}
     * @memberof PredicateQuestionView
     */
    'categories': Array<QuestionCategoryOverview>;
    /**
     * 
     * @type {number}
     * @memberof PredicateQuestionView
     */
    'icdCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateQuestionView
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateQuestionView
     */
    'answeredCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateQuestionView
     */
    'trialCount': number;
    /**
     * 
     * @type {number}
     * @memberof PredicateQuestionView
     */
    'icdTrialCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionView
     */
    'context'?: string;
    /**
     * 
     * @type {number}
     * @memberof PredicateQuestionView
     */
    'distance'?: number | null;
}


/**
 * 
 * @export
 * @interface PredicatesUpdateBody
 */
export interface PredicatesUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'prescreenStatus'?: PredicatesUpdateBodyPrescreenStatusEnum;
    /**
     * 
     * @type {PrescreenDecision}
     * @memberof PredicatesUpdateBody
     */
    'prescreenDecision'?: PrescreenDecision;
    /**
     * Assign/repoint the predicate\'s projection. Must belong to the predicate\'s category. Omitted = unchanged.
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'projectionId'?: string;
    /**
     * 
     * @type {FeedbackType}
     * @memberof PredicatesUpdateBody
     */
    'feedbackType'?: FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'status'?: PredicatesUpdateBodyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'ontologyStatus'?: PredicatesUpdateBodyOntologyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'qualityCheckStatus'?: PredicatesUpdateBodyQualityCheckStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'operator'?: PredicatesUpdateBodyOperatorEnum;
    /**
     * 
     * @type {object}
     * @memberof PredicatesUpdateBody
     */
    'value'?: object;
    /**
     * 
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'polarity'?: PredicatesUpdateBodyPolarityEnum;
    /**
     * 
     * @type {object}
     * @memberof PredicatesUpdateBody
     */
    'temporalAnchor'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof PredicatesUpdateBody
     */
    'temporalDirection'?: object | null;
    /**
     * 
     * @type {number}
     * @memberof PredicatesUpdateBody
     */
    'temporalBoundsValue'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof PredicatesUpdateBody
     */
    'temporalBoundsUnit'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'predicateLibraryItemId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PredicatesUpdateBody
     */
    'ontologyCodes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PredicatesUpdateBody
     */
    'notes'?: string;
}

export const PredicatesUpdateBodyPrescreenStatusEnum = {
    Unreviewed: 'unreviewed'
} as const;

export type PredicatesUpdateBodyPrescreenStatusEnum = typeof PredicatesUpdateBodyPrescreenStatusEnum[keyof typeof PredicatesUpdateBodyPrescreenStatusEnum];
export const PredicatesUpdateBodyStatusEnum = {
    Unreviewed: 'unreviewed',
    NeedsAttention: 'needs_attention',
    AutoApproved: 'auto_approved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type PredicatesUpdateBodyStatusEnum = typeof PredicatesUpdateBodyStatusEnum[keyof typeof PredicatesUpdateBodyStatusEnum];
export const PredicatesUpdateBodyOntologyStatusEnum = {
    Unreviewed: 'unreviewed',
    NeedsAttention: 'needs_attention',
    AutoApproved: 'auto_approved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type PredicatesUpdateBodyOntologyStatusEnum = typeof PredicatesUpdateBodyOntologyStatusEnum[keyof typeof PredicatesUpdateBodyOntologyStatusEnum];
export const PredicatesUpdateBodyQualityCheckStatusEnum = {
    Unreviewed: 'unreviewed',
    NeedsAttention: 'needs_attention',
    AutoApproved: 'auto_approved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type PredicatesUpdateBodyQualityCheckStatusEnum = typeof PredicatesUpdateBodyQualityCheckStatusEnum[keyof typeof PredicatesUpdateBodyQualityCheckStatusEnum];
export const PredicatesUpdateBodyOperatorEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte',
    In: 'in',
    NotIn: 'not_in',
    Between: 'between',
    Contains: 'contains',
    Exists: 'exists',
    NotExists: 'not_exists'
} as const;

export type PredicatesUpdateBodyOperatorEnum = typeof PredicatesUpdateBodyOperatorEnum[keyof typeof PredicatesUpdateBodyOperatorEnum];
export const PredicatesUpdateBodyPolarityEnum = {
    Require: 'REQUIRE',
    Exclude: 'EXCLUDE'
} as const;

export type PredicatesUpdateBodyPolarityEnum = typeof PredicatesUpdateBodyPolarityEnum[keyof typeof PredicatesUpdateBodyPolarityEnum];

/**
 * 
 * @export
 * @interface PreferenceView
 */
export interface PreferenceView {
    /**
     * 
     * @type {boolean}
     * @memberof PreferenceView
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreferenceView
     */
    'notification': boolean;
    /**
     * 
     * @type {DigestView}
     * @memberof PreferenceView
     */
    'digest'?: DigestView;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PrescreenDecision = {
    Keep: 'KEEP',
    Skip: 'SKIP',
    SiteVerified: 'SITE_VERIFIED'
} as const;

export type PrescreenDecision = typeof PrescreenDecision[keyof typeof PrescreenDecision];


/**
 * 
 * @export
 * @interface ProjectionCreateBody
 */
export interface ProjectionCreateBody {
    /**
     * 
     * @type {ProjectionType}
     * @memberof ProjectionCreateBody
     */
    'type': ProjectionType;
    /**
     * 
     * @type {PredicateAnswerType}
     * @memberof ProjectionCreateBody
     */
    'answerType': PredicateAnswerType;
    /**
     * 
     * @type {TemporalBoundsUnit}
     * @memberof ProjectionCreateBody
     */
    'windowUnit'?: TemporalBoundsUnit;
    /**
     * 
     * @type {string}
     * @memberof ProjectionCreateBody
     */
    'predicateLibraryItemId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionCreateBody
     */
    'unit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectionCreateBody
     */
    'windowValue'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectionCreateBody
     */
    'prescreenable': boolean;
}


/**
 * 
 * @export
 * @interface ProjectionDetailView
 */
export interface ProjectionDetailView {
    /**
     * 
     * @type {ProjectionType}
     * @memberof ProjectionDetailView
     */
    'type': ProjectionType;
    /**
     * 
     * @type {TemporalBoundsUnit}
     * @memberof ProjectionDetailView
     */
    'windowUnit'?: TemporalBoundsUnit;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDetailView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDetailView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDetailView
     */
    'predicateLibraryItemId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDetailView
     */
    'answerType': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionDetailView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectionDetailView
     */
    'windowValue'?: number | null;
    /**
     * Null until someone rules — which reads as \"do not ask\" everywhere.
     * @type {boolean}
     * @memberof ProjectionDetailView
     */
    'prescreenable'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectionDetailView
     */
    'isDeprecated': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProjectionDetailView
     */
    'predicateCount': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectionDetailView
     */
    'questionCount': number;
}


/**
 * 
 * @export
 * @interface ProjectionSupersedeBody
 */
export interface ProjectionSupersedeBody {
    /**
     * 
     * @type {PredicateAnswerType}
     * @memberof ProjectionSupersedeBody
     */
    'answerType'?: PredicateAnswerType;
    /**
     * 
     * @type {string}
     * @memberof ProjectionSupersedeBody
     */
    'unit'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectionSupersedeBody
     */
    'prescreenable'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectionType = {
    Ever: 'ever',
    ActiveNow: 'active_now',
    LastTime: 'last_time',
    FirstTime: 'first_time',
    Count: 'count',
    CurrentValue: 'current_value',
    PeakHigh: 'peak_high',
    PeakLow: 'peak_low',
    Total: 'total',
    Duration: 'duration'
} as const;

export type ProjectionType = typeof ProjectionType[keyof typeof ProjectionType];


/**
 * 
 * @export
 * @interface ProjectionUpdateBody
 */
export interface ProjectionUpdateBody {
    /**
     * 
     * @type {PredicateAnswerType}
     * @memberof ProjectionUpdateBody
     */
    'answerType'?: PredicateAnswerType;
    /**
     * 
     * @type {string}
     * @memberof ProjectionUpdateBody
     */
    'unit'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectionUpdateBody
     */
    'prescreenable'?: boolean;
}


/**
 * 
 * @export
 * @interface ProjectionView
 */
export interface ProjectionView {
    /**
     * 
     * @type {ProjectionType}
     * @memberof ProjectionView
     */
    'type': ProjectionType;
    /**
     * 
     * @type {TemporalBoundsUnit}
     * @memberof ProjectionView
     */
    'windowUnit'?: TemporalBoundsUnit;
    /**
     * 
     * @type {string}
     * @memberof ProjectionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionView
     */
    'predicateLibraryItemId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionView
     */
    'answerType': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectionView
     */
    'windowValue'?: number | null;
    /**
     * Null until someone rules — which reads as \"do not ask\" everywhere.
     * @type {boolean}
     * @memberof ProjectionView
     */
    'prescreenable'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectionView
     */
    'isDeprecated': boolean;
}


/**
 * 
 * @export
 * @interface ProposeRuleBody
 */
export interface ProposeRuleBody {
    /**
     * 
     * @type {ConversionType}
     * @memberof ProposeRuleBody
     */
    'type': ConversionType;
    /**
     * 
     * @type {Array<ConversionRuleTestCase>}
     * @memberof ProposeRuleBody
     */
    'testCases': Array<ConversionRuleTestCase>;
    /**
     * 
     * @type {ConversionProposer}
     * @memberof ProposeRuleBody
     */
    'proposedBy': ConversionProposer;
    /**
     * 
     * @type {string}
     * @memberof ProposeRuleBody
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof ProposeRuleBody
     */
    'sourceUnit': string;
    /**
     * 
     * @type {string}
     * @memberof ProposeRuleBody
     */
    'standardUnit': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProposeRuleBody
     */
    'inputs': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProposeRuleBody
     */
    'formula': string;
    /**
     * 
     * @type {string}
     * @memberof ProposeRuleBody
     */
    'provenance': string;
}


/**
 * 
 * @export
 * @interface ProposedLocationDataView
 */
export interface ProposedLocationDataView {
    /**
     * 
     * @type {string}
     * @memberof ProposedLocationDataView
     */
    'facility'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedLocationDataView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof ProposedLocationDataView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof ProposedLocationDataView
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedLocationDataView
     */
    'locationStatus'?: string | null;
}
/**
 * 
 * @export
 * @interface PublicLocationView
 */
export interface PublicLocationView {
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'facility'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicLocationView
     */
    'isAvailable': boolean;
}
/**
 * 
 * @export
 * @interface PulseBatchBody
 */
export interface PulseBatchBody {
    /**
     * 
     * @type {Array<object>}
     * @memberof PulseBatchBody
     */
    'events': Array<object>;
}
/**
 * 
 * @export
 * @interface QuestionBody
 */
export interface QuestionBody {
    /**
     * 
     * @type {AnswerType}
     * @memberof QuestionBody
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionBody
     */
    'questionType'?: QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof QuestionBody
     */
    'visibilityType'?: VisibilityType;
    /**
     * 
     * @type {string}
     * @memberof QuestionBody
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionBody
     */
    'unit'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionBody
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestionBody
     */
    'expiry'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionBody
     */
    'autoGenerateTranslations': boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestionBody
     */
    'context'?: string;
    /**
     * Display/order priority (higher = asked earlier within its category).
     * @type {number}
     * @memberof QuestionBody
     */
    'priority'?: number;
    /**
     * Canonical `PredicateLibraryItem` FK — binds a curated question to its library slot.
     * @type {string}
     * @memberof QuestionBody
     */
    'predicateLibraryItemId'?: string;
    /**
     * The `Projection` of `predicateLibraryItemId` this question answers.
     * @type {string}
     * @memberof QuestionBody
     */
    'projectionId'?: string;
}


/**
 * 
 * @export
 * @interface QuestionBulkDelete
 */
export interface QuestionBulkDelete {
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionBulkDelete
     */
    'questionIds': Array<string>;
}
/**
 * 
 * @export
 * @interface QuestionCategoryOverview
 */
export interface QuestionCategoryOverview {
    /**
     * 
     * @type {CategoryType}
     * @memberof QuestionCategoryOverview
     */
    'type': CategoryType;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryOverview
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryOverview
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryOverview
     */
    'shortName': string;
}


/**
 * 
 * @export
 * @interface QuestionCategoryView
 */
export interface QuestionCategoryView {
    /**
     * 
     * @type {CategoryType}
     * @memberof QuestionCategoryView
     */
    'type': CategoryType;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'shortName': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'questionId': string;
    /**
     * 
     * @type {number}
     * @memberof QuestionCategoryView
     */
    'priority': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionCategoryView
     */
    'icdCodes'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof QuestionCategoryView
     */
    'icdTrialCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'context'?: string;
}


/**
 * 
 * @export
 * @interface QuestionConfigurationItem
 */
export interface QuestionConfigurationItem {
    /**
     * 
     * @type {string}
     * @memberof QuestionConfigurationItem
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionConfigurationItem
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface QuestionConfigurationView
 */
export interface QuestionConfigurationView {
    /**
     * 
     * @type {Array<QuestionConfigurationItem>}
     * @memberof QuestionConfigurationView
     */
    'questions': Array<QuestionConfigurationItem>;
}
/**
 * 
 * @export
 * @interface QuestionContextTranslationBody
 */
export interface QuestionContextTranslationBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof QuestionContextTranslationBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface QuestionContextTranslationView
 */
export interface QuestionContextTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof QuestionContextTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof QuestionContextTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof QuestionContextTranslationView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof QuestionContextTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionContextTranslationView
     */
    'questionId': string;
}


/**
 * 
 * @export
 * @interface QuestionCountListView
 */
export interface QuestionCountListView {
    /**
     * 
     * @type {Array<QuestionView>}
     * @memberof QuestionCountListView
     */
    'items': Array<QuestionView>;
    /**
     * 
     * @type {number}
     * @memberof QuestionCountListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface QuestionCriteriaListView
 */
export interface QuestionCriteriaListView {
    /**
     * 
     * @type {Array<QuestionCriterionView>}
     * @memberof QuestionCriteriaListView
     */
    'items': Array<QuestionCriterionView>;
    /**
     * 
     * @type {number}
     * @memberof QuestionCriteriaListView
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriteriaListView
     */
    'standardCriterionText'?: string | null;
}
/**
 * 
 * @export
 * @interface QuestionCriterionView
 */
export interface QuestionCriterionView {
    /**
     * 
     * @type {CriteriaStatus}
     * @memberof QuestionCriterionView
     */
    'status': CriteriaStatus;
    /**
     * 
     * @type {CriteriaType}
     * @memberof QuestionCriterionView
     */
    'type': CriteriaType;
    /**
     * 
     * @type {MatchingTrialStatus}
     * @memberof QuestionCriterionView
     */
    'matchingTrialStatus': MatchingTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'criteriaId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'trialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'criterionText': string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionCriterionView
     */
    'value'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionCriterionView
     */
    'minThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionCriterionView
     */
    'maxThreshold'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionCriterionView
     */
    'otherValues'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionCriterionView
     */
    'icdCodes': Array<string>;
    /**
     * 
     * @type {Array<SponsorView>}
     * @memberof QuestionCriterionView
     */
    'sponsors': Array<SponsorView>;
}


/**
 * 
 * @export
 * @interface QuestionDependencyBody
 */
export interface QuestionDependencyBody {
    /**
     * 
     * @type {DependencyType}
     * @memberof QuestionDependencyBody
     */
    'type': DependencyType;
    /**
     * 
     * @type {DependencyOperator}
     * @memberof QuestionDependencyBody
     */
    'operator'?: DependencyOperator;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyBody
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyBody
     */
    'targetId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionDependencyBody
     */
    'parameters': Array<string>;
}


/**
 * 
 * @export
 * @interface QuestionDependencyChainQuestionView
 */
export interface QuestionDependencyChainQuestionView {
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyChainQuestionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyChainQuestionView
     */
    'text': string;
    /**
     * Has a predicate library slot, so its predicate question page exists.
     * @type {boolean}
     * @memberof QuestionDependencyChainQuestionView
     */
    'isLibraryBound': boolean;
}
/**
 * 
 * @export
 * @interface QuestionDependencyChainView
 */
export interface QuestionDependencyChainView {
    /**
     * 
     * @type {Array<QuestionDependencyEdgeView>}
     * @memberof QuestionDependencyChainView
     */
    'edges': Array<QuestionDependencyEdgeView>;
    /**
     * 
     * @type {Array<QuestionDependencyChainQuestionView>}
     * @memberof QuestionDependencyChainView
     */
    'questions': Array<QuestionDependencyChainQuestionView>;
}
/**
 * 
 * @export
 * @interface QuestionDependencyEdgeView
 */
export interface QuestionDependencyEdgeView {
    /**
     * 
     * @type {DependencyType}
     * @memberof QuestionDependencyEdgeView
     */
    'type': DependencyType;
    /**
     * 
     * @type {DependencyOperator}
     * @memberof QuestionDependencyEdgeView
     */
    'operator': DependencyOperator;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyEdgeView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyEdgeView
     */
    'sourceId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyEdgeView
     */
    'targetId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionDependencyEdgeView
     */
    'parameters': Array<string>;
}


/**
 * 
 * @export
 * @interface QuestionDependencyListView
 */
export interface QuestionDependencyListView {
    /**
     * 
     * @type {Array<QuestionDependencyView>}
     * @memberof QuestionDependencyListView
     */
    'targets': Array<QuestionDependencyView>;
    /**
     * 
     * @type {Array<QuestionDependencyView>}
     * @memberof QuestionDependencyListView
     */
    'sources': Array<QuestionDependencyView>;
    /**
     * 
     * @type {number}
     * @memberof QuestionDependencyListView
     */
    'count': number;
    /**
     * 
     * @type {QuestionDependencyChainView}
     * @memberof QuestionDependencyListView
     */
    'chain': QuestionDependencyChainView;
}
/**
 * 
 * @export
 * @interface QuestionDependencyPreviewBody
 */
export interface QuestionDependencyPreviewBody {
    /**
     * 
     * @type {DependencyType}
     * @memberof QuestionDependencyPreviewBody
     */
    'type': DependencyType;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyPreviewBody
     */
    'sourceId': string;
    /**
     * The second source, `bmiCalculation` only (e.g. length when `sourceId` is weight).
     * @type {string}
     * @memberof QuestionDependencyPreviewBody
     */
    'otherId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionDependencyPreviewBody
     */
    'parameters': Array<string>;
    /**
     * Sample answer for `sourceId`, in the same wire format the chat would submit.
     * @type {string}
     * @memberof QuestionDependencyPreviewBody
     */
    'sampleAnswer': string;
    /**
     * Sample answer for `otherId`, `bmiCalculation` only.
     * @type {string}
     * @memberof QuestionDependencyPreviewBody
     */
    'otherSampleAnswer'?: string;
}


/**
 * 
 * @export
 * @interface QuestionDependencyPreviewView
 */
export interface QuestionDependencyPreviewView {
    /**
     * Undefined when the sample inputs don\'t produce a value (e.g. below a threshold).
     * @type {string}
     * @memberof QuestionDependencyPreviewView
     */
    'value'?: string;
    /**
     * True when this combination would clear an existing answer on the target instead of setting one.
     * @type {boolean}
     * @memberof QuestionDependencyPreviewView
     */
    'shouldDelete': boolean;
}
/**
 * 
 * @export
 * @interface QuestionDependencyView
 */
export interface QuestionDependencyView {
    /**
     * 
     * @type {DependencyType}
     * @memberof QuestionDependencyView
     */
    'type': DependencyType;
    /**
     * 
     * @type {DependencyOperator}
     * @memberof QuestionDependencyView
     */
    'operator': DependencyOperator;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyView
     */
    'sourceId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyView
     */
    'targetId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionDependencyView
     */
    'parameters': Array<string>;
}


/**
 * 
 * @export
 * @interface QuestionDetailsView
 */
export interface QuestionDetailsView {
    /**
     * 
     * @type {AnswerType}
     * @memberof QuestionDetailsView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionDetailsView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof QuestionDetailsView
     */
    'visibilityType': VisibilityType;
    /**
     * 
     * @type {GenerationType}
     * @memberof QuestionDetailsView
     */
    'generationType': GenerationType;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'context'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionDetailsView
     */
    'expiry'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionDetailsView
     */
    'trialCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionDetailsView
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionDetailsView
     */
    'answeredCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionDetailsView
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface QuestionIgnoreMergeBody
 */
export interface QuestionIgnoreMergeBody {
    /**
     * 
     * @type {string}
     * @memberof QuestionIgnoreMergeBody
     */
    'secondQuestionId': string;
}
/**
 * 
 * @export
 * @interface QuestionMergeBody
 */
export interface QuestionMergeBody {
    /**
     * 
     * @type {string}
     * @memberof QuestionMergeBody
     */
    'targetQuestionId': string;
}
/**
 * 
 * @export
 * @interface QuestionOptionBody
 */
export interface QuestionOptionBody {
    /**
     * 
     * @type {number}
     * @memberof QuestionOptionBody
     */
    'limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionOptionBody
     */
    'offset'?: number | null;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof QuestionOptionBody
     */
    'translations': Array<TranslationBody>;
    /**
     * 
     * @type {string}
     * @memberof QuestionOptionBody
     */
    'key': string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionOptionBody
     */
    'requireCustomValue'?: boolean;
}
/**
 * 
 * @export
 * @interface QuestionOptionUpdateBody
 */
export interface QuestionOptionUpdateBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof QuestionOptionUpdateBody
     */
    'translations': Array<TranslationBody>;
    /**
     * Renames the option. Only a library-owned question that is still `proposed` accepts one.
     * @type {string}
     * @memberof QuestionOptionUpdateBody
     */
    'key'?: string;
}
/**
 * 
 * @export
 * @interface QuestionOptionView
 */
export interface QuestionOptionView {
    /**
     * 
     * @type {string}
     * @memberof QuestionOptionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionOptionView
     */
    'key': string;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof QuestionOptionView
     */
    'translations': Array<TranslationView>;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionOptionView
     */
    'requireCustomValue'?: boolean | null;
    /**
     * How many of the question\'s predicates compare against this key. Zero means it can be removed.
     * @type {number}
     * @memberof QuestionOptionView
     */
    'predicateCount': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionOrderBy = {
    UpdatedAt: 'updatedAt',
    QuestionType: 'questionType',
    IsActive: 'isActive',
    SkippedCount: 'skippedCount',
    AnsweredCount: 'answeredCount',
    TrialCount: 'trialCount',
    Distance: 'distance'
} as const;

export type QuestionOrderBy = typeof QuestionOrderBy[keyof typeof QuestionOrderBy];


/**
 * 
 * @export
 * @interface QuestionTranslationBody
 */
export interface QuestionTranslationBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof QuestionTranslationBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface QuestionTranslationView
 */
export interface QuestionTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof QuestionTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof QuestionTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof QuestionTranslationView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof QuestionTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionTranslationView
     */
    'questionId': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionType = {
    Standard: 'standard',
    TrialSpecific: 'trialSpecific',
    Proposed: 'proposed',
    Physician: 'physician',
    Distractor: 'distractor'
} as const;

export type QuestionType = typeof QuestionType[keyof typeof QuestionType];


/**
 * 
 * @export
 * @interface QuestionUpdateBody
 */
export interface QuestionUpdateBody {
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionUpdateBody
     */
    'questionType'?: QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof QuestionUpdateBody
     */
    'visibilityType'?: VisibilityType;
    /**
     * 
     * @type {AnswerType}
     * @memberof QuestionUpdateBody
     */
    'answerType'?: AnswerType;
    /**
     * 
     * @type {string}
     * @memberof QuestionUpdateBody
     */
    'unit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionUpdateBody
     */
    'expiry'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionUpdateBody
     */
    'icdCodes'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionUpdateBody
     */
    'isActive'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionUpdateBody
     */
    'standardCriterionText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionUpdateBody
     */
    'context'?: string | null;
}


/**
 * 
 * @export
 * @interface QuestionView
 */
export interface QuestionView {
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof QuestionView
     */
    'visibilityType': VisibilityType;
    /**
     * 
     * @type {AnswerType}
     * @memberof QuestionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {GenerationType}
     * @memberof QuestionView
     */
    'generationType': GenerationType;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionView
     */
    'isActive': boolean;
    /**
     * 
     * @type {Array<QuestionCategoryOverview>}
     * @memberof QuestionView
     */
    'categories': Array<QuestionCategoryOverview>;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'icdCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'answeredCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'trialCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'icdTrialCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'context'?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'distance'?: number | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReadinessBlockerKind = {
    UnruledProjection: 'unruled_projection',
    MissingProjection: 'missing_projection',
    UnmatchablePredicate: 'unmatchable_predicate',
    MissingQuestion: 'missing_question',
    UndatedWindow: 'undated_window'
} as const;

export type ReadinessBlockerKind = typeof ReadinessBlockerKind[keyof typeof ReadinessBlockerKind];


/**
 * 
 * @export
 * @interface ReadinessBlockerView
 */
export interface ReadinessBlockerView {
    /**
     * 
     * @type {ReadinessBlockerKind}
     * @memberof ReadinessBlockerView
     */
    'kind': ReadinessBlockerKind;
    /**
     * 
     * @type {string}
     * @memberof ReadinessBlockerView
     */
    'projectionId'?: string | null;
    /**
     * Where a reviewer would go to clear it - the library page is keyed on this.
     * @type {string}
     * @memberof ReadinessBlockerView
     */
    'predicateLibraryItemId'?: string | null;
    /**
     * True when one library edit clears it - what `rulingsNeeded` counts.
     * @type {boolean}
     * @memberof ReadinessBlockerView
     */
    'isRuling': boolean;
    /**
     * 
     * @type {string}
     * @memberof ReadinessBlockerView
     */
    'predicateId': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReadinessBucket = {
    Ready: 'ready',
    WaitingOnRulings: 'waiting_on_rulings',
    NeedsRerun: 'needs_rerun',
    InPipeline: 'in_pipeline',
    NotStarted: 'not_started',
    Broken: 'broken'
} as const;

export type ReadinessBucket = typeof ReadinessBucket[keyof typeof ReadinessBucket];


/**
 * 
 * @export
 * @interface RecordMappingIssueView
 */
export interface RecordMappingIssueView {
    /**
     * 
     * @type {string}
     * @memberof RecordMappingIssueView
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof RecordMappingIssueView
     */
    'resourceType': string;
    /**
     * 
     * @type {string}
     * @memberof RecordMappingIssueView
     */
    'system'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordMappingIssueView
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordMappingIssueView
     */
    'display'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordMappingIssueView
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof RecordMappingIssueView
     */
    'count': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RecordProviderCountry = {
    Be: 'BE',
    Fr: 'FR',
    Es: 'ES',
    Eu: 'EU'
} as const;

export type RecordProviderCountry = typeof RecordProviderCountry[keyof typeof RecordProviderCountry];


/**
 * 
 * @export
 * @enum {string}
 */

export const RecordProviderId = {
    DedalusPilot: 'dedalus-pilot',
    Weare: 'weare'
} as const;

export type RecordProviderId = typeof RecordProviderId[keyof typeof RecordProviderId];


/**
 * 
 * @export
 * @interface RecordShareCapabilityView
 */
export interface RecordShareCapabilityView {
    /**
     * Whether this patient can share a health record. The client uses it to decide whether to offer the entry point at all; it is computed server-side from the feature flag and whether the identity seam can resolve this patient, so it never promises something the pipeline would refuse.
     * @type {boolean}
     * @memberof RecordShareCapabilityView
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RecordShareErrorCategory = {
    ConsentMissing: 'CONSENT_MISSING',
    IdentityFailed: 'IDENTITY_FAILED',
    GrantExpired: 'GRANT_EXPIRED',
    SourceUnavailable: 'SOURCE_UNAVAILABLE',
    RecordNotFound: 'RECORD_NOT_FOUND',
    ParseError: 'PARSE_ERROR',
    SubjectMismatch: 'SUBJECT_MISMATCH',
    UntrustedUrl: 'UNTRUSTED_URL',
    EvaluationFailed: 'EVALUATION_FAILED',
    StaleAttempt: 'STALE_ATTEMPT'
} as const;

export type RecordShareErrorCategory = typeof RecordShareErrorCategory[keyof typeof RecordShareErrorCategory];


/**
 * 
 * @export
 * @interface RecordShareEvaluationView
 */
export interface RecordShareEvaluationView {
    /**
     * 
     * @type {EvaluationOutcome}
     * @memberof RecordShareEvaluationView
     */
    'evaluation': EvaluationOutcome;
    /**
     * 
     * @type {number}
     * @memberof RecordShareEvaluationView
     */
    'written': number;
    /**
     * 
     * @type {number}
     * @memberof RecordShareEvaluationView
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof RecordShareEvaluationView
     */
    'unmapped': number;
    /**
     * 
     * @type {boolean}
     * @memberof RecordShareEvaluationView
     */
    'deferred'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RecordShareNextKind = {
    Redirect: 'redirect',
    Consent: 'consent',
    Ingest: 'ingest'
} as const;

export type RecordShareNextKind = typeof RecordShareNextKind[keyof typeof RecordShareNextKind];


/**
 * 
 * @export
 * @interface RecordShareNextView
 */
export interface RecordShareNextView {
    /**
     * 
     * @type {RecordShareNextKind}
     * @memberof RecordShareNextView
     */
    'kind': RecordShareNextKind;
    /**
     * 
     * @type {string}
     * @memberof RecordShareNextView
     */
    'url'?: string;
}


/**
 * 
 * @export
 * @interface RecordShareProviderView
 */
export interface RecordShareProviderView {
    /**
     * 
     * @type {RecordProviderId}
     * @memberof RecordShareProviderView
     */
    'id': RecordProviderId;
    /**
     * 
     * @type {RecordProviderCountry}
     * @memberof RecordShareProviderView
     */
    'country': RecordProviderCountry;
    /**
     * 
     * @type {Array<ShareCategory>}
     * @memberof RecordShareProviderView
     */
    'categories': Array<ShareCategory>;
    /**
     * 
     * @type {string}
     * @memberof RecordShareProviderView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RecordShareProviderView
     */
    'region': string;
    /**
     * Whether identity is a browser round trip the client must leave the app for.
     * @type {boolean}
     * @memberof RecordShareProviderView
     */
    'identityHandoff': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecordShareProviderView
     */
    'authorisationHandoff': boolean;
    /**
     * Stage keys the retrieval progress list renders, in order.
     * @type {Array<string>}
     * @memberof RecordShareProviderView
     */
    'retrievalStages': Array<string>;
}


/**
 * 
 * @export
 * @interface RecordShareProvidersView
 */
export interface RecordShareProvidersView {
    /**
     * 
     * @type {Array<RecordShareProviderView>}
     * @memberof RecordShareProvidersView
     */
    'items': Array<RecordShareProviderView>;
}
/**
 * 
 * @export
 * @interface RecordShareRedirectView
 */
export interface RecordShareRedirectView {
    /**
     * 
     * @type {string}
     * @memberof RecordShareRedirectView
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof RecordShareRedirectView
     */
    'statusCode': number;
}
/**
 * 
 * @export
 * @interface RecordShareResultView
 */
export interface RecordShareResultView {
    /**
     * 
     * @type {IngestOutcome}
     * @memberof RecordShareResultView
     */
    'outcome': IngestOutcome;
    /**
     * 
     * @type {EvaluationOutcome}
     * @memberof RecordShareResultView
     */
    'evaluation': EvaluationOutcome;
    /**
     * 
     * @type {number}
     * @memberof RecordShareResultView
     */
    'factsPersisted': number;
    /**
     * 
     * @type {number}
     * @memberof RecordShareResultView
     */
    'written': number;
    /**
     * 
     * @type {number}
     * @memberof RecordShareResultView
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof RecordShareResultView
     */
    'unmapped': number;
    /**
     * 
     * @type {number}
     * @memberof RecordShareResultView
     */
    'unconsentedDropped': number;
    /**
     * 
     * @type {number}
     * @memberof RecordShareResultView
     */
    'issueCount': number;
}


/**
 * 
 * @export
 * @interface RecordShareStartView
 */
export interface RecordShareStartView {
    /**
     * 
     * @type {string}
     * @memberof RecordShareStartView
     */
    'shareId': string;
    /**
     * 
     * @type {RecordShareNextView}
     * @memberof RecordShareStartView
     */
    'next': RecordShareNextView;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RecordShareStatus = {
    Started: 'started',
    Identified: 'identified',
    Consented: 'consented',
    Authorised: 'authorised',
    Retrieving: 'retrieving',
    Retrieved: 'retrieved',
    Failed: 'failed',
    Abandoned: 'abandoned'
} as const;

export type RecordShareStatus = typeof RecordShareStatus[keyof typeof RecordShareStatus];


/**
 * 
 * @export
 * @interface RecordShareStatusView
 */
export interface RecordShareStatusView {
    /**
     * 
     * @type {RecordShareStatus}
     * @memberof RecordShareStatusView
     */
    'status': RecordShareStatus;
    /**
     * 
     * @type {RecordProviderId}
     * @memberof RecordShareStatusView
     */
    'providerId': RecordProviderId;
    /**
     * 
     * @type {RecordShareErrorCategory}
     * @memberof RecordShareStatusView
     */
    'errorCategory'?: RecordShareErrorCategory;
    /**
     * 
     * @type {string}
     * @memberof RecordShareStatusView
     */
    'shareId': string;
    /**
     * 
     * @type {RecordShareProviderView}
     * @memberof RecordShareStatusView
     */
    'descriptor': RecordShareProviderView;
    /**
     * 
     * @type {string}
     * @memberof RecordShareStatusView
     */
    'retrievedAt'?: string;
    /**
     * 
     * @type {RecordShareResultView}
     * @memberof RecordShareStatusView
     */
    'result'?: RecordShareResultView;
    /**
     * Computed server-side: a `retrieving` claim older than the reclaim window can be re-submitted.
     * @type {boolean}
     * @memberof RecordShareStatusView
     */
    'retryable': boolean;
    /**
     * 
     * @type {string}
     * @memberof RecordShareStatusView
     */
    'retryableAt'?: string;
}


/**
 * 
 * @export
 * @interface RecordShareStepView
 */
export interface RecordShareStepView {
    /**
     * 
     * @type {RecordShareNextView}
     * @memberof RecordShareStepView
     */
    'next': RecordShareNextView;
}
/**
 * 
 * @export
 * @interface ReducedTeamView
 */
export interface ReducedTeamView {
    /**
     * 
     * @type {string}
     * @memberof ReducedTeamView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof ReducedTeamView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RefreshBody
 */
export interface RefreshBody {
    /**
     * 
     * @type {string}
     * @memberof RefreshBody
     */
    'refreshToken': string;
    /**
     * 
     * @type {string}
     * @memberof RefreshBody
     */
    'teamId'?: string | null;
}
/**
 * 
 * @export
 * @interface RejectLocationChangeBody
 */
export interface RejectLocationChangeBody {
    /**
     * 
     * @type {string}
     * @memberof RejectLocationChangeBody
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface RejectionReasonBody
 */
export interface RejectionReasonBody {
    /**
     * 
     * @type {PatientRejectionReason}
     * @memberof RejectionReasonBody
     */
    'type': PatientRejectionReason;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonBody
     */
    'criteriaId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonBody
     */
    'comment'?: string | null;
}


/**
 * 
 * @export
 * @interface RejectionReasonView
 */
export interface RejectionReasonView {
    /**
     * 
     * @type {PatientRejectionReason}
     * @memberof RejectionReasonView
     */
    'type': PatientRejectionReason;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'rejecterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'rejecterName': string;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'criteriaId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'criteriaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'comment'?: string | null;
}


/**
 * 
 * @export
 * @interface RemoveCategoryDiseaseBody
 */
export interface RemoveCategoryDiseaseBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveCategoryDiseaseBody
     */
    'diseaseId': string;
}
/**
 * 
 * @export
 * @interface RemoveProdUsersBody
 */
export interface RemoveProdUsersBody {
    /**
     * 
     * @type {number}
     * @memberof RemoveProdUsersBody
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof RemoveProdUsersBody
     */
    'offset': number;
}
/**
 * 
 * @export
 * @interface RemoveQuestionCategoryBody
 */
export interface RemoveQuestionCategoryBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveQuestionCategoryBody
     */
    'categoryId': string;
}
/**
 * 
 * @export
 * @interface ReportingBreakdownItemView
 */
export interface ReportingBreakdownItemView {
    /**
     * 
     * @type {string}
     * @memberof ReportingBreakdownItemView
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof ReportingBreakdownItemView
     */
    'userCount': number;
}
/**
 * 
 * @export
 * @interface ReportingBreakdownView
 */
export interface ReportingBreakdownView {
    /**
     * 
     * @type {Array<ReportingBreakdownItemView>}
     * @memberof ReportingBreakdownView
     */
    'items': Array<ReportingBreakdownItemView>;
    /**
     * 
     * @type {number}
     * @memberof ReportingBreakdownView
     */
    'suppressedCount': number;
}
/**
 * 
 * @export
 * @interface ReportingFunnelMilestoneView
 */
export interface ReportingFunnelMilestoneView {
    /**
     * 
     * @type {number}
     * @memberof ReportingFunnelMilestoneView
     */
    'milestoneOrder': number;
    /**
     * 
     * @type {string}
     * @memberof ReportingFunnelMilestoneView
     */
    'milestone': string;
    /**
     * 
     * @type {number}
     * @memberof ReportingFunnelMilestoneView
     */
    'userCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingFunnelMilestoneView
     */
    'isPartial': boolean;
}
/**
 * 
 * @export
 * @interface ReportingFunnelView
 */
export interface ReportingFunnelView {
    /**
     * 
     * @type {ReportingViewedTeamView}
     * @memberof ReportingFunnelView
     */
    'viewedTeam'?: ReportingViewedTeamView;
    /**
     * 
     * @type {Array<ReportingFunnelMilestoneView>}
     * @memberof ReportingFunnelView
     */
    'milestones': Array<ReportingFunnelMilestoneView>;
}
/**
 * 
 * @export
 * @interface ReportingTieredBreakdownItemView
 */
export interface ReportingTieredBreakdownItemView {
    /**
     * 
     * @type {string}
     * @memberof ReportingTieredBreakdownItemView
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof ReportingTieredBreakdownItemView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ReportingTieredBreakdownView
 */
export interface ReportingTieredBreakdownView {
    /**
     * 
     * @type {number}
     * @memberof ReportingTieredBreakdownView
     */
    'suppressedCount'?: number;
    /**
     * 
     * @type {Array<ReportingTieredBreakdownItemView>}
     * @memberof ReportingTieredBreakdownView
     */
    'items': Array<ReportingTieredBreakdownItemView>;
    /**
     * 
     * @type {number}
     * @memberof ReportingTieredBreakdownView
     */
    'hiddenCount': number;
}
/**
 * 
 * @export
 * @interface ReportingUserOverviewView
 */
export interface ReportingUserOverviewView {
    /**
     * 
     * @type {ReportingViewedTeamView}
     * @memberof ReportingUserOverviewView
     */
    'viewedTeam'?: ReportingViewedTeamView;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserOverviewView
     */
    'totalPatients': number;
    /**
     * 
     * @type {ReportingBreakdownView}
     * @memberof ReportingUserOverviewView
     */
    'byCountry': ReportingBreakdownView;
    /**
     * 
     * @type {ReportingBreakdownView}
     * @memberof ReportingUserOverviewView
     */
    'byGender': ReportingBreakdownView;
    /**
     * 
     * @type {ReportingBreakdownView}
     * @memberof ReportingUserOverviewView
     */
    'byAgeGroup': ReportingBreakdownView;
    /**
     * 
     * @type {ReportingBreakdownView}
     * @memberof ReportingUserOverviewView
     */
    'byHealthStatus': ReportingBreakdownView;
}
/**
 * 
 * @export
 * @interface ReportingUserSourceView
 */
export interface ReportingUserSourceView {
    /**
     * 
     * @type {string}
     * @memberof ReportingUserSourceView
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ReportingUserSourcesView
 */
export interface ReportingUserSourcesView {
    /**
     * 
     * @type {Array<ReportingUserSourceView>}
     * @memberof ReportingUserSourcesView
     */
    'items': Array<ReportingUserSourceView>;
}
/**
 * 
 * @export
 * @interface ReportingViewedTeamView
 */
export interface ReportingViewedTeamView {
    /**
     * 
     * @type {string}
     * @memberof ReportingViewedTeamView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof ReportingViewedTeamView
     */
    'teamName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportingViewedTeamView
     */
    'reportingSourceSlugs': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ResearchType = {
    Trial: 'trial',
    Survey: 'survey',
    Panel: 'panel'
} as const;

export type ResearchType = typeof ResearchType[keyof typeof ResearchType];


/**
 * 
 * @export
 * @interface ResetPasswordBody
 */
export interface ResetPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBody
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface RetryQuestionBody
 */
export interface RetryQuestionBody {
    /**
     * 
     * @type {Language}
     * @memberof RetryQuestionBody
     */
    'language': Language;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReviewableRolloutStage = {
    Shadow: 'shadow',
    Canary: 'canary',
    Promoted: 'promoted'
} as const;

export type ReviewableRolloutStage = typeof ReviewableRolloutStage[keyof typeof ReviewableRolloutStage];


/**
 * 
 * @export
 * @enum {string}
 */

export const Role = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type Role = typeof Role[keyof typeof Role];


/**
 * 
 * @export
 * @enum {string}
 */

export const RolloutStage = {
    Legacy: 'legacy',
    Shadow: 'shadow',
    Canary: 'canary',
    Promoted: 'promoted'
} as const;

export type RolloutStage = typeof RolloutStage[keyof typeof RolloutStage];


/**
 * 
 * @export
 * @enum {string}
 */

export const SearchScope = {
    MyCountry: 'myCountry',
    AllEuropeanCountries: 'allEuropeanCountries'
} as const;

export type SearchScope = typeof SearchScope[keyof typeof SearchScope];


/**
 * 
 * @export
 * @interface SetParityRoutingBody
 */
export interface SetParityRoutingBody {
    /**
     * Omitted = every disease in this country. A per-disease row overrides the wildcard.
     * @type {string}
     * @memberof SetParityRoutingBody
     */
    'diseaseId'?: string;
    /**
     * 
     * @type {RolloutStage}
     * @memberof SetParityRoutingBody
     */
    'stage': RolloutStage;
    /**
     * Spelled as on the trial sites. A country with no site is rejected with `CountryHasNoSites`.
     * @type {string}
     * @memberof SetParityRoutingBody
     */
    'country': string;
}


/**
 * 
 * @export
 * @interface SetPasswordBody
 */
export interface SetPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordBody
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordBody
     */
    'password': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SexEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    All: 'ALL'
} as const;

export type SexEnum = typeof SexEnum[keyof typeof SexEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ShareCategory = {
    Conditions: 'conditions',
    Labs: 'labs',
    Medications: 'medications',
    Demographics: 'demographics',
    Vaccinations: 'vaccinations'
} as const;

export type ShareCategory = typeof ShareCategory[keyof typeof ShareCategory];


/**
 * 
 * @export
 * @interface SiteOpportunityCellView
 */
export interface SiteOpportunityCellView {
    /**
     * 
     * @type {string}
     * @memberof SiteOpportunityCellView
     */
    'city'?: string;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'patientCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'lowerQuartileSiteKm'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'medianSiteKm'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'upperQuartileSiteKm'?: number;
    /**
     * 
     * @type {string}
     * @memberof SiteOpportunityCellView
     */
    'nearestSite'?: string;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'countryLatitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'countryLongitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof SiteOpportunityCellView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityCellView
     */
    'rejectionCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof SiteOpportunityCellView
     */
    'rolledUpToCountry': boolean;
}
/**
 * 
 * @export
 * @interface SiteOpportunityFilterOptionsView
 */
export interface SiteOpportunityFilterOptionsView {
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'userCountry': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'userGender': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'trialTherapeuticArea': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'sponsor': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'sponsorClass': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'userSource': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'trialDisease': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'nearestSiteCity': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteOpportunityFilterOptionsView
     */
    'nearestSiteFacility': Array<string>;
}
/**
 * 
 * @export
 * @interface SiteOpportunitySiteView
 */
export interface SiteOpportunitySiteView {
    /**
     * 
     * @type {string}
     * @memberof SiteOpportunitySiteView
     */
    'facility'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteOpportunitySiteView
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteOpportunitySiteView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunitySiteView
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunitySiteView
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunitySiteView
     */
    'rejectionCount': number;
}
/**
 * 
 * @export
 * @interface SiteOpportunityView
 */
export interface SiteOpportunityView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof SiteOpportunityView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityView
     */
    'noSiteInCountryCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityView
     */
    'totalRejections': number;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof SiteOpportunityView
     */
    'byDistance': ReportingTieredBreakdownView;
    /**
     * 
     * @type {Array<SiteOpportunityCellView>}
     * @memberof SiteOpportunityView
     */
    'cells': Array<SiteOpportunityCellView>;
    /**
     * 
     * @type {number}
     * @memberof SiteOpportunityView
     */
    'unplacedRejectionCount': number;
    /**
     * 
     * @type {Array<SiteOpportunitySiteView>}
     * @memberof SiteOpportunityView
     */
    'sites': Array<SiteOpportunitySiteView>;
    /**
     * 
     * @type {SiteOpportunityFilterOptionsView}
     * @memberof SiteOpportunityView
     */
    'filterOptions': SiteOpportunityFilterOptionsView;
}


/**
 * 
 * @export
 * @interface SkipChatEntryBody
 */
export interface SkipChatEntryBody {
    /**
     * 
     * @type {SkipReason}
     * @memberof SkipChatEntryBody
     */
    'reason': SkipReason;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SkipReason = {
    DontWantAnswerNow: 'dont_want_answer_now',
    DontWantAnswerEver: 'dont_want_answer_ever',
    DontKnow: 'dont_know',
    DontUnderstandQuestion: 'dont_understand_question',
    HaveAskDoctor: 'have_ask_doctor',
    AlreadyAnsweredQuestion: 'already_answered_question',
    AnswerOtherQuestionFirst: 'answer_other_question_first',
    NotRelevant: 'not_relevant',
    Other: 'other'
} as const;

export type SkipReason = typeof SkipReason[keyof typeof SkipReason];


/**
 * 
 * @export
 * @interface SliceBlastRadiusView
 */
export interface SliceBlastRadiusView {
    /**
     * 
     * @type {Array<BlastRadiusDiseaseView>}
     * @memberof SliceBlastRadiusView
     */
    'otherDiseases': Array<BlastRadiusDiseaseView>;
    /**
     * Servable trials covering the slice.
     * @type {number}
     * @memberof SliceBlastRadiusView
     */
    'trials': number;
    /**
     * Of those, the ones this change carries into the engine. Already-served ones are not moved.
     * @type {number}
     * @memberof SliceBlastRadiusView
     */
    'moving': number;
    /**
     * Moving trials that also recruit outside the slice - the ones that carry patients over.
     * @type {number}
     * @memberof SliceBlastRadiusView
     */
    'spilling': number;
    /**
     * Rows a rebuild of the moving trials would rewrite. Human-owned rows are never overwritten.
     * @type {number}
     * @memberof SliceBlastRadiusView
     */
    'patientRows': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SliceBlastRadiusView
     */
    'otherCountries': Array<string>;
}
/**
 * 
 * @export
 * @interface SliceCountryView
 */
export interface SliceCountryView {
    /**
     * 
     * @type {string}
     * @memberof SliceCountryView
     */
    'country': string;
    /**
     * Trials with a site in this country. Zero never appears: a country with no sites is not listed.
     * @type {number}
     * @memberof SliceCountryView
     */
    'trials': number;
}
/**
 * 
 * @export
 * @interface SliceReadinessTrialView
 */
export interface SliceReadinessTrialView {
    /**
     * 
     * @type {ReadinessBucket}
     * @memberof SliceReadinessTrialView
     */
    'bucket': ReadinessBucket;
    /**
     * 
     * @type {string}
     * @memberof SliceReadinessTrialView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof SliceReadinessTrialView
     */
    'nct': string;
    /**
     * 
     * @type {string}
     * @memberof SliceReadinessTrialView
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof SliceReadinessTrialView
     */
    'rulingsNeeded': number;
    /**
     * Branches that resolve, over branches that exist. A branch is one alternative way to satisfy one requirement, so this is reachability and not progress: one ruling can carry a trial from none to all of them, because a leg every branch ANDs blocks every branch.
     * @type {number}
     * @memberof SliceReadinessTrialView
     */
    'branchesResolved': number;
    /**
     * 
     * @type {number}
     * @memberof SliceReadinessTrialView
     */
    'branchesTotal': number;
    /**
     * 
     * @type {Array<ReadinessBlockerView>}
     * @memberof SliceReadinessTrialView
     */
    'blockers': Array<ReadinessBlockerView>;
}


/**
 * 
 * @export
 * @interface SliceReadinessView
 */
export interface SliceReadinessView {
    /**
     * 
     * @type {RolloutStage}
     * @memberof SliceReadinessView
     */
    'stage': RolloutStage;
    /**
     * 
     * @type {string}
     * @memberof SliceReadinessView
     */
    'icdCode': string;
    /**
     * 
     * @type {string}
     * @memberof SliceReadinessView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof SliceReadinessView
     */
    'diseaseName': string;
    /**
     * 
     * @type {number}
     * @memberof SliceReadinessView
     */
    'trials': number;
    /**
     * 
     * @type {number}
     * @memberof SliceReadinessView
     */
    'ready': number;
    /**
     * 
     * @type {number}
     * @memberof SliceReadinessView
     */
    'waitingOnRulings': number;
    /**
     * 
     * @type {number}
     * @memberof SliceReadinessView
     */
    'needsRerun': number;
    /**
     * 
     * @type {number}
     * @memberof SliceReadinessView
     */
    'inPipeline': number;
    /**
     * Never entered the pipeline at all. Somebody has to schedule a run, not wait for one.
     * @type {number}
     * @memberof SliceReadinessView
     */
    'notStarted': number;
    /**
     * Can never match anyone: a criterion contradicts itself. A bug report, not queued work.
     * @type {number}
     * @memberof SliceReadinessView
     */
    'broken': number;
    /**
     * Distinct library rulings outstanding across the slice. A row two trials share counts once.
     * @type {number}
     * @memberof SliceReadinessView
     */
    'rulingsNeeded': number;
    /**
     * Trials matching today plus those `within` more rulings would open. The ordering key.
     * @type {number}
     * @memberof SliceReadinessView
     */
    'reachable': number;
    /**
     * Every admitted trial\'s resolvable branches, summed across the slice.
     * @type {number}
     * @memberof SliceReadinessView
     */
    'branchesResolved': number;
    /**
     * 
     * @type {number}
     * @memberof SliceReadinessView
     */
    'branchesTotal': number;
}


/**
 * 
 * @export
 * @interface SliceRebuildBody
 */
export interface SliceRebuildBody {
    /**
     * 
     * @type {string}
     * @memberof SliceRebuildBody
     */
    'icdCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SliceRebuildBody
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface SliceRebuildView
 */
export interface SliceRebuildView {
    /**
     * Trials a rebuild was queued for. The rebuilds themselves run in the `activeTrial` lambda.
     * @type {number}
     * @memberof SliceRebuildView
     */
    'queued': number;
}
/**
 * 
 * @export
 * @interface SponsorCreateBody
 */
export interface SponsorCreateBody {
    /**
     * 
     * @type {string}
     * @memberof SponsorCreateBody
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SponsorMergeBody
 */
export interface SponsorMergeBody {
    /**
     * 
     * @type {string}
     * @memberof SponsorMergeBody
     */
    'targetId': string;
}
/**
 * 
 * @export
 * @interface SponsorUpdateBody
 */
export interface SponsorUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof SponsorUpdateBody
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SponsorView
 */
export interface SponsorView {
    /**
     * 
     * @type {string}
     * @memberof SponsorView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SponsorView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SponsorView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SponsorView
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StepClaimStatus = {
    Claimed: 'claimed',
    Succeeded: 'succeeded',
    Failed: 'failed',
    Expired: 'expired',
    Stale: 'stale'
} as const;

export type StepClaimStatus = typeof StepClaimStatus[keyof typeof StepClaimStatus];


/**
 * 
 * @export
 * @interface SubmitContactFormBody
 */
export interface SubmitContactFormBody {
    /**
     * 
     * @type {ContactFormTopic}
     * @memberof SubmitContactFormBody
     */
    'topic'?: ContactFormTopic;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBody
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBody
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBody
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBody
     */
    'recaptchaToken': string;
    /**
     * 
     * @type {SubmitContactFormBodyCAPI}
     * @memberof SubmitContactFormBody
     */
    'capiData'?: SubmitContactFormBodyCAPI;
}


/**
 * 
 * @export
 * @interface SubmitContactFormBodyCAPI
 */
export interface SubmitContactFormBodyCAPI {
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBodyCAPI
     */
    'eventId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBodyCAPI
     */
    'sourceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBodyCAPI
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBodyCAPI
     */
    'fbc'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitContactFormBodyCAPI
     */
    'fbp'?: string;
}
/**
 * 
 * @export
 * @interface SubscriptionPreferenceView
 */
export interface SubscriptionPreferenceView {
    /**
     * 
     * @type {CommunicationKey}
     * @memberof SubscriptionPreferenceView
     */
    'key': CommunicationKey;
    /**
     * 
     * @type {PreferenceView}
     * @memberof SubscriptionPreferenceView
     */
    'preference': PreferenceView;
}


/**
 * 
 * @export
 * @interface SubscriptionPreferencesBody
 */
export interface SubscriptionPreferencesBody {
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPreferencesBody
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPreferencesBody
     */
    'notification': boolean;
    /**
     * 
     * @type {DigestBody}
     * @memberof SubscriptionPreferencesBody
     */
    'digest'?: DigestBody | null;
}
/**
 * 
 * @export
 * @interface SubscriptionPreferencesListView
 */
export interface SubscriptionPreferencesListView {
    /**
     * 
     * @type {Array<SubscriptionPreferenceView>}
     * @memberof SubscriptionPreferencesListView
     */
    'items': Array<SubscriptionPreferenceView>;
}
/**
 * 
 * @export
 * @interface SupersedeRuleBody
 */
export interface SupersedeRuleBody {
    /**
     * 
     * @type {ConversionType}
     * @memberof SupersedeRuleBody
     */
    'type'?: ConversionType;
    /**
     * 
     * @type {Array<ConversionRuleTestCase>}
     * @memberof SupersedeRuleBody
     */
    'testCases': Array<ConversionRuleTestCase>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupersedeRuleBody
     */
    'inputs'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SupersedeRuleBody
     */
    'formula': string;
    /**
     * 
     * @type {string}
     * @memberof SupersedeRuleBody
     */
    'provenance': string;
}


/**
 * 
 * @export
 * @interface SurveyCreateBody
 */
export interface SurveyCreateBody {
    /**
     * 
     * @type {string}
     * @memberof SurveyCreateBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyCreateBody
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyCreateBody
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface SurveyDependencyUpdateBody
 */
export interface SurveyDependencyUpdateBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyDependencyUpdateBody
     */
    'requiredAnswers': Array<string>;
}
/**
 * 
 * @export
 * @interface SurveyDetailsView
 */
export interface SurveyDetailsView {
    /**
     * 
     * @type {SurveyStatus}
     * @memberof SurveyDetailsView
     */
    'status': SurveyStatus;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'sentAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyDetailsView
     */
    'potentialReachCount'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SurveyOrderBy = {
    SurveyId: 'surveyId',
    UpdatedAt: 'updatedAt',
    Title: 'title'
} as const;

export type SurveyOrderBy = typeof SurveyOrderBy[keyof typeof SurveyOrderBy];


/**
 * 
 * @export
 * @interface SurveyQuestionBody
 */
export interface SurveyQuestionBody {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionBody
     */
    'questionId': string;
}
/**
 * 
 * @export
 * @interface SurveyQuestionConditionView
 */
export interface SurveyQuestionConditionView {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionConditionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionConditionView
     */
    'questionText': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionConditionView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionConditionView
     */
    'answerType': SurveyQuestionConditionViewAnswerTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyQuestionConditionView
     */
    'requiredAnswers'?: Array<string> | null;
}

export const SurveyQuestionConditionViewAnswerTypeEnum = {
    Boolean: 'boolean',
    Number: 'number',
    String: 'string',
    Date: 'date',
    Options: 'options',
    MultipleOptions: 'multipleOptions'
} as const;

export type SurveyQuestionConditionViewAnswerTypeEnum = typeof SurveyQuestionConditionViewAnswerTypeEnum[keyof typeof SurveyQuestionConditionViewAnswerTypeEnum];

/**
 * 
 * @export
 * @interface SurveyQuestionDependencyBody
 */
export interface SurveyQuestionDependencyBody {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDependencyBody
     */
    'sourceId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyQuestionDependencyBody
     */
    'requiredAnswers': Array<string>;
}
/**
 * 
 * @export
 * @interface SurveyQuestionDependencyListView
 */
export interface SurveyQuestionDependencyListView {
    /**
     * 
     * @type {Array<SurveyQuestionDependencyView>}
     * @memberof SurveyQuestionDependencyListView
     */
    'items': Array<SurveyQuestionDependencyView>;
    /**
     * 
     * @type {number}
     * @memberof SurveyQuestionDependencyListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface SurveyQuestionDependencyView
 */
export interface SurveyQuestionDependencyView {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDependencyView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDependencyView
     */
    'sourceId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDependencyView
     */
    'text': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyQuestionDependencyView
     */
    'requiredAnswers': Array<string>;
}
/**
 * 
 * @export
 * @interface SurveyQuestionMoveBody
 */
export interface SurveyQuestionMoveBody {
    /**
     * 
     * @type {number}
     * @memberof SurveyQuestionMoveBody
     */
    'newPosition': number;
}
/**
 * 
 * @export
 * @interface SurveyQuestionOptionView
 */
export interface SurveyQuestionOptionView {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionOptionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionOptionView
     */
    'key': string;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof SurveyQuestionOptionView
     */
    'translations': Array<TranslationView>;
}
/**
 * 
 * @export
 * @interface SurveyQuestionUpdateBody
 */
export interface SurveyQuestionUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionUpdateBody
     */
    'questionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyQuestionUpdateBody
     */
    'getFromProfile'?: boolean;
}
/**
 * 
 * @export
 * @interface SurveyQuestionView
 */
export interface SurveyQuestionView {
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof SurveyQuestionView
     */
    'translations': Array<TranslationView>;
    /**
     * 
     * @type {QuestionType}
     * @memberof SurveyQuestionView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {AnswerType}
     * @memberof SurveyQuestionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'surveyId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyQuestionView
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'questionText': string;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyQuestionView
     */
    'isSurveyOnly': boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<SurveyQuestionConditionView>}
     * @memberof SurveyQuestionView
     */
    'conditions'?: Array<SurveyQuestionConditionView> | null;
    /**
     * 
     * @type {Array<SurveyQuestionOptionView>}
     * @memberof SurveyQuestionView
     */
    'options'?: Array<SurveyQuestionOptionView> | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SurveyResponseOrderBy = {
    AnsweredAt: 'answeredAt',
    UserId: 'userId',
    QuestionText: 'questionText'
} as const;

export type SurveyResponseOrderBy = typeof SurveyResponseOrderBy[keyof typeof SurveyResponseOrderBy];


/**
 * 
 * @export
 * @interface SurveyResponseOverviewView
 */
export interface SurveyResponseOverviewView {
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'eligible': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'denied': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'confirmed': number;
}
/**
 * 
 * @export
 * @interface SurveyResponseView
 */
export interface SurveyResponseView {
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseView
     */
    'questionText': string;
    /**
     * 
     * @type {AnswerType}
     * @memberof SurveyResponseView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {object}
     * @memberof SurveyResponseView
     */
    'numberValue'?: object | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyResponseView
     */
    'otherValues'?: Array<string> | null;
    /**
     * 
     * @type {object}
     * @memberof SurveyResponseView
     */
    'booleanValue'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseView
     */
    'answeredAt': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SurveyStatus = {
    Draft: 'draft',
    Active: 'active',
    Closed: 'closed'
} as const;

export type SurveyStatus = typeof SurveyStatus[keyof typeof SurveyStatus];


/**
 * 
 * @export
 * @interface SurveyTranslationBody
 */
export interface SurveyTranslationBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof SurveyTranslationBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface SurveyTranslationView
 */
export interface SurveyTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof SurveyTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof SurveyTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof SurveyTranslationView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof SurveyTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyTranslationView
     */
    'surveyId': string;
}


/**
 * 
 * @export
 * @interface SurveyUpdateBody
 */
export interface SurveyUpdateBody {
    /**
     * 
     * @type {SurveyStatus}
     * @memberof SurveyUpdateBody
     */
    'status'?: SurveyStatus;
    /**
     * 
     * @type {string}
     * @memberof SurveyUpdateBody
     */
    'endDate'?: string;
}


/**
 * 
 * @export
 * @interface SurveyView
 */
export interface SurveyView {
    /**
     * 
     * @type {SurveyStatus}
     * @memberof SurveyView
     */
    'status': SurveyStatus;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof SurveyView
     */
    'questionCount': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyView
     */
    'notRespondedCount': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyView
     */
    'partiallyRespondedCount': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyView
     */
    'fullyAnsweredCount': number;
}


/**
 * 
 * @export
 * @interface SurveysOverviewView
 */
export interface SurveysOverviewView {
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'eligible': number;
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'denied': number;
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'confirmed': number;
}
/**
 * 
 * @export
 * @interface SwitchAccountBody
 */
export interface SwitchAccountBody {
    /**
     * 
     * @type {string}
     * @memberof SwitchAccountBody
     */
    'targetUserId': string;
}
/**
 * 
 * @export
 * @interface TagConfigurationItem
 */
export interface TagConfigurationItem {
    /**
     * 
     * @type {string}
     * @memberof TagConfigurationItem
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof TagConfigurationItem
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface TagConfigurationView
 */
export interface TagConfigurationView {
    /**
     * 
     * @type {Array<TagConfigurationItem>}
     * @memberof TagConfigurationView
     */
    'tags': Array<TagConfigurationItem>;
}
/**
 * 
 * @export
 * @interface TeamBody
 */
export interface TeamBody {
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'teamRole': string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'researchSiteName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'role': TeamBodyRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'token'?: string;
}

export const TeamBodyRoleEnum = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type TeamBodyRoleEnum = typeof TeamBodyRoleEnum[keyof typeof TeamBodyRoleEnum];

/**
 * 
 * @export
 * @interface TeamCreateInviteBody
 */
export interface TeamCreateInviteBody {
    /**
     * 
     * @type {ThemeType}
     * @memberof TeamCreateInviteBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {Role}
     * @memberof TeamCreateInviteBody
     */
    'teamRole': Role;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteBody
     */
    'teamName': string;
    /**
     * 
     * @type {Array<InviteTrialData>}
     * @memberof TeamCreateInviteBody
     */
    'trialData': Array<InviteTrialData>;
}


/**
 * 
 * @export
 * @interface TeamCreateInviteListView
 */
export interface TeamCreateInviteListView {
    /**
     * 
     * @type {Array<TeamCreateInviteView>}
     * @memberof TeamCreateInviteListView
     */
    'items': Array<TeamCreateInviteView>;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteListView
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface TeamCreateInviteQuery
 */
export interface TeamCreateInviteQuery {
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteQuery
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface TeamCreateInviteUpdateBody
 */
export interface TeamCreateInviteUpdateBody {
    /**
     * 
     * @type {Role}
     * @memberof TeamCreateInviteUpdateBody
     */
    'teamRole'?: Role;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteUpdateBody
     */
    'teamName'?: string;
    /**
     * 
     * @type {Array<InviteTrialData>}
     * @memberof TeamCreateInviteUpdateBody
     */
    'trialData': Array<InviteTrialData>;
}


/**
 * 
 * @export
 * @interface TeamCreateInviteView
 */
export interface TeamCreateInviteView {
    /**
     * 
     * @type {Language}
     * @memberof TeamCreateInviteView
     */
    'language': Language;
    /**
     * 
     * @type {TokenType}
     * @memberof TeamCreateInviteView
     */
    'tokenType': TokenType;
    /**
     * 
     * @type {Role}
     * @memberof TeamCreateInviteView
     */
    'role': Role;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'inviteUrl': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'teamName': string;
    /**
     * 
     * @type {Array<TokenTrialDataView>}
     * @memberof TeamCreateInviteView
     */
    'trialData': Array<TokenTrialDataView>;
}


/**
 * 
 * @export
 * @interface TeamDetailsView
 */
export interface TeamDetailsView {
    /**
     * 
     * @type {Role}
     * @memberof TeamDetailsView
     */
    'role': Role;
    /**
     * 
     * @type {TeamType}
     * @memberof TeamDetailsView
     */
    'type': TeamType;
    /**
     * 
     * @type {string}
     * @memberof TeamDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetailsView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetailsView
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetailsView
     */
    'researchSiteName'?: string;
    /**
     * 
     * @type {LeadResponsible}
     * @memberof TeamDetailsView
     */
    'leadResponsible': LeadResponsible;
    /**
     * 
     * @type {boolean}
     * @memberof TeamDetailsView
     */
    'roleConfirmed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeamDetailsView
     */
    'reportingEnabled': boolean;
}


/**
 * 
 * @export
 * @interface TeamListView
 */
export interface TeamListView {
    /**
     * 
     * @type {Array<TeamView>}
     * @memberof TeamListView
     */
    'items': Array<TeamView>;
    /**
     * 
     * @type {string}
     * @memberof TeamListView
     */
    'nextPageToken'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamLocationView
 */
export interface TeamLocationView {
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface TeamMandatesListView
 */
export interface TeamMandatesListView {
    /**
     * 
     * @type {boolean}
     * @memberof TeamMandatesListView
     */
    'hasRunningSubscription': boolean;
    /**
     * 
     * @type {number}
     * @memberof TeamMandatesListView
     */
    'subscriptionCount': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMandatesListView
     */
    'unusedSubscriptionCount': number;
    /**
     * 
     * @type {Array<MandateView>}
     * @memberof TeamMandatesListView
     */
    'mandates': Array<MandateView>;
    /**
     * 
     * @type {number}
     * @memberof TeamMandatesListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface TeamMemberBody
 */
export interface TeamMemberBody {
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TeamMemberBody
     */
    'trialPermissions'?: Array<TrialPermissionEnum>;
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof TeamMemberBody
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {Array<PanelPermissionEnum>}
     * @memberof TeamMemberBody
     */
    'panelPermissions'?: Array<PanelPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberBody
     */
    'teamRole': string;
}
/**
 * 
 * @export
 * @interface TeamMemberInviteBody
 */
export interface TeamMemberInviteBody {
    /**
     * 
     * @type {ThemeType}
     * @memberof TeamMemberInviteBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof TeamMemberInviteBody
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TeamMemberInviteBody
     */
    'permissions'?: Array<TrialPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInviteBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInviteBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInviteBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInviteBody
     */
    'teamRole': string;
}


/**
 * 
 * @export
 * @interface TeamMemberListView
 */
export interface TeamMemberListView {
    /**
     * 
     * @type {Array<TeamMemberView>}
     * @memberof TeamMemberListView
     */
    'items': Array<TeamMemberView>;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberListView
     */
    'nextPageToken'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamMemberPanelPermissionsBody
 */
export interface TeamMemberPanelPermissionsBody {
    /**
     * 
     * @type {Array<PanelPermissionEnum>}
     * @memberof TeamMemberPanelPermissionsBody
     */
    'panelPermissions': Array<PanelPermissionEnum>;
}
/**
 * 
 * @export
 * @interface TeamMemberView
 */
export interface TeamMemberView {
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof TeamMemberView
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TeamMemberView
     */
    'trialPermissions': Array<TrialPermissionEnum>;
    /**
     * 
     * @type {Array<PanelPermissionEnum>}
     * @memberof TeamMemberView
     */
    'panelPermissions': Array<PanelPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'teamRole': string;
}
/**
 * 
 * @export
 * @interface TeamMergeBody
 */
export interface TeamMergeBody {
    /**
     * 
     * @type {string}
     * @memberof TeamMergeBody
     */
    'sourceTeamId': string;
}
/**
 * 
 * @export
 * @interface TeamMergeView
 */
export interface TeamMergeView {
    /**
     * 
     * @type {number}
     * @memberof TeamMergeView
     */
    'membersMigrated': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMergeView
     */
    'membersSkipped': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMergeView
     */
    'mandatesMigrated': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMergeView
     */
    'trialsMerged': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMergeView
     */
    'activitiesMigrated': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMergeView
     */
    'invitesMigrated': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMergeView
     */
    'permissionsMigrated': number;
}
/**
 * 
 * @export
 * @interface TeamPanelView
 */
export interface TeamPanelView {
    /**
     * 
     * @type {string}
     * @memberof TeamPanelView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamPanelView
     */
    'title': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TeamPermissionEnum = {
    Read: 'team:read',
    Write: 'team:write',
    Users: 'team:users',
    Billing: 'team:billing'
} as const;

export type TeamPermissionEnum = typeof TeamPermissionEnum[keyof typeof TeamPermissionEnum];


/**
 * 
 * @export
 * @interface TeamReportingScopeAuditLogEntryView
 */
export interface TeamReportingScopeAuditLogEntryView {
    /**
     * 
     * @type {string}
     * @memberof TeamReportingScopeAuditLogEntryView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamReportingScopeAuditLogEntryView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TeamReportingScopeAuditLogEntryView
     */
    'changedByDisplayName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamReportingScopeAuditLogEntryView
     */
    'oldValue': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamReportingScopeAuditLogEntryView
     */
    'newValue': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TeamReportingScopeAuditLogEntryView
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface TeamReportingScopeView
 */
export interface TeamReportingScopeView {
    /**
     * The team\'s current Insights reporting scope — canonical user_source values from dim_user_source.sqlx. Empty when reporting is not enabled for this team.
     * @type {Array<string>}
     * @memberof TeamReportingScopeView
     */
    'reportingSourceSlugs': Array<string>;
}
/**
 * 
 * @export
 * @interface TeamReportingSourceSlugsBody
 */
export interface TeamReportingSourceSlugsBody {
    /**
     * The user_source values (as canonicalized by dim_user_source.sqlx) this team may see in Insights
     * @type {Array<string>}
     * @memberof TeamReportingSourceSlugsBody
     */
    'reportingSourceSlugs': Array<string>;
    /**
     * Why the scope is changing, for the audit trail
     * @type {string}
     * @memberof TeamReportingSourceSlugsBody
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface TeamTrialBody
 */
export interface TeamTrialBody {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TeamTrialBody
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialBody
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialBody
     */
    'matchingId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialBody
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @interface TeamTrialLocationView
 */
export interface TeamTrialLocationView {
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamTrialView
 */
export interface TeamTrialView {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TeamTrialView
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialView
     */
    'briefTitleKey': string;
    /**
     * 
     * @type {TeamTrialLocationView}
     * @memberof TeamTrialView
     */
    'location'?: TeamTrialLocationView;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TeamType = {
    Work: 'work',
    Management: 'management'
} as const;

export type TeamType = typeof TeamType[keyof typeof TeamType];


/**
 * 
 * @export
 * @interface TeamUpdateBody
 */
export interface TeamUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof TeamUpdateBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamUpdateBody
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamUpdateBody
     */
    'researchSiteName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamUpdateBody
     */
    'leadResponsible'?: string;
}
/**
 * 
 * @export
 * @interface TeamView
 */
export interface TeamView {
    /**
     * 
     * @type {TeamType}
     * @memberof TeamView
     */
    'type': TeamType;
    /**
     * 
     * @type {Role}
     * @memberof TeamView
     */
    'role': Role;
    /**
     * 
     * @type {string}
     * @memberof TeamView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamView
     */
    'name': string;
    /**
     * 
     * @type {Array<TrialIdsView>}
     * @memberof TeamView
     */
    'trials': Array<TrialIdsView>;
    /**
     * 
     * @type {Array<TeamPanelView>}
     * @memberof TeamView
     */
    'panels': Array<TeamPanelView>;
    /**
     * 
     * @type {number}
     * @memberof TeamView
     */
    'memberCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof TeamView
     */
    'reportingEnabled': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TemporalAnchor = {
    Enrollment: 'enrollment',
    Screening: 'screening',
    Now: 'now',
    Event: 'event'
} as const;

export type TemporalAnchor = typeof TemporalAnchor[keyof typeof TemporalAnchor];


/**
 * 
 * @export
 * @enum {string}
 */

export const TemporalBoundsUnit = {
    D: 'd',
    Wk: 'wk',
    Mo: 'mo',
    A: 'a'
} as const;

export type TemporalBoundsUnit = typeof TemporalBoundsUnit[keyof typeof TemporalBoundsUnit];


/**
 * 
 * @export
 * @enum {string}
 */

export const TemporalDirection = {
    Before: 'before',
    After: 'after',
    Within: 'within'
} as const;

export type TemporalDirection = typeof TemporalDirection[keyof typeof TemporalDirection];


/**
 * 
 * @export
 * @enum {string}
 */

export const ThemeType = {
    Curewiki: 'Curewiki',
    YesWeCancer: 'YesWeCancer',
    Bhs: 'BHS',
    Pce: 'PCE',
    Pec: 'PEC'
} as const;

export type ThemeType = typeof ThemeType[keyof typeof ThemeType];


/**
 * 
 * @export
 * @interface ThresholdPairView
 */
export interface ThresholdPairView {
    /**
     * 
     * @type {number}
     * @memberof ThresholdPairView
     */
    'min': number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdPairView
     */
    'max': number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdPairView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ThresholdScatterView
 */
export interface ThresholdScatterView {
    /**
     * 
     * @type {Array<ThresholdPairView>}
     * @memberof ThresholdScatterView
     */
    'items': Array<ThresholdPairView>;
    /**
     * 
     * @type {number}
     * @memberof ThresholdScatterView
     */
    'hiddenCount': number;
}
/**
 * 
 * @export
 * @interface TierCanonicalTypeMergeBody
 */
export interface TierCanonicalTypeMergeBody {
    /**
     * The `TierCanonicalType` that absorbs this one and keeps its name, tier and description.
     * @type {string}
     * @memberof TierCanonicalTypeMergeBody
     */
    'targetId': string;
}
/**
 * 
 * @export
 * @interface TierCanonicalTypeUpdateBody
 */
export interface TierCanonicalTypeUpdateBody {
    /**
     * Null means the type has no ontology. Refused once any concept or predicate of the type carries codes: those codes belong to the old system.
     * @type {OntologySystem}
     * @memberof TierCanonicalTypeUpdateBody
     */
    'ontologySystem'?: OntologySystem | null;
    /**
     * New slug. Renames the type on every library item and predicate that carries it.
     * @type {string}
     * @memberof TierCanonicalTypeUpdateBody
     */
    'canonicalType'?: string;
    /**
     * Null clears it.
     * @type {string}
     * @memberof TierCanonicalTypeUpdateBody
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @interface TierCanonicalTypeView
 */
export interface TierCanonicalTypeView {
    /**
     * 
     * @type {OntologySystem}
     * @memberof TierCanonicalTypeView
     */
    'ontologySystem'?: OntologySystem;
    /**
     * 
     * @type {string}
     * @memberof TierCanonicalTypeView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TierCanonicalTypeView
     */
    'canonicalType': string;
    /**
     * 
     * @type {number}
     * @memberof TierCanonicalTypeView
     */
    'order': number;
    /**
     * What belongs in this type. The extraction prompt and the create drawer show it.
     * @type {string}
     * @memberof TierCanonicalTypeView
     */
    'description'?: string | null;
    /**
     * Concepts carrying this canonical type. A move rewrites `tierId` on all of them.
     * @type {number}
     * @memberof TierCanonicalTypeView
     */
    'itemCount': number;
}


/**
 * 
 * @export
 * @interface TierCanonicalTypesReassignBody
 */
export interface TierCanonicalTypesReassignBody {
    /**
     * 
     * @type {Array<TierCanonicalTypesReassignEntry>}
     * @memberof TierCanonicalTypesReassignBody
     */
    'tiers': Array<TierCanonicalTypesReassignEntry>;
}
/**
 * 
 * @export
 * @interface TierCanonicalTypesReassignEntry
 */
export interface TierCanonicalTypesReassignEntry {
    /**
     * 
     * @type {string}
     * @memberof TierCanonicalTypesReassignEntry
     */
    'tierId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TierCanonicalTypesReassignEntry
     */
    'canonicalTypeIds': Array<string>;
}
/**
 * 
 * @export
 * @interface TierCreateBody
 */
export interface TierCreateBody {
    /**
     * 
     * @type {string}
     * @memberof TierCreateBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TierCreateBody
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof TierCreateBody
     */
    'exhaustive': boolean;
}
/**
 * 
 * @export
 * @interface TierUpdateBody
 */
export interface TierUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof TierUpdateBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TierUpdateBody
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TierUpdateBody
     */
    'exhaustive'?: boolean;
}
/**
 * 
 * @export
 * @interface TierView
 */
export interface TierView {
    /**
     * 
     * @type {string}
     * @memberof TierView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TierView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TierView
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof TierView
     */
    'order': number;
    /**
     * Source-language name. Other languages are filled by DeepL from `nameHashedKey`.
     * @type {string}
     * @memberof TierView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TierView
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof TierView
     */
    'exhaustive': boolean;
    /**
     * In within-tier `order`. Drag targets for the admin screen.
     * @type {Array<TierCanonicalTypeView>}
     * @memberof TierView
     */
    'canonicalTypes': Array<TierCanonicalTypeView>;
}
/**
 * 
 * @export
 * @interface TiersReorderBody
 */
export interface TiersReorderBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof TiersReorderBody
     */
    'tierIds': Array<string>;
}
/**
 * 
 * @export
 * @interface TokenTrialDataView
 */
export interface TokenTrialDataView {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TokenTrialDataView
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TokenTrialDataView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TokenTrialDataView
     */
    'matchingId': string;
    /**
     * 
     * @type {string}
     * @memberof TokenTrialDataView
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TokenType = {
    AccountClaim: 'account-claim',
    Invite: 'invite',
    TeamInvite: 'team-invite',
    TeamCreate: 'team-create',
    Milestone: 'milestone'
} as const;

export type TokenType = typeof TokenType[keyof typeof TokenType];


/**
 * 
 * @export
 * @interface TokenView
 */
export interface TokenView {
    /**
     * 
     * @type {Language}
     * @memberof TokenView
     */
    'language': Language;
    /**
     * 
     * @type {TokenType}
     * @memberof TokenView
     */
    'tokenType': TokenType;
    /**
     * 
     * @type {Role}
     * @memberof TokenView
     */
    'role': Role;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'teamRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'teamName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'companyRole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'trialId'?: string;
}


/**
 * 
 * @export
 * @interface TranslationBody
 */
export interface TranslationBody {
    /**
     * 
     * @type {string}
     * @memberof TranslationBody
     */
    'language': TranslationBodyLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof TranslationBody
     */
    'value': string;
    /**
     * 
     * @type {boolean}
     * @memberof TranslationBody
     */
    'autoGenerate': boolean;
}

export const TranslationBodyLanguageEnum = {
    En: 'en',
    Es: 'es',
    Nl: 'nl',
    Fr: 'fr',
    De: 'de',
    Cs: 'cs',
    It: 'it',
    Pt: 'pt',
    Pl: 'pl'
} as const;

export type TranslationBodyLanguageEnum = typeof TranslationBodyLanguageEnum[keyof typeof TranslationBodyLanguageEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const TranslationGenerationType = {
    AiGenerated: 'aiGenerated',
    HumanCurated: 'humanCurated',
    AutoTranslated: 'autoTranslated'
} as const;

export type TranslationGenerationType = typeof TranslationGenerationType[keyof typeof TranslationGenerationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const TranslationStatus = {
    Ready: 'ready',
    Processing: 'processing'
} as const;

export type TranslationStatus = typeof TranslationStatus[keyof typeof TranslationStatus];


/**
 * 
 * @export
 * @interface TranslationView
 */
export interface TranslationView {
    /**
     * 
     * @type {Language}
     * @memberof TranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof TranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof TranslationView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof TranslationView
     */
    'value': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TrialAcceptedOrderBy = {
    Country: 'country',
    PostalCode: 'postalCode',
    LocationName: 'locationName',
    AcceptedAt: 'acceptedAt'
} as const;

export type TrialAcceptedOrderBy = typeof TrialAcceptedOrderBy[keyof typeof TrialAcceptedOrderBy];


/**
 * 
 * @export
 * @interface TrialAcceptedView
 */
export interface TrialAcceptedView {
    /**
     * 
     * @type {string}
     * @memberof TrialAcceptedView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAcceptedView
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAcceptedView
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAcceptedView
     */
    'siteCountry': string;
    /**
     * The site is outside the patient\'s own country.
     * @type {boolean}
     * @memberof TrialAcceptedView
     */
    'isFromAbroad': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrialAcceptedView
     */
    'isLocationActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialAcceptedView
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialAcceptedView
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialAcceptedView
     */
    'acceptedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialAccessApproveBody
 */
export interface TrialAccessApproveBody {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TrialAccessApproveBody
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessApproveBody
     */
    'matchingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessApproveBody
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessApproveBody
     */
    'locationName'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialAccessBody
 */
export interface TrialAccessBody {
    /**
     * 
     * @type {string}
     * @memberof TrialAccessBody
     */
    'matchingId'?: string | null;
    /**
     * 
     * @type {TrialAccessLocation}
     * @memberof TrialAccessBody
     */
    'location'?: TrialAccessLocation;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessBody
     */
    'requestMessage'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialAccessBody
     */
    'isExistingTrial': boolean;
}
/**
 * 
 * @export
 * @interface TrialAccessListView
 */
export interface TrialAccessListView {
    /**
     * 
     * @type {number}
     * @memberof TrialAccessListView
     */
    'count': number;
    /**
     * 
     * @type {Array<TrialAccessView>}
     * @memberof TrialAccessListView
     */
    'items': Array<TrialAccessView>;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessListView
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface TrialAccessLocation
 */
export interface TrialAccessLocation {
    /**
     * 
     * @type {boolean}
     * @memberof TrialAccessLocation
     */
    'isExistingLocation': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialAccessView
 */
export interface TrialAccessView {
    /**
     * 
     * @type {Language}
     * @memberof TrialAccessView
     */
    'language': Language;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof TrialAccessView
     */
    'status': AccessRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'matchingId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'teamName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'teamLeadName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'organizationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'researchSiteName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'role': TrialAccessViewRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'requestMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'createdAt': string;
    /**
     * 
     * @type {TrialAccessLocation}
     * @memberof TrialAccessView
     */
    'location'?: TrialAccessLocation;
}

export const TrialAccessViewRoleEnum = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type TrialAccessViewRoleEnum = typeof TrialAccessViewRoleEnum[keyof typeof TrialAccessViewRoleEnum];

/**
 * 
 * @export
 * @interface TrialActivityView
 */
export interface TrialActivityView {
    /**
     * 
     * @type {AnswerType}
     * @memberof TrialActivityView
     */
    'answerType'?: AnswerType;
    /**
     * 
     * @type {ActivityType}
     * @memberof TrialActivityView
     */
    'type': ActivityType;
    /**
     * 
     * @type {FeedbackType}
     * @memberof TrialActivityView
     */
    'feedbackType'?: FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'questionText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'criteriaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'userId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrialActivityView
     */
    'value'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrialActivityView
     */
    'minThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrialActivityView
     */
    'maxThreshold'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'unit'?: string;
    /**
     * 
     * @type {object}
     * @memberof TrialActivityView
     */
    'effectType'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'locationName'?: string | null;
}


/**
 * 
 * @export
 * @interface TrialAddCTBody
 */
export interface TrialAddCTBody {
    /**
     * 
     * @type {boolean}
     * @memberof TrialAddCTBody
     */
    'reprocessingConfirmed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TrialAddSponsorBody
 */
export interface TrialAddSponsorBody {
    /**
     * 
     * @type {string}
     * @memberof TrialAddSponsorBody
     */
    'sponsorId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TrialAllocation = {
    Randomized: 'RANDOMIZED',
    NonRandomized: 'NON_RANDOMIZED',
    Na: 'NA'
} as const;

export type TrialAllocation = typeof TrialAllocation[keyof typeof TrialAllocation];


/**
 * 
 * @export
 * @interface TrialAtomicCohortView
 */
export interface TrialAtomicCohortView {
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialAtomicCohortView
     */
    'cohortStatus'?: PipelineReviewStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicCohortView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicCohortView
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof TrialAtomicCohortView
     */
    'sortOrder': number;
    /**
     * 
     * @type {Array<CohortIcdHintView>}
     * @memberof TrialAtomicCohortView
     */
    'icdHints': Array<CohortIcdHintView>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialAtomicCohortView
     */
    'populationIcdHints'?: Array<string> | null;
    /**
     * The predicates in `criteria` that have this cohort.
     * @type {number}
     * @memberof TrialAtomicCohortView
     */
    'predicateCount': number;
}


/**
 * 
 * @export
 * @interface TrialAtomicCriteriaActivationBody
 */
export interface TrialAtomicCriteriaActivationBody {
    /**
     * Predicates of the trial\'s Criteria tab. A predicate that is already in the asked state does not change.
     * @type {Array<string>}
     * @memberof TrialAtomicCriteriaActivationBody
     */
    'predicateIds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TrialAtomicCriteriaActivationBody
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface TrialAtomicCriteriaView
 */
export interface TrialAtomicCriteriaView {
    /**
     * By position. A rejected criterion is not in the list.
     * @type {Array<TrialAtomicCriterionView>}
     * @memberof TrialAtomicCriteriaView
     */
    'criteria': Array<TrialAtomicCriterionView>;
    /**
     * By sort order. A rejected cohort is not in the list.
     * @type {Array<TrialAtomicCohortView>}
     * @memberof TrialAtomicCriteriaView
     */
    'cohorts': Array<TrialAtomicCohortView>;
}
/**
 * 
 * @export
 * @interface TrialAtomicCriterionSuggestionBody
 */
export interface TrialAtomicCriterionSuggestionBody {
    /**
     * What should change in the atomic criterion, and why.
     * @type {string}
     * @memberof TrialAtomicCriterionSuggestionBody
     */
    'suggestion': string;
}
/**
 * 
 * @export
 * @interface TrialAtomicCriterionView
 */
export interface TrialAtomicCriterionView {
    /**
     * 
     * @type {CriteriaType}
     * @memberof TrialAtomicCriterionView
     */
    'criteriaType': CriteriaType;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialAtomicCriterionView
     */
    'splitStatus': PipelineReviewStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicCriterionView
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof TrialAtomicCriterionView
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicCriterionView
     */
    'rawText': string;
    /**
     * The AND/OR tree of the criterion (`form: original`), flat and root first.
     * @type {Array<CriterionNodeView>}
     * @memberof TrialAtomicCriterionView
     */
    'nodes': Array<CriterionNodeView>;
    /**
     * The predicates that the engine reads and the ones that a trial manager switched off, by position. A rejected or merged predicate is not in the list.
     * @type {Array<TrialAtomicPredicateView>}
     * @memberof TrialAtomicCriterionView
     */
    'predicates': Array<TrialAtomicPredicateView>;
}


/**
 * 
 * @export
 * @interface TrialAtomicOptionView
 */
export interface TrialAtomicOptionView {
    /**
     * The value that a predicate compares against.
     * @type {string}
     * @memberof TrialAtomicOptionView
     */
    'key': string;
    /**
     * In English. The key when the English text is missing.
     * @type {string}
     * @memberof TrialAtomicOptionView
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface TrialAtomicPredicateView
 */
export interface TrialAtomicPredicateView {
    /**
     * 
     * @type {Polarity}
     * @memberof TrialAtomicPredicateView
     */
    'polarity'?: Polarity;
    /**
     * 
     * @type {PredicateOperator}
     * @memberof TrialAtomicPredicateView
     */
    'operator'?: PredicateOperator;
    /**
     * 
     * @type {object}
     * @memberof TrialAtomicPredicateView
     */
    'value': object;
    /**
     * 
     * @type {TemporalAnchor}
     * @memberof TrialAtomicPredicateView
     */
    'temporalAnchor'?: TemporalAnchor;
    /**
     * 
     * @type {TemporalBoundsUnit}
     * @memberof TrialAtomicPredicateView
     */
    'temporalBoundsUnit'?: TemporalBoundsUnit;
    /**
     * 
     * @type {TemporalDirection}
     * @memberof TrialAtomicPredicateView
     */
    'temporalDirection'?: TemporalDirection;
    /**
     * 
     * @type {ProjectionView}
     * @memberof TrialAtomicPredicateView
     */
    'projection'?: ProjectionView | null;
    /**
     * 
     * @type {PrescreenDecision}
     * @memberof TrialAtomicPredicateView
     */
    'prescreenDecision'?: PrescreenDecision;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialAtomicPredicateView
     */
    'prescreenStatus'?: PipelineReviewStatus;
    /**
     * 
     * @type {TrialAtomicQuestionView}
     * @memberof TrialAtomicPredicateView
     */
    'question'?: TrialAtomicQuestionView | null;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialAtomicPredicateView
     */
    'status': PipelineReviewStatus;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialAtomicPredicateView
     */
    'qualityCheckStatus'?: PipelineReviewStatus;
    /**
     * 
     * @type {LibraryDecision}
     * @memberof TrialAtomicPredicateView
     */
    'libraryDecision'?: LibraryDecision;
    /**
     * 
     * @type {ConfidenceLevel}
     * @memberof TrialAtomicPredicateView
     */
    'confidence': ConfidenceLevel;
    /**
     * Display name per ontology code. A code with no entry is shown bare.
     * @type {{ [key: string]: string; }}
     * @memberof TrialAtomicPredicateView
     */
    'ontologyCodeLabels'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {OntologySystem}
     * @memberof TrialAtomicPredicateView
     */
    'ontologySystem'?: OntologySystem;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicPredicateView
     */
    'id': string;
    /**
     * The node of `TrialAtomicCriterionView.nodes` that this predicate hangs off.
     * @type {string}
     * @memberof TrialAtomicPredicateView
     */
    'criterionNodeId'?: string | null;
    /**
     * Null when the predicate applies to the whole trial.
     * @type {string}
     * @memberof TrialAtomicPredicateView
     */
    'cohortId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicPredicateView
     */
    'rewrittenText': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicPredicateView
     */
    'field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicPredicateView
     */
    'canonicalType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicPredicateView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrialAtomicPredicateView
     */
    'normalizedValue'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrialAtomicPredicateView
     */
    'isExhaustiveList': boolean;
    /**
     * False while a trial manager has switched the predicate off. The engine does not match on it.
     * @type {boolean}
     * @memberof TrialAtomicPredicateView
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof TrialAtomicPredicateView
     */
    'temporalBoundsValue'?: number | null;
    /**
     * `projection.prescreenable`. Null when the predicate has no projection or nobody has ruled.
     * @type {boolean}
     * @memberof TrialAtomicPredicateView
     */
    'prescreenable'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrialAtomicPredicateView
     */
    'extractionAgreement'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialAtomicPredicateView
     */
    'ontologyCodes'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface TrialAtomicQuestionView
 */
export interface TrialAtomicQuestionView {
    /**
     * 
     * @type {AnswerType}
     * @memberof TrialAtomicQuestionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicQuestionView
     */
    'id': string;
    /**
     * In English. The translation key when the English text is missing.
     * @type {string}
     * @memberof TrialAtomicQuestionView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAtomicQuestionView
     */
    'unit'?: string | null;
    /**
     * In answer order. Empty for a question without options.
     * @type {Array<TrialAtomicOptionView>}
     * @memberof TrialAtomicQuestionView
     */
    'options': Array<TrialAtomicOptionView>;
}


/**
 * 
 * @export
 * @interface TrialBoosterBody
 */
export interface TrialBoosterBody {
    /**
     * 
     * @type {string}
     * @memberof TrialBoosterBody
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof TrialBoosterBody
     */
    'numberOfPatients': number;
}
/**
 * 
 * @export
 * @interface TrialCohortCountView
 */
export interface TrialCohortCountView {
    /**
     * Matches plus the patients who still have criteria to answer (status `active`).
     * @type {number}
     * @memberof TrialCohortCountView
     */
    'potentialCount': number | null;
    /**
     * Patients past the criteria: every status except `active`, `excluded`, `rejected` and `denied`.
     * @type {number}
     * @memberof TrialCohortCountView
     */
    'matchCount': number | null;
    /**
     * 
     * @type {string}
     * @memberof TrialCohortCountView
     */
    'cohortId': string;
}
/**
 * 
 * @export
 * @interface TrialCommentBody
 */
export interface TrialCommentBody {
    /**
     * 
     * @type {string}
     * @memberof TrialCommentBody
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface TrialCompanionInviteOnlyBody
 */
export interface TrialCompanionInviteOnlyBody {
    /**
     * 
     * @type {boolean}
     * @memberof TrialCompanionInviteOnlyBody
     */
    'companionInviteOnly': boolean;
}
/**
 * 
 * @export
 * @interface TrialContactBody
 */
export interface TrialContactBody {
    /**
     * 
     * @type {string}
     * @memberof TrialContactBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactBody
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactBody
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface TrialContactView
 */
export interface TrialContactView {
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'type': TrialContactViewTypeEnum;
}

export const TrialContactViewTypeEnum = {
    Static: 'static',
    LinkedUser: 'linkedUser'
} as const;

export type TrialContactViewTypeEnum = typeof TrialContactViewTypeEnum[keyof typeof TrialContactViewTypeEnum];

/**
 * 
 * @export
 * @interface TrialCountrySitesView
 */
export interface TrialCountrySitesView {
    /**
     * 
     * @type {string}
     * @memberof TrialCountrySitesView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof TrialCountrySitesView
     */
    'siteCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialCountrySitesView
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof TrialCountrySitesView
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface TrialCreateBody
 */
export interface TrialCreateBody {
    /**
     * 
     * @type {SexEnum}
     * @memberof TrialCreateBody
     */
    'sex': SexEnum;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'primaryCompletionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'studyCompletionDate': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'sponsor': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'responsibleParty': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'criteriaText': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialCreateBody
     */
    'conditions': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TrialCreateBody
     */
    'allowHealthyPatients': boolean;
}


/**
 * 
 * @export
 * @interface TrialCriteriaAnswerCountsView
 */
export interface TrialCriteriaAnswerCountsView {
    /**
     * Patients who started pre-screening for the trial: a live `UserTrial` row in any status.
     * @type {number}
     * @memberof TrialCriteriaAnswerCountsView
     */
    'patientCount': number | null;
    /**
     * Potential patients whose row has no cohort: the legacy matcher computed it, or the trial has no cohort criteria. They are in none of `cohorts`. As in `potentialCount`, `excluded`, `rejected` and `denied` rows do not count.
     * @type {number}
     * @memberof TrialCriteriaAnswerCountsView
     */
    'unassignedCount': number | null;
    /**
     * False when the engine cannot serve the trial: the engine is off, the trial is not admitted, or the engine has not loaded the trial. `rows` is then empty.
     * @type {boolean}
     * @memberof TrialCriteriaAnswerCountsView
     */
    'available': boolean;
    /**
     * The time that the counts are for.
     * @type {string}
     * @memberof TrialCriteriaAnswerCountsView
     */
    'evaluatedAt': string;
    /**
     * A count above 0 and below this number is null, so a small group cannot point to one patient. A larger count in a row is null too while `patientCount` minus the shown counts would give a small one back.
     * @type {number}
     * @memberof TrialCriteriaAnswerCountsView
     */
    'hiddenBelow': number;
    /**
     * One row per predicate that the engine reads, in criterion order, then predicate order. A rejected or merged predicate has no row.  A patient counts on a predicate only when the engine gives a verdict on it for that patient, so a row can add up to less than `patientCount`. A predicate in a cohort or an OR branch that the engine did not use for the patient gets no verdict. So a cohort predicate counts only the patients evaluated on its cohort. An unanswered predicate is unsure only when the patient can still answer it.
     * @type {Array<TrialCriterionAnswerCountView>}
     * @memberof TrialCriteriaAnswerCountsView
     */
    'rows': Array<TrialCriterionAnswerCountView>;
    /**
     * One row per cohort of the trial that is not rejected, in cohort order. Filled also when `available` is false, because the counts do not need the engine.
     * @type {Array<TrialCohortCountView>}
     * @memberof TrialCriteriaAnswerCountsView
     */
    'cohorts': Array<TrialCohortCountView>;
}
/**
 * 
 * @export
 * @interface TrialCriteriaBody
 */
export interface TrialCriteriaBody {
    /**
     * 
     * @type {CriteriaType}
     * @memberof TrialCriteriaBody
     */
    'type': CriteriaType;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaBody
     */
    'criteriaText': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialCriteriaBody
     */
    'value'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaBody
     */
    'minThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaBody
     */
    'maxThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialCriteriaBody
     */
    'otherValues'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaBody
     */
    'questionId': string;
}


/**
 * 
 * @export
 * @interface TrialCriteriaView
 */
export interface TrialCriteriaView {
    /**
     * 
     * @type {CriteriaStatus}
     * @memberof TrialCriteriaView
     */
    'status': CriteriaStatus;
    /**
     * 
     * @type {CriteriaType}
     * @memberof TrialCriteriaView
     */
    'type': CriteriaType;
    /**
     * 
     * @type {QuestionType}
     * @memberof TrialCriteriaView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {AnswerType}
     * @memberof TrialCriteriaView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'originalCriteriaText': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'questionText': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialCriteriaView
     */
    'value'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'minThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'maxThreshold'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialCriteriaView
     */
    'otherValues'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'commentCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'feedbackCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'position': number;
    /**
     * 
     * @type {Array<CriteriaDependencyView>}
     * @memberof TrialCriteriaView
     */
    'dependencies': Array<CriteriaDependencyView>;
}


/**
 * 
 * @export
 * @interface TrialCriterionAnswerCountView
 */
export interface TrialCriterionAnswerCountView {
    /**
     * Patients who meet the predicate. For an exclusion, the excluded fact does not apply to them.
     * @type {number}
     * @memberof TrialCriterionAnswerCountView
     */
    'meetsCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof TrialCriterionAnswerCountView
     */
    'doesNotMeetCount': number | null;
    /**
     * Patients the engine cannot decide on yet, for example because they did not answer.
     * @type {number}
     * @memberof TrialCriterionAnswerCountView
     */
    'unsureCount': number | null;
    /**
     * The `TrialPredicate` id, which is also the leg id the engine reports.
     * @type {string}
     * @memberof TrialCriterionAnswerCountView
     */
    'predicateId': string;
}
/**
 * 
 * @export
 * @interface TrialDelayBreakdownItemView
 */
export interface TrialDelayBreakdownItemView {
    /**
     * 
     * @type {string}
     * @memberof TrialDelayBreakdownItemView
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof TrialDelayBreakdownItemView
     */
    'totalDelayDays': number;
    /**
     * 
     * @type {number}
     * @memberof TrialDelayBreakdownItemView
     */
    'delayedTrials': number;
}
/**
 * 
 * @export
 * @interface TrialDelayBreakdownView
 */
export interface TrialDelayBreakdownView {
    /**
     * 
     * @type {Array<TrialDelayBreakdownItemView>}
     * @memberof TrialDelayBreakdownView
     */
    'items': Array<TrialDelayBreakdownItemView>;
    /**
     * 
     * @type {number}
     * @memberof TrialDelayBreakdownView
     */
    'hiddenCount': number;
}
/**
 * 
 * @export
 * @interface TrialDelaysView
 */
export interface TrialDelaysView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof TrialDelaysView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {number}
     * @memberof TrialDelaysView
     */
    'totalTrials': number;
    /**
     * 
     * @type {number}
     * @memberof TrialDelaysView
     */
    'delayedTrials': number;
    /**
     * 
     * @type {number}
     * @memberof TrialDelaysView
     */
    'totalDelayDays': number;
    /**
     * 
     * @type {number}
     * @memberof TrialDelaysView
     */
    'averageDelayDays': number;
    /**
     * 
     * @type {TrialDelayBreakdownView}
     * @memberof TrialDelaysView
     */
    'byTherapeuticArea': TrialDelayBreakdownView;
    /**
     * 
     * @type {TrialDelayBreakdownView}
     * @memberof TrialDelaysView
     */
    'byDisease': TrialDelayBreakdownView;
    /**
     * 
     * @type {TrialDelayBreakdownView}
     * @memberof TrialDelaysView
     */
    'byCountry': TrialDelayBreakdownView;
}


/**
 * 
 * @export
 * @interface TrialDeleteSponsorBody
 */
export interface TrialDeleteSponsorBody {
    /**
     * 
     * @type {string}
     * @memberof TrialDeleteSponsorBody
     */
    'sponsorId': string;
}
/**
 * 
 * @export
 * @interface TrialDetailsView
 */
export interface TrialDetailsView {
    /**
     * 
     * @type {MandateStatus}
     * @memberof TrialDetailsView
     */
    'mandateStatus': MandateStatus;
    /**
     * 
     * @type {ManagementStatus}
     * @memberof TrialDetailsView
     */
    'managedBy': ManagementStatus;
    /**
     * 
     * @type {MatchingTrialStatus}
     * @memberof TrialDetailsView
     */
    'matchingStatus': MatchingTrialStatus;
    /**
     * 
     * @type {OverallTrialStatus}
     * @memberof TrialDetailsView
     */
    'overallStatus': OverallTrialStatus;
    /**
     * 
     * @type {Array<TrialPhase>}
     * @memberof TrialDetailsView
     */
    'phases'?: Array<TrialPhase> | null;
    /**
     * 
     * @type {TrialAllocation}
     * @memberof TrialDetailsView
     */
    'allocation'?: TrialAllocation;
    /**
     * 
     * @type {TrialInterventionModel}
     * @memberof TrialDetailsView
     */
    'interventionModel'?: TrialInterventionModel;
    /**
     * 
     * @type {TrialPrimaryPurpose}
     * @memberof TrialDetailsView
     */
    'primaryPurpose'?: TrialPrimaryPurpose;
    /**
     * 
     * @type {TrialMasking}
     * @memberof TrialDetailsView
     */
    'masking'?: TrialMasking;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'mandateLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'officialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'briefTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'detailedDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'briefSummary': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialDetailsView
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrialDetailsView
     */
    'isValidated': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'studyType'?: string | null;
    /**
     * Target number of participants from clinicaltrials.gov. 0 when the source sends none.
     * @type {number}
     * @memberof TrialDetailsView
     */
    'enrollmentCount': number;
    /**
     * The predicate pipeline finished this trial, so the matching engine may serve it.
     * @type {boolean}
     * @memberof TrialDetailsView
     */
    'isEngineAdmitted': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'primaryCompletionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'studyCompletionDate'?: string | null;
    /**
     * First day of the recruitment window that Curewiki sets. Left out when no window is set.
     * @type {string}
     * @memberof TrialDetailsView
     */
    'recruitmentStartDate'?: string | null;
    /**
     * Last day of the recruitment window that Curewiki sets. Left out when no window is set.
     * @type {string}
     * @memberof TrialDetailsView
     */
    'recruitmentEndDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'lastUpdatePostDate': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'responsibleParty': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'url': string;
    /**
     * 
     * @type {Array<AiProcessorView>}
     * @memberof TrialDetailsView
     */
    'processedBy'?: Array<AiProcessorView> | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'nextReachOutVerified'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'nextReachOutMissingAnswers'?: string | null;
    /**
     * 
     * @type {EffectView}
     * @memberof TrialDetailsView
     */
    'effect'?: EffectView;
    /**
     * 
     * @type {boolean}
     * @memberof TrialDetailsView
     */
    'withDirectMessage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrialDetailsView
     */
    'companionInviteOnly': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialDetailsView
     */
    'conditions': Array<string>;
    /**
     * 
     * @type {Array<SponsorView>}
     * @memberof TrialDetailsView
     */
    'sponsors': Array<SponsorView>;
}


/**
 * 
 * @export
 * @interface TrialEffectBody
 */
export interface TrialEffectBody {
    /**
     * 
     * @type {EffectType}
     * @memberof TrialEffectBody
     */
    'type': EffectType;
    /**
     * 
     * @type {boolean}
     * @memberof TrialEffectBody
     */
    'withDirectMessage': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialEffectBody
     */
    'url'?: string;
}


/**
 * 
 * @export
 * @interface TrialEligibilityView
 */
export interface TrialEligibilityView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof TrialEligibilityView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {number}
     * @memberof TrialEligibilityView
     */
    'totalTrials': number;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialEligibilityView
     */
    'gender': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialEligibilityView
     */
    'smoking': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ThresholdScatterView}
     * @memberof TrialEligibilityView
     */
    'ageThresholds': ThresholdScatterView;
    /**
     * 
     * @type {ThresholdScatterView}
     * @memberof TrialEligibilityView
     */
    'bmiThresholds': ThresholdScatterView;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TrialEnrolledOrderBy = {
    Country: 'country',
    PostalCode: 'postalCode',
    LocationName: 'locationName',
    EnrolledAt: 'enrolledAt',
    UnsubscribedAt: 'unsubscribedAt'
} as const;

export type TrialEnrolledOrderBy = typeof TrialEnrolledOrderBy[keyof typeof TrialEnrolledOrderBy];


/**
 * 
 * @export
 * @interface TrialEnrolledView
 */
export interface TrialEnrolledView {
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'country'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialEnrolledView
     */
    'isLocationActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'siteCountry': string;
    /**
     * The site is outside the patient\'s own country.
     * @type {boolean}
     * @memberof TrialEnrolledView
     */
    'isFromAbroad': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'milestoneName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrialEnrolledView
     */
    'daysUntilNextMilestone'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'enrolledAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'unsubscribedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialEnrolledView
     */
    'unsubscribedAtMilestoneName'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialFacilityCountryView
 */
export interface TrialFacilityCountryView {
    /**
     * 
     * @type {string}
     * @memberof TrialFacilityCountryView
     */
    'facility': string;
    /**
     * 
     * @type {string}
     * @memberof TrialFacilityCountryView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof TrialFacilityCountryView
     */
    'trialCount': number;
}
/**
 * 
 * @export
 * @interface TrialGeographyView
 */
export interface TrialGeographyView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof TrialGeographyView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {number}
     * @memberof TrialGeographyView
     */
    'totalTrials': number;
    /**
     * 
     * @type {number}
     * @memberof TrialGeographyView
     */
    'countryCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialGeographyView
     */
    'facilityCount': number;
    /**
     * 
     * @type {Array<TrialCountrySitesView>}
     * @memberof TrialGeographyView
     */
    'byCountry': Array<TrialCountrySitesView>;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialGeographyView
     */
    'byFacility': ReportingTieredBreakdownView;
    /**
     * 
     * @type {Array<TrialFacilityCountryView>}
     * @memberof TrialGeographyView
     */
    'byFacilityCountry': Array<TrialFacilityCountryView>;
    /**
     * 
     * @type {TrialSiteTableView}
     * @memberof TrialGeographyView
     */
    'siteTable': TrialSiteTableView;
}


/**
 * 
 * @export
 * @interface TrialIdsView
 */
export interface TrialIdsView {
    /**
     * 
     * @type {string}
     * @memberof TrialIdsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialIdsView
     */
    'matchingId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TrialInterventionModel = {
    SingleGroup: 'SINGLE_GROUP',
    Parallel: 'PARALLEL',
    Crossover: 'CROSSOVER',
    Factorial: 'FACTORIAL',
    Sequential: 'SEQUENTIAL'
} as const;

export type TrialInterventionModel = typeof TrialInterventionModel[keyof typeof TrialInterventionModel];


/**
 * 
 * @export
 * @interface TrialInviteUpdateBody
 */
export interface TrialInviteUpdateBody {
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TrialInviteUpdateBody
     */
    'permissions'?: Array<TrialPermissionEnum>;
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof TrialInviteUpdateBody
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TrialInviteUpdateBody
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof TrialInviteUpdateBody
     */
    'teamRole': string;
}
/**
 * 
 * @export
 * @interface TrialLocationBody
 */
export interface TrialLocationBody {
    /**
     * 
     * @type {string}
     * @memberof TrialLocationBody
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationBody
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationBody
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationBody
     */
    'facility'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialLocationBody
     */
    'showContactDetails'?: boolean;
}
/**
 * 
 * @export
 * @interface TrialLocationContactView
 */
export interface TrialLocationContactView {
    /**
     * 
     * @type {string}
     * @memberof TrialLocationContactView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationContactView
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationContactView
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationContactView
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationContactView
     */
    'role'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialLocationCountriesView
 */
export interface TrialLocationCountriesView {
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialLocationCountriesView
     */
    'countries': Array<string>;
}
/**
 * 
 * @export
 * @interface TrialLocationPermissionsListView
 */
export interface TrialLocationPermissionsListView {
    /**
     * 
     * @type {number}
     * @memberof TrialLocationPermissionsListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface TrialLocationView
 */
export interface TrialLocationView {
    /**
     * 
     * @type {LocationRecruitmentStatus}
     * @memberof TrialLocationView
     */
    'recruitmentStatus': LocationRecruitmentStatus;
    /**
     * 
     * @type {AcceptanceFlow}
     * @memberof TrialLocationView
     */
    'acceptanceFlow': AcceptanceFlow;
    /**
     * 
     * @type {CoordinateView}
     * @memberof TrialLocationView
     */
    'coordinates'?: CoordinateView;
    /**
     * 
     * @type {Array<TrialLocationContactView>}
     * @memberof TrialLocationView
     */
    'contacts'?: Array<TrialLocationContactView>;
    /**
     * 
     * @type {number}
     * @memberof TrialLocationView
     */
    'confirmedUserTrialCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialLocationView
     */
    'pendingUserTrialCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialLocationView
     */
    'potentialUserTrialCount': number;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'facility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'locationStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrialLocationView
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrialLocationView
     */
    'showContactDetails': boolean;
    /**
     * 
     * @type {EffectView}
     * @memberof TrialLocationView
     */
    'effect'?: EffectView;
}


/**
 * 
 * @export
 * @interface TrialManagerSignUpBody
 */
export interface TrialManagerSignUpBody {
    /**
     * 
     * @type {Language}
     * @memberof TrialManagerSignUpBody
     */
    'language': Language;
    /**
     * 
     * @type {Role}
     * @memberof TrialManagerSignUpBody
     */
    'role'?: Role;
    /**
     * 
     * @type {ThemeType}
     * @memberof TrialManagerSignUpBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'companyRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'researchSiteName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'phoneNumber'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TrialMasking = {
    None: 'NONE',
    Single: 'SINGLE',
    Double: 'DOUBLE',
    Triple: 'TRIPLE',
    Quadruple: 'QUADRUPLE'
} as const;

export type TrialMasking = typeof TrialMasking[keyof typeof TrialMasking];


/**
 * 
 * @export
 * @interface TrialMatchView
 */
export interface TrialMatchView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof TrialMatchView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialMatchView
     */
    'isLocationActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'siteCountry': string;
    /**
     * The site is outside the patient\'s own country.
     * @type {boolean}
     * @memberof TrialMatchView
     */
    'isFromAbroad': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'contactedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'verifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'acceptedAt'?: string | null;
}


/**
 * 
 * @export
 * @interface TrialMilestoneBody
 */
export interface TrialMilestoneBody {
    /**
     * 
     * @type {number}
     * @memberof TrialMilestoneBody
     */
    'daysAfterEnrollment': number;
    /**
     * 
     * @type {Array<MilestoneTranslationInput>}
     * @memberof TrialMilestoneBody
     */
    'translations': Array<MilestoneTranslationInput>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TrialOrderBy = {
    TrialId: 'trialId',
    UpdatedAt: 'updatedAt',
    MatchingStatus: 'matchingStatus',
    Favorite: 'favorite',
    ManagedBy: 'managedBy',
    PendingUserTrialCount: 'pendingUserTrialCount',
    ConfirmedUserTrialCount: 'confirmedUserTrialCount',
    AcceptedUserTrialCount: 'acceptedUserTrialCount',
    EligibleUserTrialCount: 'eligibleUserTrialCount',
    PotentialUserTrialCount: 'potentialUserTrialCount'
} as const;

export type TrialOrderBy = typeof TrialOrderBy[keyof typeof TrialOrderBy];


/**
 * 
 * @export
 * @interface TrialOverviewView
 */
export interface TrialOverviewView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof TrialOverviewView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {number}
     * @memberof TrialOverviewView
     */
    'totalTrials': number;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialOverviewView
     */
    'byTherapeuticArea': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialOverviewView
     */
    'byDisease': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialOverviewView
     */
    'byCountry': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialOverviewView
     */
    'bySponsorClass': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialOverviewView
     */
    'bySponsor': ReportingTieredBreakdownView;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialOverviewView
     */
    'byGenderCriteria': ReportingTieredBreakdownView;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TrialPermissionEnum = {
    Trialread: 'trial:read',
    Trialcomment: 'trial:comment',
    Trialwrite: 'trial:write',
    Trialfunnel: 'trial:funnel',
    Contactsread: 'contacts:read',
    Teamwrite: 'team:write',
    Funneloverview: 'funnel:overview'
} as const;

export type TrialPermissionEnum = typeof TrialPermissionEnum[keyof typeof TrialPermissionEnum];


/**
 * 
 * @export
 * @interface TrialPermissionsView
 */
export interface TrialPermissionsView {
    /**
     * 
     * @type {Role}
     * @memberof TrialPermissionsView
     */
    'type': Role;
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TrialPermissionsView
     */
    'permissions': Array<TrialPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'email': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TrialPhase = {
    Na: 'NA',
    EarlyPhase1: 'EARLY_PHASE1',
    Phase1: 'PHASE1',
    Phase2: 'PHASE2',
    Phase3: 'PHASE3',
    Phase4: 'PHASE4'
} as const;

export type TrialPhase = typeof TrialPhase[keyof typeof TrialPhase];


/**
 * 
 * @export
 * @interface TrialPredicateView
 */
export interface TrialPredicateView {
    /**
     * 
     * @type {CriteriaType}
     * @memberof TrialPredicateView
     */
    'criteriaType': CriteriaType;
    /**
     * 
     * @type {ProjectionView}
     * @memberof TrialPredicateView
     */
    'projection'?: ProjectionView | null;
    /**
     * Unit sourced via JOIN from the related `PredicateLibraryItem.unit`. Null when unmapped or unitless.
     * @type {string}
     * @memberof TrialPredicateView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {PredicateOperator}
     * @memberof TrialPredicateView
     */
    'operator'?: PredicateOperator;
    /**
     * 
     * @type {object}
     * @memberof TrialPredicateView
     */
    'value': object;
    /**
     * 
     * @type {Polarity}
     * @memberof TrialPredicateView
     */
    'polarity'?: Polarity;
    /**
     * 
     * @type {TemporalAnchor}
     * @memberof TrialPredicateView
     */
    'temporalAnchor'?: TemporalAnchor;
    /**
     * 
     * @type {TemporalDirection}
     * @memberof TrialPredicateView
     */
    'temporalDirection'?: TemporalDirection;
    /**
     * 
     * @type {TemporalBoundsUnit}
     * @memberof TrialPredicateView
     */
    'temporalBoundsUnit'?: TemporalBoundsUnit;
    /**
     * 
     * @type {FeasibilitySuggestion}
     * @memberof TrialPredicateView
     */
    'feasibilitySuggestion'?: FeasibilitySuggestion;
    /**
     * 
     * @type {PrescreenDecision}
     * @memberof TrialPredicateView
     */
    'prescreenDecision'?: PrescreenDecision;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialPredicateView
     */
    'prescreenStatus'?: PipelineReviewStatus;
    /**
     * 
     * @type {ConfidenceLevel}
     * @memberof TrialPredicateView
     */
    'prescreenJudgeConfidence'?: ConfidenceLevel;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialPredicateView
     */
    'qualityCheckStatus'?: PipelineReviewStatus;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialPredicateView
     */
    'status': PipelineReviewStatus;
    /**
     * 
     * @type {ConfidenceLevel}
     * @memberof TrialPredicateView
     */
    'confidence': ConfidenceLevel;
    /**
     * 
     * @type {LibraryDecision}
     * @memberof TrialPredicateView
     */
    'libraryDecision'?: LibraryDecision;
    /**
     * 
     * @type {PredicateLibraryGap}
     * @memberof TrialPredicateView
     */
    'libraryGap': PredicateLibraryGap;
    /**
     * 
     * @type {ProjectionType}
     * @memberof TrialPredicateView
     */
    'proposedProjectionType'?: ProjectionType;
    /**
     * 
     * @type {OntologySystem}
     * @memberof TrialPredicateView
     */
    'ontologySystem'?: OntologySystem;
    /**
     * Display name per ontology code. A code with no entry is shown bare.
     * @type {{ [key: string]: string; }}
     * @memberof TrialPredicateView
     */
    'ontologyCodeLabels'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof TrialPredicateView
     */
    'ontologyStatus'?: PipelineReviewStatus;
    /**
     * The axes this row still has a reviewer\'s verdict to take back, from the ledger. A terminal status is not enough on its own: a row its step auto-approved, or one decided before the ledger recorded axes, has nothing to reverse.
     * @type {Array<string>}
     * @memberof TrialPredicateView
     */
    'undoableAxes': Array<TrialPredicateViewUndoableAxesEnum>;
    /**
     * Audit trail for HITL flow (b). Populated only on the detail endpoint; the list endpoint returns an empty array to keep payloads small.
     * @type {Array<CriteriaActivityView>}
     * @memberof TrialPredicateView
     */
    'activities': Array<CriteriaActivityView>;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'originalCriterionId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'predicateLibraryItemId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'cohortId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'questionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'mergedIntoPredicateId'?: string | null;
    /**
     * Canonical slug, sourced via JOIN from the related `PredicateLibraryItem.canonicalType`. Null until Step 4 maps the predicate to a library row.
     * @type {string}
     * @memberof TrialPredicateView
     */
    'canonicalType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'field'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrialPredicateView
     */
    'temporalBoundsValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'criterionNodeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'feasibilityReason'?: string | null;
    /**
     * Whether the prescreen judge agreed with the filter\'s decision. Null until the judge has read the row.
     * @type {boolean}
     * @memberof TrialPredicateView
     */
    'prescreenJudgeAgreement'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'qualityCheckNotes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrialPredicateView
     */
    'extractionAgreement'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'libraryDecisionReason'?: string | null;
    /**
     * What the library-match pass proposed but could not apply, for the review forms to offer back: the canonical type and unit it voted for, and the projection it asked of the field. Null on a row that reached no majority, and on anything extracted before the pass began recording them.  A proposal, not a resolved fact — the resolved ones are `canonicalType` and `unit`, from the assigned `PredicateLibraryItem`, and `projection`, from its Projection. Prefill only.
     * @type {string}
     * @memberof TrialPredicateView
     */
    'proposedCanonicalType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'proposedUnit'?: string | null;
    /**
     * Whether the library row this predicate is still waiting on now exists — the predicate library item first, then a projection on it. Creating one does not repoint the rows that asked for it, so without this a row keeps asking for a concept somebody already created.  False on a row that waits on nothing, and on one whose proposal has no library row yet.
     * @type {boolean}
     * @memberof TrialPredicateView
     */
    'isProposalResolved': boolean;
    /**
     * The extracted number in the unit it was written in, and the same number converted into the concept\'s own unit. `normalizedValue` is null while the conversion rule is still queued — that gap holds Step 4\'s gate.
     * @type {number}
     * @memberof TrialPredicateView
     */
    'rawValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'rawUnit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrialPredicateView
     */
    'normalizedValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'conversionRuleId'?: string | null;
    /**
     * Sourced via JOIN from the related `PredicateLibraryItem` — a retired concept must be visible as one.
     * @type {boolean}
     * @memberof TrialPredicateView
     */
    'isPredicateLibraryItemDeprecated': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialPredicateView
     */
    'ontologyCodes'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'ontologyReviewReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialPredicateView
     */
    'rewrittenText': string;
    /**
     * 
     * @type {number}
     * @memberof TrialPredicateView
     */
    'position': number;
    /**
     * 
     * @type {boolean}
     * @memberof TrialPredicateView
     */
    'isExhaustiveList': boolean;
    /**
     * False while a trial manager has switched the predicate off. The engine does not match on it.
     * @type {boolean}
     * @memberof TrialPredicateView
     */
    'isActive': boolean;
}

export const TrialPredicateViewUndoableAxesEnum = {
    Legacy: 'legacy',
    Step1: 'step-1',
    Step2: 'step-2',
    Step3: 'step-3',
    Step4: 'step-4',
    Step5: 'step-5',
    Step6: 'step-6',
    Step7: 'step-7',
    Step8: 'step-8'
} as const;

export type TrialPredicateViewUndoableAxesEnum = typeof TrialPredicateViewUndoableAxesEnum[keyof typeof TrialPredicateViewUndoableAxesEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const TrialPrimaryPurpose = {
    Treatment: 'TREATMENT',
    Prevention: 'PREVENTION',
    Diagnostic: 'DIAGNOSTIC',
    Ect: 'ECT',
    SupportiveCare: 'SUPPORTIVE_CARE',
    Screening: 'SCREENING',
    HealthServicesResearch: 'HEALTH_SERVICES_RESEARCH',
    BasicScience: 'BASIC_SCIENCE',
    DeviceFeasibility: 'DEVICE_FEASIBILITY',
    Other: 'OTHER'
} as const;

export type TrialPrimaryPurpose = typeof TrialPrimaryPurpose[keyof typeof TrialPrimaryPurpose];


/**
 * 
 * @export
 * @interface TrialPublicView
 */
export interface TrialPublicView {
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof TrialPublicView
     */
    'status': AccessRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialPublicView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPublicView
     */
    'officialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPublicView
     */
    'briefTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPublicView
     */
    'trialId': string;
    /**
     * 
     * @type {number}
     * @memberof TrialPublicView
     */
    'potentialUserTrialCount'?: number;
}


/**
 * 
 * @export
 * @interface TrialReachOutBody
 */
export interface TrialReachOutBody {
    /**
     * 
     * @type {string}
     * @memberof TrialReachOutBody
     */
    'communicationKey': TrialReachOutBodyCommunicationKeyEnum;
}

export const TrialReachOutBodyCommunicationKeyEnum = {
    ResetPassword: 'resetPassword',
    SetPassword: 'setPassword',
    VerifyEmail: 'verifyEmail',
    Invite: 'invite',
    VolunteerAcceptedManagedTrial: 'volunteerAcceptedManagedTrial',
    RequestTrialCriteriaDigest: 'requestTrialCriteriaDigest',
    RequestBooster: 'requestBooster',
    ExternalContactMatch: 'externalContactMatch',
    FullMatch: 'fullMatch',
    FullMatchPanel: 'fullMatchPanel',
    NoMatch: 'noMatch',
    NewQuestions: 'newQuestions',
    NewTrial: 'newTrial',
    SurveyReminder: 'surveyReminder',
    NewSurvey: 'newSurvey',
    FirstSurveyReminder: 'firstSurveyReminder',
    SecondSurveyReminder: 'secondSurveyReminder',
    FirstSurveyReactivation: 'firstSurveyReactivation',
    SecondSurveyReactivation: 'secondSurveyReactivation',
    NewTrialHealthy: 'newTrialHealthy',
    NewTrialUnhealthy: 'newTrialUnhealthy',
    TrialAccessApproved: 'trialAccessApproved',
    TrialAccessRejected: 'trialAccessRejected',
    CriteriaExplanation: 'criteriaExplanation',
    PatientReachOutMissingAnswers: 'patientReachOutMissingAnswers',
    PatientReachOutMissingAnswersPanel: 'patientReachOutMissingAnswersPanel',
    PatientReachOutVerified: 'patientReachOutVerified',
    PatientReachOutVerifiedPanel: 'patientReachOutVerifiedPanel',
    AccountClaim: 'accountClaim',
    TrialManagerWelcome: 'trialManagerWelcome',
    AccessRequestConfirmation: 'accessRequestConfirmation',
    NewAccessRequest: 'newAccessRequest',
    PendingLocationPatients: 'pendingLocationPatients',
    AutoApproveOverview: 'autoApproveOverview',
    PendingPanelPatients: 'pendingPanelPatients',
    WeeklyTopSponsor: 'weeklyTopSponsor',
    MilestoneConfirmation: 'milestoneConfirmation',
    MilestoneUpdate: 'milestoneUpdate',
    PendingLocationUpdate: 'pendingLocationUpdate',
    ContactFormInquiry: 'contactFormInquiry'
} as const;

export type TrialReachOutBodyCommunicationKeyEnum = typeof TrialReachOutBodyCommunicationKeyEnum[keyof typeof TrialReachOutBodyCommunicationKeyEnum];

/**
 * 
 * @export
 * @interface TrialReachOutView
 */
export interface TrialReachOutView {
    /**
     * 
     * @type {number}
     * @memberof TrialReachOutView
     */
    'patientCount': number;
    /**
     * 
     * @type {string}
     * @memberof TrialReachOutView
     */
    'nextReachOut': string;
}
/**
 * 
 * @export
 * @interface TrialRejectionsFilterOptionsView
 */
export interface TrialRejectionsFilterOptionsView {
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialRejectionsFilterOptionsView
     */
    'userCountry': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialRejectionsFilterOptionsView
     */
    'userGender': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialRejectionsFilterOptionsView
     */
    'trialTherapeuticArea': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialRejectionsFilterOptionsView
     */
    'sponsor': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialRejectionsFilterOptionsView
     */
    'sponsorClass': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialRejectionsFilterOptionsView
     */
    'userSource': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialRejectionsFilterOptionsView
     */
    'trialDisease': Array<string>;
}
/**
 * 
 * @export
 * @interface TrialRejectionsView
 */
export interface TrialRejectionsView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof TrialRejectionsView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {number}
     * @memberof TrialRejectionsView
     */
    'totalRejections': number;
    /**
     * 
     * @type {ReportingTieredBreakdownView}
     * @memberof TrialRejectionsView
     */
    'byReason': ReportingTieredBreakdownView;
    /**
     * 
     * @type {TrialRejectionsFilterOptionsView}
     * @memberof TrialRejectionsView
     */
    'filterOptions': TrialRejectionsFilterOptionsView;
}


/**
 * 
 * @export
 * @interface TrialSiteTableView
 */
export interface TrialSiteTableView {
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof TrialSiteTableView
     */
    'rows': Array<Array<number>>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialSiteTableView
     */
    'facilities': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialSiteTableView
     */
    'cities': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialSiteTableView
     */
    'countries': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialSiteTableView
     */
    'zipCodes': Array<string>;
}
/**
 * 
 * @export
 * @interface TrialSkipLocationSyncBody
 */
export interface TrialSkipLocationSyncBody {
    /**
     * 
     * @type {boolean}
     * @memberof TrialSkipLocationSyncBody
     */
    'skipLocationSync': boolean;
}
/**
 * 
 * @export
 * @interface TrialTeamListView
 */
export interface TrialTeamListView {
    /**
     * 
     * @type {Array<TrialTeamView>}
     * @memberof TrialTeamListView
     */
    'items': Array<TrialTeamView>;
    /**
     * 
     * @type {string}
     * @memberof TrialTeamListView
     */
    'nextPageToken'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialTeamView
 */
export interface TrialTeamView {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TrialTeamView
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TrialTeamView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialTeamView
     */
    'teamName': string;
    /**
     * 
     * @type {number}
     * @memberof TrialTeamView
     */
    'memberCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialTeamView
     */
    'trialCount': number;
    /**
     * 
     * @type {LeadResponsibleView}
     * @memberof TrialTeamView
     */
    'leadResponsible': LeadResponsibleView;
    /**
     * 
     * @type {string}
     * @memberof TrialTeamView
     */
    'mandateLocationId'?: string;
    /**
     * 
     * @type {TeamLocationView}
     * @memberof TrialTeamView
     */
    'location'?: TeamLocationView;
}
/**
 * 
 * @export
 * @interface TrialTranslationBody
 */
export interface TrialTranslationBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof TrialTranslationBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface TrialTranslationView
 */
export interface TrialTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof TrialTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof TrialTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {TranslationGenerationType}
     * @memberof TrialTranslationView
     */
    'generationType': TranslationGenerationType;
    /**
     * 
     * @type {string}
     * @memberof TrialTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof TrialTranslationView
     */
    'trialId': string;
}


/**
 * 
 * @export
 * @interface TrialView
 */
export interface TrialView {
    /**
     * 
     * @type {ManagementStatus}
     * @memberof TrialView
     */
    'managedBy': ManagementStatus;
    /**
     * 
     * @type {MatchingTrialStatus}
     * @memberof TrialView
     */
    'matchingStatus': MatchingTrialStatus;
    /**
     * 
     * @type {OverallTrialStatus}
     * @memberof TrialView
     */
    'overallStatus': OverallTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'officialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'briefTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'trialId': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialView
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'pendingUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'confirmedUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'eligibleUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'acceptedUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'potentialUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'locationsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'primaryCompletionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'studyCompletionDate'?: string;
    /**
     * 
     * @type {Array<SponsorView>}
     * @memberof TrialView
     */
    'sponsors': Array<SponsorView>;
}


/**
 * 
 * @export
 * @interface TrialVolunteerActivityUsersView
 */
export interface TrialVolunteerActivityUsersView {
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityUsersView
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityUsersView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TrialVolunteerActivityView
 */
export interface TrialVolunteerActivityView {
    /**
     * 
     * @type {VolunteerActivityType}
     * @memberof TrialVolunteerActivityView
     */
    'type': VolunteerActivityType;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'receiverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'receiverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'researcherId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'researcherName': string;
}


/**
 * 
 * @export
 * @interface TrialVolunteerAnswersListView
 */
export interface TrialVolunteerAnswersListView {
    /**
     * 
     * @type {Language}
     * @memberof TrialVolunteerAnswersListView
     */
    'patientLanguage': Language;
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof TrialVolunteerAnswersListView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {Array<TrialVolunteerAnswersView>}
     * @memberof TrialVolunteerAnswersListView
     */
    'items': Array<TrialVolunteerAnswersView>;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteerAnswersListView
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'eligibleAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'patientCountry': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'patientPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'researcherFeedback'?: string | null;
    /**
     * 
     * @type {Array<RejectionReasonView>}
     * @memberof TrialVolunteerAnswersListView
     */
    'rejectionReasons': Array<RejectionReasonView>;
}


/**
 * 
 * @export
 * @interface TrialVolunteerAnswersView
 */
export interface TrialVolunteerAnswersView {
    /**
     * 
     * @type {AnswerType}
     * @memberof TrialVolunteerAnswersView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {CriteriaStatus}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaStatus': CriteriaStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaText': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaValue'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaMinThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaMaxThreshold'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaOtherValues'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteerAnswersView
     */
    'numberValue'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialVolunteerAnswersView
     */
    'otherValues'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrialVolunteerAnswersView
     */
    'booleanValue'?: boolean | null;
}


/**
 * 
 * @export
 * @interface TrialVolunteerContactBody
 */
export interface TrialVolunteerContactBody {
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactBody
     */
    'contactedAt': string;
}
/**
 * 
 * @export
 * @interface TrialVolunteerContactView
 */
export interface TrialVolunteerContactView {
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactView
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface TrialVolunteerFeedbackBody
 */
export interface TrialVolunteerFeedbackBody {
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerFeedbackBody
     */
    'status': TrialVolunteerFeedbackBodyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerFeedbackBody
     */
    'patientMessage'?: string | null;
    /**
     * 
     * @type {Array<RejectionReasonBody>}
     * @memberof TrialVolunteerFeedbackBody
     */
    'rejectionReasons'?: Array<RejectionReasonBody> | null;
}

export const TrialVolunteerFeedbackBodyStatusEnum = {
    Active: 'active',
    Excluded: 'excluded',
    Eligible: 'eligible',
    Denied: 'denied',
    Pending: 'pending',
    PendingLocation: 'pendingLocation',
    Verified: 'verified',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Confirmed: 'confirmed',
    PreEnrolled: 'preEnrolled',
    Enrolled: 'enrolled'
} as const;

export type TrialVolunteerFeedbackBodyStatusEnum = typeof TrialVolunteerFeedbackBodyStatusEnum[keyof typeof TrialVolunteerFeedbackBodyStatusEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const TrialVolunteersOrderBy = {
    Country: 'country',
    PostalCode: 'postalCode',
    LocationName: 'locationName',
    AcceptedAt: 'acceptedAt',
    VerifiedAt: 'verifiedAt',
    ContactedAt: 'contactedAt'
} as const;

export type TrialVolunteersOrderBy = typeof TrialVolunteersOrderBy[keyof typeof TrialVolunteersOrderBy];


/**
 * 
 * @export
 * @interface TrialVolunteersOverviewView
 */
export interface TrialVolunteersOverviewView {
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'matched': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'confirmed': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'verified': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'eligible': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'rejected': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'excluded': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'denied': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'pending': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'pendingLocation': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'preEnrolled': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'enrolled': number;
}
/**
 * 
 * @export
 * @interface TrialsOverviewView
 */
export interface TrialsOverviewView {
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'confirmed': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'verified': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'eligible': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'rejected': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'excluded': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'denied': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'pending': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'pendingLocation': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'preEnrolled': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'enrolled': number;
    /**
     * The site countries of the listed trials; empty while `widenedSearchEnabled` is off.
     * @type {Array<string>}
     * @memberof TrialsOverviewView
     */
    'countries': Array<string>;
}
/**
 * 
 * @export
 * @interface UnassignMandateBody
 */
export interface UnassignMandateBody {
    /**
     * 
     * @type {string}
     * @memberof UnassignMandateBody
     */
    'teamId': string;
}
/**
 * 
 * @export
 * @interface UniqueLocationView
 */
export interface UniqueLocationView {
    /**
     * 
     * @type {string}
     * @memberof UniqueLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniqueLocationView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @interface UnsubscribeByTokenBody
 */
export interface UnsubscribeByTokenBody {
    /**
     * 
     * @type {string}
     * @memberof UnsubscribeByTokenBody
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface UpdateDisplayNameView
 */
export interface UpdateDisplayNameView {
    /**
     * 
     * @type {number}
     * @memberof UpdateDisplayNameView
     */
    'totalProcessed': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDisplayNameView
     */
    'totalUpdated': number;
}
/**
 * 
 * @export
 * @interface UpdateMetadataBody
 */
export interface UpdateMetadataBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateMetadataBody
     */
    'metadata': string;
}
/**
 * 
 * @export
 * @interface UpdateMySurveyBody
 */
export interface UpdateMySurveyBody {
    /**
     * 
     * @type {MySurveyCommandType}
     * @memberof UpdateMySurveyBody
     */
    'command': MySurveyCommandType;
}


/**
 * 
 * @export
 * @interface UpdateMyTrialBody
 */
export interface UpdateMyTrialBody {
    /**
     * 
     * @type {MyTrialCommandType}
     * @memberof UpdateMyTrialBody
     */
    'command': MyTrialCommandType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMyTrialBody
     */
    'isPhysician'?: boolean;
}


/**
 * 
 * @export
 * @interface UpdatePasswordBody
 */
export interface UpdatePasswordBody {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordBody
     */
    'currentPassword': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordBody
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface UpdateProfileBody
 */
export interface UpdateProfileBody {
    /**
     * 
     * @type {Language}
     * @memberof UpdateProfileBody
     */
    'language'?: Language;
    /**
     * 
     * @type {Gender}
     * @memberof UpdateProfileBody
     */
    'gender'?: Gender;
    /**
     * 
     * @type {SearchScope}
     * @memberof UpdateProfileBody
     */
    'searchScope'?: SearchScope;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProfileBody
     */
    'diseases'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'hospital'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'phoneNumber'?: string | null;
}


/**
 * 
 * @export
 * @interface UpdateTrialBody
 */
export interface UpdateTrialBody {
    /**
     * 
     * @type {ManagementStatus}
     * @memberof UpdateTrialBody
     */
    'managedBy'?: ManagementStatus;
    /**
     * 
     * @type {BillingType}
     * @memberof UpdateTrialBody
     */
    'billingType'?: BillingType;
    /**
     * 
     * @type {OverallTrialStatus}
     * @memberof UpdateTrialBody
     */
    'overallStatus'?: OverallTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrialBody
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrialBody
     */
    'primaryCompletionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrialBody
     */
    'studyCompletionDate'?: string;
    /**
     * First day of the Curewiki recruitment window. Null clears it.
     * @type {string}
     * @memberof UpdateTrialBody
     */
    'recruitmentStartDate'?: string | null;
    /**
     * Last day of the Curewiki recruitment window. Null clears it.
     * @type {string}
     * @memberof UpdateTrialBody
     */
    'recruitmentEndDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrialBody
     */
    'withDirectMessage'?: boolean;
}


/**
 * 
 * @export
 * @interface UpdateUserTrialLocationBody
 */
export interface UpdateUserTrialLocationBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserTrialLocationBody
     */
    'oldLocationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserTrialLocationBody
     */
    'newLocationId': string;
}
/**
 * 
 * @export
 * @interface UpdateUserTrialLocationView
 */
export interface UpdateUserTrialLocationView {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserTrialLocationView
     */
    'updatedCount': number;
}
/**
 * 
 * @export
 * @interface UserConsentListView
 */
export interface UserConsentListView {
    /**
     * 
     * @type {Array<UserConsentView>}
     * @memberof UserConsentListView
     */
    'items': Array<UserConsentView>;
}
/**
 * 
 * @export
 * @interface UserConsentView
 */
export interface UserConsentView {
    /**
     * 
     * @type {ConsentType}
     * @memberof UserConsentView
     */
    'type': ConsentType;
    /**
     * 
     * @type {ConsentStatus}
     * @memberof UserConsentView
     */
    'status': ConsentStatus;
    /**
     * 
     * @type {Array<ShareCategory>}
     * @memberof UserConsentView
     */
    'shareCategories'?: Array<ShareCategory>;
    /**
     * 
     * @type {string}
     * @memberof UserConsentView
     */
    'consentKey': string;
    /**
     * 
     * @type {string}
     * @memberof UserConsentView
     */
    'referenceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserConsentView
     */
    'consentedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserConsentView
     */
    'withdrawnAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserConsentView
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface UserFunnelDimensionOptionsView
 */
export interface UserFunnelDimensionOptionsView {
    /**
     * 
     * @type {string}
     * @memberof UserFunnelDimensionOptionsView
     */
    'dimension': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserFunnelDimensionOptionsView
     */
    'values': Array<string>;
}
/**
 * 
 * @export
 * @interface UserFunnelFilterOptionsView
 */
export interface UserFunnelFilterOptionsView {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserFunnelFilterOptionsView
     */
    'sources': Array<string>;
    /**
     * 
     * @type {Array<UserFunnelDimensionOptionsView>}
     * @memberof UserFunnelFilterOptionsView
     */
    'dimensions': Array<UserFunnelDimensionOptionsView>;
}
/**
 * 
 * @export
 * @interface UserFunnelView
 */
export interface UserFunnelView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof UserFunnelView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {Array<ReportingFunnelMilestoneView>}
     * @memberof UserFunnelView
     */
    'milestones': Array<ReportingFunnelMilestoneView>;
    /**
     * 
     * @type {UserFunnelFilterOptionsView}
     * @memberof UserFunnelView
     */
    'filterOptions': UserFunnelFilterOptionsView;
}


/**
 * 
 * @export
 * @interface UserPanelDetailView
 */
export interface UserPanelDetailView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserPanelDetailView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {Array<Language>}
     * @memberof UserPanelDetailView
     */
    'languages': Array<Language>;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'purpose': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'participantsWillDo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'dateAndTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'preparationRequired'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'timeCommitment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'compensation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'followUp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'resultSharing'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'confidentiality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'panelId': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'endDate': string;
    /**
     * 
     * @type {Array<UserPanelLocationView>}
     * @memberof UserPanelDetailView
     */
    'locations': Array<UserPanelLocationView>;
    /**
     * 
     * @type {Array<SponsorView>}
     * @memberof UserPanelDetailView
     */
    'sponsors'?: Array<SponsorView>;
    /**
     * 
     * @type {UserPanelLocationDetailView}
     * @memberof UserPanelDetailView
     */
    'currentLocation': UserPanelLocationDetailView;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelDetailView
     */
    'title': string;
}


/**
 * 
 * @export
 * @interface UserPanelLocationDetailView
 */
export interface UserPanelLocationDetailView {
    /**
     * 
     * @type {string}
     * @memberof UserPanelLocationDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelLocationDetailView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelLocationDetailView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelLocationDetailView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPanelLocationDetailView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @interface UserPanelLocationView
 */
export interface UserPanelLocationView {
    /**
     * 
     * @type {string}
     * @memberof UserPanelLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelLocationView
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface UserPanelView
 */
export interface UserPanelView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserPanelView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof UserPanelView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserPanelView
     */
    'title': string;
}


/**
 * 
 * @export
 * @interface UserSurveyDetailView
 */
export interface UserSurveyDetailView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserSurveyDetailView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyDetailView
     */
    'questionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyDetailView
     */
    'questionsAnswered'?: number;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserSurveyDetailView
     */
    'titleTranslated'?: TranslationView;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'description': string;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserSurveyDetailView
     */
    'descriptionTranslated'?: TranslationView;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'surveyId': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'endDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSurveyDetailView
     */
    'hasMoreQuestions': boolean;
}


/**
 * 
 * @export
 * @interface UserSurveyView
 */
export interface UserSurveyView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserSurveyView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyView
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyView
     */
    'questionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyView
     */
    'questionsAnswered'?: number;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserSurveyView
     */
    'titleTranslated'?: TranslationView;
}


/**
 * 
 * @export
 * @interface UserTrialDetailView
 */
export interface UserTrialDetailView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserTrialDetailView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {ManagementStatus}
     * @memberof UserTrialDetailView
     */
    'managedBy': ManagementStatus;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'briefTitle': string;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserTrialDetailView
     */
    'briefTitleTranslated'?: TranslationView;
    /**
     * 
     * @type {number}
     * @memberof UserTrialDetailView
     */
    'criteriaTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTrialDetailView
     */
    'criteriaAnswered'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTrialDetailView
     */
    'currentMilestone'?: number;
    /**
     * Metres from the patient\'s postal code to the matched site.
     * @type {number}
     * @memberof UserTrialDetailView
     */
    'distance'?: number | null;
    /**
     * The matched site\'s country.
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'country'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialDetailView
     */
    'isValidatedTrial': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'briefSummary': string;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserTrialDetailView
     */
    'briefSummaryTranslated'?: TranslationView;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTrialDetailView
     */
    'conditions': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'userFeedback'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'researcherFeedback'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialDetailView
     */
    'hasMoreQuestions': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialDetailView
     */
    'hasMorePhysicianQuestions': boolean;
    /**
     * True when this confirmed patient can join the Companion program themselves.
     * @type {boolean}
     * @memberof UserTrialDetailView
     */
    'hasMilestoneProgram': boolean;
    /**
     * 
     * @type {Array<LocationSimpleView>}
     * @memberof UserTrialDetailView
     */
    'locations': Array<LocationSimpleView>;
    /**
     * 
     * @type {LocationDetailView}
     * @memberof UserTrialDetailView
     */
    'currentLocation': LocationDetailView;
    /**
     * 
     * @type {EffectView}
     * @memberof UserTrialDetailView
     */
    'effect'?: EffectView;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'trialId': string;
    /**
     * 
     * @type {Array<ContactView>}
     * @memberof UserTrialDetailView
     */
    'contacts'?: Array<ContactView>;
    /**
     * 
     * @type {Array<TrialLocationContactView>}
     * @memberof UserTrialDetailView
     */
    'locationContacts'?: Array<TrialLocationContactView>;
    /**
     * 
     * @type {Array<SponsorView>}
     * @memberof UserTrialDetailView
     */
    'sponsors'?: Array<SponsorView>;
}


/**
 * 
 * @export
 * @interface UserTrialFeedBackView
 */
export interface UserTrialFeedBackView {
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialFeedBackView
     */
    'isManaged': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialFeedBackView
     */
    'isAccepted': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedBackView
     */
    'redirectUrl'?: string;
}
/**
 * 
 * @export
 * @interface UserTrialFeedbackBody
 */
export interface UserTrialFeedbackBody {
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedbackBody
     */
    'status': UserTrialFeedbackBodyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedbackBody
     */
    'userFeedback'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedbackBody
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedbackBody
     */
    'enrolledAt'?: string;
}

export const UserTrialFeedbackBodyStatusEnum = {
    Active: 'active',
    Excluded: 'excluded',
    Eligible: 'eligible',
    Denied: 'denied',
    Pending: 'pending',
    PendingLocation: 'pendingLocation',
    Verified: 'verified',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Confirmed: 'confirmed',
    PreEnrolled: 'preEnrolled',
    Enrolled: 'enrolled'
} as const;

export type UserTrialFeedbackBodyStatusEnum = typeof UserTrialFeedbackBodyStatusEnum[keyof typeof UserTrialFeedbackBodyStatusEnum];

/**
 * 
 * @export
 * @interface UserTrialLocationView
 */
export interface UserTrialLocationView {
    /**
     * 
     * @type {LocationLockReason}
     * @memberof UserTrialLocationView
     */
    'lockReason': LocationLockReason;
    /**
     * 
     * @type {string}
     * @memberof UserTrialLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTrialLocationView
     */
    'facility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTrialLocationView
     */
    'locationStatus'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const UserTrialStatus = {
    Active: 'active',
    Excluded: 'excluded',
    Eligible: 'eligible',
    Denied: 'denied',
    Pending: 'pending',
    PendingLocation: 'pendingLocation',
    Verified: 'verified',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Confirmed: 'confirmed',
    PreEnrolled: 'preEnrolled',
    Enrolled: 'enrolled'
} as const;

export type UserTrialStatus = typeof UserTrialStatus[keyof typeof UserTrialStatus];


/**
 * 
 * @export
 * @interface UserTrialView
 */
export interface UserTrialView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserTrialView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {ManagementStatus}
     * @memberof UserTrialView
     */
    'managedBy': ManagementStatus;
    /**
     * 
     * @type {string}
     * @memberof UserTrialView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialView
     */
    'briefTitle': string;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserTrialView
     */
    'briefTitleTranslated'?: TranslationView;
    /**
     * 
     * @type {number}
     * @memberof UserTrialView
     */
    'criteriaTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTrialView
     */
    'criteriaAnswered'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTrialView
     */
    'currentMilestone'?: number;
    /**
     * Metres from the patient\'s postal code to the matched site.
     * @type {number}
     * @memberof UserTrialView
     */
    'distance'?: number | null;
    /**
     * The matched site\'s country.
     * @type {string}
     * @memberof UserTrialView
     */
    'country'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialView
     */
    'isValidatedTrial': boolean;
}


/**
 * 
 * @export
 * @interface UsersCacheRegenerationBody
 */
export interface UsersCacheRegenerationBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof UsersCacheRegenerationBody
     */
    'userIds': Array<string>;
}
/**
 * 
 * @export
 * @interface VerifyBody
 */
export interface VerifyBody {
    /**
     * 
     * @type {string}
     * @memberof VerifyBody
     */
    'code': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VisibilityType = {
    Hidden: 'hidden',
    Default: 'default',
    First: 'first'
} as const;

export type VisibilityType = typeof VisibilityType[keyof typeof VisibilityType];


/**
 * 
 * @export
 * @enum {string}
 */

export const VolunteerActivityType = {
    ViewAnswer: 'viewAnswer',
    ViewContact: 'viewContact',
    GrantedLocationView: 'grantedLocationView',
    RevokedLocationView: 'revokedLocationView',
    Accept: 'accept',
    Reject: 'reject',
    Booster: 'booster',
    Contacted: 'contacted',
    ReachOutVerified: 'reachOutVerified',
    ReachOutMissingAnswers: 'reachOutMissingAnswers'
} as const;

export type VolunteerActivityType = typeof VolunteerActivityType[keyof typeof VolunteerActivityType];


/**
 * 
 * @export
 * @interface WhatIfBody
 */
export interface WhatIfBody {
    /**
     * Trial UUID (not the NCT code).
     * @type {string}
     * @memberof WhatIfBody
     */
    'trialId': string;
    /**
     * Inclusive lower age bound in years. Omit to keep the trial bound; null removes it.
     * @type {number}
     * @memberof WhatIfBody
     */
    'ageMin'?: number | null;
    /**
     * Inclusive upper age bound in years. Omit to keep the trial bound; null removes it.
     * @type {number}
     * @memberof WhatIfBody
     */
    'ageMax'?: number | null;
    /**
     * 
     * @type {WhatIfSex}
     * @memberof WhatIfBody
     */
    'sex'?: WhatIfSex;
    /**
     * Countries the trial recruits in. Omit to keep the trial countries; an empty list selects none.
     * @type {Array<string>}
     * @memberof WhatIfBody
     */
    'countries'?: Array<string>;
    /**
     * Countries taken out of the scenario. For a trial that recruits everywhere this is the way to drop one country: the API withholds small countries, so the full list cannot be sent back.
     * @type {Array<string>}
     * @memberof WhatIfBody
     */
    'excludeCountries'?: Array<string>;
    /**
     * Criteria of the trial switched off in the scenario: they no longer rule anyone out.
     * @type {Array<string>}
     * @memberof WhatIfBody
     */
    'disabledCriteria'?: Array<string>;
    /**
     * 
     * @type {Array<WhatIfThresholdBody>}
     * @memberof WhatIfBody
     */
    'thresholds'?: Array<WhatIfThresholdBody>;
}


/**
 * 
 * @export
 * @interface WhatIfCountryView
 */
export interface WhatIfCountryView {
    /**
     * 
     * @type {string}
     * @memberof WhatIfCountryView
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof WhatIfCountryView
     */
    'patients': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WhatIfCriterionKind = {
    Age: 'age',
    Sex: 'sex',
    Criterion: 'criterion'
} as const;

export type WhatIfCriterionKind = typeof WhatIfCriterionKind[keyof typeof WhatIfCriterionKind];


/**
 * 
 * @export
 * @interface WhatIfCriterionView
 */
export interface WhatIfCriterionView {
    /**
     * 
     * @type {WhatIfCriterionKind}
     * @memberof WhatIfCriterionView
     */
    'kind': WhatIfCriterionKind;
    /**
     * 
     * @type {number}
     * @memberof WhatIfCriterionView
     */
    'minThreshold': number | null;
    /**
     * 
     * @type {number}
     * @memberof WhatIfCriterionView
     */
    'maxThreshold': number | null;
    /**
     * 
     * @type {WhatIfSliderView}
     * @memberof WhatIfCriterionView
     */
    'slider'?: WhatIfSliderView;
    /**
     * 
     * @type {AnswerType}
     * @memberof WhatIfCriterionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {CriteriaType}
     * @memberof WhatIfCriterionView
     */
    'criteriaType': CriteriaType;
    /**
     * 
     * @type {string}
     * @memberof WhatIfCriterionView
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof WhatIfCriterionView
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof WhatIfCriterionView
     */
    'questionText': string;
    /**
     * 
     * @type {string}
     * @memberof WhatIfCriterionView
     */
    'originalCriteriaText': string;
    /**
     * 
     * @type {number}
     * @memberof WhatIfCriterionView
     */
    'pass': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfCriterionView
     */
    'fail': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfCriterionView
     */
    'unanswered': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfCriterionView
     */
    'toggleImpact': number;
}


/**
 * 
 * @export
 * @interface WhatIfLeversView
 */
export interface WhatIfLeversView {
    /**
     * 
     * @type {number}
     * @memberof WhatIfLeversView
     */
    'ageMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof WhatIfLeversView
     */
    'ageMax': number | null;
    /**
     * 
     * @type {WhatIfSex}
     * @memberof WhatIfLeversView
     */
    'sex': WhatIfSex;
    /**
     * 
     * @type {Array<string>}
     * @memberof WhatIfLeversView
     */
    'countries': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WhatIfLeversView
     */
    'excludedCountries': Array<string>;
}


/**
 * 
 * @export
 * @interface WhatIfScenarioView
 */
export interface WhatIfScenarioView {
    /**
     * 
     * @type {WhatIfLeversView}
     * @memberof WhatIfScenarioView
     */
    'levers': WhatIfLeversView;
    /**
     * 
     * @type {number}
     * @memberof WhatIfScenarioView
     */
    'patients': number;
}
/**
 * 
 * @export
 * @interface WhatIfScopeView
 */
export interface WhatIfScopeView {
    /**
     * 
     * @type {LandingScopeType}
     * @memberof WhatIfScopeView
     */
    'type': LandingScopeType;
    /**
     * 
     * @type {string}
     * @memberof WhatIfScopeView
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof WhatIfScopeView
     */
    'label': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const WhatIfSex = {
    Any: 'any',
    Female: 'female',
    Male: 'male'
} as const;

export type WhatIfSex = typeof WhatIfSex[keyof typeof WhatIfSex];


/**
 * 
 * @export
 * @interface WhatIfSliderView
 */
export interface WhatIfSliderView {
    /**
     * 
     * @type {number}
     * @memberof WhatIfSliderView
     */
    'min': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfSliderView
     */
    'max': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfSliderView
     */
    'step': number;
}
/**
 * 
 * @export
 * @interface WhatIfThresholdBody
 */
export interface WhatIfThresholdBody {
    /**
     * Id of a numeric criterion of the trial.
     * @type {string}
     * @memberof WhatIfThresholdBody
     */
    'criterionId': string;
    /**
     * 
     * @type {number}
     * @memberof WhatIfThresholdBody
     */
    'min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WhatIfThresholdBody
     */
    'max'?: number | null;
}
/**
 * 
 * @export
 * @interface WhatIfTrialListItemView
 */
export interface WhatIfTrialListItemView {
    /**
     * 
     * @type {string}
     * @memberof WhatIfTrialListItemView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WhatIfTrialListItemView
     */
    'nctCode': string;
    /**
     * 
     * @type {string}
     * @memberof WhatIfTrialListItemView
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface WhatIfTrialView
 */
export interface WhatIfTrialView {
    /**
     * 
     * @type {string}
     * @memberof WhatIfTrialView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WhatIfTrialView
     */
    'nctCode': string;
    /**
     * 
     * @type {string}
     * @memberof WhatIfTrialView
     */
    'title': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WhatIfTrialView
     */
    'icdCodes': Array<string>;
}
/**
 * 
 * @export
 * @interface WhatIfTrialsView
 */
export interface WhatIfTrialsView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof WhatIfTrialsView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {Array<LandingProfileView>}
     * @memberof WhatIfTrialsView
     */
    'profiles'?: Array<LandingProfileView>;
    /**
     * 
     * @type {WhatIfScopeView}
     * @memberof WhatIfTrialsView
     */
    'scope': WhatIfScopeView;
    /**
     * 
     * @type {Array<WhatIfTrialListItemView>}
     * @memberof WhatIfTrialsView
     */
    'trials': Array<WhatIfTrialListItemView>;
}


/**
 * 
 * @export
 * @interface WhatIfView
 */
export interface WhatIfView {
    /**
     * 
     * @type {InsightsTier}
     * @memberof WhatIfView
     */
    'tier': InsightsTier;
    /**
     * 
     * @type {WhatIfTrialView}
     * @memberof WhatIfView
     */
    'trial': WhatIfTrialView;
    /**
     * 
     * @type {WhatIfScenarioView}
     * @memberof WhatIfView
     */
    'baseline': WhatIfScenarioView;
    /**
     * 
     * @type {WhatIfScenarioView}
     * @memberof WhatIfView
     */
    'scenario': WhatIfScenarioView;
    /**
     * 
     * @type {number}
     * @memberof WhatIfView
     */
    'base': number;
    /**
     * 
     * @type {Array<WhatIfCountryView>}
     * @memberof WhatIfView
     */
    'countries': Array<WhatIfCountryView>;
    /**
     * 
     * @type {Array<WhatIfCriterionView>}
     * @memberof WhatIfView
     */
    'criteria': Array<WhatIfCriterionView>;
    /**
     * 
     * @type {boolean}
     * @memberof WhatIfView
     */
    'isExact': boolean;
}



/**
 * ActivityApi - axios parameter creator
 * @export
 */
export const ActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete an activity
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteActivity', 'id', id)
            const localVarPath = `/activity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityApi - functional programming interface
 * @export
 */
export const ActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary delete an activity
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityApi.deleteActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivityApi - factory interface
 * @export
 */
export const ActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityApiFp(configuration)
    return {
        /**
         * 
         * @summary delete an activity
         * @param {ActivityApiDeleteActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity(requestParameters: ActivityApiDeleteActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteActivity(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteActivity operation in ActivityApi.
 * @export
 * @interface ActivityApiDeleteActivityRequest
 */
export interface ActivityApiDeleteActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivityApiDeleteActivity
     */
    readonly id: string
}

/**
 * ActivityApi - object-oriented interface
 * @export
 * @class ActivityApi
 * @extends {BaseAPI}
 */
export class ActivityApi extends BaseAPI {
    /**
     * 
     * @summary delete an activity
     * @param {ActivityApiDeleteActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityApi
     */
    public deleteActivity(requestParameters: ActivityApiDeleteActivityRequest, options?: RawAxiosRequestConfig) {
        return ActivityApiFp(this.configuration).deleteActivity(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AttributesApi - axios parameter creator
 * @export
 */
export const AttributesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get a list of all attributes of a user
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {AttributeFilter} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes: async (language: Language, limit?: number | null, offset?: number | null, filter?: AttributeFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getAttributes', 'language', language)
            const localVarPath = `/attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets the completion percentage for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletionPercentage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/attributes/completion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttributesApi - functional programming interface
 * @export
 */
export const AttributesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttributesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get a list of all attributes of a user
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {AttributeFilter} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttributes(language: Language, limit?: number | null, offset?: number | null, filter?: AttributeFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAttributeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttributes(language, limit, offset, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributesApi.getAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary gets the completion percentage for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompletionPercentage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletionPercentageView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompletionPercentage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributesApi.getCompletionPercentage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttributesApi - factory interface
 * @export
 */
export const AttributesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttributesApiFp(configuration)
    return {
        /**
         * 
         * @summary get a list of all attributes of a user
         * @param {AttributesApiGetAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes(requestParameters: AttributesApiGetAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAttributeView> {
            return localVarFp.getAttributes(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets the completion percentage for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletionPercentage(options?: RawAxiosRequestConfig): AxiosPromise<CompletionPercentageView> {
            return localVarFp.getCompletionPercentage(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAttributes operation in AttributesApi.
 * @export
 * @interface AttributesApiGetAttributesRequest
 */
export interface AttributesApiGetAttributesRequest {
    /**
     * 
     * @type {Language}
     * @memberof AttributesApiGetAttributes
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof AttributesApiGetAttributes
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof AttributesApiGetAttributes
     */
    readonly offset?: number | null

    /**
     * 
     * @type {AttributeFilter}
     * @memberof AttributesApiGetAttributes
     */
    readonly filter?: AttributeFilter
}

/**
 * AttributesApi - object-oriented interface
 * @export
 * @class AttributesApi
 * @extends {BaseAPI}
 */
export class AttributesApi extends BaseAPI {
    /**
     * 
     * @summary get a list of all attributes of a user
     * @param {AttributesApiGetAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public getAttributes(requestParameters: AttributesApiGetAttributesRequest, options?: RawAxiosRequestConfig) {
        return AttributesApiFp(this.configuration).getAttributes(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets the completion percentage for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public getCompletionPercentage(options?: RawAxiosRequestConfig) {
        return AttributesApiFp(this.configuration).getCompletionPercentage(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Claim an anonymous account through a token
         * @param {string} token 
         * @param {AnonymousClaimBody} anonymousClaimBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousClaim: async (token: string, anonymousClaimBody: AnonymousClaimBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('anonymousClaim', 'token', token)
            // verify required parameter 'anonymousClaimBody' is not null or undefined
            assertParamExists('anonymousClaim', 'anonymousClaimBody', anonymousClaimBody)
            const localVarPath = `/auth/anon/claim/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anonymousClaimBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request the claiming of an anonymous account through email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousRequestClaim: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('anonymousRequestClaim', 'email', email)
            const localVarPath = `/auth/anon/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new anonymous patient user
         * @param {AnonymousSignUpBody} anonymousSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousSignUp: async (anonymousSignUpBody: AnonymousSignUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anonymousSignUpBody' is not null or undefined
            assertParamExists('anonymousSignUp', 'anonymousSignUpBody', anonymousSignUpBody)
            const localVarPath = `/auth/anon/sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anonymousSignUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a dependent account and switch to it
         * @param {CreateDependentBody} createDependentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDependent: async (createDependentBody: CreateDependentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDependentBody' is not null or undefined
            assertParamExists('createDependent', 'createDependentBody', createDependentBody)
            const localVarPath = `/auth/dependent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDependentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List accounts linked to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkedAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/linked-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with Google
         * @param {GoogleLoginBody} googleLoginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin: async (googleLoginBody: GoogleLoginBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleLoginBody' is not null or undefined
            assertParamExists('googleLogin', 'googleLoginBody', googleLoginBody)
            const localVarPath = `/auth/google-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(googleLoginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new user with Google
         * @param {GoogleSignUpBody} googleSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleSignUp: async (googleSignUpBody: GoogleSignUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleSignUpBody' is not null or undefined
            assertParamExists('googleSignUp', 'googleSignUpBody', googleSignUpBody)
            const localVarPath = `/auth/google-sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(googleSignUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login by username and password
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginBody: LoginBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginBody' is not null or undefined
            assertParamExists('login', 'loginBody', loginBody)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new patient user
         * @param {PatientSignUpBody} patientSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientSignUp: async (patientSignUpBody: PatientSignUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSignUpBody' is not null or undefined
            assertParamExists('patientSignUp', 'patientSignUpBody', patientSignUpBody)
            const localVarPath = `/auth/sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientSignUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh the current id token
         * @param {RefreshBody} refreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (refreshBody: RefreshBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshBody' is not null or undefined
            assertParamExists('refresh', 'refreshBody', refreshBody)
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a reset password code
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordBody: ResetPasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordBody', resetPasswordBody)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set password after receiving a code
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword: async (setPasswordBody: SetPasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setPasswordBody' is not null or undefined
            assertParamExists('setPassword', 'setPasswordBody', setPasswordBody)
            const localVarPath = `/auth/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Switch active account
         * @param {SwitchAccountBody} switchAccountBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchAccount: async (switchAccountBody: SwitchAccountBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'switchAccountBody' is not null or undefined
            assertParamExists('switchAccount', 'switchAccountBody', switchAccountBody)
            const localVarPath = `/auth/switch-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(switchAccountBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new trial manager user
         * @param {TrialManagerSignUpBody} trialManagerSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialManagerSignUp: async (trialManagerSignUpBody: TrialManagerSignUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialManagerSignUpBody' is not null or undefined
            assertParamExists('trialManagerSignUp', 'trialManagerSignUpBody', trialManagerSignUpBody)
            const localVarPath = `/auth/trial-manager-sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialManagerSignUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify a user email
         * @param {VerifyBody} verifyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify: async (verifyBody: VerifyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyBody' is not null or undefined
            assertParamExists('verify', 'verifyBody', verifyBody)
            const localVarPath = `/auth/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Claim an anonymous account through a token
         * @param {string} token 
         * @param {AnonymousClaimBody} anonymousClaimBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anonymousClaim(token: string, anonymousClaimBody: AnonymousClaimBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anonymousClaim(token, anonymousClaimBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.anonymousClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request the claiming of an anonymous account through email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anonymousRequestClaim(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anonymousRequestClaim(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.anonymousRequestClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new anonymous patient user
         * @param {AnonymousSignUpBody} anonymousSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anonymousSignUp(anonymousSignUpBody: AnonymousSignUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnonymousLoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anonymousSignUp(anonymousSignUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.anonymousSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a dependent account and switch to it
         * @param {CreateDependentBody} createDependentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDependent(createDependentBody: CreateDependentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDependent(createDependentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.createDependent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List accounts linked to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkedAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedAccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkedAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getLinkedAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with Google
         * @param {GoogleLoginBody} googleLoginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLogin(googleLoginBody: GoogleLoginBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleLogin(googleLoginBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.googleLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new user with Google
         * @param {GoogleSignUpBody} googleSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleSignUp(googleSignUpBody: GoogleSignUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleSignUp(googleSignUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.googleSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login by username and password
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginBody: LoginBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new patient user
         * @param {PatientSignUpBody} patientSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientSignUp(patientSignUpBody: PatientSignUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientSignUp(patientSignUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.patientSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh the current id token
         * @param {RefreshBody} refreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(refreshBody: RefreshBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(refreshBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request a reset password code
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordBody: ResetPasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set password after receiving a code
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPassword(setPasswordBody: SetPasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPassword(setPasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.setPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Switch active account
         * @param {SwitchAccountBody} switchAccountBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchAccount(switchAccountBody: SwitchAccountBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchAccount(switchAccountBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.switchAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new trial manager user
         * @param {TrialManagerSignUpBody} trialManagerSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trialManagerSignUp(trialManagerSignUpBody: TrialManagerSignUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trialManagerSignUp(trialManagerSignUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.trialManagerSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify a user email
         * @param {VerifyBody} verifyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verify(verifyBody: VerifyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verify(verifyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Claim an anonymous account through a token
         * @param {AuthApiAnonymousClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousClaim(requestParameters: AuthApiAnonymousClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.anonymousClaim(requestParameters.token, requestParameters.anonymousClaimBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request the claiming of an anonymous account through email
         * @param {AuthApiAnonymousRequestClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousRequestClaim(requestParameters: AuthApiAnonymousRequestClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.anonymousRequestClaim(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new anonymous patient user
         * @param {AuthApiAnonymousSignUpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousSignUp(requestParameters: AuthApiAnonymousSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnonymousLoginView> {
            return localVarFp.anonymousSignUp(requestParameters.anonymousSignUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a dependent account and switch to it
         * @param {AuthApiCreateDependentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDependent(requestParameters: AuthApiCreateDependentRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.createDependent(requestParameters.createDependentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List accounts linked to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkedAccounts(options?: RawAxiosRequestConfig): AxiosPromise<LinkedAccountsView> {
            return localVarFp.getLinkedAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with Google
         * @param {AuthApiGoogleLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(requestParameters: AuthApiGoogleLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.googleLogin(requestParameters.googleLoginBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new user with Google
         * @param {AuthApiGoogleSignUpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleSignUp(requestParameters: AuthApiGoogleSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.googleSignUp(requestParameters.googleSignUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login by username and password
         * @param {AuthApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: AuthApiLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.login(requestParameters.loginBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new patient user
         * @param {AuthApiPatientSignUpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientSignUp(requestParameters: AuthApiPatientSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.patientSignUp(requestParameters.patientSignUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh the current id token
         * @param {AuthApiRefreshRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(requestParameters: AuthApiRefreshRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.refresh(requestParameters.refreshBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a reset password code
         * @param {AuthApiResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(requestParameters: AuthApiResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetPassword(requestParameters.resetPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set password after receiving a code
         * @param {AuthApiSetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(requestParameters: AuthApiSetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.setPassword(requestParameters.setPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Switch active account
         * @param {AuthApiSwitchAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchAccount(requestParameters: AuthApiSwitchAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.switchAccount(requestParameters.switchAccountBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new trial manager user
         * @param {AuthApiTrialManagerSignUpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialManagerSignUp(requestParameters: AuthApiTrialManagerSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.trialManagerSignUp(requestParameters.trialManagerSignUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify a user email
         * @param {AuthApiVerifyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify(requestParameters: AuthApiVerifyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verify(requestParameters.verifyBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for anonymousClaim operation in AuthApi.
 * @export
 * @interface AuthApiAnonymousClaimRequest
 */
export interface AuthApiAnonymousClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiAnonymousClaim
     */
    readonly token: string

    /**
     * 
     * @type {AnonymousClaimBody}
     * @memberof AuthApiAnonymousClaim
     */
    readonly anonymousClaimBody: AnonymousClaimBody
}

/**
 * Request parameters for anonymousRequestClaim operation in AuthApi.
 * @export
 * @interface AuthApiAnonymousRequestClaimRequest
 */
export interface AuthApiAnonymousRequestClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiAnonymousRequestClaim
     */
    readonly email: string
}

/**
 * Request parameters for anonymousSignUp operation in AuthApi.
 * @export
 * @interface AuthApiAnonymousSignUpRequest
 */
export interface AuthApiAnonymousSignUpRequest {
    /**
     * 
     * @type {AnonymousSignUpBody}
     * @memberof AuthApiAnonymousSignUp
     */
    readonly anonymousSignUpBody: AnonymousSignUpBody
}

/**
 * Request parameters for createDependent operation in AuthApi.
 * @export
 * @interface AuthApiCreateDependentRequest
 */
export interface AuthApiCreateDependentRequest {
    /**
     * 
     * @type {CreateDependentBody}
     * @memberof AuthApiCreateDependent
     */
    readonly createDependentBody: CreateDependentBody
}

/**
 * Request parameters for googleLogin operation in AuthApi.
 * @export
 * @interface AuthApiGoogleLoginRequest
 */
export interface AuthApiGoogleLoginRequest {
    /**
     * 
     * @type {GoogleLoginBody}
     * @memberof AuthApiGoogleLogin
     */
    readonly googleLoginBody: GoogleLoginBody
}

/**
 * Request parameters for googleSignUp operation in AuthApi.
 * @export
 * @interface AuthApiGoogleSignUpRequest
 */
export interface AuthApiGoogleSignUpRequest {
    /**
     * 
     * @type {GoogleSignUpBody}
     * @memberof AuthApiGoogleSignUp
     */
    readonly googleSignUpBody: GoogleSignUpBody
}

/**
 * Request parameters for login operation in AuthApi.
 * @export
 * @interface AuthApiLoginRequest
 */
export interface AuthApiLoginRequest {
    /**
     * 
     * @type {LoginBody}
     * @memberof AuthApiLogin
     */
    readonly loginBody: LoginBody
}

/**
 * Request parameters for patientSignUp operation in AuthApi.
 * @export
 * @interface AuthApiPatientSignUpRequest
 */
export interface AuthApiPatientSignUpRequest {
    /**
     * 
     * @type {PatientSignUpBody}
     * @memberof AuthApiPatientSignUp
     */
    readonly patientSignUpBody: PatientSignUpBody
}

/**
 * Request parameters for refresh operation in AuthApi.
 * @export
 * @interface AuthApiRefreshRequest
 */
export interface AuthApiRefreshRequest {
    /**
     * 
     * @type {RefreshBody}
     * @memberof AuthApiRefresh
     */
    readonly refreshBody: RefreshBody
}

/**
 * Request parameters for resetPassword operation in AuthApi.
 * @export
 * @interface AuthApiResetPasswordRequest
 */
export interface AuthApiResetPasswordRequest {
    /**
     * 
     * @type {ResetPasswordBody}
     * @memberof AuthApiResetPassword
     */
    readonly resetPasswordBody: ResetPasswordBody
}

/**
 * Request parameters for setPassword operation in AuthApi.
 * @export
 * @interface AuthApiSetPasswordRequest
 */
export interface AuthApiSetPasswordRequest {
    /**
     * 
     * @type {SetPasswordBody}
     * @memberof AuthApiSetPassword
     */
    readonly setPasswordBody: SetPasswordBody
}

/**
 * Request parameters for switchAccount operation in AuthApi.
 * @export
 * @interface AuthApiSwitchAccountRequest
 */
export interface AuthApiSwitchAccountRequest {
    /**
     * 
     * @type {SwitchAccountBody}
     * @memberof AuthApiSwitchAccount
     */
    readonly switchAccountBody: SwitchAccountBody
}

/**
 * Request parameters for trialManagerSignUp operation in AuthApi.
 * @export
 * @interface AuthApiTrialManagerSignUpRequest
 */
export interface AuthApiTrialManagerSignUpRequest {
    /**
     * 
     * @type {TrialManagerSignUpBody}
     * @memberof AuthApiTrialManagerSignUp
     */
    readonly trialManagerSignUpBody: TrialManagerSignUpBody
}

/**
 * Request parameters for verify operation in AuthApi.
 * @export
 * @interface AuthApiVerifyRequest
 */
export interface AuthApiVerifyRequest {
    /**
     * 
     * @type {VerifyBody}
     * @memberof AuthApiVerify
     */
    readonly verifyBody: VerifyBody
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Claim an anonymous account through a token
     * @param {AuthApiAnonymousClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public anonymousClaim(requestParameters: AuthApiAnonymousClaimRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).anonymousClaim(requestParameters.token, requestParameters.anonymousClaimBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request the claiming of an anonymous account through email
     * @param {AuthApiAnonymousRequestClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public anonymousRequestClaim(requestParameters: AuthApiAnonymousRequestClaimRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).anonymousRequestClaim(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new anonymous patient user
     * @param {AuthApiAnonymousSignUpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public anonymousSignUp(requestParameters: AuthApiAnonymousSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).anonymousSignUp(requestParameters.anonymousSignUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a dependent account and switch to it
     * @param {AuthApiCreateDependentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public createDependent(requestParameters: AuthApiCreateDependentRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).createDependent(requestParameters.createDependentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List accounts linked to the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getLinkedAccounts(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getLinkedAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with Google
     * @param {AuthApiGoogleLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public googleLogin(requestParameters: AuthApiGoogleLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).googleLogin(requestParameters.googleLoginBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new user with Google
     * @param {AuthApiGoogleSignUpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public googleSignUp(requestParameters: AuthApiGoogleSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).googleSignUp(requestParameters.googleSignUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login by username and password
     * @param {AuthApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(requestParameters: AuthApiLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(requestParameters.loginBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new patient user
     * @param {AuthApiPatientSignUpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public patientSignUp(requestParameters: AuthApiPatientSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).patientSignUp(requestParameters.patientSignUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh the current id token
     * @param {AuthApiRefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refresh(requestParameters: AuthApiRefreshRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refresh(requestParameters.refreshBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a reset password code
     * @param {AuthApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPassword(requestParameters: AuthApiResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetPassword(requestParameters.resetPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set password after receiving a code
     * @param {AuthApiSetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public setPassword(requestParameters: AuthApiSetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).setPassword(requestParameters.setPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Switch active account
     * @param {AuthApiSwitchAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public switchAccount(requestParameters: AuthApiSwitchAccountRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).switchAccount(requestParameters.switchAccountBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new trial manager user
     * @param {AuthApiTrialManagerSignUpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public trialManagerSignUp(requestParameters: AuthApiTrialManagerSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).trialManagerSignUp(requestParameters.trialManagerSignUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify a user email
     * @param {AuthApiVerifyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verify(requestParameters: AuthApiVerifyRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verify(requestParameters.verifyBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoryApi - axios parameter creator
 * @export
 */
export const CategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add a disease to a category on the platform
         * @param {string} id 
         * @param {AddCategoryDiseaseBody} addCategoryDiseaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCategoryDisease: async (id: string, addCategoryDiseaseBody: AddCategoryDiseaseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addCategoryDisease', 'id', id)
            // verify required parameter 'addCategoryDiseaseBody' is not null or undefined
            assertParamExists('addCategoryDisease', 'addCategoryDiseaseBody', addCategoryDiseaseBody)
            const localVarPath = `/category/{id}/diseases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCategoryDiseaseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a category on the platform
         * @param {CategoryCreateBody} categoryCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (categoryCreateBody: CategoryCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryCreateBody' is not null or undefined
            assertParamExists('createCategory', 'categoryCreateBody', categoryCreateBody)
            const localVarPath = `/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoryCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCategory', 'id', id)
            const localVarPath = `/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all categories on the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {string} [parentCategoryId] 
         * @param {GetCategoriesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (limit?: number | null, offset?: number | null, searchString?: string, parentCategoryId?: string, type?: GetCategoriesTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (parentCategoryId !== undefined) {
                localVarQueryParameter['parentCategoryId'] = parentCategoryId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all translations of a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryContextTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryContextTranslations', 'id', id)
            const localVarPath = `/category/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all diseases associated to a category on the platform
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryDiseases: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryDiseases', 'id', id)
            const localVarPath = `/category/{id}/diseases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all questions associated to a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryQuestions: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryQuestions', 'id', id)
            const localVarPath = `/category/{id}/questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the full tree of all categories of a certain type in the platform
         * @param {GetNestedCategoriesTypeEnum} type 
         * @param {boolean | null} [forceRecalculate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNestedCategories: async (type: GetNestedCategoriesTypeEnum, forceRecalculate?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getNestedCategories', 'type', type)
            const localVarPath = `/category/nested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forceRecalculate !== undefined) {
                localVarQueryParameter['forceRecalculate'] = forceRecalculate;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary remove a disease from a category on the platform
         * @param {string} id 
         * @param {RemoveCategoryDiseaseBody} removeCategoryDiseaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCategoryDisease: async (id: string, removeCategoryDiseaseBody: RemoveCategoryDiseaseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCategoryDisease', 'id', id)
            // verify required parameter 'removeCategoryDiseaseBody' is not null or undefined
            assertParamExists('removeCategoryDisease', 'removeCategoryDiseaseBody', removeCategoryDiseaseBody)
            const localVarPath = `/category/{id}/diseases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeCategoryDiseaseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a category on the platform
         * @param {string} id 
         * @param {CategoryUpdateBody} categoryUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory: async (id: string, categoryUpdateBody: CategoryUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCategory', 'id', id)
            // verify required parameter 'categoryUpdateBody' is not null or undefined
            assertParamExists('updateCategory', 'categoryUpdateBody', categoryUpdateBody)
            const localVarPath = `/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoryUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the translations of a category on the platform
         * @param {string} id 
         * @param {CategoryContextTranslationsBody} categoryContextTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCategoryContextTranslations: async (id: string, categoryContextTranslationsBody: CategoryContextTranslationsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertCategoryContextTranslations', 'id', id)
            // verify required parameter 'categoryContextTranslationsBody' is not null or undefined
            assertParamExists('upsertCategoryContextTranslations', 'categoryContextTranslationsBody', categoryContextTranslationsBody)
            const localVarPath = `/category/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoryContextTranslationsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryApi - functional programming interface
 * @export
 */
export const CategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add a disease to a category on the platform
         * @param {string} id 
         * @param {AddCategoryDiseaseBody} addCategoryDiseaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCategoryDisease(id: string, addCategoryDiseaseBody: AddCategoryDiseaseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCategoryDisease(id, addCategoryDiseaseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.addCategoryDisease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a category on the platform
         * @param {CategoryCreateBody} categoryCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(categoryCreateBody: CategoryCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(categoryCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.createCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.deleteCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all categories on the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {string} [parentCategoryId] 
         * @param {GetCategoriesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(limit?: number | null, offset?: number | null, searchString?: string, parentCategoryId?: string, type?: GetCategoriesTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategorySearchView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(limit, offset, searchString, parentCategoryId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all translations of a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryContextTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategoryContextTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryContextTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getCategoryContextTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all diseases associated to a category on the platform
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryDiseases(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategoryDiseaseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryDiseases(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getCategoryDiseases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all questions associated to a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryQuestions(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategoryQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryQuestions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getCategoryQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the full tree of all categories of a certain type in the platform
         * @param {GetNestedCategoriesTypeEnum} type 
         * @param {boolean | null} [forceRecalculate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNestedCategories(type: GetNestedCategoriesTypeEnum, forceRecalculate?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNestedCategories(type, forceRecalculate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getNestedCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary remove a disease from a category on the platform
         * @param {string} id 
         * @param {RemoveCategoryDiseaseBody} removeCategoryDiseaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCategoryDisease(id: string, removeCategoryDiseaseBody: RemoveCategoryDiseaseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCategoryDisease(id, removeCategoryDiseaseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.removeCategoryDisease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a category on the platform
         * @param {string} id 
         * @param {CategoryUpdateBody} categoryUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategory(id: string, categoryUpdateBody: CategoryUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategory(id, categoryUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.updateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the translations of a category on the platform
         * @param {string} id 
         * @param {CategoryContextTranslationsBody} categoryContextTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertCategoryContextTranslations(id: string, categoryContextTranslationsBody: CategoryContextTranslationsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategoryContextTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertCategoryContextTranslations(id, categoryContextTranslationsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.upsertCategoryContextTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoryApi - factory interface
 * @export
 */
export const CategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryApiFp(configuration)
    return {
        /**
         * 
         * @summary add a disease to a category on the platform
         * @param {CategoryApiAddCategoryDiseaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCategoryDisease(requestParameters: CategoryApiAddCategoryDiseaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCategoryDisease(requestParameters.id, requestParameters.addCategoryDiseaseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a category on the platform
         * @param {CategoryApiCreateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(requestParameters: CategoryApiCreateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDetailsView> {
            return localVarFp.createCategory(requestParameters.categoryCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a category on the platform
         * @param {CategoryApiDeleteCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory(requestParameters: CategoryApiDeleteCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCategory(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all categories on the platform
         * @param {CategoryApiGetCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(requestParameters: CategoryApiGetCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListCategorySearchView> {
            return localVarFp.getCategories(requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.parentCategoryId, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all translations of a category on the platform
         * @param {CategoryApiGetCategoryContextTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryContextTranslations(requestParameters: CategoryApiGetCategoryContextTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCategoryContextTranslationView> {
            return localVarFp.getCategoryContextTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all diseases associated to a category on the platform
         * @param {CategoryApiGetCategoryDiseasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryDiseases(requestParameters: CategoryApiGetCategoryDiseasesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCategoryDiseaseView> {
            return localVarFp.getCategoryDiseases(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all questions associated to a category on the platform
         * @param {CategoryApiGetCategoryQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryQuestions(requestParameters: CategoryApiGetCategoryQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCategoryQuestionView> {
            return localVarFp.getCategoryQuestions(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the full tree of all categories of a certain type in the platform
         * @param {CategoryApiGetNestedCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNestedCategories(requestParameters: CategoryApiGetNestedCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryTreeView> {
            return localVarFp.getNestedCategories(requestParameters.type, requestParameters.forceRecalculate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary remove a disease from a category on the platform
         * @param {CategoryApiRemoveCategoryDiseaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCategoryDisease(requestParameters: CategoryApiRemoveCategoryDiseaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCategoryDisease(requestParameters.id, requestParameters.removeCategoryDiseaseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a category on the platform
         * @param {CategoryApiUpdateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory(requestParameters: CategoryApiUpdateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDetailsView> {
            return localVarFp.updateCategory(requestParameters.id, requestParameters.categoryUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the translations of a category on the platform
         * @param {CategoryApiUpsertCategoryContextTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCategoryContextTranslations(requestParameters: CategoryApiUpsertCategoryContextTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCategoryContextTranslationView> {
            return localVarFp.upsertCategoryContextTranslations(requestParameters.id, requestParameters.categoryContextTranslationsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCategoryDisease operation in CategoryApi.
 * @export
 * @interface CategoryApiAddCategoryDiseaseRequest
 */
export interface CategoryApiAddCategoryDiseaseRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiAddCategoryDisease
     */
    readonly id: string

    /**
     * 
     * @type {AddCategoryDiseaseBody}
     * @memberof CategoryApiAddCategoryDisease
     */
    readonly addCategoryDiseaseBody: AddCategoryDiseaseBody
}

/**
 * Request parameters for createCategory operation in CategoryApi.
 * @export
 * @interface CategoryApiCreateCategoryRequest
 */
export interface CategoryApiCreateCategoryRequest {
    /**
     * 
     * @type {CategoryCreateBody}
     * @memberof CategoryApiCreateCategory
     */
    readonly categoryCreateBody: CategoryCreateBody
}

/**
 * Request parameters for deleteCategory operation in CategoryApi.
 * @export
 * @interface CategoryApiDeleteCategoryRequest
 */
export interface CategoryApiDeleteCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiDeleteCategory
     */
    readonly id: string
}

/**
 * Request parameters for getCategories operation in CategoryApi.
 * @export
 * @interface CategoryApiGetCategoriesRequest
 */
export interface CategoryApiGetCategoriesRequest {
    /**
     * 
     * @type {number}
     * @memberof CategoryApiGetCategories
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof CategoryApiGetCategories
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategories
     */
    readonly searchString?: string

    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategories
     */
    readonly parentCategoryId?: string

    /**
     * 
     * @type {'starter' | 'icdCode' | 'tag' | 'mergedQuestion'}
     * @memberof CategoryApiGetCategories
     */
    readonly type?: GetCategoriesTypeEnum
}

/**
 * Request parameters for getCategoryContextTranslations operation in CategoryApi.
 * @export
 * @interface CategoryApiGetCategoryContextTranslationsRequest
 */
export interface CategoryApiGetCategoryContextTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategoryContextTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getCategoryDiseases operation in CategoryApi.
 * @export
 * @interface CategoryApiGetCategoryDiseasesRequest
 */
export interface CategoryApiGetCategoryDiseasesRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategoryDiseases
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof CategoryApiGetCategoryDiseases
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof CategoryApiGetCategoryDiseases
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getCategoryQuestions operation in CategoryApi.
 * @export
 * @interface CategoryApiGetCategoryQuestionsRequest
 */
export interface CategoryApiGetCategoryQuestionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategoryQuestions
     */
    readonly id: string
}

/**
 * Request parameters for getNestedCategories operation in CategoryApi.
 * @export
 * @interface CategoryApiGetNestedCategoriesRequest
 */
export interface CategoryApiGetNestedCategoriesRequest {
    /**
     * 
     * @type {'starter' | 'icdCode' | 'tag' | 'mergedQuestion'}
     * @memberof CategoryApiGetNestedCategories
     */
    readonly type: GetNestedCategoriesTypeEnum

    /**
     * 
     * @type {boolean}
     * @memberof CategoryApiGetNestedCategories
     */
    readonly forceRecalculate?: boolean | null
}

/**
 * Request parameters for removeCategoryDisease operation in CategoryApi.
 * @export
 * @interface CategoryApiRemoveCategoryDiseaseRequest
 */
export interface CategoryApiRemoveCategoryDiseaseRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiRemoveCategoryDisease
     */
    readonly id: string

    /**
     * 
     * @type {RemoveCategoryDiseaseBody}
     * @memberof CategoryApiRemoveCategoryDisease
     */
    readonly removeCategoryDiseaseBody: RemoveCategoryDiseaseBody
}

/**
 * Request parameters for updateCategory operation in CategoryApi.
 * @export
 * @interface CategoryApiUpdateCategoryRequest
 */
export interface CategoryApiUpdateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiUpdateCategory
     */
    readonly id: string

    /**
     * 
     * @type {CategoryUpdateBody}
     * @memberof CategoryApiUpdateCategory
     */
    readonly categoryUpdateBody: CategoryUpdateBody
}

/**
 * Request parameters for upsertCategoryContextTranslations operation in CategoryApi.
 * @export
 * @interface CategoryApiUpsertCategoryContextTranslationsRequest
 */
export interface CategoryApiUpsertCategoryContextTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiUpsertCategoryContextTranslations
     */
    readonly id: string

    /**
     * 
     * @type {CategoryContextTranslationsBody}
     * @memberof CategoryApiUpsertCategoryContextTranslations
     */
    readonly categoryContextTranslationsBody: CategoryContextTranslationsBody
}

/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */
export class CategoryApi extends BaseAPI {
    /**
     * 
     * @summary add a disease to a category on the platform
     * @param {CategoryApiAddCategoryDiseaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public addCategoryDisease(requestParameters: CategoryApiAddCategoryDiseaseRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).addCategoryDisease(requestParameters.id, requestParameters.addCategoryDiseaseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a category on the platform
     * @param {CategoryApiCreateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public createCategory(requestParameters: CategoryApiCreateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).createCategory(requestParameters.categoryCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a category on the platform
     * @param {CategoryApiDeleteCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public deleteCategory(requestParameters: CategoryApiDeleteCategoryRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).deleteCategory(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all categories on the platform
     * @param {CategoryApiGetCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategories(requestParameters: CategoryApiGetCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategories(requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.parentCategoryId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all translations of a category on the platform
     * @param {CategoryApiGetCategoryContextTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategoryContextTranslations(requestParameters: CategoryApiGetCategoryContextTranslationsRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategoryContextTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all diseases associated to a category on the platform
     * @param {CategoryApiGetCategoryDiseasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategoryDiseases(requestParameters: CategoryApiGetCategoryDiseasesRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategoryDiseases(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all questions associated to a category on the platform
     * @param {CategoryApiGetCategoryQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategoryQuestions(requestParameters: CategoryApiGetCategoryQuestionsRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategoryQuestions(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the full tree of all categories of a certain type in the platform
     * @param {CategoryApiGetNestedCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getNestedCategories(requestParameters: CategoryApiGetNestedCategoriesRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getNestedCategories(requestParameters.type, requestParameters.forceRecalculate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary remove a disease from a category on the platform
     * @param {CategoryApiRemoveCategoryDiseaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public removeCategoryDisease(requestParameters: CategoryApiRemoveCategoryDiseaseRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).removeCategoryDisease(requestParameters.id, requestParameters.removeCategoryDiseaseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a category on the platform
     * @param {CategoryApiUpdateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public updateCategory(requestParameters: CategoryApiUpdateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).updateCategory(requestParameters.id, requestParameters.categoryUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the translations of a category on the platform
     * @param {CategoryApiUpsertCategoryContextTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public upsertCategoryContextTranslations(requestParameters: CategoryApiUpsertCategoryContextTranslationsRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).upsertCategoryContextTranslations(requestParameters.id, requestParameters.categoryContextTranslationsBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetCategoriesTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;
export type GetCategoriesTypeEnum = typeof GetCategoriesTypeEnum[keyof typeof GetCategoriesTypeEnum];
/**
 * @export
 */
export const GetNestedCategoriesTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;
export type GetNestedCategoriesTypeEnum = typeof GetNestedCategoriesTypeEnum[keyof typeof GetNestedCategoriesTypeEnum];


/**
 * ChatEntriesApi - axios parameter creator
 * @export
 */
export const ChatEntriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {string} id 
         * @param {AnswerChatBody} answerChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerChatEntry: async (id: string, answerChatBody: AnswerChatBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('answerChatEntry', 'id', id)
            // verify required parameter 'answerChatBody' is not null or undefined
            assertParamExists('answerChatEntry', 'answerChatBody', answerChatBody)
            const localVarPath = `/chats/entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerChatBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueChat: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chats/entries/continue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all chatEntries from a user
         * @param {HistoryType} history 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatEntries: async (history: HistoryType, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'history' is not null or undefined
            assertParamExists('getChatEntries', 'history', history)
            const localVarPath = `/chats/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (history !== undefined) {
                localVarQueryParameter['history'] = history;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the eligibility chat progress — exhaustive-tier fraction, phase name per tier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatProgress: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chats/entries/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete to skip a question (chatEntry)
         * @param {string} id 
         * @param {SkipChatEntryBody} skipChatEntryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipChatEntry: async (id: string, skipChatEntryBody: SkipChatEntryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skipChatEntry', 'id', id)
            // verify required parameter 'skipChatEntryBody' is not null or undefined
            assertParamExists('skipChatEntry', 'skipChatEntryBody', skipChatEntryBody)
            const localVarPath = `/chats/entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skipChatEntryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatEntriesApi - functional programming interface
 * @export
 */
export const ChatEntriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatEntriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {string} id 
         * @param {AnswerChatBody} answerChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerChatEntry(id: string, answerChatBody: AnswerChatBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerChatEntry(id, answerChatBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.answerChatEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continueChat(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continueChat(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.continueChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all chatEntries from a user
         * @param {HistoryType} history 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatEntries(history: HistoryType, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListChatEntryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatEntries(history, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.getChatEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the eligibility chat progress — exhaustive-tier fraction, phase name per tier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatProgress(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatProgressView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatProgress(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.getChatProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete to skip a question (chatEntry)
         * @param {string} id 
         * @param {SkipChatEntryBody} skipChatEntryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipChatEntry(id: string, skipChatEntryBody: SkipChatEntryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipChatEntry(id, skipChatEntryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.skipChatEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatEntriesApi - factory interface
 * @export
 */
export const ChatEntriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatEntriesApiFp(configuration)
    return {
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {ChatEntriesApiAnswerChatEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerChatEntry(requestParameters: ChatEntriesApiAnswerChatEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.answerChatEntry(requestParameters.id, requestParameters.answerChatBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueChat(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.continueChat(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all chatEntries from a user
         * @param {ChatEntriesApiGetChatEntriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatEntries(requestParameters: ChatEntriesApiGetChatEntriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListChatEntryView> {
            return localVarFp.getChatEntries(requestParameters.history, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the eligibility chat progress — exhaustive-tier fraction, phase name per tier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatProgress(options?: RawAxiosRequestConfig): AxiosPromise<ChatProgressView> {
            return localVarFp.getChatProgress(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete to skip a question (chatEntry)
         * @param {ChatEntriesApiSkipChatEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipChatEntry(requestParameters: ChatEntriesApiSkipChatEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.skipChatEntry(requestParameters.id, requestParameters.skipChatEntryBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for answerChatEntry operation in ChatEntriesApi.
 * @export
 * @interface ChatEntriesApiAnswerChatEntryRequest
 */
export interface ChatEntriesApiAnswerChatEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatEntriesApiAnswerChatEntry
     */
    readonly id: string

    /**
     * 
     * @type {AnswerChatBody}
     * @memberof ChatEntriesApiAnswerChatEntry
     */
    readonly answerChatBody: AnswerChatBody
}

/**
 * Request parameters for getChatEntries operation in ChatEntriesApi.
 * @export
 * @interface ChatEntriesApiGetChatEntriesRequest
 */
export interface ChatEntriesApiGetChatEntriesRequest {
    /**
     * 
     * @type {HistoryType}
     * @memberof ChatEntriesApiGetChatEntries
     */
    readonly history: HistoryType

    /**
     * 
     * @type {number}
     * @memberof ChatEntriesApiGetChatEntries
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof ChatEntriesApiGetChatEntries
     */
    readonly offset?: number | null
}

/**
 * Request parameters for skipChatEntry operation in ChatEntriesApi.
 * @export
 * @interface ChatEntriesApiSkipChatEntryRequest
 */
export interface ChatEntriesApiSkipChatEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatEntriesApiSkipChatEntry
     */
    readonly id: string

    /**
     * 
     * @type {SkipChatEntryBody}
     * @memberof ChatEntriesApiSkipChatEntry
     */
    readonly skipChatEntryBody: SkipChatEntryBody
}

/**
 * ChatEntriesApi - object-oriented interface
 * @export
 * @class ChatEntriesApi
 * @extends {BaseAPI}
 */
export class ChatEntriesApi extends BaseAPI {
    /**
     * 
     * @summary process an answer to a question (chatEntry)
     * @param {ChatEntriesApiAnswerChatEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public answerChatEntry(requestParameters: ChatEntriesApiAnswerChatEntryRequest, options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).answerChatEntry(requestParameters.id, requestParameters.answerChatBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary process an answer to a question (chatEntry)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public continueChat(options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).continueChat(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all chatEntries from a user
     * @param {ChatEntriesApiGetChatEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public getChatEntries(requestParameters: ChatEntriesApiGetChatEntriesRequest, options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).getChatEntries(requestParameters.history, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the eligibility chat progress — exhaustive-tier fraction, phase name per tier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public getChatProgress(options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).getChatProgress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete to skip a question (chatEntry)
     * @param {ChatEntriesApiSkipChatEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public skipChatEntry(requestParameters: ChatEntriesApiSkipChatEntryRequest, options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).skipChatEntry(requestParameters.id, requestParameters.skipChatEntryBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CohortsApi - axios parameter creator
 * @export
 */
export const CohortsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add a Cohort the pipeline missed (HITL flow (c) reviewer decision)
         * @param {CohortsCreateBody} cohortsCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (cohortsCreateBody: CohortsCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortsCreateBody' is not null or undefined
            assertParamExists('create', 'cohortsCreateBody', cohortsCreateBody)
            const localVarPath = `/cohorts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cohortsCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch a Cohort by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detail', 'id', id)
            const localVarPath = `/cohorts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list Cohorts for a trial
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (trialId: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('list', 'trialId', trialId)
            const localVarPath = `/cohorts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (trialId !== undefined) {
                localVarQueryParameter['trialId'] = trialId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary resolve a Cohort review: cohortStatus (+ optional rename) and/or icdHintStatus (+ optional corrected hints) — HITL flow (c) / (e) reviewer decision
         * @param {string} id 
         * @param {CohortsUpdateBody} cohortsUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, cohortsUpdateBody: CohortsUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'cohortsUpdateBody' is not null or undefined
            assertParamExists('update', 'cohortsUpdateBody', cohortsUpdateBody)
            const localVarPath = `/cohorts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cohortsUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CohortsApi - functional programming interface
 * @export
 */
export const CohortsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CohortsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add a Cohort the pipeline missed (HITL flow (c) reviewer decision)
         * @param {CohortsCreateBody} cohortsCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(cohortsCreateBody: CohortsCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CohortView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(cohortsCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CohortsApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary fetch a Cohort by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CohortView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CohortsApi.detail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list Cohorts for a trial
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(trialId: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCohortView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(trialId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CohortsApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary resolve a Cohort review: cohortStatus (+ optional rename) and/or icdHintStatus (+ optional corrected hints) — HITL flow (c) / (e) reviewer decision
         * @param {string} id 
         * @param {CohortsUpdateBody} cohortsUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, cohortsUpdateBody: CohortsUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, cohortsUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CohortsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CohortsApi - factory interface
 * @export
 */
export const CohortsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CohortsApiFp(configuration)
    return {
        /**
         * 
         * @summary add a Cohort the pipeline missed (HITL flow (c) reviewer decision)
         * @param {CohortsApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: CohortsApiCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CohortView> {
            return localVarFp.create(requestParameters.cohortsCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch a Cohort by id
         * @param {CohortsApiDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail(requestParameters: CohortsApiDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CohortView> {
            return localVarFp.detail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list Cohorts for a trial
         * @param {CohortsApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: CohortsApiListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCohortView> {
            return localVarFp.list(requestParameters.trialId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary resolve a Cohort review: cohortStatus (+ optional rename) and/or icdHintStatus (+ optional corrected hints) — HITL flow (c) / (e) reviewer decision
         * @param {CohortsApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters: CohortsApiUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.update(requestParameters.id, requestParameters.cohortsUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for create operation in CohortsApi.
 * @export
 * @interface CohortsApiCreateRequest
 */
export interface CohortsApiCreateRequest {
    /**
     * 
     * @type {CohortsCreateBody}
     * @memberof CohortsApiCreate
     */
    readonly cohortsCreateBody: CohortsCreateBody
}

/**
 * Request parameters for detail operation in CohortsApi.
 * @export
 * @interface CohortsApiDetailRequest
 */
export interface CohortsApiDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof CohortsApiDetail
     */
    readonly id: string
}

/**
 * Request parameters for list operation in CohortsApi.
 * @export
 * @interface CohortsApiListRequest
 */
export interface CohortsApiListRequest {
    /**
     * 
     * @type {string}
     * @memberof CohortsApiList
     */
    readonly trialId: string

    /**
     * 
     * @type {number}
     * @memberof CohortsApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof CohortsApiList
     */
    readonly offset?: number | null
}

/**
 * Request parameters for update operation in CohortsApi.
 * @export
 * @interface CohortsApiUpdateRequest
 */
export interface CohortsApiUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CohortsApiUpdate
     */
    readonly id: string

    /**
     * 
     * @type {CohortsUpdateBody}
     * @memberof CohortsApiUpdate
     */
    readonly cohortsUpdateBody: CohortsUpdateBody
}

/**
 * CohortsApi - object-oriented interface
 * @export
 * @class CohortsApi
 * @extends {BaseAPI}
 */
export class CohortsApi extends BaseAPI {
    /**
     * 
     * @summary add a Cohort the pipeline missed (HITL flow (c) reviewer decision)
     * @param {CohortsApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CohortsApi
     */
    public create(requestParameters: CohortsApiCreateRequest, options?: RawAxiosRequestConfig) {
        return CohortsApiFp(this.configuration).create(requestParameters.cohortsCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch a Cohort by id
     * @param {CohortsApiDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CohortsApi
     */
    public detail(requestParameters: CohortsApiDetailRequest, options?: RawAxiosRequestConfig) {
        return CohortsApiFp(this.configuration).detail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list Cohorts for a trial
     * @param {CohortsApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CohortsApi
     */
    public list(requestParameters: CohortsApiListRequest, options?: RawAxiosRequestConfig) {
        return CohortsApiFp(this.configuration).list(requestParameters.trialId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary resolve a Cohort review: cohortStatus (+ optional rename) and/or icdHintStatus (+ optional corrected hints) — HITL flow (c) / (e) reviewer decision
     * @param {CohortsApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CohortsApi
     */
    public update(requestParameters: CohortsApiUpdateRequest, options?: RawAxiosRequestConfig) {
        return CohortsApiFp(this.configuration).update(requestParameters.id, requestParameters.cohortsUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the configuration details of the application state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the question configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/configurations/question-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the tag configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/configurations/tag-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export const ConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the configuration details of the application state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigurationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigurationApi.getConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the question configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionConfigurationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigurationApi.getQuestionConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the tag configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagConfigurationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigurationApi.getTagConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConfigurationApi - factory interface
 * @export
 */
export const ConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the configuration details of the application state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<ConfigurationView> {
            return localVarFp.getConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the question configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<QuestionConfigurationView> {
            return localVarFp.getQuestionConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the tag configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<TagConfigurationView> {
            return localVarFp.getTagConfiguration(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigurationApi extends BaseAPI {
    /**
     * 
     * @summary Get the configuration details of the application state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getConfiguration(options?: RawAxiosRequestConfig) {
        return ConfigurationApiFp(this.configuration).getConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the question configuration details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getQuestionConfiguration(options?: RawAxiosRequestConfig) {
        return ConfigurationApiFp(this.configuration).getQuestionConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the tag configuration details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getTagConfiguration(options?: RawAxiosRequestConfig) {
        return ConfigurationApiFp(this.configuration).getTagConfiguration(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConsentsApi - axios parameter creator
 * @export
 */
export const ConsentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Grant a consent.
         * @param {CreateUserConsentBody} createUserConsentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserConsent: async (createUserConsentBody: CreateUserConsentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserConsentBody' is not null or undefined
            assertParamExists('createUserConsent', 'createUserConsentBody', createUserConsentBody)
            const localVarPath = `/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserConsentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific consent by key.
         * @param {string} consentKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsent: async (consentKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentKey' is not null or undefined
            assertParamExists('getUserConsent', 'consentKey', consentKey)
            const localVarPath = `/consents/{consentKey}`
                .replace(`{${"consentKey"}}`, encodeURIComponent(String(consentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all consents for the authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Withdraw a consent.
         * @param {string} consentKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawUserConsent: async (consentKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentKey' is not null or undefined
            assertParamExists('withdrawUserConsent', 'consentKey', consentKey)
            const localVarPath = `/consents/{consentKey}/withdraw`
                .replace(`{${"consentKey"}}`, encodeURIComponent(String(consentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentsApi - functional programming interface
 * @export
 */
export const ConsentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConsentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Grant a consent.
         * @param {CreateUserConsentBody} createUserConsentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserConsent(createUserConsentBody: CreateUserConsentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConsentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserConsent(createUserConsentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.createUserConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific consent by key.
         * @param {string} consentKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserConsent(consentKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConsentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserConsent(consentKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.getUserConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all consents for the authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserConsents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConsentListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserConsents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.getUserConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Withdraw a consent.
         * @param {string} consentKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withdrawUserConsent(consentKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConsentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.withdrawUserConsent(consentKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.withdrawUserConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConsentsApi - factory interface
 * @export
 */
export const ConsentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConsentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Grant a consent.
         * @param {ConsentsApiCreateUserConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserConsent(requestParameters: ConsentsApiCreateUserConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserConsentView> {
            return localVarFp.createUserConsent(requestParameters.createUserConsentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific consent by key.
         * @param {ConsentsApiGetUserConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsent(requestParameters: ConsentsApiGetUserConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserConsentView> {
            return localVarFp.getUserConsent(requestParameters.consentKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all consents for the authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsents(options?: RawAxiosRequestConfig): AxiosPromise<UserConsentListView> {
            return localVarFp.getUserConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Withdraw a consent.
         * @param {ConsentsApiWithdrawUserConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawUserConsent(requestParameters: ConsentsApiWithdrawUserConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserConsentView> {
            return localVarFp.withdrawUserConsent(requestParameters.consentKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createUserConsent operation in ConsentsApi.
 * @export
 * @interface ConsentsApiCreateUserConsentRequest
 */
export interface ConsentsApiCreateUserConsentRequest {
    /**
     * 
     * @type {CreateUserConsentBody}
     * @memberof ConsentsApiCreateUserConsent
     */
    readonly createUserConsentBody: CreateUserConsentBody
}

/**
 * Request parameters for getUserConsent operation in ConsentsApi.
 * @export
 * @interface ConsentsApiGetUserConsentRequest
 */
export interface ConsentsApiGetUserConsentRequest {
    /**
     * 
     * @type {string}
     * @memberof ConsentsApiGetUserConsent
     */
    readonly consentKey: string
}

/**
 * Request parameters for withdrawUserConsent operation in ConsentsApi.
 * @export
 * @interface ConsentsApiWithdrawUserConsentRequest
 */
export interface ConsentsApiWithdrawUserConsentRequest {
    /**
     * 
     * @type {string}
     * @memberof ConsentsApiWithdrawUserConsent
     */
    readonly consentKey: string
}

/**
 * ConsentsApi - object-oriented interface
 * @export
 * @class ConsentsApi
 * @extends {BaseAPI}
 */
export class ConsentsApi extends BaseAPI {
    /**
     * 
     * @summary Grant a consent.
     * @param {ConsentsApiCreateUserConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public createUserConsent(requestParameters: ConsentsApiCreateUserConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentsApiFp(this.configuration).createUserConsent(requestParameters.createUserConsentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific consent by key.
     * @param {ConsentsApiGetUserConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public getUserConsent(requestParameters: ConsentsApiGetUserConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentsApiFp(this.configuration).getUserConsent(requestParameters.consentKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all consents for the authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public getUserConsents(options?: RawAxiosRequestConfig) {
        return ConsentsApiFp(this.configuration).getUserConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Withdraw a consent.
     * @param {ConsentsApiWithdrawUserConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public withdrawUserConsent(requestParameters: ConsentsApiWithdrawUserConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentsApiFp(this.configuration).withdrawUserConsent(requestParameters.consentKey, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a contact
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContact', 'id', id)
            const localVarPath = `/contact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing contact
         * @param {string} id 
         * @param {ContactUpdateBody} contactUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (id: string, contactUpdateBody: ContactUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateContact', 'id', id)
            // verify required parameter 'contactUpdateBody' is not null or undefined
            assertParamExists('updateContact', 'contactUpdateBody', contactUpdateBody)
            const localVarPath = `/contact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a contact
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContact(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContact(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.deleteContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing contact
         * @param {string} id 
         * @param {ContactUpdateBody} contactUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(id: string, contactUpdateBody: ContactUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(id, contactUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.updateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a contact
         * @param {ContactApiDeleteContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(requestParameters: ContactApiDeleteContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContact(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing contact
         * @param {ContactApiUpdateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(requestParameters: ContactApiUpdateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateContact(requestParameters.id, requestParameters.contactUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteContact operation in ContactApi.
 * @export
 * @interface ContactApiDeleteContactRequest
 */
export interface ContactApiDeleteContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiDeleteContact
     */
    readonly id: string
}

/**
 * Request parameters for updateContact operation in ContactApi.
 * @export
 * @interface ContactApiUpdateContactRequest
 */
export interface ContactApiUpdateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiUpdateContact
     */
    readonly id: string

    /**
     * 
     * @type {ContactUpdateBody}
     * @memberof ContactApiUpdateContact
     */
    readonly contactUpdateBody: ContactUpdateBody
}

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
    /**
     * 
     * @summary Delete a contact
     * @param {ContactApiDeleteContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public deleteContact(requestParameters: ContactApiDeleteContactRequest, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).deleteContact(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing contact
     * @param {ContactApiUpdateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public updateContact(requestParameters: ContactApiUpdateContactRequest, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).updateContact(requestParameters.id, requestParameters.contactUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactFormApi - axios parameter creator
 * @export
 */
export const ContactFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Submit a contact form inquiry
         * @param {SubmitContactFormBody} submitContactFormBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitContactForm: async (submitContactFormBody: SubmitContactFormBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitContactFormBody' is not null or undefined
            assertParamExists('submitContactForm', 'submitContactFormBody', submitContactFormBody)
            const localVarPath = `/contact-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitContactFormBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactFormApi - functional programming interface
 * @export
 */
export const ContactFormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactFormApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Submit a contact form inquiry
         * @param {SubmitContactFormBody} submitContactFormBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitContactForm(submitContactFormBody: SubmitContactFormBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitContactForm(submitContactFormBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactFormApi.submitContactForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactFormApi - factory interface
 * @export
 */
export const ContactFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactFormApiFp(configuration)
    return {
        /**
         * 
         * @summary Submit a contact form inquiry
         * @param {ContactFormApiSubmitContactFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitContactForm(requestParameters: ContactFormApiSubmitContactFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitContactForm(requestParameters.submitContactFormBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for submitContactForm operation in ContactFormApi.
 * @export
 * @interface ContactFormApiSubmitContactFormRequest
 */
export interface ContactFormApiSubmitContactFormRequest {
    /**
     * 
     * @type {SubmitContactFormBody}
     * @memberof ContactFormApiSubmitContactForm
     */
    readonly submitContactFormBody: SubmitContactFormBody
}

/**
 * ContactFormApi - object-oriented interface
 * @export
 * @class ContactFormApi
 * @extends {BaseAPI}
 */
export class ContactFormApi extends BaseAPI {
    /**
     * 
     * @summary Submit a contact form inquiry
     * @param {ContactFormApiSubmitContactFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactFormApi
     */
    public submitContactForm(requestParameters: ContactFormApiSubmitContactFormRequest, options?: RawAxiosRequestConfig) {
        return ContactFormApiFp(this.configuration).submitContactForm(requestParameters.submitContactFormBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConversionApi - axios parameter creator
 * @export
 */
export const ConversionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary send a lead event to Meta
         * @param {LeadBody} leadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendLeadEvent: async (leadBody: LeadBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadBody' is not null or undefined
            assertParamExists('sendLeadEvent', 'leadBody', leadBody)
            const localVarPath = `/conversion/lead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send a page view event to Meta
         * @param {PageViewBody} pageViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPageViewEvent: async (pageViewBody: PageViewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageViewBody' is not null or undefined
            assertParamExists('sendPageViewEvent', 'pageViewBody', pageViewBody)
            const localVarPath = `/conversion/page-view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageViewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversionApi - functional programming interface
 * @export
 */
export const ConversionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary send a lead event to Meta
         * @param {LeadBody} leadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendLeadEvent(leadBody: LeadBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendLeadEvent(leadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversionApi.sendLeadEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary send a page view event to Meta
         * @param {PageViewBody} pageViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPageViewEvent(pageViewBody: PageViewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPageViewEvent(pageViewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversionApi.sendPageViewEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversionApi - factory interface
 * @export
 */
export const ConversionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversionApiFp(configuration)
    return {
        /**
         * 
         * @summary send a lead event to Meta
         * @param {ConversionApiSendLeadEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendLeadEvent(requestParameters: ConversionApiSendLeadEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendLeadEvent(requestParameters.leadBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send a page view event to Meta
         * @param {ConversionApiSendPageViewEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPageViewEvent(requestParameters: ConversionApiSendPageViewEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendPageViewEvent(requestParameters.pageViewBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sendLeadEvent operation in ConversionApi.
 * @export
 * @interface ConversionApiSendLeadEventRequest
 */
export interface ConversionApiSendLeadEventRequest {
    /**
     * 
     * @type {LeadBody}
     * @memberof ConversionApiSendLeadEvent
     */
    readonly leadBody: LeadBody
}

/**
 * Request parameters for sendPageViewEvent operation in ConversionApi.
 * @export
 * @interface ConversionApiSendPageViewEventRequest
 */
export interface ConversionApiSendPageViewEventRequest {
    /**
     * 
     * @type {PageViewBody}
     * @memberof ConversionApiSendPageViewEvent
     */
    readonly pageViewBody: PageViewBody
}

/**
 * ConversionApi - object-oriented interface
 * @export
 * @class ConversionApi
 * @extends {BaseAPI}
 */
export class ConversionApi extends BaseAPI {
    /**
     * 
     * @summary send a lead event to Meta
     * @param {ConversionApiSendLeadEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionApi
     */
    public sendLeadEvent(requestParameters: ConversionApiSendLeadEventRequest, options?: RawAxiosRequestConfig) {
        return ConversionApiFp(this.configuration).sendLeadEvent(requestParameters.leadBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send a page view event to Meta
     * @param {ConversionApiSendPageViewEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionApi
     */
    public sendPageViewEvent(requestParameters: ConversionApiSendPageViewEventRequest, options?: RawAxiosRequestConfig) {
        return ConversionApiFp(this.configuration).sendPageViewEvent(requestParameters.pageViewBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConversionRuleApi - axios parameter creator
 * @export
 */
export const ConversionRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary confirm a queued conversion rule, activating it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('confirm', 'id', id)
            const localVarPath = `/conversion-rules/{id}/confirm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary edit a queued conversion rule before confirming it
         * @param {string} id 
         * @param {EditRuleBody} editRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit: async (id: string, editRuleBody: EditRuleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edit', 'id', id)
            // verify required parameter 'editRuleBody' is not null or undefined
            assertParamExists('edit', 'editRuleBody', editRuleBody)
            const localVarPath = `/conversion-rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editRuleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list conversion rules, optionally filtered by status / field / type
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {ConversionRuleStatus} [status] 
         * @param {ConversionType} [type] 
         * @param {string} [field] 
         * @param {string} [sourceUnit] 
         * @param {string} [standardUnit] 
         * @param {string} [provenance] 
         * @param {string} [reviewedBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit?: number | null, offset?: number | null, status?: ConversionRuleStatus, type?: ConversionType, field?: string, sourceUnit?: string, standardUnit?: string, provenance?: string, reviewedBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/conversion-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (sourceUnit !== undefined) {
                localVarQueryParameter['sourceUnit'] = sourceUnit;
            }

            if (standardUnit !== undefined) {
                localVarQueryParameter['standardUnit'] = standardUnit;
            }

            if (provenance !== undefined) {
                localVarQueryParameter['provenance'] = provenance;
            }

            if (reviewedBy !== undefined) {
                localVarQueryParameter['reviewedBy'] = reviewedBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary propose a new conversion rule, queued for review unless it auto-accepts
         * @param {ProposeRuleBody} proposeRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        propose: async (proposeRuleBody: ProposeRuleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposeRuleBody' is not null or undefined
            assertParamExists('propose', 'proposeRuleBody', proposeRuleBody)
            const localVarPath = `/conversion-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proposeRuleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reject a queued conversion rule
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reject: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reject', 'id', id)
            const localVarPath = `/conversion-rules/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary supersede an active conversion rule with a corrected new version
         * @param {string} id 
         * @param {SupersedeRuleBody} supersedeRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supersede: async (id: string, supersedeRuleBody: SupersedeRuleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('supersede', 'id', id)
            // verify required parameter 'supersedeRuleBody' is not null or undefined
            assertParamExists('supersede', 'supersedeRuleBody', supersedeRuleBody)
            const localVarPath = `/conversion-rules/{id}/supersede`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supersedeRuleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversionRuleApi - functional programming interface
 * @export
 */
export const ConversionRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversionRuleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary confirm a queued conversion rule, activating it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirm(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversionRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirm(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversionRuleApi.confirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary edit a queued conversion rule before confirming it
         * @param {string} id 
         * @param {EditRuleBody} editRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edit(id: string, editRuleBody: EditRuleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversionRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edit(id, editRuleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversionRuleApi.edit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list conversion rules, optionally filtered by status / field / type
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {ConversionRuleStatus} [status] 
         * @param {ConversionType} [type] 
         * @param {string} [field] 
         * @param {string} [sourceUnit] 
         * @param {string} [standardUnit] 
         * @param {string} [provenance] 
         * @param {string} [reviewedBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit?: number | null, offset?: number | null, status?: ConversionRuleStatus, type?: ConversionType, field?: string, sourceUnit?: string, standardUnit?: string, provenance?: string, reviewedBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListConversionRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, status, type, field, sourceUnit, standardUnit, provenance, reviewedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversionRuleApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary propose a new conversion rule, queued for review unless it auto-accepts
         * @param {ProposeRuleBody} proposeRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async propose(proposeRuleBody: ProposeRuleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversionRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.propose(proposeRuleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversionRuleApi.propose']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reject a queued conversion rule
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reject(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversionRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reject(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversionRuleApi.reject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary supersede an active conversion rule with a corrected new version
         * @param {string} id 
         * @param {SupersedeRuleBody} supersedeRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supersede(id: string, supersedeRuleBody: SupersedeRuleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversionRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supersede(id, supersedeRuleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversionRuleApi.supersede']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversionRuleApi - factory interface
 * @export
 */
export const ConversionRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversionRuleApiFp(configuration)
    return {
        /**
         * 
         * @summary confirm a queued conversion rule, activating it
         * @param {ConversionRuleApiConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm(requestParameters: ConversionRuleApiConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversionRuleView> {
            return localVarFp.confirm(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary edit a queued conversion rule before confirming it
         * @param {ConversionRuleApiEditRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(requestParameters: ConversionRuleApiEditRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversionRuleView> {
            return localVarFp.edit(requestParameters.id, requestParameters.editRuleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list conversion rules, optionally filtered by status / field / type
         * @param {ConversionRuleApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: ConversionRuleApiListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListConversionRuleView> {
            return localVarFp.list(requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.type, requestParameters.field, requestParameters.sourceUnit, requestParameters.standardUnit, requestParameters.provenance, requestParameters.reviewedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary propose a new conversion rule, queued for review unless it auto-accepts
         * @param {ConversionRuleApiProposeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        propose(requestParameters: ConversionRuleApiProposeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversionRuleView> {
            return localVarFp.propose(requestParameters.proposeRuleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reject a queued conversion rule
         * @param {ConversionRuleApiRejectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reject(requestParameters: ConversionRuleApiRejectRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversionRuleView> {
            return localVarFp.reject(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary supersede an active conversion rule with a corrected new version
         * @param {ConversionRuleApiSupersedeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supersede(requestParameters: ConversionRuleApiSupersedeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversionRuleView> {
            return localVarFp.supersede(requestParameters.id, requestParameters.supersedeRuleBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for confirm operation in ConversionRuleApi.
 * @export
 * @interface ConversionRuleApiConfirmRequest
 */
export interface ConversionRuleApiConfirmRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiConfirm
     */
    readonly id: string
}

/**
 * Request parameters for edit operation in ConversionRuleApi.
 * @export
 * @interface ConversionRuleApiEditRequest
 */
export interface ConversionRuleApiEditRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiEdit
     */
    readonly id: string

    /**
     * 
     * @type {EditRuleBody}
     * @memberof ConversionRuleApiEdit
     */
    readonly editRuleBody: EditRuleBody
}

/**
 * Request parameters for list operation in ConversionRuleApi.
 * @export
 * @interface ConversionRuleApiListRequest
 */
export interface ConversionRuleApiListRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversionRuleApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof ConversionRuleApiList
     */
    readonly offset?: number | null

    /**
     * 
     * @type {ConversionRuleStatus}
     * @memberof ConversionRuleApiList
     */
    readonly status?: ConversionRuleStatus

    /**
     * 
     * @type {ConversionType}
     * @memberof ConversionRuleApiList
     */
    readonly type?: ConversionType

    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiList
     */
    readonly field?: string

    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiList
     */
    readonly sourceUnit?: string

    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiList
     */
    readonly standardUnit?: string

    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiList
     */
    readonly provenance?: string

    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiList
     */
    readonly reviewedBy?: string
}

/**
 * Request parameters for propose operation in ConversionRuleApi.
 * @export
 * @interface ConversionRuleApiProposeRequest
 */
export interface ConversionRuleApiProposeRequest {
    /**
     * 
     * @type {ProposeRuleBody}
     * @memberof ConversionRuleApiPropose
     */
    readonly proposeRuleBody: ProposeRuleBody
}

/**
 * Request parameters for reject operation in ConversionRuleApi.
 * @export
 * @interface ConversionRuleApiRejectRequest
 */
export interface ConversionRuleApiRejectRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiReject
     */
    readonly id: string
}

/**
 * Request parameters for supersede operation in ConversionRuleApi.
 * @export
 * @interface ConversionRuleApiSupersedeRequest
 */
export interface ConversionRuleApiSupersedeRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversionRuleApiSupersede
     */
    readonly id: string

    /**
     * 
     * @type {SupersedeRuleBody}
     * @memberof ConversionRuleApiSupersede
     */
    readonly supersedeRuleBody: SupersedeRuleBody
}

/**
 * ConversionRuleApi - object-oriented interface
 * @export
 * @class ConversionRuleApi
 * @extends {BaseAPI}
 */
export class ConversionRuleApi extends BaseAPI {
    /**
     * 
     * @summary confirm a queued conversion rule, activating it
     * @param {ConversionRuleApiConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionRuleApi
     */
    public confirm(requestParameters: ConversionRuleApiConfirmRequest, options?: RawAxiosRequestConfig) {
        return ConversionRuleApiFp(this.configuration).confirm(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary edit a queued conversion rule before confirming it
     * @param {ConversionRuleApiEditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionRuleApi
     */
    public edit(requestParameters: ConversionRuleApiEditRequest, options?: RawAxiosRequestConfig) {
        return ConversionRuleApiFp(this.configuration).edit(requestParameters.id, requestParameters.editRuleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list conversion rules, optionally filtered by status / field / type
     * @param {ConversionRuleApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionRuleApi
     */
    public list(requestParameters: ConversionRuleApiListRequest = {}, options?: RawAxiosRequestConfig) {
        return ConversionRuleApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.type, requestParameters.field, requestParameters.sourceUnit, requestParameters.standardUnit, requestParameters.provenance, requestParameters.reviewedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary propose a new conversion rule, queued for review unless it auto-accepts
     * @param {ConversionRuleApiProposeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionRuleApi
     */
    public propose(requestParameters: ConversionRuleApiProposeRequest, options?: RawAxiosRequestConfig) {
        return ConversionRuleApiFp(this.configuration).propose(requestParameters.proposeRuleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reject a queued conversion rule
     * @param {ConversionRuleApiRejectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionRuleApi
     */
    public reject(requestParameters: ConversionRuleApiRejectRequest, options?: RawAxiosRequestConfig) {
        return ConversionRuleApiFp(this.configuration).reject(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary supersede an active conversion rule with a corrected new version
     * @param {ConversionRuleApiSupersedeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionRuleApi
     */
    public supersede(requestParameters: ConversionRuleApiSupersedeRequest, options?: RawAxiosRequestConfig) {
        return ConversionRuleApiFp(this.configuration).supersede(requestParameters.id, requestParameters.supersedeRuleBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CriteriaApi - axios parameter creator
 * @export
 */
export const CriteriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add a comment to a criteria
         * @param {string} id 
         * @param {CriteriaCommentBody} criteriaCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment: async (id: string, criteriaCommentBody: CriteriaCommentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createComment', 'id', id)
            // verify required parameter 'criteriaCommentBody' is not null or undefined
            assertParamExists('createComment', 'criteriaCommentBody', criteriaCommentBody)
            const localVarPath = `/criteria/{id}/comment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaCommentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a feedback to a criteria
         * @param {string} id 
         * @param {CriteriaFeedbackBody} criteriaFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeedback: async (id: string, criteriaFeedbackBody: CriteriaFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFeedback', 'id', id)
            // verify required parameter 'criteriaFeedbackBody' is not null or undefined
            assertParamExists('createFeedback', 'criteriaFeedbackBody', criteriaFeedbackBody)
            const localVarPath = `/criteria/{id}/feedback`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary soft delete a criteria, it will be restorable for 30 days
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCriteria: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCriteria', 'id', id)
            const localVarPath = `/criteria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActivity', 'id', id)
            const localVarPath = `/criteria/{id}/activity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change the position of a criteria
         * @param {string} id 
         * @param {CriteriaMoveBody} criteriaMoveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCriteria: async (id: string, criteriaMoveBody: CriteriaMoveBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveCriteria', 'id', id)
            // verify required parameter 'criteriaMoveBody' is not null or undefined
            assertParamExists('moveCriteria', 'criteriaMoveBody', criteriaMoveBody)
            const localVarPath = `/criteria/{id}/move`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaMoveBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary restore a deleted criteria
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreCriteria: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreCriteria', 'id', id)
            const localVarPath = `/criteria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change any of the properties of a criteria
         * @param {string} id 
         * @param {CriteriaUpdateBody} criteriaUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCriteria: async (id: string, criteriaUpdateBody: CriteriaUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCriteria', 'id', id)
            // verify required parameter 'criteriaUpdateBody' is not null or undefined
            assertParamExists('updateCriteria', 'criteriaUpdateBody', criteriaUpdateBody)
            const localVarPath = `/criteria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CriteriaApi - functional programming interface
 * @export
 */
export const CriteriaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CriteriaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add a comment to a criteria
         * @param {string} id 
         * @param {CriteriaCommentBody} criteriaCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComment(id: string, criteriaCommentBody: CriteriaCommentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComment(id, criteriaCommentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.createComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a feedback to a criteria
         * @param {string} id 
         * @param {CriteriaFeedbackBody} criteriaFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFeedback(id: string, criteriaFeedbackBody: CriteriaFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFeedback(id, criteriaFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.createFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary soft delete a criteria, it will be restorable for 30 days
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCriteria(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCriteria(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.deleteCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivity(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCriteriaActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivity(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.getActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary change the position of a criteria
         * @param {string} id 
         * @param {CriteriaMoveBody} criteriaMoveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveCriteria(id: string, criteriaMoveBody: CriteriaMoveBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveCriteria(id, criteriaMoveBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.moveCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary restore a deleted criteria
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreCriteria(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreCriteria(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.restoreCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary change any of the properties of a criteria
         * @param {string} id 
         * @param {CriteriaUpdateBody} criteriaUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCriteria(id: string, criteriaUpdateBody: CriteriaUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCriteria(id, criteriaUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.updateCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CriteriaApi - factory interface
 * @export
 */
export const CriteriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CriteriaApiFp(configuration)
    return {
        /**
         * 
         * @summary add a comment to a criteria
         * @param {CriteriaApiCreateCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(requestParameters: CriteriaApiCreateCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createComment(requestParameters.id, requestParameters.criteriaCommentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a feedback to a criteria
         * @param {CriteriaApiCreateFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeedback(requestParameters: CriteriaApiCreateFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createFeedback(requestParameters.id, requestParameters.criteriaFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary soft delete a criteria, it will be restorable for 30 days
         * @param {CriteriaApiDeleteCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCriteria(requestParameters: CriteriaApiDeleteCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCriteria(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {CriteriaApiGetActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(requestParameters: CriteriaApiGetActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCriteriaActivityView> {
            return localVarFp.getActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change the position of a criteria
         * @param {CriteriaApiMoveCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCriteria(requestParameters: CriteriaApiMoveCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveCriteria(requestParameters.id, requestParameters.criteriaMoveBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary restore a deleted criteria
         * @param {CriteriaApiRestoreCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreCriteria(requestParameters: CriteriaApiRestoreCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreCriteria(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change any of the properties of a criteria
         * @param {CriteriaApiUpdateCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCriteria(requestParameters: CriteriaApiUpdateCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCriteria(requestParameters.id, requestParameters.criteriaUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createComment operation in CriteriaApi.
 * @export
 * @interface CriteriaApiCreateCommentRequest
 */
export interface CriteriaApiCreateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiCreateComment
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaCommentBody}
     * @memberof CriteriaApiCreateComment
     */
    readonly criteriaCommentBody: CriteriaCommentBody
}

/**
 * Request parameters for createFeedback operation in CriteriaApi.
 * @export
 * @interface CriteriaApiCreateFeedbackRequest
 */
export interface CriteriaApiCreateFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiCreateFeedback
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaFeedbackBody}
     * @memberof CriteriaApiCreateFeedback
     */
    readonly criteriaFeedbackBody: CriteriaFeedbackBody
}

/**
 * Request parameters for deleteCriteria operation in CriteriaApi.
 * @export
 * @interface CriteriaApiDeleteCriteriaRequest
 */
export interface CriteriaApiDeleteCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiDeleteCriteria
     */
    readonly id: string
}

/**
 * Request parameters for getActivity operation in CriteriaApi.
 * @export
 * @interface CriteriaApiGetActivityRequest
 */
export interface CriteriaApiGetActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiGetActivity
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof CriteriaApiGetActivity
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof CriteriaApiGetActivity
     */
    readonly offset?: number | null
}

/**
 * Request parameters for moveCriteria operation in CriteriaApi.
 * @export
 * @interface CriteriaApiMoveCriteriaRequest
 */
export interface CriteriaApiMoveCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiMoveCriteria
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaMoveBody}
     * @memberof CriteriaApiMoveCriteria
     */
    readonly criteriaMoveBody: CriteriaMoveBody
}

/**
 * Request parameters for restoreCriteria operation in CriteriaApi.
 * @export
 * @interface CriteriaApiRestoreCriteriaRequest
 */
export interface CriteriaApiRestoreCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiRestoreCriteria
     */
    readonly id: string
}

/**
 * Request parameters for updateCriteria operation in CriteriaApi.
 * @export
 * @interface CriteriaApiUpdateCriteriaRequest
 */
export interface CriteriaApiUpdateCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiUpdateCriteria
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaUpdateBody}
     * @memberof CriteriaApiUpdateCriteria
     */
    readonly criteriaUpdateBody: CriteriaUpdateBody
}

/**
 * CriteriaApi - object-oriented interface
 * @export
 * @class CriteriaApi
 * @extends {BaseAPI}
 */
export class CriteriaApi extends BaseAPI {
    /**
     * 
     * @summary add a comment to a criteria
     * @param {CriteriaApiCreateCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public createComment(requestParameters: CriteriaApiCreateCommentRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).createComment(requestParameters.id, requestParameters.criteriaCommentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a feedback to a criteria
     * @param {CriteriaApiCreateFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public createFeedback(requestParameters: CriteriaApiCreateFeedbackRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).createFeedback(requestParameters.id, requestParameters.criteriaFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary soft delete a criteria, it will be restorable for 30 days
     * @param {CriteriaApiDeleteCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public deleteCriteria(requestParameters: CriteriaApiDeleteCriteriaRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).deleteCriteria(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch paginated activity log of a criteria
     * @param {CriteriaApiGetActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public getActivity(requestParameters: CriteriaApiGetActivityRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).getActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change the position of a criteria
     * @param {CriteriaApiMoveCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public moveCriteria(requestParameters: CriteriaApiMoveCriteriaRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).moveCriteria(requestParameters.id, requestParameters.criteriaMoveBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary restore a deleted criteria
     * @param {CriteriaApiRestoreCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public restoreCriteria(requestParameters: CriteriaApiRestoreCriteriaRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).restoreCriteria(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change any of the properties of a criteria
     * @param {CriteriaApiUpdateCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public updateCriteria(requestParameters: CriteriaApiUpdateCriteriaRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).updateCriteria(requestParameters.id, requestParameters.criteriaUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DelayIndexApi - axios parameter creator
 * @export
 */
export const DelayIndexApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get the clinical trial delay index for a specific month
         * @param {number} month 
         * @param {number} year 
         * @param {Array<string>} [countriesFilter] 
         * @param {string} [icdCategoryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndex: async (month: number, year: number, countriesFilter?: Array<string>, icdCategoryFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getDelayIndex', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getDelayIndex', 'year', year)
            const localVarPath = `/delay-index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (countriesFilter) {
                localVarQueryParameter['countriesFilter'] = countriesFilter;
            }

            if (icdCategoryFilter !== undefined) {
                localVarQueryParameter['icdCategoryFilter'] = icdCategoryFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per country
         * @param {number} month 
         * @param {number} year 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [icdCategoryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndexPerCountry: async (month: number, year: number, limit?: number | null, offset?: number | null, icdCategoryFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getDelayIndexPerCountry', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getDelayIndexPerCountry', 'year', year)
            const localVarPath = `/delay-index/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (icdCategoryFilter !== undefined) {
                localVarQueryParameter['icdCategoryFilter'] = icdCategoryFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per disease
         * @param {number} month 
         * @param {number} year 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {Array<string>} [countriesFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndexPerDisease: async (month: number, year: number, limit?: number | null, offset?: number | null, countriesFilter?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getDelayIndexPerDisease', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getDelayIndexPerDisease', 'year', year)
            const localVarPath = `/delay-index/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (countriesFilter) {
                localVarQueryParameter['countriesFilter'] = countriesFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DelayIndexApi - functional programming interface
 * @export
 */
export const DelayIndexApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DelayIndexApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get the clinical trial delay index for a specific month
         * @param {number} month 
         * @param {number} year 
         * @param {Array<string>} [countriesFilter] 
         * @param {string} [icdCategoryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelayIndex(month: number, year: number, countriesFilter?: Array<string>, icdCategoryFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DelayIndexView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelayIndex(month, year, countriesFilter, icdCategoryFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DelayIndexApi.getDelayIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per country
         * @param {number} month 
         * @param {number} year 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [icdCategoryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelayIndexPerCountry(month: number, year: number, limit?: number | null, offset?: number | null, icdCategoryFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListLabeledDelayItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelayIndexPerCountry(month, year, limit, offset, icdCategoryFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DelayIndexApi.getDelayIndexPerCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per disease
         * @param {number} month 
         * @param {number} year 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {Array<string>} [countriesFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelayIndexPerDisease(month: number, year: number, limit?: number | null, offset?: number | null, countriesFilter?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListLabeledDelayItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelayIndexPerDisease(month, year, limit, offset, countriesFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DelayIndexApi.getDelayIndexPerDisease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DelayIndexApi - factory interface
 * @export
 */
export const DelayIndexApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DelayIndexApiFp(configuration)
    return {
        /**
         * 
         * @summary get the clinical trial delay index for a specific month
         * @param {DelayIndexApiGetDelayIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndex(requestParameters: DelayIndexApiGetDelayIndexRequest, options?: RawAxiosRequestConfig): AxiosPromise<DelayIndexView> {
            return localVarFp.getDelayIndex(requestParameters.month, requestParameters.year, requestParameters.countriesFilter, requestParameters.icdCategoryFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per country
         * @param {DelayIndexApiGetDelayIndexPerCountryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndexPerCountry(requestParameters: DelayIndexApiGetDelayIndexPerCountryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListLabeledDelayItem> {
            return localVarFp.getDelayIndexPerCountry(requestParameters.month, requestParameters.year, requestParameters.limit, requestParameters.offset, requestParameters.icdCategoryFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per disease
         * @param {DelayIndexApiGetDelayIndexPerDiseaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndexPerDisease(requestParameters: DelayIndexApiGetDelayIndexPerDiseaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListLabeledDelayItem> {
            return localVarFp.getDelayIndexPerDisease(requestParameters.month, requestParameters.year, requestParameters.limit, requestParameters.offset, requestParameters.countriesFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDelayIndex operation in DelayIndexApi.
 * @export
 * @interface DelayIndexApiGetDelayIndexRequest
 */
export interface DelayIndexApiGetDelayIndexRequest {
    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndex
     */
    readonly month: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndex
     */
    readonly year: number

    /**
     * 
     * @type {Array<string>}
     * @memberof DelayIndexApiGetDelayIndex
     */
    readonly countriesFilter?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof DelayIndexApiGetDelayIndex
     */
    readonly icdCategoryFilter?: string
}

/**
 * Request parameters for getDelayIndexPerCountry operation in DelayIndexApi.
 * @export
 * @interface DelayIndexApiGetDelayIndexPerCountryRequest
 */
export interface DelayIndexApiGetDelayIndexPerCountryRequest {
    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly month: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly year: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly icdCategoryFilter?: string
}

/**
 * Request parameters for getDelayIndexPerDisease operation in DelayIndexApi.
 * @export
 * @interface DelayIndexApiGetDelayIndexPerDiseaseRequest
 */
export interface DelayIndexApiGetDelayIndexPerDiseaseRequest {
    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly month: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly year: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly offset?: number | null

    /**
     * 
     * @type {Array<string>}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly countriesFilter?: Array<string>
}

/**
 * DelayIndexApi - object-oriented interface
 * @export
 * @class DelayIndexApi
 * @extends {BaseAPI}
 */
export class DelayIndexApi extends BaseAPI {
    /**
     * 
     * @summary get the clinical trial delay index for a specific month
     * @param {DelayIndexApiGetDelayIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DelayIndexApi
     */
    public getDelayIndex(requestParameters: DelayIndexApiGetDelayIndexRequest, options?: RawAxiosRequestConfig) {
        return DelayIndexApiFp(this.configuration).getDelayIndex(requestParameters.month, requestParameters.year, requestParameters.countriesFilter, requestParameters.icdCategoryFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the clinical trial delay index for a specific month per country
     * @param {DelayIndexApiGetDelayIndexPerCountryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DelayIndexApi
     */
    public getDelayIndexPerCountry(requestParameters: DelayIndexApiGetDelayIndexPerCountryRequest, options?: RawAxiosRequestConfig) {
        return DelayIndexApiFp(this.configuration).getDelayIndexPerCountry(requestParameters.month, requestParameters.year, requestParameters.limit, requestParameters.offset, requestParameters.icdCategoryFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the clinical trial delay index for a specific month per disease
     * @param {DelayIndexApiGetDelayIndexPerDiseaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DelayIndexApi
     */
    public getDelayIndexPerDisease(requestParameters: DelayIndexApiGetDelayIndexPerDiseaseRequest, options?: RawAxiosRequestConfig) {
        return DelayIndexApiFp(this.configuration).getDelayIndexPerDisease(requestParameters.month, requestParameters.year, requestParameters.limit, requestParameters.offset, requestParameters.countriesFilter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DependencyApi - axios parameter creator
 * @export
 */
export const DependencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a dependency
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDependency: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDependency', 'id', id)
            const localVarPath = `/dependency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes one page of users. Call again with `after = nextCursor` until `nextCursor` is null.
         * @summary Fix missing user attributes for a dependency
         * @param {string} id 
         * @param {string} [after] The &#x60;nextCursor&#x60; of the previous call. User ids are not uuids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixDependency: async (id: string, after?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fixDependency', 'id', id)
            const localVarPath = `/dependency/{id}/fix`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing dependency
         * @param {string} id 
         * @param {DependencyUpdateBody} dependencyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependency: async (id: string, dependencyUpdateBody: DependencyUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDependency', 'id', id)
            // verify required parameter 'dependencyUpdateBody' is not null or undefined
            assertParamExists('updateDependency', 'dependencyUpdateBody', dependencyUpdateBody)
            const localVarPath = `/dependency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dependencyUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DependencyApi - functional programming interface
 * @export
 */
export const DependencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DependencyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a dependency
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDependency(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDependency(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DependencyApi.deleteDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes one page of users. Call again with `after = nextCursor` until `nextCursor` is null.
         * @summary Fix missing user attributes for a dependency
         * @param {string} id 
         * @param {string} [after] The &#x60;nextCursor&#x60; of the previous call. User ids are not uuids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fixDependency(id: string, after?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DependencyFixView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fixDependency(id, after, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DependencyApi.fixDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing dependency
         * @param {string} id 
         * @param {DependencyUpdateBody} dependencyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDependency(id: string, dependencyUpdateBody: DependencyUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDependency(id, dependencyUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DependencyApi.updateDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DependencyApi - factory interface
 * @export
 */
export const DependencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DependencyApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a dependency
         * @param {DependencyApiDeleteDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDependency(requestParameters: DependencyApiDeleteDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDependency(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes one page of users. Call again with `after = nextCursor` until `nextCursor` is null.
         * @summary Fix missing user attributes for a dependency
         * @param {DependencyApiFixDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixDependency(requestParameters: DependencyApiFixDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<DependencyFixView> {
            return localVarFp.fixDependency(requestParameters.id, requestParameters.after, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing dependency
         * @param {DependencyApiUpdateDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependency(requestParameters: DependencyApiUpdateDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDependency(requestParameters.id, requestParameters.dependencyUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDependency operation in DependencyApi.
 * @export
 * @interface DependencyApiDeleteDependencyRequest
 */
export interface DependencyApiDeleteDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof DependencyApiDeleteDependency
     */
    readonly id: string
}

/**
 * Request parameters for fixDependency operation in DependencyApi.
 * @export
 * @interface DependencyApiFixDependencyRequest
 */
export interface DependencyApiFixDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof DependencyApiFixDependency
     */
    readonly id: string

    /**
     * The &#x60;nextCursor&#x60; of the previous call. User ids are not uuids.
     * @type {string}
     * @memberof DependencyApiFixDependency
     */
    readonly after?: string
}

/**
 * Request parameters for updateDependency operation in DependencyApi.
 * @export
 * @interface DependencyApiUpdateDependencyRequest
 */
export interface DependencyApiUpdateDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof DependencyApiUpdateDependency
     */
    readonly id: string

    /**
     * 
     * @type {DependencyUpdateBody}
     * @memberof DependencyApiUpdateDependency
     */
    readonly dependencyUpdateBody: DependencyUpdateBody
}

/**
 * DependencyApi - object-oriented interface
 * @export
 * @class DependencyApi
 * @extends {BaseAPI}
 */
export class DependencyApi extends BaseAPI {
    /**
     * 
     * @summary Delete a dependency
     * @param {DependencyApiDeleteDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DependencyApi
     */
    public deleteDependency(requestParameters: DependencyApiDeleteDependencyRequest, options?: RawAxiosRequestConfig) {
        return DependencyApiFp(this.configuration).deleteDependency(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes one page of users. Call again with `after = nextCursor` until `nextCursor` is null.
     * @summary Fix missing user attributes for a dependency
     * @param {DependencyApiFixDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DependencyApi
     */
    public fixDependency(requestParameters: DependencyApiFixDependencyRequest, options?: RawAxiosRequestConfig) {
        return DependencyApiFp(this.configuration).fixDependency(requestParameters.id, requestParameters.after, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing dependency
     * @param {DependencyApiUpdateDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DependencyApi
     */
    public updateDependency(requestParameters: DependencyApiUpdateDependencyRequest, options?: RawAxiosRequestConfig) {
        return DependencyApiFp(this.configuration).updateDependency(requestParameters.id, requestParameters.dependencyUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DependencyProposalsApi - axios parameter creator
 * @export
 */
export const DependencyProposalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve (creates the dependency) or reject an AI-proposed dependency
         * @param {string} id 
         * @param {DependencyProposalReviewBody} dependencyProposalReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewDependencyProposal: async (id: string, dependencyProposalReviewBody: DependencyProposalReviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reviewDependencyProposal', 'id', id)
            // verify required parameter 'dependencyProposalReviewBody' is not null or undefined
            assertParamExists('reviewDependencyProposal', 'dependencyProposalReviewBody', dependencyProposalReviewBody)
            const localVarPath = `/dependency-proposals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dependencyProposalReviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DependencyProposalsApi - functional programming interface
 * @export
 */
export const DependencyProposalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DependencyProposalsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve (creates the dependency) or reject an AI-proposed dependency
         * @param {string} id 
         * @param {DependencyProposalReviewBody} dependencyProposalReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewDependencyProposal(id: string, dependencyProposalReviewBody: DependencyProposalReviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewDependencyProposal(id, dependencyProposalReviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DependencyProposalsApi.reviewDependencyProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DependencyProposalsApi - factory interface
 * @export
 */
export const DependencyProposalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DependencyProposalsApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve (creates the dependency) or reject an AI-proposed dependency
         * @param {DependencyProposalsApiReviewDependencyProposalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewDependencyProposal(requestParameters: DependencyProposalsApiReviewDependencyProposalRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reviewDependencyProposal(requestParameters.id, requestParameters.dependencyProposalReviewBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reviewDependencyProposal operation in DependencyProposalsApi.
 * @export
 * @interface DependencyProposalsApiReviewDependencyProposalRequest
 */
export interface DependencyProposalsApiReviewDependencyProposalRequest {
    /**
     * 
     * @type {string}
     * @memberof DependencyProposalsApiReviewDependencyProposal
     */
    readonly id: string

    /**
     * 
     * @type {DependencyProposalReviewBody}
     * @memberof DependencyProposalsApiReviewDependencyProposal
     */
    readonly dependencyProposalReviewBody: DependencyProposalReviewBody
}

/**
 * DependencyProposalsApi - object-oriented interface
 * @export
 * @class DependencyProposalsApi
 * @extends {BaseAPI}
 */
export class DependencyProposalsApi extends BaseAPI {
    /**
     * 
     * @summary Approve (creates the dependency) or reject an AI-proposed dependency
     * @param {DependencyProposalsApiReviewDependencyProposalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DependencyProposalsApi
     */
    public reviewDependencyProposal(requestParameters: DependencyProposalsApiReviewDependencyProposalRequest, options?: RawAxiosRequestConfig) {
        return DependencyProposalsApiFp(this.configuration).reviewDependencyProposal(requestParameters.id, requestParameters.dependencyProposalReviewBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiseasesApi - axios parameter creator
 * @export
 */
export const DiseasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a new disease
         * @param {DiseaseCreateBody} diseaseCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDisease: async (diseaseCreateBody: DiseaseCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'diseaseCreateBody' is not null or undefined
            assertParamExists('createDisease', 'diseaseCreateBody', diseaseCreateBody)
            const localVarPath = `/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diseaseCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a name to an icd code
         * @param {string} id 
         * @param {DiseaseNameCreate} diseaseNameCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIcdDiseaseName: async (id: string, diseaseNameCreate: DiseaseNameCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createIcdDiseaseName', 'id', id)
            // verify required parameter 'diseaseNameCreate' is not null or undefined
            assertParamExists('createIcdDiseaseName', 'diseaseNameCreate', diseaseNameCreate)
            const localVarPath = `/diseases/icd/{id}/names`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diseaseNameCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a disease name
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiseaseName: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDiseaseName', 'id', id)
            const localVarPath = `/diseases/names/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all disease names in the platform
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {boolean} [exactMatch] 
         * @param {string} [countryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseases: async (language: Language, limit?: number | null, offset?: number | null, searchString?: string, exactMatch?: boolean, countryFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getDiseases', 'language', language)
            const localVarPath = `/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exactMatch'] = exactMatch;
            }

            if (countryFilter !== undefined) {
                localVarQueryParameter['countryFilter'] = countryFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get trials count of selected diseases for a specific country
         * @param {string} countryFilter 
         * @param {Array<string>} icdCodes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseasesTrialsCount: async (countryFilter: string, icdCodes: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryFilter' is not null or undefined
            assertParamExists('getDiseasesTrialsCount', 'countryFilter', countryFilter)
            // verify required parameter 'icdCodes' is not null or undefined
            assertParamExists('getDiseasesTrialsCount', 'icdCodes', icdCodes)
            const localVarPath = `/diseases/trials-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryFilter !== undefined) {
                localVarQueryParameter['countryFilter'] = countryFilter;
            }

            if (icdCodes) {
                localVarQueryParameter['icdCodes'] = icdCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get diseases with category and parent category using embedding search
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseasesV2: async (language: Language, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getDiseasesV2', 'language', language)
            const localVarPath = `/diseases/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all names of an icd code in the platform
         * @param {Language} language 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseaseNames: async (language: Language, id: string, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getIcdDiseaseNames', 'language', language)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIcdDiseaseNames', 'id', id)
            const localVarPath = `/diseases/icd/{id}/names`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all translations of an icd code in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseaseTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIcdDiseaseTranslations', 'id', id)
            const localVarPath = `/diseases/icd/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all icd codes in the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseases: async (limit?: number | null, offset?: number | null, searchString?: string, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/diseases/icd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exactMatch'] = exactMatch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a disease name
         * @param {string} id 
         * @param {DiseaseNameUpdateQuery} diseaseNameUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiseaseName: async (id: string, diseaseNameUpdateQuery: DiseaseNameUpdateQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDiseaseName', 'id', id)
            // verify required parameter 'diseaseNameUpdateQuery' is not null or undefined
            assertParamExists('updateDiseaseName', 'diseaseNameUpdateQuery', diseaseNameUpdateQuery)
            const localVarPath = `/diseases/names/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diseaseNameUpdateQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the translations of an icd code in the platform
         * @param {string} id 
         * @param {DiseaseTranslationsBody} diseaseTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertIcdDiseaseTranslations: async (id: string, diseaseTranslationsBody: DiseaseTranslationsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertIcdDiseaseTranslations', 'id', id)
            // verify required parameter 'diseaseTranslationsBody' is not null or undefined
            assertParamExists('upsertIcdDiseaseTranslations', 'diseaseTranslationsBody', diseaseTranslationsBody)
            const localVarPath = `/diseases/icd/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diseaseTranslationsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiseasesApi - functional programming interface
 * @export
 */
export const DiseasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiseasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create a new disease
         * @param {DiseaseCreateBody} diseaseCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDisease(diseaseCreateBody: DiseaseCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseCreateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDisease(diseaseCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.createDisease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a name to an icd code
         * @param {string} id 
         * @param {DiseaseNameCreate} diseaseNameCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIcdDiseaseName(id: string, diseaseNameCreate: DiseaseNameCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIcdDiseaseName(id, diseaseNameCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.createIcdDiseaseName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a disease name
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDiseaseName(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDiseaseName(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.deleteDiseaseName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all disease names in the platform
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {boolean} [exactMatch] 
         * @param {string} [countryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiseases(language: Language, limit?: number | null, offset?: number | null, searchString?: string, exactMatch?: boolean, countryFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiseases(language, limit, offset, searchString, exactMatch, countryFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getDiseases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get trials count of selected diseases for a specific country
         * @param {string} countryFilter 
         * @param {Array<string>} icdCodes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiseasesTrialsCount(countryFilter: string, icdCodes: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseTrialsCountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiseasesTrialsCount(countryFilter, icdCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getDiseasesTrialsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get diseases with category and parent category using embedding search
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiseasesV2(language: Language, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseV2View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiseasesV2(language, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getDiseasesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all names of an icd code in the platform
         * @param {Language} language 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIcdDiseaseNames(language: Language, id: string, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIcdDiseaseNames(language, id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getIcdDiseaseNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all translations of an icd code in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIcdDiseaseTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIcdDiseaseTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getIcdDiseaseTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all icd codes in the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIcdDiseases(limit?: number | null, offset?: number | null, searchString?: string, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListIcdDiseaseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIcdDiseases(limit, offset, searchString, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getIcdDiseases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a disease name
         * @param {string} id 
         * @param {DiseaseNameUpdateQuery} diseaseNameUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDiseaseName(id: string, diseaseNameUpdateQuery: DiseaseNameUpdateQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDiseaseName(id, diseaseNameUpdateQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.updateDiseaseName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the translations of an icd code in the platform
         * @param {string} id 
         * @param {DiseaseTranslationsBody} diseaseTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertIcdDiseaseTranslations(id: string, diseaseTranslationsBody: DiseaseTranslationsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertIcdDiseaseTranslations(id, diseaseTranslationsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.upsertIcdDiseaseTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiseasesApi - factory interface
 * @export
 */
export const DiseasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiseasesApiFp(configuration)
    return {
        /**
         * 
         * @summary create a new disease
         * @param {DiseasesApiCreateDiseaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDisease(requestParameters: DiseasesApiCreateDiseaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiseaseCreateView> {
            return localVarFp.createDisease(requestParameters.diseaseCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a name to an icd code
         * @param {DiseasesApiCreateIcdDiseaseNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIcdDiseaseName(requestParameters: DiseasesApiCreateIcdDiseaseNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiseaseView> {
            return localVarFp.createIcdDiseaseName(requestParameters.id, requestParameters.diseaseNameCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a disease name
         * @param {DiseasesApiDeleteDiseaseNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiseaseName(requestParameters: DiseasesApiDeleteDiseaseNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDiseaseName(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all disease names in the platform
         * @param {DiseasesApiGetDiseasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseases(requestParameters: DiseasesApiGetDiseasesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseView> {
            return localVarFp.getDiseases(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.exactMatch, requestParameters.countryFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get trials count of selected diseases for a specific country
         * @param {DiseasesApiGetDiseasesTrialsCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseasesTrialsCount(requestParameters: DiseasesApiGetDiseasesTrialsCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiseaseTrialsCountView> {
            return localVarFp.getDiseasesTrialsCount(requestParameters.countryFilter, requestParameters.icdCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get diseases with category and parent category using embedding search
         * @param {DiseasesApiGetDiseasesV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseasesV2(requestParameters: DiseasesApiGetDiseasesV2Request, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseV2View> {
            return localVarFp.getDiseasesV2(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all names of an icd code in the platform
         * @param {DiseasesApiGetIcdDiseaseNamesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseaseNames(requestParameters: DiseasesApiGetIcdDiseaseNamesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseNameView> {
            return localVarFp.getIcdDiseaseNames(requestParameters.language, requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all translations of an icd code in the platform
         * @param {DiseasesApiGetIcdDiseaseTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseaseTranslations(requestParameters: DiseasesApiGetIcdDiseaseTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseTranslationView> {
            return localVarFp.getIcdDiseaseTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all icd codes in the platform
         * @param {DiseasesApiGetIcdDiseasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseases(requestParameters: DiseasesApiGetIcdDiseasesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListIcdDiseaseView> {
            return localVarFp.getIcdDiseases(requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a disease name
         * @param {DiseasesApiUpdateDiseaseNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiseaseName(requestParameters: DiseasesApiUpdateDiseaseNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiseaseNameView> {
            return localVarFp.updateDiseaseName(requestParameters.id, requestParameters.diseaseNameUpdateQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the translations of an icd code in the platform
         * @param {DiseasesApiUpsertIcdDiseaseTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertIcdDiseaseTranslations(requestParameters: DiseasesApiUpsertIcdDiseaseTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseTranslationView> {
            return localVarFp.upsertIcdDiseaseTranslations(requestParameters.id, requestParameters.diseaseTranslationsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDisease operation in DiseasesApi.
 * @export
 * @interface DiseasesApiCreateDiseaseRequest
 */
export interface DiseasesApiCreateDiseaseRequest {
    /**
     * 
     * @type {DiseaseCreateBody}
     * @memberof DiseasesApiCreateDisease
     */
    readonly diseaseCreateBody: DiseaseCreateBody
}

/**
 * Request parameters for createIcdDiseaseName operation in DiseasesApi.
 * @export
 * @interface DiseasesApiCreateIcdDiseaseNameRequest
 */
export interface DiseasesApiCreateIcdDiseaseNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiCreateIcdDiseaseName
     */
    readonly id: string

    /**
     * 
     * @type {DiseaseNameCreate}
     * @memberof DiseasesApiCreateIcdDiseaseName
     */
    readonly diseaseNameCreate: DiseaseNameCreate
}

/**
 * Request parameters for deleteDiseaseName operation in DiseasesApi.
 * @export
 * @interface DiseasesApiDeleteDiseaseNameRequest
 */
export interface DiseasesApiDeleteDiseaseNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiDeleteDiseaseName
     */
    readonly id: string
}

/**
 * Request parameters for getDiseases operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetDiseasesRequest
 */
export interface DiseasesApiGetDiseasesRequest {
    /**
     * 
     * @type {Language}
     * @memberof DiseasesApiGetDiseases
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetDiseases
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetDiseases
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetDiseases
     */
    readonly searchString?: string

    /**
     * 
     * @type {boolean}
     * @memberof DiseasesApiGetDiseases
     */
    readonly exactMatch?: boolean

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetDiseases
     */
    readonly countryFilter?: string
}

/**
 * Request parameters for getDiseasesTrialsCount operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetDiseasesTrialsCountRequest
 */
export interface DiseasesApiGetDiseasesTrialsCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetDiseasesTrialsCount
     */
    readonly countryFilter: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DiseasesApiGetDiseasesTrialsCount
     */
    readonly icdCodes: Array<string>
}

/**
 * Request parameters for getDiseasesV2 operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetDiseasesV2Request
 */
export interface DiseasesApiGetDiseasesV2Request {
    /**
     * 
     * @type {Language}
     * @memberof DiseasesApiGetDiseasesV2
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetDiseasesV2
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetDiseasesV2
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetDiseasesV2
     */
    readonly searchString?: string
}

/**
 * Request parameters for getIcdDiseaseNames operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetIcdDiseaseNamesRequest
 */
export interface DiseasesApiGetIcdDiseaseNamesRequest {
    /**
     * 
     * @type {Language}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly language: Language

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly searchString?: string
}

/**
 * Request parameters for getIcdDiseaseTranslations operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetIcdDiseaseTranslationsRequest
 */
export interface DiseasesApiGetIcdDiseaseTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetIcdDiseaseTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getIcdDiseases operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetIcdDiseasesRequest
 */
export interface DiseasesApiGetIcdDiseasesRequest {
    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetIcdDiseases
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetIcdDiseases
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetIcdDiseases
     */
    readonly searchString?: string

    /**
     * 
     * @type {boolean}
     * @memberof DiseasesApiGetIcdDiseases
     */
    readonly exactMatch?: boolean
}

/**
 * Request parameters for updateDiseaseName operation in DiseasesApi.
 * @export
 * @interface DiseasesApiUpdateDiseaseNameRequest
 */
export interface DiseasesApiUpdateDiseaseNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiUpdateDiseaseName
     */
    readonly id: string

    /**
     * 
     * @type {DiseaseNameUpdateQuery}
     * @memberof DiseasesApiUpdateDiseaseName
     */
    readonly diseaseNameUpdateQuery: DiseaseNameUpdateQuery
}

/**
 * Request parameters for upsertIcdDiseaseTranslations operation in DiseasesApi.
 * @export
 * @interface DiseasesApiUpsertIcdDiseaseTranslationsRequest
 */
export interface DiseasesApiUpsertIcdDiseaseTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiUpsertIcdDiseaseTranslations
     */
    readonly id: string

    /**
     * 
     * @type {DiseaseTranslationsBody}
     * @memberof DiseasesApiUpsertIcdDiseaseTranslations
     */
    readonly diseaseTranslationsBody: DiseaseTranslationsBody
}

/**
 * DiseasesApi - object-oriented interface
 * @export
 * @class DiseasesApi
 * @extends {BaseAPI}
 */
export class DiseasesApi extends BaseAPI {
    /**
     * 
     * @summary create a new disease
     * @param {DiseasesApiCreateDiseaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public createDisease(requestParameters: DiseasesApiCreateDiseaseRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).createDisease(requestParameters.diseaseCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a name to an icd code
     * @param {DiseasesApiCreateIcdDiseaseNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public createIcdDiseaseName(requestParameters: DiseasesApiCreateIcdDiseaseNameRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).createIcdDiseaseName(requestParameters.id, requestParameters.diseaseNameCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a disease name
     * @param {DiseasesApiDeleteDiseaseNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public deleteDiseaseName(requestParameters: DiseasesApiDeleteDiseaseNameRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).deleteDiseaseName(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all disease names in the platform
     * @param {DiseasesApiGetDiseasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getDiseases(requestParameters: DiseasesApiGetDiseasesRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getDiseases(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.exactMatch, requestParameters.countryFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get trials count of selected diseases for a specific country
     * @param {DiseasesApiGetDiseasesTrialsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getDiseasesTrialsCount(requestParameters: DiseasesApiGetDiseasesTrialsCountRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getDiseasesTrialsCount(requestParameters.countryFilter, requestParameters.icdCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get diseases with category and parent category using embedding search
     * @param {DiseasesApiGetDiseasesV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getDiseasesV2(requestParameters: DiseasesApiGetDiseasesV2Request, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getDiseasesV2(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all names of an icd code in the platform
     * @param {DiseasesApiGetIcdDiseaseNamesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getIcdDiseaseNames(requestParameters: DiseasesApiGetIcdDiseaseNamesRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getIcdDiseaseNames(requestParameters.language, requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all translations of an icd code in the platform
     * @param {DiseasesApiGetIcdDiseaseTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getIcdDiseaseTranslations(requestParameters: DiseasesApiGetIcdDiseaseTranslationsRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getIcdDiseaseTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all icd codes in the platform
     * @param {DiseasesApiGetIcdDiseasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getIcdDiseases(requestParameters: DiseasesApiGetIcdDiseasesRequest = {}, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getIcdDiseases(requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a disease name
     * @param {DiseasesApiUpdateDiseaseNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public updateDiseaseName(requestParameters: DiseasesApiUpdateDiseaseNameRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).updateDiseaseName(requestParameters.id, requestParameters.diseaseNameUpdateQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the translations of an icd code in the platform
     * @param {DiseasesApiUpsertIcdDiseaseTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public upsertIcdDiseaseTranslations(requestParameters: DiseasesApiUpsertIcdDiseaseTranslationsRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).upsertIcdDiseaseTranslations(requestParameters.id, requestParameters.diseaseTranslationsBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary DB-deep readiness probe (200 when the DB is reachable, 503 otherwise)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ready: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health/ready`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary DB-deep readiness probe (200 when the DB is reachable, 503 otherwise)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ready(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ready(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.ready']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary DB-deep readiness probe (200 when the DB is reachable, 503 otherwise)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ready(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ready(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary DB-deep readiness probe (200 when the DB is reachable, 503 otherwise)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public ready(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).ready(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HospitalsApi - axios parameter creator
 * @export
 */
export const HospitalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a new hospital center
         * @param {HospitalCenterCreate} hospitalCenterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHospitalCenter: async (hospitalCenterCreate: HospitalCenterCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hospitalCenterCreate' is not null or undefined
            assertParamExists('createHospitalCenter', 'hospitalCenterCreate', hospitalCenterCreate)
            const localVarPath = `/hospitals/center`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalCenterCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a name to a hospital center
         * @param {string} id 
         * @param {HospitalNameCreate} hospitalNameCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHospitalCenterName: async (id: string, hospitalNameCreate: HospitalNameCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createHospitalCenterName', 'id', id)
            // verify required parameter 'hospitalNameCreate' is not null or undefined
            assertParamExists('createHospitalCenterName', 'hospitalNameCreate', hospitalNameCreate)
            const localVarPath = `/hospitals/center/{id}/names`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalNameCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a hospital name
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHospitalName: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteHospitalName', 'id', id)
            const localVarPath = `/hospitals/names/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a hospital centers in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHospitalCenterDetails', 'id', id)
            const localVarPath = `/hospitals/center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all hospital names of a hospital center in the platform
         * @param {Language} language 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterNames: async (language: Language, id: string, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getHospitalCenterNames', 'language', language)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHospitalCenterNames', 'id', id)
            const localVarPath = `/hospitals/center/{id}/names`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all translations of a hospital center in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHospitalCenterTranslations', 'id', id)
            const localVarPath = `/hospitals/center/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all hospital centers in the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenters: async (limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hospitals/center`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all hospital names in the platform
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitals: async (language: Language, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getHospitals', 'language', language)
            const localVarPath = `/hospitals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary merge this hospital into the specified target hospital.
         * @param {string} id 
         * @param {HospitalMergeBody} hospitalMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeHospitals: async (id: string, hospitalMergeBody: HospitalMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mergeHospitals', 'id', id)
            // verify required parameter 'hospitalMergeBody' is not null or undefined
            assertParamExists('mergeHospitals', 'hospitalMergeBody', hospitalMergeBody)
            const localVarPath = `/hospitals/{id}/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update \'isStandard\' field of a hospital center.
         * @param {string} id 
         * @param {HospitalCenterUpdateQuery} hospitalCenterUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHospitalCenter: async (id: string, hospitalCenterUpdateQuery: HospitalCenterUpdateQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHospitalCenter', 'id', id)
            // verify required parameter 'hospitalCenterUpdateQuery' is not null or undefined
            assertParamExists('updateHospitalCenter', 'hospitalCenterUpdateQuery', hospitalCenterUpdateQuery)
            const localVarPath = `/hospitals/center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalCenterUpdateQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a hospital name
         * @param {string} id 
         * @param {HospitalNameUpdateQuery} hospitalNameUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHospitalName: async (id: string, hospitalNameUpdateQuery: HospitalNameUpdateQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHospitalName', 'id', id)
            // verify required parameter 'hospitalNameUpdateQuery' is not null or undefined
            assertParamExists('updateHospitalName', 'hospitalNameUpdateQuery', hospitalNameUpdateQuery)
            const localVarPath = `/hospitals/names/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalNameUpdateQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the translations of a hospital center in the platform
         * @param {string} id 
         * @param {HospitalTranslationsBody} hospitalTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHospitalCenterTranslations: async (id: string, hospitalTranslationsBody: HospitalTranslationsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertHospitalCenterTranslations', 'id', id)
            // verify required parameter 'hospitalTranslationsBody' is not null or undefined
            assertParamExists('upsertHospitalCenterTranslations', 'hospitalTranslationsBody', hospitalTranslationsBody)
            const localVarPath = `/hospitals/center/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalTranslationsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HospitalsApi - functional programming interface
 * @export
 */
export const HospitalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HospitalsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create a new hospital center
         * @param {HospitalCenterCreate} hospitalCenterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHospitalCenter(hospitalCenterCreate: HospitalCenterCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalCenterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHospitalCenter(hospitalCenterCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.createHospitalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a name to a hospital center
         * @param {string} id 
         * @param {HospitalNameCreate} hospitalNameCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHospitalCenterName(id: string, hospitalNameCreate: HospitalNameCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHospitalCenterName(id, hospitalNameCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.createHospitalCenterName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a hospital name
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHospitalName(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHospitalName(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.deleteHospitalName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a hospital centers in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitalCenterDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalCenterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalCenterDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitalCenterDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all hospital names of a hospital center in the platform
         * @param {Language} language 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitalCenterNames(language: Language, id: string, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalCenterNames(language, id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitalCenterNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all translations of a hospital center in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitalCenterTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalCenterTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitalCenterTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all hospital centers in the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitalCenters(limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalCenterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalCenters(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitalCenters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all hospital names in the platform
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitals(language: Language, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitals(language, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary merge this hospital into the specified target hospital.
         * @param {string} id 
         * @param {HospitalMergeBody} hospitalMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeHospitals(id: string, hospitalMergeBody: HospitalMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeHospitals(id, hospitalMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.mergeHospitals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update \'isStandard\' field of a hospital center.
         * @param {string} id 
         * @param {HospitalCenterUpdateQuery} hospitalCenterUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHospitalCenter(id: string, hospitalCenterUpdateQuery: HospitalCenterUpdateQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalCenterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHospitalCenter(id, hospitalCenterUpdateQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.updateHospitalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a hospital name
         * @param {string} id 
         * @param {HospitalNameUpdateQuery} hospitalNameUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHospitalName(id: string, hospitalNameUpdateQuery: HospitalNameUpdateQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHospitalName(id, hospitalNameUpdateQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.updateHospitalName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the translations of a hospital center in the platform
         * @param {string} id 
         * @param {HospitalTranslationsBody} hospitalTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertHospitalCenterTranslations(id: string, hospitalTranslationsBody: HospitalTranslationsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertHospitalCenterTranslations(id, hospitalTranslationsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.upsertHospitalCenterTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HospitalsApi - factory interface
 * @export
 */
export const HospitalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HospitalsApiFp(configuration)
    return {
        /**
         * 
         * @summary create a new hospital center
         * @param {HospitalsApiCreateHospitalCenterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHospitalCenter(requestParameters: HospitalsApiCreateHospitalCenterRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalCenterView> {
            return localVarFp.createHospitalCenter(requestParameters.hospitalCenterCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a name to a hospital center
         * @param {HospitalsApiCreateHospitalCenterNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHospitalCenterName(requestParameters: HospitalsApiCreateHospitalCenterNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalView> {
            return localVarFp.createHospitalCenterName(requestParameters.id, requestParameters.hospitalNameCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a hospital name
         * @param {HospitalsApiDeleteHospitalNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHospitalName(requestParameters: HospitalsApiDeleteHospitalNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteHospitalName(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a hospital centers in the platform
         * @param {HospitalsApiGetHospitalCenterDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterDetails(requestParameters: HospitalsApiGetHospitalCenterDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalCenterView> {
            return localVarFp.getHospitalCenterDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all hospital names of a hospital center in the platform
         * @param {HospitalsApiGetHospitalCenterNamesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterNames(requestParameters: HospitalsApiGetHospitalCenterNamesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalNameView> {
            return localVarFp.getHospitalCenterNames(requestParameters.language, requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all translations of a hospital center in the platform
         * @param {HospitalsApiGetHospitalCenterTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterTranslations(requestParameters: HospitalsApiGetHospitalCenterTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalTranslationView> {
            return localVarFp.getHospitalCenterTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all hospital centers in the platform
         * @param {HospitalsApiGetHospitalCentersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenters(requestParameters: HospitalsApiGetHospitalCentersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalCenterView> {
            return localVarFp.getHospitalCenters(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all hospital names in the platform
         * @param {HospitalsApiGetHospitalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitals(requestParameters: HospitalsApiGetHospitalsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalView> {
            return localVarFp.getHospitals(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary merge this hospital into the specified target hospital.
         * @param {HospitalsApiMergeHospitalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeHospitals(requestParameters: HospitalsApiMergeHospitalsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mergeHospitals(requestParameters.id, requestParameters.hospitalMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update \'isStandard\' field of a hospital center.
         * @param {HospitalsApiUpdateHospitalCenterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHospitalCenter(requestParameters: HospitalsApiUpdateHospitalCenterRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalCenterView> {
            return localVarFp.updateHospitalCenter(requestParameters.id, requestParameters.hospitalCenterUpdateQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a hospital name
         * @param {HospitalsApiUpdateHospitalNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHospitalName(requestParameters: HospitalsApiUpdateHospitalNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalNameView> {
            return localVarFp.updateHospitalName(requestParameters.id, requestParameters.hospitalNameUpdateQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the translations of a hospital center in the platform
         * @param {HospitalsApiUpsertHospitalCenterTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHospitalCenterTranslations(requestParameters: HospitalsApiUpsertHospitalCenterTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalTranslationView> {
            return localVarFp.upsertHospitalCenterTranslations(requestParameters.id, requestParameters.hospitalTranslationsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createHospitalCenter operation in HospitalsApi.
 * @export
 * @interface HospitalsApiCreateHospitalCenterRequest
 */
export interface HospitalsApiCreateHospitalCenterRequest {
    /**
     * 
     * @type {HospitalCenterCreate}
     * @memberof HospitalsApiCreateHospitalCenter
     */
    readonly hospitalCenterCreate: HospitalCenterCreate
}

/**
 * Request parameters for createHospitalCenterName operation in HospitalsApi.
 * @export
 * @interface HospitalsApiCreateHospitalCenterNameRequest
 */
export interface HospitalsApiCreateHospitalCenterNameRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiCreateHospitalCenterName
     */
    readonly id: string

    /**
     * 
     * @type {HospitalNameCreate}
     * @memberof HospitalsApiCreateHospitalCenterName
     */
    readonly hospitalNameCreate: HospitalNameCreate
}

/**
 * Request parameters for deleteHospitalName operation in HospitalsApi.
 * @export
 * @interface HospitalsApiDeleteHospitalNameRequest
 */
export interface HospitalsApiDeleteHospitalNameRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiDeleteHospitalName
     */
    readonly id: string
}

/**
 * Request parameters for getHospitalCenterDetails operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalCenterDetailsRequest
 */
export interface HospitalsApiGetHospitalCenterDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenterDetails
     */
    readonly id: string
}

/**
 * Request parameters for getHospitalCenterNames operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalCenterNamesRequest
 */
export interface HospitalsApiGetHospitalCenterNamesRequest {
    /**
     * 
     * @type {Language}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly language: Language

    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly searchString?: string
}

/**
 * Request parameters for getHospitalCenterTranslations operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalCenterTranslationsRequest
 */
export interface HospitalsApiGetHospitalCenterTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenterTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getHospitalCenters operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalCentersRequest
 */
export interface HospitalsApiGetHospitalCentersRequest {
    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitalCenters
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitalCenters
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenters
     */
    readonly searchString?: string
}

/**
 * Request parameters for getHospitals operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalsRequest
 */
export interface HospitalsApiGetHospitalsRequest {
    /**
     * 
     * @type {Language}
     * @memberof HospitalsApiGetHospitals
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitals
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitals
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitals
     */
    readonly searchString?: string
}

/**
 * Request parameters for mergeHospitals operation in HospitalsApi.
 * @export
 * @interface HospitalsApiMergeHospitalsRequest
 */
export interface HospitalsApiMergeHospitalsRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiMergeHospitals
     */
    readonly id: string

    /**
     * 
     * @type {HospitalMergeBody}
     * @memberof HospitalsApiMergeHospitals
     */
    readonly hospitalMergeBody: HospitalMergeBody
}

/**
 * Request parameters for updateHospitalCenter operation in HospitalsApi.
 * @export
 * @interface HospitalsApiUpdateHospitalCenterRequest
 */
export interface HospitalsApiUpdateHospitalCenterRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiUpdateHospitalCenter
     */
    readonly id: string

    /**
     * 
     * @type {HospitalCenterUpdateQuery}
     * @memberof HospitalsApiUpdateHospitalCenter
     */
    readonly hospitalCenterUpdateQuery: HospitalCenterUpdateQuery
}

/**
 * Request parameters for updateHospitalName operation in HospitalsApi.
 * @export
 * @interface HospitalsApiUpdateHospitalNameRequest
 */
export interface HospitalsApiUpdateHospitalNameRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiUpdateHospitalName
     */
    readonly id: string

    /**
     * 
     * @type {HospitalNameUpdateQuery}
     * @memberof HospitalsApiUpdateHospitalName
     */
    readonly hospitalNameUpdateQuery: HospitalNameUpdateQuery
}

/**
 * Request parameters for upsertHospitalCenterTranslations operation in HospitalsApi.
 * @export
 * @interface HospitalsApiUpsertHospitalCenterTranslationsRequest
 */
export interface HospitalsApiUpsertHospitalCenterTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiUpsertHospitalCenterTranslations
     */
    readonly id: string

    /**
     * 
     * @type {HospitalTranslationsBody}
     * @memberof HospitalsApiUpsertHospitalCenterTranslations
     */
    readonly hospitalTranslationsBody: HospitalTranslationsBody
}

/**
 * HospitalsApi - object-oriented interface
 * @export
 * @class HospitalsApi
 * @extends {BaseAPI}
 */
export class HospitalsApi extends BaseAPI {
    /**
     * 
     * @summary create a new hospital center
     * @param {HospitalsApiCreateHospitalCenterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public createHospitalCenter(requestParameters: HospitalsApiCreateHospitalCenterRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).createHospitalCenter(requestParameters.hospitalCenterCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a name to a hospital center
     * @param {HospitalsApiCreateHospitalCenterNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public createHospitalCenterName(requestParameters: HospitalsApiCreateHospitalCenterNameRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).createHospitalCenterName(requestParameters.id, requestParameters.hospitalNameCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a hospital name
     * @param {HospitalsApiDeleteHospitalNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public deleteHospitalName(requestParameters: HospitalsApiDeleteHospitalNameRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).deleteHospitalName(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a hospital centers in the platform
     * @param {HospitalsApiGetHospitalCenterDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitalCenterDetails(requestParameters: HospitalsApiGetHospitalCenterDetailsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitalCenterDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all hospital names of a hospital center in the platform
     * @param {HospitalsApiGetHospitalCenterNamesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitalCenterNames(requestParameters: HospitalsApiGetHospitalCenterNamesRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitalCenterNames(requestParameters.language, requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all translations of a hospital center in the platform
     * @param {HospitalsApiGetHospitalCenterTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitalCenterTranslations(requestParameters: HospitalsApiGetHospitalCenterTranslationsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitalCenterTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all hospital centers in the platform
     * @param {HospitalsApiGetHospitalCentersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitalCenters(requestParameters: HospitalsApiGetHospitalCentersRequest = {}, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitalCenters(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all hospital names in the platform
     * @param {HospitalsApiGetHospitalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitals(requestParameters: HospitalsApiGetHospitalsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitals(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary merge this hospital into the specified target hospital.
     * @param {HospitalsApiMergeHospitalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public mergeHospitals(requestParameters: HospitalsApiMergeHospitalsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).mergeHospitals(requestParameters.id, requestParameters.hospitalMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update \'isStandard\' field of a hospital center.
     * @param {HospitalsApiUpdateHospitalCenterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public updateHospitalCenter(requestParameters: HospitalsApiUpdateHospitalCenterRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).updateHospitalCenter(requestParameters.id, requestParameters.hospitalCenterUpdateQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a hospital name
     * @param {HospitalsApiUpdateHospitalNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public updateHospitalName(requestParameters: HospitalsApiUpdateHospitalNameRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).updateHospitalName(requestParameters.id, requestParameters.hospitalNameUpdateQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the translations of a hospital center in the platform
     * @param {HospitalsApiUpsertHospitalCenterTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public upsertHospitalCenterTranslations(requestParameters: HospitalsApiUpsertHospitalCenterTranslationsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).upsertHospitalCenterTranslations(requestParameters.id, requestParameters.hospitalTranslationsBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InsightsApi - axios parameter creator
 * @export
 */
export const InsightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Resolve the Google Data Studio report URL for the current user\'s team (free, paid, or custom tier).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insights/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsightsApi - functional programming interface
 * @export
 */
export const InsightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsightsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Resolve the Google Data Studio report URL for the current user\'s team (free, paid, or custom tier).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsightsConfigView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.getConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InsightsApi - factory interface
 * @export
 */
export const InsightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsightsApiFp(configuration)
    return {
        /**
         * 
         * @summary Resolve the Google Data Studio report URL for the current user\'s team (free, paid, or custom tier).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(options?: RawAxiosRequestConfig): AxiosPromise<InsightsConfigView> {
            return localVarFp.getConfig(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsightsApi - object-oriented interface
 * @export
 * @class InsightsApi
 * @extends {BaseAPI}
 */
export class InsightsApi extends BaseAPI {
    /**
     * 
     * @summary Resolve the Google Data Studio report URL for the current user\'s team (free, paid, or custom tier).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public getConfig(options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).getConfig(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InviteApi - axios parameter creator
 * @export
 */
export const InviteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept an invite with a token as an existing user
         * @param {AcceptExistingUserInviteBody} acceptExistingUserInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInviteAuthorized: async (acceptExistingUserInviteBody: AcceptExistingUserInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptExistingUserInviteBody' is not null or undefined
            assertParamExists('acceptInviteAuthorized', 'acceptExistingUserInviteBody', acceptExistingUserInviteBody)
            const localVarPath = `/invites/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptExistingUserInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept an invite with a token as a new user
         * @param {AcceptNewUserInviteBody} acceptNewUserInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInviteUnauthorized: async (acceptNewUserInviteBody: AcceptNewUserInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptNewUserInviteBody' is not null or undefined
            assertParamExists('acceptInviteUnauthorized', 'acceptNewUserInviteBody', acceptNewUserInviteBody)
            const localVarPath = `/invites/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptNewUserInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept milestone enrollment token and register new patient
         * @param {AcceptMilestoneTokenBody} acceptMilestoneTokenBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptMilestoneToken: async (acceptMilestoneTokenBody: AcceptMilestoneTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptMilestoneTokenBody' is not null or undefined
            assertParamExists('acceptMilestoneToken', 'acceptMilestoneTokenBody', acceptMilestoneTokenBody)
            const localVarPath = `/invites/milestone/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptMilestoneTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept milestone enrollment token as an existing patient
         * @param {AcceptMilestoneTokenExistingBody} acceptMilestoneTokenExistingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptMilestoneTokenExisting: async (acceptMilestoneTokenExistingBody: AcceptMilestoneTokenExistingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptMilestoneTokenExistingBody' is not null or undefined
            assertParamExists('acceptMilestoneTokenExisting', 'acceptMilestoneTokenExistingBody', acceptMilestoneTokenExistingBody)
            const localVarPath = `/invites/milestone/accept-existing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptMilestoneTokenExistingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept an invite for multiple trials to be added to the users team
         * @param {string} teamId 
         * @param {AcceptExistingTeamInviteBody} acceptExistingTeamInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTrialInviteWithExistingTeam: async (teamId: string, acceptExistingTeamInviteBody: AcceptExistingTeamInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('acceptTrialInviteWithExistingTeam', 'teamId', teamId)
            // verify required parameter 'acceptExistingTeamInviteBody' is not null or undefined
            assertParamExists('acceptTrialInviteWithExistingTeam', 'acceptExistingTeamInviteBody', acceptExistingTeamInviteBody)
            const localVarPath = `/invites/team/{teamId}/accept`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptExistingTeamInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an invite to the platform (admin, patient or reviewer)
         * @param {InviteBody} inviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvite: async (inviteBody: InviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteBody' is not null or undefined
            assertParamExists('createInvite', 'inviteBody', inviteBody)
            const localVarPath = `/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an invite for multiple trials to be added to the users team on creation
         * @param {TeamCreateInviteBody} teamCreateInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamCreationInvite: async (teamCreateInviteBody: TeamCreateInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamCreateInviteBody' is not null or undefined
            assertParamExists('createTeamCreationInvite', 'teamCreateInviteBody', teamCreateInviteBody)
            const localVarPath = `/invites/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamCreateInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an invite to a team.
         * @param {string} teamId 
         * @param {TeamMemberInviteBody} teamMemberInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamInvite: async (teamId: string, teamMemberInviteBody: TeamMemberInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamInvite', 'teamId', teamId)
            // verify required parameter 'teamMemberInviteBody' is not null or undefined
            assertParamExists('createTeamInvite', 'teamMemberInviteBody', teamMemberInviteBody)
            const localVarPath = `/invites/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an invite for multiple trials to be added to the users team on creation
         * @param {string} tokenValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamCreationInvite: async (tokenValue: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenValue' is not null or undefined
            assertParamExists('deleteTeamCreationInvite', 'tokenValue', tokenValue)
            const localVarPath = `/invites/team/token/{tokenValue}`
                .replace(`{${"tokenValue"}}`, encodeURIComponent(String(tokenValue)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an invite of a team
         * @param {string} teamId 
         * @param {string} tokenValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamInvite: async (teamId: string, tokenValue: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeamInvite', 'teamId', teamId)
            // verify required parameter 'tokenValue' is not null or undefined
            assertParamExists('deleteTeamInvite', 'tokenValue', tokenValue)
            const localVarPath = `/invites/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary View all invites to the platform
         * @param {number} [limit] 
         * @param {Role} [role] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvites: async (limit?: number, role?: Role, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch all invites for multiple trials to be added to the users team on creation
         * @param {TeamCreateInviteQuery} teamCreateInviteQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamCreateInvites: async (teamCreateInviteQuery: TeamCreateInviteQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamCreateInviteQuery' is not null or undefined
            assertParamExists('getTeamCreateInvites', 'teamCreateInviteQuery', teamCreateInviteQuery)
            const localVarPath = `/invites/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamCreateInviteQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get invites of a specific team
         * @param {string} teamId 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInvites: async (teamId: string, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamInvites', 'teamId', teamId)
            const localVarPath = `/invites/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an invite for multiple trials to be added to the users team on creation
         * @param {string} tokenValue 
         * @param {TeamCreateInviteUpdateBody} teamCreateInviteUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamCreationInvite: async (tokenValue: string, teamCreateInviteUpdateBody: TeamCreateInviteUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenValue' is not null or undefined
            assertParamExists('updateTeamCreationInvite', 'tokenValue', tokenValue)
            // verify required parameter 'teamCreateInviteUpdateBody' is not null or undefined
            assertParamExists('updateTeamCreationInvite', 'teamCreateInviteUpdateBody', teamCreateInviteUpdateBody)
            const localVarPath = `/invites/team/token/{tokenValue}`
                .replace(`{${"tokenValue"}}`, encodeURIComponent(String(tokenValue)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamCreateInviteUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update an invite for a trial manager to a team.
         * @param {string} teamId 
         * @param {TrialInviteUpdateBody} trialInviteUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberInvite: async (teamId: string, trialInviteUpdateBody: TrialInviteUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamMemberInvite', 'teamId', teamId)
            // verify required parameter 'trialInviteUpdateBody' is not null or undefined
            assertParamExists('updateTeamMemberInvite', 'trialInviteUpdateBody', trialInviteUpdateBody)
            const localVarPath = `/invites/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialInviteUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InviteApi - functional programming interface
 * @export
 */
export const InviteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InviteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept an invite with a token as an existing user
         * @param {AcceptExistingUserInviteBody} acceptExistingUserInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInviteAuthorized(acceptExistingUserInviteBody: AcceptExistingUserInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInviteAuthorized(acceptExistingUserInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.acceptInviteAuthorized']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept an invite with a token as a new user
         * @param {AcceptNewUserInviteBody} acceptNewUserInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInviteUnauthorized(acceptNewUserInviteBody: AcceptNewUserInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInviteUnauthorized(acceptNewUserInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.acceptInviteUnauthorized']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept milestone enrollment token and register new patient
         * @param {AcceptMilestoneTokenBody} acceptMilestoneTokenBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptMilestoneToken(acceptMilestoneTokenBody: AcceptMilestoneTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptMilestoneToken(acceptMilestoneTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.acceptMilestoneToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept milestone enrollment token as an existing patient
         * @param {AcceptMilestoneTokenExistingBody} acceptMilestoneTokenExistingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptMilestoneTokenExisting(acceptMilestoneTokenExistingBody: AcceptMilestoneTokenExistingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptMilestoneTokenExisting(acceptMilestoneTokenExistingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.acceptMilestoneTokenExisting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept an invite for multiple trials to be added to the users team
         * @param {string} teamId 
         * @param {AcceptExistingTeamInviteBody} acceptExistingTeamInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTrialInviteWithExistingTeam(teamId: string, acceptExistingTeamInviteBody: AcceptExistingTeamInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTrialInviteWithExistingTeam(teamId, acceptExistingTeamInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.acceptTrialInviteWithExistingTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an invite to the platform (admin, patient or reviewer)
         * @param {InviteBody} inviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvite(inviteBody: InviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvite(inviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.createInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an invite for multiple trials to be added to the users team on creation
         * @param {TeamCreateInviteBody} teamCreateInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamCreationInvite(teamCreateInviteBody: TeamCreateInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamCreateInviteView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamCreationInvite(teamCreateInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.createTeamCreationInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an invite to a team.
         * @param {string} teamId 
         * @param {TeamMemberInviteBody} teamMemberInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamInvite(teamId: string, teamMemberInviteBody: TeamMemberInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamInvite(teamId, teamMemberInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.createTeamInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an invite for multiple trials to be added to the users team on creation
         * @param {string} tokenValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamCreationInvite(tokenValue: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamCreationInvite(tokenValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.deleteTeamCreationInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an invite of a team
         * @param {string} teamId 
         * @param {string} tokenValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamInvite(teamId: string, tokenValue: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamInvite(teamId, tokenValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.deleteTeamInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary View all invites to the platform
         * @param {number} [limit] 
         * @param {Role} [role] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvites(limit?: number, role?: Role, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvites(limit, role, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.getInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch all invites for multiple trials to be added to the users team on creation
         * @param {TeamCreateInviteQuery} teamCreateInviteQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamCreateInvites(teamCreateInviteQuery: TeamCreateInviteQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamCreateInviteListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamCreateInvites(teamCreateInviteQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.getTeamCreateInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get invites of a specific team
         * @param {string} teamId 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamInvites(teamId: string, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamInvites(teamId, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.getTeamInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an invite for multiple trials to be added to the users team on creation
         * @param {string} tokenValue 
         * @param {TeamCreateInviteUpdateBody} teamCreateInviteUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamCreationInvite(tokenValue: string, teamCreateInviteUpdateBody: TeamCreateInviteUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamCreateInviteView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamCreationInvite(tokenValue, teamCreateInviteUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.updateTeamCreationInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update an invite for a trial manager to a team.
         * @param {string} teamId 
         * @param {TrialInviteUpdateBody} trialInviteUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamMemberInvite(teamId: string, trialInviteUpdateBody: TrialInviteUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamMemberInvite(teamId, trialInviteUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.updateTeamMemberInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InviteApi - factory interface
 * @export
 */
export const InviteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InviteApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept an invite with a token as an existing user
         * @param {InviteApiAcceptInviteAuthorizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInviteAuthorized(requestParameters: InviteApiAcceptInviteAuthorizedRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.acceptInviteAuthorized(requestParameters.acceptExistingUserInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept an invite with a token as a new user
         * @param {InviteApiAcceptInviteUnauthorizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInviteUnauthorized(requestParameters: InviteApiAcceptInviteUnauthorizedRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.acceptInviteUnauthorized(requestParameters.acceptNewUserInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept milestone enrollment token and register new patient
         * @param {InviteApiAcceptMilestoneTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptMilestoneToken(requestParameters: InviteApiAcceptMilestoneTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.acceptMilestoneToken(requestParameters.acceptMilestoneTokenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept milestone enrollment token as an existing patient
         * @param {InviteApiAcceptMilestoneTokenExistingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptMilestoneTokenExisting(requestParameters: InviteApiAcceptMilestoneTokenExistingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptMilestoneTokenExisting(requestParameters.acceptMilestoneTokenExistingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept an invite for multiple trials to be added to the users team
         * @param {InviteApiAcceptTrialInviteWithExistingTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTrialInviteWithExistingTeam(requestParameters: InviteApiAcceptTrialInviteWithExistingTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptTrialInviteWithExistingTeam(requestParameters.teamId, requestParameters.acceptExistingTeamInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an invite to the platform (admin, patient or reviewer)
         * @param {InviteApiCreateInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvite(requestParameters: InviteApiCreateInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createInvite(requestParameters.inviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an invite for multiple trials to be added to the users team on creation
         * @param {InviteApiCreateTeamCreationInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamCreationInvite(requestParameters: InviteApiCreateTeamCreationInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamCreateInviteView> {
            return localVarFp.createTeamCreationInvite(requestParameters.teamCreateInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an invite to a team.
         * @param {InviteApiCreateTeamInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamInvite(requestParameters: InviteApiCreateTeamInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteView> {
            return localVarFp.createTeamInvite(requestParameters.teamId, requestParameters.teamMemberInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an invite for multiple trials to be added to the users team on creation
         * @param {InviteApiDeleteTeamCreationInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamCreationInvite(requestParameters: InviteApiDeleteTeamCreationInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeamCreationInvite(requestParameters.tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an invite of a team
         * @param {InviteApiDeleteTeamInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamInvite(requestParameters: InviteApiDeleteTeamInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeamInvite(requestParameters.teamId, requestParameters.tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary View all invites to the platform
         * @param {InviteApiGetInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvites(requestParameters: InviteApiGetInvitesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InviteListView> {
            return localVarFp.getInvites(requestParameters.limit, requestParameters.role, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch all invites for multiple trials to be added to the users team on creation
         * @param {InviteApiGetTeamCreateInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamCreateInvites(requestParameters: InviteApiGetTeamCreateInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamCreateInviteListView> {
            return localVarFp.getTeamCreateInvites(requestParameters.teamCreateInviteQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get invites of a specific team
         * @param {InviteApiGetTeamInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInvites(requestParameters: InviteApiGetTeamInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteListView> {
            return localVarFp.getTeamInvites(requestParameters.teamId, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an invite for multiple trials to be added to the users team on creation
         * @param {InviteApiUpdateTeamCreationInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamCreationInvite(requestParameters: InviteApiUpdateTeamCreationInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamCreateInviteView> {
            return localVarFp.updateTeamCreationInvite(requestParameters.tokenValue, requestParameters.teamCreateInviteUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update an invite for a trial manager to a team.
         * @param {InviteApiUpdateTeamMemberInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberInvite(requestParameters: InviteApiUpdateTeamMemberInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteView> {
            return localVarFp.updateTeamMemberInvite(requestParameters.teamId, requestParameters.trialInviteUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptInviteAuthorized operation in InviteApi.
 * @export
 * @interface InviteApiAcceptInviteAuthorizedRequest
 */
export interface InviteApiAcceptInviteAuthorizedRequest {
    /**
     * 
     * @type {AcceptExistingUserInviteBody}
     * @memberof InviteApiAcceptInviteAuthorized
     */
    readonly acceptExistingUserInviteBody: AcceptExistingUserInviteBody
}

/**
 * Request parameters for acceptInviteUnauthorized operation in InviteApi.
 * @export
 * @interface InviteApiAcceptInviteUnauthorizedRequest
 */
export interface InviteApiAcceptInviteUnauthorizedRequest {
    /**
     * 
     * @type {AcceptNewUserInviteBody}
     * @memberof InviteApiAcceptInviteUnauthorized
     */
    readonly acceptNewUserInviteBody: AcceptNewUserInviteBody
}

/**
 * Request parameters for acceptMilestoneToken operation in InviteApi.
 * @export
 * @interface InviteApiAcceptMilestoneTokenRequest
 */
export interface InviteApiAcceptMilestoneTokenRequest {
    /**
     * 
     * @type {AcceptMilestoneTokenBody}
     * @memberof InviteApiAcceptMilestoneToken
     */
    readonly acceptMilestoneTokenBody: AcceptMilestoneTokenBody
}

/**
 * Request parameters for acceptMilestoneTokenExisting operation in InviteApi.
 * @export
 * @interface InviteApiAcceptMilestoneTokenExistingRequest
 */
export interface InviteApiAcceptMilestoneTokenExistingRequest {
    /**
     * 
     * @type {AcceptMilestoneTokenExistingBody}
     * @memberof InviteApiAcceptMilestoneTokenExisting
     */
    readonly acceptMilestoneTokenExistingBody: AcceptMilestoneTokenExistingBody
}

/**
 * Request parameters for acceptTrialInviteWithExistingTeam operation in InviteApi.
 * @export
 * @interface InviteApiAcceptTrialInviteWithExistingTeamRequest
 */
export interface InviteApiAcceptTrialInviteWithExistingTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiAcceptTrialInviteWithExistingTeam
     */
    readonly teamId: string

    /**
     * 
     * @type {AcceptExistingTeamInviteBody}
     * @memberof InviteApiAcceptTrialInviteWithExistingTeam
     */
    readonly acceptExistingTeamInviteBody: AcceptExistingTeamInviteBody
}

/**
 * Request parameters for createInvite operation in InviteApi.
 * @export
 * @interface InviteApiCreateInviteRequest
 */
export interface InviteApiCreateInviteRequest {
    /**
     * 
     * @type {InviteBody}
     * @memberof InviteApiCreateInvite
     */
    readonly inviteBody: InviteBody
}

/**
 * Request parameters for createTeamCreationInvite operation in InviteApi.
 * @export
 * @interface InviteApiCreateTeamCreationInviteRequest
 */
export interface InviteApiCreateTeamCreationInviteRequest {
    /**
     * 
     * @type {TeamCreateInviteBody}
     * @memberof InviteApiCreateTeamCreationInvite
     */
    readonly teamCreateInviteBody: TeamCreateInviteBody
}

/**
 * Request parameters for createTeamInvite operation in InviteApi.
 * @export
 * @interface InviteApiCreateTeamInviteRequest
 */
export interface InviteApiCreateTeamInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiCreateTeamInvite
     */
    readonly teamId: string

    /**
     * 
     * @type {TeamMemberInviteBody}
     * @memberof InviteApiCreateTeamInvite
     */
    readonly teamMemberInviteBody: TeamMemberInviteBody
}

/**
 * Request parameters for deleteTeamCreationInvite operation in InviteApi.
 * @export
 * @interface InviteApiDeleteTeamCreationInviteRequest
 */
export interface InviteApiDeleteTeamCreationInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiDeleteTeamCreationInvite
     */
    readonly tokenValue: string
}

/**
 * Request parameters for deleteTeamInvite operation in InviteApi.
 * @export
 * @interface InviteApiDeleteTeamInviteRequest
 */
export interface InviteApiDeleteTeamInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiDeleteTeamInvite
     */
    readonly teamId: string

    /**
     * 
     * @type {string}
     * @memberof InviteApiDeleteTeamInvite
     */
    readonly tokenValue: string
}

/**
 * Request parameters for getInvites operation in InviteApi.
 * @export
 * @interface InviteApiGetInvitesRequest
 */
export interface InviteApiGetInvitesRequest {
    /**
     * 
     * @type {number}
     * @memberof InviteApiGetInvites
     */
    readonly limit?: number

    /**
     * 
     * @type {Role}
     * @memberof InviteApiGetInvites
     */
    readonly role?: Role

    /**
     * 
     * @type {string}
     * @memberof InviteApiGetInvites
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getTeamCreateInvites operation in InviteApi.
 * @export
 * @interface InviteApiGetTeamCreateInvitesRequest
 */
export interface InviteApiGetTeamCreateInvitesRequest {
    /**
     * 
     * @type {TeamCreateInviteQuery}
     * @memberof InviteApiGetTeamCreateInvites
     */
    readonly teamCreateInviteQuery: TeamCreateInviteQuery
}

/**
 * Request parameters for getTeamInvites operation in InviteApi.
 * @export
 * @interface InviteApiGetTeamInvitesRequest
 */
export interface InviteApiGetTeamInvitesRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiGetTeamInvites
     */
    readonly teamId: string

    /**
     * 
     * @type {string}
     * @memberof InviteApiGetTeamInvites
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for updateTeamCreationInvite operation in InviteApi.
 * @export
 * @interface InviteApiUpdateTeamCreationInviteRequest
 */
export interface InviteApiUpdateTeamCreationInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiUpdateTeamCreationInvite
     */
    readonly tokenValue: string

    /**
     * 
     * @type {TeamCreateInviteUpdateBody}
     * @memberof InviteApiUpdateTeamCreationInvite
     */
    readonly teamCreateInviteUpdateBody: TeamCreateInviteUpdateBody
}

/**
 * Request parameters for updateTeamMemberInvite operation in InviteApi.
 * @export
 * @interface InviteApiUpdateTeamMemberInviteRequest
 */
export interface InviteApiUpdateTeamMemberInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiUpdateTeamMemberInvite
     */
    readonly teamId: string

    /**
     * 
     * @type {TrialInviteUpdateBody}
     * @memberof InviteApiUpdateTeamMemberInvite
     */
    readonly trialInviteUpdateBody: TrialInviteUpdateBody
}

/**
 * InviteApi - object-oriented interface
 * @export
 * @class InviteApi
 * @extends {BaseAPI}
 */
export class InviteApi extends BaseAPI {
    /**
     * 
     * @summary Accept an invite with a token as an existing user
     * @param {InviteApiAcceptInviteAuthorizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public acceptInviteAuthorized(requestParameters: InviteApiAcceptInviteAuthorizedRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).acceptInviteAuthorized(requestParameters.acceptExistingUserInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept an invite with a token as a new user
     * @param {InviteApiAcceptInviteUnauthorizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public acceptInviteUnauthorized(requestParameters: InviteApiAcceptInviteUnauthorizedRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).acceptInviteUnauthorized(requestParameters.acceptNewUserInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept milestone enrollment token and register new patient
     * @param {InviteApiAcceptMilestoneTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public acceptMilestoneToken(requestParameters: InviteApiAcceptMilestoneTokenRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).acceptMilestoneToken(requestParameters.acceptMilestoneTokenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept milestone enrollment token as an existing patient
     * @param {InviteApiAcceptMilestoneTokenExistingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public acceptMilestoneTokenExisting(requestParameters: InviteApiAcceptMilestoneTokenExistingRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).acceptMilestoneTokenExisting(requestParameters.acceptMilestoneTokenExistingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept an invite for multiple trials to be added to the users team
     * @param {InviteApiAcceptTrialInviteWithExistingTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public acceptTrialInviteWithExistingTeam(requestParameters: InviteApiAcceptTrialInviteWithExistingTeamRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).acceptTrialInviteWithExistingTeam(requestParameters.teamId, requestParameters.acceptExistingTeamInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an invite to the platform (admin, patient or reviewer)
     * @param {InviteApiCreateInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public createInvite(requestParameters: InviteApiCreateInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).createInvite(requestParameters.inviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an invite for multiple trials to be added to the users team on creation
     * @param {InviteApiCreateTeamCreationInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public createTeamCreationInvite(requestParameters: InviteApiCreateTeamCreationInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).createTeamCreationInvite(requestParameters.teamCreateInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an invite to a team.
     * @param {InviteApiCreateTeamInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public createTeamInvite(requestParameters: InviteApiCreateTeamInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).createTeamInvite(requestParameters.teamId, requestParameters.teamMemberInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an invite for multiple trials to be added to the users team on creation
     * @param {InviteApiDeleteTeamCreationInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public deleteTeamCreationInvite(requestParameters: InviteApiDeleteTeamCreationInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).deleteTeamCreationInvite(requestParameters.tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an invite of a team
     * @param {InviteApiDeleteTeamInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public deleteTeamInvite(requestParameters: InviteApiDeleteTeamInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).deleteTeamInvite(requestParameters.teamId, requestParameters.tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary View all invites to the platform
     * @param {InviteApiGetInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public getInvites(requestParameters: InviteApiGetInvitesRequest = {}, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).getInvites(requestParameters.limit, requestParameters.role, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch all invites for multiple trials to be added to the users team on creation
     * @param {InviteApiGetTeamCreateInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public getTeamCreateInvites(requestParameters: InviteApiGetTeamCreateInvitesRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).getTeamCreateInvites(requestParameters.teamCreateInviteQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get invites of a specific team
     * @param {InviteApiGetTeamInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public getTeamInvites(requestParameters: InviteApiGetTeamInvitesRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).getTeamInvites(requestParameters.teamId, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an invite for multiple trials to be added to the users team on creation
     * @param {InviteApiUpdateTeamCreationInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public updateTeamCreationInvite(requestParameters: InviteApiUpdateTeamCreationInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).updateTeamCreationInvite(requestParameters.tokenValue, requestParameters.teamCreateInviteUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update an invite for a trial manager to a team.
     * @param {InviteApiUpdateTeamMemberInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public updateTeamMemberInvite(requestParameters: InviteApiUpdateTeamMemberInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).updateTeamMemberInvite(requestParameters.teamId, requestParameters.trialInviteUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary set the acceptance flow for a location. A trial can have 1 effect.
         * @param {string} id 
         * @param {LocationEffectBody} locationEffectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEffect: async (id: string, locationEffectBody: LocationEffectBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addEffect', 'id', id)
            // verify required parameter 'locationEffectBody' is not null or undefined
            assertParamExists('addEffect', 'locationEffectBody', locationEffectBody)
            const localVarPath = `/location/{id}/effect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationEffectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new contact for a location
         * @param {string} id 
         * @param {LocationContactAddBody} locationContactAddBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLocationContact: async (id: string, locationContactAddBody: LocationContactAddBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addLocationContact', 'id', id)
            // verify required parameter 'locationContactAddBody' is not null or undefined
            assertParamExists('addLocationContact', 'locationContactAddBody', locationContactAddBody)
            const localVarPath = `/location/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationContactAddBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLocation', 'id', id)
            const localVarPath = `/location/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocation', 'id', id)
            const localVarPath = `/location/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of locations with unique facility name
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reset the acceptance flow for the location to the default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEffect: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEffect', 'id', id)
            const localVarPath = `/location/{id}/effect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set location status to inactive
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLocationInactive: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setLocationInactive', 'id', id)
            const localVarPath = `/location/{id}/status/inactive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing location
         * @param {string} id 
         * @param {LocationUpdateBody} locationUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (id: string, locationUpdateBody: LocationUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLocation', 'id', id)
            // verify required parameter 'locationUpdateBody' is not null or undefined
            assertParamExists('updateLocation', 'locationUpdateBody', locationUpdateBody)
            const localVarPath = `/location/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the external contact for a location (if that type of effect is present)
         * @param {string} id 
         * @param {LocationContactUpdateBody} locationContactUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationContact: async (id: string, locationContactUpdateBody: LocationContactUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLocationContact', 'id', id)
            // verify required parameter 'locationContactUpdateBody' is not null or undefined
            assertParamExists('updateLocationContact', 'locationContactUpdateBody', locationContactUpdateBody)
            const localVarPath = `/location/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationContactUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary set the acceptance flow for a location. A trial can have 1 effect.
         * @param {string} id 
         * @param {LocationEffectBody} locationEffectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEffect(id: string, locationEffectBody: LocationEffectBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEffect(id, locationEffectBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.addEffect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new contact for a location
         * @param {string} id 
         * @param {LocationContactAddBody} locationContactAddBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLocationContact(id: string, locationContactAddBody: LocationContactAddBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addLocationContact(id, locationContactAddBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.addLocationContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.deleteLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of locations with unique facility name
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUniqueLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reset the acceptance flow for the location to the default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEffect(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEffect(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.removeEffect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set location status to inactive
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setLocationInactive(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setLocationInactive(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.setLocationInactive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing location
         * @param {string} id 
         * @param {LocationUpdateBody} locationUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(id: string, locationUpdateBody: LocationUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(id, locationUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.updateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the external contact for a location (if that type of effect is present)
         * @param {string} id 
         * @param {LocationContactUpdateBody} locationContactUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationContact(id: string, locationContactUpdateBody: LocationContactUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationContact(id, locationContactUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.updateLocationContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * 
         * @summary set the acceptance flow for a location. A trial can have 1 effect.
         * @param {LocationApiAddEffectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEffect(requestParameters: LocationApiAddEffectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addEffect(requestParameters.id, requestParameters.locationEffectBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new contact for a location
         * @param {LocationApiAddLocationContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLocationContact(requestParameters: LocationApiAddLocationContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addLocationContact(requestParameters.id, requestParameters.locationContactAddBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a location
         * @param {LocationApiDeleteLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(requestParameters: LocationApiDeleteLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLocation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific location
         * @param {LocationApiGetLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation(requestParameters: LocationApiGetLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationView> {
            return localVarFp.getLocation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of locations with unique facility name
         * @param {LocationApiGetLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(requestParameters: LocationApiGetLocationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListUniqueLocationView> {
            return localVarFp.getLocations(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reset the acceptance flow for the location to the default
         * @param {LocationApiRemoveEffectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEffect(requestParameters: LocationApiRemoveEffectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeEffect(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set location status to inactive
         * @param {LocationApiSetLocationInactiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLocationInactive(requestParameters: LocationApiSetLocationInactiveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setLocationInactive(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing location
         * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(requestParameters: LocationApiUpdateLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLocation(requestParameters.id, requestParameters.locationUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the external contact for a location (if that type of effect is present)
         * @param {LocationApiUpdateLocationContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationContact(requestParameters: LocationApiUpdateLocationContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLocationContact(requestParameters.id, requestParameters.locationContactUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addEffect operation in LocationApi.
 * @export
 * @interface LocationApiAddEffectRequest
 */
export interface LocationApiAddEffectRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiAddEffect
     */
    readonly id: string

    /**
     * 
     * @type {LocationEffectBody}
     * @memberof LocationApiAddEffect
     */
    readonly locationEffectBody: LocationEffectBody
}

/**
 * Request parameters for addLocationContact operation in LocationApi.
 * @export
 * @interface LocationApiAddLocationContactRequest
 */
export interface LocationApiAddLocationContactRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiAddLocationContact
     */
    readonly id: string

    /**
     * 
     * @type {LocationContactAddBody}
     * @memberof LocationApiAddLocationContact
     */
    readonly locationContactAddBody: LocationContactAddBody
}

/**
 * Request parameters for deleteLocation operation in LocationApi.
 * @export
 * @interface LocationApiDeleteLocationRequest
 */
export interface LocationApiDeleteLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiDeleteLocation
     */
    readonly id: string
}

/**
 * Request parameters for getLocation operation in LocationApi.
 * @export
 * @interface LocationApiGetLocationRequest
 */
export interface LocationApiGetLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiGetLocation
     */
    readonly id: string
}

/**
 * Request parameters for getLocations operation in LocationApi.
 * @export
 * @interface LocationApiGetLocationsRequest
 */
export interface LocationApiGetLocationsRequest {
    /**
     * 
     * @type {number}
     * @memberof LocationApiGetLocations
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof LocationApiGetLocations
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof LocationApiGetLocations
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for removeEffect operation in LocationApi.
 * @export
 * @interface LocationApiRemoveEffectRequest
 */
export interface LocationApiRemoveEffectRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiRemoveEffect
     */
    readonly id: string
}

/**
 * Request parameters for setLocationInactive operation in LocationApi.
 * @export
 * @interface LocationApiSetLocationInactiveRequest
 */
export interface LocationApiSetLocationInactiveRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiSetLocationInactive
     */
    readonly id: string
}

/**
 * Request parameters for updateLocation operation in LocationApi.
 * @export
 * @interface LocationApiUpdateLocationRequest
 */
export interface LocationApiUpdateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiUpdateLocation
     */
    readonly id: string

    /**
     * 
     * @type {LocationUpdateBody}
     * @memberof LocationApiUpdateLocation
     */
    readonly locationUpdateBody: LocationUpdateBody
}

/**
 * Request parameters for updateLocationContact operation in LocationApi.
 * @export
 * @interface LocationApiUpdateLocationContactRequest
 */
export interface LocationApiUpdateLocationContactRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiUpdateLocationContact
     */
    readonly id: string

    /**
     * 
     * @type {LocationContactUpdateBody}
     * @memberof LocationApiUpdateLocationContact
     */
    readonly locationContactUpdateBody: LocationContactUpdateBody
}

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * 
     * @summary set the acceptance flow for a location. A trial can have 1 effect.
     * @param {LocationApiAddEffectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public addEffect(requestParameters: LocationApiAddEffectRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).addEffect(requestParameters.id, requestParameters.locationEffectBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new contact for a location
     * @param {LocationApiAddLocationContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public addLocationContact(requestParameters: LocationApiAddLocationContactRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).addLocationContact(requestParameters.id, requestParameters.locationContactAddBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a location
     * @param {LocationApiDeleteLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public deleteLocation(requestParameters: LocationApiDeleteLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).deleteLocation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific location
     * @param {LocationApiGetLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getLocation(requestParameters: LocationApiGetLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getLocation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of locations with unique facility name
     * @param {LocationApiGetLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getLocations(requestParameters: LocationApiGetLocationsRequest = {}, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getLocations(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reset the acceptance flow for the location to the default
     * @param {LocationApiRemoveEffectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public removeEffect(requestParameters: LocationApiRemoveEffectRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).removeEffect(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set location status to inactive
     * @param {LocationApiSetLocationInactiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public setLocationInactive(requestParameters: LocationApiSetLocationInactiveRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).setLocationInactive(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing location
     * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public updateLocation(requestParameters: LocationApiUpdateLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).updateLocation(requestParameters.id, requestParameters.locationUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the external contact for a location (if that type of effect is present)
     * @param {LocationApiUpdateLocationContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public updateLocationContact(requestParameters: LocationApiUpdateLocationContactRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).updateLocationContact(requestParameters.id, requestParameters.locationContactUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MandateApi - axios parameter creator
 * @export
 */
export const MandateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary handle webhook events sent by Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhookEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mandate/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MandateApi - functional programming interface
 * @export
 */
export const MandateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MandateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary handle webhook events sent by Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhookEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhookEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MandateApi.handleWebhookEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MandateApi - factory interface
 * @export
 */
export const MandateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MandateApiFp(configuration)
    return {
        /**
         * 
         * @summary handle webhook events sent by Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhookEvents(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleWebhookEvents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MandateApi - object-oriented interface
 * @export
 * @class MandateApi
 * @extends {BaseAPI}
 */
export class MandateApi extends BaseAPI {
    /**
     * 
     * @summary handle webhook events sent by Stripe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandateApi
     */
    public handleWebhookEvents(options?: RawAxiosRequestConfig) {
        return MandateApiFp(this.configuration).handleWebhookEvents(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MatchingEngineApi - axios parameter creator
 * @export
 */
export const MatchingEngineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary per-patient legacy→engine status pairs for one trial (parity review)
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [disease] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchedSetPatients: async (trialId: string, limit?: number | null, offset?: number | null, disease?: string, country?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('matchedSetPatients', 'trialId', trialId)
            const localVarPath = `/admin/matching-engine/parity/matched-sets/trials/{trialId}/patients`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (disease !== undefined) {
                localVarQueryParameter['disease'] = disease;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary legacy-vs-engine matched-set rollup per slice (parity review)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchedSetSlices: async (limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/matching-engine/parity/matched-sets/slices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary legacy-vs-engine matched sets per (trial, slice), biggest delta first
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [disease] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchedSetTrials: async (limit?: number | null, offset?: number | null, disease?: string, country?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/matching-engine/parity/matched-sets/trials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (disease !== undefined) {
                localVarQueryParameter['disease'] = disease;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary bitmap-vs-walker parity counters per trial (rollout gate)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parity: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/matching-engine/parity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary recorded comparisons for a trial, newest first (parity review)
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {ParityDivergencesMismatchOnlyEnum} [mismatchOnly] Omitted means divergences only — the review screen\&#39;s question. Pass &#x60;false&#x60; to drop into the agreements for context.  Typed as a string enum rather than a boolean: &#x60;enableImplicitConversion&#x60; coerces a boolean-typed query param with &#x60;Boolean(value)&#x60; before any &#x60;@Transform&#x60; can see the raw text, so &#x60;\&#39;false\&#39;&#x60; would arrive &#x60;true&#x60;. The handler reads the literal.
         * @param {string} [disease] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parityDivergences: async (trialId: string, limit?: number | null, offset?: number | null, mismatchOnly?: ParityDivergencesMismatchOnlyEnum, disease?: string, country?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('parityDivergences', 'trialId', trialId)
            const localVarPath = `/admin/matching-engine/parity/trials/{trialId}/divergences`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (mismatchOnly !== undefined) {
                localVarQueryParameter['mismatchOnly'] = mismatchOnly;
            }

            if (disease !== undefined) {
                localVarQueryParameter['disease'] = disease;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary trials with every slice they cover, paged over trials (parity review)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {RolloutStage} [stage] 
         * @param {boolean} [mismatchesOnly] &#x60;Type(() &#x3D;&gt; String)&#x60; + &#x60;Transform&#x60; guard against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60; — it coerces on the reflected type, so on a &#x60;boolean&#x60; it would run &#x60;Boolean(\&#39;false\&#39;)&#x60; → &#x60;true&#x60; before &#x60;Transform&#x60; sees the raw value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parityGroupedTrials: async (limit?: number | null, offset?: number | null, stage?: RolloutStage, mismatchesOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/matching-engine/parity/grouped-trials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (mismatchesOnly !== undefined) {
                localVarQueryParameter['mismatchesOnly'] = mismatchesOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary slices that have left legacy, with trial counts (parity review)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {ReviewableRolloutStage} [stage] 
         * @param {boolean} [mismatchesOnly] &#x60;Type(() &#x3D;&gt; String)&#x60; + &#x60;Transform&#x60; guard against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60;. The String declaration is what makes it work: implicit conversion coerces on the reflected type, so on a &#x60;boolean&#x60; it runs &#x60;Boolean(\&#39;false\&#39;)&#x60; → &#x60;true&#x60; before &#x60;Transform&#x60; sees the raw value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paritySlices: async (limit?: number | null, offset?: number | null, stage?: ReviewableRolloutStage, mismatchesOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/matching-engine/parity/slices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (mismatchesOnly !== undefined) {
                localVarQueryParameter['mismatchesOnly'] = mismatchesOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary a trial\'s slice footprint, each slice with its own stage (parity review)
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parityTrialSlices: async (trialId: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('parityTrialSlices', 'trialId', trialId)
            const localVarPath = `/admin/matching-engine/parity/trials/{trialId}/slices`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary trials per slice ranked by mismatch ratio (parity review)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {RolloutStage} [stage] 
         * @param {string} [disease] 
         * @param {string} [country] 
         * @param {boolean} [mismatchesOnly] &#x60;Transform&#x60; guards against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parityTrials: async (limit?: number | null, offset?: number | null, stage?: RolloutStage, disease?: string, country?: string, mismatchesOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/matching-engine/parity/trials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (disease !== undefined) {
                localVarQueryParameter['disease'] = disease;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (mismatchesOnly !== undefined) {
                localVarQueryParameter['mismatchesOnly'] = mismatchesOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary queue a fleet-wide bitmap engine rebuild from source (admin recovery)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuild: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/matching-engine/rebuild`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatchingEngineApi - functional programming interface
 * @export
 */
export const MatchingEngineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatchingEngineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary per-patient legacy→engine status pairs for one trial (parity review)
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [disease] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchedSetPatients(trialId: string, limit?: number | null, offset?: number | null, disease?: string, country?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMatchedSetPatientView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchedSetPatients(trialId, limit, offset, disease, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.matchedSetPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary legacy-vs-engine matched-set rollup per slice (parity review)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchedSetSlices(limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMatchedSetSliceView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchedSetSlices(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.matchedSetSlices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary legacy-vs-engine matched sets per (trial, slice), biggest delta first
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [disease] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchedSetTrials(limit?: number | null, offset?: number | null, disease?: string, country?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMatchedSetTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchedSetTrials(limit, offset, disease, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.matchedSetTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary bitmap-vs-walker parity counters per trial (rollout gate)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parity(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parity(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.parity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary recorded comparisons for a trial, newest first (parity review)
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {ParityDivergencesMismatchOnlyEnum} [mismatchOnly] Omitted means divergences only — the review screen\&#39;s question. Pass &#x60;false&#x60; to drop into the agreements for context.  Typed as a string enum rather than a boolean: &#x60;enableImplicitConversion&#x60; coerces a boolean-typed query param with &#x60;Boolean(value)&#x60; before any &#x60;@Transform&#x60; can see the raw text, so &#x60;\&#39;false\&#39;&#x60; would arrive &#x60;true&#x60;. The handler reads the literal.
         * @param {string} [disease] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parityDivergences(trialId: string, limit?: number | null, offset?: number | null, mismatchOnly?: ParityDivergencesMismatchOnlyEnum, disease?: string, country?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListParityDivergenceView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parityDivergences(trialId, limit, offset, mismatchOnly, disease, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.parityDivergences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary trials with every slice they cover, paged over trials (parity review)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {RolloutStage} [stage] 
         * @param {boolean} [mismatchesOnly] &#x60;Type(() &#x3D;&gt; String)&#x60; + &#x60;Transform&#x60; guard against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60; — it coerces on the reflected type, so on a &#x60;boolean&#x60; it would run &#x60;Boolean(\&#39;false\&#39;)&#x60; → &#x60;true&#x60; before &#x60;Transform&#x60; sees the raw value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parityGroupedTrials(limit?: number | null, offset?: number | null, stage?: RolloutStage, mismatchesOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListParityGroupedTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parityGroupedTrials(limit, offset, stage, mismatchesOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.parityGroupedTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary slices that have left legacy, with trial counts (parity review)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {ReviewableRolloutStage} [stage] 
         * @param {boolean} [mismatchesOnly] &#x60;Type(() &#x3D;&gt; String)&#x60; + &#x60;Transform&#x60; guard against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60;. The String declaration is what makes it work: implicit conversion coerces on the reflected type, so on a &#x60;boolean&#x60; it runs &#x60;Boolean(\&#39;false\&#39;)&#x60; → &#x60;true&#x60; before &#x60;Transform&#x60; sees the raw value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paritySlices(limit?: number | null, offset?: number | null, stage?: ReviewableRolloutStage, mismatchesOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListParitySliceView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paritySlices(limit, offset, stage, mismatchesOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.paritySlices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary a trial\'s slice footprint, each slice with its own stage (parity review)
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parityTrialSlices(trialId: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListParityTrialSliceView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parityTrialSlices(trialId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.parityTrialSlices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary trials per slice ranked by mismatch ratio (parity review)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {RolloutStage} [stage] 
         * @param {string} [disease] 
         * @param {string} [country] 
         * @param {boolean} [mismatchesOnly] &#x60;Transform&#x60; guards against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parityTrials(limit?: number | null, offset?: number | null, stage?: RolloutStage, disease?: string, country?: string, mismatchesOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListParityTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parityTrials(limit, offset, stage, disease, country, mismatchesOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.parityTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary queue a fleet-wide bitmap engine rebuild from source (admin recovery)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebuild(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebuild(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchingEngineApi.rebuild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MatchingEngineApi - factory interface
 * @export
 */
export const MatchingEngineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatchingEngineApiFp(configuration)
    return {
        /**
         * 
         * @summary per-patient legacy→engine status pairs for one trial (parity review)
         * @param {MatchingEngineApiMatchedSetPatientsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchedSetPatients(requestParameters: MatchingEngineApiMatchedSetPatientsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListMatchedSetPatientView> {
            return localVarFp.matchedSetPatients(requestParameters.trialId, requestParameters.limit, requestParameters.offset, requestParameters.disease, requestParameters.country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary legacy-vs-engine matched-set rollup per slice (parity review)
         * @param {MatchingEngineApiMatchedSetSlicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchedSetSlices(requestParameters: MatchingEngineApiMatchedSetSlicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListMatchedSetSliceView> {
            return localVarFp.matchedSetSlices(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary legacy-vs-engine matched sets per (trial, slice), biggest delta first
         * @param {MatchingEngineApiMatchedSetTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchedSetTrials(requestParameters: MatchingEngineApiMatchedSetTrialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListMatchedSetTrialView> {
            return localVarFp.matchedSetTrials(requestParameters.limit, requestParameters.offset, requestParameters.disease, requestParameters.country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary bitmap-vs-walker parity counters per trial (rollout gate)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parity(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.parity(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary recorded comparisons for a trial, newest first (parity review)
         * @param {MatchingEngineApiParityDivergencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parityDivergences(requestParameters: MatchingEngineApiParityDivergencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListParityDivergenceView> {
            return localVarFp.parityDivergences(requestParameters.trialId, requestParameters.limit, requestParameters.offset, requestParameters.mismatchOnly, requestParameters.disease, requestParameters.country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary trials with every slice they cover, paged over trials (parity review)
         * @param {MatchingEngineApiParityGroupedTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parityGroupedTrials(requestParameters: MatchingEngineApiParityGroupedTrialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListParityGroupedTrialView> {
            return localVarFp.parityGroupedTrials(requestParameters.limit, requestParameters.offset, requestParameters.stage, requestParameters.mismatchesOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary slices that have left legacy, with trial counts (parity review)
         * @param {MatchingEngineApiParitySlicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paritySlices(requestParameters: MatchingEngineApiParitySlicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListParitySliceView> {
            return localVarFp.paritySlices(requestParameters.limit, requestParameters.offset, requestParameters.stage, requestParameters.mismatchesOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary a trial\'s slice footprint, each slice with its own stage (parity review)
         * @param {MatchingEngineApiParityTrialSlicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parityTrialSlices(requestParameters: MatchingEngineApiParityTrialSlicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListParityTrialSliceView> {
            return localVarFp.parityTrialSlices(requestParameters.trialId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary trials per slice ranked by mismatch ratio (parity review)
         * @param {MatchingEngineApiParityTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parityTrials(requestParameters: MatchingEngineApiParityTrialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListParityTrialView> {
            return localVarFp.parityTrials(requestParameters.limit, requestParameters.offset, requestParameters.stage, requestParameters.disease, requestParameters.country, requestParameters.mismatchesOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary queue a fleet-wide bitmap engine rebuild from source (admin recovery)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuild(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rebuild(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for matchedSetPatients operation in MatchingEngineApi.
 * @export
 * @interface MatchingEngineApiMatchedSetPatientsRequest
 */
export interface MatchingEngineApiMatchedSetPatientsRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiMatchedSetPatients
     */
    readonly trialId: string

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiMatchedSetPatients
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiMatchedSetPatients
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiMatchedSetPatients
     */
    readonly disease?: string

    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiMatchedSetPatients
     */
    readonly country?: string
}

/**
 * Request parameters for matchedSetSlices operation in MatchingEngineApi.
 * @export
 * @interface MatchingEngineApiMatchedSetSlicesRequest
 */
export interface MatchingEngineApiMatchedSetSlicesRequest {
    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiMatchedSetSlices
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiMatchedSetSlices
     */
    readonly offset?: number | null
}

/**
 * Request parameters for matchedSetTrials operation in MatchingEngineApi.
 * @export
 * @interface MatchingEngineApiMatchedSetTrialsRequest
 */
export interface MatchingEngineApiMatchedSetTrialsRequest {
    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiMatchedSetTrials
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiMatchedSetTrials
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiMatchedSetTrials
     */
    readonly disease?: string

    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiMatchedSetTrials
     */
    readonly country?: string
}

/**
 * Request parameters for parityDivergences operation in MatchingEngineApi.
 * @export
 * @interface MatchingEngineApiParityDivergencesRequest
 */
export interface MatchingEngineApiParityDivergencesRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiParityDivergences
     */
    readonly trialId: string

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParityDivergences
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParityDivergences
     */
    readonly offset?: number | null

    /**
     * Omitted means divergences only — the review screen\&#39;s question. Pass &#x60;false&#x60; to drop into the agreements for context.  Typed as a string enum rather than a boolean: &#x60;enableImplicitConversion&#x60; coerces a boolean-typed query param with &#x60;Boolean(value)&#x60; before any &#x60;@Transform&#x60; can see the raw text, so &#x60;\&#39;false\&#39;&#x60; would arrive &#x60;true&#x60;. The handler reads the literal.
     * @type {'true' | 'false'}
     * @memberof MatchingEngineApiParityDivergences
     */
    readonly mismatchOnly?: ParityDivergencesMismatchOnlyEnum

    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiParityDivergences
     */
    readonly disease?: string

    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiParityDivergences
     */
    readonly country?: string
}

/**
 * Request parameters for parityGroupedTrials operation in MatchingEngineApi.
 * @export
 * @interface MatchingEngineApiParityGroupedTrialsRequest
 */
export interface MatchingEngineApiParityGroupedTrialsRequest {
    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParityGroupedTrials
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParityGroupedTrials
     */
    readonly offset?: number | null

    /**
     * 
     * @type {RolloutStage}
     * @memberof MatchingEngineApiParityGroupedTrials
     */
    readonly stage?: RolloutStage

    /**
     * &#x60;Type(() &#x3D;&gt; String)&#x60; + &#x60;Transform&#x60; guard against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60; — it coerces on the reflected type, so on a &#x60;boolean&#x60; it would run &#x60;Boolean(\&#39;false\&#39;)&#x60; → &#x60;true&#x60; before &#x60;Transform&#x60; sees the raw value.
     * @type {boolean}
     * @memberof MatchingEngineApiParityGroupedTrials
     */
    readonly mismatchesOnly?: boolean
}

/**
 * Request parameters for paritySlices operation in MatchingEngineApi.
 * @export
 * @interface MatchingEngineApiParitySlicesRequest
 */
export interface MatchingEngineApiParitySlicesRequest {
    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParitySlices
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParitySlices
     */
    readonly offset?: number | null

    /**
     * 
     * @type {ReviewableRolloutStage}
     * @memberof MatchingEngineApiParitySlices
     */
    readonly stage?: ReviewableRolloutStage

    /**
     * &#x60;Type(() &#x3D;&gt; String)&#x60; + &#x60;Transform&#x60; guard against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60;. The String declaration is what makes it work: implicit conversion coerces on the reflected type, so on a &#x60;boolean&#x60; it runs &#x60;Boolean(\&#39;false\&#39;)&#x60; → &#x60;true&#x60; before &#x60;Transform&#x60; sees the raw value.
     * @type {boolean}
     * @memberof MatchingEngineApiParitySlices
     */
    readonly mismatchesOnly?: boolean
}

/**
 * Request parameters for parityTrialSlices operation in MatchingEngineApi.
 * @export
 * @interface MatchingEngineApiParityTrialSlicesRequest
 */
export interface MatchingEngineApiParityTrialSlicesRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiParityTrialSlices
     */
    readonly trialId: string

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParityTrialSlices
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParityTrialSlices
     */
    readonly offset?: number | null
}

/**
 * Request parameters for parityTrials operation in MatchingEngineApi.
 * @export
 * @interface MatchingEngineApiParityTrialsRequest
 */
export interface MatchingEngineApiParityTrialsRequest {
    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParityTrials
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof MatchingEngineApiParityTrials
     */
    readonly offset?: number | null

    /**
     * 
     * @type {RolloutStage}
     * @memberof MatchingEngineApiParityTrials
     */
    readonly stage?: RolloutStage

    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiParityTrials
     */
    readonly disease?: string

    /**
     * 
     * @type {string}
     * @memberof MatchingEngineApiParityTrials
     */
    readonly country?: string

    /**
     * &#x60;Transform&#x60; guards against &#x60;enableImplicitConversion&#x60; reading &#x60;\&#39;false\&#39;&#x60; as &#x60;true&#x60;.
     * @type {boolean}
     * @memberof MatchingEngineApiParityTrials
     */
    readonly mismatchesOnly?: boolean
}

/**
 * MatchingEngineApi - object-oriented interface
 * @export
 * @class MatchingEngineApi
 * @extends {BaseAPI}
 */
export class MatchingEngineApi extends BaseAPI {
    /**
     * 
     * @summary per-patient legacy→engine status pairs for one trial (parity review)
     * @param {MatchingEngineApiMatchedSetPatientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public matchedSetPatients(requestParameters: MatchingEngineApiMatchedSetPatientsRequest, options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).matchedSetPatients(requestParameters.trialId, requestParameters.limit, requestParameters.offset, requestParameters.disease, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary legacy-vs-engine matched-set rollup per slice (parity review)
     * @param {MatchingEngineApiMatchedSetSlicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public matchedSetSlices(requestParameters: MatchingEngineApiMatchedSetSlicesRequest = {}, options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).matchedSetSlices(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary legacy-vs-engine matched sets per (trial, slice), biggest delta first
     * @param {MatchingEngineApiMatchedSetTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public matchedSetTrials(requestParameters: MatchingEngineApiMatchedSetTrialsRequest = {}, options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).matchedSetTrials(requestParameters.limit, requestParameters.offset, requestParameters.disease, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary bitmap-vs-walker parity counters per trial (rollout gate)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public parity(options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).parity(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary recorded comparisons for a trial, newest first (parity review)
     * @param {MatchingEngineApiParityDivergencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public parityDivergences(requestParameters: MatchingEngineApiParityDivergencesRequest, options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).parityDivergences(requestParameters.trialId, requestParameters.limit, requestParameters.offset, requestParameters.mismatchOnly, requestParameters.disease, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary trials with every slice they cover, paged over trials (parity review)
     * @param {MatchingEngineApiParityGroupedTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public parityGroupedTrials(requestParameters: MatchingEngineApiParityGroupedTrialsRequest = {}, options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).parityGroupedTrials(requestParameters.limit, requestParameters.offset, requestParameters.stage, requestParameters.mismatchesOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary slices that have left legacy, with trial counts (parity review)
     * @param {MatchingEngineApiParitySlicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public paritySlices(requestParameters: MatchingEngineApiParitySlicesRequest = {}, options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).paritySlices(requestParameters.limit, requestParameters.offset, requestParameters.stage, requestParameters.mismatchesOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary a trial\'s slice footprint, each slice with its own stage (parity review)
     * @param {MatchingEngineApiParityTrialSlicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public parityTrialSlices(requestParameters: MatchingEngineApiParityTrialSlicesRequest, options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).parityTrialSlices(requestParameters.trialId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary trials per slice ranked by mismatch ratio (parity review)
     * @param {MatchingEngineApiParityTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public parityTrials(requestParameters: MatchingEngineApiParityTrialsRequest = {}, options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).parityTrials(requestParameters.limit, requestParameters.offset, requestParameters.stage, requestParameters.disease, requestParameters.country, requestParameters.mismatchesOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary queue a fleet-wide bitmap engine rebuild from source (admin recovery)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchingEngineApi
     */
    public rebuild(options?: RawAxiosRequestConfig) {
        return MatchingEngineApiFp(this.configuration).rebuild(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ParityDivergencesMismatchOnlyEnum = {
    True: 'true',
    False: 'false'
} as const;
export type ParityDivergencesMismatchOnlyEnum = typeof ParityDivergencesMismatchOnlyEnum[keyof typeof ParityDivergencesMismatchOnlyEnum];


/**
 * MilestoneApi - axios parameter creator
 * @export
 */
export const MilestoneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new language translation for a milestone
         * @param {string} id 
         * @param {MilestoneAddTranslationBody} milestoneAddTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTranslation: async (id: string, milestoneAddTranslationBody: MilestoneAddTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTranslation', 'id', id)
            // verify required parameter 'milestoneAddTranslationBody' is not null or undefined
            assertParamExists('addTranslation', 'milestoneAddTranslationBody', milestoneAddTranslationBody)
            const localVarPath = `/milestone/{id}/translation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(milestoneAddTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a link for a milestone
         * @param {string} id 
         * @param {MilestoneLinkBody} milestoneLinkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLink: async (id: string, milestoneLinkBody: MilestoneLinkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createLink', 'id', id)
            // verify required parameter 'milestoneLinkBody' is not null or undefined
            assertParamExists('createLink', 'milestoneLinkBody', milestoneLinkBody)
            const localVarPath = `/milestone/{id}/link`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(milestoneLinkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a milestone
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMilestone: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMilestone', 'id', id)
            const localVarPath = `/milestone/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get milestone details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMilestone: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMilestone', 'id', id)
            const localVarPath = `/milestone/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update milestone properties
         * @param {string} id 
         * @param {MilestoneUpdateBody} milestoneUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMilestone: async (id: string, milestoneUpdateBody: MilestoneUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMilestone', 'id', id)
            // verify required parameter 'milestoneUpdateBody' is not null or undefined
            assertParamExists('updateMilestone', 'milestoneUpdateBody', milestoneUpdateBody)
            const localVarPath = `/milestone/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(milestoneUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an attachment for a milestone
         * @param {string} id 
         * @param {MilestoneUploadAttachmentBody} milestoneUploadAttachmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: async (id: string, milestoneUploadAttachmentBody: MilestoneUploadAttachmentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadAttachment', 'id', id)
            // verify required parameter 'milestoneUploadAttachmentBody' is not null or undefined
            assertParamExists('uploadAttachment', 'milestoneUploadAttachmentBody', milestoneUploadAttachmentBody)
            const localVarPath = `/milestone/{id}/attachment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(milestoneUploadAttachmentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MilestoneApi - functional programming interface
 * @export
 */
export const MilestoneApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MilestoneApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a new language translation for a milestone
         * @param {string} id 
         * @param {MilestoneAddTranslationBody} milestoneAddTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTranslation(id: string, milestoneAddTranslationBody: MilestoneAddTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTranslation(id, milestoneAddTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneApi.addTranslation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a link for a milestone
         * @param {string} id 
         * @param {MilestoneLinkBody} milestoneLinkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLink(id: string, milestoneLinkBody: MilestoneLinkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilestoneLinkView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLink(id, milestoneLinkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneApi.createLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a milestone
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMilestone(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMilestone(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneApi.deleteMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get milestone details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMilestone(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilestoneView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMilestone(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneApi.getMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update milestone properties
         * @param {string} id 
         * @param {MilestoneUpdateBody} milestoneUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMilestone(id: string, milestoneUpdateBody: MilestoneUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMilestone(id, milestoneUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneApi.updateMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload an attachment for a milestone
         * @param {string} id 
         * @param {MilestoneUploadAttachmentBody} milestoneUploadAttachmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachment(id: string, milestoneUploadAttachmentBody: MilestoneUploadAttachmentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilestoneAttachmentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachment(id, milestoneUploadAttachmentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneApi.uploadAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MilestoneApi - factory interface
 * @export
 */
export const MilestoneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MilestoneApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a new language translation for a milestone
         * @param {MilestoneApiAddTranslationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTranslation(requestParameters: MilestoneApiAddTranslationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addTranslation(requestParameters.id, requestParameters.milestoneAddTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a link for a milestone
         * @param {MilestoneApiCreateLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLink(requestParameters: MilestoneApiCreateLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<MilestoneLinkView> {
            return localVarFp.createLink(requestParameters.id, requestParameters.milestoneLinkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a milestone
         * @param {MilestoneApiDeleteMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMilestone(requestParameters: MilestoneApiDeleteMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMilestone(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get milestone details
         * @param {MilestoneApiGetMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMilestone(requestParameters: MilestoneApiGetMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<MilestoneView> {
            return localVarFp.getMilestone(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update milestone properties
         * @param {MilestoneApiUpdateMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMilestone(requestParameters: MilestoneApiUpdateMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMilestone(requestParameters.id, requestParameters.milestoneUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an attachment for a milestone
         * @param {MilestoneApiUploadAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(requestParameters: MilestoneApiUploadAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<MilestoneAttachmentView> {
            return localVarFp.uploadAttachment(requestParameters.id, requestParameters.milestoneUploadAttachmentBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addTranslation operation in MilestoneApi.
 * @export
 * @interface MilestoneApiAddTranslationRequest
 */
export interface MilestoneApiAddTranslationRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneApiAddTranslation
     */
    readonly id: string

    /**
     * 
     * @type {MilestoneAddTranslationBody}
     * @memberof MilestoneApiAddTranslation
     */
    readonly milestoneAddTranslationBody: MilestoneAddTranslationBody
}

/**
 * Request parameters for createLink operation in MilestoneApi.
 * @export
 * @interface MilestoneApiCreateLinkRequest
 */
export interface MilestoneApiCreateLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneApiCreateLink
     */
    readonly id: string

    /**
     * 
     * @type {MilestoneLinkBody}
     * @memberof MilestoneApiCreateLink
     */
    readonly milestoneLinkBody: MilestoneLinkBody
}

/**
 * Request parameters for deleteMilestone operation in MilestoneApi.
 * @export
 * @interface MilestoneApiDeleteMilestoneRequest
 */
export interface MilestoneApiDeleteMilestoneRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneApiDeleteMilestone
     */
    readonly id: string
}

/**
 * Request parameters for getMilestone operation in MilestoneApi.
 * @export
 * @interface MilestoneApiGetMilestoneRequest
 */
export interface MilestoneApiGetMilestoneRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneApiGetMilestone
     */
    readonly id: string
}

/**
 * Request parameters for updateMilestone operation in MilestoneApi.
 * @export
 * @interface MilestoneApiUpdateMilestoneRequest
 */
export interface MilestoneApiUpdateMilestoneRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneApiUpdateMilestone
     */
    readonly id: string

    /**
     * 
     * @type {MilestoneUpdateBody}
     * @memberof MilestoneApiUpdateMilestone
     */
    readonly milestoneUpdateBody: MilestoneUpdateBody
}

/**
 * Request parameters for uploadAttachment operation in MilestoneApi.
 * @export
 * @interface MilestoneApiUploadAttachmentRequest
 */
export interface MilestoneApiUploadAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneApiUploadAttachment
     */
    readonly id: string

    /**
     * 
     * @type {MilestoneUploadAttachmentBody}
     * @memberof MilestoneApiUploadAttachment
     */
    readonly milestoneUploadAttachmentBody: MilestoneUploadAttachmentBody
}

/**
 * MilestoneApi - object-oriented interface
 * @export
 * @class MilestoneApi
 * @extends {BaseAPI}
 */
export class MilestoneApi extends BaseAPI {
    /**
     * 
     * @summary Add a new language translation for a milestone
     * @param {MilestoneApiAddTranslationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneApi
     */
    public addTranslation(requestParameters: MilestoneApiAddTranslationRequest, options?: RawAxiosRequestConfig) {
        return MilestoneApiFp(this.configuration).addTranslation(requestParameters.id, requestParameters.milestoneAddTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a link for a milestone
     * @param {MilestoneApiCreateLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneApi
     */
    public createLink(requestParameters: MilestoneApiCreateLinkRequest, options?: RawAxiosRequestConfig) {
        return MilestoneApiFp(this.configuration).createLink(requestParameters.id, requestParameters.milestoneLinkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a milestone
     * @param {MilestoneApiDeleteMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneApi
     */
    public deleteMilestone(requestParameters: MilestoneApiDeleteMilestoneRequest, options?: RawAxiosRequestConfig) {
        return MilestoneApiFp(this.configuration).deleteMilestone(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get milestone details
     * @param {MilestoneApiGetMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneApi
     */
    public getMilestone(requestParameters: MilestoneApiGetMilestoneRequest, options?: RawAxiosRequestConfig) {
        return MilestoneApiFp(this.configuration).getMilestone(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update milestone properties
     * @param {MilestoneApiUpdateMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneApi
     */
    public updateMilestone(requestParameters: MilestoneApiUpdateMilestoneRequest, options?: RawAxiosRequestConfig) {
        return MilestoneApiFp(this.configuration).updateMilestone(requestParameters.id, requestParameters.milestoneUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an attachment for a milestone
     * @param {MilestoneApiUploadAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneApi
     */
    public uploadAttachment(requestParameters: MilestoneApiUploadAttachmentRequest, options?: RawAxiosRequestConfig) {
        return MilestoneApiFp(this.configuration).uploadAttachment(requestParameters.id, requestParameters.milestoneUploadAttachmentBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MilestoneAttachmentApi - axios parameter creator
 * @export
 */
export const MilestoneAttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a milestone attachment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAttachment', 'id', id)
            const localVarPath = `/milestone-attachment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get presigned download URL for an attachment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUrl: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDownloadUrl', 'id', id)
            const localVarPath = `/milestone-attachment/{id}/url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MilestoneAttachmentApi - functional programming interface
 * @export
 */
export const MilestoneAttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MilestoneAttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a milestone attachment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneAttachmentApi.deleteAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get presigned download URL for an attachment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadUrl(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilestoneAttachmentUrlView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadUrl(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneAttachmentApi.getDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MilestoneAttachmentApi - factory interface
 * @export
 */
export const MilestoneAttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MilestoneAttachmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a milestone attachment
         * @param {MilestoneAttachmentApiDeleteAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(requestParameters: MilestoneAttachmentApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAttachment(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get presigned download URL for an attachment
         * @param {MilestoneAttachmentApiGetDownloadUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUrl(requestParameters: MilestoneAttachmentApiGetDownloadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<MilestoneAttachmentUrlView> {
            return localVarFp.getDownloadUrl(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteAttachment operation in MilestoneAttachmentApi.
 * @export
 * @interface MilestoneAttachmentApiDeleteAttachmentRequest
 */
export interface MilestoneAttachmentApiDeleteAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneAttachmentApiDeleteAttachment
     */
    readonly id: string
}

/**
 * Request parameters for getDownloadUrl operation in MilestoneAttachmentApi.
 * @export
 * @interface MilestoneAttachmentApiGetDownloadUrlRequest
 */
export interface MilestoneAttachmentApiGetDownloadUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneAttachmentApiGetDownloadUrl
     */
    readonly id: string
}

/**
 * MilestoneAttachmentApi - object-oriented interface
 * @export
 * @class MilestoneAttachmentApi
 * @extends {BaseAPI}
 */
export class MilestoneAttachmentApi extends BaseAPI {
    /**
     * 
     * @summary Delete a milestone attachment
     * @param {MilestoneAttachmentApiDeleteAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneAttachmentApi
     */
    public deleteAttachment(requestParameters: MilestoneAttachmentApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig) {
        return MilestoneAttachmentApiFp(this.configuration).deleteAttachment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get presigned download URL for an attachment
     * @param {MilestoneAttachmentApiGetDownloadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneAttachmentApi
     */
    public getDownloadUrl(requestParameters: MilestoneAttachmentApiGetDownloadUrlRequest, options?: RawAxiosRequestConfig) {
        return MilestoneAttachmentApiFp(this.configuration).getDownloadUrl(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MilestoneLinkApi - axios parameter creator
 * @export
 */
export const MilestoneLinkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a milestone link
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLink: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLink', 'id', id)
            const localVarPath = `/milestone-link/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a milestone link
         * @param {string} id 
         * @param {MilestoneLinkUpdateBody} milestoneLinkUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLink: async (id: string, milestoneLinkUpdateBody: MilestoneLinkUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLink', 'id', id)
            // verify required parameter 'milestoneLinkUpdateBody' is not null or undefined
            assertParamExists('updateLink', 'milestoneLinkUpdateBody', milestoneLinkUpdateBody)
            const localVarPath = `/milestone-link/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(milestoneLinkUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MilestoneLinkApi - functional programming interface
 * @export
 */
export const MilestoneLinkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MilestoneLinkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a milestone link
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLink(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLink(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneLinkApi.deleteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a milestone link
         * @param {string} id 
         * @param {MilestoneLinkUpdateBody} milestoneLinkUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLink(id: string, milestoneLinkUpdateBody: MilestoneLinkUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilestoneLinkView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLink(id, milestoneLinkUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneLinkApi.updateLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MilestoneLinkApi - factory interface
 * @export
 */
export const MilestoneLinkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MilestoneLinkApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a milestone link
         * @param {MilestoneLinkApiDeleteLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLink(requestParameters: MilestoneLinkApiDeleteLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLink(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a milestone link
         * @param {MilestoneLinkApiUpdateLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLink(requestParameters: MilestoneLinkApiUpdateLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<MilestoneLinkView> {
            return localVarFp.updateLink(requestParameters.id, requestParameters.milestoneLinkUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteLink operation in MilestoneLinkApi.
 * @export
 * @interface MilestoneLinkApiDeleteLinkRequest
 */
export interface MilestoneLinkApiDeleteLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneLinkApiDeleteLink
     */
    readonly id: string
}

/**
 * Request parameters for updateLink operation in MilestoneLinkApi.
 * @export
 * @interface MilestoneLinkApiUpdateLinkRequest
 */
export interface MilestoneLinkApiUpdateLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneLinkApiUpdateLink
     */
    readonly id: string

    /**
     * 
     * @type {MilestoneLinkUpdateBody}
     * @memberof MilestoneLinkApiUpdateLink
     */
    readonly milestoneLinkUpdateBody: MilestoneLinkUpdateBody
}

/**
 * MilestoneLinkApi - object-oriented interface
 * @export
 * @class MilestoneLinkApi
 * @extends {BaseAPI}
 */
export class MilestoneLinkApi extends BaseAPI {
    /**
     * 
     * @summary Delete a milestone link
     * @param {MilestoneLinkApiDeleteLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneLinkApi
     */
    public deleteLink(requestParameters: MilestoneLinkApiDeleteLinkRequest, options?: RawAxiosRequestConfig) {
        return MilestoneLinkApiFp(this.configuration).deleteLink(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a milestone link
     * @param {MilestoneLinkApiUpdateLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneLinkApi
     */
    public updateLink(requestParameters: MilestoneLinkApiUpdateLinkRequest, options?: RawAxiosRequestConfig) {
        return MilestoneLinkApiFp(this.configuration).updateLink(requestParameters.id, requestParameters.milestoneLinkUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MilestoneTranslationApi - axios parameter creator
 * @export
 */
export const MilestoneTranslationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a milestone translation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTranslation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTranslation', 'id', id)
            const localVarPath = `/milestone-translation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a milestone translation
         * @param {string} id 
         * @param {MilestoneTranslationUpdateBody} milestoneTranslationUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTranslation: async (id: string, milestoneTranslationUpdateBody: MilestoneTranslationUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTranslation', 'id', id)
            // verify required parameter 'milestoneTranslationUpdateBody' is not null or undefined
            assertParamExists('updateTranslation', 'milestoneTranslationUpdateBody', milestoneTranslationUpdateBody)
            const localVarPath = `/milestone-translation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(milestoneTranslationUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MilestoneTranslationApi - functional programming interface
 * @export
 */
export const MilestoneTranslationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MilestoneTranslationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a milestone translation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTranslation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTranslation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneTranslationApi.deleteTranslation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a milestone translation
         * @param {string} id 
         * @param {MilestoneTranslationUpdateBody} milestoneTranslationUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTranslation(id: string, milestoneTranslationUpdateBody: MilestoneTranslationUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTranslation(id, milestoneTranslationUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MilestoneTranslationApi.updateTranslation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MilestoneTranslationApi - factory interface
 * @export
 */
export const MilestoneTranslationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MilestoneTranslationApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a milestone translation
         * @param {MilestoneTranslationApiDeleteTranslationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTranslation(requestParameters: MilestoneTranslationApiDeleteTranslationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTranslation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a milestone translation
         * @param {MilestoneTranslationApiUpdateTranslationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTranslation(requestParameters: MilestoneTranslationApiUpdateTranslationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTranslation(requestParameters.id, requestParameters.milestoneTranslationUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteTranslation operation in MilestoneTranslationApi.
 * @export
 * @interface MilestoneTranslationApiDeleteTranslationRequest
 */
export interface MilestoneTranslationApiDeleteTranslationRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationApiDeleteTranslation
     */
    readonly id: string
}

/**
 * Request parameters for updateTranslation operation in MilestoneTranslationApi.
 * @export
 * @interface MilestoneTranslationApiUpdateTranslationRequest
 */
export interface MilestoneTranslationApiUpdateTranslationRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneTranslationApiUpdateTranslation
     */
    readonly id: string

    /**
     * 
     * @type {MilestoneTranslationUpdateBody}
     * @memberof MilestoneTranslationApiUpdateTranslation
     */
    readonly milestoneTranslationUpdateBody: MilestoneTranslationUpdateBody
}

/**
 * MilestoneTranslationApi - object-oriented interface
 * @export
 * @class MilestoneTranslationApi
 * @extends {BaseAPI}
 */
export class MilestoneTranslationApi extends BaseAPI {
    /**
     * 
     * @summary Delete a milestone translation
     * @param {MilestoneTranslationApiDeleteTranslationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneTranslationApi
     */
    public deleteTranslation(requestParameters: MilestoneTranslationApiDeleteTranslationRequest, options?: RawAxiosRequestConfig) {
        return MilestoneTranslationApiFp(this.configuration).deleteTranslation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a milestone translation
     * @param {MilestoneTranslationApiUpdateTranslationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MilestoneTranslationApi
     */
    public updateTranslation(requestParameters: MilestoneTranslationApiUpdateTranslationRequest, options?: RawAxiosRequestConfig) {
        return MilestoneTranslationApiFp(this.configuration).updateTranslation(requestParameters.id, requestParameters.milestoneTranslationUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get notifications.
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get count of unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadNotificationsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/unread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary mark notifications as read.
         * @param {NotificationReadBody} notificationReadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsAsRead: async (notificationReadBody: NotificationReadBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationReadBody' is not null or undefined
            assertParamExists('markNotificationsAsRead', 'notificationReadBody', notificationReadBody)
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get notifications.
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get count of unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadNotificationsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationCountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadNotificationsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getUnreadNotificationsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary mark notifications as read.
         * @param {NotificationReadBody} notificationReadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationsAsRead(notificationReadBody: NotificationReadBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationsAsRead(notificationReadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markNotificationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary get notifications.
         * @param {NotificationsApiGetNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(requestParameters: NotificationsApiGetNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<NotificationListView> {
            return localVarFp.getNotifications(requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get count of unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadNotificationsCount(options?: RawAxiosRequestConfig): AxiosPromise<NotificationCountView> {
            return localVarFp.getUnreadNotificationsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary mark notifications as read.
         * @param {NotificationsApiMarkNotificationsAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsAsRead(requestParameters: NotificationsApiMarkNotificationsAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markNotificationsAsRead(requestParameters.notificationReadBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getNotifications operation in NotificationsApi.
 * @export
 * @interface NotificationsApiGetNotificationsRequest
 */
export interface NotificationsApiGetNotificationsRequest {
    /**
     * 
     * @type {number}
     * @memberof NotificationsApiGetNotifications
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiGetNotifications
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for markNotificationsAsRead operation in NotificationsApi.
 * @export
 * @interface NotificationsApiMarkNotificationsAsReadRequest
 */
export interface NotificationsApiMarkNotificationsAsReadRequest {
    /**
     * 
     * @type {NotificationReadBody}
     * @memberof NotificationsApiMarkNotificationsAsRead
     */
    readonly notificationReadBody: NotificationReadBody
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary get notifications.
     * @param {NotificationsApiGetNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(requestParameters: NotificationsApiGetNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotifications(requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get count of unread notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getUnreadNotificationsCount(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getUnreadNotificationsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary mark notifications as read.
     * @param {NotificationsApiMarkNotificationsAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markNotificationsAsRead(requestParameters: NotificationsApiMarkNotificationsAsReadRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markNotificationsAsRead(requestParameters.notificationReadBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OriginalCriteriaApi - axios parameter creator
 * @export
 */
export const OriginalCriteriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary fetch an OriginalCriterion by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detail', 'id', id)
            const localVarPath = `/original-criteria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list OriginalCriteria for a trial
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PipelineReviewStatus} [splitStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (trialId: string, limit?: number | null, offset?: number | null, splitStatus?: PipelineReviewStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('list', 'trialId', trialId)
            const localVarPath = `/original-criteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (splitStatus !== undefined) {
                localVarQueryParameter['splitStatus'] = splitStatus;
            }

            if (trialId !== undefined) {
                localVarQueryParameter['trialId'] = trialId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list Predicates derived from a single OriginalCriterion (atomic split fan-out)
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PipelineReviewStatus} [status] 
         * @param {CriteriaType} [criteriaType] 
         * @param {LibraryDecision} [libraryDecision] 
         * @param {PredicateLibraryGap} [libraryGap] What the row still needs from the library — the same discriminator the reviewer UI branches on, and the only one that reads a cross-trial queue correctly. &#x60;libraryDecision&#x60; cannot: Step 4 splits a single gap across &#x60;QUEUE_FOR_LIBRARY&#x60; and &#x60;FLAG_FOR_REVIEW&#x60; on how many personas agreed, so filtering by it hides the lower-confidence half of the same queue.
         * @param {TemporalBoundsUnit} [temporalBoundsUnit] 
         * @param {PipelineReviewStatus} [ontologyStatus] The ontology-review axis, independent of &#x60;status&#x60; — the review pane\&#39;s status buckets.
         * @param {PipelineReviewStatus} [prescreenStatus] The prescreen-review axis (Step 6), independent of &#x60;status&#x60; — same status buckets.
         * @param {PipelineReviewStatus} [qualityCheckStatus] The quality-check axis (Step 7), independent of &#x60;status&#x60; — the review pane\&#39;s status buckets. Same &#x60;PipelineReviewStatus&#x60; vocabulary as the axes above, kept as a separate filter because it is a separate axis.
         * @param {string} [trialId] 
         * @param {string} [canonicalType] 
         * @param {string} [predicateLibraryItemId] The resolved category itself, where its whole natural key matters and not just the slug.
         * @param {string} [search] 
         * @param {string} [proposedCanonicalType] The canonical type the vote asked for, on a row that has no category to filter by. &#x60;canonicalType&#x60; joins the *resolved* &#x60;PredicateLibraryItem&#x60;, which is null on exactly the rows a &#x60;new_concept&#x60; queue is made of.
         * @param {string} [proposedField] 
         * @param {string} [proposedUnit] Part of a proposed category\&#39;s natural key, so a queue group is only itself with it: the same type and field in two units are two categories. Empty string means \&quot;proposed without a unit\&quot; — omitting it would filter on nothing and pull the other units\&#39; rows back in.
         * @param {string} [proposedProjectionType] The projection the vote asked for. Empty string means \&quot;the vote named none\&quot;.
         * @param {number} [temporalBoundsValue] The predicate\&#39;s own window. Only identifies a group on a proposed &#x60;count&#x60;, where the window is part of the projection; on every other type it is a per-trial matching filter and varies across the rows of one group.
         * @param {string} [originalCriterionId] 
         * @param {string} [cohortId] 
         * @param {boolean | null} [includeRejected] Lifts the ancestor filter, so the atoms of a criterion whose split was rejected are returned too. Only Step 3\&#39;s review pane sets it: rejecting is what discards those atoms, and the pane has to show the reviewer what their verdict removed. Nothing that consumes a predicate may pass it - a rejected criterion\&#39;s atoms are dead for every downstream purpose.  &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
         * @param {boolean | null} [askedOnly] Only the rows the eligibility chat asks: Step 6 kept them or has not ruled yet. The Step 4, 5 and 7 panes set it, because those steps never process a SKIP or SITE_VERIFIED row. &#x60;| null&#x60; for the same reason as &#x60;includeRejected&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPredicates: async (id: string, limit?: number | null, offset?: number | null, status?: PipelineReviewStatus, criteriaType?: CriteriaType, libraryDecision?: LibraryDecision, libraryGap?: PredicateLibraryGap, temporalBoundsUnit?: TemporalBoundsUnit, ontologyStatus?: PipelineReviewStatus, prescreenStatus?: PipelineReviewStatus, qualityCheckStatus?: PipelineReviewStatus, trialId?: string, canonicalType?: string, predicateLibraryItemId?: string, search?: string, proposedCanonicalType?: string, proposedField?: string, proposedUnit?: string, proposedProjectionType?: string, temporalBoundsValue?: number, originalCriterionId?: string, cohortId?: string, includeRejected?: boolean | null, askedOnly?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listPredicates', 'id', id)
            const localVarPath = `/original-criteria/{id}/predicates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (criteriaType !== undefined) {
                localVarQueryParameter['criteriaType'] = criteriaType;
            }

            if (libraryDecision !== undefined) {
                localVarQueryParameter['libraryDecision'] = libraryDecision;
            }

            if (libraryGap !== undefined) {
                localVarQueryParameter['libraryGap'] = libraryGap;
            }

            if (temporalBoundsUnit !== undefined) {
                localVarQueryParameter['temporalBoundsUnit'] = temporalBoundsUnit;
            }

            if (ontologyStatus !== undefined) {
                localVarQueryParameter['ontologyStatus'] = ontologyStatus;
            }

            if (prescreenStatus !== undefined) {
                localVarQueryParameter['prescreenStatus'] = prescreenStatus;
            }

            if (qualityCheckStatus !== undefined) {
                localVarQueryParameter['qualityCheckStatus'] = qualityCheckStatus;
            }

            if (trialId !== undefined) {
                localVarQueryParameter['trialId'] = trialId;
            }

            if (canonicalType !== undefined) {
                localVarQueryParameter['canonicalType'] = canonicalType;
            }

            if (predicateLibraryItemId !== undefined) {
                localVarQueryParameter['predicateLibraryItemId'] = predicateLibraryItemId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (proposedCanonicalType !== undefined) {
                localVarQueryParameter['proposedCanonicalType'] = proposedCanonicalType;
            }

            if (proposedField !== undefined) {
                localVarQueryParameter['proposedField'] = proposedField;
            }

            if (proposedUnit !== undefined) {
                localVarQueryParameter['proposedUnit'] = proposedUnit;
            }

            if (proposedProjectionType !== undefined) {
                localVarQueryParameter['proposedProjectionType'] = proposedProjectionType;
            }

            if (temporalBoundsValue !== undefined) {
                localVarQueryParameter['temporalBoundsValue'] = temporalBoundsValue;
            }

            if (originalCriterionId !== undefined) {
                localVarQueryParameter['originalCriterionId'] = originalCriterionId;
            }

            if (cohortId !== undefined) {
                localVarQueryParameter['cohortId'] = cohortId;
            }

            if (includeRejected !== undefined) {
                localVarQueryParameter['includeRejected'] = includeRejected;
            }

            if (askedOnly !== undefined) {
                localVarQueryParameter['askedOnly'] = askedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary resolve an OriginalCriterion split: splitStatus (+ optional replacement boolean tree) — HITL flow (a) reviewer decision
         * @param {string} id 
         * @param {OriginalCriteriaUpdateBody} originalCriteriaUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, originalCriteriaUpdateBody: OriginalCriteriaUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'originalCriteriaUpdateBody' is not null or undefined
            assertParamExists('update', 'originalCriteriaUpdateBody', originalCriteriaUpdateBody)
            const localVarPath = `/original-criteria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(originalCriteriaUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OriginalCriteriaApi - functional programming interface
 * @export
 */
export const OriginalCriteriaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OriginalCriteriaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary fetch an OriginalCriterion by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OriginalCriterionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OriginalCriteriaApi.detail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list OriginalCriteria for a trial
         * @param {string} trialId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PipelineReviewStatus} [splitStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(trialId: string, limit?: number | null, offset?: number | null, splitStatus?: PipelineReviewStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOriginalCriterionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(trialId, limit, offset, splitStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OriginalCriteriaApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list Predicates derived from a single OriginalCriterion (atomic split fan-out)
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PipelineReviewStatus} [status] 
         * @param {CriteriaType} [criteriaType] 
         * @param {LibraryDecision} [libraryDecision] 
         * @param {PredicateLibraryGap} [libraryGap] What the row still needs from the library — the same discriminator the reviewer UI branches on, and the only one that reads a cross-trial queue correctly. &#x60;libraryDecision&#x60; cannot: Step 4 splits a single gap across &#x60;QUEUE_FOR_LIBRARY&#x60; and &#x60;FLAG_FOR_REVIEW&#x60; on how many personas agreed, so filtering by it hides the lower-confidence half of the same queue.
         * @param {TemporalBoundsUnit} [temporalBoundsUnit] 
         * @param {PipelineReviewStatus} [ontologyStatus] The ontology-review axis, independent of &#x60;status&#x60; — the review pane\&#39;s status buckets.
         * @param {PipelineReviewStatus} [prescreenStatus] The prescreen-review axis (Step 6), independent of &#x60;status&#x60; — same status buckets.
         * @param {PipelineReviewStatus} [qualityCheckStatus] The quality-check axis (Step 7), independent of &#x60;status&#x60; — the review pane\&#39;s status buckets. Same &#x60;PipelineReviewStatus&#x60; vocabulary as the axes above, kept as a separate filter because it is a separate axis.
         * @param {string} [trialId] 
         * @param {string} [canonicalType] 
         * @param {string} [predicateLibraryItemId] The resolved category itself, where its whole natural key matters and not just the slug.
         * @param {string} [search] 
         * @param {string} [proposedCanonicalType] The canonical type the vote asked for, on a row that has no category to filter by. &#x60;canonicalType&#x60; joins the *resolved* &#x60;PredicateLibraryItem&#x60;, which is null on exactly the rows a &#x60;new_concept&#x60; queue is made of.
         * @param {string} [proposedField] 
         * @param {string} [proposedUnit] Part of a proposed category\&#39;s natural key, so a queue group is only itself with it: the same type and field in two units are two categories. Empty string means \&quot;proposed without a unit\&quot; — omitting it would filter on nothing and pull the other units\&#39; rows back in.
         * @param {string} [proposedProjectionType] The projection the vote asked for. Empty string means \&quot;the vote named none\&quot;.
         * @param {number} [temporalBoundsValue] The predicate\&#39;s own window. Only identifies a group on a proposed &#x60;count&#x60;, where the window is part of the projection; on every other type it is a per-trial matching filter and varies across the rows of one group.
         * @param {string} [originalCriterionId] 
         * @param {string} [cohortId] 
         * @param {boolean | null} [includeRejected] Lifts the ancestor filter, so the atoms of a criterion whose split was rejected are returned too. Only Step 3\&#39;s review pane sets it: rejecting is what discards those atoms, and the pane has to show the reviewer what their verdict removed. Nothing that consumes a predicate may pass it - a rejected criterion\&#39;s atoms are dead for every downstream purpose.  &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
         * @param {boolean | null} [askedOnly] Only the rows the eligibility chat asks: Step 6 kept them or has not ruled yet. The Step 4, 5 and 7 panes set it, because those steps never process a SKIP or SITE_VERIFIED row. &#x60;| null&#x60; for the same reason as &#x60;includeRejected&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPredicates(id: string, limit?: number | null, offset?: number | null, status?: PipelineReviewStatus, criteriaType?: CriteriaType, libraryDecision?: LibraryDecision, libraryGap?: PredicateLibraryGap, temporalBoundsUnit?: TemporalBoundsUnit, ontologyStatus?: PipelineReviewStatus, prescreenStatus?: PipelineReviewStatus, qualityCheckStatus?: PipelineReviewStatus, trialId?: string, canonicalType?: string, predicateLibraryItemId?: string, search?: string, proposedCanonicalType?: string, proposedField?: string, proposedUnit?: string, proposedProjectionType?: string, temporalBoundsValue?: number, originalCriterionId?: string, cohortId?: string, includeRejected?: boolean | null, askedOnly?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialPredicateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPredicates(id, limit, offset, status, criteriaType, libraryDecision, libraryGap, temporalBoundsUnit, ontologyStatus, prescreenStatus, qualityCheckStatus, trialId, canonicalType, predicateLibraryItemId, search, proposedCanonicalType, proposedField, proposedUnit, proposedProjectionType, temporalBoundsValue, originalCriterionId, cohortId, includeRejected, askedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OriginalCriteriaApi.listPredicates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary resolve an OriginalCriterion split: splitStatus (+ optional replacement boolean tree) — HITL flow (a) reviewer decision
         * @param {string} id 
         * @param {OriginalCriteriaUpdateBody} originalCriteriaUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, originalCriteriaUpdateBody: OriginalCriteriaUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, originalCriteriaUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OriginalCriteriaApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OriginalCriteriaApi - factory interface
 * @export
 */
export const OriginalCriteriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OriginalCriteriaApiFp(configuration)
    return {
        /**
         * 
         * @summary fetch an OriginalCriterion by id
         * @param {OriginalCriteriaApiDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail(requestParameters: OriginalCriteriaApiDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<OriginalCriterionView> {
            return localVarFp.detail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list OriginalCriteria for a trial
         * @param {OriginalCriteriaApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: OriginalCriteriaApiListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListOriginalCriterionView> {
            return localVarFp.list(requestParameters.trialId, requestParameters.limit, requestParameters.offset, requestParameters.splitStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list Predicates derived from a single OriginalCriterion (atomic split fan-out)
         * @param {OriginalCriteriaApiListPredicatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPredicates(requestParameters: OriginalCriteriaApiListPredicatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialPredicateView> {
            return localVarFp.listPredicates(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.criteriaType, requestParameters.libraryDecision, requestParameters.libraryGap, requestParameters.temporalBoundsUnit, requestParameters.ontologyStatus, requestParameters.prescreenStatus, requestParameters.qualityCheckStatus, requestParameters.trialId, requestParameters.canonicalType, requestParameters.predicateLibraryItemId, requestParameters.search, requestParameters.proposedCanonicalType, requestParameters.proposedField, requestParameters.proposedUnit, requestParameters.proposedProjectionType, requestParameters.temporalBoundsValue, requestParameters.originalCriterionId, requestParameters.cohortId, requestParameters.includeRejected, requestParameters.askedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary resolve an OriginalCriterion split: splitStatus (+ optional replacement boolean tree) — HITL flow (a) reviewer decision
         * @param {OriginalCriteriaApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters: OriginalCriteriaApiUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.update(requestParameters.id, requestParameters.originalCriteriaUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for detail operation in OriginalCriteriaApi.
 * @export
 * @interface OriginalCriteriaApiDetailRequest
 */
export interface OriginalCriteriaApiDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiDetail
     */
    readonly id: string
}

/**
 * Request parameters for list operation in OriginalCriteriaApi.
 * @export
 * @interface OriginalCriteriaApiListRequest
 */
export interface OriginalCriteriaApiListRequest {
    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiList
     */
    readonly trialId: string

    /**
     * 
     * @type {number}
     * @memberof OriginalCriteriaApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof OriginalCriteriaApiList
     */
    readonly offset?: number | null

    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof OriginalCriteriaApiList
     */
    readonly splitStatus?: PipelineReviewStatus
}

/**
 * Request parameters for listPredicates operation in OriginalCriteriaApi.
 * @export
 * @interface OriginalCriteriaApiListPredicatesRequest
 */
export interface OriginalCriteriaApiListPredicatesRequest {
    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly offset?: number | null

    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly status?: PipelineReviewStatus

    /**
     * 
     * @type {CriteriaType}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly criteriaType?: CriteriaType

    /**
     * 
     * @type {LibraryDecision}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly libraryDecision?: LibraryDecision

    /**
     * What the row still needs from the library — the same discriminator the reviewer UI branches on, and the only one that reads a cross-trial queue correctly. &#x60;libraryDecision&#x60; cannot: Step 4 splits a single gap across &#x60;QUEUE_FOR_LIBRARY&#x60; and &#x60;FLAG_FOR_REVIEW&#x60; on how many personas agreed, so filtering by it hides the lower-confidence half of the same queue.
     * @type {PredicateLibraryGap}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly libraryGap?: PredicateLibraryGap

    /**
     * 
     * @type {TemporalBoundsUnit}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly temporalBoundsUnit?: TemporalBoundsUnit

    /**
     * The ontology-review axis, independent of &#x60;status&#x60; — the review pane\&#39;s status buckets.
     * @type {PipelineReviewStatus}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly ontologyStatus?: PipelineReviewStatus

    /**
     * The prescreen-review axis (Step 6), independent of &#x60;status&#x60; — same status buckets.
     * @type {PipelineReviewStatus}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly prescreenStatus?: PipelineReviewStatus

    /**
     * The quality-check axis (Step 7), independent of &#x60;status&#x60; — the review pane\&#39;s status buckets. Same &#x60;PipelineReviewStatus&#x60; vocabulary as the axes above, kept as a separate filter because it is a separate axis.
     * @type {PipelineReviewStatus}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly qualityCheckStatus?: PipelineReviewStatus

    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly trialId?: string

    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly canonicalType?: string

    /**
     * The resolved category itself, where its whole natural key matters and not just the slug.
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly predicateLibraryItemId?: string

    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly search?: string

    /**
     * The canonical type the vote asked for, on a row that has no category to filter by. &#x60;canonicalType&#x60; joins the *resolved* &#x60;PredicateLibraryItem&#x60;, which is null on exactly the rows a &#x60;new_concept&#x60; queue is made of.
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly proposedCanonicalType?: string

    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly proposedField?: string

    /**
     * Part of a proposed category\&#39;s natural key, so a queue group is only itself with it: the same type and field in two units are two categories. Empty string means \&quot;proposed without a unit\&quot; — omitting it would filter on nothing and pull the other units\&#39; rows back in.
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly proposedUnit?: string

    /**
     * The projection the vote asked for. Empty string means \&quot;the vote named none\&quot;.
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly proposedProjectionType?: string

    /**
     * The predicate\&#39;s own window. Only identifies a group on a proposed &#x60;count&#x60;, where the window is part of the projection; on every other type it is a per-trial matching filter and varies across the rows of one group.
     * @type {number}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly temporalBoundsValue?: number

    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly originalCriterionId?: string

    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly cohortId?: string

    /**
     * Lifts the ancestor filter, so the atoms of a criterion whose split was rejected are returned too. Only Step 3\&#39;s review pane sets it: rejecting is what discards those atoms, and the pane has to show the reviewer what their verdict removed. Nothing that consumes a predicate may pass it - a rejected criterion\&#39;s atoms are dead for every downstream purpose.  &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
     * @type {boolean}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly includeRejected?: boolean | null

    /**
     * Only the rows the eligibility chat asks: Step 6 kept them or has not ruled yet. The Step 4, 5 and 7 panes set it, because those steps never process a SKIP or SITE_VERIFIED row. &#x60;| null&#x60; for the same reason as &#x60;includeRejected&#x60;.
     * @type {boolean}
     * @memberof OriginalCriteriaApiListPredicates
     */
    readonly askedOnly?: boolean | null
}

/**
 * Request parameters for update operation in OriginalCriteriaApi.
 * @export
 * @interface OriginalCriteriaApiUpdateRequest
 */
export interface OriginalCriteriaApiUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OriginalCriteriaApiUpdate
     */
    readonly id: string

    /**
     * 
     * @type {OriginalCriteriaUpdateBody}
     * @memberof OriginalCriteriaApiUpdate
     */
    readonly originalCriteriaUpdateBody: OriginalCriteriaUpdateBody
}

/**
 * OriginalCriteriaApi - object-oriented interface
 * @export
 * @class OriginalCriteriaApi
 * @extends {BaseAPI}
 */
export class OriginalCriteriaApi extends BaseAPI {
    /**
     * 
     * @summary fetch an OriginalCriterion by id
     * @param {OriginalCriteriaApiDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OriginalCriteriaApi
     */
    public detail(requestParameters: OriginalCriteriaApiDetailRequest, options?: RawAxiosRequestConfig) {
        return OriginalCriteriaApiFp(this.configuration).detail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list OriginalCriteria for a trial
     * @param {OriginalCriteriaApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OriginalCriteriaApi
     */
    public list(requestParameters: OriginalCriteriaApiListRequest, options?: RawAxiosRequestConfig) {
        return OriginalCriteriaApiFp(this.configuration).list(requestParameters.trialId, requestParameters.limit, requestParameters.offset, requestParameters.splitStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list Predicates derived from a single OriginalCriterion (atomic split fan-out)
     * @param {OriginalCriteriaApiListPredicatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OriginalCriteriaApi
     */
    public listPredicates(requestParameters: OriginalCriteriaApiListPredicatesRequest, options?: RawAxiosRequestConfig) {
        return OriginalCriteriaApiFp(this.configuration).listPredicates(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.criteriaType, requestParameters.libraryDecision, requestParameters.libraryGap, requestParameters.temporalBoundsUnit, requestParameters.ontologyStatus, requestParameters.prescreenStatus, requestParameters.qualityCheckStatus, requestParameters.trialId, requestParameters.canonicalType, requestParameters.predicateLibraryItemId, requestParameters.search, requestParameters.proposedCanonicalType, requestParameters.proposedField, requestParameters.proposedUnit, requestParameters.proposedProjectionType, requestParameters.temporalBoundsValue, requestParameters.originalCriterionId, requestParameters.cohortId, requestParameters.includeRejected, requestParameters.askedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary resolve an OriginalCriterion split: splitStatus (+ optional replacement boolean tree) — HITL flow (a) reviewer decision
     * @param {OriginalCriteriaApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OriginalCriteriaApi
     */
    public update(requestParameters: OriginalCriteriaApiUpdateRequest, options?: RawAxiosRequestConfig) {
        return OriginalCriteriaApiFp(this.configuration).update(requestParameters.id, requestParameters.originalCriteriaUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PanelManagementApi - axios parameter creator
 * @export
 */
export const PanelManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign or unassign a team to a panel
         * @param {string} id 
         * @param {PanelAssignTeamBody} panelAssignTeamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTeam: async (id: string, panelAssignTeamBody: PanelAssignTeamBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignTeam', 'id', id)
            // verify required parameter 'panelAssignTeamBody' is not null or undefined
            assertParamExists('assignTeam', 'panelAssignTeamBody', panelAssignTeamBody)
            const localVarPath = `/panel-management/{id}/team`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(panelAssignTeamBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new panel
         * @param {PanelCreateBody} panelCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPanel: async (panelCreateBody: PanelCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'panelCreateBody' is not null or undefined
            assertParamExists('createPanel', 'panelCreateBody', panelCreateBody)
            const localVarPath = `/panel-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(panelCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a panel
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePanel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePanel', 'id', id)
            const localVarPath = `/panel-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a panel details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPanelDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPanelDetails', 'id', id)
            const localVarPath = `/panel-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all panels
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PanelOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPanels: async (limit?: number | null, offset?: number | null, searchString?: string | null, orderDirection?: OrderDirection, orderBy?: PanelOrderBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/panel-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a panel
         * @param {string} id 
         * @param {PanelUpdateBody} panelUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePanel: async (id: string, panelUpdateBody: PanelUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePanel', 'id', id)
            // verify required parameter 'panelUpdateBody' is not null or undefined
            assertParamExists('updatePanel', 'panelUpdateBody', panelUpdateBody)
            const localVarPath = `/panel-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(panelUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PanelManagementApi - functional programming interface
 * @export
 */
export const PanelManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PanelManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign or unassign a team to a panel
         * @param {string} id 
         * @param {PanelAssignTeamBody} panelAssignTeamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignTeam(id: string, panelAssignTeamBody: PanelAssignTeamBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignTeam(id, panelAssignTeamBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanelManagementApi.assignTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new panel
         * @param {PanelCreateBody} panelCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPanel(panelCreateBody: PanelCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PanelView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPanel(panelCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanelManagementApi.createPanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a panel
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePanel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePanel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanelManagementApi.deletePanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a panel details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPanelDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PanelDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPanelDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanelManagementApi.getPanelDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of all panels
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PanelOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPanels(limit?: number | null, offset?: number | null, searchString?: string | null, orderDirection?: OrderDirection, orderBy?: PanelOrderBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPanelView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPanels(limit, offset, searchString, orderDirection, orderBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanelManagementApi.getPanels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a panel
         * @param {string} id 
         * @param {PanelUpdateBody} panelUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePanel(id: string, panelUpdateBody: PanelUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePanel(id, panelUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanelManagementApi.updatePanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PanelManagementApi - factory interface
 * @export
 */
export const PanelManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PanelManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign or unassign a team to a panel
         * @param {PanelManagementApiAssignTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTeam(requestParameters: PanelManagementApiAssignTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignTeam(requestParameters.id, requestParameters.panelAssignTeamBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new panel
         * @param {PanelManagementApiCreatePanelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPanel(requestParameters: PanelManagementApiCreatePanelRequest, options?: RawAxiosRequestConfig): AxiosPromise<PanelView> {
            return localVarFp.createPanel(requestParameters.panelCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a panel
         * @param {PanelManagementApiDeletePanelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePanel(requestParameters: PanelManagementApiDeletePanelRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePanel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a panel details
         * @param {PanelManagementApiGetPanelDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPanelDetails(requestParameters: PanelManagementApiGetPanelDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PanelDetailsView> {
            return localVarFp.getPanelDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all panels
         * @param {PanelManagementApiGetPanelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPanels(requestParameters: PanelManagementApiGetPanelsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListPanelView> {
            return localVarFp.getPanels(requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.orderDirection, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a panel
         * @param {PanelManagementApiUpdatePanelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePanel(requestParameters: PanelManagementApiUpdatePanelRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePanel(requestParameters.id, requestParameters.panelUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assignTeam operation in PanelManagementApi.
 * @export
 * @interface PanelManagementApiAssignTeamRequest
 */
export interface PanelManagementApiAssignTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof PanelManagementApiAssignTeam
     */
    readonly id: string

    /**
     * 
     * @type {PanelAssignTeamBody}
     * @memberof PanelManagementApiAssignTeam
     */
    readonly panelAssignTeamBody: PanelAssignTeamBody
}

/**
 * Request parameters for createPanel operation in PanelManagementApi.
 * @export
 * @interface PanelManagementApiCreatePanelRequest
 */
export interface PanelManagementApiCreatePanelRequest {
    /**
     * 
     * @type {PanelCreateBody}
     * @memberof PanelManagementApiCreatePanel
     */
    readonly panelCreateBody: PanelCreateBody
}

/**
 * Request parameters for deletePanel operation in PanelManagementApi.
 * @export
 * @interface PanelManagementApiDeletePanelRequest
 */
export interface PanelManagementApiDeletePanelRequest {
    /**
     * 
     * @type {string}
     * @memberof PanelManagementApiDeletePanel
     */
    readonly id: string
}

/**
 * Request parameters for getPanelDetails operation in PanelManagementApi.
 * @export
 * @interface PanelManagementApiGetPanelDetailsRequest
 */
export interface PanelManagementApiGetPanelDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof PanelManagementApiGetPanelDetails
     */
    readonly id: string
}

/**
 * Request parameters for getPanels operation in PanelManagementApi.
 * @export
 * @interface PanelManagementApiGetPanelsRequest
 */
export interface PanelManagementApiGetPanelsRequest {
    /**
     * 
     * @type {number}
     * @memberof PanelManagementApiGetPanels
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof PanelManagementApiGetPanels
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof PanelManagementApiGetPanels
     */
    readonly searchString?: string | null

    /**
     * 
     * @type {OrderDirection}
     * @memberof PanelManagementApiGetPanels
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {PanelOrderBy}
     * @memberof PanelManagementApiGetPanels
     */
    readonly orderBy?: PanelOrderBy
}

/**
 * Request parameters for updatePanel operation in PanelManagementApi.
 * @export
 * @interface PanelManagementApiUpdatePanelRequest
 */
export interface PanelManagementApiUpdatePanelRequest {
    /**
     * 
     * @type {string}
     * @memberof PanelManagementApiUpdatePanel
     */
    readonly id: string

    /**
     * 
     * @type {PanelUpdateBody}
     * @memberof PanelManagementApiUpdatePanel
     */
    readonly panelUpdateBody: PanelUpdateBody
}

/**
 * PanelManagementApi - object-oriented interface
 * @export
 * @class PanelManagementApi
 * @extends {BaseAPI}
 */
export class PanelManagementApi extends BaseAPI {
    /**
     * 
     * @summary Assign or unassign a team to a panel
     * @param {PanelManagementApiAssignTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanelManagementApi
     */
    public assignTeam(requestParameters: PanelManagementApiAssignTeamRequest, options?: RawAxiosRequestConfig) {
        return PanelManagementApiFp(this.configuration).assignTeam(requestParameters.id, requestParameters.panelAssignTeamBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new panel
     * @param {PanelManagementApiCreatePanelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanelManagementApi
     */
    public createPanel(requestParameters: PanelManagementApiCreatePanelRequest, options?: RawAxiosRequestConfig) {
        return PanelManagementApiFp(this.configuration).createPanel(requestParameters.panelCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a panel
     * @param {PanelManagementApiDeletePanelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanelManagementApi
     */
    public deletePanel(requestParameters: PanelManagementApiDeletePanelRequest, options?: RawAxiosRequestConfig) {
        return PanelManagementApiFp(this.configuration).deletePanel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a panel details
     * @param {PanelManagementApiGetPanelDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanelManagementApi
     */
    public getPanelDetails(requestParameters: PanelManagementApiGetPanelDetailsRequest, options?: RawAxiosRequestConfig) {
        return PanelManagementApiFp(this.configuration).getPanelDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all panels
     * @param {PanelManagementApiGetPanelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanelManagementApi
     */
    public getPanels(requestParameters: PanelManagementApiGetPanelsRequest = {}, options?: RawAxiosRequestConfig) {
        return PanelManagementApiFp(this.configuration).getPanels(requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.orderDirection, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a panel
     * @param {PanelManagementApiUpdatePanelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanelManagementApi
     */
    public updatePanel(requestParameters: PanelManagementApiUpdatePanelRequest, options?: RawAxiosRequestConfig) {
        return PanelManagementApiFp(this.configuration).updatePanel(requestParameters.id, requestParameters.panelUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ParityRoutingApi - axios parameter creator
 * @export
 */
export const ParityRoutingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary what a stage change on one slice would move, read before the write
         * @param {RolloutStage} stage 
         * @param {string} country 
         * @param {string} [icdCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blastRadius: async (stage: RolloutStage, country: string, icdCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('blastRadius', 'stage', stage)
            // verify required parameter 'country' is not null or undefined
            assertParamExists('blastRadius', 'country', country)
            const localVarPath = `/admin/parity-routing/blast-radius`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (icdCode !== undefined) {
                localVarQueryParameter['icdCode'] = icdCode;
            }

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary countries with at least one trial site - the only values a routing row may name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/parity-routing/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary stage changes, newest first (append-only log)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [diseaseId] A disease\&#39;s own events. Pair with &#x60;includeWildcard&#x60; to also pick up the country-wide changes that moved its effective stage without naming it.
         * @param {string} [country] 
         * @param {boolean} [includeWildcard] With &#x60;diseaseId&#x60; + &#x60;country&#x60;, also return that country\&#39;s wildcard events — otherwise a slice whose stage only ever moved country-wide reads as having no history while plainly sitting at canary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        history: async (limit?: number | null, offset?: number | null, diseaseId?: string, country?: string, includeWildcard?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/parity-routing/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (diseaseId !== undefined) {
                localVarQueryParameter['diseaseId'] = diseaseId;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (includeWildcard !== undefined) {
                localVarQueryParameter['includeWildcard'] = includeWildcard;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary configured rollout stage per slice, country wildcards included
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {RolloutStage} [stage] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit?: number | null, offset?: number | null, stage?: RolloutStage, country?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/parity-routing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary queue a cohort rebuild for every trial covering one slice, so its parity evidence lands now
         * @param {SliceRebuildBody} sliceRebuildBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuild: async (sliceRebuildBody: SliceRebuildBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sliceRebuildBody' is not null or undefined
            assertParamExists('rebuild', 'sliceRebuildBody', sliceRebuildBody)
            const localVarPath = `/admin/parity-routing/rebuild`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sliceRebuildBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary remove a routing row; that slice falls back to wildcard, then legacy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/admin/parity-routing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set one slice\'s rollout stage; omit diseaseId for the whole country
         * @param {SetParityRoutingBody} setParityRoutingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        set: async (setParityRoutingBody: SetParityRoutingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setParityRoutingBody' is not null or undefined
            assertParamExists('set', 'setParityRoutingBody', setParityRoutingBody)
            const localVarPath = `/admin/parity-routing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setParityRoutingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParityRoutingApi - functional programming interface
 * @export
 */
export const ParityRoutingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParityRoutingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary what a stage change on one slice would move, read before the write
         * @param {RolloutStage} stage 
         * @param {string} country 
         * @param {string} [icdCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blastRadius(stage: RolloutStage, country: string, icdCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SliceBlastRadiusView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blastRadius(stage, country, icdCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParityRoutingApi.blastRadius']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary countries with at least one trial site - the only values a routing row may name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSliceCountryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParityRoutingApi.countries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary stage changes, newest first (append-only log)
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [diseaseId] A disease\&#39;s own events. Pair with &#x60;includeWildcard&#x60; to also pick up the country-wide changes that moved its effective stage without naming it.
         * @param {string} [country] 
         * @param {boolean} [includeWildcard] With &#x60;diseaseId&#x60; + &#x60;country&#x60;, also return that country\&#39;s wildcard events — otherwise a slice whose stage only ever moved country-wide reads as having no history while plainly sitting at canary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async history(limit?: number | null, offset?: number | null, diseaseId?: string, country?: string, includeWildcard?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListParityRoutingEventView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.history(limit, offset, diseaseId, country, includeWildcard, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParityRoutingApi.history']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary configured rollout stage per slice, country wildcards included
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {RolloutStage} [stage] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit?: number | null, offset?: number | null, stage?: RolloutStage, country?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListParityRoutingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, stage, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParityRoutingApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary queue a cohort rebuild for every trial covering one slice, so its parity evidence lands now
         * @param {SliceRebuildBody} sliceRebuildBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebuild(sliceRebuildBody: SliceRebuildBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SliceRebuildView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebuild(sliceRebuildBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParityRoutingApi.rebuild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary remove a routing row; that slice falls back to wildcard, then legacy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParityRoutingApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary set one slice\'s rollout stage; omit diseaseId for the whole country
         * @param {SetParityRoutingBody} setParityRoutingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async set(setParityRoutingBody: SetParityRoutingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParityRoutingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.set(setParityRoutingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParityRoutingApi.set']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParityRoutingApi - factory interface
 * @export
 */
export const ParityRoutingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParityRoutingApiFp(configuration)
    return {
        /**
         * 
         * @summary what a stage change on one slice would move, read before the write
         * @param {ParityRoutingApiBlastRadiusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blastRadius(requestParameters: ParityRoutingApiBlastRadiusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SliceBlastRadiusView> {
            return localVarFp.blastRadius(requestParameters.stage, requestParameters.country, requestParameters.icdCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary countries with at least one trial site - the only values a routing row may name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options?: RawAxiosRequestConfig): AxiosPromise<ListSliceCountryView> {
            return localVarFp.countries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary stage changes, newest first (append-only log)
         * @param {ParityRoutingApiHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        history(requestParameters: ParityRoutingApiHistoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListParityRoutingEventView> {
            return localVarFp.history(requestParameters.limit, requestParameters.offset, requestParameters.diseaseId, requestParameters.country, requestParameters.includeWildcard, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary configured rollout stage per slice, country wildcards included
         * @param {ParityRoutingApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: ParityRoutingApiListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListParityRoutingView> {
            return localVarFp.list(requestParameters.limit, requestParameters.offset, requestParameters.stage, requestParameters.country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary queue a cohort rebuild for every trial covering one slice, so its parity evidence lands now
         * @param {ParityRoutingApiRebuildRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuild(requestParameters: ParityRoutingApiRebuildRequest, options?: RawAxiosRequestConfig): AxiosPromise<SliceRebuildView> {
            return localVarFp.rebuild(requestParameters.sliceRebuildBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary remove a routing row; that slice falls back to wildcard, then legacy
         * @param {ParityRoutingApiRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(requestParameters: ParityRoutingApiRemoveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set one slice\'s rollout stage; omit diseaseId for the whole country
         * @param {ParityRoutingApiSetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        set(requestParameters: ParityRoutingApiSetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ParityRoutingView> {
            return localVarFp.set(requestParameters.setParityRoutingBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for blastRadius operation in ParityRoutingApi.
 * @export
 * @interface ParityRoutingApiBlastRadiusRequest
 */
export interface ParityRoutingApiBlastRadiusRequest {
    /**
     * 
     * @type {RolloutStage}
     * @memberof ParityRoutingApiBlastRadius
     */
    readonly stage: RolloutStage

    /**
     * 
     * @type {string}
     * @memberof ParityRoutingApiBlastRadius
     */
    readonly country: string

    /**
     * 
     * @type {string}
     * @memberof ParityRoutingApiBlastRadius
     */
    readonly icdCode?: string
}

/**
 * Request parameters for history operation in ParityRoutingApi.
 * @export
 * @interface ParityRoutingApiHistoryRequest
 */
export interface ParityRoutingApiHistoryRequest {
    /**
     * 
     * @type {number}
     * @memberof ParityRoutingApiHistory
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof ParityRoutingApiHistory
     */
    readonly offset?: number | null

    /**
     * A disease\&#39;s own events. Pair with &#x60;includeWildcard&#x60; to also pick up the country-wide changes that moved its effective stage without naming it.
     * @type {string}
     * @memberof ParityRoutingApiHistory
     */
    readonly diseaseId?: string

    /**
     * 
     * @type {string}
     * @memberof ParityRoutingApiHistory
     */
    readonly country?: string

    /**
     * With &#x60;diseaseId&#x60; + &#x60;country&#x60;, also return that country\&#39;s wildcard events — otherwise a slice whose stage only ever moved country-wide reads as having no history while plainly sitting at canary.
     * @type {boolean}
     * @memberof ParityRoutingApiHistory
     */
    readonly includeWildcard?: boolean
}

/**
 * Request parameters for list operation in ParityRoutingApi.
 * @export
 * @interface ParityRoutingApiListRequest
 */
export interface ParityRoutingApiListRequest {
    /**
     * 
     * @type {number}
     * @memberof ParityRoutingApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof ParityRoutingApiList
     */
    readonly offset?: number | null

    /**
     * 
     * @type {RolloutStage}
     * @memberof ParityRoutingApiList
     */
    readonly stage?: RolloutStage

    /**
     * 
     * @type {string}
     * @memberof ParityRoutingApiList
     */
    readonly country?: string
}

/**
 * Request parameters for rebuild operation in ParityRoutingApi.
 * @export
 * @interface ParityRoutingApiRebuildRequest
 */
export interface ParityRoutingApiRebuildRequest {
    /**
     * 
     * @type {SliceRebuildBody}
     * @memberof ParityRoutingApiRebuild
     */
    readonly sliceRebuildBody: SliceRebuildBody
}

/**
 * Request parameters for remove operation in ParityRoutingApi.
 * @export
 * @interface ParityRoutingApiRemoveRequest
 */
export interface ParityRoutingApiRemoveRequest {
    /**
     * 
     * @type {string}
     * @memberof ParityRoutingApiRemove
     */
    readonly id: string
}

/**
 * Request parameters for set operation in ParityRoutingApi.
 * @export
 * @interface ParityRoutingApiSetRequest
 */
export interface ParityRoutingApiSetRequest {
    /**
     * 
     * @type {SetParityRoutingBody}
     * @memberof ParityRoutingApiSet
     */
    readonly setParityRoutingBody: SetParityRoutingBody
}

/**
 * ParityRoutingApi - object-oriented interface
 * @export
 * @class ParityRoutingApi
 * @extends {BaseAPI}
 */
export class ParityRoutingApi extends BaseAPI {
    /**
     * 
     * @summary what a stage change on one slice would move, read before the write
     * @param {ParityRoutingApiBlastRadiusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParityRoutingApi
     */
    public blastRadius(requestParameters: ParityRoutingApiBlastRadiusRequest, options?: RawAxiosRequestConfig) {
        return ParityRoutingApiFp(this.configuration).blastRadius(requestParameters.stage, requestParameters.country, requestParameters.icdCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary countries with at least one trial site - the only values a routing row may name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParityRoutingApi
     */
    public countries(options?: RawAxiosRequestConfig) {
        return ParityRoutingApiFp(this.configuration).countries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary stage changes, newest first (append-only log)
     * @param {ParityRoutingApiHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParityRoutingApi
     */
    public history(requestParameters: ParityRoutingApiHistoryRequest = {}, options?: RawAxiosRequestConfig) {
        return ParityRoutingApiFp(this.configuration).history(requestParameters.limit, requestParameters.offset, requestParameters.diseaseId, requestParameters.country, requestParameters.includeWildcard, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary configured rollout stage per slice, country wildcards included
     * @param {ParityRoutingApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParityRoutingApi
     */
    public list(requestParameters: ParityRoutingApiListRequest = {}, options?: RawAxiosRequestConfig) {
        return ParityRoutingApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.stage, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary queue a cohort rebuild for every trial covering one slice, so its parity evidence lands now
     * @param {ParityRoutingApiRebuildRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParityRoutingApi
     */
    public rebuild(requestParameters: ParityRoutingApiRebuildRequest, options?: RawAxiosRequestConfig) {
        return ParityRoutingApiFp(this.configuration).rebuild(requestParameters.sliceRebuildBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary remove a routing row; that slice falls back to wildcard, then legacy
     * @param {ParityRoutingApiRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParityRoutingApi
     */
    public remove(requestParameters: ParityRoutingApiRemoveRequest, options?: RawAxiosRequestConfig) {
        return ParityRoutingApiFp(this.configuration).remove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set one slice\'s rollout stage; omit diseaseId for the whole country
     * @param {ParityRoutingApiSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParityRoutingApi
     */
    public set(requestParameters: ParityRoutingApiSetRequest, options?: RawAxiosRequestConfig) {
        return ParityRoutingApiFp(this.configuration).set(requestParameters.setParityRoutingBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PendingLocationChangeApi - axios parameter creator
 * @export
 */
export const PendingLocationChangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary approve a pending location change
         * @param {string} id 
         * @param {ApproveLocationChangeBody} approveLocationChangeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approve: async (id: string, approveLocationChangeBody: ApproveLocationChangeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approve', 'id', id)
            // verify required parameter 'approveLocationChangeBody' is not null or undefined
            assertParamExists('approve', 'approveLocationChangeBody', approveLocationChangeBody)
            const localVarPath = `/pending-location-change/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveLocationChangeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reject a pending location change
         * @param {string} id 
         * @param {RejectLocationChangeBody} rejectLocationChangeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reject: async (id: string, rejectLocationChangeBody: RejectLocationChangeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reject', 'id', id)
            // verify required parameter 'rejectLocationChangeBody' is not null or undefined
            assertParamExists('reject', 'rejectLocationChangeBody', rejectLocationChangeBody)
            const localVarPath = `/pending-location-change/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectLocationChangeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PendingLocationChangeApi - functional programming interface
 * @export
 */
export const PendingLocationChangeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PendingLocationChangeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary approve a pending location change
         * @param {string} id 
         * @param {ApproveLocationChangeBody} approveLocationChangeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approve(id: string, approveLocationChangeBody: ApproveLocationChangeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approve(id, approveLocationChangeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PendingLocationChangeApi.approve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reject a pending location change
         * @param {string} id 
         * @param {RejectLocationChangeBody} rejectLocationChangeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reject(id: string, rejectLocationChangeBody: RejectLocationChangeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reject(id, rejectLocationChangeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PendingLocationChangeApi.reject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PendingLocationChangeApi - factory interface
 * @export
 */
export const PendingLocationChangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PendingLocationChangeApiFp(configuration)
    return {
        /**
         * 
         * @summary approve a pending location change
         * @param {PendingLocationChangeApiApproveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approve(requestParameters: PendingLocationChangeApiApproveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approve(requestParameters.id, requestParameters.approveLocationChangeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reject a pending location change
         * @param {PendingLocationChangeApiRejectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reject(requestParameters: PendingLocationChangeApiRejectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reject(requestParameters.id, requestParameters.rejectLocationChangeBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approve operation in PendingLocationChangeApi.
 * @export
 * @interface PendingLocationChangeApiApproveRequest
 */
export interface PendingLocationChangeApiApproveRequest {
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeApiApprove
     */
    readonly id: string

    /**
     * 
     * @type {ApproveLocationChangeBody}
     * @memberof PendingLocationChangeApiApprove
     */
    readonly approveLocationChangeBody: ApproveLocationChangeBody
}

/**
 * Request parameters for reject operation in PendingLocationChangeApi.
 * @export
 * @interface PendingLocationChangeApiRejectRequest
 */
export interface PendingLocationChangeApiRejectRequest {
    /**
     * 
     * @type {string}
     * @memberof PendingLocationChangeApiReject
     */
    readonly id: string

    /**
     * 
     * @type {RejectLocationChangeBody}
     * @memberof PendingLocationChangeApiReject
     */
    readonly rejectLocationChangeBody: RejectLocationChangeBody
}

/**
 * PendingLocationChangeApi - object-oriented interface
 * @export
 * @class PendingLocationChangeApi
 * @extends {BaseAPI}
 */
export class PendingLocationChangeApi extends BaseAPI {
    /**
     * 
     * @summary approve a pending location change
     * @param {PendingLocationChangeApiApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PendingLocationChangeApi
     */
    public approve(requestParameters: PendingLocationChangeApiApproveRequest, options?: RawAxiosRequestConfig) {
        return PendingLocationChangeApiFp(this.configuration).approve(requestParameters.id, requestParameters.approveLocationChangeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reject a pending location change
     * @param {PendingLocationChangeApiRejectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PendingLocationChangeApi
     */
    public reject(requestParameters: PendingLocationChangeApiRejectRequest, options?: RawAxiosRequestConfig) {
        return PendingLocationChangeApiFp(this.configuration).reject(requestParameters.id, requestParameters.rejectLocationChangeBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve a trial request access.
         * @param {string} trialId 
         * @param {string} teamId 
         * @param {TrialAccessApproveBody} trialAccessApproveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTrialAccessRequest: async (trialId: string, teamId: string, trialAccessApproveBody: TrialAccessApproveBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('approveTrialAccessRequest', 'trialId', trialId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('approveTrialAccessRequest', 'teamId', teamId)
            // verify required parameter 'trialAccessApproveBody' is not null or undefined
            assertParamExists('approveTrialAccessRequest', 'trialAccessApproveBody', trialAccessApproveBody)
            const localVarPath = `/permissions/trial/{trialId}/access/{teamId}`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAccessApproveBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all trial access requests.
         * @param {AccessRequestStatus} status 
         * @param {number} [limit] 
         * @param {boolean | null} [isExistingTrial] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequests: async (status: AccessRequestStatus, limit?: number, isExistingTrial?: boolean | null, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getAccessRequests', 'status', status)
            const localVarPath = `/permissions/access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (isExistingTrial !== undefined) {
                localVarQueryParameter['isExistingTrial'] = isExistingTrial;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get count of contact permissions for a team. The count can be used to check whether this is the final person with contact details permissions in a team.
         * @param {string} trialId 
         * @param {string | null} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPermissions: async (trialId: string, teamId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('getLocationPermissions', 'trialId', trialId)
            const localVarPath = `/permissions/trial/{trialId}/location`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trial access requests for a single trial.
         * @param {string} trialId 
         * @param {AccessRequestStatus} status 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialAccessRequests: async (trialId: string, status: AccessRequestStatus, limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('getTrialAccessRequests', 'trialId', trialId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getTrialAccessRequests', 'status', status)
            const localVarPath = `/permissions/trial/{trialId}/access`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get permissions of a user for a trial.
         * @param {string} trialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrialPermissions: async (trialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('getUserTrialPermissions', 'trialId', trialId)
            const localVarPath = `/permissions/trial/{trialId}/user`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject a trial request access.
         * @param {string} trialId 
         * @param {string} teamId 
         * @param {string} responseMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectTrialAccessRequest: async (trialId: string, teamId: string, responseMessage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('rejectTrialAccessRequest', 'trialId', trialId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('rejectTrialAccessRequest', 'teamId', teamId)
            // verify required parameter 'responseMessage' is not null or undefined
            assertParamExists('rejectTrialAccessRequest', 'responseMessage', responseMessage)
            const localVarPath = `/permissions/trial/{trialId}/access/{teamId}`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (responseMessage !== undefined) {
                localVarQueryParameter['responseMessage'] = responseMessage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request access to a trial.
         * @param {string} trialId 
         * @param {TrialAccessBody} trialAccessBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccess: async (trialId: string, trialAccessBody: TrialAccessBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('requestAccess', 'trialId', trialId)
            // verify required parameter 'trialAccessBody' is not null or undefined
            assertParamExists('requestAccess', 'trialAccessBody', trialAccessBody)
            const localVarPath = `/permissions/trial/{trialId}/access`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAccessBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the permission timestamp for a single trial.
         * @param {string} trialId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionTimestamp: async (trialId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('updatePermissionTimestamp', 'trialId', trialId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updatePermissionTimestamp', 'body', body)
            const localVarPath = `/permissions/trial/{trialId}/permission-timestamp`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve a trial request access.
         * @param {string} trialId 
         * @param {string} teamId 
         * @param {TrialAccessApproveBody} trialAccessApproveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveTrialAccessRequest(trialId: string, teamId: string, trialAccessApproveBody: TrialAccessApproveBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveTrialAccessRequest(trialId, teamId, trialAccessApproveBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.approveTrialAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all trial access requests.
         * @param {AccessRequestStatus} status 
         * @param {number} [limit] 
         * @param {boolean | null} [isExistingTrial] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessRequests(status: AccessRequestStatus, limit?: number, isExistingTrial?: boolean | null, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTrialAccessListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessRequests(status, limit, isExistingTrial, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.getAccessRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get count of contact permissions for a team. The count can be used to check whether this is the final person with contact details permissions in a team.
         * @param {string} trialId 
         * @param {string | null} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationPermissions(trialId: string, teamId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialLocationPermissionsListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationPermissions(trialId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.getLocationPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get trial access requests for a single trial.
         * @param {string} trialId 
         * @param {AccessRequestStatus} status 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialAccessRequests(trialId: string, status: AccessRequestStatus, limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialAccessListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialAccessRequests(trialId, status, limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.getTrialAccessRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get permissions of a user for a trial.
         * @param {string} trialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTrialPermissions(trialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialPermissionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTrialPermissions(trialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.getUserTrialPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject a trial request access.
         * @param {string} trialId 
         * @param {string} teamId 
         * @param {string} responseMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectTrialAccessRequest(trialId: string, teamId: string, responseMessage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectTrialAccessRequest(trialId, teamId, responseMessage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.rejectTrialAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request access to a trial.
         * @param {string} trialId 
         * @param {TrialAccessBody} trialAccessBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAccess(trialId: string, trialAccessBody: TrialAccessBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccess(trialId, trialAccessBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.requestAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the permission timestamp for a single trial.
         * @param {string} trialId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermissionTimestamp(trialId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermissionTimestamp(trialId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.updatePermissionTimestamp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve a trial request access.
         * @param {PermissionsApiApproveTrialAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTrialAccessRequest(requestParameters: PermissionsApiApproveTrialAccessRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveTrialAccessRequest(requestParameters.trialId, requestParameters.teamId, requestParameters.trialAccessApproveBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all trial access requests.
         * @param {PermissionsApiGetAccessRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequests(requestParameters: PermissionsApiGetAccessRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTrialAccessListView> {
            return localVarFp.getAccessRequests(requestParameters.status, requestParameters.limit, requestParameters.isExistingTrial, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get count of contact permissions for a team. The count can be used to check whether this is the final person with contact details permissions in a team.
         * @param {PermissionsApiGetLocationPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPermissions(requestParameters: PermissionsApiGetLocationPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialLocationPermissionsListView> {
            return localVarFp.getLocationPermissions(requestParameters.trialId, requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get trial access requests for a single trial.
         * @param {PermissionsApiGetTrialAccessRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialAccessRequests(requestParameters: PermissionsApiGetTrialAccessRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialAccessListView> {
            return localVarFp.getTrialAccessRequests(requestParameters.trialId, requestParameters.status, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get permissions of a user for a trial.
         * @param {PermissionsApiGetUserTrialPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrialPermissions(requestParameters: PermissionsApiGetUserTrialPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialPermissionsView> {
            return localVarFp.getUserTrialPermissions(requestParameters.trialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject a trial request access.
         * @param {PermissionsApiRejectTrialAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectTrialAccessRequest(requestParameters: PermissionsApiRejectTrialAccessRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectTrialAccessRequest(requestParameters.trialId, requestParameters.teamId, requestParameters.responseMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request access to a trial.
         * @param {PermissionsApiRequestAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccess(requestParameters: PermissionsApiRequestAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestAccess(requestParameters.trialId, requestParameters.trialAccessBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the permission timestamp for a single trial.
         * @param {PermissionsApiUpdatePermissionTimestampRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionTimestamp(requestParameters: PermissionsApiUpdatePermissionTimestampRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePermissionTimestamp(requestParameters.trialId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveTrialAccessRequest operation in PermissionsApi.
 * @export
 * @interface PermissionsApiApproveTrialAccessRequestRequest
 */
export interface PermissionsApiApproveTrialAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiApproveTrialAccessRequest
     */
    readonly trialId: string

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiApproveTrialAccessRequest
     */
    readonly teamId: string

    /**
     * 
     * @type {TrialAccessApproveBody}
     * @memberof PermissionsApiApproveTrialAccessRequest
     */
    readonly trialAccessApproveBody: TrialAccessApproveBody
}

/**
 * Request parameters for getAccessRequests operation in PermissionsApi.
 * @export
 * @interface PermissionsApiGetAccessRequestsRequest
 */
export interface PermissionsApiGetAccessRequestsRequest {
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof PermissionsApiGetAccessRequests
     */
    readonly status: AccessRequestStatus

    /**
     * 
     * @type {number}
     * @memberof PermissionsApiGetAccessRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {boolean}
     * @memberof PermissionsApiGetAccessRequests
     */
    readonly isExistingTrial?: boolean | null

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetAccessRequests
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getLocationPermissions operation in PermissionsApi.
 * @export
 * @interface PermissionsApiGetLocationPermissionsRequest
 */
export interface PermissionsApiGetLocationPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetLocationPermissions
     */
    readonly trialId: string

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetLocationPermissions
     */
    readonly teamId?: string | null
}

/**
 * Request parameters for getTrialAccessRequests operation in PermissionsApi.
 * @export
 * @interface PermissionsApiGetTrialAccessRequestsRequest
 */
export interface PermissionsApiGetTrialAccessRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetTrialAccessRequests
     */
    readonly trialId: string

    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof PermissionsApiGetTrialAccessRequests
     */
    readonly status: AccessRequestStatus

    /**
     * 
     * @type {number}
     * @memberof PermissionsApiGetTrialAccessRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetTrialAccessRequests
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getUserTrialPermissions operation in PermissionsApi.
 * @export
 * @interface PermissionsApiGetUserTrialPermissionsRequest
 */
export interface PermissionsApiGetUserTrialPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetUserTrialPermissions
     */
    readonly trialId: string
}

/**
 * Request parameters for rejectTrialAccessRequest operation in PermissionsApi.
 * @export
 * @interface PermissionsApiRejectTrialAccessRequestRequest
 */
export interface PermissionsApiRejectTrialAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiRejectTrialAccessRequest
     */
    readonly trialId: string

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiRejectTrialAccessRequest
     */
    readonly teamId: string

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiRejectTrialAccessRequest
     */
    readonly responseMessage: string
}

/**
 * Request parameters for requestAccess operation in PermissionsApi.
 * @export
 * @interface PermissionsApiRequestAccessRequest
 */
export interface PermissionsApiRequestAccessRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiRequestAccess
     */
    readonly trialId: string

    /**
     * 
     * @type {TrialAccessBody}
     * @memberof PermissionsApiRequestAccess
     */
    readonly trialAccessBody: TrialAccessBody
}

/**
 * Request parameters for updatePermissionTimestamp operation in PermissionsApi.
 * @export
 * @interface PermissionsApiUpdatePermissionTimestampRequest
 */
export interface PermissionsApiUpdatePermissionTimestampRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiUpdatePermissionTimestamp
     */
    readonly trialId: string

    /**
     * 
     * @type {object}
     * @memberof PermissionsApiUpdatePermissionTimestamp
     */
    readonly body: object
}

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * 
     * @summary Approve a trial request access.
     * @param {PermissionsApiApproveTrialAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public approveTrialAccessRequest(requestParameters: PermissionsApiApproveTrialAccessRequestRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).approveTrialAccessRequest(requestParameters.trialId, requestParameters.teamId, requestParameters.trialAccessApproveBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all trial access requests.
     * @param {PermissionsApiGetAccessRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getAccessRequests(requestParameters: PermissionsApiGetAccessRequestsRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getAccessRequests(requestParameters.status, requestParameters.limit, requestParameters.isExistingTrial, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get count of contact permissions for a team. The count can be used to check whether this is the final person with contact details permissions in a team.
     * @param {PermissionsApiGetLocationPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getLocationPermissions(requestParameters: PermissionsApiGetLocationPermissionsRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getLocationPermissions(requestParameters.trialId, requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get trial access requests for a single trial.
     * @param {PermissionsApiGetTrialAccessRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getTrialAccessRequests(requestParameters: PermissionsApiGetTrialAccessRequestsRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getTrialAccessRequests(requestParameters.trialId, requestParameters.status, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get permissions of a user for a trial.
     * @param {PermissionsApiGetUserTrialPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getUserTrialPermissions(requestParameters: PermissionsApiGetUserTrialPermissionsRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getUserTrialPermissions(requestParameters.trialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject a trial request access.
     * @param {PermissionsApiRejectTrialAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public rejectTrialAccessRequest(requestParameters: PermissionsApiRejectTrialAccessRequestRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).rejectTrialAccessRequest(requestParameters.trialId, requestParameters.teamId, requestParameters.responseMessage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request access to a trial.
     * @param {PermissionsApiRequestAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public requestAccess(requestParameters: PermissionsApiRequestAccessRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).requestAccess(requestParameters.trialId, requestParameters.trialAccessBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the permission timestamp for a single trial.
     * @param {PermissionsApiUpdatePermissionTimestampRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public updatePermissionTimestamp(requestParameters: PermissionsApiUpdatePermissionTimestampRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).updatePermissionTimestamp(requestParameters.trialId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PredicateLibraryItemsApi - axios parameter creator
 * @export
 */
export const PredicateLibraryItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary seed a canonical PredicateLibraryItem (mints its `ever` projection)
         * @param {PredicateLibraryItemCreateBody} predicateLibraryItemCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (predicateLibraryItemCreateBody: PredicateLibraryItemCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'predicateLibraryItemCreateBody' is not null or undefined
            assertParamExists('create', 'predicateLibraryItemCreateBody', predicateLibraryItemCreateBody)
            const localVarPath = `/predicate-library-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predicateLibraryItemCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deprecate (retire) a PredicateLibraryItem
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deprecate', 'id', id)
            const localVarPath = `/predicate-library-items/{id}/deprecate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch a canonical PredicateLibraryItem by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detail', 'id', id)
            const localVarPath = `/predicate-library-items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list canonical PredicateLibraryItem library entries
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [canonicalType] 
         * @param {string} [field] 
         * @param {string} [search] Split into words on &#x60;_&#x60; and whitespace, ignoring words shorter than 3 characters. A row that matches any word is returned, and the rows that match the most words come first. With &#x60;canonicalType&#x60; set, only the field and the display name are searched, and the words of the type\&#39;s own name are ignored while another word remains.
         * @param {string} [tierId] 
         * @param {boolean | null} [isDeprecated] Omitted lists only live concepts — the repoint picker must not offer retired ones. &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit?: number | null, offset?: number | null, canonicalType?: string, field?: string, search?: string, tierId?: string, isDeprecated?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predicate-library-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (canonicalType !== undefined) {
                localVarQueryParameter['canonicalType'] = canonicalType;
            }

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (tierId !== undefined) {
                localVarQueryParameter['tierId'] = tierId;
            }

            if (isDeprecated !== undefined) {
                localVarQueryParameter['isDeprecated'] = isDeprecated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary the live items of a canonical type closest to a field, closest first
         * @param {string} canonicalType 
         * @param {string} field The field to match, as Step 4 proposed it.
         * @param {number} [limit] Omitted returns 3.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        similar: async (canonicalType: string, field: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'canonicalType' is not null or undefined
            assertParamExists('similar', 'canonicalType', canonicalType)
            // verify required parameter 'field' is not null or undefined
            assertParamExists('similar', 'field', field)
            const localVarPath = `/predicate-library-items/similar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (canonicalType !== undefined) {
                localVarQueryParameter['canonicalType'] = canonicalType;
            }

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary edit a PredicateLibraryItem (the natural key and the answer shape are fixed)
         * @param {string} id 
         * @param {PredicateLibraryItemUpdateBody} predicateLibraryItemUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, predicateLibraryItemUpdateBody: PredicateLibraryItemUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'predicateLibraryItemUpdateBody' is not null or undefined
            assertParamExists('update', 'predicateLibraryItemUpdateBody', predicateLibraryItemUpdateBody)
            const localVarPath = `/predicate-library-items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predicateLibraryItemUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredicateLibraryItemsApi - functional programming interface
 * @export
 */
export const PredicateLibraryItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredicateLibraryItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary seed a canonical PredicateLibraryItem (mints its `ever` projection)
         * @param {PredicateLibraryItemCreateBody} predicateLibraryItemCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(predicateLibraryItemCreateBody: PredicateLibraryItemCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredicateLibraryItemView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(predicateLibraryItemCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateLibraryItemsApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deprecate (retire) a PredicateLibraryItem
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deprecate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deprecate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateLibraryItemsApi.deprecate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary fetch a canonical PredicateLibraryItem by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredicateLibraryItemView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateLibraryItemsApi.detail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list canonical PredicateLibraryItem library entries
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [canonicalType] 
         * @param {string} [field] 
         * @param {string} [search] Split into words on &#x60;_&#x60; and whitespace, ignoring words shorter than 3 characters. A row that matches any word is returned, and the rows that match the most words come first. With &#x60;canonicalType&#x60; set, only the field and the display name are searched, and the words of the type\&#39;s own name are ignored while another word remains.
         * @param {string} [tierId] 
         * @param {boolean | null} [isDeprecated] Omitted lists only live concepts — the repoint picker must not offer retired ones. &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit?: number | null, offset?: number | null, canonicalType?: string, field?: string, search?: string, tierId?: string, isDeprecated?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPredicateLibraryItemView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, canonicalType, field, search, tierId, isDeprecated, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateLibraryItemsApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary the live items of a canonical type closest to a field, closest first
         * @param {string} canonicalType 
         * @param {string} field The field to match, as Step 4 proposed it.
         * @param {number} [limit] Omitted returns 3.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async similar(canonicalType: string, field: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPredicateLibraryItemSimilarView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.similar(canonicalType, field, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateLibraryItemsApi.similar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary edit a PredicateLibraryItem (the natural key and the answer shape are fixed)
         * @param {string} id 
         * @param {PredicateLibraryItemUpdateBody} predicateLibraryItemUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, predicateLibraryItemUpdateBody: PredicateLibraryItemUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredicateLibraryItemView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, predicateLibraryItemUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateLibraryItemsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PredicateLibraryItemsApi - factory interface
 * @export
 */
export const PredicateLibraryItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredicateLibraryItemsApiFp(configuration)
    return {
        /**
         * 
         * @summary seed a canonical PredicateLibraryItem (mints its `ever` projection)
         * @param {PredicateLibraryItemsApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: PredicateLibraryItemsApiCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredicateLibraryItemView> {
            return localVarFp.create(requestParameters.predicateLibraryItemCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deprecate (retire) a PredicateLibraryItem
         * @param {PredicateLibraryItemsApiDeprecateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecate(requestParameters: PredicateLibraryItemsApiDeprecateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deprecate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch a canonical PredicateLibraryItem by id
         * @param {PredicateLibraryItemsApiDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail(requestParameters: PredicateLibraryItemsApiDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredicateLibraryItemView> {
            return localVarFp.detail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list canonical PredicateLibraryItem library entries
         * @param {PredicateLibraryItemsApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: PredicateLibraryItemsApiListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListPredicateLibraryItemView> {
            return localVarFp.list(requestParameters.limit, requestParameters.offset, requestParameters.canonicalType, requestParameters.field, requestParameters.search, requestParameters.tierId, requestParameters.isDeprecated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary the live items of a canonical type closest to a field, closest first
         * @param {PredicateLibraryItemsApiSimilarRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        similar(requestParameters: PredicateLibraryItemsApiSimilarRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPredicateLibraryItemSimilarView> {
            return localVarFp.similar(requestParameters.canonicalType, requestParameters.field, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary edit a PredicateLibraryItem (the natural key and the answer shape are fixed)
         * @param {PredicateLibraryItemsApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters: PredicateLibraryItemsApiUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredicateLibraryItemView> {
            return localVarFp.update(requestParameters.id, requestParameters.predicateLibraryItemUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for create operation in PredicateLibraryItemsApi.
 * @export
 * @interface PredicateLibraryItemsApiCreateRequest
 */
export interface PredicateLibraryItemsApiCreateRequest {
    /**
     * 
     * @type {PredicateLibraryItemCreateBody}
     * @memberof PredicateLibraryItemsApiCreate
     */
    readonly predicateLibraryItemCreateBody: PredicateLibraryItemCreateBody
}

/**
 * Request parameters for deprecate operation in PredicateLibraryItemsApi.
 * @export
 * @interface PredicateLibraryItemsApiDeprecateRequest
 */
export interface PredicateLibraryItemsApiDeprecateRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemsApiDeprecate
     */
    readonly id: string
}

/**
 * Request parameters for detail operation in PredicateLibraryItemsApi.
 * @export
 * @interface PredicateLibraryItemsApiDetailRequest
 */
export interface PredicateLibraryItemsApiDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemsApiDetail
     */
    readonly id: string
}

/**
 * Request parameters for list operation in PredicateLibraryItemsApi.
 * @export
 * @interface PredicateLibraryItemsApiListRequest
 */
export interface PredicateLibraryItemsApiListRequest {
    /**
     * 
     * @type {number}
     * @memberof PredicateLibraryItemsApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof PredicateLibraryItemsApiList
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemsApiList
     */
    readonly canonicalType?: string

    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemsApiList
     */
    readonly field?: string

    /**
     * Split into words on &#x60;_&#x60; and whitespace, ignoring words shorter than 3 characters. A row that matches any word is returned, and the rows that match the most words come first. With &#x60;canonicalType&#x60; set, only the field and the display name are searched, and the words of the type\&#39;s own name are ignored while another word remains.
     * @type {string}
     * @memberof PredicateLibraryItemsApiList
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemsApiList
     */
    readonly tierId?: string

    /**
     * Omitted lists only live concepts — the repoint picker must not offer retired ones. &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
     * @type {boolean}
     * @memberof PredicateLibraryItemsApiList
     */
    readonly isDeprecated?: boolean | null
}

/**
 * Request parameters for similar operation in PredicateLibraryItemsApi.
 * @export
 * @interface PredicateLibraryItemsApiSimilarRequest
 */
export interface PredicateLibraryItemsApiSimilarRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemsApiSimilar
     */
    readonly canonicalType: string

    /**
     * The field to match, as Step 4 proposed it.
     * @type {string}
     * @memberof PredicateLibraryItemsApiSimilar
     */
    readonly field: string

    /**
     * Omitted returns 3.
     * @type {number}
     * @memberof PredicateLibraryItemsApiSimilar
     */
    readonly limit?: number
}

/**
 * Request parameters for update operation in PredicateLibraryItemsApi.
 * @export
 * @interface PredicateLibraryItemsApiUpdateRequest
 */
export interface PredicateLibraryItemsApiUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicateLibraryItemsApiUpdate
     */
    readonly id: string

    /**
     * 
     * @type {PredicateLibraryItemUpdateBody}
     * @memberof PredicateLibraryItemsApiUpdate
     */
    readonly predicateLibraryItemUpdateBody: PredicateLibraryItemUpdateBody
}

/**
 * PredicateLibraryItemsApi - object-oriented interface
 * @export
 * @class PredicateLibraryItemsApi
 * @extends {BaseAPI}
 */
export class PredicateLibraryItemsApi extends BaseAPI {
    /**
     * 
     * @summary seed a canonical PredicateLibraryItem (mints its `ever` projection)
     * @param {PredicateLibraryItemsApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateLibraryItemsApi
     */
    public create(requestParameters: PredicateLibraryItemsApiCreateRequest, options?: RawAxiosRequestConfig) {
        return PredicateLibraryItemsApiFp(this.configuration).create(requestParameters.predicateLibraryItemCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deprecate (retire) a PredicateLibraryItem
     * @param {PredicateLibraryItemsApiDeprecateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateLibraryItemsApi
     */
    public deprecate(requestParameters: PredicateLibraryItemsApiDeprecateRequest, options?: RawAxiosRequestConfig) {
        return PredicateLibraryItemsApiFp(this.configuration).deprecate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch a canonical PredicateLibraryItem by id
     * @param {PredicateLibraryItemsApiDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateLibraryItemsApi
     */
    public detail(requestParameters: PredicateLibraryItemsApiDetailRequest, options?: RawAxiosRequestConfig) {
        return PredicateLibraryItemsApiFp(this.configuration).detail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list canonical PredicateLibraryItem library entries
     * @param {PredicateLibraryItemsApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateLibraryItemsApi
     */
    public list(requestParameters: PredicateLibraryItemsApiListRequest = {}, options?: RawAxiosRequestConfig) {
        return PredicateLibraryItemsApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.canonicalType, requestParameters.field, requestParameters.search, requestParameters.tierId, requestParameters.isDeprecated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary the live items of a canonical type closest to a field, closest first
     * @param {PredicateLibraryItemsApiSimilarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateLibraryItemsApi
     */
    public similar(requestParameters: PredicateLibraryItemsApiSimilarRequest, options?: RawAxiosRequestConfig) {
        return PredicateLibraryItemsApiFp(this.configuration).similar(requestParameters.canonicalType, requestParameters.field, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary edit a PredicateLibraryItem (the natural key and the answer shape are fixed)
     * @param {PredicateLibraryItemsApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateLibraryItemsApi
     */
    public update(requestParameters: PredicateLibraryItemsApiUpdateRequest, options?: RawAxiosRequestConfig) {
        return PredicateLibraryItemsApiFp(this.configuration).update(requestParameters.id, requestParameters.predicateLibraryItemUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PredicatePipelineApi - axios parameter creator
 * @export
 */
export const PredicatePipelineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary each gated step\'s auto-approve switch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoApprove: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predicate-pipeline/auto-approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary kick a recruiting trial into the predicate pipeline (Step 1); advances automatically thereafter
         * @param {string} trialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        start: async (trialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('start', 'trialId', trialId)
            const localVarPath = `/predicate-pipeline/trials/{trialId}/start`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary start every trial in an (ICD, country) slice the pipeline has never run
         * @param {string} icdCode 
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSlice: async (icdCode: string, country: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'icdCode' is not null or undefined
            assertParamExists('startSlice', 'icdCode', icdCode)
            // verify required parameter 'country' is not null or undefined
            assertParamExists('startSlice', 'country', country)
            const localVarPath = `/predicate-pipeline/slices/{icdCode}/{country}/start`
                .replace(`{${"icdCode"}}`, encodeURIComponent(String(icdCode)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary a trial\'s source text plus its per-step ledger state, gate open/closed, and the items pending review
         * @param {string} trialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        steps: async (trialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('steps', 'trialId', trialId)
            const localVarPath = `/predicate-pipeline/trials/{trialId}/steps`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list trials in the predicate pipeline with the step each is sitting on
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PipelineTrialState} [state] 
         * @param {PipelineStep} [currentStep] The step the trial is sitting on. Takes the whole &#x60;PipelineStep&#x60; enum because that is what the generated client exposes, but only the per-trial steps (1-7) can ever match: &#x60;legacy&#x60; and &#x60;step8&#x60; are not per-trial, and a &#x60;done&#x60; trial sits on no step at all.
         * @param {string} [search] NCT id or official title, case-insensitive substring.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trials: async (limit?: number | null, offset?: number | null, state?: PipelineTrialState, currentStep?: PipelineStep, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predicate-pipeline/trials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (currentStep !== undefined) {
                localVarQueryParameter['currentStep'] = currentStep;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary turn a step\'s auto-approve switch on or off; takes up to the config cache TTL to reach a running step
         * @param {PredicatePipelineAutoApproveBody} predicatePipelineAutoApproveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoApprove: async (predicatePipelineAutoApproveBody: PredicatePipelineAutoApproveBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'predicatePipelineAutoApproveBody' is not null or undefined
            assertParamExists('updateAutoApprove', 'predicatePipelineAutoApproveBody', predicatePipelineAutoApproveBody)
            const localVarPath = `/predicate-pipeline/auto-approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predicatePipelineAutoApproveBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredicatePipelineApi - functional programming interface
 * @export
 */
export const PredicatePipelineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredicatePipelineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary each gated step\'s auto-approve switch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoApprove(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredicatePipelineAutoApproveView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoApprove(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatePipelineApi.autoApprove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary kick a recruiting trial into the predicate pipeline (Step 1); advances automatically thereafter
         * @param {string} trialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async start(trialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.start(trialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatePipelineApi.start']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary start every trial in an (ICD, country) slice the pipeline has never run
         * @param {string} icdCode 
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startSlice(icdCode: string, country: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredicatePipelineStartSliceView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startSlice(icdCode, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatePipelineApi.startSlice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary a trial\'s source text plus its per-step ledger state, gate open/closed, and the items pending review
         * @param {string} trialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async steps(trialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredicatePipelineStepsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.steps(trialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatePipelineApi.steps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list trials in the predicate pipeline with the step each is sitting on
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PipelineTrialState} [state] 
         * @param {PipelineStep} [currentStep] The step the trial is sitting on. Takes the whole &#x60;PipelineStep&#x60; enum because that is what the generated client exposes, but only the per-trial steps (1-7) can ever match: &#x60;legacy&#x60; and &#x60;step8&#x60; are not per-trial, and a &#x60;done&#x60; trial sits on no step at all.
         * @param {string} [search] NCT id or official title, case-insensitive substring.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trials(limit?: number | null, offset?: number | null, state?: PipelineTrialState, currentStep?: PipelineStep, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPredicatePipelineTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trials(limit, offset, state, currentStep, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatePipelineApi.trials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary turn a step\'s auto-approve switch on or off; takes up to the config cache TTL to reach a running step
         * @param {PredicatePipelineAutoApproveBody} predicatePipelineAutoApproveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAutoApprove(predicatePipelineAutoApproveBody: PredicatePipelineAutoApproveBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredicatePipelineAutoApproveView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAutoApprove(predicatePipelineAutoApproveBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatePipelineApi.updateAutoApprove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PredicatePipelineApi - factory interface
 * @export
 */
export const PredicatePipelineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredicatePipelineApiFp(configuration)
    return {
        /**
         * 
         * @summary each gated step\'s auto-approve switch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoApprove(options?: RawAxiosRequestConfig): AxiosPromise<PredicatePipelineAutoApproveView> {
            return localVarFp.autoApprove(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary kick a recruiting trial into the predicate pipeline (Step 1); advances automatically thereafter
         * @param {PredicatePipelineApiStartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        start(requestParameters: PredicatePipelineApiStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.start(requestParameters.trialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary start every trial in an (ICD, country) slice the pipeline has never run
         * @param {PredicatePipelineApiStartSliceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSlice(requestParameters: PredicatePipelineApiStartSliceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredicatePipelineStartSliceView> {
            return localVarFp.startSlice(requestParameters.icdCode, requestParameters.country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary a trial\'s source text plus its per-step ledger state, gate open/closed, and the items pending review
         * @param {PredicatePipelineApiStepsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        steps(requestParameters: PredicatePipelineApiStepsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredicatePipelineStepsView> {
            return localVarFp.steps(requestParameters.trialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list trials in the predicate pipeline with the step each is sitting on
         * @param {PredicatePipelineApiTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trials(requestParameters: PredicatePipelineApiTrialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListPredicatePipelineTrialView> {
            return localVarFp.trials(requestParameters.limit, requestParameters.offset, requestParameters.state, requestParameters.currentStep, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary turn a step\'s auto-approve switch on or off; takes up to the config cache TTL to reach a running step
         * @param {PredicatePipelineApiUpdateAutoApproveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoApprove(requestParameters: PredicatePipelineApiUpdateAutoApproveRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredicatePipelineAutoApproveView> {
            return localVarFp.updateAutoApprove(requestParameters.predicatePipelineAutoApproveBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for start operation in PredicatePipelineApi.
 * @export
 * @interface PredicatePipelineApiStartRequest
 */
export interface PredicatePipelineApiStartRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineApiStart
     */
    readonly trialId: string
}

/**
 * Request parameters for startSlice operation in PredicatePipelineApi.
 * @export
 * @interface PredicatePipelineApiStartSliceRequest
 */
export interface PredicatePipelineApiStartSliceRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineApiStartSlice
     */
    readonly icdCode: string

    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineApiStartSlice
     */
    readonly country: string
}

/**
 * Request parameters for steps operation in PredicatePipelineApi.
 * @export
 * @interface PredicatePipelineApiStepsRequest
 */
export interface PredicatePipelineApiStepsRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicatePipelineApiSteps
     */
    readonly trialId: string
}

/**
 * Request parameters for trials operation in PredicatePipelineApi.
 * @export
 * @interface PredicatePipelineApiTrialsRequest
 */
export interface PredicatePipelineApiTrialsRequest {
    /**
     * 
     * @type {number}
     * @memberof PredicatePipelineApiTrials
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof PredicatePipelineApiTrials
     */
    readonly offset?: number | null

    /**
     * 
     * @type {PipelineTrialState}
     * @memberof PredicatePipelineApiTrials
     */
    readonly state?: PipelineTrialState

    /**
     * The step the trial is sitting on. Takes the whole &#x60;PipelineStep&#x60; enum because that is what the generated client exposes, but only the per-trial steps (1-7) can ever match: &#x60;legacy&#x60; and &#x60;step8&#x60; are not per-trial, and a &#x60;done&#x60; trial sits on no step at all.
     * @type {PipelineStep}
     * @memberof PredicatePipelineApiTrials
     */
    readonly currentStep?: PipelineStep

    /**
     * NCT id or official title, case-insensitive substring.
     * @type {string}
     * @memberof PredicatePipelineApiTrials
     */
    readonly search?: string
}

/**
 * Request parameters for updateAutoApprove operation in PredicatePipelineApi.
 * @export
 * @interface PredicatePipelineApiUpdateAutoApproveRequest
 */
export interface PredicatePipelineApiUpdateAutoApproveRequest {
    /**
     * 
     * @type {PredicatePipelineAutoApproveBody}
     * @memberof PredicatePipelineApiUpdateAutoApprove
     */
    readonly predicatePipelineAutoApproveBody: PredicatePipelineAutoApproveBody
}

/**
 * PredicatePipelineApi - object-oriented interface
 * @export
 * @class PredicatePipelineApi
 * @extends {BaseAPI}
 */
export class PredicatePipelineApi extends BaseAPI {
    /**
     * 
     * @summary each gated step\'s auto-approve switch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatePipelineApi
     */
    public autoApprove(options?: RawAxiosRequestConfig) {
        return PredicatePipelineApiFp(this.configuration).autoApprove(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary kick a recruiting trial into the predicate pipeline (Step 1); advances automatically thereafter
     * @param {PredicatePipelineApiStartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatePipelineApi
     */
    public start(requestParameters: PredicatePipelineApiStartRequest, options?: RawAxiosRequestConfig) {
        return PredicatePipelineApiFp(this.configuration).start(requestParameters.trialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary start every trial in an (ICD, country) slice the pipeline has never run
     * @param {PredicatePipelineApiStartSliceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatePipelineApi
     */
    public startSlice(requestParameters: PredicatePipelineApiStartSliceRequest, options?: RawAxiosRequestConfig) {
        return PredicatePipelineApiFp(this.configuration).startSlice(requestParameters.icdCode, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary a trial\'s source text plus its per-step ledger state, gate open/closed, and the items pending review
     * @param {PredicatePipelineApiStepsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatePipelineApi
     */
    public steps(requestParameters: PredicatePipelineApiStepsRequest, options?: RawAxiosRequestConfig) {
        return PredicatePipelineApiFp(this.configuration).steps(requestParameters.trialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list trials in the predicate pipeline with the step each is sitting on
     * @param {PredicatePipelineApiTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatePipelineApi
     */
    public trials(requestParameters: PredicatePipelineApiTrialsRequest = {}, options?: RawAxiosRequestConfig) {
        return PredicatePipelineApiFp(this.configuration).trials(requestParameters.limit, requestParameters.offset, requestParameters.state, requestParameters.currentStep, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary turn a step\'s auto-approve switch on or off; takes up to the config cache TTL to reach a running step
     * @param {PredicatePipelineApiUpdateAutoApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatePipelineApi
     */
    public updateAutoApprove(requestParameters: PredicatePipelineApiUpdateAutoApproveRequest, options?: RawAxiosRequestConfig) {
        return PredicatePipelineApiFp(this.configuration).updateAutoApprove(requestParameters.predicatePipelineAutoApproveBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PredicateQuestionsApi - axios parameter creator
 * @export
 */
export const PredicateQuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary fetch one Step 8 generated question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detail', 'id', id)
            const localVarPath = `/predicate-questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary run Step 8 now instead of waiting for the daily cron (idempotent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predicate-questions/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list Step 8 generated questions with the library slot and criteria behind each
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {Array<AnswerType>} [answerTypes] 
         * @param {Array<QuestionType>} [questionTypes] The reviewer\&#39;s Status filter: pending &#x3D; &#x60;proposed&#x60;, approved &#x3D; &#x60;standard&#x60;. Spelled as the stored column rather than a review-status enum of its own — &#x60;questionType&#x60; *is* the gate, there is no second status to keep in step.
         * @param {PredicateQuestionOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [search] 
         * @param {string} [predicateLibraryItemId] 
         * @param {string} [projectionId] 
         * @param {boolean | null} [hasPendingDependencyProposals] Only questions with at least one &#x60;proposed&#x60; dependency proposal. &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit?: number | null, offset?: number | null, answerTypes?: Array<AnswerType>, questionTypes?: Array<QuestionType>, orderBy?: PredicateQuestionOrderBy, orderDirection?: OrderDirection, search?: string, predicateLibraryItemId?: string, projectionId?: string, hasPendingDependencyProposals?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predicate-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (answerTypes) {
                localVarQueryParameter['answerTypes'] = answerTypes;
            }

            if (questionTypes) {
                localVarQueryParameter['questionTypes'] = questionTypes;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (predicateLibraryItemId !== undefined) {
                localVarQueryParameter['predicateLibraryItemId'] = predicateLibraryItemId;
            }

            if (projectionId !== undefined) {
                localVarQueryParameter['projectionId'] = projectionId;
            }

            if (hasPendingDependencyProposals !== undefined) {
                localVarQueryParameter['hasPendingDependencyProposals'] = hasPendingDependencyProposals;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredicateQuestionsApi - functional programming interface
 * @export
 */
export const PredicateQuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredicateQuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary fetch one Step 8 generated question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredicateQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateQuestionsApi.detail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary run Step 8 now instead of waiting for the daily cron (idempotent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateQuestionsApi.generate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list Step 8 generated questions with the library slot and criteria behind each
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {Array<AnswerType>} [answerTypes] 
         * @param {Array<QuestionType>} [questionTypes] The reviewer\&#39;s Status filter: pending &#x3D; &#x60;proposed&#x60;, approved &#x3D; &#x60;standard&#x60;. Spelled as the stored column rather than a review-status enum of its own — &#x60;questionType&#x60; *is* the gate, there is no second status to keep in step.
         * @param {PredicateQuestionOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [search] 
         * @param {string} [predicateLibraryItemId] 
         * @param {string} [projectionId] 
         * @param {boolean | null} [hasPendingDependencyProposals] Only questions with at least one &#x60;proposed&#x60; dependency proposal. &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit?: number | null, offset?: number | null, answerTypes?: Array<AnswerType>, questionTypes?: Array<QuestionType>, orderBy?: PredicateQuestionOrderBy, orderDirection?: OrderDirection, search?: string, predicateLibraryItemId?: string, projectionId?: string, hasPendingDependencyProposals?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPredicateQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, answerTypes, questionTypes, orderBy, orderDirection, search, predicateLibraryItemId, projectionId, hasPendingDependencyProposals, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicateQuestionsApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PredicateQuestionsApi - factory interface
 * @export
 */
export const PredicateQuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredicateQuestionsApiFp(configuration)
    return {
        /**
         * 
         * @summary fetch one Step 8 generated question
         * @param {PredicateQuestionsApiDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail(requestParameters: PredicateQuestionsApiDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredicateQuestionView> {
            return localVarFp.detail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary run Step 8 now instead of waiting for the daily cron (idempotent)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list Step 8 generated questions with the library slot and criteria behind each
         * @param {PredicateQuestionsApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: PredicateQuestionsApiListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListPredicateQuestionView> {
            return localVarFp.list(requestParameters.limit, requestParameters.offset, requestParameters.answerTypes, requestParameters.questionTypes, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.search, requestParameters.predicateLibraryItemId, requestParameters.projectionId, requestParameters.hasPendingDependencyProposals, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for detail operation in PredicateQuestionsApi.
 * @export
 * @interface PredicateQuestionsApiDetailRequest
 */
export interface PredicateQuestionsApiDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionsApiDetail
     */
    readonly id: string
}

/**
 * Request parameters for list operation in PredicateQuestionsApi.
 * @export
 * @interface PredicateQuestionsApiListRequest
 */
export interface PredicateQuestionsApiListRequest {
    /**
     * 
     * @type {number}
     * @memberof PredicateQuestionsApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof PredicateQuestionsApiList
     */
    readonly offset?: number | null

    /**
     * 
     * @type {Array<AnswerType>}
     * @memberof PredicateQuestionsApiList
     */
    readonly answerTypes?: Array<AnswerType>

    /**
     * The reviewer\&#39;s Status filter: pending &#x3D; &#x60;proposed&#x60;, approved &#x3D; &#x60;standard&#x60;. Spelled as the stored column rather than a review-status enum of its own — &#x60;questionType&#x60; *is* the gate, there is no second status to keep in step.
     * @type {Array<QuestionType>}
     * @memberof PredicateQuestionsApiList
     */
    readonly questionTypes?: Array<QuestionType>

    /**
     * 
     * @type {PredicateQuestionOrderBy}
     * @memberof PredicateQuestionsApiList
     */
    readonly orderBy?: PredicateQuestionOrderBy

    /**
     * 
     * @type {OrderDirection}
     * @memberof PredicateQuestionsApiList
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionsApiList
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionsApiList
     */
    readonly predicateLibraryItemId?: string

    /**
     * 
     * @type {string}
     * @memberof PredicateQuestionsApiList
     */
    readonly projectionId?: string

    /**
     * Only questions with at least one &#x60;proposed&#x60; dependency proposal. &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
     * @type {boolean}
     * @memberof PredicateQuestionsApiList
     */
    readonly hasPendingDependencyProposals?: boolean | null
}

/**
 * PredicateQuestionsApi - object-oriented interface
 * @export
 * @class PredicateQuestionsApi
 * @extends {BaseAPI}
 */
export class PredicateQuestionsApi extends BaseAPI {
    /**
     * 
     * @summary fetch one Step 8 generated question
     * @param {PredicateQuestionsApiDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateQuestionsApi
     */
    public detail(requestParameters: PredicateQuestionsApiDetailRequest, options?: RawAxiosRequestConfig) {
        return PredicateQuestionsApiFp(this.configuration).detail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary run Step 8 now instead of waiting for the daily cron (idempotent)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateQuestionsApi
     */
    public generate(options?: RawAxiosRequestConfig) {
        return PredicateQuestionsApiFp(this.configuration).generate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list Step 8 generated questions with the library slot and criteria behind each
     * @param {PredicateQuestionsApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicateQuestionsApi
     */
    public list(requestParameters: PredicateQuestionsApiListRequest = {}, options?: RawAxiosRequestConfig) {
        return PredicateQuestionsApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.answerTypes, requestParameters.questionTypes, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.search, requestParameters.predicateLibraryItemId, requestParameters.projectionId, requestParameters.hasPendingDependencyProposals, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PredicatesApi - axios parameter creator
 * @export
 */
export const PredicatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary fetch a TrialPredicate by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detail', 'id', id)
            const localVarPath = `/predicates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary predicates blocked on the library, grouped by the entry that would unblock them
         * @param {PredicateLibraryGap} gap 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [predicateLibraryItemId] Narrows the queue to one category, for the category page\&#39;s own view of what it is missing. Only meaningful on &#x60;missing_projection&#x60; — a &#x60;new_concept&#x60; group has no category by definition, so combining the two matches nothing.
         * @param {string} [search] Narrows to the groups whose type or field matches. A row in Step 4 links here with its own field already filled in — the queue is the same length however one trial got you to it, and scanning it for the entry you came to create is the slow part.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        libraryQueue: async (gap: PredicateLibraryGap, limit?: number | null, offset?: number | null, predicateLibraryItemId?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gap' is not null or undefined
            assertParamExists('libraryQueue', 'gap', gap)
            const localVarPath = `/predicates/library-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (gap !== undefined) {
                localVarQueryParameter['gap'] = gap;
            }

            if (predicateLibraryItemId !== undefined) {
                localVarQueryParameter['predicateLibraryItemId'] = predicateLibraryItemId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list TrialPredicates with optional filters
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PipelineReviewStatus} [status] 
         * @param {CriteriaType} [criteriaType] 
         * @param {LibraryDecision} [libraryDecision] 
         * @param {PredicateLibraryGap} [libraryGap] What the row still needs from the library — the same discriminator the reviewer UI branches on, and the only one that reads a cross-trial queue correctly. &#x60;libraryDecision&#x60; cannot: Step 4 splits a single gap across &#x60;QUEUE_FOR_LIBRARY&#x60; and &#x60;FLAG_FOR_REVIEW&#x60; on how many personas agreed, so filtering by it hides the lower-confidence half of the same queue.
         * @param {TemporalBoundsUnit} [temporalBoundsUnit] 
         * @param {PipelineReviewStatus} [ontologyStatus] The ontology-review axis, independent of &#x60;status&#x60; — the review pane\&#39;s status buckets.
         * @param {PipelineReviewStatus} [prescreenStatus] The prescreen-review axis (Step 6), independent of &#x60;status&#x60; — same status buckets.
         * @param {PipelineReviewStatus} [qualityCheckStatus] The quality-check axis (Step 7), independent of &#x60;status&#x60; — the review pane\&#39;s status buckets. Same &#x60;PipelineReviewStatus&#x60; vocabulary as the axes above, kept as a separate filter because it is a separate axis.
         * @param {string} [trialId] 
         * @param {string} [canonicalType] 
         * @param {string} [predicateLibraryItemId] The resolved category itself, where its whole natural key matters and not just the slug.
         * @param {string} [search] 
         * @param {string} [proposedCanonicalType] The canonical type the vote asked for, on a row that has no category to filter by. &#x60;canonicalType&#x60; joins the *resolved* &#x60;PredicateLibraryItem&#x60;, which is null on exactly the rows a &#x60;new_concept&#x60; queue is made of.
         * @param {string} [proposedField] 
         * @param {string} [proposedUnit] Part of a proposed category\&#39;s natural key, so a queue group is only itself with it: the same type and field in two units are two categories. Empty string means \&quot;proposed without a unit\&quot; — omitting it would filter on nothing and pull the other units\&#39; rows back in.
         * @param {string} [proposedProjectionType] The projection the vote asked for. Empty string means \&quot;the vote named none\&quot;.
         * @param {number} [temporalBoundsValue] The predicate\&#39;s own window. Only identifies a group on a proposed &#x60;count&#x60;, where the window is part of the projection; on every other type it is a per-trial matching filter and varies across the rows of one group.
         * @param {string} [originalCriterionId] 
         * @param {string} [cohortId] 
         * @param {boolean | null} [includeRejected] Lifts the ancestor filter, so the atoms of a criterion whose split was rejected are returned too. Only Step 3\&#39;s review pane sets it: rejecting is what discards those atoms, and the pane has to show the reviewer what their verdict removed. Nothing that consumes a predicate may pass it - a rejected criterion\&#39;s atoms are dead for every downstream purpose.  &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
         * @param {boolean | null} [askedOnly] Only the rows the eligibility chat asks: Step 6 kept them or has not ruled yet. The Step 4, 5 and 7 panes set it, because those steps never process a SKIP or SITE_VERIFIED row. &#x60;| null&#x60; for the same reason as &#x60;includeRejected&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit?: number | null, offset?: number | null, status?: PipelineReviewStatus, criteriaType?: CriteriaType, libraryDecision?: LibraryDecision, libraryGap?: PredicateLibraryGap, temporalBoundsUnit?: TemporalBoundsUnit, ontologyStatus?: PipelineReviewStatus, prescreenStatus?: PipelineReviewStatus, qualityCheckStatus?: PipelineReviewStatus, trialId?: string, canonicalType?: string, predicateLibraryItemId?: string, search?: string, proposedCanonicalType?: string, proposedField?: string, proposedUnit?: string, proposedProjectionType?: string, temporalBoundsValue?: number, originalCriterionId?: string, cohortId?: string, includeRejected?: boolean | null, askedOnly?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predicates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (criteriaType !== undefined) {
                localVarQueryParameter['criteriaType'] = criteriaType;
            }

            if (libraryDecision !== undefined) {
                localVarQueryParameter['libraryDecision'] = libraryDecision;
            }

            if (libraryGap !== undefined) {
                localVarQueryParameter['libraryGap'] = libraryGap;
            }

            if (temporalBoundsUnit !== undefined) {
                localVarQueryParameter['temporalBoundsUnit'] = temporalBoundsUnit;
            }

            if (ontologyStatus !== undefined) {
                localVarQueryParameter['ontologyStatus'] = ontologyStatus;
            }

            if (prescreenStatus !== undefined) {
                localVarQueryParameter['prescreenStatus'] = prescreenStatus;
            }

            if (qualityCheckStatus !== undefined) {
                localVarQueryParameter['qualityCheckStatus'] = qualityCheckStatus;
            }

            if (trialId !== undefined) {
                localVarQueryParameter['trialId'] = trialId;
            }

            if (canonicalType !== undefined) {
                localVarQueryParameter['canonicalType'] = canonicalType;
            }

            if (predicateLibraryItemId !== undefined) {
                localVarQueryParameter['predicateLibraryItemId'] = predicateLibraryItemId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (proposedCanonicalType !== undefined) {
                localVarQueryParameter['proposedCanonicalType'] = proposedCanonicalType;
            }

            if (proposedField !== undefined) {
                localVarQueryParameter['proposedField'] = proposedField;
            }

            if (proposedUnit !== undefined) {
                localVarQueryParameter['proposedUnit'] = proposedUnit;
            }

            if (proposedProjectionType !== undefined) {
                localVarQueryParameter['proposedProjectionType'] = proposedProjectionType;
            }

            if (temporalBoundsValue !== undefined) {
                localVarQueryParameter['temporalBoundsValue'] = temporalBoundsValue;
            }

            if (originalCriterionId !== undefined) {
                localVarQueryParameter['originalCriterionId'] = originalCriterionId;
            }

            if (cohortId !== undefined) {
                localVarQueryParameter['cohortId'] = cohortId;
            }

            if (includeRejected !== undefined) {
                localVarQueryParameter['includeRejected'] = includeRejected;
            }

            if (askedOnly !== undefined) {
                localVarQueryParameter['askedOnly'] = askedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary edit + set status on a TrialPredicate (HITL flow (b) reviewer decision)
         * @param {string} id 
         * @param {PredicatesUpdateBody} predicatesUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, predicatesUpdateBody: PredicatesUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'predicatesUpdateBody' is not null or undefined
            assertParamExists('update', 'predicatesUpdateBody', predicatesUpdateBody)
            const localVarPath = `/predicates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predicatesUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredicatesApi - functional programming interface
 * @export
 */
export const PredicatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredicatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary fetch a TrialPredicate by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialPredicateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatesApi.detail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary predicates blocked on the library, grouped by the entry that would unblock them
         * @param {PredicateLibraryGap} gap 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [predicateLibraryItemId] Narrows the queue to one category, for the category page\&#39;s own view of what it is missing. Only meaningful on &#x60;missing_projection&#x60; — a &#x60;new_concept&#x60; group has no category by definition, so combining the two matches nothing.
         * @param {string} [search] Narrows to the groups whose type or field matches. A row in Step 4 links here with its own field already filled in — the queue is the same length however one trial got you to it, and scanning it for the entry you came to create is the slow part.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async libraryQueue(gap: PredicateLibraryGap, limit?: number | null, offset?: number | null, predicateLibraryItemId?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPredicateLibraryQueueView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.libraryQueue(gap, limit, offset, predicateLibraryItemId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatesApi.libraryQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list TrialPredicates with optional filters
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PipelineReviewStatus} [status] 
         * @param {CriteriaType} [criteriaType] 
         * @param {LibraryDecision} [libraryDecision] 
         * @param {PredicateLibraryGap} [libraryGap] What the row still needs from the library — the same discriminator the reviewer UI branches on, and the only one that reads a cross-trial queue correctly. &#x60;libraryDecision&#x60; cannot: Step 4 splits a single gap across &#x60;QUEUE_FOR_LIBRARY&#x60; and &#x60;FLAG_FOR_REVIEW&#x60; on how many personas agreed, so filtering by it hides the lower-confidence half of the same queue.
         * @param {TemporalBoundsUnit} [temporalBoundsUnit] 
         * @param {PipelineReviewStatus} [ontologyStatus] The ontology-review axis, independent of &#x60;status&#x60; — the review pane\&#39;s status buckets.
         * @param {PipelineReviewStatus} [prescreenStatus] The prescreen-review axis (Step 6), independent of &#x60;status&#x60; — same status buckets.
         * @param {PipelineReviewStatus} [qualityCheckStatus] The quality-check axis (Step 7), independent of &#x60;status&#x60; — the review pane\&#39;s status buckets. Same &#x60;PipelineReviewStatus&#x60; vocabulary as the axes above, kept as a separate filter because it is a separate axis.
         * @param {string} [trialId] 
         * @param {string} [canonicalType] 
         * @param {string} [predicateLibraryItemId] The resolved category itself, where its whole natural key matters and not just the slug.
         * @param {string} [search] 
         * @param {string} [proposedCanonicalType] The canonical type the vote asked for, on a row that has no category to filter by. &#x60;canonicalType&#x60; joins the *resolved* &#x60;PredicateLibraryItem&#x60;, which is null on exactly the rows a &#x60;new_concept&#x60; queue is made of.
         * @param {string} [proposedField] 
         * @param {string} [proposedUnit] Part of a proposed category\&#39;s natural key, so a queue group is only itself with it: the same type and field in two units are two categories. Empty string means \&quot;proposed without a unit\&quot; — omitting it would filter on nothing and pull the other units\&#39; rows back in.
         * @param {string} [proposedProjectionType] The projection the vote asked for. Empty string means \&quot;the vote named none\&quot;.
         * @param {number} [temporalBoundsValue] The predicate\&#39;s own window. Only identifies a group on a proposed &#x60;count&#x60;, where the window is part of the projection; on every other type it is a per-trial matching filter and varies across the rows of one group.
         * @param {string} [originalCriterionId] 
         * @param {string} [cohortId] 
         * @param {boolean | null} [includeRejected] Lifts the ancestor filter, so the atoms of a criterion whose split was rejected are returned too. Only Step 3\&#39;s review pane sets it: rejecting is what discards those atoms, and the pane has to show the reviewer what their verdict removed. Nothing that consumes a predicate may pass it - a rejected criterion\&#39;s atoms are dead for every downstream purpose.  &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
         * @param {boolean | null} [askedOnly] Only the rows the eligibility chat asks: Step 6 kept them or has not ruled yet. The Step 4, 5 and 7 panes set it, because those steps never process a SKIP or SITE_VERIFIED row. &#x60;| null&#x60; for the same reason as &#x60;includeRejected&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit?: number | null, offset?: number | null, status?: PipelineReviewStatus, criteriaType?: CriteriaType, libraryDecision?: LibraryDecision, libraryGap?: PredicateLibraryGap, temporalBoundsUnit?: TemporalBoundsUnit, ontologyStatus?: PipelineReviewStatus, prescreenStatus?: PipelineReviewStatus, qualityCheckStatus?: PipelineReviewStatus, trialId?: string, canonicalType?: string, predicateLibraryItemId?: string, search?: string, proposedCanonicalType?: string, proposedField?: string, proposedUnit?: string, proposedProjectionType?: string, temporalBoundsValue?: number, originalCriterionId?: string, cohortId?: string, includeRejected?: boolean | null, askedOnly?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialPredicateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, status, criteriaType, libraryDecision, libraryGap, temporalBoundsUnit, ontologyStatus, prescreenStatus, qualityCheckStatus, trialId, canonicalType, predicateLibraryItemId, search, proposedCanonicalType, proposedField, proposedUnit, proposedProjectionType, temporalBoundsValue, originalCriterionId, cohortId, includeRejected, askedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatesApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary edit + set status on a TrialPredicate (HITL flow (b) reviewer decision)
         * @param {string} id 
         * @param {PredicatesUpdateBody} predicatesUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, predicatesUpdateBody: PredicatesUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, predicatesUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredicatesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PredicatesApi - factory interface
 * @export
 */
export const PredicatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredicatesApiFp(configuration)
    return {
        /**
         * 
         * @summary fetch a TrialPredicate by id
         * @param {PredicatesApiDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail(requestParameters: PredicatesApiDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialPredicateView> {
            return localVarFp.detail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary predicates blocked on the library, grouped by the entry that would unblock them
         * @param {PredicatesApiLibraryQueueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        libraryQueue(requestParameters: PredicatesApiLibraryQueueRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPredicateLibraryQueueView> {
            return localVarFp.libraryQueue(requestParameters.gap, requestParameters.limit, requestParameters.offset, requestParameters.predicateLibraryItemId, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list TrialPredicates with optional filters
         * @param {PredicatesApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: PredicatesApiListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialPredicateView> {
            return localVarFp.list(requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.criteriaType, requestParameters.libraryDecision, requestParameters.libraryGap, requestParameters.temporalBoundsUnit, requestParameters.ontologyStatus, requestParameters.prescreenStatus, requestParameters.qualityCheckStatus, requestParameters.trialId, requestParameters.canonicalType, requestParameters.predicateLibraryItemId, requestParameters.search, requestParameters.proposedCanonicalType, requestParameters.proposedField, requestParameters.proposedUnit, requestParameters.proposedProjectionType, requestParameters.temporalBoundsValue, requestParameters.originalCriterionId, requestParameters.cohortId, requestParameters.includeRejected, requestParameters.askedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary edit + set status on a TrialPredicate (HITL flow (b) reviewer decision)
         * @param {PredicatesApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters: PredicatesApiUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.update(requestParameters.id, requestParameters.predicatesUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for detail operation in PredicatesApi.
 * @export
 * @interface PredicatesApiDetailRequest
 */
export interface PredicatesApiDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicatesApiDetail
     */
    readonly id: string
}

/**
 * Request parameters for libraryQueue operation in PredicatesApi.
 * @export
 * @interface PredicatesApiLibraryQueueRequest
 */
export interface PredicatesApiLibraryQueueRequest {
    /**
     * 
     * @type {PredicateLibraryGap}
     * @memberof PredicatesApiLibraryQueue
     */
    readonly gap: PredicateLibraryGap

    /**
     * 
     * @type {number}
     * @memberof PredicatesApiLibraryQueue
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof PredicatesApiLibraryQueue
     */
    readonly offset?: number | null

    /**
     * Narrows the queue to one category, for the category page\&#39;s own view of what it is missing. Only meaningful on &#x60;missing_projection&#x60; — a &#x60;new_concept&#x60; group has no category by definition, so combining the two matches nothing.
     * @type {string}
     * @memberof PredicatesApiLibraryQueue
     */
    readonly predicateLibraryItemId?: string

    /**
     * Narrows to the groups whose type or field matches. A row in Step 4 links here with its own field already filled in — the queue is the same length however one trial got you to it, and scanning it for the entry you came to create is the slow part.
     * @type {string}
     * @memberof PredicatesApiLibraryQueue
     */
    readonly search?: string
}

/**
 * Request parameters for list operation in PredicatesApi.
 * @export
 * @interface PredicatesApiListRequest
 */
export interface PredicatesApiListRequest {
    /**
     * 
     * @type {number}
     * @memberof PredicatesApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof PredicatesApiList
     */
    readonly offset?: number | null

    /**
     * 
     * @type {PipelineReviewStatus}
     * @memberof PredicatesApiList
     */
    readonly status?: PipelineReviewStatus

    /**
     * 
     * @type {CriteriaType}
     * @memberof PredicatesApiList
     */
    readonly criteriaType?: CriteriaType

    /**
     * 
     * @type {LibraryDecision}
     * @memberof PredicatesApiList
     */
    readonly libraryDecision?: LibraryDecision

    /**
     * What the row still needs from the library — the same discriminator the reviewer UI branches on, and the only one that reads a cross-trial queue correctly. &#x60;libraryDecision&#x60; cannot: Step 4 splits a single gap across &#x60;QUEUE_FOR_LIBRARY&#x60; and &#x60;FLAG_FOR_REVIEW&#x60; on how many personas agreed, so filtering by it hides the lower-confidence half of the same queue.
     * @type {PredicateLibraryGap}
     * @memberof PredicatesApiList
     */
    readonly libraryGap?: PredicateLibraryGap

    /**
     * 
     * @type {TemporalBoundsUnit}
     * @memberof PredicatesApiList
     */
    readonly temporalBoundsUnit?: TemporalBoundsUnit

    /**
     * The ontology-review axis, independent of &#x60;status&#x60; — the review pane\&#39;s status buckets.
     * @type {PipelineReviewStatus}
     * @memberof PredicatesApiList
     */
    readonly ontologyStatus?: PipelineReviewStatus

    /**
     * The prescreen-review axis (Step 6), independent of &#x60;status&#x60; — same status buckets.
     * @type {PipelineReviewStatus}
     * @memberof PredicatesApiList
     */
    readonly prescreenStatus?: PipelineReviewStatus

    /**
     * The quality-check axis (Step 7), independent of &#x60;status&#x60; — the review pane\&#39;s status buckets. Same &#x60;PipelineReviewStatus&#x60; vocabulary as the axes above, kept as a separate filter because it is a separate axis.
     * @type {PipelineReviewStatus}
     * @memberof PredicatesApiList
     */
    readonly qualityCheckStatus?: PipelineReviewStatus

    /**
     * 
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly trialId?: string

    /**
     * 
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly canonicalType?: string

    /**
     * The resolved category itself, where its whole natural key matters and not just the slug.
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly predicateLibraryItemId?: string

    /**
     * 
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly search?: string

    /**
     * The canonical type the vote asked for, on a row that has no category to filter by. &#x60;canonicalType&#x60; joins the *resolved* &#x60;PredicateLibraryItem&#x60;, which is null on exactly the rows a &#x60;new_concept&#x60; queue is made of.
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly proposedCanonicalType?: string

    /**
     * 
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly proposedField?: string

    /**
     * Part of a proposed category\&#39;s natural key, so a queue group is only itself with it: the same type and field in two units are two categories. Empty string means \&quot;proposed without a unit\&quot; — omitting it would filter on nothing and pull the other units\&#39; rows back in.
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly proposedUnit?: string

    /**
     * The projection the vote asked for. Empty string means \&quot;the vote named none\&quot;.
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly proposedProjectionType?: string

    /**
     * The predicate\&#39;s own window. Only identifies a group on a proposed &#x60;count&#x60;, where the window is part of the projection; on every other type it is a per-trial matching filter and varies across the rows of one group.
     * @type {number}
     * @memberof PredicatesApiList
     */
    readonly temporalBoundsValue?: number

    /**
     * 
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly originalCriterionId?: string

    /**
     * 
     * @type {string}
     * @memberof PredicatesApiList
     */
    readonly cohortId?: string

    /**
     * Lifts the ancestor filter, so the atoms of a criterion whose split was rejected are returned too. Only Step 3\&#39;s review pane sets it: rejecting is what discards those atoms, and the pane has to show the reviewer what their verdict removed. Nothing that consumes a predicate may pass it - a rejected criterion\&#39;s atoms are dead for every downstream purpose.  &#x60;| null&#x60; keeps the declared type off &#x60;Boolean&#x60;, so &#x60;enableImplicitConversion&#x60; leaves the raw query string for &#x60;IsQueryBoolean&#x60;\&#39;s own transform to read.
     * @type {boolean}
     * @memberof PredicatesApiList
     */
    readonly includeRejected?: boolean | null

    /**
     * Only the rows the eligibility chat asks: Step 6 kept them or has not ruled yet. The Step 4, 5 and 7 panes set it, because those steps never process a SKIP or SITE_VERIFIED row. &#x60;| null&#x60; for the same reason as &#x60;includeRejected&#x60;.
     * @type {boolean}
     * @memberof PredicatesApiList
     */
    readonly askedOnly?: boolean | null
}

/**
 * Request parameters for update operation in PredicatesApi.
 * @export
 * @interface PredicatesApiUpdateRequest
 */
export interface PredicatesApiUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PredicatesApiUpdate
     */
    readonly id: string

    /**
     * 
     * @type {PredicatesUpdateBody}
     * @memberof PredicatesApiUpdate
     */
    readonly predicatesUpdateBody: PredicatesUpdateBody
}

/**
 * PredicatesApi - object-oriented interface
 * @export
 * @class PredicatesApi
 * @extends {BaseAPI}
 */
export class PredicatesApi extends BaseAPI {
    /**
     * 
     * @summary fetch a TrialPredicate by id
     * @param {PredicatesApiDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatesApi
     */
    public detail(requestParameters: PredicatesApiDetailRequest, options?: RawAxiosRequestConfig) {
        return PredicatesApiFp(this.configuration).detail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary predicates blocked on the library, grouped by the entry that would unblock them
     * @param {PredicatesApiLibraryQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatesApi
     */
    public libraryQueue(requestParameters: PredicatesApiLibraryQueueRequest, options?: RawAxiosRequestConfig) {
        return PredicatesApiFp(this.configuration).libraryQueue(requestParameters.gap, requestParameters.limit, requestParameters.offset, requestParameters.predicateLibraryItemId, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list TrialPredicates with optional filters
     * @param {PredicatesApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatesApi
     */
    public list(requestParameters: PredicatesApiListRequest = {}, options?: RawAxiosRequestConfig) {
        return PredicatesApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.criteriaType, requestParameters.libraryDecision, requestParameters.libraryGap, requestParameters.temporalBoundsUnit, requestParameters.ontologyStatus, requestParameters.prescreenStatus, requestParameters.qualityCheckStatus, requestParameters.trialId, requestParameters.canonicalType, requestParameters.predicateLibraryItemId, requestParameters.search, requestParameters.proposedCanonicalType, requestParameters.proposedField, requestParameters.proposedUnit, requestParameters.proposedProjectionType, requestParameters.temporalBoundsValue, requestParameters.originalCriterionId, requestParameters.cohortId, requestParameters.includeRejected, requestParameters.askedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary edit + set status on a TrialPredicate (HITL flow (b) reviewer decision)
     * @param {PredicatesApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredicatesApi
     */
    public update(requestParameters: PredicatesApiUpdateRequest, options?: RawAxiosRequestConfig) {
        return PredicatesApiFp(this.configuration).update(requestParameters.id, requestParameters.predicatesUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PreferencesApi - axios parameter creator
 * @export
 */
export const PreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {any} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPreferences: async (subscriptionId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getSubscriptionPreferences', 'subscriptionId', subscriptionId)
            const localVarPath = `/preferences/subscription/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary One-click unsubscribe from a milestone email via the signed token in the email footer.
         * @param {UnsubscribeByTokenBody} unsubscribeByTokenBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeByToken: async (unsubscribeByTokenBody: UnsubscribeByTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unsubscribeByTokenBody' is not null or undefined
            assertParamExists('unsubscribeByToken', 'unsubscribeByTokenBody', unsubscribeByTokenBody)
            const localVarPath = `/preferences/unsubscribe-by-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unsubscribeByTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {string} subscriptionId 
         * @param {any} key 
         * @param {SubscriptionPreferencesBody} subscriptionPreferencesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPreferences: async (subscriptionId: string, key: any, subscriptionPreferencesBody: SubscriptionPreferencesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateSubscriptionPreferences', 'subscriptionId', subscriptionId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('updateSubscriptionPreferences', 'key', key)
            // verify required parameter 'subscriptionPreferencesBody' is not null or undefined
            assertParamExists('updateSubscriptionPreferences', 'subscriptionPreferencesBody', subscriptionPreferencesBody)
            const localVarPath = `/preferences/subscription/{subscriptionId}/key/{key}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionPreferencesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreferencesApi - functional programming interface
 * @export
 */
export const PreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {any} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionPreferences(subscriptionId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionPreferencesListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionPreferences(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreferencesApi.getSubscriptionPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary One-click unsubscribe from a milestone email via the signed token in the email footer.
         * @param {UnsubscribeByTokenBody} unsubscribeByTokenBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeByToken(unsubscribeByTokenBody: UnsubscribeByTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeByToken(unsubscribeByTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreferencesApi.unsubscribeByToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {string} subscriptionId 
         * @param {any} key 
         * @param {SubscriptionPreferencesBody} subscriptionPreferencesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionPreferences(subscriptionId: string, key: any, subscriptionPreferencesBody: SubscriptionPreferencesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionPreferenceView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionPreferences(subscriptionId, key, subscriptionPreferencesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreferencesApi.updateSubscriptionPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PreferencesApi - factory interface
 * @export
 */
export const PreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {PreferencesApiGetSubscriptionPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPreferences(requestParameters: PreferencesApiGetSubscriptionPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionPreferencesListView> {
            return localVarFp.getSubscriptionPreferences(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary One-click unsubscribe from a milestone email via the signed token in the email footer.
         * @param {PreferencesApiUnsubscribeByTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeByToken(requestParameters: PreferencesApiUnsubscribeByTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unsubscribeByToken(requestParameters.unsubscribeByTokenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {PreferencesApiUpdateSubscriptionPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPreferences(requestParameters: PreferencesApiUpdateSubscriptionPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionPreferenceView> {
            return localVarFp.updateSubscriptionPreferences(requestParameters.subscriptionId, requestParameters.key, requestParameters.subscriptionPreferencesBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getSubscriptionPreferences operation in PreferencesApi.
 * @export
 * @interface PreferencesApiGetSubscriptionPreferencesRequest
 */
export interface PreferencesApiGetSubscriptionPreferencesRequest {
    /**
     * 
     * @type {any}
     * @memberof PreferencesApiGetSubscriptionPreferences
     */
    readonly subscriptionId: any
}

/**
 * Request parameters for unsubscribeByToken operation in PreferencesApi.
 * @export
 * @interface PreferencesApiUnsubscribeByTokenRequest
 */
export interface PreferencesApiUnsubscribeByTokenRequest {
    /**
     * 
     * @type {UnsubscribeByTokenBody}
     * @memberof PreferencesApiUnsubscribeByToken
     */
    readonly unsubscribeByTokenBody: UnsubscribeByTokenBody
}

/**
 * Request parameters for updateSubscriptionPreferences operation in PreferencesApi.
 * @export
 * @interface PreferencesApiUpdateSubscriptionPreferencesRequest
 */
export interface PreferencesApiUpdateSubscriptionPreferencesRequest {
    /**
     * 
     * @type {string}
     * @memberof PreferencesApiUpdateSubscriptionPreferences
     */
    readonly subscriptionId: string

    /**
     * 
     * @type {any}
     * @memberof PreferencesApiUpdateSubscriptionPreferences
     */
    readonly key: any

    /**
     * 
     * @type {SubscriptionPreferencesBody}
     * @memberof PreferencesApiUpdateSubscriptionPreferences
     */
    readonly subscriptionPreferencesBody: SubscriptionPreferencesBody
}

/**
 * PreferencesApi - object-oriented interface
 * @export
 * @class PreferencesApi
 * @extends {BaseAPI}
 */
export class PreferencesApi extends BaseAPI {
    /**
     * 
     * @summary get preferences of a subscription.
     * @param {PreferencesApiGetSubscriptionPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public getSubscriptionPreferences(requestParameters: PreferencesApiGetSubscriptionPreferencesRequest, options?: RawAxiosRequestConfig) {
        return PreferencesApiFp(this.configuration).getSubscriptionPreferences(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary One-click unsubscribe from a milestone email via the signed token in the email footer.
     * @param {PreferencesApiUnsubscribeByTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public unsubscribeByToken(requestParameters: PreferencesApiUnsubscribeByTokenRequest, options?: RawAxiosRequestConfig) {
        return PreferencesApiFp(this.configuration).unsubscribeByToken(requestParameters.unsubscribeByTokenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get preferences of a subscription.
     * @param {PreferencesApiUpdateSubscriptionPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public updateSubscriptionPreferences(requestParameters: PreferencesApiUpdateSubscriptionPreferencesRequest, options?: RawAxiosRequestConfig) {
        return PreferencesApiFp(this.configuration).updateSubscriptionPreferences(requestParameters.subscriptionId, requestParameters.key, requestParameters.subscriptionPreferencesBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user metadata
         * @param {UpdateMetadataBody} updateMetadataBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata: async (updateMetadataBody: UpdateMetadataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateMetadataBody' is not null or undefined
            assertParamExists('updateMetadata', 'updateMetadataBody', updateMetadataBody)
            const localVarPath = `/profile/metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMetadataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set new password after validating previous password
         * @param {UpdatePasswordBody} updatePasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (updatePasswordBody: UpdatePasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePasswordBody' is not null or undefined
            assertParamExists('updatePassword', 'updatePasswordBody', updatePasswordBody)
            const localVarPath = `/profile/passwords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user details
         * @param {UpdateProfileBody} updateProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: async (updateProfileBody: UpdateProfileBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProfileBody' is not null or undefined
            assertParamExists('updateProfile', 'updateProfileBody', updateProfileBody)
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allow admin to update user details
         * @param {string} id 
         * @param {UpdateProfileBody} updateProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileAsAdmin: async (id: string, updateProfileBody: UpdateProfileBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProfileAsAdmin', 'id', id)
            // verify required parameter 'updateProfileBody' is not null or undefined
            assertParamExists('updateProfileAsAdmin', 'updateProfileBody', updateProfileBody)
            const localVarPath = `/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetadata(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetadataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetadata(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.getMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user metadata
         * @param {UpdateMetadataBody} updateMetadataBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMetadata(updateMetadataBody: UpdateMetadataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMetadata(updateMetadataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set new password after validating previous password
         * @param {UpdatePasswordBody} updatePasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(updatePasswordBody: UpdatePasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(updatePasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user details
         * @param {UpdateProfileBody} updateProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfile(updateProfileBody: UpdateProfileBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(updateProfileBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Allow admin to update user details
         * @param {string} id 
         * @param {UpdateProfileBody} updateProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileAsAdmin(id: string, updateProfileBody: UpdateProfileBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileAsAdmin(id, updateProfileBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateProfileAsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata(options?: RawAxiosRequestConfig): AxiosPromise<MetadataView> {
            return localVarFp.getMetadata(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user metadata
         * @param {ProfileApiUpdateMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata(requestParameters: ProfileApiUpdateMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMetadata(requestParameters.updateMetadataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set new password after validating previous password
         * @param {ProfileApiUpdatePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(requestParameters: ProfileApiUpdatePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.updatePassword(requestParameters.updatePasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user details
         * @param {ProfileApiUpdateProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(requestParameters: ProfileApiUpdateProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProfile(requestParameters.updateProfileBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allow admin to update user details
         * @param {ProfileApiUpdateProfileAsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileAsAdmin(requestParameters: ProfileApiUpdateProfileAsAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProfileAsAdmin(requestParameters.id, requestParameters.updateProfileBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateMetadata operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdateMetadataRequest
 */
export interface ProfileApiUpdateMetadataRequest {
    /**
     * 
     * @type {UpdateMetadataBody}
     * @memberof ProfileApiUpdateMetadata
     */
    readonly updateMetadataBody: UpdateMetadataBody
}

/**
 * Request parameters for updatePassword operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdatePasswordRequest
 */
export interface ProfileApiUpdatePasswordRequest {
    /**
     * 
     * @type {UpdatePasswordBody}
     * @memberof ProfileApiUpdatePassword
     */
    readonly updatePasswordBody: UpdatePasswordBody
}

/**
 * Request parameters for updateProfile operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdateProfileRequest
 */
export interface ProfileApiUpdateProfileRequest {
    /**
     * 
     * @type {UpdateProfileBody}
     * @memberof ProfileApiUpdateProfile
     */
    readonly updateProfileBody: UpdateProfileBody
}

/**
 * Request parameters for updateProfileAsAdmin operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdateProfileAsAdminRequest
 */
export interface ProfileApiUpdateProfileAsAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileApiUpdateProfileAsAdmin
     */
    readonly id: string

    /**
     * 
     * @type {UpdateProfileBody}
     * @memberof ProfileApiUpdateProfileAsAdmin
     */
    readonly updateProfileBody: UpdateProfileBody
}

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @summary Get user metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public getMetadata(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).getMetadata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user metadata
     * @param {ProfileApiUpdateMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateMetadata(requestParameters: ProfileApiUpdateMetadataRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateMetadata(requestParameters.updateMetadataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set new password after validating previous password
     * @param {ProfileApiUpdatePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updatePassword(requestParameters: ProfileApiUpdatePasswordRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updatePassword(requestParameters.updatePasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user details
     * @param {ProfileApiUpdateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateProfile(requestParameters: ProfileApiUpdateProfileRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateProfile(requestParameters.updateProfileBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allow admin to update user details
     * @param {ProfileApiUpdateProfileAsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateProfileAsAdmin(requestParameters: ProfileApiUpdateProfileAsAdminRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateProfileAsAdmin(requestParameters.id, requestParameters.updateProfileBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectionsApi - axios parameter creator
 * @export
 */
export const ProjectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a projection for a field
         * @param {ProjectionCreateBody} projectionCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (projectionCreateBody: ProjectionCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectionCreateBody' is not null or undefined
            assertParamExists('create', 'projectionCreateBody', projectionCreateBody)
            const localVarPath = `/projections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectionCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deprecate (retire) a Projection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deprecate', 'id', id)
            const localVarPath = `/projections/{id}/deprecate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch a Projection by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('detail', 'id', id)
            const localVarPath = `/projections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list projections, optionally filtered by predicate type
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [predicateLibraryItemId] 
         * @param {boolean | null} [isDeprecated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit?: number | null, offset?: number | null, predicateLibraryItemId?: string, isDeprecated?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (predicateLibraryItemId !== undefined) {
                localVarQueryParameter['predicateLibraryItemId'] = predicateLibraryItemId;
            }

            if (isDeprecated !== undefined) {
                localVarQueryParameter['isDeprecated'] = isDeprecated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary replace a Projection with a corrected answer shape and move its predicates onto it
         * @param {string} id 
         * @param {ProjectionSupersedeBody} projectionSupersedeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supersede: async (id: string, projectionSupersedeBody: ProjectionSupersedeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('supersede', 'id', id)
            // verify required parameter 'projectionSupersedeBody' is not null or undefined
            assertParamExists('supersede', 'projectionSupersedeBody', projectionSupersedeBody)
            const localVarPath = `/projections/{id}/supersede`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectionSupersedeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary edit a Projection answer shape (answerType / unit)
         * @param {string} id 
         * @param {ProjectionUpdateBody} projectionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, projectionUpdateBody: ProjectionUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'projectionUpdateBody' is not null or undefined
            assertParamExists('update', 'projectionUpdateBody', projectionUpdateBody)
            const localVarPath = `/projections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectionUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectionsApi - functional programming interface
 * @export
 */
export const ProjectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create a projection for a field
         * @param {ProjectionCreateBody} projectionCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(projectionCreateBody: ProjectionCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectionDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(projectionCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectionsApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deprecate (retire) a Projection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deprecate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deprecate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectionsApi.deprecate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary fetch a Projection by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectionDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectionsApi.detail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list projections, optionally filtered by predicate type
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [predicateLibraryItemId] 
         * @param {boolean | null} [isDeprecated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit?: number | null, offset?: number | null, predicateLibraryItemId?: string, isDeprecated?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListProjectionDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, predicateLibraryItemId, isDeprecated, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectionsApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary replace a Projection with a corrected answer shape and move its predicates onto it
         * @param {string} id 
         * @param {ProjectionSupersedeBody} projectionSupersedeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supersede(id: string, projectionSupersedeBody: ProjectionSupersedeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectionDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supersede(id, projectionSupersedeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectionsApi.supersede']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary edit a Projection answer shape (answerType / unit)
         * @param {string} id 
         * @param {ProjectionUpdateBody} projectionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, projectionUpdateBody: ProjectionUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectionDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, projectionUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectionsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectionsApi - factory interface
 * @export
 */
export const ProjectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectionsApiFp(configuration)
    return {
        /**
         * 
         * @summary create a projection for a field
         * @param {ProjectionsApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: ProjectionsApiCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectionDetailView> {
            return localVarFp.create(requestParameters.projectionCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deprecate (retire) a Projection
         * @param {ProjectionsApiDeprecateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecate(requestParameters: ProjectionsApiDeprecateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deprecate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch a Projection by id
         * @param {ProjectionsApiDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detail(requestParameters: ProjectionsApiDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectionDetailView> {
            return localVarFp.detail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list projections, optionally filtered by predicate type
         * @param {ProjectionsApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: ProjectionsApiListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListProjectionDetailView> {
            return localVarFp.list(requestParameters.limit, requestParameters.offset, requestParameters.predicateLibraryItemId, requestParameters.isDeprecated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary replace a Projection with a corrected answer shape and move its predicates onto it
         * @param {ProjectionsApiSupersedeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supersede(requestParameters: ProjectionsApiSupersedeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectionDetailView> {
            return localVarFp.supersede(requestParameters.id, requestParameters.projectionSupersedeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary edit a Projection answer shape (answerType / unit)
         * @param {ProjectionsApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters: ProjectionsApiUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectionDetailView> {
            return localVarFp.update(requestParameters.id, requestParameters.projectionUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for create operation in ProjectionsApi.
 * @export
 * @interface ProjectionsApiCreateRequest
 */
export interface ProjectionsApiCreateRequest {
    /**
     * 
     * @type {ProjectionCreateBody}
     * @memberof ProjectionsApiCreate
     */
    readonly projectionCreateBody: ProjectionCreateBody
}

/**
 * Request parameters for deprecate operation in ProjectionsApi.
 * @export
 * @interface ProjectionsApiDeprecateRequest
 */
export interface ProjectionsApiDeprecateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectionsApiDeprecate
     */
    readonly id: string
}

/**
 * Request parameters for detail operation in ProjectionsApi.
 * @export
 * @interface ProjectionsApiDetailRequest
 */
export interface ProjectionsApiDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectionsApiDetail
     */
    readonly id: string
}

/**
 * Request parameters for list operation in ProjectionsApi.
 * @export
 * @interface ProjectionsApiListRequest
 */
export interface ProjectionsApiListRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectionsApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof ProjectionsApiList
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof ProjectionsApiList
     */
    readonly predicateLibraryItemId?: string

    /**
     * 
     * @type {boolean}
     * @memberof ProjectionsApiList
     */
    readonly isDeprecated?: boolean | null
}

/**
 * Request parameters for supersede operation in ProjectionsApi.
 * @export
 * @interface ProjectionsApiSupersedeRequest
 */
export interface ProjectionsApiSupersedeRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectionsApiSupersede
     */
    readonly id: string

    /**
     * 
     * @type {ProjectionSupersedeBody}
     * @memberof ProjectionsApiSupersede
     */
    readonly projectionSupersedeBody: ProjectionSupersedeBody
}

/**
 * Request parameters for update operation in ProjectionsApi.
 * @export
 * @interface ProjectionsApiUpdateRequest
 */
export interface ProjectionsApiUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectionsApiUpdate
     */
    readonly id: string

    /**
     * 
     * @type {ProjectionUpdateBody}
     * @memberof ProjectionsApiUpdate
     */
    readonly projectionUpdateBody: ProjectionUpdateBody
}

/**
 * ProjectionsApi - object-oriented interface
 * @export
 * @class ProjectionsApi
 * @extends {BaseAPI}
 */
export class ProjectionsApi extends BaseAPI {
    /**
     * 
     * @summary create a projection for a field
     * @param {ProjectionsApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionsApi
     */
    public create(requestParameters: ProjectionsApiCreateRequest, options?: RawAxiosRequestConfig) {
        return ProjectionsApiFp(this.configuration).create(requestParameters.projectionCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deprecate (retire) a Projection
     * @param {ProjectionsApiDeprecateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionsApi
     */
    public deprecate(requestParameters: ProjectionsApiDeprecateRequest, options?: RawAxiosRequestConfig) {
        return ProjectionsApiFp(this.configuration).deprecate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch a Projection by id
     * @param {ProjectionsApiDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionsApi
     */
    public detail(requestParameters: ProjectionsApiDetailRequest, options?: RawAxiosRequestConfig) {
        return ProjectionsApiFp(this.configuration).detail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list projections, optionally filtered by predicate type
     * @param {ProjectionsApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionsApi
     */
    public list(requestParameters: ProjectionsApiListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProjectionsApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.predicateLibraryItemId, requestParameters.isDeprecated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary replace a Projection with a corrected answer shape and move its predicates onto it
     * @param {ProjectionsApiSupersedeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionsApi
     */
    public supersede(requestParameters: ProjectionsApiSupersedeRequest, options?: RawAxiosRequestConfig) {
        return ProjectionsApiFp(this.configuration).supersede(requestParameters.id, requestParameters.projectionSupersedeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary edit a Projection answer shape (answerType / unit)
     * @param {ProjectionsApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionsApi
     */
    public update(requestParameters: ProjectionsApiUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProjectionsApiFp(this.configuration).update(requestParameters.id, requestParameters.projectionUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PulseApi - axios parameter creator
 * @export
 */
export const PulseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ingest a batch of patient-journey events
         * @param {PulseBatchBody} pulseBatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestBatch: async (pulseBatchBody: PulseBatchBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pulseBatchBody' is not null or undefined
            assertParamExists('ingestBatch', 'pulseBatchBody', pulseBatchBody)
            const localVarPath = `/pulse/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pulseBatchBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PulseApi - functional programming interface
 * @export
 */
export const PulseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PulseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ingest a batch of patient-journey events
         * @param {PulseBatchBody} pulseBatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestBatch(pulseBatchBody: PulseBatchBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestBatch(pulseBatchBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PulseApi.ingestBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PulseApi - factory interface
 * @export
 */
export const PulseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PulseApiFp(configuration)
    return {
        /**
         * 
         * @summary ingest a batch of patient-journey events
         * @param {PulseApiIngestBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestBatch(requestParameters: PulseApiIngestBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ingestBatch(requestParameters.pulseBatchBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for ingestBatch operation in PulseApi.
 * @export
 * @interface PulseApiIngestBatchRequest
 */
export interface PulseApiIngestBatchRequest {
    /**
     * 
     * @type {PulseBatchBody}
     * @memberof PulseApiIngestBatch
     */
    readonly pulseBatchBody: PulseBatchBody
}

/**
 * PulseApi - object-oriented interface
 * @export
 * @class PulseApi
 * @extends {BaseAPI}
 */
export class PulseApi extends BaseAPI {
    /**
     * 
     * @summary ingest a batch of patient-journey events
     * @param {PulseApiIngestBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulseApi
     */
    public ingestBatch(requestParameters: PulseApiIngestBatchRequest, options?: RawAxiosRequestConfig) {
        return PulseApiFp(this.configuration).ingestBatch(requestParameters.pulseBatchBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionsApi - axios parameter creator
 * @export
 */
export const QuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a category to a question
         * @param {string} id 
         * @param {AddQuestionCategoryBody} addQuestionCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuestionCategory: async (id: string, addQuestionCategoryBody: AddQuestionCategoryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addQuestionCategory', 'id', id)
            // verify required parameter 'addQuestionCategoryBody' is not null or undefined
            assertParamExists('addQuestionCategory', 'addQuestionCategoryBody', addQuestionCategoryBody)
            const localVarPath = `/questions/{id}/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addQuestionCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add an option to a question
         * @param {string} id 
         * @param {QuestionOptionBody} questionOptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuestionOption: async (id: string, questionOptionBody: QuestionOptionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addQuestionOption', 'id', id)
            // verify required parameter 'questionOptionBody' is not null or undefined
            assertParamExists('addQuestionOption', 'questionOptionBody', questionOptionBody)
            const localVarPath = `/questions/{id}/options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionOptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary bulk delete questions
         * @param {QuestionBulkDelete} questionBulkDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteQuestion: async (questionBulkDelete: QuestionBulkDelete, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionBulkDelete' is not null or undefined
            assertParamExists('bulkDeleteQuestion', 'questionBulkDelete', questionBulkDelete)
            const localVarPath = `/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionBulkDelete, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a question, try to avoid using this endpoint by using existing questions
         * @param {QuestionBody} questionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestion: async (questionBody: QuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionBody' is not null or undefined
            assertParamExists('createQuestion', 'questionBody', questionBody)
            const localVarPath = `/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add context translations to a question
         * @param {string} id 
         * @param {QuestionContextTranslationBody} questionContextTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionContextTranslations: async (id: string, questionContextTranslationBody: QuestionContextTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createQuestionContextTranslations', 'id', id)
            // verify required parameter 'questionContextTranslationBody' is not null or undefined
            assertParamExists('createQuestionContextTranslations', 'questionContextTranslationBody', questionContextTranslationBody)
            const localVarPath = `/questions/{id}/context-translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionContextTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create the dependencies of a question
         * @param {string} id 
         * @param {QuestionDependencyBody} questionDependencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionDependency: async (id: string, questionDependencyBody: QuestionDependencyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createQuestionDependency', 'id', id)
            // verify required parameter 'questionDependencyBody' is not null or undefined
            assertParamExists('createQuestionDependency', 'questionDependencyBody', questionDependencyBody)
            const localVarPath = `/questions/{id}/dependencies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionDependencyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add translations to a question
         * @param {string} id 
         * @param {QuestionTranslationBody} questionTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionTranslations: async (id: string, questionTranslationBody: QuestionTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createQuestionTranslations', 'id', id)
            // verify required parameter 'questionTranslationBody' is not null or undefined
            assertParamExists('createQuestionTranslations', 'questionTranslationBody', questionTranslationBody)
            const localVarPath = `/questions/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestion: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteQuestion', 'id', id)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an option from a question
         * @param {string} questionId 
         * @param {string} optionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionOption: async (questionId: string, optionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('deleteQuestionOption', 'questionId', questionId)
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('deleteQuestionOption', 'optionId', optionId)
            const localVarPath = `/questions/{questionId}/options/{optionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)))
                .replace(`{${"optionId"}}`, encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the AI-proposed dependencies of a question, every status, newest first
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependencyProposals: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDependencyProposals', 'id', id)
            const localVarPath = `/questions/{id}/dependency-proposals`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch categories of a question
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {CategoryType} [categoryType] 
         * @param {OrderDirection} [orderDirection] 
         * @param {CategoryOrderBy} [orderBy] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCategories: async (id: string, limit?: number | null, offset?: number | null, categoryType?: CategoryType, orderDirection?: OrderDirection, orderBy?: CategoryOrderBy, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionCategories', 'id', id)
            const localVarPath = `/questions/{id}/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (categoryType !== undefined) {
                localVarQueryParameter['categoryType'] = categoryType;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the translations of a question context
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionContextTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionContextTranslations', 'id', id)
            const localVarPath = `/questions/{id}/context-translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the trial (criteria) that the question is linked to
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [diseaseSearchString] 
         * @param {string} [leadSponsorSearchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCriteria: async (id: string, limit?: number | null, offset?: number | null, diseaseSearchString?: string, leadSponsorSearchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionCriteria', 'id', id)
            const localVarPath = `/questions/{id}/criteria`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (diseaseSearchString !== undefined) {
                localVarQueryParameter['diseaseSearchString'] = diseaseSearchString;
            }

            if (leadSponsorSearchString !== undefined) {
                localVarQueryParameter['leadSponsorSearchString'] = leadSponsorSearchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the dependencies of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionDependencies: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionDependencies', 'id', id)
            const localVarPath = `/questions/{id}/dependencies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionDetails', 'id', id)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the options and their translations the specified question
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionOptions: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionOptions', 'id', id)
            const localVarPath = `/questions/{id}/options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the translations of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionTranslations', 'id', id)
            const localVarPath = `/questions/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the search string
         * @param {GetQuestionsBody} getQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestions: async (getQuestionsBody: GetQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getQuestionsBody' is not null or undefined
            assertParamExists('getQuestions', 'getQuestionsBody', getQuestionsBody)
            const localVarPath = `/questions/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the specified question
         * @param {boolean | null} currentVersionOnly 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimilarQuestions: async (currentVersionOnly: boolean | null, id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentVersionOnly' is not null or undefined
            assertParamExists('getSimilarQuestions', 'currentVersionOnly', currentVersionOnly)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSimilarQuestions', 'id', id)
            const localVarPath = `/questions/{id}/similar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (currentVersionOnly !== undefined) {
                localVarQueryParameter['currentVersionOnly'] = currentVersionOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the suggested questions of the specified question
         * @param {number} threshold 
         * @param {boolean | null} currentVersionOnly 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedQuestions: async (threshold: number, currentVersionOnly: boolean | null, id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threshold' is not null or undefined
            assertParamExists('getSuggestedQuestions', 'threshold', threshold)
            // verify required parameter 'currentVersionOnly' is not null or undefined
            assertParamExists('getSuggestedQuestions', 'currentVersionOnly', currentVersionOnly)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSuggestedQuestions', 'id', id)
            const localVarPath = `/questions/{id}/suggested`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }

            if (currentVersionOnly !== undefined) {
                localVarQueryParameter['currentVersionOnly'] = currentVersionOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exclude a question from the merge suggestions of the given question
         * @param {string} id 
         * @param {QuestionIgnoreMergeBody} questionIgnoreMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreMerge: async (id: string, questionIgnoreMergeBody: QuestionIgnoreMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ignoreMerge', 'id', id)
            // verify required parameter 'questionIgnoreMergeBody' is not null or undefined
            assertParamExists('ignoreMerge', 'questionIgnoreMergeBody', questionIgnoreMergeBody)
            const localVarPath = `/questions/{id}/ignore/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionIgnoreMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary merge this question into the specified target question.
         * @param {string} id 
         * @param {QuestionMergeBody} questionMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeQuestions: async (id: string, questionMergeBody: QuestionMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mergeQuestions', 'id', id)
            // verify required parameter 'questionMergeBody' is not null or undefined
            assertParamExists('mergeQuestions', 'questionMergeBody', questionMergeBody)
            const localVarPath = `/questions/{id}/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Compute what a dependency would derive for a sample source answer, without saving it
         * @param {string} id 
         * @param {QuestionDependencyPreviewBody} questionDependencyPreviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewQuestionDependency: async (id: string, questionDependencyPreviewBody: QuestionDependencyPreviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewQuestionDependency', 'id', id)
            // verify required parameter 'questionDependencyPreviewBody' is not null or undefined
            assertParamExists('previewQuestionDependency', 'questionDependencyPreviewBody', questionDependencyPreviewBody)
            const localVarPath = `/questions/{id}/dependencies/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionDependencyPreviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a category from a question
         * @param {string} id 
         * @param {RemoveQuestionCategoryBody} removeQuestionCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQuestionCategory: async (id: string, removeQuestionCategoryBody: RemoveQuestionCategoryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeQuestionCategory', 'id', id)
            // verify required parameter 'removeQuestionCategoryBody' is not null or undefined
            assertParamExists('removeQuestionCategory', 'removeQuestionCategoryBody', removeQuestionCategoryBody)
            const localVarPath = `/questions/{id}/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeQuestionCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new chat entry to re-answer a question
         * @param {string} id 
         * @param {RetryQuestionBody} retryQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryQuestion: async (id: string, retryQuestionBody: RetryQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retryQuestion', 'id', id)
            // verify required parameter 'retryQuestionBody' is not null or undefined
            assertParamExists('retryQuestion', 'retryQuestionBody', retryQuestionBody)
            const localVarPath = `/questions/{id}/chat/entry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retryQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the details of a question, no relations will be affected by this
         * @param {string} id 
         * @param {QuestionUpdateBody} questionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestion: async (id: string, questionUpdateBody: QuestionUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateQuestion', 'id', id)
            // verify required parameter 'questionUpdateBody' is not null or undefined
            assertParamExists('updateQuestion', 'questionUpdateBody', questionUpdateBody)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the key or the translations of an option
         * @param {string} questionId 
         * @param {string} optionId 
         * @param {QuestionOptionUpdateBody} questionOptionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionOption: async (questionId: string, optionId: string, questionOptionUpdateBody: QuestionOptionUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('updateQuestionOption', 'questionId', questionId)
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('updateQuestionOption', 'optionId', optionId)
            // verify required parameter 'questionOptionUpdateBody' is not null or undefined
            assertParamExists('updateQuestionOption', 'questionOptionUpdateBody', questionOptionUpdateBody)
            const localVarPath = `/questions/{questionId}/options/{optionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)))
                .replace(`{${"optionId"}}`, encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionOptionUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionsApi - functional programming interface
 * @export
 */
export const QuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a category to a question
         * @param {string} id 
         * @param {AddQuestionCategoryBody} addQuestionCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addQuestionCategory(id: string, addQuestionCategoryBody: AddQuestionCategoryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addQuestionCategory(id, addQuestionCategoryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.addQuestionCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add an option to a question
         * @param {string} id 
         * @param {QuestionOptionBody} questionOptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addQuestionOption(id: string, questionOptionBody: QuestionOptionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionOptionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addQuestionOption(id, questionOptionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.addQuestionOption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary bulk delete questions
         * @param {QuestionBulkDelete} questionBulkDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteQuestion(questionBulkDelete: QuestionBulkDelete, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteQuestion(questionBulkDelete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.bulkDeleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a question, try to avoid using this endpoint by using existing questions
         * @param {QuestionBody} questionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestion(questionBody: QuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestion(questionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add context translations to a question
         * @param {string} id 
         * @param {QuestionContextTranslationBody} questionContextTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestionContextTranslations(id: string, questionContextTranslationBody: QuestionContextTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionContextTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestionContextTranslations(id, questionContextTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestionContextTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create the dependencies of a question
         * @param {string} id 
         * @param {QuestionDependencyBody} questionDependencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestionDependency(id: string, questionDependencyBody: QuestionDependencyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDependencyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestionDependency(id, questionDependencyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestionDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add translations to a question
         * @param {string} id 
         * @param {QuestionTranslationBody} questionTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestionTranslations(id: string, questionTranslationBody: QuestionTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestionTranslations(id, questionTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuestion(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuestion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.deleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an option from a question
         * @param {string} questionId 
         * @param {string} optionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuestionOption(questionId: string, optionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuestionOption(questionId, optionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.deleteQuestionOption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the AI-proposed dependencies of a question, every status, newest first
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDependencyProposals(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDependencyProposalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDependencyProposals(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getDependencyProposals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch categories of a question
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {CategoryType} [categoryType] 
         * @param {OrderDirection} [orderDirection] 
         * @param {CategoryOrderBy} [orderBy] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionCategories(id: string, limit?: number | null, offset?: number | null, categoryType?: CategoryType, orderDirection?: OrderDirection, orderBy?: CategoryOrderBy, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionCategoryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionCategories(id, limit, offset, categoryType, orderDirection, orderBy, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the translations of a question context
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionContextTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionContextTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionContextTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionContextTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the trial (criteria) that the question is linked to
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [diseaseSearchString] 
         * @param {string} [leadSponsorSearchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionCriteria(id: string, limit?: number | null, offset?: number | null, diseaseSearchString?: string, leadSponsorSearchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionCriteriaListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionCriteria(id, limit, offset, diseaseSearchString, leadSponsorSearchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the dependencies of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionDependencies(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDependencyListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionDependencies(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionDependencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the options and their translations the specified question
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionOptions(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionOptionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionOptions(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the translations of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the search string
         * @param {GetQuestionsBody} getQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestions(getQuestionsBody: GetQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionCountListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestions(getQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the specified question
         * @param {boolean | null} currentVersionOnly 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimilarQuestions(currentVersionOnly: boolean | null, id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimilarQuestions(currentVersionOnly, id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getSimilarQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the suggested questions of the specified question
         * @param {number} threshold 
         * @param {boolean | null} currentVersionOnly 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestedQuestions(threshold: number, currentVersionOnly: boolean | null, id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuggestedQuestions(threshold, currentVersionOnly, id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getSuggestedQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exclude a question from the merge suggestions of the given question
         * @param {string} id 
         * @param {QuestionIgnoreMergeBody} questionIgnoreMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ignoreMerge(id: string, questionIgnoreMergeBody: QuestionIgnoreMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ignoreMerge(id, questionIgnoreMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.ignoreMerge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary merge this question into the specified target question.
         * @param {string} id 
         * @param {QuestionMergeBody} questionMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeQuestions(id: string, questionMergeBody: QuestionMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeQuestions(id, questionMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.mergeQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Compute what a dependency would derive for a sample source answer, without saving it
         * @param {string} id 
         * @param {QuestionDependencyPreviewBody} questionDependencyPreviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewQuestionDependency(id: string, questionDependencyPreviewBody: QuestionDependencyPreviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDependencyPreviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewQuestionDependency(id, questionDependencyPreviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.previewQuestionDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a category from a question
         * @param {string} id 
         * @param {RemoveQuestionCategoryBody} removeQuestionCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeQuestionCategory(id: string, removeQuestionCategoryBody: RemoveQuestionCategoryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeQuestionCategory(id, removeQuestionCategoryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.removeQuestionCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a new chat entry to re-answer a question
         * @param {string} id 
         * @param {RetryQuestionBody} retryQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryQuestion(id: string, retryQuestionBody: RetryQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryQuestion(id, retryQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.retryQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the details of a question, no relations will be affected by this
         * @param {string} id 
         * @param {QuestionUpdateBody} questionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestion(id: string, questionUpdateBody: QuestionUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestion(id, questionUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.updateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the key or the translations of an option
         * @param {string} questionId 
         * @param {string} optionId 
         * @param {QuestionOptionUpdateBody} questionOptionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestionOption(questionId: string, optionId: string, questionOptionUpdateBody: QuestionOptionUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionOptionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestionOption(questionId, optionId, questionOptionUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.updateQuestionOption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionsApi - factory interface
 * @export
 */
export const QuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a category to a question
         * @param {QuestionsApiAddQuestionCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuestionCategory(requestParameters: QuestionsApiAddQuestionCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addQuestionCategory(requestParameters.id, requestParameters.addQuestionCategoryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add an option to a question
         * @param {QuestionsApiAddQuestionOptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuestionOption(requestParameters: QuestionsApiAddQuestionOptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionOptionView> {
            return localVarFp.addQuestionOption(requestParameters.id, requestParameters.questionOptionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary bulk delete questions
         * @param {QuestionsApiBulkDeleteQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteQuestion(requestParameters: QuestionsApiBulkDeleteQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkDeleteQuestion(requestParameters.questionBulkDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a question, try to avoid using this endpoint by using existing questions
         * @param {QuestionsApiCreateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestion(requestParameters: QuestionsApiCreateQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionView> {
            return localVarFp.createQuestion(requestParameters.questionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add context translations to a question
         * @param {QuestionsApiCreateQuestionContextTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionContextTranslations(requestParameters: QuestionsApiCreateQuestionContextTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionContextTranslationView> {
            return localVarFp.createQuestionContextTranslations(requestParameters.id, requestParameters.questionContextTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create the dependencies of a question
         * @param {QuestionsApiCreateQuestionDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionDependency(requestParameters: QuestionsApiCreateQuestionDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDependencyView> {
            return localVarFp.createQuestionDependency(requestParameters.id, requestParameters.questionDependencyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add translations to a question
         * @param {QuestionsApiCreateQuestionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionTranslations(requestParameters: QuestionsApiCreateQuestionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionTranslationView> {
            return localVarFp.createQuestionTranslations(requestParameters.id, requestParameters.questionTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a question
         * @param {QuestionsApiDeleteQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestion(requestParameters: QuestionsApiDeleteQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteQuestion(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an option from a question
         * @param {QuestionsApiDeleteQuestionOptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionOption(requestParameters: QuestionsApiDeleteQuestionOptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteQuestionOption(requestParameters.questionId, requestParameters.optionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the AI-proposed dependencies of a question, every status, newest first
         * @param {QuestionsApiGetDependencyProposalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependencyProposals(requestParameters: QuestionsApiGetDependencyProposalsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDependencyProposalView> {
            return localVarFp.getDependencyProposals(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch categories of a question
         * @param {QuestionsApiGetQuestionCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCategories(requestParameters: QuestionsApiGetQuestionCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionCategoryView> {
            return localVarFp.getQuestionCategories(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.categoryType, requestParameters.orderDirection, requestParameters.orderBy, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the translations of a question context
         * @param {QuestionsApiGetQuestionContextTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionContextTranslations(requestParameters: QuestionsApiGetQuestionContextTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionContextTranslationView> {
            return localVarFp.getQuestionContextTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the trial (criteria) that the question is linked to
         * @param {QuestionsApiGetQuestionCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCriteria(requestParameters: QuestionsApiGetQuestionCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionCriteriaListView> {
            return localVarFp.getQuestionCriteria(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.diseaseSearchString, requestParameters.leadSponsorSearchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the dependencies of a question
         * @param {QuestionsApiGetQuestionDependenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionDependencies(requestParameters: QuestionsApiGetQuestionDependenciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDependencyListView> {
            return localVarFp.getQuestionDependencies(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a question
         * @param {QuestionsApiGetQuestionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionDetails(requestParameters: QuestionsApiGetQuestionDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsView> {
            return localVarFp.getQuestionDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the options and their translations the specified question
         * @param {QuestionsApiGetQuestionOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionOptions(requestParameters: QuestionsApiGetQuestionOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionOptionView> {
            return localVarFp.getQuestionOptions(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the translations of a question
         * @param {QuestionsApiGetQuestionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionTranslations(requestParameters: QuestionsApiGetQuestionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionTranslationView> {
            return localVarFp.getQuestionTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the search string
         * @param {QuestionsApiGetQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestions(requestParameters: QuestionsApiGetQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionCountListView> {
            return localVarFp.getQuestions(requestParameters.getQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the specified question
         * @param {QuestionsApiGetSimilarQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimilarQuestions(requestParameters: QuestionsApiGetSimilarQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionView> {
            return localVarFp.getSimilarQuestions(requestParameters.currentVersionOnly, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the suggested questions of the specified question
         * @param {QuestionsApiGetSuggestedQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedQuestions(requestParameters: QuestionsApiGetSuggestedQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionView> {
            return localVarFp.getSuggestedQuestions(requestParameters.threshold, requestParameters.currentVersionOnly, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exclude a question from the merge suggestions of the given question
         * @param {QuestionsApiIgnoreMergeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreMerge(requestParameters: QuestionsApiIgnoreMergeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ignoreMerge(requestParameters.id, requestParameters.questionIgnoreMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary merge this question into the specified target question.
         * @param {QuestionsApiMergeQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeQuestions(requestParameters: QuestionsApiMergeQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsView> {
            return localVarFp.mergeQuestions(requestParameters.id, requestParameters.questionMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Compute what a dependency would derive for a sample source answer, without saving it
         * @param {QuestionsApiPreviewQuestionDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewQuestionDependency(requestParameters: QuestionsApiPreviewQuestionDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDependencyPreviewView> {
            return localVarFp.previewQuestionDependency(requestParameters.id, requestParameters.questionDependencyPreviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a category from a question
         * @param {QuestionsApiRemoveQuestionCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQuestionCategory(requestParameters: QuestionsApiRemoveQuestionCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeQuestionCategory(requestParameters.id, requestParameters.removeQuestionCategoryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new chat entry to re-answer a question
         * @param {QuestionsApiRetryQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryQuestion(requestParameters: QuestionsApiRetryQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.retryQuestion(requestParameters.id, requestParameters.retryQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the details of a question, no relations will be affected by this
         * @param {QuestionsApiUpdateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestion(requestParameters: QuestionsApiUpdateQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsView> {
            return localVarFp.updateQuestion(requestParameters.id, requestParameters.questionUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the key or the translations of an option
         * @param {QuestionsApiUpdateQuestionOptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionOption(requestParameters: QuestionsApiUpdateQuestionOptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionOptionView> {
            return localVarFp.updateQuestionOption(requestParameters.questionId, requestParameters.optionId, requestParameters.questionOptionUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addQuestionCategory operation in QuestionsApi.
 * @export
 * @interface QuestionsApiAddQuestionCategoryRequest
 */
export interface QuestionsApiAddQuestionCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiAddQuestionCategory
     */
    readonly id: string

    /**
     * 
     * @type {AddQuestionCategoryBody}
     * @memberof QuestionsApiAddQuestionCategory
     */
    readonly addQuestionCategoryBody: AddQuestionCategoryBody
}

/**
 * Request parameters for addQuestionOption operation in QuestionsApi.
 * @export
 * @interface QuestionsApiAddQuestionOptionRequest
 */
export interface QuestionsApiAddQuestionOptionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiAddQuestionOption
     */
    readonly id: string

    /**
     * 
     * @type {QuestionOptionBody}
     * @memberof QuestionsApiAddQuestionOption
     */
    readonly questionOptionBody: QuestionOptionBody
}

/**
 * Request parameters for bulkDeleteQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiBulkDeleteQuestionRequest
 */
export interface QuestionsApiBulkDeleteQuestionRequest {
    /**
     * 
     * @type {QuestionBulkDelete}
     * @memberof QuestionsApiBulkDeleteQuestion
     */
    readonly questionBulkDelete: QuestionBulkDelete
}

/**
 * Request parameters for createQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiCreateQuestionRequest
 */
export interface QuestionsApiCreateQuestionRequest {
    /**
     * 
     * @type {QuestionBody}
     * @memberof QuestionsApiCreateQuestion
     */
    readonly questionBody: QuestionBody
}

/**
 * Request parameters for createQuestionContextTranslations operation in QuestionsApi.
 * @export
 * @interface QuestionsApiCreateQuestionContextTranslationsRequest
 */
export interface QuestionsApiCreateQuestionContextTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiCreateQuestionContextTranslations
     */
    readonly id: string

    /**
     * 
     * @type {QuestionContextTranslationBody}
     * @memberof QuestionsApiCreateQuestionContextTranslations
     */
    readonly questionContextTranslationBody: QuestionContextTranslationBody
}

/**
 * Request parameters for createQuestionDependency operation in QuestionsApi.
 * @export
 * @interface QuestionsApiCreateQuestionDependencyRequest
 */
export interface QuestionsApiCreateQuestionDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiCreateQuestionDependency
     */
    readonly id: string

    /**
     * 
     * @type {QuestionDependencyBody}
     * @memberof QuestionsApiCreateQuestionDependency
     */
    readonly questionDependencyBody: QuestionDependencyBody
}

/**
 * Request parameters for createQuestionTranslations operation in QuestionsApi.
 * @export
 * @interface QuestionsApiCreateQuestionTranslationsRequest
 */
export interface QuestionsApiCreateQuestionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiCreateQuestionTranslations
     */
    readonly id: string

    /**
     * 
     * @type {QuestionTranslationBody}
     * @memberof QuestionsApiCreateQuestionTranslations
     */
    readonly questionTranslationBody: QuestionTranslationBody
}

/**
 * Request parameters for deleteQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiDeleteQuestionRequest
 */
export interface QuestionsApiDeleteQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiDeleteQuestion
     */
    readonly id: string
}

/**
 * Request parameters for deleteQuestionOption operation in QuestionsApi.
 * @export
 * @interface QuestionsApiDeleteQuestionOptionRequest
 */
export interface QuestionsApiDeleteQuestionOptionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiDeleteQuestionOption
     */
    readonly questionId: string

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiDeleteQuestionOption
     */
    readonly optionId: string
}

/**
 * Request parameters for getDependencyProposals operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetDependencyProposalsRequest
 */
export interface QuestionsApiGetDependencyProposalsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetDependencyProposals
     */
    readonly id: string
}

/**
 * Request parameters for getQuestionCategories operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionCategoriesRequest
 */
export interface QuestionsApiGetQuestionCategoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly offset?: number | null

    /**
     * 
     * @type {CategoryType}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly categoryType?: CategoryType

    /**
     * 
     * @type {OrderDirection}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {CategoryOrderBy}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly orderBy?: CategoryOrderBy

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly searchString?: string
}

/**
 * Request parameters for getQuestionContextTranslations operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionContextTranslationsRequest
 */
export interface QuestionsApiGetQuestionContextTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionContextTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getQuestionCriteria operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionCriteriaRequest
 */
export interface QuestionsApiGetQuestionCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly diseaseSearchString?: string

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly leadSponsorSearchString?: string
}

/**
 * Request parameters for getQuestionDependencies operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionDependenciesRequest
 */
export interface QuestionsApiGetQuestionDependenciesRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionDependencies
     */
    readonly id: string
}

/**
 * Request parameters for getQuestionDetails operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionDetailsRequest
 */
export interface QuestionsApiGetQuestionDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionDetails
     */
    readonly id: string
}

/**
 * Request parameters for getQuestionOptions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionOptionsRequest
 */
export interface QuestionsApiGetQuestionOptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionOptions
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionOptions
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionOptions
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getQuestionTranslations operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionTranslationsRequest
 */
export interface QuestionsApiGetQuestionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getQuestions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionsRequest
 */
export interface QuestionsApiGetQuestionsRequest {
    /**
     * 
     * @type {GetQuestionsBody}
     * @memberof QuestionsApiGetQuestions
     */
    readonly getQuestionsBody: GetQuestionsBody
}

/**
 * Request parameters for getSimilarQuestions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetSimilarQuestionsRequest
 */
export interface QuestionsApiGetSimilarQuestionsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof QuestionsApiGetSimilarQuestions
     */
    readonly currentVersionOnly: boolean | null

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetSimilarQuestions
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSimilarQuestions
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSimilarQuestions
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getSuggestedQuestions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetSuggestedQuestionsRequest
 */
export interface QuestionsApiGetSuggestedQuestionsRequest {
    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly threshold: number

    /**
     * 
     * @type {boolean}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly currentVersionOnly: boolean | null

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly offset?: number | null
}

/**
 * Request parameters for ignoreMerge operation in QuestionsApi.
 * @export
 * @interface QuestionsApiIgnoreMergeRequest
 */
export interface QuestionsApiIgnoreMergeRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiIgnoreMerge
     */
    readonly id: string

    /**
     * 
     * @type {QuestionIgnoreMergeBody}
     * @memberof QuestionsApiIgnoreMerge
     */
    readonly questionIgnoreMergeBody: QuestionIgnoreMergeBody
}

/**
 * Request parameters for mergeQuestions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiMergeQuestionsRequest
 */
export interface QuestionsApiMergeQuestionsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiMergeQuestions
     */
    readonly id: string

    /**
     * 
     * @type {QuestionMergeBody}
     * @memberof QuestionsApiMergeQuestions
     */
    readonly questionMergeBody: QuestionMergeBody
}

/**
 * Request parameters for previewQuestionDependency operation in QuestionsApi.
 * @export
 * @interface QuestionsApiPreviewQuestionDependencyRequest
 */
export interface QuestionsApiPreviewQuestionDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiPreviewQuestionDependency
     */
    readonly id: string

    /**
     * 
     * @type {QuestionDependencyPreviewBody}
     * @memberof QuestionsApiPreviewQuestionDependency
     */
    readonly questionDependencyPreviewBody: QuestionDependencyPreviewBody
}

/**
 * Request parameters for removeQuestionCategory operation in QuestionsApi.
 * @export
 * @interface QuestionsApiRemoveQuestionCategoryRequest
 */
export interface QuestionsApiRemoveQuestionCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiRemoveQuestionCategory
     */
    readonly id: string

    /**
     * 
     * @type {RemoveQuestionCategoryBody}
     * @memberof QuestionsApiRemoveQuestionCategory
     */
    readonly removeQuestionCategoryBody: RemoveQuestionCategoryBody
}

/**
 * Request parameters for retryQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiRetryQuestionRequest
 */
export interface QuestionsApiRetryQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiRetryQuestion
     */
    readonly id: string

    /**
     * 
     * @type {RetryQuestionBody}
     * @memberof QuestionsApiRetryQuestion
     */
    readonly retryQuestionBody: RetryQuestionBody
}

/**
 * Request parameters for updateQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiUpdateQuestionRequest
 */
export interface QuestionsApiUpdateQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiUpdateQuestion
     */
    readonly id: string

    /**
     * 
     * @type {QuestionUpdateBody}
     * @memberof QuestionsApiUpdateQuestion
     */
    readonly questionUpdateBody: QuestionUpdateBody
}

/**
 * Request parameters for updateQuestionOption operation in QuestionsApi.
 * @export
 * @interface QuestionsApiUpdateQuestionOptionRequest
 */
export interface QuestionsApiUpdateQuestionOptionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiUpdateQuestionOption
     */
    readonly questionId: string

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiUpdateQuestionOption
     */
    readonly optionId: string

    /**
     * 
     * @type {QuestionOptionUpdateBody}
     * @memberof QuestionsApiUpdateQuestionOption
     */
    readonly questionOptionUpdateBody: QuestionOptionUpdateBody
}

/**
 * QuestionsApi - object-oriented interface
 * @export
 * @class QuestionsApi
 * @extends {BaseAPI}
 */
export class QuestionsApi extends BaseAPI {
    /**
     * 
     * @summary Add a category to a question
     * @param {QuestionsApiAddQuestionCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public addQuestionCategory(requestParameters: QuestionsApiAddQuestionCategoryRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).addQuestionCategory(requestParameters.id, requestParameters.addQuestionCategoryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add an option to a question
     * @param {QuestionsApiAddQuestionOptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public addQuestionOption(requestParameters: QuestionsApiAddQuestionOptionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).addQuestionOption(requestParameters.id, requestParameters.questionOptionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary bulk delete questions
     * @param {QuestionsApiBulkDeleteQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public bulkDeleteQuestion(requestParameters: QuestionsApiBulkDeleteQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).bulkDeleteQuestion(requestParameters.questionBulkDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a question, try to avoid using this endpoint by using existing questions
     * @param {QuestionsApiCreateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestion(requestParameters: QuestionsApiCreateQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestion(requestParameters.questionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add context translations to a question
     * @param {QuestionsApiCreateQuestionContextTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestionContextTranslations(requestParameters: QuestionsApiCreateQuestionContextTranslationsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestionContextTranslations(requestParameters.id, requestParameters.questionContextTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create the dependencies of a question
     * @param {QuestionsApiCreateQuestionDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestionDependency(requestParameters: QuestionsApiCreateQuestionDependencyRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestionDependency(requestParameters.id, requestParameters.questionDependencyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add translations to a question
     * @param {QuestionsApiCreateQuestionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestionTranslations(requestParameters: QuestionsApiCreateQuestionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestionTranslations(requestParameters.id, requestParameters.questionTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a question
     * @param {QuestionsApiDeleteQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public deleteQuestion(requestParameters: QuestionsApiDeleteQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).deleteQuestion(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an option from a question
     * @param {QuestionsApiDeleteQuestionOptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public deleteQuestionOption(requestParameters: QuestionsApiDeleteQuestionOptionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).deleteQuestionOption(requestParameters.questionId, requestParameters.optionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the AI-proposed dependencies of a question, every status, newest first
     * @param {QuestionsApiGetDependencyProposalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getDependencyProposals(requestParameters: QuestionsApiGetDependencyProposalsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getDependencyProposals(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch categories of a question
     * @param {QuestionsApiGetQuestionCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionCategories(requestParameters: QuestionsApiGetQuestionCategoriesRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionCategories(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.categoryType, requestParameters.orderDirection, requestParameters.orderBy, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the translations of a question context
     * @param {QuestionsApiGetQuestionContextTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionContextTranslations(requestParameters: QuestionsApiGetQuestionContextTranslationsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionContextTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the trial (criteria) that the question is linked to
     * @param {QuestionsApiGetQuestionCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionCriteria(requestParameters: QuestionsApiGetQuestionCriteriaRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionCriteria(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.diseaseSearchString, requestParameters.leadSponsorSearchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the dependencies of a question
     * @param {QuestionsApiGetQuestionDependenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionDependencies(requestParameters: QuestionsApiGetQuestionDependenciesRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionDependencies(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a question
     * @param {QuestionsApiGetQuestionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionDetails(requestParameters: QuestionsApiGetQuestionDetailsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the options and their translations the specified question
     * @param {QuestionsApiGetQuestionOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionOptions(requestParameters: QuestionsApiGetQuestionOptionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionOptions(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the translations of a question
     * @param {QuestionsApiGetQuestionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionTranslations(requestParameters: QuestionsApiGetQuestionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the nearest neighbor questions of the search string
     * @param {QuestionsApiGetQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestions(requestParameters: QuestionsApiGetQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestions(requestParameters.getQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the nearest neighbor questions of the specified question
     * @param {QuestionsApiGetSimilarQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getSimilarQuestions(requestParameters: QuestionsApiGetSimilarQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getSimilarQuestions(requestParameters.currentVersionOnly, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the suggested questions of the specified question
     * @param {QuestionsApiGetSuggestedQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getSuggestedQuestions(requestParameters: QuestionsApiGetSuggestedQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getSuggestedQuestions(requestParameters.threshold, requestParameters.currentVersionOnly, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exclude a question from the merge suggestions of the given question
     * @param {QuestionsApiIgnoreMergeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public ignoreMerge(requestParameters: QuestionsApiIgnoreMergeRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).ignoreMerge(requestParameters.id, requestParameters.questionIgnoreMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary merge this question into the specified target question.
     * @param {QuestionsApiMergeQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public mergeQuestions(requestParameters: QuestionsApiMergeQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).mergeQuestions(requestParameters.id, requestParameters.questionMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Compute what a dependency would derive for a sample source answer, without saving it
     * @param {QuestionsApiPreviewQuestionDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public previewQuestionDependency(requestParameters: QuestionsApiPreviewQuestionDependencyRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).previewQuestionDependency(requestParameters.id, requestParameters.questionDependencyPreviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a category from a question
     * @param {QuestionsApiRemoveQuestionCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public removeQuestionCategory(requestParameters: QuestionsApiRemoveQuestionCategoryRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).removeQuestionCategory(requestParameters.id, requestParameters.removeQuestionCategoryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new chat entry to re-answer a question
     * @param {QuestionsApiRetryQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public retryQuestion(requestParameters: QuestionsApiRetryQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).retryQuestion(requestParameters.id, requestParameters.retryQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the details of a question, no relations will be affected by this
     * @param {QuestionsApiUpdateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public updateQuestion(requestParameters: QuestionsApiUpdateQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).updateQuestion(requestParameters.id, requestParameters.questionUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the key or the translations of an option
     * @param {QuestionsApiUpdateQuestionOptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public updateQuestionOption(requestParameters: QuestionsApiUpdateQuestionOptionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).updateQuestionOption(requestParameters.questionId, requestParameters.optionId, requestParameters.questionOptionUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecordSharesApi - axios parameter creator
 * @export
 */
export const RecordSharesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Partner return after the patient\'s authorisation step; relays to the web app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorisationCallback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/record-shares/authorisation/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Partner return after the patient\'s identity step; relays to the web app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityCallback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/record-shares/identity/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecordSharesApi - functional programming interface
 * @export
 */
export const RecordSharesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecordSharesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Partner return after the patient\'s authorisation step; relays to the web app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorisationCallback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorisationCallback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordSharesApi.authorisationCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Partner return after the patient\'s identity step; relays to the web app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identityCallback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identityCallback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordSharesApi.identityCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecordSharesApi - factory interface
 * @export
 */
export const RecordSharesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecordSharesApiFp(configuration)
    return {
        /**
         * 
         * @summary Partner return after the patient\'s authorisation step; relays to the web app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorisationCallback(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authorisationCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Partner return after the patient\'s identity step; relays to the web app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityCallback(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.identityCallback(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecordSharesApi - object-oriented interface
 * @export
 * @class RecordSharesApi
 * @extends {BaseAPI}
 */
export class RecordSharesApi extends BaseAPI {
    /**
     * 
     * @summary Partner return after the patient\'s authorisation step; relays to the web app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordSharesApi
     */
    public authorisationCallback(options?: RawAxiosRequestConfig) {
        return RecordSharesApiFp(this.configuration).authorisationCallback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Partner return after the patient\'s identity step; relays to the web app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordSharesApi
     */
    public identityCallback(options?: RawAxiosRequestConfig) {
        return RecordSharesApiFp(this.configuration).identityCallback(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportingApi - axios parameter creator
 * @export
 */
export const ReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Geocode every (zip code, country) patients have answered into geo_point, feeding the patient map (admin only, idempotent, capped per run; pass the returned nextCursor as `after` to continue).
         * @param {GeocodePatientRegionsBody} geocodePatientRegionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodePatientRegions: async (geocodePatientRegionsBody: GeocodePatientRegionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'geocodePatientRegionsBody' is not null or undefined
            assertParamExists('geocodePatientRegions', 'geocodePatientRegionsBody', geocodePatientRegionsBody)
            const localVarPath = `/reporting/geocode-patient-regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(geocodePatientRegionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: how the eligibility chat questions are answered and skipped — per question, per skip reason, per answer and per month. Sliceable on the paid tier.
         * @param {Array<string>} [question] Keep these questions (question ids).
         * @param {Array<string>} [questionType] Keep questions of any of these question types.
         * @param {Array<string>} [answerType] Keep questions of any of these answer types.
         * @param {Array<string>} [generationType] Keep questions of any of these generation types.
         * @param {string} [fromDate] Keep questions asked in or after this month, YYYY-MM-DD.
         * @param {string} [toDate] Keep questions asked in or before this month, YYYY-MM-DD.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatbot: async (question?: Array<string>, questionType?: Array<string>, answerType?: Array<string>, generationType?: Array<string>, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/chatbot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (question) {
                localVarQueryParameter['question'] = question;
            }

            if (questionType) {
                localVarQueryParameter['questionType'] = questionType;
            }

            if (answerType) {
                localVarQueryParameter['answerType'] = answerType;
            }

            if (generationType) {
                localVarQueryParameter['generationType'] = generationType;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights partner dashboard: acquisition-cohort conversion funnel, scoped server-side to the caller team\'s reportingSourceSlugs.
         * @param {string} fromDate Any date within the starting month of the acquisition-date range (inclusive), YYYY-MM-DD. The underlying aggregate is month-granular, so the query is expanded to the whole month.
         * @param {string} toDate Any date within the ending month of the acquisition-date range (inclusive), YYYY-MM-DD. The underlying aggregate is month-granular, so the query is expanded to the whole month.
         * @param {string} [gender] Filter the funnel to a single gender value. At most one of gender/country/healthStatus/therapeuticArea may be set at a time — the underlying aggregate pre-computes one breakdown dimension per row, not their cross product.
         * @param {string} [country] Filter the funnel to a single country value. See gender for the combinability rule.
         * @param {GetFunnelHealthStatusEnum} [healthStatus] Filter the funnel to a single health status. See gender for the combinability rule.
         * @param {GetFunnelTherapeuticAreaEnum} [therapeuticArea] Filter the funnel to a single therapeutic area. A patient carrying more than one area is counted under each, so per-area funnel totals do not sum back to the unfiltered total. See gender for the combinability rule.
         * @param {string} [asTeamId] Admin-only: view this team\&#39;s Insights dashboard instead of the caller\&#39;s own. Rejected with 403 for a non-admin caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFunnel: async (fromDate: string, toDate: string, gender?: string, country?: string, healthStatus?: GetFunnelHealthStatusEnum, therapeuticArea?: GetFunnelTherapeuticAreaEnum, asTeamId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getFunnel', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getFunnel', 'toDate', toDate)
            const localVarPath = `/reporting/funnel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (healthStatus !== undefined) {
                localVarQueryParameter['healthStatus'] = healthStatus;
            }

            if (therapeuticArea !== undefined) {
                localVarQueryParameter['therapeuticArea'] = therapeuticArea;
            }

            if (asTeamId !== undefined) {
                localVarQueryParameter['asTeamId'] = asTeamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The caller\'s Insights tier (free or paid), so the dashboard can render tier chrome before loading data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsightsTier: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/tier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights overview: the cockpit curated for the caller: their team\'s trials and sources (a partner), the investigation site their team names, else the global view. Trials, patients, sites, users per month and a map. Admins pass `asTeamId` or `profile` to view as a team or a listed site.
         * @param {string} [asTeamId] Admin-only: view the overview as this team (its trials, sources and site name) instead of the caller\&#39;s own. Audited. Rejected with 403 for a non-admin caller.
         * @param {string} [profile] Admin-only: view the overview as this listed profile (an investigation site without a team, see &#x60;profiles&#x60; in the response). Rejected with 403 for a non-admin caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanding: async (asTeamId?: string, profile?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/landing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asTeamId !== undefined) {
                localVarQueryParameter['asTeamId'] = asTeamId;
            }

            if (profile !== undefined) {
                localVarQueryParameter['profile'] = profile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: aggregate patient map points — per country on the free tier, per ~10 km region on the paid tier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientGeography: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/patient-geography`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: composition of the EU patient population (country, gender, age group, health status, smoking, language, therapeutic area, disease; BMI on the paid tier). Sliceable on the paid tier.
         * @param {Array<string>} [ageGroup] Keep patients in any of these age groups.
         * @param {Array<string>} [gender] Keep patients of any of these genders.
         * @param {Array<string>} [country] Keep patients living in any of these EU countries.
         * @param {Array<string>} [smoking] Keep patients with any of these smoking statuses (Smoker, Non-smoker, Not specified).
         * @param {Array<string>} [disease] Keep patients with any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep patients in any of these therapeutic areas.
         * @param {Array<string>} [language] Keep patients using any of these languages.
         * @param {string} [acquiredFrom] Keep patients acquired in or after this month, YYYY-MM-DD.
         * @param {string} [acquiredTo] Keep patients acquired in or before this month, YYYY-MM-DD.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOverviewGlobal: async (ageGroup?: Array<string>, gender?: Array<string>, country?: Array<string>, smoking?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, language?: Array<string>, acquiredFrom?: string, acquiredTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/patient-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ageGroup) {
                localVarQueryParameter['ageGroup'] = ageGroup;
            }

            if (gender) {
                localVarQueryParameter['gender'] = gender;
            }

            if (country) {
                localVarQueryParameter['country'] = country;
            }

            if (smoking) {
                localVarQueryParameter['smoking'] = smoking;
            }

            if (disease) {
                localVarQueryParameter['disease'] = disease;
            }

            if (therapeuticArea) {
                localVarQueryParameter['therapeuticArea'] = therapeuticArea;
            }

            if (language) {
                localVarQueryParameter['language'] = language;
            }

            if (acquiredFrom !== undefined) {
                localVarQueryParameter['acquiredFrom'] = acquiredFrom;
            }

            if (acquiredTo !== undefined) {
                localVarQueryParameter['acquiredTo'] = acquiredTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: where EU patients turn matches down as too far, as ~100 km demand cells against the nearest recruiting site of the rejected trial — per country on the free tier, per cell with the site layer on the paid tier. Sliceable on the paid tier.
         * @param {Array<string>} [userCountry] Keep rejections by patients living in any of these EU countries.
         * @param {Array<string>} [userGender] Keep rejections by patients of any of these genders.
         * @param {Array<string>} [trialTherapeuticArea] Keep rejections of trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep rejections of trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep rejections of trials of any of these sponsor classes.
         * @param {Array<string>} [userSource] Keep rejections by patients from any of these acquisition sources.
         * @param {Array<string>} [trialDisease] Keep rejections of trials for any of these diseases.
         * @param {Array<string>} [nearestSiteCity] Keep rejections whose nearest recruiting site is in any of these cities (normalised city name).
         * @param {Array<string>} [nearestSiteFacility] Keep rejections whose nearest recruiting site is any of these facilities (normalised facility name).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteOpportunity: async (userCountry?: Array<string>, userGender?: Array<string>, trialTherapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, userSource?: Array<string>, trialDisease?: Array<string>, nearestSiteCity?: Array<string>, nearestSiteFacility?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/site-opportunity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userCountry) {
                localVarQueryParameter['userCountry'] = userCountry;
            }

            if (userGender) {
                localVarQueryParameter['userGender'] = userGender;
            }

            if (trialTherapeuticArea) {
                localVarQueryParameter['trialTherapeuticArea'] = trialTherapeuticArea;
            }

            if (sponsor) {
                localVarQueryParameter['sponsor'] = sponsor;
            }

            if (sponsorClass) {
                localVarQueryParameter['sponsorClass'] = sponsorClass;
            }

            if (userSource) {
                localVarQueryParameter['userSource'] = userSource;
            }

            if (trialDisease) {
                localVarQueryParameter['trialDisease'] = trialDisease;
            }

            if (nearestSiteCity) {
                localVarQueryParameter['nearestSiteCity'] = nearestSiteCity;
            }

            if (nearestSiteFacility) {
                localVarQueryParameter['nearestSiteFacility'] = nearestSiteFacility;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights (CTDI): study-completion delays of active trials — delayed count, average and median delay, average delay by therapeutic area, disease and country (public clinicaltrials.gov data).
         * @param {Array<string>} [country] Keep trials recruiting in any of these EU countries.
         * @param {Array<string>} [disease] Keep trials mapped to any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep trials of any of these sponsor classes.
         * @param {Array<string>} [gender] Keep trials with any of these gender criteria.
         * @param {Array<string>} [city] Keep trials recruiting at a site in any of these cities (normalised city name).
         * @param {Array<string>} [facility] Keep trials recruiting at any of these facilities (normalised facility name).
         * @param {Array<string>} [locationStatus] Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
         * @param {number} [ageFrom] Keep trials that accept some age at or above this, in years.
         * @param {number} [ageTo] Keep trials that accept some age at or below this, in years.
         * @param {number} [bmiFrom] Keep trials that accept some BMI at or above this.
         * @param {number} [bmiTo] Keep trials that accept some BMI at or below this.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialDelays: async (country?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, gender?: Array<string>, city?: Array<string>, facility?: Array<string>, locationStatus?: Array<string>, ageFrom?: number, ageTo?: number, bmiFrom?: number, bmiTo?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/trial-delays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (country) {
                localVarQueryParameter['country'] = country;
            }

            if (disease) {
                localVarQueryParameter['disease'] = disease;
            }

            if (therapeuticArea) {
                localVarQueryParameter['therapeuticArea'] = therapeuticArea;
            }

            if (sponsor) {
                localVarQueryParameter['sponsor'] = sponsor;
            }

            if (sponsorClass) {
                localVarQueryParameter['sponsorClass'] = sponsorClass;
            }

            if (gender) {
                localVarQueryParameter['gender'] = gender;
            }

            if (city) {
                localVarQueryParameter['city'] = city;
            }

            if (facility) {
                localVarQueryParameter['facility'] = facility;
            }

            if (locationStatus) {
                localVarQueryParameter['locationStatus'] = locationStatus;
            }

            if (ageFrom !== undefined) {
                localVarQueryParameter['ageFrom'] = ageFrom;
            }

            if (ageTo !== undefined) {
                localVarQueryParameter['ageTo'] = ageTo;
            }

            if (bmiFrom !== undefined) {
                localVarQueryParameter['bmiFrom'] = bmiFrom;
            }

            if (bmiTo !== undefined) {
                localVarQueryParameter['bmiTo'] = bmiTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: how active trials distribute their age, BMI, gender, and smoking eligibility thresholds. Sliceable on the paid tier.
         * @param {Array<string>} [country] Keep trials recruiting in any of these EU countries.
         * @param {Array<string>} [disease] Keep trials mapped to any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep trials of any of these sponsor classes.
         * @param {Array<string>} [gender] Keep trials with any of these gender criteria.
         * @param {Array<string>} [city] Keep trials recruiting at a site in any of these cities (normalised city name).
         * @param {Array<string>} [facility] Keep trials recruiting at any of these facilities (normalised facility name).
         * @param {Array<string>} [locationStatus] Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
         * @param {number} [ageFrom] Keep trials that accept some age at or above this, in years.
         * @param {number} [ageTo] Keep trials that accept some age at or below this, in years.
         * @param {number} [bmiFrom] Keep trials that accept some BMI at or above this.
         * @param {number} [bmiTo] Keep trials that accept some BMI at or below this.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialEligibility: async (country?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, gender?: Array<string>, city?: Array<string>, facility?: Array<string>, locationStatus?: Array<string>, ageFrom?: number, ageTo?: number, bmiFrom?: number, bmiTo?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/trial-criteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (country) {
                localVarQueryParameter['country'] = country;
            }

            if (disease) {
                localVarQueryParameter['disease'] = disease;
            }

            if (therapeuticArea) {
                localVarQueryParameter['therapeuticArea'] = therapeuticArea;
            }

            if (sponsor) {
                localVarQueryParameter['sponsor'] = sponsor;
            }

            if (sponsorClass) {
                localVarQueryParameter['sponsorClass'] = sponsorClass;
            }

            if (gender) {
                localVarQueryParameter['gender'] = gender;
            }

            if (city) {
                localVarQueryParameter['city'] = city;
            }

            if (facility) {
                localVarQueryParameter['facility'] = facility;
            }

            if (locationStatus) {
                localVarQueryParameter['locationStatus'] = locationStatus;
            }

            if (ageFrom !== undefined) {
                localVarQueryParameter['ageFrom'] = ageFrom;
            }

            if (ageTo !== undefined) {
                localVarQueryParameter['ageTo'] = ageTo;
            }

            if (bmiFrom !== undefined) {
                localVarQueryParameter['bmiFrom'] = bmiFrom;
            }

            if (bmiTo !== undefined) {
                localVarQueryParameter['bmiTo'] = bmiTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: trial sites per country, plus one point per site on the paid tier, for the sliced location statuses (recruiting sites unless the caller widens it). Sliceable on the paid tier.
         * @param {Array<string>} [country] Keep trials recruiting in any of these EU countries.
         * @param {Array<string>} [disease] Keep trials mapped to any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep trials of any of these sponsor classes.
         * @param {Array<string>} [gender] Keep trials with any of these gender criteria.
         * @param {Array<string>} [city] Keep trials recruiting at a site in any of these cities (normalised city name).
         * @param {Array<string>} [facility] Keep trials recruiting at any of these facilities (normalised facility name).
         * @param {Array<string>} [locationStatus] Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
         * @param {number} [ageFrom] Keep trials that accept some age at or above this, in years.
         * @param {number} [ageTo] Keep trials that accept some age at or below this, in years.
         * @param {number} [bmiFrom] Keep trials that accept some BMI at or above this.
         * @param {number} [bmiTo] Keep trials that accept some BMI at or below this.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialGeography: async (country?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, gender?: Array<string>, city?: Array<string>, facility?: Array<string>, locationStatus?: Array<string>, ageFrom?: number, ageTo?: number, bmiFrom?: number, bmiTo?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/trial-geography`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (country) {
                localVarQueryParameter['country'] = country;
            }

            if (disease) {
                localVarQueryParameter['disease'] = disease;
            }

            if (therapeuticArea) {
                localVarQueryParameter['therapeuticArea'] = therapeuticArea;
            }

            if (sponsor) {
                localVarQueryParameter['sponsor'] = sponsor;
            }

            if (sponsorClass) {
                localVarQueryParameter['sponsorClass'] = sponsorClass;
            }

            if (gender) {
                localVarQueryParameter['gender'] = gender;
            }

            if (city) {
                localVarQueryParameter['city'] = city;
            }

            if (facility) {
                localVarQueryParameter['facility'] = facility;
            }

            if (locationStatus) {
                localVarQueryParameter['locationStatus'] = locationStatus;
            }

            if (ageFrom !== undefined) {
                localVarQueryParameter['ageFrom'] = ageFrom;
            }

            if (ageTo !== undefined) {
                localVarQueryParameter['ageTo'] = ageTo;
            }

            if (bmiFrom !== undefined) {
                localVarQueryParameter['bmiFrom'] = bmiFrom;
            }

            if (bmiTo !== undefined) {
                localVarQueryParameter['bmiTo'] = bmiTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: active trials by therapeutic area, disease, country, sponsor class, and sponsor (public clinicaltrials.gov data).
         * @param {Array<string>} [country] Keep trials recruiting in any of these EU countries.
         * @param {Array<string>} [disease] Keep trials mapped to any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep trials of any of these sponsor classes.
         * @param {Array<string>} [gender] Keep trials with any of these gender criteria.
         * @param {Array<string>} [city] Keep trials recruiting at a site in any of these cities (normalised city name).
         * @param {Array<string>} [facility] Keep trials recruiting at any of these facilities (normalised facility name).
         * @param {Array<string>} [locationStatus] Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
         * @param {number} [ageFrom] Keep trials that accept some age at or above this, in years.
         * @param {number} [ageTo] Keep trials that accept some age at or below this, in years.
         * @param {number} [bmiFrom] Keep trials that accept some BMI at or above this.
         * @param {number} [bmiTo] Keep trials that accept some BMI at or below this.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialOverview: async (country?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, gender?: Array<string>, city?: Array<string>, facility?: Array<string>, locationStatus?: Array<string>, ageFrom?: number, ageTo?: number, bmiFrom?: number, bmiTo?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/trial-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (country) {
                localVarQueryParameter['country'] = country;
            }

            if (disease) {
                localVarQueryParameter['disease'] = disease;
            }

            if (therapeuticArea) {
                localVarQueryParameter['therapeuticArea'] = therapeuticArea;
            }

            if (sponsor) {
                localVarQueryParameter['sponsor'] = sponsor;
            }

            if (sponsorClass) {
                localVarQueryParameter['sponsorClass'] = sponsorClass;
            }

            if (gender) {
                localVarQueryParameter['gender'] = gender;
            }

            if (city) {
                localVarQueryParameter['city'] = city;
            }

            if (facility) {
                localVarQueryParameter['facility'] = facility;
            }

            if (locationStatus) {
                localVarQueryParameter['locationStatus'] = locationStatus;
            }

            if (ageFrom !== undefined) {
                localVarQueryParameter['ageFrom'] = ageFrom;
            }

            if (ageTo !== undefined) {
                localVarQueryParameter['ageTo'] = ageTo;
            }

            if (bmiFrom !== undefined) {
                localVarQueryParameter['bmiFrom'] = bmiFrom;
            }

            if (bmiTo !== undefined) {
                localVarQueryParameter['bmiTo'] = bmiTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: why EU patients turn down trial matches, per reason. Sliceable on the paid tier.
         * @param {Array<string>} [userCountry] Keep rejections by patients living in any of these EU countries.
         * @param {Array<string>} [userGender] Keep rejections by patients of any of these genders.
         * @param {Array<string>} [trialTherapeuticArea] Keep rejections of trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep rejections of trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep rejections of trials of any of these sponsor classes.
         * @param {Array<string>} [userSource] Keep rejections by patients from any of these acquisition sources.
         * @param {Array<string>} [trialDisease] Keep rejections of trials for any of these diseases.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialRejections: async (userCountry?: Array<string>, userGender?: Array<string>, trialTherapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, userSource?: Array<string>, trialDisease?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/trial-rejections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userCountry) {
                localVarQueryParameter['userCountry'] = userCountry;
            }

            if (userGender) {
                localVarQueryParameter['userGender'] = userGender;
            }

            if (trialTherapeuticArea) {
                localVarQueryParameter['trialTherapeuticArea'] = trialTherapeuticArea;
            }

            if (sponsor) {
                localVarQueryParameter['sponsor'] = sponsor;
            }

            if (sponsorClass) {
                localVarQueryParameter['sponsorClass'] = sponsorClass;
            }

            if (userSource) {
                localVarQueryParameter['userSource'] = userSource;
            }

            if (trialDisease) {
                localVarQueryParameter['trialDisease'] = trialDisease;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: the global acquisition-cohort funnel across every Curewiki patient, by acquisition month, source and one breakdown dimension. Sliceable on the paid tier.
         * @param {string} [fromDate] Keep patients acquired in or after this month, YYYY-MM-DD.
         * @param {string} [toDate] Keep patients acquired in or before this month, YYYY-MM-DD.
         * @param {Array<string>} [source] Keep patients from any of these acquisition sources.
         * @param {GetUserFunnelDimensionEnum} [dimension] The one dimension to slice on: country, gender, healthStatus, therapeuticArea, ageGroup, segmentation or disease. Requires &#x60;values&#x60;.
         * @param {Array<string>} [values] Keep patients whose &#x60;dimension&#x60; takes any of these values.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFunnel: async (fromDate?: string, toDate?: string, source?: Array<string>, dimension?: GetUserFunnelDimensionEnum, values?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/user-funnel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (source) {
                localVarQueryParameter['source'] = source;
            }

            if (dimension !== undefined) {
                localVarQueryParameter['dimension'] = dimension;
            }

            if (values) {
                localVarQueryParameter['values'] = values;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights partner dashboard: patient composition (country/gender/age-group/health-status), scoped server-side to the caller team\'s reportingSourceSlugs.
         * @param {string} [asTeamId] Admin-only: view this team\&#39;s Insights dashboard instead of the caller\&#39;s own. Rejected with 403 for a non-admin caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOverview: async (asTeamId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/user-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asTeamId !== undefined) {
                localVarQueryParameter['asTeamId'] = asTeamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The valid user_source catalog (dim_user_source.sqlx), for admins to pick from when setting a team\'s reporting scope.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSources: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/user-sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: the trials the caller may simulate in the criteria what-if simulator, within its scope: the trials its team manages or holds a mandate on; for an admin every active trial, or a team (`asTeamId`) or listed site (`profile`) to view as.
         * @param {string} [search] Matches the NCT code or the title, case-insensitive.
         * @param {string} [asTeamId] Admin only: scope to this team, as its members would see it.
         * @param {string} [profile] Admin only: scope to a listed site profile (see &#x60;profiles&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatIfTrials: async (search?: string, asTeamId?: string, profile?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reporting/what-if/trials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (asTeamId !== undefined) {
                localVarQueryParameter['asTeamId'] = asTeamId;
            }

            if (profile !== undefined) {
                localVarQueryParameter['profile'] = profile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insights: criteria what-if simulator. Counts the patients with the trial disease that fit a scenario of age, sex and country levers, against the trial baseline, with pass / fail / unanswered per remaining criterion. Live Postgres data; counts rounded for team users.
         * @param {WhatIfBody} whatIfBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateWhatIf: async (whatIfBody: WhatIfBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'whatIfBody' is not null or undefined
            assertParamExists('simulateWhatIf', 'whatIfBody', whatIfBody)
            const localVarPath = `/reporting/what-if`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(whatIfBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportingApi - functional programming interface
 * @export
 */
export const ReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Geocode every (zip code, country) patients have answered into geo_point, feeding the patient map (admin only, idempotent, capped per run; pass the returned nextCursor as `after` to continue).
         * @param {GeocodePatientRegionsBody} geocodePatientRegionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geocodePatientRegions(geocodePatientRegionsBody: GeocodePatientRegionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeocodePatientRegionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geocodePatientRegions(geocodePatientRegionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.geocodePatientRegions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: how the eligibility chat questions are answered and skipped — per question, per skip reason, per answer and per month. Sliceable on the paid tier.
         * @param {Array<string>} [question] Keep these questions (question ids).
         * @param {Array<string>} [questionType] Keep questions of any of these question types.
         * @param {Array<string>} [answerType] Keep questions of any of these answer types.
         * @param {Array<string>} [generationType] Keep questions of any of these generation types.
         * @param {string} [fromDate] Keep questions asked in or after this month, YYYY-MM-DD.
         * @param {string} [toDate] Keep questions asked in or before this month, YYYY-MM-DD.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatbot(question?: Array<string>, questionType?: Array<string>, answerType?: Array<string>, generationType?: Array<string>, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatbotView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatbot(question, questionType, answerType, generationType, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getChatbot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights partner dashboard: acquisition-cohort conversion funnel, scoped server-side to the caller team\'s reportingSourceSlugs.
         * @param {string} fromDate Any date within the starting month of the acquisition-date range (inclusive), YYYY-MM-DD. The underlying aggregate is month-granular, so the query is expanded to the whole month.
         * @param {string} toDate Any date within the ending month of the acquisition-date range (inclusive), YYYY-MM-DD. The underlying aggregate is month-granular, so the query is expanded to the whole month.
         * @param {string} [gender] Filter the funnel to a single gender value. At most one of gender/country/healthStatus/therapeuticArea may be set at a time — the underlying aggregate pre-computes one breakdown dimension per row, not their cross product.
         * @param {string} [country] Filter the funnel to a single country value. See gender for the combinability rule.
         * @param {GetFunnelHealthStatusEnum} [healthStatus] Filter the funnel to a single health status. See gender for the combinability rule.
         * @param {GetFunnelTherapeuticAreaEnum} [therapeuticArea] Filter the funnel to a single therapeutic area. A patient carrying more than one area is counted under each, so per-area funnel totals do not sum back to the unfiltered total. See gender for the combinability rule.
         * @param {string} [asTeamId] Admin-only: view this team\&#39;s Insights dashboard instead of the caller\&#39;s own. Rejected with 403 for a non-admin caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFunnel(fromDate: string, toDate: string, gender?: string, country?: string, healthStatus?: GetFunnelHealthStatusEnum, therapeuticArea?: GetFunnelTherapeuticAreaEnum, asTeamId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportingFunnelView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFunnel(fromDate, toDate, gender, country, healthStatus, therapeuticArea, asTeamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getFunnel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The caller\'s Insights tier (free or paid), so the dashboard can render tier chrome before loading data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInsightsTier(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsightsTierView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInsightsTier(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getInsightsTier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights overview: the cockpit curated for the caller: their team\'s trials and sources (a partner), the investigation site their team names, else the global view. Trials, patients, sites, users per month and a map. Admins pass `asTeamId` or `profile` to view as a team or a listed site.
         * @param {string} [asTeamId] Admin-only: view the overview as this team (its trials, sources and site name) instead of the caller\&#39;s own. Audited. Rejected with 403 for a non-admin caller.
         * @param {string} [profile] Admin-only: view the overview as this listed profile (an investigation site without a team, see &#x60;profiles&#x60; in the response). Rejected with 403 for a non-admin caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLanding(asTeamId?: string, profile?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLanding(asTeamId, profile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getLanding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: aggregate patient map points — per country on the free tier, per ~10 km region on the paid tier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientGeography(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientGeographyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientGeography(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getPatientGeography']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: composition of the EU patient population (country, gender, age group, health status, smoking, language, therapeutic area, disease; BMI on the paid tier). Sliceable on the paid tier.
         * @param {Array<string>} [ageGroup] Keep patients in any of these age groups.
         * @param {Array<string>} [gender] Keep patients of any of these genders.
         * @param {Array<string>} [country] Keep patients living in any of these EU countries.
         * @param {Array<string>} [smoking] Keep patients with any of these smoking statuses (Smoker, Non-smoker, Not specified).
         * @param {Array<string>} [disease] Keep patients with any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep patients in any of these therapeutic areas.
         * @param {Array<string>} [language] Keep patients using any of these languages.
         * @param {string} [acquiredFrom] Keep patients acquired in or after this month, YYYY-MM-DD.
         * @param {string} [acquiredTo] Keep patients acquired in or before this month, YYYY-MM-DD.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientOverviewGlobal(ageGroup?: Array<string>, gender?: Array<string>, country?: Array<string>, smoking?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, language?: Array<string>, acquiredFrom?: string, acquiredTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientOverviewGlobalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientOverviewGlobal(ageGroup, gender, country, smoking, disease, therapeuticArea, language, acquiredFrom, acquiredTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getPatientOverviewGlobal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: where EU patients turn matches down as too far, as ~100 km demand cells against the nearest recruiting site of the rejected trial — per country on the free tier, per cell with the site layer on the paid tier. Sliceable on the paid tier.
         * @param {Array<string>} [userCountry] Keep rejections by patients living in any of these EU countries.
         * @param {Array<string>} [userGender] Keep rejections by patients of any of these genders.
         * @param {Array<string>} [trialTherapeuticArea] Keep rejections of trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep rejections of trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep rejections of trials of any of these sponsor classes.
         * @param {Array<string>} [userSource] Keep rejections by patients from any of these acquisition sources.
         * @param {Array<string>} [trialDisease] Keep rejections of trials for any of these diseases.
         * @param {Array<string>} [nearestSiteCity] Keep rejections whose nearest recruiting site is in any of these cities (normalised city name).
         * @param {Array<string>} [nearestSiteFacility] Keep rejections whose nearest recruiting site is any of these facilities (normalised facility name).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteOpportunity(userCountry?: Array<string>, userGender?: Array<string>, trialTherapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, userSource?: Array<string>, trialDisease?: Array<string>, nearestSiteCity?: Array<string>, nearestSiteFacility?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteOpportunityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiteOpportunity(userCountry, userGender, trialTherapeuticArea, sponsor, sponsorClass, userSource, trialDisease, nearestSiteCity, nearestSiteFacility, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getSiteOpportunity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights (CTDI): study-completion delays of active trials — delayed count, average and median delay, average delay by therapeutic area, disease and country (public clinicaltrials.gov data).
         * @param {Array<string>} [country] Keep trials recruiting in any of these EU countries.
         * @param {Array<string>} [disease] Keep trials mapped to any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep trials of any of these sponsor classes.
         * @param {Array<string>} [gender] Keep trials with any of these gender criteria.
         * @param {Array<string>} [city] Keep trials recruiting at a site in any of these cities (normalised city name).
         * @param {Array<string>} [facility] Keep trials recruiting at any of these facilities (normalised facility name).
         * @param {Array<string>} [locationStatus] Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
         * @param {number} [ageFrom] Keep trials that accept some age at or above this, in years.
         * @param {number} [ageTo] Keep trials that accept some age at or below this, in years.
         * @param {number} [bmiFrom] Keep trials that accept some BMI at or above this.
         * @param {number} [bmiTo] Keep trials that accept some BMI at or below this.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialDelays(country?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, gender?: Array<string>, city?: Array<string>, facility?: Array<string>, locationStatus?: Array<string>, ageFrom?: number, ageTo?: number, bmiFrom?: number, bmiTo?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialDelaysView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialDelays(country, disease, therapeuticArea, sponsor, sponsorClass, gender, city, facility, locationStatus, ageFrom, ageTo, bmiFrom, bmiTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getTrialDelays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: how active trials distribute their age, BMI, gender, and smoking eligibility thresholds. Sliceable on the paid tier.
         * @param {Array<string>} [country] Keep trials recruiting in any of these EU countries.
         * @param {Array<string>} [disease] Keep trials mapped to any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep trials of any of these sponsor classes.
         * @param {Array<string>} [gender] Keep trials with any of these gender criteria.
         * @param {Array<string>} [city] Keep trials recruiting at a site in any of these cities (normalised city name).
         * @param {Array<string>} [facility] Keep trials recruiting at any of these facilities (normalised facility name).
         * @param {Array<string>} [locationStatus] Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
         * @param {number} [ageFrom] Keep trials that accept some age at or above this, in years.
         * @param {number} [ageTo] Keep trials that accept some age at or below this, in years.
         * @param {number} [bmiFrom] Keep trials that accept some BMI at or above this.
         * @param {number} [bmiTo] Keep trials that accept some BMI at or below this.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialEligibility(country?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, gender?: Array<string>, city?: Array<string>, facility?: Array<string>, locationStatus?: Array<string>, ageFrom?: number, ageTo?: number, bmiFrom?: number, bmiTo?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialEligibilityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialEligibility(country, disease, therapeuticArea, sponsor, sponsorClass, gender, city, facility, locationStatus, ageFrom, ageTo, bmiFrom, bmiTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getTrialEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: trial sites per country, plus one point per site on the paid tier, for the sliced location statuses (recruiting sites unless the caller widens it). Sliceable on the paid tier.
         * @param {Array<string>} [country] Keep trials recruiting in any of these EU countries.
         * @param {Array<string>} [disease] Keep trials mapped to any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep trials of any of these sponsor classes.
         * @param {Array<string>} [gender] Keep trials with any of these gender criteria.
         * @param {Array<string>} [city] Keep trials recruiting at a site in any of these cities (normalised city name).
         * @param {Array<string>} [facility] Keep trials recruiting at any of these facilities (normalised facility name).
         * @param {Array<string>} [locationStatus] Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
         * @param {number} [ageFrom] Keep trials that accept some age at or above this, in years.
         * @param {number} [ageTo] Keep trials that accept some age at or below this, in years.
         * @param {number} [bmiFrom] Keep trials that accept some BMI at or above this.
         * @param {number} [bmiTo] Keep trials that accept some BMI at or below this.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialGeography(country?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, gender?: Array<string>, city?: Array<string>, facility?: Array<string>, locationStatus?: Array<string>, ageFrom?: number, ageTo?: number, bmiFrom?: number, bmiTo?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialGeographyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialGeography(country, disease, therapeuticArea, sponsor, sponsorClass, gender, city, facility, locationStatus, ageFrom, ageTo, bmiFrom, bmiTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getTrialGeography']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: active trials by therapeutic area, disease, country, sponsor class, and sponsor (public clinicaltrials.gov data).
         * @param {Array<string>} [country] Keep trials recruiting in any of these EU countries.
         * @param {Array<string>} [disease] Keep trials mapped to any of these diseases.
         * @param {Array<string>} [therapeuticArea] Keep trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep trials of any of these sponsor classes.
         * @param {Array<string>} [gender] Keep trials with any of these gender criteria.
         * @param {Array<string>} [city] Keep trials recruiting at a site in any of these cities (normalised city name).
         * @param {Array<string>} [facility] Keep trials recruiting at any of these facilities (normalised facility name).
         * @param {Array<string>} [locationStatus] Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
         * @param {number} [ageFrom] Keep trials that accept some age at or above this, in years.
         * @param {number} [ageTo] Keep trials that accept some age at or below this, in years.
         * @param {number} [bmiFrom] Keep trials that accept some BMI at or above this.
         * @param {number} [bmiTo] Keep trials that accept some BMI at or below this.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialOverview(country?: Array<string>, disease?: Array<string>, therapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, gender?: Array<string>, city?: Array<string>, facility?: Array<string>, locationStatus?: Array<string>, ageFrom?: number, ageTo?: number, bmiFrom?: number, bmiTo?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialOverview(country, disease, therapeuticArea, sponsor, sponsorClass, gender, city, facility, locationStatus, ageFrom, ageTo, bmiFrom, bmiTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getTrialOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: why EU patients turn down trial matches, per reason. Sliceable on the paid tier.
         * @param {Array<string>} [userCountry] Keep rejections by patients living in any of these EU countries.
         * @param {Array<string>} [userGender] Keep rejections by patients of any of these genders.
         * @param {Array<string>} [trialTherapeuticArea] Keep rejections of trials in any of these therapeutic areas.
         * @param {Array<string>} [sponsor] Keep rejections of trials of any of these sponsor groups (a subsidiary rolls up to its parent).
         * @param {Array<string>} [sponsorClass] Keep rejections of trials of any of these sponsor classes.
         * @param {Array<string>} [userSource] Keep rejections by patients from any of these acquisition sources.
         * @param {Array<string>} [trialDisease] Keep rejections of trials for any of these diseases.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialRejections(userCountry?: Array<string>, userGender?: Array<string>, trialTherapeuticArea?: Array<string>, sponsor?: Array<string>, sponsorClass?: Array<string>, userSource?: Array<string>, trialDisease?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialRejectionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialRejections(userCountry, userGender, trialTherapeuticArea, sponsor, sponsorClass, userSource, trialDisease, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getTrialRejections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: the global acquisition-cohort funnel across every Curewiki patient, by acquisition month, source and one breakdown dimension. Sliceable on the paid tier.
         * @param {string} [fromDate] Keep patients acquired in or after this month, YYYY-MM-DD.
         * @param {string} [toDate] Keep patients acquired in or before this month, YYYY-MM-DD.
         * @param {Array<string>} [source] Keep patients from any of these acquisition sources.
         * @param {GetUserFunnelDimensionEnum} [dimension] The one dimension to slice on: country, gender, healthStatus, therapeuticArea, ageGroup, segmentation or disease. Requires &#x60;values&#x60;.
         * @param {Array<string>} [values] Keep patients whose &#x60;dimension&#x60; takes any of these values.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserFunnel(fromDate?: string, toDate?: string, source?: Array<string>, dimension?: GetUserFunnelDimensionEnum, values?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFunnelView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserFunnel(fromDate, toDate, source, dimension, values, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getUserFunnel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights partner dashboard: patient composition (country/gender/age-group/health-status), scoped server-side to the caller team\'s reportingSourceSlugs.
         * @param {string} [asTeamId] Admin-only: view this team\&#39;s Insights dashboard instead of the caller\&#39;s own. Rejected with 403 for a non-admin caller.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserOverview(asTeamId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportingUserOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserOverview(asTeamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getUserOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The valid user_source catalog (dim_user_source.sqlx), for admins to pick from when setting a team\'s reporting scope.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSources(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportingUserSourcesView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSources(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getUserSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: the trials the caller may simulate in the criteria what-if simulator, within its scope: the trials its team manages or holds a mandate on; for an admin every active trial, or a team (`asTeamId`) or listed site (`profile`) to view as.
         * @param {string} [search] Matches the NCT code or the title, case-insensitive.
         * @param {string} [asTeamId] Admin only: scope to this team, as its members would see it.
         * @param {string} [profile] Admin only: scope to a listed site profile (see &#x60;profiles&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhatIfTrials(search?: string, asTeamId?: string, profile?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhatIfTrialsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhatIfTrials(search, asTeamId, profile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getWhatIfTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insights: criteria what-if simulator. Counts the patients with the trial disease that fit a scenario of age, sex and country levers, against the trial baseline, with pass / fail / unanswered per remaining criterion. Live Postgres data; counts rounded for team users.
         * @param {WhatIfBody} whatIfBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulateWhatIf(whatIfBody: WhatIfBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhatIfView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simulateWhatIf(whatIfBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.simulateWhatIf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportingApi - factory interface
 * @export
 */
export const ReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportingApiFp(configuration)
    return {
        /**
         * 
         * @summary Geocode every (zip code, country) patients have answered into geo_point, feeding the patient map (admin only, idempotent, capped per run; pass the returned nextCursor as `after` to continue).
         * @param {ReportingApiGeocodePatientRegionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodePatientRegions(requestParameters: ReportingApiGeocodePatientRegionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeocodePatientRegionsView> {
            return localVarFp.geocodePatientRegions(requestParameters.geocodePatientRegionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: how the eligibility chat questions are answered and skipped — per question, per skip reason, per answer and per month. Sliceable on the paid tier.
         * @param {ReportingApiGetChatbotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatbot(requestParameters: ReportingApiGetChatbotRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatbotView> {
            return localVarFp.getChatbot(requestParameters.question, requestParameters.questionType, requestParameters.answerType, requestParameters.generationType, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights partner dashboard: acquisition-cohort conversion funnel, scoped server-side to the caller team\'s reportingSourceSlugs.
         * @param {ReportingApiGetFunnelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFunnel(requestParameters: ReportingApiGetFunnelRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportingFunnelView> {
            return localVarFp.getFunnel(requestParameters.fromDate, requestParameters.toDate, requestParameters.gender, requestParameters.country, requestParameters.healthStatus, requestParameters.therapeuticArea, requestParameters.asTeamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The caller\'s Insights tier (free or paid), so the dashboard can render tier chrome before loading data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsightsTier(options?: RawAxiosRequestConfig): AxiosPromise<InsightsTierView> {
            return localVarFp.getInsightsTier(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights overview: the cockpit curated for the caller: their team\'s trials and sources (a partner), the investigation site their team names, else the global view. Trials, patients, sites, users per month and a map. Admins pass `asTeamId` or `profile` to view as a team or a listed site.
         * @param {ReportingApiGetLandingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanding(requestParameters: ReportingApiGetLandingRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LandingView> {
            return localVarFp.getLanding(requestParameters.asTeamId, requestParameters.profile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: aggregate patient map points — per country on the free tier, per ~10 km region on the paid tier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientGeography(options?: RawAxiosRequestConfig): AxiosPromise<PatientGeographyView> {
            return localVarFp.getPatientGeography(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: composition of the EU patient population (country, gender, age group, health status, smoking, language, therapeutic area, disease; BMI on the paid tier). Sliceable on the paid tier.
         * @param {ReportingApiGetPatientOverviewGlobalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOverviewGlobal(requestParameters: ReportingApiGetPatientOverviewGlobalRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PatientOverviewGlobalView> {
            return localVarFp.getPatientOverviewGlobal(requestParameters.ageGroup, requestParameters.gender, requestParameters.country, requestParameters.smoking, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.language, requestParameters.acquiredFrom, requestParameters.acquiredTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: where EU patients turn matches down as too far, as ~100 km demand cells against the nearest recruiting site of the rejected trial — per country on the free tier, per cell with the site layer on the paid tier. Sliceable on the paid tier.
         * @param {ReportingApiGetSiteOpportunityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteOpportunity(requestParameters: ReportingApiGetSiteOpportunityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SiteOpportunityView> {
            return localVarFp.getSiteOpportunity(requestParameters.userCountry, requestParameters.userGender, requestParameters.trialTherapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.userSource, requestParameters.trialDisease, requestParameters.nearestSiteCity, requestParameters.nearestSiteFacility, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights (CTDI): study-completion delays of active trials — delayed count, average and median delay, average delay by therapeutic area, disease and country (public clinicaltrials.gov data).
         * @param {ReportingApiGetTrialDelaysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialDelays(requestParameters: ReportingApiGetTrialDelaysRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TrialDelaysView> {
            return localVarFp.getTrialDelays(requestParameters.country, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.gender, requestParameters.city, requestParameters.facility, requestParameters.locationStatus, requestParameters.ageFrom, requestParameters.ageTo, requestParameters.bmiFrom, requestParameters.bmiTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: how active trials distribute their age, BMI, gender, and smoking eligibility thresholds. Sliceable on the paid tier.
         * @param {ReportingApiGetTrialEligibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialEligibility(requestParameters: ReportingApiGetTrialEligibilityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TrialEligibilityView> {
            return localVarFp.getTrialEligibility(requestParameters.country, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.gender, requestParameters.city, requestParameters.facility, requestParameters.locationStatus, requestParameters.ageFrom, requestParameters.ageTo, requestParameters.bmiFrom, requestParameters.bmiTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: trial sites per country, plus one point per site on the paid tier, for the sliced location statuses (recruiting sites unless the caller widens it). Sliceable on the paid tier.
         * @param {ReportingApiGetTrialGeographyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialGeography(requestParameters: ReportingApiGetTrialGeographyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TrialGeographyView> {
            return localVarFp.getTrialGeography(requestParameters.country, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.gender, requestParameters.city, requestParameters.facility, requestParameters.locationStatus, requestParameters.ageFrom, requestParameters.ageTo, requestParameters.bmiFrom, requestParameters.bmiTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: active trials by therapeutic area, disease, country, sponsor class, and sponsor (public clinicaltrials.gov data).
         * @param {ReportingApiGetTrialOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialOverview(requestParameters: ReportingApiGetTrialOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TrialOverviewView> {
            return localVarFp.getTrialOverview(requestParameters.country, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.gender, requestParameters.city, requestParameters.facility, requestParameters.locationStatus, requestParameters.ageFrom, requestParameters.ageTo, requestParameters.bmiFrom, requestParameters.bmiTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: why EU patients turn down trial matches, per reason. Sliceable on the paid tier.
         * @param {ReportingApiGetTrialRejectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialRejections(requestParameters: ReportingApiGetTrialRejectionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TrialRejectionsView> {
            return localVarFp.getTrialRejections(requestParameters.userCountry, requestParameters.userGender, requestParameters.trialTherapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.userSource, requestParameters.trialDisease, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: the global acquisition-cohort funnel across every Curewiki patient, by acquisition month, source and one breakdown dimension. Sliceable on the paid tier.
         * @param {ReportingApiGetUserFunnelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFunnel(requestParameters: ReportingApiGetUserFunnelRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserFunnelView> {
            return localVarFp.getUserFunnel(requestParameters.fromDate, requestParameters.toDate, requestParameters.source, requestParameters.dimension, requestParameters.values, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights partner dashboard: patient composition (country/gender/age-group/health-status), scoped server-side to the caller team\'s reportingSourceSlugs.
         * @param {ReportingApiGetUserOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOverview(requestParameters: ReportingApiGetUserOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ReportingUserOverviewView> {
            return localVarFp.getUserOverview(requestParameters.asTeamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The valid user_source catalog (dim_user_source.sqlx), for admins to pick from when setting a team\'s reporting scope.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSources(options?: RawAxiosRequestConfig): AxiosPromise<ReportingUserSourcesView> {
            return localVarFp.getUserSources(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: the trials the caller may simulate in the criteria what-if simulator, within its scope: the trials its team manages or holds a mandate on; for an admin every active trial, or a team (`asTeamId`) or listed site (`profile`) to view as.
         * @param {ReportingApiGetWhatIfTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatIfTrials(requestParameters: ReportingApiGetWhatIfTrialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WhatIfTrialsView> {
            return localVarFp.getWhatIfTrials(requestParameters.search, requestParameters.asTeamId, requestParameters.profile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insights: criteria what-if simulator. Counts the patients with the trial disease that fit a scenario of age, sex and country levers, against the trial baseline, with pass / fail / unanswered per remaining criterion. Live Postgres data; counts rounded for team users.
         * @param {ReportingApiSimulateWhatIfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateWhatIf(requestParameters: ReportingApiSimulateWhatIfRequest, options?: RawAxiosRequestConfig): AxiosPromise<WhatIfView> {
            return localVarFp.simulateWhatIf(requestParameters.whatIfBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for geocodePatientRegions operation in ReportingApi.
 * @export
 * @interface ReportingApiGeocodePatientRegionsRequest
 */
export interface ReportingApiGeocodePatientRegionsRequest {
    /**
     * 
     * @type {GeocodePatientRegionsBody}
     * @memberof ReportingApiGeocodePatientRegions
     */
    readonly geocodePatientRegionsBody: GeocodePatientRegionsBody
}

/**
 * Request parameters for getChatbot operation in ReportingApi.
 * @export
 * @interface ReportingApiGetChatbotRequest
 */
export interface ReportingApiGetChatbotRequest {
    /**
     * Keep these questions (question ids).
     * @type {Array<string>}
     * @memberof ReportingApiGetChatbot
     */
    readonly question?: Array<string>

    /**
     * Keep questions of any of these question types.
     * @type {Array<string>}
     * @memberof ReportingApiGetChatbot
     */
    readonly questionType?: Array<string>

    /**
     * Keep questions of any of these answer types.
     * @type {Array<string>}
     * @memberof ReportingApiGetChatbot
     */
    readonly answerType?: Array<string>

    /**
     * Keep questions of any of these generation types.
     * @type {Array<string>}
     * @memberof ReportingApiGetChatbot
     */
    readonly generationType?: Array<string>

    /**
     * Keep questions asked in or after this month, YYYY-MM-DD.
     * @type {string}
     * @memberof ReportingApiGetChatbot
     */
    readonly fromDate?: string

    /**
     * Keep questions asked in or before this month, YYYY-MM-DD.
     * @type {string}
     * @memberof ReportingApiGetChatbot
     */
    readonly toDate?: string
}

/**
 * Request parameters for getFunnel operation in ReportingApi.
 * @export
 * @interface ReportingApiGetFunnelRequest
 */
export interface ReportingApiGetFunnelRequest {
    /**
     * Any date within the starting month of the acquisition-date range (inclusive), YYYY-MM-DD. The underlying aggregate is month-granular, so the query is expanded to the whole month.
     * @type {string}
     * @memberof ReportingApiGetFunnel
     */
    readonly fromDate: string

    /**
     * Any date within the ending month of the acquisition-date range (inclusive), YYYY-MM-DD. The underlying aggregate is month-granular, so the query is expanded to the whole month.
     * @type {string}
     * @memberof ReportingApiGetFunnel
     */
    readonly toDate: string

    /**
     * Filter the funnel to a single gender value. At most one of gender/country/healthStatus/therapeuticArea may be set at a time — the underlying aggregate pre-computes one breakdown dimension per row, not their cross product.
     * @type {string}
     * @memberof ReportingApiGetFunnel
     */
    readonly gender?: string

    /**
     * Filter the funnel to a single country value. See gender for the combinability rule.
     * @type {string}
     * @memberof ReportingApiGetFunnel
     */
    readonly country?: string

    /**
     * Filter the funnel to a single health status. See gender for the combinability rule.
     * @type {'Healthy' | 'With disease'}
     * @memberof ReportingApiGetFunnel
     */
    readonly healthStatus?: GetFunnelHealthStatusEnum

    /**
     * Filter the funnel to a single therapeutic area. A patient carrying more than one area is counted under each, so per-area funnel totals do not sum back to the unfiltered total. See gender for the combinability rule.
     * @type {'Oncology' | 'Cardiovascular' | 'Endocrinology' | 'Neurology' | 'Respiratory'}
     * @memberof ReportingApiGetFunnel
     */
    readonly therapeuticArea?: GetFunnelTherapeuticAreaEnum

    /**
     * Admin-only: view this team\&#39;s Insights dashboard instead of the caller\&#39;s own. Rejected with 403 for a non-admin caller.
     * @type {string}
     * @memberof ReportingApiGetFunnel
     */
    readonly asTeamId?: string
}

/**
 * Request parameters for getLanding operation in ReportingApi.
 * @export
 * @interface ReportingApiGetLandingRequest
 */
export interface ReportingApiGetLandingRequest {
    /**
     * Admin-only: view the overview as this team (its trials, sources and site name) instead of the caller\&#39;s own. Audited. Rejected with 403 for a non-admin caller.
     * @type {string}
     * @memberof ReportingApiGetLanding
     */
    readonly asTeamId?: string

    /**
     * Admin-only: view the overview as this listed profile (an investigation site without a team, see &#x60;profiles&#x60; in the response). Rejected with 403 for a non-admin caller.
     * @type {string}
     * @memberof ReportingApiGetLanding
     */
    readonly profile?: string
}

/**
 * Request parameters for getPatientOverviewGlobal operation in ReportingApi.
 * @export
 * @interface ReportingApiGetPatientOverviewGlobalRequest
 */
export interface ReportingApiGetPatientOverviewGlobalRequest {
    /**
     * Keep patients in any of these age groups.
     * @type {Array<string>}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly ageGroup?: Array<string>

    /**
     * Keep patients of any of these genders.
     * @type {Array<string>}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly gender?: Array<string>

    /**
     * Keep patients living in any of these EU countries.
     * @type {Array<string>}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly country?: Array<string>

    /**
     * Keep patients with any of these smoking statuses (Smoker, Non-smoker, Not specified).
     * @type {Array<string>}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly smoking?: Array<string>

    /**
     * Keep patients with any of these diseases.
     * @type {Array<string>}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly disease?: Array<string>

    /**
     * Keep patients in any of these therapeutic areas.
     * @type {Array<string>}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly therapeuticArea?: Array<string>

    /**
     * Keep patients using any of these languages.
     * @type {Array<string>}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly language?: Array<string>

    /**
     * Keep patients acquired in or after this month, YYYY-MM-DD.
     * @type {string}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly acquiredFrom?: string

    /**
     * Keep patients acquired in or before this month, YYYY-MM-DD.
     * @type {string}
     * @memberof ReportingApiGetPatientOverviewGlobal
     */
    readonly acquiredTo?: string
}

/**
 * Request parameters for getSiteOpportunity operation in ReportingApi.
 * @export
 * @interface ReportingApiGetSiteOpportunityRequest
 */
export interface ReportingApiGetSiteOpportunityRequest {
    /**
     * Keep rejections by patients living in any of these EU countries.
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly userCountry?: Array<string>

    /**
     * Keep rejections by patients of any of these genders.
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly userGender?: Array<string>

    /**
     * Keep rejections of trials in any of these therapeutic areas.
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly trialTherapeuticArea?: Array<string>

    /**
     * Keep rejections of trials of any of these sponsor groups (a subsidiary rolls up to its parent).
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly sponsor?: Array<string>

    /**
     * Keep rejections of trials of any of these sponsor classes.
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly sponsorClass?: Array<string>

    /**
     * Keep rejections by patients from any of these acquisition sources.
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly userSource?: Array<string>

    /**
     * Keep rejections of trials for any of these diseases.
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly trialDisease?: Array<string>

    /**
     * Keep rejections whose nearest recruiting site is in any of these cities (normalised city name).
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly nearestSiteCity?: Array<string>

    /**
     * Keep rejections whose nearest recruiting site is any of these facilities (normalised facility name).
     * @type {Array<string>}
     * @memberof ReportingApiGetSiteOpportunity
     */
    readonly nearestSiteFacility?: Array<string>
}

/**
 * Request parameters for getTrialDelays operation in ReportingApi.
 * @export
 * @interface ReportingApiGetTrialDelaysRequest
 */
export interface ReportingApiGetTrialDelaysRequest {
    /**
     * Keep trials recruiting in any of these EU countries.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly country?: Array<string>

    /**
     * Keep trials mapped to any of these diseases.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly disease?: Array<string>

    /**
     * Keep trials in any of these therapeutic areas.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly therapeuticArea?: Array<string>

    /**
     * Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly sponsor?: Array<string>

    /**
     * Keep trials of any of these sponsor classes.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly sponsorClass?: Array<string>

    /**
     * Keep trials with any of these gender criteria.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly gender?: Array<string>

    /**
     * Keep trials recruiting at a site in any of these cities (normalised city name).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly city?: Array<string>

    /**
     * Keep trials recruiting at any of these facilities (normalised facility name).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly facility?: Array<string>

    /**
     * Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly locationStatus?: Array<string>

    /**
     * Keep trials that accept some age at or above this, in years.
     * @type {number}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly ageFrom?: number

    /**
     * Keep trials that accept some age at or below this, in years.
     * @type {number}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly ageTo?: number

    /**
     * Keep trials that accept some BMI at or above this.
     * @type {number}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly bmiFrom?: number

    /**
     * Keep trials that accept some BMI at or below this.
     * @type {number}
     * @memberof ReportingApiGetTrialDelays
     */
    readonly bmiTo?: number
}

/**
 * Request parameters for getTrialEligibility operation in ReportingApi.
 * @export
 * @interface ReportingApiGetTrialEligibilityRequest
 */
export interface ReportingApiGetTrialEligibilityRequest {
    /**
     * Keep trials recruiting in any of these EU countries.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly country?: Array<string>

    /**
     * Keep trials mapped to any of these diseases.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly disease?: Array<string>

    /**
     * Keep trials in any of these therapeutic areas.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly therapeuticArea?: Array<string>

    /**
     * Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly sponsor?: Array<string>

    /**
     * Keep trials of any of these sponsor classes.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly sponsorClass?: Array<string>

    /**
     * Keep trials with any of these gender criteria.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly gender?: Array<string>

    /**
     * Keep trials recruiting at a site in any of these cities (normalised city name).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly city?: Array<string>

    /**
     * Keep trials recruiting at any of these facilities (normalised facility name).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly facility?: Array<string>

    /**
     * Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly locationStatus?: Array<string>

    /**
     * Keep trials that accept some age at or above this, in years.
     * @type {number}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly ageFrom?: number

    /**
     * Keep trials that accept some age at or below this, in years.
     * @type {number}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly ageTo?: number

    /**
     * Keep trials that accept some BMI at or above this.
     * @type {number}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly bmiFrom?: number

    /**
     * Keep trials that accept some BMI at or below this.
     * @type {number}
     * @memberof ReportingApiGetTrialEligibility
     */
    readonly bmiTo?: number
}

/**
 * Request parameters for getTrialGeography operation in ReportingApi.
 * @export
 * @interface ReportingApiGetTrialGeographyRequest
 */
export interface ReportingApiGetTrialGeographyRequest {
    /**
     * Keep trials recruiting in any of these EU countries.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly country?: Array<string>

    /**
     * Keep trials mapped to any of these diseases.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly disease?: Array<string>

    /**
     * Keep trials in any of these therapeutic areas.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly therapeuticArea?: Array<string>

    /**
     * Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly sponsor?: Array<string>

    /**
     * Keep trials of any of these sponsor classes.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly sponsorClass?: Array<string>

    /**
     * Keep trials with any of these gender criteria.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly gender?: Array<string>

    /**
     * Keep trials recruiting at a site in any of these cities (normalised city name).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly city?: Array<string>

    /**
     * Keep trials recruiting at any of these facilities (normalised facility name).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly facility?: Array<string>

    /**
     * Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly locationStatus?: Array<string>

    /**
     * Keep trials that accept some age at or above this, in years.
     * @type {number}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly ageFrom?: number

    /**
     * Keep trials that accept some age at or below this, in years.
     * @type {number}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly ageTo?: number

    /**
     * Keep trials that accept some BMI at or above this.
     * @type {number}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly bmiFrom?: number

    /**
     * Keep trials that accept some BMI at or below this.
     * @type {number}
     * @memberof ReportingApiGetTrialGeography
     */
    readonly bmiTo?: number
}

/**
 * Request parameters for getTrialOverview operation in ReportingApi.
 * @export
 * @interface ReportingApiGetTrialOverviewRequest
 */
export interface ReportingApiGetTrialOverviewRequest {
    /**
     * Keep trials recruiting in any of these EU countries.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly country?: Array<string>

    /**
     * Keep trials mapped to any of these diseases.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly disease?: Array<string>

    /**
     * Keep trials in any of these therapeutic areas.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly therapeuticArea?: Array<string>

    /**
     * Keep trials of any of these sponsor groups (a subsidiary rolls up to its parent).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly sponsor?: Array<string>

    /**
     * Keep trials of any of these sponsor classes.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly sponsorClass?: Array<string>

    /**
     * Keep trials with any of these gender criteria.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly gender?: Array<string>

    /**
     * Keep trials recruiting at a site in any of these cities (normalised city name).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly city?: Array<string>

    /**
     * Keep trials recruiting at any of these facilities (normalised facility name).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly facility?: Array<string>

    /**
     * Keep sites with any of these clinicaltrials.gov location statuses (\&#39;RECRUITING\&#39;, \&#39;Not specified\&#39;). Default: RECRUITING. Narrows the sites the geography endpoint returns, and the trials a city or facility slicer selects through them.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly locationStatus?: Array<string>

    /**
     * Keep trials that accept some age at or above this, in years.
     * @type {number}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly ageFrom?: number

    /**
     * Keep trials that accept some age at or below this, in years.
     * @type {number}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly ageTo?: number

    /**
     * Keep trials that accept some BMI at or above this.
     * @type {number}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly bmiFrom?: number

    /**
     * Keep trials that accept some BMI at or below this.
     * @type {number}
     * @memberof ReportingApiGetTrialOverview
     */
    readonly bmiTo?: number
}

/**
 * Request parameters for getTrialRejections operation in ReportingApi.
 * @export
 * @interface ReportingApiGetTrialRejectionsRequest
 */
export interface ReportingApiGetTrialRejectionsRequest {
    /**
     * Keep rejections by patients living in any of these EU countries.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialRejections
     */
    readonly userCountry?: Array<string>

    /**
     * Keep rejections by patients of any of these genders.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialRejections
     */
    readonly userGender?: Array<string>

    /**
     * Keep rejections of trials in any of these therapeutic areas.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialRejections
     */
    readonly trialTherapeuticArea?: Array<string>

    /**
     * Keep rejections of trials of any of these sponsor groups (a subsidiary rolls up to its parent).
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialRejections
     */
    readonly sponsor?: Array<string>

    /**
     * Keep rejections of trials of any of these sponsor classes.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialRejections
     */
    readonly sponsorClass?: Array<string>

    /**
     * Keep rejections by patients from any of these acquisition sources.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialRejections
     */
    readonly userSource?: Array<string>

    /**
     * Keep rejections of trials for any of these diseases.
     * @type {Array<string>}
     * @memberof ReportingApiGetTrialRejections
     */
    readonly trialDisease?: Array<string>
}

/**
 * Request parameters for getUserFunnel operation in ReportingApi.
 * @export
 * @interface ReportingApiGetUserFunnelRequest
 */
export interface ReportingApiGetUserFunnelRequest {
    /**
     * Keep patients acquired in or after this month, YYYY-MM-DD.
     * @type {string}
     * @memberof ReportingApiGetUserFunnel
     */
    readonly fromDate?: string

    /**
     * Keep patients acquired in or before this month, YYYY-MM-DD.
     * @type {string}
     * @memberof ReportingApiGetUserFunnel
     */
    readonly toDate?: string

    /**
     * Keep patients from any of these acquisition sources.
     * @type {Array<string>}
     * @memberof ReportingApiGetUserFunnel
     */
    readonly source?: Array<string>

    /**
     * The one dimension to slice on: country, gender, healthStatus, therapeuticArea, ageGroup, segmentation or disease. Requires &#x60;values&#x60;.
     * @type {'country' | 'gender' | 'healthStatus' | 'therapeuticArea' | 'ageGroup' | 'segmentation' | 'disease'}
     * @memberof ReportingApiGetUserFunnel
     */
    readonly dimension?: GetUserFunnelDimensionEnum

    /**
     * Keep patients whose &#x60;dimension&#x60; takes any of these values.
     * @type {Array<string>}
     * @memberof ReportingApiGetUserFunnel
     */
    readonly values?: Array<string>
}

/**
 * Request parameters for getUserOverview operation in ReportingApi.
 * @export
 * @interface ReportingApiGetUserOverviewRequest
 */
export interface ReportingApiGetUserOverviewRequest {
    /**
     * Admin-only: view this team\&#39;s Insights dashboard instead of the caller\&#39;s own. Rejected with 403 for a non-admin caller.
     * @type {string}
     * @memberof ReportingApiGetUserOverview
     */
    readonly asTeamId?: string
}

/**
 * Request parameters for getWhatIfTrials operation in ReportingApi.
 * @export
 * @interface ReportingApiGetWhatIfTrialsRequest
 */
export interface ReportingApiGetWhatIfTrialsRequest {
    /**
     * Matches the NCT code or the title, case-insensitive.
     * @type {string}
     * @memberof ReportingApiGetWhatIfTrials
     */
    readonly search?: string

    /**
     * Admin only: scope to this team, as its members would see it.
     * @type {string}
     * @memberof ReportingApiGetWhatIfTrials
     */
    readonly asTeamId?: string

    /**
     * Admin only: scope to a listed site profile (see &#x60;profiles&#x60;).
     * @type {string}
     * @memberof ReportingApiGetWhatIfTrials
     */
    readonly profile?: string
}

/**
 * Request parameters for simulateWhatIf operation in ReportingApi.
 * @export
 * @interface ReportingApiSimulateWhatIfRequest
 */
export interface ReportingApiSimulateWhatIfRequest {
    /**
     * 
     * @type {WhatIfBody}
     * @memberof ReportingApiSimulateWhatIf
     */
    readonly whatIfBody: WhatIfBody
}

/**
 * ReportingApi - object-oriented interface
 * @export
 * @class ReportingApi
 * @extends {BaseAPI}
 */
export class ReportingApi extends BaseAPI {
    /**
     * 
     * @summary Geocode every (zip code, country) patients have answered into geo_point, feeding the patient map (admin only, idempotent, capped per run; pass the returned nextCursor as `after` to continue).
     * @param {ReportingApiGeocodePatientRegionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public geocodePatientRegions(requestParameters: ReportingApiGeocodePatientRegionsRequest, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).geocodePatientRegions(requestParameters.geocodePatientRegionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: how the eligibility chat questions are answered and skipped — per question, per skip reason, per answer and per month. Sliceable on the paid tier.
     * @param {ReportingApiGetChatbotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getChatbot(requestParameters: ReportingApiGetChatbotRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getChatbot(requestParameters.question, requestParameters.questionType, requestParameters.answerType, requestParameters.generationType, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights partner dashboard: acquisition-cohort conversion funnel, scoped server-side to the caller team\'s reportingSourceSlugs.
     * @param {ReportingApiGetFunnelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getFunnel(requestParameters: ReportingApiGetFunnelRequest, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getFunnel(requestParameters.fromDate, requestParameters.toDate, requestParameters.gender, requestParameters.country, requestParameters.healthStatus, requestParameters.therapeuticArea, requestParameters.asTeamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The caller\'s Insights tier (free or paid), so the dashboard can render tier chrome before loading data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getInsightsTier(options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getInsightsTier(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights overview: the cockpit curated for the caller: their team\'s trials and sources (a partner), the investigation site their team names, else the global view. Trials, patients, sites, users per month and a map. Admins pass `asTeamId` or `profile` to view as a team or a listed site.
     * @param {ReportingApiGetLandingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getLanding(requestParameters: ReportingApiGetLandingRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getLanding(requestParameters.asTeamId, requestParameters.profile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: aggregate patient map points — per country on the free tier, per ~10 km region on the paid tier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getPatientGeography(options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getPatientGeography(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: composition of the EU patient population (country, gender, age group, health status, smoking, language, therapeutic area, disease; BMI on the paid tier). Sliceable on the paid tier.
     * @param {ReportingApiGetPatientOverviewGlobalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getPatientOverviewGlobal(requestParameters: ReportingApiGetPatientOverviewGlobalRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getPatientOverviewGlobal(requestParameters.ageGroup, requestParameters.gender, requestParameters.country, requestParameters.smoking, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.language, requestParameters.acquiredFrom, requestParameters.acquiredTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: where EU patients turn matches down as too far, as ~100 km demand cells against the nearest recruiting site of the rejected trial — per country on the free tier, per cell with the site layer on the paid tier. Sliceable on the paid tier.
     * @param {ReportingApiGetSiteOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getSiteOpportunity(requestParameters: ReportingApiGetSiteOpportunityRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getSiteOpportunity(requestParameters.userCountry, requestParameters.userGender, requestParameters.trialTherapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.userSource, requestParameters.trialDisease, requestParameters.nearestSiteCity, requestParameters.nearestSiteFacility, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights (CTDI): study-completion delays of active trials — delayed count, average and median delay, average delay by therapeutic area, disease and country (public clinicaltrials.gov data).
     * @param {ReportingApiGetTrialDelaysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getTrialDelays(requestParameters: ReportingApiGetTrialDelaysRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getTrialDelays(requestParameters.country, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.gender, requestParameters.city, requestParameters.facility, requestParameters.locationStatus, requestParameters.ageFrom, requestParameters.ageTo, requestParameters.bmiFrom, requestParameters.bmiTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: how active trials distribute their age, BMI, gender, and smoking eligibility thresholds. Sliceable on the paid tier.
     * @param {ReportingApiGetTrialEligibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getTrialEligibility(requestParameters: ReportingApiGetTrialEligibilityRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getTrialEligibility(requestParameters.country, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.gender, requestParameters.city, requestParameters.facility, requestParameters.locationStatus, requestParameters.ageFrom, requestParameters.ageTo, requestParameters.bmiFrom, requestParameters.bmiTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: trial sites per country, plus one point per site on the paid tier, for the sliced location statuses (recruiting sites unless the caller widens it). Sliceable on the paid tier.
     * @param {ReportingApiGetTrialGeographyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getTrialGeography(requestParameters: ReportingApiGetTrialGeographyRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getTrialGeography(requestParameters.country, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.gender, requestParameters.city, requestParameters.facility, requestParameters.locationStatus, requestParameters.ageFrom, requestParameters.ageTo, requestParameters.bmiFrom, requestParameters.bmiTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: active trials by therapeutic area, disease, country, sponsor class, and sponsor (public clinicaltrials.gov data).
     * @param {ReportingApiGetTrialOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getTrialOverview(requestParameters: ReportingApiGetTrialOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getTrialOverview(requestParameters.country, requestParameters.disease, requestParameters.therapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.gender, requestParameters.city, requestParameters.facility, requestParameters.locationStatus, requestParameters.ageFrom, requestParameters.ageTo, requestParameters.bmiFrom, requestParameters.bmiTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: why EU patients turn down trial matches, per reason. Sliceable on the paid tier.
     * @param {ReportingApiGetTrialRejectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getTrialRejections(requestParameters: ReportingApiGetTrialRejectionsRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getTrialRejections(requestParameters.userCountry, requestParameters.userGender, requestParameters.trialTherapeuticArea, requestParameters.sponsor, requestParameters.sponsorClass, requestParameters.userSource, requestParameters.trialDisease, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: the global acquisition-cohort funnel across every Curewiki patient, by acquisition month, source and one breakdown dimension. Sliceable on the paid tier.
     * @param {ReportingApiGetUserFunnelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getUserFunnel(requestParameters: ReportingApiGetUserFunnelRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getUserFunnel(requestParameters.fromDate, requestParameters.toDate, requestParameters.source, requestParameters.dimension, requestParameters.values, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights partner dashboard: patient composition (country/gender/age-group/health-status), scoped server-side to the caller team\'s reportingSourceSlugs.
     * @param {ReportingApiGetUserOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getUserOverview(requestParameters: ReportingApiGetUserOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getUserOverview(requestParameters.asTeamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The valid user_source catalog (dim_user_source.sqlx), for admins to pick from when setting a team\'s reporting scope.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getUserSources(options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getUserSources(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: the trials the caller may simulate in the criteria what-if simulator, within its scope: the trials its team manages or holds a mandate on; for an admin every active trial, or a team (`asTeamId`) or listed site (`profile`) to view as.
     * @param {ReportingApiGetWhatIfTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public getWhatIfTrials(requestParameters: ReportingApiGetWhatIfTrialsRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).getWhatIfTrials(requestParameters.search, requestParameters.asTeamId, requestParameters.profile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insights: criteria what-if simulator. Counts the patients with the trial disease that fit a scenario of age, sex and country levers, against the trial baseline, with pass / fail / unanswered per remaining criterion. Live Postgres data; counts rounded for team users.
     * @param {ReportingApiSimulateWhatIfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    public simulateWhatIf(requestParameters: ReportingApiSimulateWhatIfRequest, options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).simulateWhatIf(requestParameters.whatIfBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetFunnelHealthStatusEnum = {
    Healthy: 'Healthy',
    WithDisease: 'With disease'
} as const;
export type GetFunnelHealthStatusEnum = typeof GetFunnelHealthStatusEnum[keyof typeof GetFunnelHealthStatusEnum];
/**
 * @export
 */
export const GetFunnelTherapeuticAreaEnum = {
    Oncology: 'Oncology',
    Cardiovascular: 'Cardiovascular',
    Endocrinology: 'Endocrinology',
    Neurology: 'Neurology',
    Respiratory: 'Respiratory'
} as const;
export type GetFunnelTherapeuticAreaEnum = typeof GetFunnelTherapeuticAreaEnum[keyof typeof GetFunnelTherapeuticAreaEnum];
/**
 * @export
 */
export const GetUserFunnelDimensionEnum = {
    Country: 'country',
    Gender: 'gender',
    HealthStatus: 'healthStatus',
    TherapeuticArea: 'therapeuticArea',
    AgeGroup: 'ageGroup',
    Segmentation: 'segmentation',
    Disease: 'disease'
} as const;
export type GetUserFunnelDimensionEnum = typeof GetUserFunnelDimensionEnum[keyof typeof GetUserFunnelDimensionEnum];


/**
 * SliceReadinessApi - axios parameter creator
 * @export
 */
export const SliceReadinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary slices ranked by trials within N library rulings of matching anyone
         * @param {number | null} [within] Count a trial as reachable when at most this many more rulings would open it. One is the useful default: what a single reviewer decision buys today.
         * @param {string} [country] 
         * @param {string} [icdCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (within?: number | null, country?: string, icdCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/slice-readiness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (within !== undefined) {
                localVarQueryParameter['within'] = within;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (icdCode !== undefined) {
                localVarQueryParameter['icdCode'] = icdCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary recalculate every trial now instead of waiting for the 15-minute run
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/slice-readiness/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary one slice\'s trials, each with the library rows it waits on
         * @param {string} icdCode 
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trials: async (icdCode: string, country: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'icdCode' is not null or undefined
            assertParamExists('trials', 'icdCode', icdCode)
            // verify required parameter 'country' is not null or undefined
            assertParamExists('trials', 'country', country)
            const localVarPath = `/admin/slice-readiness/{icdCode}/{country}/trials`
                .replace(`{${"icdCode"}}`, encodeURIComponent(String(icdCode)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SliceReadinessApi - functional programming interface
 * @export
 */
export const SliceReadinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SliceReadinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary slices ranked by trials within N library rulings of matching anyone
         * @param {number | null} [within] Count a trial as reachable when at most this many more rulings would open it. One is the useful default: what a single reviewer decision buys today.
         * @param {string} [country] 
         * @param {string} [icdCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(within?: number | null, country?: string, icdCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSliceReadinessView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(within, country, icdCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SliceReadinessApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary recalculate every trial now instead of waiting for the 15-minute run
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SliceReadinessApi.refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary one slice\'s trials, each with the library rows it waits on
         * @param {string} icdCode 
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trials(icdCode: string, country: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSliceReadinessTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trials(icdCode, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SliceReadinessApi.trials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SliceReadinessApi - factory interface
 * @export
 */
export const SliceReadinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SliceReadinessApiFp(configuration)
    return {
        /**
         * 
         * @summary slices ranked by trials within N library rulings of matching anyone
         * @param {SliceReadinessApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: SliceReadinessApiListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSliceReadinessView> {
            return localVarFp.list(requestParameters.within, requestParameters.country, requestParameters.icdCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary recalculate every trial now instead of waiting for the 15-minute run
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.refresh(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary one slice\'s trials, each with the library rows it waits on
         * @param {SliceReadinessApiTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trials(requestParameters: SliceReadinessApiTrialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSliceReadinessTrialView> {
            return localVarFp.trials(requestParameters.icdCode, requestParameters.country, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for list operation in SliceReadinessApi.
 * @export
 * @interface SliceReadinessApiListRequest
 */
export interface SliceReadinessApiListRequest {
    /**
     * Count a trial as reachable when at most this many more rulings would open it. One is the useful default: what a single reviewer decision buys today.
     * @type {number}
     * @memberof SliceReadinessApiList
     */
    readonly within?: number | null

    /**
     * 
     * @type {string}
     * @memberof SliceReadinessApiList
     */
    readonly country?: string

    /**
     * 
     * @type {string}
     * @memberof SliceReadinessApiList
     */
    readonly icdCode?: string
}

/**
 * Request parameters for trials operation in SliceReadinessApi.
 * @export
 * @interface SliceReadinessApiTrialsRequest
 */
export interface SliceReadinessApiTrialsRequest {
    /**
     * 
     * @type {string}
     * @memberof SliceReadinessApiTrials
     */
    readonly icdCode: string

    /**
     * 
     * @type {string}
     * @memberof SliceReadinessApiTrials
     */
    readonly country: string
}

/**
 * SliceReadinessApi - object-oriented interface
 * @export
 * @class SliceReadinessApi
 * @extends {BaseAPI}
 */
export class SliceReadinessApi extends BaseAPI {
    /**
     * 
     * @summary slices ranked by trials within N library rulings of matching anyone
     * @param {SliceReadinessApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SliceReadinessApi
     */
    public list(requestParameters: SliceReadinessApiListRequest = {}, options?: RawAxiosRequestConfig) {
        return SliceReadinessApiFp(this.configuration).list(requestParameters.within, requestParameters.country, requestParameters.icdCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary recalculate every trial now instead of waiting for the 15-minute run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SliceReadinessApi
     */
    public refresh(options?: RawAxiosRequestConfig) {
        return SliceReadinessApiFp(this.configuration).refresh(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary one slice\'s trials, each with the library rows it waits on
     * @param {SliceReadinessApiTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SliceReadinessApi
     */
    public trials(requestParameters: SliceReadinessApiTrialsRequest, options?: RawAxiosRequestConfig) {
        return SliceReadinessApiFp(this.configuration).trials(requestParameters.icdCode, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SponsorApi - axios parameter creator
 * @export
 */
export const SponsorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new sponsor
         * @param {SponsorCreateBody} sponsorCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (sponsorCreateBody: SponsorCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sponsorCreateBody' is not null or undefined
            assertParamExists('create', 'sponsorCreateBody', sponsorCreateBody)
            const localVarPath = `/sponsors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sponsorCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all sponsors
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sponsors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Merge source sponsor into destination sponsor
         * @param {string} sourceId 
         * @param {SponsorMergeBody} sponsorMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge: async (sourceId: string, sponsorMergeBody: SponsorMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('merge', 'sourceId', sourceId)
            // verify required parameter 'sponsorMergeBody' is not null or undefined
            assertParamExists('merge', 'sponsorMergeBody', sponsorMergeBody)
            const localVarPath = `/sponsors/{sourceId}/merge`
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sponsorMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sponsor details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        query: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('query', 'id', id)
            const localVarPath = `/sponsors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sponsor
         * @param {string} id 
         * @param {SponsorUpdateBody} sponsorUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, sponsorUpdateBody: SponsorUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'sponsorUpdateBody' is not null or undefined
            assertParamExists('update', 'sponsorUpdateBody', sponsorUpdateBody)
            const localVarPath = `/sponsors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sponsorUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SponsorApi - functional programming interface
 * @export
 */
export const SponsorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SponsorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new sponsor
         * @param {SponsorCreateBody} sponsorCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(sponsorCreateBody: SponsorCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SponsorView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(sponsorCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SponsorApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all sponsors
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSponsorView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SponsorApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Merge source sponsor into destination sponsor
         * @param {string} sourceId 
         * @param {SponsorMergeBody} sponsorMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merge(sourceId: string, sponsorMergeBody: SponsorMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merge(sourceId, sponsorMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SponsorApi.merge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sponsor details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async query(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SponsorView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.query(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SponsorApi.query']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update sponsor
         * @param {string} id 
         * @param {SponsorUpdateBody} sponsorUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, sponsorUpdateBody: SponsorUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SponsorView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, sponsorUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SponsorApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SponsorApi - factory interface
 * @export
 */
export const SponsorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SponsorApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new sponsor
         * @param {SponsorApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: SponsorApiCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SponsorView> {
            return localVarFp.create(requestParameters.sponsorCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all sponsors
         * @param {SponsorApiListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(requestParameters: SponsorApiListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSponsorView> {
            return localVarFp.list(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Merge source sponsor into destination sponsor
         * @param {SponsorApiMergeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge(requestParameters: SponsorApiMergeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.merge(requestParameters.sourceId, requestParameters.sponsorMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sponsor details
         * @param {SponsorApiQueryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        query(requestParameters: SponsorApiQueryRequest, options?: RawAxiosRequestConfig): AxiosPromise<SponsorView> {
            return localVarFp.query(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sponsor
         * @param {SponsorApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters: SponsorApiUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SponsorView> {
            return localVarFp.update(requestParameters.id, requestParameters.sponsorUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for create operation in SponsorApi.
 * @export
 * @interface SponsorApiCreateRequest
 */
export interface SponsorApiCreateRequest {
    /**
     * 
     * @type {SponsorCreateBody}
     * @memberof SponsorApiCreate
     */
    readonly sponsorCreateBody: SponsorCreateBody
}

/**
 * Request parameters for list operation in SponsorApi.
 * @export
 * @interface SponsorApiListRequest
 */
export interface SponsorApiListRequest {
    /**
     * 
     * @type {number}
     * @memberof SponsorApiList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof SponsorApiList
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof SponsorApiList
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for merge operation in SponsorApi.
 * @export
 * @interface SponsorApiMergeRequest
 */
export interface SponsorApiMergeRequest {
    /**
     * 
     * @type {string}
     * @memberof SponsorApiMerge
     */
    readonly sourceId: string

    /**
     * 
     * @type {SponsorMergeBody}
     * @memberof SponsorApiMerge
     */
    readonly sponsorMergeBody: SponsorMergeBody
}

/**
 * Request parameters for query operation in SponsorApi.
 * @export
 * @interface SponsorApiQueryRequest
 */
export interface SponsorApiQueryRequest {
    /**
     * 
     * @type {string}
     * @memberof SponsorApiQuery
     */
    readonly id: string
}

/**
 * Request parameters for update operation in SponsorApi.
 * @export
 * @interface SponsorApiUpdateRequest
 */
export interface SponsorApiUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SponsorApiUpdate
     */
    readonly id: string

    /**
     * 
     * @type {SponsorUpdateBody}
     * @memberof SponsorApiUpdate
     */
    readonly sponsorUpdateBody: SponsorUpdateBody
}

/**
 * SponsorApi - object-oriented interface
 * @export
 * @class SponsorApi
 * @extends {BaseAPI}
 */
export class SponsorApi extends BaseAPI {
    /**
     * 
     * @summary Create a new sponsor
     * @param {SponsorApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public create(requestParameters: SponsorApiCreateRequest, options?: RawAxiosRequestConfig) {
        return SponsorApiFp(this.configuration).create(requestParameters.sponsorCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all sponsors
     * @param {SponsorApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public list(requestParameters: SponsorApiListRequest = {}, options?: RawAxiosRequestConfig) {
        return SponsorApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Merge source sponsor into destination sponsor
     * @param {SponsorApiMergeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public merge(requestParameters: SponsorApiMergeRequest, options?: RawAxiosRequestConfig) {
        return SponsorApiFp(this.configuration).merge(requestParameters.sourceId, requestParameters.sponsorMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sponsor details
     * @param {SponsorApiQueryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public query(requestParameters: SponsorApiQueryRequest, options?: RawAxiosRequestConfig) {
        return SponsorApiFp(this.configuration).query(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sponsor
     * @param {SponsorApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public update(requestParameters: SponsorApiUpdateRequest, options?: RawAxiosRequestConfig) {
        return SponsorApiFp(this.configuration).update(requestParameters.id, requestParameters.sponsorUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SurveyDependencyApi - axios parameter creator
 * @export
 */
export const SurveyDependencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a survey dependency
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyDependency: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSurveyDependency', 'id', id)
            const localVarPath = `/survey-dependency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing survey dependency
         * @param {string} id 
         * @param {SurveyDependencyUpdateBody} surveyDependencyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurveyDependency: async (id: string, surveyDependencyUpdateBody: SurveyDependencyUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSurveyDependency', 'id', id)
            // verify required parameter 'surveyDependencyUpdateBody' is not null or undefined
            assertParamExists('updateSurveyDependency', 'surveyDependencyUpdateBody', surveyDependencyUpdateBody)
            const localVarPath = `/survey-dependency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyDependencyUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyDependencyApi - functional programming interface
 * @export
 */
export const SurveyDependencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyDependencyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a survey dependency
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurveyDependency(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurveyDependency(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyDependencyApi.deleteSurveyDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing survey dependency
         * @param {string} id 
         * @param {SurveyDependencyUpdateBody} surveyDependencyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurveyDependency(id: string, surveyDependencyUpdateBody: SurveyDependencyUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurveyDependency(id, surveyDependencyUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyDependencyApi.updateSurveyDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyDependencyApi - factory interface
 * @export
 */
export const SurveyDependencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyDependencyApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a survey dependency
         * @param {SurveyDependencyApiDeleteSurveyDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyDependency(requestParameters: SurveyDependencyApiDeleteSurveyDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSurveyDependency(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing survey dependency
         * @param {SurveyDependencyApiUpdateSurveyDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurveyDependency(requestParameters: SurveyDependencyApiUpdateSurveyDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSurveyDependency(requestParameters.id, requestParameters.surveyDependencyUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteSurveyDependency operation in SurveyDependencyApi.
 * @export
 * @interface SurveyDependencyApiDeleteSurveyDependencyRequest
 */
export interface SurveyDependencyApiDeleteSurveyDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyDependencyApiDeleteSurveyDependency
     */
    readonly id: string
}

/**
 * Request parameters for updateSurveyDependency operation in SurveyDependencyApi.
 * @export
 * @interface SurveyDependencyApiUpdateSurveyDependencyRequest
 */
export interface SurveyDependencyApiUpdateSurveyDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyDependencyApiUpdateSurveyDependency
     */
    readonly id: string

    /**
     * 
     * @type {SurveyDependencyUpdateBody}
     * @memberof SurveyDependencyApiUpdateSurveyDependency
     */
    readonly surveyDependencyUpdateBody: SurveyDependencyUpdateBody
}

/**
 * SurveyDependencyApi - object-oriented interface
 * @export
 * @class SurveyDependencyApi
 * @extends {BaseAPI}
 */
export class SurveyDependencyApi extends BaseAPI {
    /**
     * 
     * @summary Delete a survey dependency
     * @param {SurveyDependencyApiDeleteSurveyDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyDependencyApi
     */
    public deleteSurveyDependency(requestParameters: SurveyDependencyApiDeleteSurveyDependencyRequest, options?: RawAxiosRequestConfig) {
        return SurveyDependencyApiFp(this.configuration).deleteSurveyDependency(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing survey dependency
     * @param {SurveyDependencyApiUpdateSurveyDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyDependencyApi
     */
    public updateSurveyDependency(requestParameters: SurveyDependencyApiUpdateSurveyDependencyRequest, options?: RawAxiosRequestConfig) {
        return SurveyDependencyApiFp(this.configuration).updateSurveyDependency(requestParameters.id, requestParameters.surveyDependencyUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SurveyManagementApi - axios parameter creator
 * @export
 */
export const SurveyManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create translations for the description of a survey
         * @param {string} id 
         * @param {SurveyTranslationBody} surveyTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDescriptionTranslations: async (id: string, surveyTranslationBody: SurveyTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDescriptionTranslations', 'id', id)
            // verify required parameter 'surveyTranslationBody' is not null or undefined
            assertParamExists('createDescriptionTranslations', 'surveyTranslationBody', surveyTranslationBody)
            const localVarPath = `/survey-management/{id}/translations:description`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new survey
         * @param {SurveyCreateBody} surveyCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: async (surveyCreateBody: SurveyCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyCreateBody' is not null or undefined
            assertParamExists('createSurvey', 'surveyCreateBody', surveyCreateBody)
            const localVarPath = `/survey-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a survey question
         * @param {string} id 
         * @param {SurveyQuestionBody} surveyQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyQuestion: async (id: string, surveyQuestionBody: SurveyQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSurveyQuestion', 'id', id)
            // verify required parameter 'surveyQuestionBody' is not null or undefined
            assertParamExists('createSurveyQuestion', 'surveyQuestionBody', surveyQuestionBody)
            const localVarPath = `/survey-management/{id}/questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create translations for the title of a survey
         * @param {string} id 
         * @param {SurveyTranslationBody} surveyTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTitleTranslations: async (id: string, surveyTranslationBody: SurveyTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTitleTranslations', 'id', id)
            // verify required parameter 'surveyTranslationBody' is not null or undefined
            assertParamExists('createTitleTranslations', 'surveyTranslationBody', surveyTranslationBody)
            const localVarPath = `/survey-management/{id}/translations:title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSurvey', 'id', id)
            const localVarPath = `/survey-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplicate a survey into a new draft
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSurvey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicateSurvey', 'id', id)
            const localVarPath = `/survey-management/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the paginated list of translations of the description of a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDescriptionTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDescriptionTranslations', 'id', id)
            const localVarPath = `/survey-management/{id}/translations:description`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the overview of responses to a specific survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponseOverview: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResponseOverview', 'id', id)
            const localVarPath = `/survey-management/{id}/responses/overview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated list of individual survey responses
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [userId] 
         * @param {string | null} [questionId] 
         * @param {string | null} [answer] 
         * @param {string | null} [answeredFrom] 
         * @param {string | null} [answeredTo] 
         * @param {string | null} [searchString] 
         * @param {OrderDirection} [orderDirection] 
         * @param {SurveyResponseOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponses: async (id: string, limit?: number | null, offset?: number | null, userId?: string | null, questionId?: string | null, answer?: string | null, answeredFrom?: string | null, answeredTo?: string | null, searchString?: string | null, orderDirection?: OrderDirection, orderBy?: SurveyResponseOrderBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResponses', 'id', id)
            const localVarPath = `/survey-management/{id}/responses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (questionId !== undefined) {
                localVarQueryParameter['questionId'] = questionId;
            }

            if (answer !== undefined) {
                localVarQueryParameter['answer'] = answer;
            }

            if (answeredFrom !== undefined) {
                localVarQueryParameter['answeredFrom'] = answeredFrom;
            }

            if (answeredTo !== undefined) {
                localVarQueryParameter['answeredTo'] = answeredTo;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSurveyDetails', 'id', id)
            const localVarPath = `/survey-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get questions for a survey
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyQuestions: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSurveyQuestions', 'id', id)
            const localVarPath = `/survey-management/{id}/questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all surveys
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {SurveyStatus} [status] 
         * @param {string | null} [searchString] 
         * @param {OrderDirection} [orderDirection] 
         * @param {SurveyOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveys: async (limit?: number | null, offset?: number | null, status?: SurveyStatus, searchString?: string | null, orderDirection?: OrderDirection, orderBy?: SurveyOrderBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/survey-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the paginated list of translations of the title of a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTitleTranslations', 'id', id)
            const localVarPath = `/survey-management/{id}/translations:title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSurvey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendSurvey', 'id', id)
            const localVarPath = `/survey-management/{id}/send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a survey
         * @param {string} id 
         * @param {SurveyUpdateBody} surveyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey: async (id: string, surveyUpdateBody: SurveyUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSurvey', 'id', id)
            // verify required parameter 'surveyUpdateBody' is not null or undefined
            assertParamExists('updateSurvey', 'surveyUpdateBody', surveyUpdateBody)
            const localVarPath = `/survey-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyManagementApi - functional programming interface
 * @export
 */
export const SurveyManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create translations for the description of a survey
         * @param {string} id 
         * @param {SurveyTranslationBody} surveyTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDescriptionTranslations(id: string, surveyTranslationBody: SurveyTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDescriptionTranslations(id, surveyTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.createDescriptionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new survey
         * @param {SurveyCreateBody} surveyCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurvey(surveyCreateBody: SurveyCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurvey(surveyCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.createSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a survey question
         * @param {string} id 
         * @param {SurveyQuestionBody} surveyQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurveyQuestion(id: string, surveyQuestionBody: SurveyQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurveyQuestion(id, surveyQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.createSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create translations for the title of a survey
         * @param {string} id 
         * @param {SurveyTranslationBody} surveyTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTitleTranslations(id: string, surveyTranslationBody: SurveyTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTitleTranslations(id, surveyTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.createTitleTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurvey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurvey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.deleteSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Duplicate a survey into a new draft
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateSurvey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateSurvey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.duplicateSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the paginated list of translations of the description of a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDescriptionTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDescriptionTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getDescriptionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the overview of responses to a specific survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResponseOverview(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponseOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResponseOverview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getResponseOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated list of individual survey responses
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [userId] 
         * @param {string | null} [questionId] 
         * @param {string | null} [answer] 
         * @param {string | null} [answeredFrom] 
         * @param {string | null} [answeredTo] 
         * @param {string | null} [searchString] 
         * @param {OrderDirection} [orderDirection] 
         * @param {SurveyResponseOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResponses(id: string, limit?: number | null, offset?: number | null, userId?: string | null, questionId?: string | null, answer?: string | null, answeredFrom?: string | null, answeredTo?: string | null, searchString?: string | null, orderDirection?: OrderDirection, orderBy?: SurveyResponseOrderBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyResponseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResponses(id, limit, offset, userId, questionId, answer, answeredFrom, answeredTo, searchString, orderDirection, orderBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getResponses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveyDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get questions for a survey
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyQuestions(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyQuestions(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveyQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of all surveys
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {SurveyStatus} [status] 
         * @param {string | null} [searchString] 
         * @param {OrderDirection} [orderDirection] 
         * @param {SurveyOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveys(limit?: number | null, offset?: number | null, status?: SurveyStatus, searchString?: string | null, orderDirection?: OrderDirection, orderBy?: SurveyOrderBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveys(limit, offset, status, searchString, orderDirection, orderBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the paginated list of translations of the title of a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTitleTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTitleTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getTitleTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSurvey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSurvey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.sendSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a survey
         * @param {string} id 
         * @param {SurveyUpdateBody} surveyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurvey(id: string, surveyUpdateBody: SurveyUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurvey(id, surveyUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.updateSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyManagementApi - factory interface
 * @export
 */
export const SurveyManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Create translations for the description of a survey
         * @param {SurveyManagementApiCreateDescriptionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDescriptionTranslations(requestParameters: SurveyManagementApiCreateDescriptionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyTranslationView> {
            return localVarFp.createDescriptionTranslations(requestParameters.id, requestParameters.surveyTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new survey
         * @param {SurveyManagementApiCreateSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey(requestParameters: SurveyManagementApiCreateSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyView> {
            return localVarFp.createSurvey(requestParameters.surveyCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a survey question
         * @param {SurveyManagementApiCreateSurveyQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyQuestion(requestParameters: SurveyManagementApiCreateSurveyQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyQuestionView> {
            return localVarFp.createSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create translations for the title of a survey
         * @param {SurveyManagementApiCreateTitleTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTitleTranslations(requestParameters: SurveyManagementApiCreateTitleTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyTranslationView> {
            return localVarFp.createTitleTranslations(requestParameters.id, requestParameters.surveyTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a survey
         * @param {SurveyManagementApiDeleteSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey(requestParameters: SurveyManagementApiDeleteSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSurvey(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplicate a survey into a new draft
         * @param {SurveyManagementApiDuplicateSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSurvey(requestParameters: SurveyManagementApiDuplicateSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyView> {
            return localVarFp.duplicateSurvey(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the paginated list of translations of the description of a survey
         * @param {SurveyManagementApiGetDescriptionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDescriptionTranslations(requestParameters: SurveyManagementApiGetDescriptionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyTranslationView> {
            return localVarFp.getDescriptionTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the overview of responses to a specific survey
         * @param {SurveyManagementApiGetResponseOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponseOverview(requestParameters: SurveyManagementApiGetResponseOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseOverviewView> {
            return localVarFp.getResponseOverview(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated list of individual survey responses
         * @param {SurveyManagementApiGetResponsesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponses(requestParameters: SurveyManagementApiGetResponsesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyResponseView> {
            return localVarFp.getResponses(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.userId, requestParameters.questionId, requestParameters.answer, requestParameters.answeredFrom, requestParameters.answeredTo, requestParameters.searchString, requestParameters.orderDirection, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey details
         * @param {SurveyManagementApiGetSurveyDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyDetails(requestParameters: SurveyManagementApiGetSurveyDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsView> {
            return localVarFp.getSurveyDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get questions for a survey
         * @param {SurveyManagementApiGetSurveyQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyQuestions(requestParameters: SurveyManagementApiGetSurveyQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyQuestionView> {
            return localVarFp.getSurveyQuestions(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all surveys
         * @param {SurveyManagementApiGetSurveysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveys(requestParameters: SurveyManagementApiGetSurveysRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyView> {
            return localVarFp.getSurveys(requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.searchString, requestParameters.orderDirection, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the paginated list of translations of the title of a survey
         * @param {SurveyManagementApiGetTitleTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleTranslations(requestParameters: SurveyManagementApiGetTitleTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyTranslationView> {
            return localVarFp.getTitleTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a survey
         * @param {SurveyManagementApiSendSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSurvey(requestParameters: SurveyManagementApiSendSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendSurvey(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a survey
         * @param {SurveyManagementApiUpdateSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey(requestParameters: SurveyManagementApiUpdateSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSurvey(requestParameters.id, requestParameters.surveyUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDescriptionTranslations operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiCreateDescriptionTranslationsRequest
 */
export interface SurveyManagementApiCreateDescriptionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiCreateDescriptionTranslations
     */
    readonly id: string

    /**
     * 
     * @type {SurveyTranslationBody}
     * @memberof SurveyManagementApiCreateDescriptionTranslations
     */
    readonly surveyTranslationBody: SurveyTranslationBody
}

/**
 * Request parameters for createSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiCreateSurveyRequest
 */
export interface SurveyManagementApiCreateSurveyRequest {
    /**
     * 
     * @type {SurveyCreateBody}
     * @memberof SurveyManagementApiCreateSurvey
     */
    readonly surveyCreateBody: SurveyCreateBody
}

/**
 * Request parameters for createSurveyQuestion operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiCreateSurveyQuestionRequest
 */
export interface SurveyManagementApiCreateSurveyQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiCreateSurveyQuestion
     */
    readonly id: string

    /**
     * 
     * @type {SurveyQuestionBody}
     * @memberof SurveyManagementApiCreateSurveyQuestion
     */
    readonly surveyQuestionBody: SurveyQuestionBody
}

/**
 * Request parameters for createTitleTranslations operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiCreateTitleTranslationsRequest
 */
export interface SurveyManagementApiCreateTitleTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiCreateTitleTranslations
     */
    readonly id: string

    /**
     * 
     * @type {SurveyTranslationBody}
     * @memberof SurveyManagementApiCreateTitleTranslations
     */
    readonly surveyTranslationBody: SurveyTranslationBody
}

/**
 * Request parameters for deleteSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiDeleteSurveyRequest
 */
export interface SurveyManagementApiDeleteSurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiDeleteSurvey
     */
    readonly id: string
}

/**
 * Request parameters for duplicateSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiDuplicateSurveyRequest
 */
export interface SurveyManagementApiDuplicateSurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiDuplicateSurvey
     */
    readonly id: string
}

/**
 * Request parameters for getDescriptionTranslations operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetDescriptionTranslationsRequest
 */
export interface SurveyManagementApiGetDescriptionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetDescriptionTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getResponseOverview operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetResponseOverviewRequest
 */
export interface SurveyManagementApiGetResponseOverviewRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponseOverview
     */
    readonly id: string
}

/**
 * Request parameters for getResponses operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetResponsesRequest
 */
export interface SurveyManagementApiGetResponsesRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly userId?: string | null

    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly questionId?: string | null

    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly answer?: string | null

    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly answeredFrom?: string | null

    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly answeredTo?: string | null

    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly searchString?: string | null

    /**
     * 
     * @type {OrderDirection}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {SurveyResponseOrderBy}
     * @memberof SurveyManagementApiGetResponses
     */
    readonly orderBy?: SurveyResponseOrderBy
}

/**
 * Request parameters for getSurveyDetails operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetSurveyDetailsRequest
 */
export interface SurveyManagementApiGetSurveyDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetSurveyDetails
     */
    readonly id: string
}

/**
 * Request parameters for getSurveyQuestions operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetSurveyQuestionsRequest
 */
export interface SurveyManagementApiGetSurveyQuestionsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetSurveyQuestions
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetSurveyQuestions
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetSurveyQuestions
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getSurveys operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetSurveysRequest
 */
export interface SurveyManagementApiGetSurveysRequest {
    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly offset?: number | null

    /**
     * 
     * @type {SurveyStatus}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly status?: SurveyStatus

    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly searchString?: string | null

    /**
     * 
     * @type {OrderDirection}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {SurveyOrderBy}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly orderBy?: SurveyOrderBy
}

/**
 * Request parameters for getTitleTranslations operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetTitleTranslationsRequest
 */
export interface SurveyManagementApiGetTitleTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetTitleTranslations
     */
    readonly id: string
}

/**
 * Request parameters for sendSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiSendSurveyRequest
 */
export interface SurveyManagementApiSendSurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiSendSurvey
     */
    readonly id: string
}

/**
 * Request parameters for updateSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiUpdateSurveyRequest
 */
export interface SurveyManagementApiUpdateSurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiUpdateSurvey
     */
    readonly id: string

    /**
     * 
     * @type {SurveyUpdateBody}
     * @memberof SurveyManagementApiUpdateSurvey
     */
    readonly surveyUpdateBody: SurveyUpdateBody
}

/**
 * SurveyManagementApi - object-oriented interface
 * @export
 * @class SurveyManagementApi
 * @extends {BaseAPI}
 */
export class SurveyManagementApi extends BaseAPI {
    /**
     * 
     * @summary Create translations for the description of a survey
     * @param {SurveyManagementApiCreateDescriptionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public createDescriptionTranslations(requestParameters: SurveyManagementApiCreateDescriptionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).createDescriptionTranslations(requestParameters.id, requestParameters.surveyTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new survey
     * @param {SurveyManagementApiCreateSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public createSurvey(requestParameters: SurveyManagementApiCreateSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).createSurvey(requestParameters.surveyCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a survey question
     * @param {SurveyManagementApiCreateSurveyQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public createSurveyQuestion(requestParameters: SurveyManagementApiCreateSurveyQuestionRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).createSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create translations for the title of a survey
     * @param {SurveyManagementApiCreateTitleTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public createTitleTranslations(requestParameters: SurveyManagementApiCreateTitleTranslationsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).createTitleTranslations(requestParameters.id, requestParameters.surveyTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a survey
     * @param {SurveyManagementApiDeleteSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public deleteSurvey(requestParameters: SurveyManagementApiDeleteSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).deleteSurvey(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplicate a survey into a new draft
     * @param {SurveyManagementApiDuplicateSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public duplicateSurvey(requestParameters: SurveyManagementApiDuplicateSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).duplicateSurvey(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the paginated list of translations of the description of a survey
     * @param {SurveyManagementApiGetDescriptionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getDescriptionTranslations(requestParameters: SurveyManagementApiGetDescriptionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getDescriptionTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the overview of responses to a specific survey
     * @param {SurveyManagementApiGetResponseOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getResponseOverview(requestParameters: SurveyManagementApiGetResponseOverviewRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getResponseOverview(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated list of individual survey responses
     * @param {SurveyManagementApiGetResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getResponses(requestParameters: SurveyManagementApiGetResponsesRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getResponses(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.userId, requestParameters.questionId, requestParameters.answer, requestParameters.answeredFrom, requestParameters.answeredTo, requestParameters.searchString, requestParameters.orderDirection, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey details
     * @param {SurveyManagementApiGetSurveyDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveyDetails(requestParameters: SurveyManagementApiGetSurveyDetailsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveyDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get questions for a survey
     * @param {SurveyManagementApiGetSurveyQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveyQuestions(requestParameters: SurveyManagementApiGetSurveyQuestionsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveyQuestions(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all surveys
     * @param {SurveyManagementApiGetSurveysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveys(requestParameters: SurveyManagementApiGetSurveysRequest = {}, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveys(requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.searchString, requestParameters.orderDirection, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the paginated list of translations of the title of a survey
     * @param {SurveyManagementApiGetTitleTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getTitleTranslations(requestParameters: SurveyManagementApiGetTitleTranslationsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getTitleTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a survey
     * @param {SurveyManagementApiSendSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public sendSurvey(requestParameters: SurveyManagementApiSendSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).sendSurvey(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a survey
     * @param {SurveyManagementApiUpdateSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public updateSurvey(requestParameters: SurveyManagementApiUpdateSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).updateSurvey(requestParameters.id, requestParameters.surveyUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SurveyQuestionsApi - axios parameter creator
 * @export
 */
export const SurveyQuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create the dependencies of a survey question
         * @param {string} id 
         * @param {SurveyQuestionDependencyBody} surveyQuestionDependencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyQuestionDependency: async (id: string, surveyQuestionDependencyBody: SurveyQuestionDependencyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSurveyQuestionDependency', 'id', id)
            // verify required parameter 'surveyQuestionDependencyBody' is not null or undefined
            assertParamExists('createSurveyQuestionDependency', 'surveyQuestionDependencyBody', surveyQuestionDependencyBody)
            const localVarPath = `/survey-questions/{id}/dependencies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyQuestionDependencyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a survey question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyQuestion: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSurveyQuestion', 'id', id)
            const localVarPath = `/survey-questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the dependencies of a survey question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyQuestionDependencies: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSurveyQuestionDependencies', 'id', id)
            const localVarPath = `/survey-questions/{id}/dependencies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change the position of a survey question
         * @param {string} id 
         * @param {SurveyQuestionMoveBody} surveyQuestionMoveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSurveyQuestion: async (id: string, surveyQuestionMoveBody: SurveyQuestionMoveBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveSurveyQuestion', 'id', id)
            // verify required parameter 'surveyQuestionMoveBody' is not null or undefined
            assertParamExists('moveSurveyQuestion', 'surveyQuestionMoveBody', surveyQuestionMoveBody)
            const localVarPath = `/survey-questions/{id}/move`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyQuestionMoveBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change any of the properties of a survey question
         * @param {string} id 
         * @param {SurveyQuestionUpdateBody} surveyQuestionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurveyQuestion: async (id: string, surveyQuestionUpdateBody: SurveyQuestionUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSurveyQuestion', 'id', id)
            // verify required parameter 'surveyQuestionUpdateBody' is not null or undefined
            assertParamExists('updateSurveyQuestion', 'surveyQuestionUpdateBody', surveyQuestionUpdateBody)
            const localVarPath = `/survey-questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyQuestionUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyQuestionsApi - functional programming interface
 * @export
 */
export const SurveyQuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyQuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create the dependencies of a survey question
         * @param {string} id 
         * @param {SurveyQuestionDependencyBody} surveyQuestionDependencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurveyQuestionDependency(id: string, surveyQuestionDependencyBody: SurveyQuestionDependencyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyQuestionDependencyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurveyQuestionDependency(id, surveyQuestionDependencyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.createSurveyQuestionDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a survey question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurveyQuestion(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurveyQuestion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.deleteSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the dependencies of a survey question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyQuestionDependencies(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyQuestionDependencyListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyQuestionDependencies(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.getSurveyQuestionDependencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary change the position of a survey question
         * @param {string} id 
         * @param {SurveyQuestionMoveBody} surveyQuestionMoveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveSurveyQuestion(id: string, surveyQuestionMoveBody: SurveyQuestionMoveBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveSurveyQuestion(id, surveyQuestionMoveBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.moveSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary change any of the properties of a survey question
         * @param {string} id 
         * @param {SurveyQuestionUpdateBody} surveyQuestionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurveyQuestion(id: string, surveyQuestionUpdateBody: SurveyQuestionUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurveyQuestion(id, surveyQuestionUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.updateSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyQuestionsApi - factory interface
 * @export
 */
export const SurveyQuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyQuestionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create the dependencies of a survey question
         * @param {SurveyQuestionsApiCreateSurveyQuestionDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyQuestionDependency(requestParameters: SurveyQuestionsApiCreateSurveyQuestionDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyQuestionDependencyView> {
            return localVarFp.createSurveyQuestionDependency(requestParameters.id, requestParameters.surveyQuestionDependencyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a survey question
         * @param {SurveyQuestionsApiDeleteSurveyQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyQuestion(requestParameters: SurveyQuestionsApiDeleteSurveyQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSurveyQuestion(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the dependencies of a survey question
         * @param {SurveyQuestionsApiGetSurveyQuestionDependenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyQuestionDependencies(requestParameters: SurveyQuestionsApiGetSurveyQuestionDependenciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyQuestionDependencyListView> {
            return localVarFp.getSurveyQuestionDependencies(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change the position of a survey question
         * @param {SurveyQuestionsApiMoveSurveyQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSurveyQuestion(requestParameters: SurveyQuestionsApiMoveSurveyQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionMoveBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change any of the properties of a survey question
         * @param {SurveyQuestionsApiUpdateSurveyQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurveyQuestion(requestParameters: SurveyQuestionsApiUpdateSurveyQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createSurveyQuestionDependency operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiCreateSurveyQuestionDependencyRequest
 */
export interface SurveyQuestionsApiCreateSurveyQuestionDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiCreateSurveyQuestionDependency
     */
    readonly id: string

    /**
     * 
     * @type {SurveyQuestionDependencyBody}
     * @memberof SurveyQuestionsApiCreateSurveyQuestionDependency
     */
    readonly surveyQuestionDependencyBody: SurveyQuestionDependencyBody
}

/**
 * Request parameters for deleteSurveyQuestion operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiDeleteSurveyQuestionRequest
 */
export interface SurveyQuestionsApiDeleteSurveyQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiDeleteSurveyQuestion
     */
    readonly id: string
}

/**
 * Request parameters for getSurveyQuestionDependencies operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiGetSurveyQuestionDependenciesRequest
 */
export interface SurveyQuestionsApiGetSurveyQuestionDependenciesRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiGetSurveyQuestionDependencies
     */
    readonly id: string
}

/**
 * Request parameters for moveSurveyQuestion operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiMoveSurveyQuestionRequest
 */
export interface SurveyQuestionsApiMoveSurveyQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiMoveSurveyQuestion
     */
    readonly id: string

    /**
     * 
     * @type {SurveyQuestionMoveBody}
     * @memberof SurveyQuestionsApiMoveSurveyQuestion
     */
    readonly surveyQuestionMoveBody: SurveyQuestionMoveBody
}

/**
 * Request parameters for updateSurveyQuestion operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiUpdateSurveyQuestionRequest
 */
export interface SurveyQuestionsApiUpdateSurveyQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiUpdateSurveyQuestion
     */
    readonly id: string

    /**
     * 
     * @type {SurveyQuestionUpdateBody}
     * @memberof SurveyQuestionsApiUpdateSurveyQuestion
     */
    readonly surveyQuestionUpdateBody: SurveyQuestionUpdateBody
}

/**
 * SurveyQuestionsApi - object-oriented interface
 * @export
 * @class SurveyQuestionsApi
 * @extends {BaseAPI}
 */
export class SurveyQuestionsApi extends BaseAPI {
    /**
     * 
     * @summary Create the dependencies of a survey question
     * @param {SurveyQuestionsApiCreateSurveyQuestionDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public createSurveyQuestionDependency(requestParameters: SurveyQuestionsApiCreateSurveyQuestionDependencyRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).createSurveyQuestionDependency(requestParameters.id, requestParameters.surveyQuestionDependencyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a survey question
     * @param {SurveyQuestionsApiDeleteSurveyQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public deleteSurveyQuestion(requestParameters: SurveyQuestionsApiDeleteSurveyQuestionRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).deleteSurveyQuestion(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the dependencies of a survey question
     * @param {SurveyQuestionsApiGetSurveyQuestionDependenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public getSurveyQuestionDependencies(requestParameters: SurveyQuestionsApiGetSurveyQuestionDependenciesRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).getSurveyQuestionDependencies(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change the position of a survey question
     * @param {SurveyQuestionsApiMoveSurveyQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public moveSurveyQuestion(requestParameters: SurveyQuestionsApiMoveSurveyQuestionRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).moveSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionMoveBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change any of the properties of a survey question
     * @param {SurveyQuestionsApiUpdateSurveyQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public updateSurveyQuestion(requestParameters: SurveyQuestionsApiUpdateSurveyQuestionRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).updateSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamApi - axios parameter creator
 * @export
 */
export const TeamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a trial to a team
         * @param {string} id 
         * @param {TeamTrialBody} teamTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamTrial: async (id: string, teamTrialBody: TeamTrialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTeamTrial', 'id', id)
            // verify required parameter 'teamTrialBody' is not null or undefined
            assertParamExists('addTeamTrial', 'teamTrialBody', teamTrialBody)
            const localVarPath = `/team/{id}/trials`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamTrialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new team
         * @param {TeamBody} teamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: async (teamBody: TeamBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamBody' is not null or undefined
            assertParamExists('createTeam', 'teamBody', teamBody)
            const localVarPath = `/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a team and all its data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTeam', 'id', id)
            const localVarPath = `/team/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new Stripe checkout session to start a new subscription
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutSession: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCheckoutSession', 'id', id)
            const localVarPath = `/team/{id}/subscription/checkout`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get url to the Stripe billing portal of the team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortalURL: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerPortalURL', 'id', id)
            const localVarPath = `/team/{id}/subscription/portal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a team\'s current Insights reporting scope (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportingScope: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportingScope', 'id', id)
            const localVarPath = `/team/{id}/reporting-scope`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recent changes to a team\'s Insights reporting scope (admin only)
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportingScopeAuditLog: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportingScopeAuditLog', 'id', id)
            const localVarPath = `/team/{id}/reporting-scope/audit-log`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the details of a team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeamDetails', 'id', id)
            const localVarPath = `/team/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the members of a team
         * @param {string} id 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMembers: async (id: string, limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeamMembers', 'id', id)
            const localVarPath = `/team/{id}/members`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the panels a team has access to
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamPanels: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeamPanels', 'id', id)
            const localVarPath = `/team/{id}/panels`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the trials of a team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamTrials: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeamTrials', 'id', id)
            const localVarPath = `/team/{id}/trials`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all teams
         * @param {number} [limit] 
         * @param {string} [searchString] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams: async (limit?: number, searchString?: string, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Merge a source team into target team
         * @param {string} id 
         * @param {TeamMergeBody} teamMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeTeams: async (id: string, teamMergeBody: TeamMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mergeTeams', 'id', id)
            // verify required parameter 'teamMergeBody' is not null or undefined
            assertParamExists('mergeTeams', 'teamMergeBody', teamMergeBody)
            const localVarPath = `/team/{id}/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Migrate sponsor team to trial manager role
         * @param {string} id 
         * @param {MigrateSponsorToTrialManagerBody} migrateSponsorToTrialManagerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateSponsorToTrialManager: async (id: string, migrateSponsorToTrialManagerBody: MigrateSponsorToTrialManagerBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('migrateSponsorToTrialManager', 'id', id)
            // verify required parameter 'migrateSponsorToTrialManagerBody' is not null or undefined
            assertParamExists('migrateSponsorToTrialManager', 'migrateSponsorToTrialManagerBody', migrateSponsorToTrialManagerBody)
            const localVarPath = `/team/{id}/migrate-sponsor-to-tm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(migrateSponsorToTrialManagerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the panel permissions of a team member
         * @param {string} id 
         * @param {string} userId 
         * @param {TeamMemberPanelPermissionsBody} teamMemberPanelPermissionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberPanelPermissions: async (id: string, userId: string, teamMemberPanelPermissionsBody: TeamMemberPanelPermissionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMemberPanelPermissions', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateMemberPanelPermissions', 'userId', userId)
            // verify required parameter 'teamMemberPanelPermissionsBody' is not null or undefined
            assertParamExists('updateMemberPanelPermissions', 'teamMemberPanelPermissionsBody', teamMemberPanelPermissionsBody)
            const localVarPath = `/team/{id}/members/{userId}/panel-permissions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberPanelPermissionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set a partner team\'s Insights reporting scope (admin only)
         * @param {string} id 
         * @param {TeamReportingSourceSlugsBody} teamReportingSourceSlugsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportingSourceSlugs: async (id: string, teamReportingSourceSlugsBody: TeamReportingSourceSlugsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateReportingSourceSlugs', 'id', id)
            // verify required parameter 'teamReportingSourceSlugsBody' is not null or undefined
            assertParamExists('updateReportingSourceSlugs', 'teamReportingSourceSlugsBody', teamReportingSourceSlugsBody)
            const localVarPath = `/team/{id}/reporting-scope`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamReportingSourceSlugsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a team
         * @param {string} id 
         * @param {TeamUpdateBody} teamUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: async (id: string, teamUpdateBody: TeamUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTeam', 'id', id)
            // verify required parameter 'teamUpdateBody' is not null or undefined
            assertParamExists('updateTeam', 'teamUpdateBody', teamUpdateBody)
            const localVarPath = `/team/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the membership of a user of a trial
         * @param {string} id 
         * @param {string} userId 
         * @param {TeamMemberBody} teamMemberBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMembership: async (id: string, userId: string, teamMemberBody: TeamMemberBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTeamMembership', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateTeamMembership', 'userId', userId)
            // verify required parameter 'teamMemberBody' is not null or undefined
            assertParamExists('updateTeamMembership', 'teamMemberBody', teamMemberBody)
            const localVarPath = `/team/{id}/members/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamApi - functional programming interface
 * @export
 */
export const TeamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a trial to a team
         * @param {string} id 
         * @param {TeamTrialBody} teamTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTeamTrial(id: string, teamTrialBody: TeamTrialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTeamTrial(id, teamTrialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.addTeamTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a new team
         * @param {TeamBody} teamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeam(teamBody: TeamBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeam(teamBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a team and all its data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeam(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeam(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.deleteTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a new Stripe checkout session to start a new subscription
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckoutSession(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckoutSession(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get url to the Stripe billing portal of the team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerPortalURL(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPortalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerPortalURL(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getCustomerPortalURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a team\'s current Insights reporting scope (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportingScope(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamReportingScopeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportingScope(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getReportingScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recent changes to a team\'s Insights reporting scope (admin only)
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportingScopeAuditLog(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTeamReportingScopeAuditLogEntryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportingScopeAuditLog(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getReportingScopeAuditLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch the details of a team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch the members of a team
         * @param {string} id 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamMembers(id: string, limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamMembers(id, limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the panels a team has access to
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamPanels(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTeamPanelView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamPanels(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamPanels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the trials of a team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamTrials(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTeamTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamTrials(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all teams
         * @param {number} [limit] 
         * @param {string} [searchString] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeams(limit?: number, searchString?: string, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeams(limit, searchString, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Merge a source team into target team
         * @param {string} id 
         * @param {TeamMergeBody} teamMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeTeams(id: string, teamMergeBody: TeamMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMergeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeTeams(id, teamMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.mergeTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Migrate sponsor team to trial manager role
         * @param {string} id 
         * @param {MigrateSponsorToTrialManagerBody} migrateSponsorToTrialManagerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateSponsorToTrialManager(id: string, migrateSponsorToTrialManagerBody: MigrateSponsorToTrialManagerBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateSponsorToTrialManager(id, migrateSponsorToTrialManagerBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.migrateSponsorToTrialManager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the panel permissions of a team member
         * @param {string} id 
         * @param {string} userId 
         * @param {TeamMemberPanelPermissionsBody} teamMemberPanelPermissionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberPanelPermissions(id: string, userId: string, teamMemberPanelPermissionsBody: TeamMemberPanelPermissionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberPanelPermissions(id, userId, teamMemberPanelPermissionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateMemberPanelPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set a partner team\'s Insights reporting scope (admin only)
         * @param {string} id 
         * @param {TeamReportingSourceSlugsBody} teamReportingSourceSlugsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportingSourceSlugs(id: string, teamReportingSourceSlugsBody: TeamReportingSourceSlugsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportingSourceSlugs(id, teamReportingSourceSlugsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateReportingSourceSlugs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a team
         * @param {string} id 
         * @param {TeamUpdateBody} teamUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeam(id: string, teamUpdateBody: TeamUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeam(id, teamUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the membership of a user of a trial
         * @param {string} id 
         * @param {string} userId 
         * @param {TeamMemberBody} teamMemberBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamMembership(id: string, userId: string, teamMemberBody: TeamMemberBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamMembership(id, userId, teamMemberBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamApi - factory interface
 * @export
 */
export const TeamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a trial to a team
         * @param {TeamApiAddTeamTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamTrial(requestParameters: TeamApiAddTeamTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addTeamTrial(requestParameters.id, requestParameters.teamTrialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new team
         * @param {TeamApiCreateTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam(requestParameters: TeamApiCreateTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamView> {
            return localVarFp.createTeam(requestParameters.teamBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a team and all its data
         * @param {TeamApiDeleteTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam(requestParameters: TeamApiDeleteTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeam(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new Stripe checkout session to start a new subscription
         * @param {TeamApiGetCheckoutSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutSession(requestParameters: TeamApiGetCheckoutSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutView> {
            return localVarFp.getCheckoutSession(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get url to the Stripe billing portal of the team
         * @param {TeamApiGetCustomerPortalURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortalURL(requestParameters: TeamApiGetCustomerPortalURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerPortalView> {
            return localVarFp.getCustomerPortalURL(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a team\'s current Insights reporting scope (admin only)
         * @param {TeamApiGetReportingScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportingScope(requestParameters: TeamApiGetReportingScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamReportingScopeView> {
            return localVarFp.getReportingScope(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recent changes to a team\'s Insights reporting scope (admin only)
         * @param {TeamApiGetReportingScopeAuditLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportingScopeAuditLog(requestParameters: TeamApiGetReportingScopeAuditLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTeamReportingScopeAuditLogEntryView> {
            return localVarFp.getReportingScopeAuditLog(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the details of a team
         * @param {TeamApiGetTeamDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDetails(requestParameters: TeamApiGetTeamDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamDetailsView> {
            return localVarFp.getTeamDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the members of a team
         * @param {TeamApiGetTeamMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMembers(requestParameters: TeamApiGetTeamMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberListView> {
            return localVarFp.getTeamMembers(requestParameters.id, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the panels a team has access to
         * @param {TeamApiGetTeamPanelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamPanels(requestParameters: TeamApiGetTeamPanelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTeamPanelView> {
            return localVarFp.getTeamPanels(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the trials of a team
         * @param {TeamApiGetTeamTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamTrials(requestParameters: TeamApiGetTeamTrialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTeamTrialView> {
            return localVarFp.getTeamTrials(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all teams
         * @param {TeamApiGetTeamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams(requestParameters: TeamApiGetTeamsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TeamListView> {
            return localVarFp.getTeams(requestParameters.limit, requestParameters.searchString, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Merge a source team into target team
         * @param {TeamApiMergeTeamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeTeams(requestParameters: TeamApiMergeTeamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMergeView> {
            return localVarFp.mergeTeams(requestParameters.id, requestParameters.teamMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Migrate sponsor team to trial manager role
         * @param {TeamApiMigrateSponsorToTrialManagerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateSponsorToTrialManager(requestParameters: TeamApiMigrateSponsorToTrialManagerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migrateSponsorToTrialManager(requestParameters.id, requestParameters.migrateSponsorToTrialManagerBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the panel permissions of a team member
         * @param {TeamApiUpdateMemberPanelPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberPanelPermissions(requestParameters: TeamApiUpdateMemberPanelPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMemberPanelPermissions(requestParameters.id, requestParameters.userId, requestParameters.teamMemberPanelPermissionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set a partner team\'s Insights reporting scope (admin only)
         * @param {TeamApiUpdateReportingSourceSlugsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportingSourceSlugs(requestParameters: TeamApiUpdateReportingSourceSlugsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateReportingSourceSlugs(requestParameters.id, requestParameters.teamReportingSourceSlugsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a team
         * @param {TeamApiUpdateTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(requestParameters: TeamApiUpdateTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamView> {
            return localVarFp.updateTeam(requestParameters.id, requestParameters.teamUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the membership of a user of a trial
         * @param {TeamApiUpdateTeamMembershipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMembership(requestParameters: TeamApiUpdateTeamMembershipRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberView> {
            return localVarFp.updateTeamMembership(requestParameters.id, requestParameters.userId, requestParameters.teamMemberBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addTeamTrial operation in TeamApi.
 * @export
 * @interface TeamApiAddTeamTrialRequest
 */
export interface TeamApiAddTeamTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiAddTeamTrial
     */
    readonly id: string

    /**
     * 
     * @type {TeamTrialBody}
     * @memberof TeamApiAddTeamTrial
     */
    readonly teamTrialBody: TeamTrialBody
}

/**
 * Request parameters for createTeam operation in TeamApi.
 * @export
 * @interface TeamApiCreateTeamRequest
 */
export interface TeamApiCreateTeamRequest {
    /**
     * 
     * @type {TeamBody}
     * @memberof TeamApiCreateTeam
     */
    readonly teamBody: TeamBody
}

/**
 * Request parameters for deleteTeam operation in TeamApi.
 * @export
 * @interface TeamApiDeleteTeamRequest
 */
export interface TeamApiDeleteTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiDeleteTeam
     */
    readonly id: string
}

/**
 * Request parameters for getCheckoutSession operation in TeamApi.
 * @export
 * @interface TeamApiGetCheckoutSessionRequest
 */
export interface TeamApiGetCheckoutSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetCheckoutSession
     */
    readonly id: string
}

/**
 * Request parameters for getCustomerPortalURL operation in TeamApi.
 * @export
 * @interface TeamApiGetCustomerPortalURLRequest
 */
export interface TeamApiGetCustomerPortalURLRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetCustomerPortalURL
     */
    readonly id: string
}

/**
 * Request parameters for getReportingScope operation in TeamApi.
 * @export
 * @interface TeamApiGetReportingScopeRequest
 */
export interface TeamApiGetReportingScopeRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetReportingScope
     */
    readonly id: string
}

/**
 * Request parameters for getReportingScopeAuditLog operation in TeamApi.
 * @export
 * @interface TeamApiGetReportingScopeAuditLogRequest
 */
export interface TeamApiGetReportingScopeAuditLogRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetReportingScopeAuditLog
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TeamApiGetReportingScopeAuditLog
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TeamApiGetReportingScopeAuditLog
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getTeamDetails operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamDetailsRequest
 */
export interface TeamApiGetTeamDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamDetails
     */
    readonly id: string
}

/**
 * Request parameters for getTeamMembers operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamMembersRequest
 */
export interface TeamApiGetTeamMembersRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamMembers
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TeamApiGetTeamMembers
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamMembers
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getTeamPanels operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamPanelsRequest
 */
export interface TeamApiGetTeamPanelsRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamPanels
     */
    readonly id: string
}

/**
 * Request parameters for getTeamTrials operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamTrialsRequest
 */
export interface TeamApiGetTeamTrialsRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamTrials
     */
    readonly id: string
}

/**
 * Request parameters for getTeams operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamsRequest
 */
export interface TeamApiGetTeamsRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamApiGetTeams
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeams
     */
    readonly searchString?: string

    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeams
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for mergeTeams operation in TeamApi.
 * @export
 * @interface TeamApiMergeTeamsRequest
 */
export interface TeamApiMergeTeamsRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiMergeTeams
     */
    readonly id: string

    /**
     * 
     * @type {TeamMergeBody}
     * @memberof TeamApiMergeTeams
     */
    readonly teamMergeBody: TeamMergeBody
}

/**
 * Request parameters for migrateSponsorToTrialManager operation in TeamApi.
 * @export
 * @interface TeamApiMigrateSponsorToTrialManagerRequest
 */
export interface TeamApiMigrateSponsorToTrialManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiMigrateSponsorToTrialManager
     */
    readonly id: string

    /**
     * 
     * @type {MigrateSponsorToTrialManagerBody}
     * @memberof TeamApiMigrateSponsorToTrialManager
     */
    readonly migrateSponsorToTrialManagerBody: MigrateSponsorToTrialManagerBody
}

/**
 * Request parameters for updateMemberPanelPermissions operation in TeamApi.
 * @export
 * @interface TeamApiUpdateMemberPanelPermissionsRequest
 */
export interface TeamApiUpdateMemberPanelPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateMemberPanelPermissions
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateMemberPanelPermissions
     */
    readonly userId: string

    /**
     * 
     * @type {TeamMemberPanelPermissionsBody}
     * @memberof TeamApiUpdateMemberPanelPermissions
     */
    readonly teamMemberPanelPermissionsBody: TeamMemberPanelPermissionsBody
}

/**
 * Request parameters for updateReportingSourceSlugs operation in TeamApi.
 * @export
 * @interface TeamApiUpdateReportingSourceSlugsRequest
 */
export interface TeamApiUpdateReportingSourceSlugsRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateReportingSourceSlugs
     */
    readonly id: string

    /**
     * 
     * @type {TeamReportingSourceSlugsBody}
     * @memberof TeamApiUpdateReportingSourceSlugs
     */
    readonly teamReportingSourceSlugsBody: TeamReportingSourceSlugsBody
}

/**
 * Request parameters for updateTeam operation in TeamApi.
 * @export
 * @interface TeamApiUpdateTeamRequest
 */
export interface TeamApiUpdateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateTeam
     */
    readonly id: string

    /**
     * 
     * @type {TeamUpdateBody}
     * @memberof TeamApiUpdateTeam
     */
    readonly teamUpdateBody: TeamUpdateBody
}

/**
 * Request parameters for updateTeamMembership operation in TeamApi.
 * @export
 * @interface TeamApiUpdateTeamMembershipRequest
 */
export interface TeamApiUpdateTeamMembershipRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateTeamMembership
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateTeamMembership
     */
    readonly userId: string

    /**
     * 
     * @type {TeamMemberBody}
     * @memberof TeamApiUpdateTeamMembership
     */
    readonly teamMemberBody: TeamMemberBody
}

/**
 * TeamApi - object-oriented interface
 * @export
 * @class TeamApi
 * @extends {BaseAPI}
 */
export class TeamApi extends BaseAPI {
    /**
     * 
     * @summary Add a trial to a team
     * @param {TeamApiAddTeamTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public addTeamTrial(requestParameters: TeamApiAddTeamTrialRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).addTeamTrial(requestParameters.id, requestParameters.teamTrialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new team
     * @param {TeamApiCreateTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeam(requestParameters: TeamApiCreateTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeam(requestParameters.teamBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a team and all its data
     * @param {TeamApiDeleteTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public deleteTeam(requestParameters: TeamApiDeleteTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).deleteTeam(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new Stripe checkout session to start a new subscription
     * @param {TeamApiGetCheckoutSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getCheckoutSession(requestParameters: TeamApiGetCheckoutSessionRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getCheckoutSession(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get url to the Stripe billing portal of the team
     * @param {TeamApiGetCustomerPortalURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getCustomerPortalURL(requestParameters: TeamApiGetCustomerPortalURLRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getCustomerPortalURL(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a team\'s current Insights reporting scope (admin only)
     * @param {TeamApiGetReportingScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getReportingScope(requestParameters: TeamApiGetReportingScopeRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getReportingScope(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recent changes to a team\'s Insights reporting scope (admin only)
     * @param {TeamApiGetReportingScopeAuditLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getReportingScopeAuditLog(requestParameters: TeamApiGetReportingScopeAuditLogRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getReportingScopeAuditLog(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the details of a team
     * @param {TeamApiGetTeamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamDetails(requestParameters: TeamApiGetTeamDetailsRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the members of a team
     * @param {TeamApiGetTeamMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamMembers(requestParameters: TeamApiGetTeamMembersRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamMembers(requestParameters.id, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the panels a team has access to
     * @param {TeamApiGetTeamPanelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamPanels(requestParameters: TeamApiGetTeamPanelsRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamPanels(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the trials of a team
     * @param {TeamApiGetTeamTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamTrials(requestParameters: TeamApiGetTeamTrialsRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamTrials(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all teams
     * @param {TeamApiGetTeamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeams(requestParameters: TeamApiGetTeamsRequest = {}, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeams(requestParameters.limit, requestParameters.searchString, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Merge a source team into target team
     * @param {TeamApiMergeTeamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public mergeTeams(requestParameters: TeamApiMergeTeamsRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).mergeTeams(requestParameters.id, requestParameters.teamMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Migrate sponsor team to trial manager role
     * @param {TeamApiMigrateSponsorToTrialManagerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public migrateSponsorToTrialManager(requestParameters: TeamApiMigrateSponsorToTrialManagerRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).migrateSponsorToTrialManager(requestParameters.id, requestParameters.migrateSponsorToTrialManagerBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the panel permissions of a team member
     * @param {TeamApiUpdateMemberPanelPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateMemberPanelPermissions(requestParameters: TeamApiUpdateMemberPanelPermissionsRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateMemberPanelPermissions(requestParameters.id, requestParameters.userId, requestParameters.teamMemberPanelPermissionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set a partner team\'s Insights reporting scope (admin only)
     * @param {TeamApiUpdateReportingSourceSlugsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateReportingSourceSlugs(requestParameters: TeamApiUpdateReportingSourceSlugsRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateReportingSourceSlugs(requestParameters.id, requestParameters.teamReportingSourceSlugsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a team
     * @param {TeamApiUpdateTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeam(requestParameters: TeamApiUpdateTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeam(requestParameters.id, requestParameters.teamUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the membership of a user of a trial
     * @param {TeamApiUpdateTeamMembershipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamMembership(requestParameters: TeamApiUpdateTeamMembershipRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamMembership(requestParameters.id, requestParameters.userId, requestParameters.teamMemberBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TiersApi - axios parameter creator
 * @export
 */
export const TiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a tier, appended last
         * @param {TierCreateBody} tierCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (tierCreateBody: TierCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tierCreateBody' is not null or undefined
            assertParamExists('create', 'tierCreateBody', tierCreateBody)
            const localVarPath = `/tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tierCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list every tier in order, with its mapped canonical types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary merge a canonical type into another, folding concepts that collide
         * @param {string} id 
         * @param {TierCanonicalTypeMergeBody} tierCanonicalTypeMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeCanonicalType: async (id: string, tierCanonicalTypeMergeBody: TierCanonicalTypeMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mergeCanonicalType', 'id', id)
            // verify required parameter 'tierCanonicalTypeMergeBody' is not null or undefined
            assertParamExists('mergeCanonicalType', 'tierCanonicalTypeMergeBody', tierCanonicalTypeMergeBody)
            const localVarPath = `/tiers/canonical-types/{id}/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tierCanonicalTypeMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set every touched tier`s canonical types and their order in one write, retiering every concept of each
         * @param {TierCanonicalTypesReassignBody} tierCanonicalTypesReassignBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reassignCanonicalTypes: async (tierCanonicalTypesReassignBody: TierCanonicalTypesReassignBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tierCanonicalTypesReassignBody' is not null or undefined
            assertParamExists('reassignCanonicalTypes', 'tierCanonicalTypesReassignBody', tierCanonicalTypesReassignBody)
            const localVarPath = `/tiers/canonical-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tierCanonicalTypesReassignBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a tier (refused while it still has mapped canonical types)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/tiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary renumber every tier to the given order
         * @param {TiersReorderBody} tiersReorderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorder: async (tiersReorderBody: TiersReorderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tiersReorderBody' is not null or undefined
            assertParamExists('reorder', 'tiersReorderBody', tiersReorderBody)
            const localVarPath = `/tiers/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tiersReorderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary rename a tier, or edit its description or exhaustive flag
         * @param {string} id 
         * @param {TierUpdateBody} tierUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, tierUpdateBody: TierUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'tierUpdateBody' is not null or undefined
            assertParamExists('update', 'tierUpdateBody', tierUpdateBody)
            const localVarPath = `/tiers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tierUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary rename a canonical type everywhere it is stored, or edit its description
         * @param {string} id 
         * @param {TierCanonicalTypeUpdateBody} tierCanonicalTypeUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCanonicalType: async (id: string, tierCanonicalTypeUpdateBody: TierCanonicalTypeUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCanonicalType', 'id', id)
            // verify required parameter 'tierCanonicalTypeUpdateBody' is not null or undefined
            assertParamExists('updateCanonicalType', 'tierCanonicalTypeUpdateBody', tierCanonicalTypeUpdateBody)
            const localVarPath = `/tiers/canonical-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tierCanonicalTypeUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TiersApi - functional programming interface
 * @export
 */
export const TiersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TiersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create a tier, appended last
         * @param {TierCreateBody} tierCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(tierCreateBody: TierCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TierView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(tierCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list every tier in order, with its mapped canonical types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTierView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary merge a canonical type into another, folding concepts that collide
         * @param {string} id 
         * @param {TierCanonicalTypeMergeBody} tierCanonicalTypeMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeCanonicalType(id: string, tierCanonicalTypeMergeBody: TierCanonicalTypeMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTierView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeCanonicalType(id, tierCanonicalTypeMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.mergeCanonicalType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary set every touched tier`s canonical types and their order in one write, retiering every concept of each
         * @param {TierCanonicalTypesReassignBody} tierCanonicalTypesReassignBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reassignCanonicalTypes(tierCanonicalTypesReassignBody: TierCanonicalTypesReassignBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTierView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reassignCanonicalTypes(tierCanonicalTypesReassignBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.reassignCanonicalTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a tier (refused while it still has mapped canonical types)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary renumber every tier to the given order
         * @param {TiersReorderBody} tiersReorderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorder(tiersReorderBody: TiersReorderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTierView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorder(tiersReorderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.reorder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary rename a tier, or edit its description or exhaustive flag
         * @param {string} id 
         * @param {TierUpdateBody} tierUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, tierUpdateBody: TierUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TierView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, tierUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary rename a canonical type everywhere it is stored, or edit its description
         * @param {string} id 
         * @param {TierCanonicalTypeUpdateBody} tierCanonicalTypeUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCanonicalType(id: string, tierCanonicalTypeUpdateBody: TierCanonicalTypeUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TierView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCanonicalType(id, tierCanonicalTypeUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TiersApi.updateCanonicalType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TiersApi - factory interface
 * @export
 */
export const TiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TiersApiFp(configuration)
    return {
        /**
         * 
         * @summary create a tier, appended last
         * @param {TiersApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: TiersApiCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TierView> {
            return localVarFp.create(requestParameters.tierCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list every tier in order, with its mapped canonical types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options?: RawAxiosRequestConfig): AxiosPromise<ListTierView> {
            return localVarFp.list(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary merge a canonical type into another, folding concepts that collide
         * @param {TiersApiMergeCanonicalTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeCanonicalType(requestParameters: TiersApiMergeCanonicalTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTierView> {
            return localVarFp.mergeCanonicalType(requestParameters.id, requestParameters.tierCanonicalTypeMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set every touched tier`s canonical types and their order in one write, retiering every concept of each
         * @param {TiersApiReassignCanonicalTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reassignCanonicalTypes(requestParameters: TiersApiReassignCanonicalTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTierView> {
            return localVarFp.reassignCanonicalTypes(requestParameters.tierCanonicalTypesReassignBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a tier (refused while it still has mapped canonical types)
         * @param {TiersApiRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(requestParameters: TiersApiRemoveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary renumber every tier to the given order
         * @param {TiersApiReorderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorder(requestParameters: TiersApiReorderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTierView> {
            return localVarFp.reorder(requestParameters.tiersReorderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary rename a tier, or edit its description or exhaustive flag
         * @param {TiersApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters: TiersApiUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TierView> {
            return localVarFp.update(requestParameters.id, requestParameters.tierUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary rename a canonical type everywhere it is stored, or edit its description
         * @param {TiersApiUpdateCanonicalTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCanonicalType(requestParameters: TiersApiUpdateCanonicalTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<TierView> {
            return localVarFp.updateCanonicalType(requestParameters.id, requestParameters.tierCanonicalTypeUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for create operation in TiersApi.
 * @export
 * @interface TiersApiCreateRequest
 */
export interface TiersApiCreateRequest {
    /**
     * 
     * @type {TierCreateBody}
     * @memberof TiersApiCreate
     */
    readonly tierCreateBody: TierCreateBody
}

/**
 * Request parameters for mergeCanonicalType operation in TiersApi.
 * @export
 * @interface TiersApiMergeCanonicalTypeRequest
 */
export interface TiersApiMergeCanonicalTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof TiersApiMergeCanonicalType
     */
    readonly id: string

    /**
     * 
     * @type {TierCanonicalTypeMergeBody}
     * @memberof TiersApiMergeCanonicalType
     */
    readonly tierCanonicalTypeMergeBody: TierCanonicalTypeMergeBody
}

/**
 * Request parameters for reassignCanonicalTypes operation in TiersApi.
 * @export
 * @interface TiersApiReassignCanonicalTypesRequest
 */
export interface TiersApiReassignCanonicalTypesRequest {
    /**
     * 
     * @type {TierCanonicalTypesReassignBody}
     * @memberof TiersApiReassignCanonicalTypes
     */
    readonly tierCanonicalTypesReassignBody: TierCanonicalTypesReassignBody
}

/**
 * Request parameters for remove operation in TiersApi.
 * @export
 * @interface TiersApiRemoveRequest
 */
export interface TiersApiRemoveRequest {
    /**
     * 
     * @type {string}
     * @memberof TiersApiRemove
     */
    readonly id: string
}

/**
 * Request parameters for reorder operation in TiersApi.
 * @export
 * @interface TiersApiReorderRequest
 */
export interface TiersApiReorderRequest {
    /**
     * 
     * @type {TiersReorderBody}
     * @memberof TiersApiReorder
     */
    readonly tiersReorderBody: TiersReorderBody
}

/**
 * Request parameters for update operation in TiersApi.
 * @export
 * @interface TiersApiUpdateRequest
 */
export interface TiersApiUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TiersApiUpdate
     */
    readonly id: string

    /**
     * 
     * @type {TierUpdateBody}
     * @memberof TiersApiUpdate
     */
    readonly tierUpdateBody: TierUpdateBody
}

/**
 * Request parameters for updateCanonicalType operation in TiersApi.
 * @export
 * @interface TiersApiUpdateCanonicalTypeRequest
 */
export interface TiersApiUpdateCanonicalTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof TiersApiUpdateCanonicalType
     */
    readonly id: string

    /**
     * 
     * @type {TierCanonicalTypeUpdateBody}
     * @memberof TiersApiUpdateCanonicalType
     */
    readonly tierCanonicalTypeUpdateBody: TierCanonicalTypeUpdateBody
}

/**
 * TiersApi - object-oriented interface
 * @export
 * @class TiersApi
 * @extends {BaseAPI}
 */
export class TiersApi extends BaseAPI {
    /**
     * 
     * @summary create a tier, appended last
     * @param {TiersApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public create(requestParameters: TiersApiCreateRequest, options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).create(requestParameters.tierCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list every tier in order, with its mapped canonical types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public list(options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).list(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary merge a canonical type into another, folding concepts that collide
     * @param {TiersApiMergeCanonicalTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public mergeCanonicalType(requestParameters: TiersApiMergeCanonicalTypeRequest, options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).mergeCanonicalType(requestParameters.id, requestParameters.tierCanonicalTypeMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set every touched tier`s canonical types and their order in one write, retiering every concept of each
     * @param {TiersApiReassignCanonicalTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public reassignCanonicalTypes(requestParameters: TiersApiReassignCanonicalTypesRequest, options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).reassignCanonicalTypes(requestParameters.tierCanonicalTypesReassignBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a tier (refused while it still has mapped canonical types)
     * @param {TiersApiRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public remove(requestParameters: TiersApiRemoveRequest, options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).remove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary renumber every tier to the given order
     * @param {TiersApiReorderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public reorder(requestParameters: TiersApiReorderRequest, options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).reorder(requestParameters.tiersReorderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary rename a tier, or edit its description or exhaustive flag
     * @param {TiersApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public update(requestParameters: TiersApiUpdateRequest, options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).update(requestParameters.id, requestParameters.tierUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary rename a canonical type everywhere it is stored, or edit its description
     * @param {TiersApiUpdateCanonicalTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiersApi
     */
    public updateCanonicalType(requestParameters: TiersApiUpdateCanonicalTypeRequest, options?: RawAxiosRequestConfig) {
        return TiersApiFp(this.configuration).updateCanonicalType(requestParameters.id, requestParameters.tierCanonicalTypeUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary fetch the data associated with a token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getToken', 'token', token)
            const localVarPath = `/tokens/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary fetch the data associated with a token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApi.getToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiFp(configuration)
    return {
        /**
         * 
         * @summary fetch the data associated with a token
         * @param {TokenApiGetTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToken(requestParameters: TokenApiGetTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenView> {
            return localVarFp.getToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getToken operation in TokenApi.
 * @export
 * @interface TokenApiGetTokenRequest
 */
export interface TokenApiGetTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenApiGetToken
     */
    readonly token: string
}

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
    /**
     * 
     * @summary fetch the data associated with a token
     * @param {TokenApiGetTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public getToken(requestParameters: TokenApiGetTokenRequest, options?: RawAxiosRequestConfig) {
        return TokenApiFp(this.configuration).getToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TranslationsApi - axios parameter creator
 * @export
 */
export const TranslationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create translations for a new language for all diseases
         * @param {NewDiseaseTranslationsBody} newDiseaseTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diseaseTranslations: async (newDiseaseTranslationsBody: NewDiseaseTranslationsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newDiseaseTranslationsBody' is not null or undefined
            assertParamExists('diseaseTranslations', 'newDiseaseTranslationsBody', newDiseaseTranslationsBody)
            const localVarPath = `/translations/disease-translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newDiseaseTranslationsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create translations for a new language
         * @param {NewLanguageBody} newLanguageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newLanguage: async (newLanguageBody: NewLanguageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newLanguageBody' is not null or undefined
            assertParamExists('newLanguage', 'newLanguageBody', newLanguageBody)
            const localVarPath = `/translations/new-language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newLanguageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslationsApi - functional programming interface
 * @export
 */
export const TranslationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranslationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create translations for a new language for all diseases
         * @param {NewDiseaseTranslationsBody} newDiseaseTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async diseaseTranslations(newDiseaseTranslationsBody: NewDiseaseTranslationsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.diseaseTranslations(newDiseaseTranslationsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationsApi.diseaseTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create translations for a new language
         * @param {NewLanguageBody} newLanguageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newLanguage(newLanguageBody: NewLanguageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newLanguage(newLanguageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationsApi.newLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TranslationsApi - factory interface
 * @export
 */
export const TranslationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranslationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create translations for a new language for all diseases
         * @param {TranslationsApiDiseaseTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diseaseTranslations(requestParameters: TranslationsApiDiseaseTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.diseaseTranslations(requestParameters.newDiseaseTranslationsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create translations for a new language
         * @param {TranslationsApiNewLanguageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newLanguage(requestParameters: TranslationsApiNewLanguageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.newLanguage(requestParameters.newLanguageBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for diseaseTranslations operation in TranslationsApi.
 * @export
 * @interface TranslationsApiDiseaseTranslationsRequest
 */
export interface TranslationsApiDiseaseTranslationsRequest {
    /**
     * 
     * @type {NewDiseaseTranslationsBody}
     * @memberof TranslationsApiDiseaseTranslations
     */
    readonly newDiseaseTranslationsBody: NewDiseaseTranslationsBody
}

/**
 * Request parameters for newLanguage operation in TranslationsApi.
 * @export
 * @interface TranslationsApiNewLanguageRequest
 */
export interface TranslationsApiNewLanguageRequest {
    /**
     * 
     * @type {NewLanguageBody}
     * @memberof TranslationsApiNewLanguage
     */
    readonly newLanguageBody: NewLanguageBody
}

/**
 * TranslationsApi - object-oriented interface
 * @export
 * @class TranslationsApi
 * @extends {BaseAPI}
 */
export class TranslationsApi extends BaseAPI {
    /**
     * 
     * @summary Create translations for a new language for all diseases
     * @param {TranslationsApiDiseaseTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationsApi
     */
    public diseaseTranslations(requestParameters: TranslationsApiDiseaseTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TranslationsApiFp(this.configuration).diseaseTranslations(requestParameters.newDiseaseTranslationsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create translations for a new language
     * @param {TranslationsApiNewLanguageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationsApi
     */
    public newLanguage(requestParameters: TranslationsApiNewLanguageRequest, options?: RawAxiosRequestConfig) {
        return TranslationsApiFp(this.configuration).newLanguage(requestParameters.newLanguageBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrialManagementApi - axios parameter creator
 * @export
 */
export const TrialManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add CT trial to platform
         * @param {string} id 
         * @param {TrialAddCTBody} trialAddCTBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCT: async (id: string, trialAddCTBody: TrialAddCTBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addCT', 'id', id)
            // verify required parameter 'trialAddCTBody' is not null or undefined
            assertParamExists('addCT', 'trialAddCTBody', trialAddCTBody)
            const localVarPath = `/trial-management/{id}/add-ct`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAddCTBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set the acceptance flow for a trial (all locations). A trial can have 1 effect and each of its locations can have 1 effect.
         * @param {string} id 
         * @param {TrialEffectBody} trialEffectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEffect: async (id: string, trialEffectBody: TrialEffectBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addEffect', 'id', id)
            // verify required parameter 'trialEffectBody' is not null or undefined
            assertParamExists('addEffect', 'trialEffectBody', trialEffectBody)
            const localVarPath = `/trial-management/{id}/effect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialEffectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary mark a trial as favorite
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addFavoriteTrial', 'id', id)
            const localVarPath = `/trial-management/{id}/favorite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a sponsor to a trial
         * @param {string} id 
         * @param {TrialAddSponsorBody} trialAddSponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSponsor: async (id: string, trialAddSponsorBody: TrialAddSponsorBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addSponsor', 'id', id)
            // verify required parameter 'trialAddSponsorBody' is not null or undefined
            assertParamExists('addSponsor', 'trialAddSponsorBody', trialAddSponsorBody)
            const localVarPath = `/trial-management/{id}/sponsor`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAddSponsorBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Non-production only. Fast-forward an enrolled patient to their next milestone (backdates enrollment and fires the milestone email). Used by QA to walk the companion flow without waiting real days.
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advanceMilestone: async (id: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('advanceMilestone', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('advanceMilestone', 'userId', userId)
            const localVarPath = `/trial-management/{id}/volunteers/{userId}/advance-milestone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set mandate status to paid
         * @param {string} id 
         * @param {AssignMandateBody} assignMandateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMandate: async (id: string, assignMandateBody: AssignMandateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignMandate', 'id', id)
            // verify required parameter 'assignMandateBody' is not null or undefined
            assertParamExists('assignMandate', 'assignMandateBody', assignMandateBody)
            const localVarPath = `/trial-management/{id}/mandate/assign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignMandateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set a trial to the completed status to stop recruitment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeTrial', 'id', id)
            const localVarPath = `/trial-management/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a comment to a trial
         * @param {string} id 
         * @param {TrialCommentBody} trialCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment: async (id: string, trialCommentBody: TrialCommentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createComment', 'id', id)
            // verify required parameter 'trialCommentBody' is not null or undefined
            assertParamExists('createComment', 'trialCommentBody', trialCommentBody)
            const localVarPath = `/trial-management/{id}/comment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialCommentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a contact to a trial
         * @param {string} id 
         * @param {TrialContactBody} trialContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (id: string, trialContactBody: TrialContactBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createContact', 'id', id)
            // verify required parameter 'trialContactBody' is not null or undefined
            assertParamExists('createContact', 'trialContactBody', trialContactBody)
            const localVarPath = `/trial-management/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialContactBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a criteria
         * @param {string} id 
         * @param {TrialCriteriaBody} trialCriteriaBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCriteria: async (id: string, trialCriteriaBody: TrialCriteriaBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createCriteria', 'id', id)
            // verify required parameter 'trialCriteriaBody' is not null or undefined
            assertParamExists('createCriteria', 'trialCriteriaBody', trialCriteriaBody)
            const localVarPath = `/trial-management/{id}/criteria`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialCriteriaBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a location to a trial
         * @param {string} id 
         * @param {TrialLocationBody} trialLocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation: async (id: string, trialLocationBody: TrialLocationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createLocation', 'id', id)
            // verify required parameter 'trialLocationBody' is not null or undefined
            assertParamExists('createLocation', 'trialLocationBody', trialLocationBody)
            const localVarPath = `/trial-management/{id}/location`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialLocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new milestone for a trial
         * @param {string} id 
         * @param {TrialMilestoneBody} trialMilestoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMilestone: async (id: string, trialMilestoneBody: TrialMilestoneBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createMilestone', 'id', id)
            // verify required parameter 'trialMilestoneBody' is not null or undefined
            assertParamExists('createMilestone', 'trialMilestoneBody', trialMilestoneBody)
            const localVarPath = `/trial-management/{id}/milestone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialMilestoneBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {string} id 
         * @param {TrialTranslationBody} trialTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryTranslations: async (id: string, trialTranslationBody: TrialTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSummaryTranslations', 'id', id)
            // verify required parameter 'trialTranslationBody' is not null or undefined
            assertParamExists('createSummaryTranslations', 'trialTranslationBody', trialTranslationBody)
            const localVarPath = `/trial-management/{id}/translations:summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {string} id 
         * @param {TrialTranslationBody} trialTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTitleTranslations: async (id: string, trialTranslationBody: TrialTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTitleTranslations', 'id', id)
            // verify required parameter 'trialTranslationBody' is not null or undefined
            assertParamExists('createTitleTranslations', 'trialTranslationBody', trialTranslationBody)
            const localVarPath = `/trial-management/{id}/translations:title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new trial
         * @param {TrialCreateBody} trialCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrial: async (trialCreateBody: TrialCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialCreateBody' is not null or undefined
            assertParamExists('createTrial', 'trialCreateBody', trialCreateBody)
            const localVarPath = `/trial-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary unmark a trial as favorite
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFavoriteTrial', 'id', id)
            const localVarPath = `/trial-management/{id}/favorite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a sponsor from a trial
         * @param {string} id 
         * @param {TrialDeleteSponsorBody} trialDeleteSponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSponsor: async (id: string, trialDeleteSponsorBody: TrialDeleteSponsorBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSponsor', 'id', id)
            // verify required parameter 'trialDeleteSponsorBody' is not null or undefined
            assertParamExists('deleteSponsor', 'trialDeleteSponsorBody', trialDeleteSponsorBody)
            const localVarPath = `/trial-management/{id}/sponsor`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialDeleteSponsorBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary soft delete a trial, it will be restorable for 30 days
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTrial', 'id', id)
            const localVarPath = `/trial-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of patients willing to participate in a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {TrialAcceptedOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [locationId] 
         * @param {string} [cohortId] Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
         * @param {string} [postalCode] 
         * @param {boolean | null} [onlyActiveLocations] 
         * @param {boolean | null} [includePending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccepted: async (id: string, limit?: number | null, offset?: number | null, orderBy?: TrialAcceptedOrderBy, orderDirection?: OrderDirection, locationId?: string, cohortId?: string, postalCode?: string, onlyActiveLocations?: boolean | null, includePending?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccepted', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/accepted`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (cohortId !== undefined) {
                localVarQueryParameter['cohortId'] = cohortId;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postalCode'] = postalCode;
            }

            if (onlyActiveLocations !== undefined) {
                localVarQueryParameter['onlyActiveLocations'] = onlyActiveLocations;
            }

            if (includePending !== undefined) {
                localVarQueryParameter['includePending'] = includePending;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActivity', 'id', id)
            const localVarPath = `/trial-management/{id}/activity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the atomic criteria of a specific trial with their questions and cohorts
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAtomicCriteria: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAtomicCriteria', 'id', id)
            const localVarPath = `/trial-management/{id}/criteria/atomic`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacts: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContacts', 'id', id)
            const localVarPath = `/trial-management/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of criteria of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteria: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCriteria', 'id', id)
            const localVarPath = `/trial-management/{id}/criteria`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get how the pre-screening patients of a specific trial stand on each of its predicates
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteriaAnswerCounts: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCriteriaAnswerCounts', 'id', id)
            const localVarPath = `/trial-management/{id}/criteria/answer-counts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDetails', 'id', id)
            const localVarPath = `/trial-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of the userIds that are enrolled in a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {TrialEnrolledOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string | null} [locationId] 
         * @param {string} [cohortId] Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
         * @param {string} [milestoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrolled: async (id: string, limit?: number | null, offset?: number | null, orderBy?: TrialEnrolledOrderBy, orderDirection?: OrderDirection, locationId?: string | null, cohortId?: string, milestoneId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnrolled', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/enrolled`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (cohortId !== undefined) {
                localVarQueryParameter['cohortId'] = cohortId;
            }

            if (milestoneId !== undefined) {
                localVarQueryParameter['milestoneId'] = milestoneId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all lead sponsors of the trials
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSponsors: async (limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trial-management/lead-sponsors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the countries of the locations of a specific trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationCountries: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocationCountries', 'id', id)
            const localVarPath = `/trial-management/{id}/location/countries`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the locations of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {LocationRecruitmentStatus} [status] 
         * @param {AcceptanceFlow} [flow] 
         * @param {string} [country] 
         * @param {string} [facility] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (id: string, limit?: number | null, offset?: number | null, status?: LocationRecruitmentStatus, flow?: AcceptanceFlow, country?: string, facility?: string, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocations', 'id', id)
            const localVarPath = `/trial-management/{id}/location`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (flow !== undefined) {
                localVarQueryParameter['flow'] = flow;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (facility !== undefined) {
                localVarQueryParameter['facility'] = facility;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of the userIds that fully matched a trial
         * @param {string} id 
         * @param {boolean | null} showDetails 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {TrialVolunteersOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string | null} [locationId] 
         * @param {string} [cohortId] Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
         * @param {string} [country] 
         * @param {string} [postalCode] 
         * @param {boolean | null} [fromAbroad] True keeps the patients matched at a site outside their own country, false the others.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatches: async (id: string, showDetails: boolean | null, limit?: number | null, offset?: number | null, orderBy?: TrialVolunteersOrderBy, orderDirection?: OrderDirection, locationId?: string | null, cohortId?: string, country?: string, postalCode?: string, fromAbroad?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMatches', 'id', id)
            // verify required parameter 'showDetails' is not null or undefined
            assertParamExists('getMatches', 'showDetails', showDetails)
            const localVarPath = `/trial-management/{id}/volunteers/matches`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (cohortId !== undefined) {
                localVarQueryParameter['cohortId'] = cohortId;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postalCode'] = postalCode;
            }

            if (fromAbroad !== undefined) {
                localVarQueryParameter['fromAbroad'] = fromAbroad;
            }

            if (showDetails !== undefined) {
                localVarQueryParameter['showDetails'] = showDetails;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get or create milestone enrollment token for trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMilestoneToken: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMilestoneToken', 'id', id)
            const localVarPath = `/trial-management/{id}/milestone-token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get milestones for a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMilestones: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMilestones', 'id', id)
            const localVarPath = `/trial-management/{id}/milestone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get pending location changes for a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PendingLocationChangeStatus} [status] 
         * @param {PendingLocationChangesOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingLocationChanges: async (id: string, limit?: number | null, offset?: number | null, status?: PendingLocationChangeStatus, orderBy?: PendingLocationChangesOrderBy, orderDirection?: OrderDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPendingLocationChanges', 'id', id)
            const localVarPath = `/trial-management/{id}/pending-location-changes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the list of public recruitment locations for a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicLocations: async (id: string, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPublicLocations', 'id', id)
            const localVarPath = `/trial-management/{id}/location/public`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get public details required for requesting access to a trial.
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicTrials: async (limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trial-management/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSummaryTranslations', 'id', id)
            const localVarPath = `/trial-management/{id}/translations:summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get information on mandates of a team
         * @param {string} teamId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMandates: async (teamId: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamMandates', 'teamId', teamId)
            const localVarPath = `/trial-management/team-mandates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the teams for a trial
         * @param {string} id 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams: async (id: string, limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeams', 'id', id)
            const localVarPath = `/trial-management/{id}/teams`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTitleTranslations', 'id', id)
            const localVarPath = `/trial-management/{id}/translations:title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of activities on a funnel page
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [researcherId] 
         * @param {string | null} [start] 
         * @param {string | null} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerActivity: async (id: string, limit?: number | null, offset?: number | null, researcherId?: string | null, start?: string | null, end?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteerActivity', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/activity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (researcherId !== undefined) {
                localVarQueryParameter['researcherId'] = researcherId;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of the users that can be filtered on in the funnel activity list
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerActivityUsers: async (id: string, limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteerActivityUsers', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/activity/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the answers of a volunteer for a specific volunteer
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {OrderDirection} [order] 
         * @param {UserTrialStatus} [status] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerAnswers: async (id: string, limit?: number | null, offset?: number | null, order?: OrderDirection, status?: UserTrialStatus, userId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteerAnswers', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/answers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the contact details of a volunteer of a specific trial
         * @param {string} id 
         * @param {string} userId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerContact: async (id: string, userId: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteerContact', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getVolunteerContact', 'userId', userId)
            const localVarPath = `/trial-management/{id}/volunteers/{userId}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the overview of volunteers of a specific trial
         * @param {string} id 
         * @param {string | null} [locationId] 
         * @param {string} [cohortId] Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteersOverview: async (id: string, locationId?: string | null, cohortId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteersOverview', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/overview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (cohortId !== undefined) {
                localVarQueryParameter['cohortId'] = cohortId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recalculate the cache of a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculate: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('recalculate', 'userId', userId)
            const localVarPath = `/trial-management/user/{userId}/cache`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recalculate the cache of many users in the background
         * @param {UsersCacheRegenerationBody} usersCacheRegenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateMany: async (usersCacheRegenerationBody: UsersCacheRegenerationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usersCacheRegenerationBody' is not null or undefined
            assertParamExists('recalculateMany', 'usersCacheRegenerationBody', usersCacheRegenerationBody)
            const localVarPath = `/trial-management/users/cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersCacheRegenerationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reset the acceptance flow for the trial to the default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEffect: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEffect', 'id', id)
            const localVarPath = `/trial-management/{id}/effect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To be used in dev only. Remove user trials which were synced from prod to dev
         * @param {string} id 
         * @param {RemoveProdUsersBody} removeProdUsersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProdUsers: async (id: string, removeProdUsersBody: RemoveProdUsersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeProdUsers', 'id', id)
            // verify required parameter 'removeProdUsersBody' is not null or undefined
            assertParamExists('removeProdUsers', 'removeProdUsersBody', removeProdUsersBody)
            const localVarPath = `/trial-management/{id}/remove-prod-users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeProdUsersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request a booster for a trial
         * @param {string} id 
         * @param {TrialBoosterBody} trialBoosterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestBooster: async (id: string, trialBoosterBody: TrialBoosterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('requestBooster', 'id', id)
            // verify required parameter 'trialBoosterBody' is not null or undefined
            assertParamExists('requestBooster', 'trialBoosterBody', trialBoosterBody)
            const localVarPath = `/trial-management/{id}/booster`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialBoosterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request a new criteria for a trial
         * @param {string} id 
         * @param {CriteriaRequestBody} criteriaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCriteria: async (id: string, criteriaRequestBody: CriteriaRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('requestCriteria', 'id', id)
            // verify required parameter 'criteriaRequestBody' is not null or undefined
            assertParamExists('requestCriteria', 'criteriaRequestBody', criteriaRequestBody)
            const localVarPath = `/trial-management/{id}/request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Regenerate user trial cache. After changes are made to a trial this endpoint makes sure that the user cache is updated.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetTrialCache: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetTrialCache', 'id', id)
            const localVarPath = `/trial-management/{id}/cache`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the status of a user in a trial
         * @param {string} id 
         * @param {string} userId 
         * @param {TrialVolunteerFeedbackBody} trialVolunteerFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToVolunteer: async (id: string, userId: string, trialVolunteerFeedbackBody: TrialVolunteerFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('respondToVolunteer', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('respondToVolunteer', 'userId', userId)
            // verify required parameter 'trialVolunteerFeedbackBody' is not null or undefined
            assertParamExists('respondToVolunteer', 'trialVolunteerFeedbackBody', trialVolunteerFeedbackBody)
            const localVarPath = `/trial-management/{id}/volunteers/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialVolunteerFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary restore a deleted trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreTrial', 'id', id)
            const localVarPath = `/trial-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all trials, paginated, searchable. If a user can only see a limited number of trials, then only those are returned.
         * @param {GetTrialsBody} getTrialsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (getTrialsBody: GetTrialsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getTrialsBody' is not null or undefined
            assertParamExists('search', 'getTrialsBody', getTrialsBody)
            const localVarPath = `/trial-management/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTrialsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary switch atomic criteria of a specific trial off or on for matching and the eligibility chat
         * @param {string} id 
         * @param {TrialAtomicCriteriaActivationBody} trialAtomicCriteriaActivationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAtomicCriteriaActivation: async (id: string, trialAtomicCriteriaActivationBody: TrialAtomicCriteriaActivationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setAtomicCriteriaActivation', 'id', id)
            // verify required parameter 'trialAtomicCriteriaActivationBody' is not null or undefined
            assertParamExists('setAtomicCriteriaActivation', 'trialAtomicCriteriaActivationBody', trialAtomicCriteriaActivationBody)
            const localVarPath = `/trial-management/{id}/criteria/atomic/activation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAtomicCriteriaActivationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set whether patients join the Companion program only by invitation
         * @param {string} id 
         * @param {TrialCompanionInviteOnlyBody} trialCompanionInviteOnlyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCompanionInviteOnly: async (id: string, trialCompanionInviteOnlyBody: TrialCompanionInviteOnlyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setCompanionInviteOnly', 'id', id)
            // verify required parameter 'trialCompanionInviteOnlyBody' is not null or undefined
            assertParamExists('setCompanionInviteOnly', 'trialCompanionInviteOnlyBody', trialCompanionInviteOnlyBody)
            const localVarPath = `/trial-management/{id}/companion-invite-only`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialCompanionInviteOnlyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set skipLocationSync value for a trial
         * @param {string} id 
         * @param {TrialSkipLocationSyncBody} trialSkipLocationSyncBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSkipLocationSync: async (id: string, trialSkipLocationSyncBody: TrialSkipLocationSyncBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setSkipLocationSync', 'id', id)
            // verify required parameter 'trialSkipLocationSyncBody' is not null or undefined
            assertParamExists('setSkipLocationSync', 'trialSkipLocationSyncBody', trialSkipLocationSyncBody)
            const localVarPath = `/trial-management/{id}/skip-location-sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialSkipLocationSyncBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary suggest to Curewiki a change to an atomic criterion of a specific trial
         * @param {string} id 
         * @param {string} predicateId 
         * @param {TrialAtomicCriterionSuggestionBody} trialAtomicCriterionSuggestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestAtomicCriterionChange: async (id: string, predicateId: string, trialAtomicCriterionSuggestionBody: TrialAtomicCriterionSuggestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('suggestAtomicCriterionChange', 'id', id)
            // verify required parameter 'predicateId' is not null or undefined
            assertParamExists('suggestAtomicCriterionChange', 'predicateId', predicateId)
            // verify required parameter 'trialAtomicCriterionSuggestionBody' is not null or undefined
            assertParamExists('suggestAtomicCriterionChange', 'trialAtomicCriterionSuggestionBody', trialAtomicCriterionSuggestionBody)
            const localVarPath = `/trial-management/{id}/criteria/atomic/{predicateId}/suggestion`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"predicateId"}}`, encodeURIComponent(String(predicateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAtomicCriterionSuggestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set mandate status to active (unpaid)
         * @param {string} id 
         * @param {UnassignMandateBody} unassignMandateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMandate: async (id: string, unassignMandateBody: UnassignMandateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unassignMandate', 'id', id)
            // verify required parameter 'unassignMandateBody' is not null or undefined
            assertParamExists('unassignMandate', 'unassignMandateBody', unassignMandateBody)
            const localVarPath = `/trial-management/{id}/mandate/unassign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unassignMandateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a trial
         * @param {string} id 
         * @param {UpdateTrialBody} updateTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrial: async (id: string, updateTrialBody: UpdateTrialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTrial', 'id', id)
            // verify required parameter 'updateTrialBody' is not null or undefined
            assertParamExists('updateTrial', 'updateTrialBody', updateTrialBody)
            const localVarPath = `/trial-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user trial locations from old to new location
         * @param {string} id 
         * @param {UpdateUserTrialLocationBody} updateUserTrialLocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTrialLocation: async (id: string, updateUserTrialLocationBody: UpdateUserTrialLocationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserTrialLocation', 'id', id)
            // verify required parameter 'updateUserTrialLocationBody' is not null or undefined
            assertParamExists('updateUserTrialLocation', 'updateUserTrialLocationBody', updateUserTrialLocationBody)
            const localVarPath = `/trial-management/{id}/user-trials/location`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserTrialLocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary indicate the contact date of a  volunteer
         * @param {string} id 
         * @param {string} userId 
         * @param {TrialVolunteerContactBody} trialVolunteerContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVolunteerContacted: async (id: string, userId: string, trialVolunteerContactBody: TrialVolunteerContactBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVolunteerContacted', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateVolunteerContacted', 'userId', userId)
            // verify required parameter 'trialVolunteerContactBody' is not null or undefined
            assertParamExists('updateVolunteerContacted', 'trialVolunteerContactBody', trialVolunteerContactBody)
            const localVarPath = `/trial-management/{id}/volunteers/{userId}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialVolunteerContactBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary validate all properties of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAll: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validateAll', 'id', id)
            const localVarPath = `/trial-management/{id}/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reach out to eligible patients for a trial
         * @param {string} id 
         * @param {TrialReachOutBody} trialReachOutBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        volunteerReachOut: async (id: string, trialReachOutBody: TrialReachOutBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('volunteerReachOut', 'id', id)
            // verify required parameter 'trialReachOutBody' is not null or undefined
            assertParamExists('volunteerReachOut', 'trialReachOutBody', trialReachOutBody)
            const localVarPath = `/trial-management/{id}/reach-out`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialReachOutBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrialManagementApi - functional programming interface
 * @export
 */
export const TrialManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrialManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add CT trial to platform
         * @param {string} id 
         * @param {TrialAddCTBody} trialAddCTBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCT(id: string, trialAddCTBody: TrialAddCTBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCT(id, trialAddCTBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.addCT']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary set the acceptance flow for a trial (all locations). A trial can have 1 effect and each of its locations can have 1 effect.
         * @param {string} id 
         * @param {TrialEffectBody} trialEffectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEffect(id: string, trialEffectBody: TrialEffectBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEffect(id, trialEffectBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.addEffect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary mark a trial as favorite
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFavoriteTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFavoriteTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.addFavoriteTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a sponsor to a trial
         * @param {string} id 
         * @param {TrialAddSponsorBody} trialAddSponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSponsor(id: string, trialAddSponsorBody: TrialAddSponsorBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSponsor(id, trialAddSponsorBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.addSponsor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Non-production only. Fast-forward an enrolled patient to their next milestone (backdates enrollment and fires the milestone email). Used by QA to walk the companion flow without waiting real days.
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advanceMilestone(id: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvanceMilestoneView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advanceMilestone(id, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.advanceMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set mandate status to paid
         * @param {string} id 
         * @param {AssignMandateBody} assignMandateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignMandate(id: string, assignMandateBody: AssignMandateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignMandate(id, assignMandateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.assignMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary set a trial to the completed status to stop recruitment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.completeTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a comment to a trial
         * @param {string} id 
         * @param {TrialCommentBody} trialCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComment(id: string, trialCommentBody: TrialCommentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComment(id, trialCommentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a contact to a trial
         * @param {string} id 
         * @param {TrialContactBody} trialContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(id: string, trialContactBody: TrialContactBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(id, trialContactBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a criteria
         * @param {string} id 
         * @param {TrialCriteriaBody} trialCriteriaBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCriteria(id: string, trialCriteriaBody: TrialCriteriaBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCriteria(id, trialCriteriaBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a location to a trial
         * @param {string} id 
         * @param {TrialLocationBody} trialLocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocation(id: string, trialLocationBody: TrialLocationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocation(id, trialLocationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new milestone for a trial
         * @param {string} id 
         * @param {TrialMilestoneBody} trialMilestoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMilestone(id: string, trialMilestoneBody: TrialMilestoneBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilestoneView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMilestone(id, trialMilestoneBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {string} id 
         * @param {TrialTranslationBody} trialTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSummaryTranslations(id: string, trialTranslationBody: TrialTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSummaryTranslations(id, trialTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createSummaryTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {string} id 
         * @param {TrialTranslationBody} trialTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTitleTranslations(id: string, trialTranslationBody: TrialTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTitleTranslations(id, trialTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createTitleTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a new trial
         * @param {TrialCreateBody} trialCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrial(trialCreateBody: TrialCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrial(trialCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary unmark a trial as favorite
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFavoriteTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFavoriteTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.deleteFavoriteTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a sponsor from a trial
         * @param {string} id 
         * @param {TrialDeleteSponsorBody} trialDeleteSponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSponsor(id: string, trialDeleteSponsorBody: TrialDeleteSponsorBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSponsor(id, trialDeleteSponsorBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.deleteSponsor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary soft delete a trial, it will be restorable for 30 days
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.deleteTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of patients willing to participate in a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {TrialAcceptedOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [locationId] 
         * @param {string} [cohortId] Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
         * @param {string} [postalCode] 
         * @param {boolean | null} [onlyActiveLocations] 
         * @param {boolean | null} [includePending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccepted(id: string, limit?: number | null, offset?: number | null, orderBy?: TrialAcceptedOrderBy, orderDirection?: OrderDirection, locationId?: string, cohortId?: string, postalCode?: string, onlyActiveLocations?: boolean | null, includePending?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialAcceptedView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccepted(id, limit, offset, orderBy, orderDirection, locationId, cohortId, postalCode, onlyActiveLocations, includePending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getAccepted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivity(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivity(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the atomic criteria of a specific trial with their questions and cohorts
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAtomicCriteria(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialAtomicCriteriaView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAtomicCriteria(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getAtomicCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContacts(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialContactView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContacts(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of criteria of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCriteria(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialCriteriaView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCriteria(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get how the pre-screening patients of a specific trial stand on each of its predicates
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCriteriaAnswerCounts(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialCriteriaAnswerCountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCriteriaAnswerCounts(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getCriteriaAnswerCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of the userIds that are enrolled in a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {TrialEnrolledOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string | null} [locationId] 
         * @param {string} [cohortId] Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
         * @param {string} [milestoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnrolled(id: string, limit?: number | null, offset?: number | null, orderBy?: TrialEnrolledOrderBy, orderDirection?: OrderDirection, locationId?: string | null, cohortId?: string, milestoneId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialEnrolledView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnrolled(id, limit, offset, orderBy, orderDirection, locationId, cohortId, milestoneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getEnrolled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all lead sponsors of the trials
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeadSponsors(limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSponsorView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadSponsors(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getLeadSponsors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the countries of the locations of a specific trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationCountries(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialLocationCountriesView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationCountries(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getLocationCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the locations of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {LocationRecruitmentStatus} [status] 
         * @param {AcceptanceFlow} [flow] 
         * @param {string} [country] 
         * @param {string} [facility] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(id: string, limit?: number | null, offset?: number | null, status?: LocationRecruitmentStatus, flow?: AcceptanceFlow, country?: string, facility?: string, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(id, limit, offset, status, flow, country, facility, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of the userIds that fully matched a trial
         * @param {string} id 
         * @param {boolean | null} showDetails 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {TrialVolunteersOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string | null} [locationId] 
         * @param {string} [cohortId] Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
         * @param {string} [country] 
         * @param {string} [postalCode] 
         * @param {boolean | null} [fromAbroad] True keeps the patients matched at a site outside their own country, false the others.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatches(id: string, showDetails: boolean | null, limit?: number | null, offset?: number | null, orderBy?: TrialVolunteersOrderBy, orderDirection?: OrderDirection, locationId?: string | null, cohortId?: string, country?: string, postalCode?: string, fromAbroad?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialMatchView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatches(id, showDetails, limit, offset, orderBy, orderDirection, locationId, cohortId, country, postalCode, fromAbroad, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getMatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get or create milestone enrollment token for trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMilestoneToken(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilestoneTokenView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMilestoneToken(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getMilestoneToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get milestones for a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMilestones(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMilestoneListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMilestones(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getMilestones']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get pending location changes for a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {PendingLocationChangeStatus} [status] 
         * @param {PendingLocationChangesOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingLocationChanges(id: string, limit?: number | null, offset?: number | null, status?: PendingLocationChangeStatus, orderBy?: PendingLocationChangesOrderBy, orderDirection?: OrderDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPendingLocationChangeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingLocationChanges(id, limit, offset, status, orderBy, orderDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getPendingLocationChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the list of public recruitment locations for a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicLocations(id: string, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPublicLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicLocations(id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getPublicLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get public details required for requesting access to a trial.
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicTrials(limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialPublicView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicTrials(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getPublicTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getSummaryTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get information on mandates of a team
         * @param {string} teamId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamMandates(teamId: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMandatesListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamMandates(teamId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getTeamMandates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch the teams for a trial
         * @param {string} id 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeams(id: string, limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialTeamListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeams(id, limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTitleTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTitleTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getTitleTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of activities on a funnel page
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [researcherId] 
         * @param {string | null} [start] 
         * @param {string | null} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteerActivity(id: string, limit?: number | null, offset?: number | null, researcherId?: string | null, start?: string | null, end?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialVolunteerActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteerActivity(id, limit, offset, researcherId, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of the users that can be filtered on in the funnel activity list
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteerActivityUsers(id: string, limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialVolunteerActivityUsersView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteerActivityUsers(id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteerActivityUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the answers of a volunteer for a specific volunteer
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {OrderDirection} [order] 
         * @param {UserTrialStatus} [status] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteerAnswers(id: string, limit?: number | null, offset?: number | null, order?: OrderDirection, status?: UserTrialStatus, userId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialVolunteerAnswersListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteerAnswers(id, limit, offset, order, status, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteerAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the contact details of a volunteer of a specific trial
         * @param {string} id 
         * @param {string} userId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteerContact(id: string, userId: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialVolunteerContactView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteerContact(id, userId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the overview of volunteers of a specific trial
         * @param {string} id 
         * @param {string | null} [locationId] 
         * @param {string} [cohortId] Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteersOverview(id: string, locationId?: string | null, cohortId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialVolunteersOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteersOverview(id, locationId, cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteersOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recalculate the cache of a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculate(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculate(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.recalculate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recalculate the cache of many users in the background
         * @param {UsersCacheRegenerationBody} usersCacheRegenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculateMany(usersCacheRegenerationBody: UsersCacheRegenerationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculateMany(usersCacheRegenerationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.recalculateMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reset the acceptance flow for the trial to the default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEffect(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEffect(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.removeEffect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To be used in dev only. Remove user trials which were synced from prod to dev
         * @param {string} id 
         * @param {RemoveProdUsersBody} removeProdUsersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeProdUsers(id: string, removeProdUsersBody: RemoveProdUsersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeProdUsers(id, removeProdUsersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.removeProdUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary request a booster for a trial
         * @param {string} id 
         * @param {TrialBoosterBody} trialBoosterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestBooster(id: string, trialBoosterBody: TrialBoosterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestBooster(id, trialBoosterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.requestBooster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary request a new criteria for a trial
         * @param {string} id 
         * @param {CriteriaRequestBody} criteriaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestCriteria(id: string, criteriaRequestBody: CriteriaRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestCriteria(id, criteriaRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.requestCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Regenerate user trial cache. After changes are made to a trial this endpoint makes sure that the user cache is updated.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetTrialCache(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetTrialCache(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.resetTrialCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the status of a user in a trial
         * @param {string} id 
         * @param {string} userId 
         * @param {TrialVolunteerFeedbackBody} trialVolunteerFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondToVolunteer(id: string, userId: string, trialVolunteerFeedbackBody: TrialVolunteerFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondToVolunteer(id, userId, trialVolunteerFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.respondToVolunteer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary restore a deleted trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.restoreTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all trials, paginated, searchable. If a user can only see a limited number of trials, then only those are returned.
         * @param {GetTrialsBody} getTrialsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(getTrialsBody: GetTrialsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(getTrialsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary switch atomic criteria of a specific trial off or on for matching and the eligibility chat
         * @param {string} id 
         * @param {TrialAtomicCriteriaActivationBody} trialAtomicCriteriaActivationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAtomicCriteriaActivation(id: string, trialAtomicCriteriaActivationBody: TrialAtomicCriteriaActivationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialAtomicPredicateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAtomicCriteriaActivation(id, trialAtomicCriteriaActivationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.setAtomicCriteriaActivation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set whether patients join the Companion program only by invitation
         * @param {string} id 
         * @param {TrialCompanionInviteOnlyBody} trialCompanionInviteOnlyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCompanionInviteOnly(id: string, trialCompanionInviteOnlyBody: TrialCompanionInviteOnlyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCompanionInviteOnly(id, trialCompanionInviteOnlyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.setCompanionInviteOnly']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set skipLocationSync value for a trial
         * @param {string} id 
         * @param {TrialSkipLocationSyncBody} trialSkipLocationSyncBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSkipLocationSync(id: string, trialSkipLocationSyncBody: TrialSkipLocationSyncBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSkipLocationSync(id, trialSkipLocationSyncBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.setSkipLocationSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary suggest to Curewiki a change to an atomic criterion of a specific trial
         * @param {string} id 
         * @param {string} predicateId 
         * @param {TrialAtomicCriterionSuggestionBody} trialAtomicCriterionSuggestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestAtomicCriterionChange(id: string, predicateId: string, trialAtomicCriterionSuggestionBody: TrialAtomicCriterionSuggestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestAtomicCriterionChange(id, predicateId, trialAtomicCriterionSuggestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.suggestAtomicCriterionChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set mandate status to active (unpaid)
         * @param {string} id 
         * @param {UnassignMandateBody} unassignMandateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignMandate(id: string, unassignMandateBody: UnassignMandateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignMandate(id, unassignMandateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.unassignMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a trial
         * @param {string} id 
         * @param {UpdateTrialBody} updateTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrial(id: string, updateTrialBody: UpdateTrialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrial(id, updateTrialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.updateTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user trial locations from old to new location
         * @param {string} id 
         * @param {UpdateUserTrialLocationBody} updateUserTrialLocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserTrialLocation(id: string, updateUserTrialLocationBody: UpdateUserTrialLocationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserTrialLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserTrialLocation(id, updateUserTrialLocationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.updateUserTrialLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary indicate the contact date of a  volunteer
         * @param {string} id 
         * @param {string} userId 
         * @param {TrialVolunteerContactBody} trialVolunteerContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVolunteerContacted(id: string, userId: string, trialVolunteerContactBody: TrialVolunteerContactBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVolunteerContacted(id, userId, trialVolunteerContactBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.updateVolunteerContacted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary validate all properties of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAll(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAll(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.validateAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reach out to eligible patients for a trial
         * @param {string} id 
         * @param {TrialReachOutBody} trialReachOutBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async volunteerReachOut(id: string, trialReachOutBody: TrialReachOutBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialReachOutView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.volunteerReachOut(id, trialReachOutBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.volunteerReachOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrialManagementApi - factory interface
 * @export
 */
export const TrialManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrialManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary add CT trial to platform
         * @param {TrialManagementApiAddCTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCT(requestParameters: TrialManagementApiAddCTRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCT(requestParameters.id, requestParameters.trialAddCTBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set the acceptance flow for a trial (all locations). A trial can have 1 effect and each of its locations can have 1 effect.
         * @param {TrialManagementApiAddEffectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEffect(requestParameters: TrialManagementApiAddEffectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addEffect(requestParameters.id, requestParameters.trialEffectBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary mark a trial as favorite
         * @param {TrialManagementApiAddFavoriteTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteTrial(requestParameters: TrialManagementApiAddFavoriteTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addFavoriteTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a sponsor to a trial
         * @param {TrialManagementApiAddSponsorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSponsor(requestParameters: TrialManagementApiAddSponsorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSponsor(requestParameters.id, requestParameters.trialAddSponsorBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Non-production only. Fast-forward an enrolled patient to their next milestone (backdates enrollment and fires the milestone email). Used by QA to walk the companion flow without waiting real days.
         * @param {TrialManagementApiAdvanceMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advanceMilestone(requestParameters: TrialManagementApiAdvanceMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdvanceMilestoneView> {
            return localVarFp.advanceMilestone(requestParameters.id, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set mandate status to paid
         * @param {TrialManagementApiAssignMandateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMandate(requestParameters: TrialManagementApiAssignMandateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignMandate(requestParameters.id, requestParameters.assignMandateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set a trial to the completed status to stop recruitment
         * @param {TrialManagementApiCompleteTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeTrial(requestParameters: TrialManagementApiCompleteTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.completeTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a comment to a trial
         * @param {TrialManagementApiCreateCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(requestParameters: TrialManagementApiCreateCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createComment(requestParameters.id, requestParameters.trialCommentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a contact to a trial
         * @param {TrialManagementApiCreateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(requestParameters: TrialManagementApiCreateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createContact(requestParameters.id, requestParameters.trialContactBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a criteria
         * @param {TrialManagementApiCreateCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCriteria(requestParameters: TrialManagementApiCreateCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCriteria(requestParameters.id, requestParameters.trialCriteriaBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a location to a trial
         * @param {TrialManagementApiCreateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation(requestParameters: TrialManagementApiCreateLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationView> {
            return localVarFp.createLocation(requestParameters.id, requestParameters.trialLocationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new milestone for a trial
         * @param {TrialManagementApiCreateMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMilestone(requestParameters: TrialManagementApiCreateMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<MilestoneView> {
            return localVarFp.createMilestone(requestParameters.id, requestParameters.trialMilestoneBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {TrialManagementApiCreateSummaryTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryTranslations(requestParameters: TrialManagementApiCreateSummaryTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialTranslationView> {
            return localVarFp.createSummaryTranslations(requestParameters.id, requestParameters.trialTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {TrialManagementApiCreateTitleTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTitleTranslations(requestParameters: TrialManagementApiCreateTitleTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialTranslationView> {
            return localVarFp.createTitleTranslations(requestParameters.id, requestParameters.trialTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new trial
         * @param {TrialManagementApiCreateTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrial(requestParameters: TrialManagementApiCreateTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialView> {
            return localVarFp.createTrial(requestParameters.trialCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary unmark a trial as favorite
         * @param {TrialManagementApiDeleteFavoriteTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteTrial(requestParameters: TrialManagementApiDeleteFavoriteTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFavoriteTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a sponsor from a trial
         * @param {TrialManagementApiDeleteSponsorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSponsor(requestParameters: TrialManagementApiDeleteSponsorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSponsor(requestParameters.id, requestParameters.trialDeleteSponsorBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary soft delete a trial, it will be restorable for 30 days
         * @param {TrialManagementApiDeleteTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrial(requestParameters: TrialManagementApiDeleteTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of patients willing to participate in a trial
         * @param {TrialManagementApiGetAcceptedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccepted(requestParameters: TrialManagementApiGetAcceptedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialAcceptedView> {
            return localVarFp.getAccepted(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.locationId, requestParameters.cohortId, requestParameters.postalCode, requestParameters.onlyActiveLocations, requestParameters.includePending, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {TrialManagementApiGetActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(requestParameters: TrialManagementApiGetActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialActivityView> {
            return localVarFp.getActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the atomic criteria of a specific trial with their questions and cohorts
         * @param {TrialManagementApiGetAtomicCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAtomicCriteria(requestParameters: TrialManagementApiGetAtomicCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialAtomicCriteriaView> {
            return localVarFp.getAtomicCriteria(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {TrialManagementApiGetContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacts(requestParameters: TrialManagementApiGetContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialContactView> {
            return localVarFp.getContacts(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of criteria of a specific trial
         * @param {TrialManagementApiGetCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteria(requestParameters: TrialManagementApiGetCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialCriteriaView> {
            return localVarFp.getCriteria(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get how the pre-screening patients of a specific trial stand on each of its predicates
         * @param {TrialManagementApiGetCriteriaAnswerCountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteriaAnswerCounts(requestParameters: TrialManagementApiGetCriteriaAnswerCountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialCriteriaAnswerCountsView> {
            return localVarFp.getCriteriaAnswerCounts(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {TrialManagementApiGetDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails(requestParameters: TrialManagementApiGetDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialDetailsView> {
            return localVarFp.getDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of the userIds that are enrolled in a trial
         * @param {TrialManagementApiGetEnrolledRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrolled(requestParameters: TrialManagementApiGetEnrolledRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialEnrolledView> {
            return localVarFp.getEnrolled(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.locationId, requestParameters.cohortId, requestParameters.milestoneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all lead sponsors of the trials
         * @param {TrialManagementApiGetLeadSponsorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSponsors(requestParameters: TrialManagementApiGetLeadSponsorsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSponsorView> {
            return localVarFp.getLeadSponsors(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the countries of the locations of a specific trial
         * @param {TrialManagementApiGetLocationCountriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationCountries(requestParameters: TrialManagementApiGetLocationCountriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialLocationCountriesView> {
            return localVarFp.getLocationCountries(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the locations of a specific trial
         * @param {TrialManagementApiGetLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(requestParameters: TrialManagementApiGetLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialLocationView> {
            return localVarFp.getLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.flow, requestParameters.country, requestParameters.facility, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of the userIds that fully matched a trial
         * @param {TrialManagementApiGetMatchesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatches(requestParameters: TrialManagementApiGetMatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialMatchView> {
            return localVarFp.getMatches(requestParameters.id, requestParameters.showDetails, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.locationId, requestParameters.cohortId, requestParameters.country, requestParameters.postalCode, requestParameters.fromAbroad, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get or create milestone enrollment token for trial
         * @param {TrialManagementApiGetMilestoneTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMilestoneToken(requestParameters: TrialManagementApiGetMilestoneTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<MilestoneTokenView> {
            return localVarFp.getMilestoneToken(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get milestones for a trial
         * @param {TrialManagementApiGetMilestonesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMilestones(requestParameters: TrialManagementApiGetMilestonesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListMilestoneListView> {
            return localVarFp.getMilestones(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get pending location changes for a trial
         * @param {TrialManagementApiGetPendingLocationChangesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingLocationChanges(requestParameters: TrialManagementApiGetPendingLocationChangesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPendingLocationChangeView> {
            return localVarFp.getPendingLocationChanges(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.orderBy, requestParameters.orderDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the list of public recruitment locations for a trial
         * @param {TrialManagementApiGetPublicLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicLocations(requestParameters: TrialManagementApiGetPublicLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPublicLocationView> {
            return localVarFp.getPublicLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get public details required for requesting access to a trial.
         * @param {TrialManagementApiGetPublicTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicTrials(requestParameters: TrialManagementApiGetPublicTrialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialPublicView> {
            return localVarFp.getPublicTrials(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {TrialManagementApiGetSummaryTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryTranslations(requestParameters: TrialManagementApiGetSummaryTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialTranslationView> {
            return localVarFp.getSummaryTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get information on mandates of a team
         * @param {TrialManagementApiGetTeamMandatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMandates(requestParameters: TrialManagementApiGetTeamMandatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMandatesListView> {
            return localVarFp.getTeamMandates(requestParameters.teamId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the teams for a trial
         * @param {TrialManagementApiGetTeamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams(requestParameters: TrialManagementApiGetTeamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialTeamListView> {
            return localVarFp.getTeams(requestParameters.id, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {TrialManagementApiGetTitleTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleTranslations(requestParameters: TrialManagementApiGetTitleTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialTranslationView> {
            return localVarFp.getTitleTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of activities on a funnel page
         * @param {TrialManagementApiGetVolunteerActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerActivity(requestParameters: TrialManagementApiGetVolunteerActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialVolunteerActivityView> {
            return localVarFp.getVolunteerActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.researcherId, requestParameters.start, requestParameters.end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of the users that can be filtered on in the funnel activity list
         * @param {TrialManagementApiGetVolunteerActivityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerActivityUsers(requestParameters: TrialManagementApiGetVolunteerActivityUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialVolunteerActivityUsersView> {
            return localVarFp.getVolunteerActivityUsers(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the answers of a volunteer for a specific volunteer
         * @param {TrialManagementApiGetVolunteerAnswersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerAnswers(requestParameters: TrialManagementApiGetVolunteerAnswersRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialVolunteerAnswersListView> {
            return localVarFp.getVolunteerAnswers(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.status, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the contact details of a volunteer of a specific trial
         * @param {TrialManagementApiGetVolunteerContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerContact(requestParameters: TrialManagementApiGetVolunteerContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialVolunteerContactView> {
            return localVarFp.getVolunteerContact(requestParameters.id, requestParameters.userId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the overview of volunteers of a specific trial
         * @param {TrialManagementApiGetVolunteersOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteersOverview(requestParameters: TrialManagementApiGetVolunteersOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialVolunteersOverviewView> {
            return localVarFp.getVolunteersOverview(requestParameters.id, requestParameters.locationId, requestParameters.cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recalculate the cache of a user
         * @param {TrialManagementApiRecalculateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculate(requestParameters: TrialManagementApiRecalculateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recalculate(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recalculate the cache of many users in the background
         * @param {TrialManagementApiRecalculateManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateMany(requestParameters: TrialManagementApiRecalculateManyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recalculateMany(requestParameters.usersCacheRegenerationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reset the acceptance flow for the trial to the default
         * @param {TrialManagementApiRemoveEffectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEffect(requestParameters: TrialManagementApiRemoveEffectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeEffect(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To be used in dev only. Remove user trials which were synced from prod to dev
         * @param {TrialManagementApiRemoveProdUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProdUsers(requestParameters: TrialManagementApiRemoveProdUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeProdUsers(requestParameters.id, requestParameters.removeProdUsersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request a booster for a trial
         * @param {TrialManagementApiRequestBoosterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestBooster(requestParameters: TrialManagementApiRequestBoosterRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestBooster(requestParameters.id, requestParameters.trialBoosterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request a new criteria for a trial
         * @param {TrialManagementApiRequestCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCriteria(requestParameters: TrialManagementApiRequestCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestCriteria(requestParameters.id, requestParameters.criteriaRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Regenerate user trial cache. After changes are made to a trial this endpoint makes sure that the user cache is updated.
         * @param {TrialManagementApiResetTrialCacheRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetTrialCache(requestParameters: TrialManagementApiResetTrialCacheRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetTrialCache(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the status of a user in a trial
         * @param {TrialManagementApiRespondToVolunteerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToVolunteer(requestParameters: TrialManagementApiRespondToVolunteerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.respondToVolunteer(requestParameters.id, requestParameters.userId, requestParameters.trialVolunteerFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary restore a deleted trial
         * @param {TrialManagementApiRestoreTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreTrial(requestParameters: TrialManagementApiRestoreTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all trials, paginated, searchable. If a user can only see a limited number of trials, then only those are returned.
         * @param {TrialManagementApiSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(requestParameters: TrialManagementApiSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialView> {
            return localVarFp.search(requestParameters.getTrialsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary switch atomic criteria of a specific trial off or on for matching and the eligibility chat
         * @param {TrialManagementApiSetAtomicCriteriaActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAtomicCriteriaActivation(requestParameters: TrialManagementApiSetAtomicCriteriaActivationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialAtomicPredicateView> {
            return localVarFp.setAtomicCriteriaActivation(requestParameters.id, requestParameters.trialAtomicCriteriaActivationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set whether patients join the Companion program only by invitation
         * @param {TrialManagementApiSetCompanionInviteOnlyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCompanionInviteOnly(requestParameters: TrialManagementApiSetCompanionInviteOnlyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setCompanionInviteOnly(requestParameters.id, requestParameters.trialCompanionInviteOnlyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set skipLocationSync value for a trial
         * @param {TrialManagementApiSetSkipLocationSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSkipLocationSync(requestParameters: TrialManagementApiSetSkipLocationSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setSkipLocationSync(requestParameters.id, requestParameters.trialSkipLocationSyncBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary suggest to Curewiki a change to an atomic criterion of a specific trial
         * @param {TrialManagementApiSuggestAtomicCriterionChangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestAtomicCriterionChange(requestParameters: TrialManagementApiSuggestAtomicCriterionChangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.suggestAtomicCriterionChange(requestParameters.id, requestParameters.predicateId, requestParameters.trialAtomicCriterionSuggestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set mandate status to active (unpaid)
         * @param {TrialManagementApiUnassignMandateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMandate(requestParameters: TrialManagementApiUnassignMandateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignMandate(requestParameters.id, requestParameters.unassignMandateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a trial
         * @param {TrialManagementApiUpdateTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrial(requestParameters: TrialManagementApiUpdateTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTrial(requestParameters.id, requestParameters.updateTrialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user trial locations from old to new location
         * @param {TrialManagementApiUpdateUserTrialLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTrialLocation(requestParameters: TrialManagementApiUpdateUserTrialLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUserTrialLocationView> {
            return localVarFp.updateUserTrialLocation(requestParameters.id, requestParameters.updateUserTrialLocationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary indicate the contact date of a  volunteer
         * @param {TrialManagementApiUpdateVolunteerContactedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVolunteerContacted(requestParameters: TrialManagementApiUpdateVolunteerContactedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateVolunteerContacted(requestParameters.id, requestParameters.userId, requestParameters.trialVolunteerContactBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary validate all properties of a trial
         * @param {TrialManagementApiValidateAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAll(requestParameters: TrialManagementApiValidateAllRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateAll(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reach out to eligible patients for a trial
         * @param {TrialManagementApiVolunteerReachOutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        volunteerReachOut(requestParameters: TrialManagementApiVolunteerReachOutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialReachOutView> {
            return localVarFp.volunteerReachOut(requestParameters.id, requestParameters.trialReachOutBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCT operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAddCTRequest
 */
export interface TrialManagementApiAddCTRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAddCT
     */
    readonly id: string

    /**
     * 
     * @type {TrialAddCTBody}
     * @memberof TrialManagementApiAddCT
     */
    readonly trialAddCTBody: TrialAddCTBody
}

/**
 * Request parameters for addEffect operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAddEffectRequest
 */
export interface TrialManagementApiAddEffectRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAddEffect
     */
    readonly id: string

    /**
     * 
     * @type {TrialEffectBody}
     * @memberof TrialManagementApiAddEffect
     */
    readonly trialEffectBody: TrialEffectBody
}

/**
 * Request parameters for addFavoriteTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAddFavoriteTrialRequest
 */
export interface TrialManagementApiAddFavoriteTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAddFavoriteTrial
     */
    readonly id: string
}

/**
 * Request parameters for addSponsor operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAddSponsorRequest
 */
export interface TrialManagementApiAddSponsorRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAddSponsor
     */
    readonly id: string

    /**
     * 
     * @type {TrialAddSponsorBody}
     * @memberof TrialManagementApiAddSponsor
     */
    readonly trialAddSponsorBody: TrialAddSponsorBody
}

/**
 * Request parameters for advanceMilestone operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAdvanceMilestoneRequest
 */
export interface TrialManagementApiAdvanceMilestoneRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAdvanceMilestone
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAdvanceMilestone
     */
    readonly userId: string
}

/**
 * Request parameters for assignMandate operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAssignMandateRequest
 */
export interface TrialManagementApiAssignMandateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAssignMandate
     */
    readonly id: string

    /**
     * 
     * @type {AssignMandateBody}
     * @memberof TrialManagementApiAssignMandate
     */
    readonly assignMandateBody: AssignMandateBody
}

/**
 * Request parameters for completeTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCompleteTrialRequest
 */
export interface TrialManagementApiCompleteTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCompleteTrial
     */
    readonly id: string
}

/**
 * Request parameters for createComment operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateCommentRequest
 */
export interface TrialManagementApiCreateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateComment
     */
    readonly id: string

    /**
     * 
     * @type {TrialCommentBody}
     * @memberof TrialManagementApiCreateComment
     */
    readonly trialCommentBody: TrialCommentBody
}

/**
 * Request parameters for createContact operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateContactRequest
 */
export interface TrialManagementApiCreateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateContact
     */
    readonly id: string

    /**
     * 
     * @type {TrialContactBody}
     * @memberof TrialManagementApiCreateContact
     */
    readonly trialContactBody: TrialContactBody
}

/**
 * Request parameters for createCriteria operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateCriteriaRequest
 */
export interface TrialManagementApiCreateCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateCriteria
     */
    readonly id: string

    /**
     * 
     * @type {TrialCriteriaBody}
     * @memberof TrialManagementApiCreateCriteria
     */
    readonly trialCriteriaBody: TrialCriteriaBody
}

/**
 * Request parameters for createLocation operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateLocationRequest
 */
export interface TrialManagementApiCreateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateLocation
     */
    readonly id: string

    /**
     * 
     * @type {TrialLocationBody}
     * @memberof TrialManagementApiCreateLocation
     */
    readonly trialLocationBody: TrialLocationBody
}

/**
 * Request parameters for createMilestone operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateMilestoneRequest
 */
export interface TrialManagementApiCreateMilestoneRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateMilestone
     */
    readonly id: string

    /**
     * 
     * @type {TrialMilestoneBody}
     * @memberof TrialManagementApiCreateMilestone
     */
    readonly trialMilestoneBody: TrialMilestoneBody
}

/**
 * Request parameters for createSummaryTranslations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateSummaryTranslationsRequest
 */
export interface TrialManagementApiCreateSummaryTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateSummaryTranslations
     */
    readonly id: string

    /**
     * 
     * @type {TrialTranslationBody}
     * @memberof TrialManagementApiCreateSummaryTranslations
     */
    readonly trialTranslationBody: TrialTranslationBody
}

/**
 * Request parameters for createTitleTranslations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateTitleTranslationsRequest
 */
export interface TrialManagementApiCreateTitleTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateTitleTranslations
     */
    readonly id: string

    /**
     * 
     * @type {TrialTranslationBody}
     * @memberof TrialManagementApiCreateTitleTranslations
     */
    readonly trialTranslationBody: TrialTranslationBody
}

/**
 * Request parameters for createTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateTrialRequest
 */
export interface TrialManagementApiCreateTrialRequest {
    /**
     * 
     * @type {TrialCreateBody}
     * @memberof TrialManagementApiCreateTrial
     */
    readonly trialCreateBody: TrialCreateBody
}

/**
 * Request parameters for deleteFavoriteTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiDeleteFavoriteTrialRequest
 */
export interface TrialManagementApiDeleteFavoriteTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiDeleteFavoriteTrial
     */
    readonly id: string
}

/**
 * Request parameters for deleteSponsor operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiDeleteSponsorRequest
 */
export interface TrialManagementApiDeleteSponsorRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiDeleteSponsor
     */
    readonly id: string

    /**
     * 
     * @type {TrialDeleteSponsorBody}
     * @memberof TrialManagementApiDeleteSponsor
     */
    readonly trialDeleteSponsorBody: TrialDeleteSponsorBody
}

/**
 * Request parameters for deleteTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiDeleteTrialRequest
 */
export interface TrialManagementApiDeleteTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiDeleteTrial
     */
    readonly id: string
}

/**
 * Request parameters for getAccepted operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetAcceptedRequest
 */
export interface TrialManagementApiGetAcceptedRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly offset?: number | null

    /**
     * 
     * @type {TrialAcceptedOrderBy}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly orderBy?: TrialAcceptedOrderBy

    /**
     * 
     * @type {OrderDirection}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly locationId?: string

    /**
     * Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
     * @type {string}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly cohortId?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly postalCode?: string

    /**
     * 
     * @type {boolean}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly onlyActiveLocations?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof TrialManagementApiGetAccepted
     */
    readonly includePending?: boolean | null
}

/**
 * Request parameters for getActivity operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetActivityRequest
 */
export interface TrialManagementApiGetActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetActivity
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetActivity
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetActivity
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getAtomicCriteria operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetAtomicCriteriaRequest
 */
export interface TrialManagementApiGetAtomicCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetAtomicCriteria
     */
    readonly id: string
}

/**
 * Request parameters for getContacts operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetContactsRequest
 */
export interface TrialManagementApiGetContactsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetContacts
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetContacts
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetContacts
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getCriteria operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetCriteriaRequest
 */
export interface TrialManagementApiGetCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetCriteria
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetCriteria
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetCriteria
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getCriteriaAnswerCounts operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetCriteriaAnswerCountsRequest
 */
export interface TrialManagementApiGetCriteriaAnswerCountsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetCriteriaAnswerCounts
     */
    readonly id: string
}

/**
 * Request parameters for getDetails operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetDetailsRequest
 */
export interface TrialManagementApiGetDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetDetails
     */
    readonly id: string
}

/**
 * Request parameters for getEnrolled operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetEnrolledRequest
 */
export interface TrialManagementApiGetEnrolledRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetEnrolled
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetEnrolled
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetEnrolled
     */
    readonly offset?: number | null

    /**
     * 
     * @type {TrialEnrolledOrderBy}
     * @memberof TrialManagementApiGetEnrolled
     */
    readonly orderBy?: TrialEnrolledOrderBy

    /**
     * 
     * @type {OrderDirection}
     * @memberof TrialManagementApiGetEnrolled
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetEnrolled
     */
    readonly locationId?: string | null

    /**
     * Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
     * @type {string}
     * @memberof TrialManagementApiGetEnrolled
     */
    readonly cohortId?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetEnrolled
     */
    readonly milestoneId?: string
}

/**
 * Request parameters for getLeadSponsors operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetLeadSponsorsRequest
 */
export interface TrialManagementApiGetLeadSponsorsRequest {
    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetLeadSponsors
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetLeadSponsors
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLeadSponsors
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for getLocationCountries operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetLocationCountriesRequest
 */
export interface TrialManagementApiGetLocationCountriesRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocationCountries
     */
    readonly id: string
}

/**
 * Request parameters for getLocations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetLocationsRequest
 */
export interface TrialManagementApiGetLocationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocations
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetLocations
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetLocations
     */
    readonly offset?: number | null

    /**
     * 
     * @type {LocationRecruitmentStatus}
     * @memberof TrialManagementApiGetLocations
     */
    readonly status?: LocationRecruitmentStatus

    /**
     * 
     * @type {AcceptanceFlow}
     * @memberof TrialManagementApiGetLocations
     */
    readonly flow?: AcceptanceFlow

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocations
     */
    readonly country?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocations
     */
    readonly facility?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocations
     */
    readonly searchString?: string
}

/**
 * Request parameters for getMatches operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetMatchesRequest
 */
export interface TrialManagementApiGetMatchesRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof TrialManagementApiGetMatches
     */
    readonly showDetails: boolean | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetMatches
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetMatches
     */
    readonly offset?: number | null

    /**
     * 
     * @type {TrialVolunteersOrderBy}
     * @memberof TrialManagementApiGetMatches
     */
    readonly orderBy?: TrialVolunteersOrderBy

    /**
     * 
     * @type {OrderDirection}
     * @memberof TrialManagementApiGetMatches
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly locationId?: string | null

    /**
     * Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly cohortId?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly country?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly postalCode?: string

    /**
     * True keeps the patients matched at a site outside their own country, false the others.
     * @type {boolean}
     * @memberof TrialManagementApiGetMatches
     */
    readonly fromAbroad?: boolean | null
}

/**
 * Request parameters for getMilestoneToken operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetMilestoneTokenRequest
 */
export interface TrialManagementApiGetMilestoneTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMilestoneToken
     */
    readonly id: string
}

/**
 * Request parameters for getMilestones operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetMilestonesRequest
 */
export interface TrialManagementApiGetMilestonesRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMilestones
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetMilestones
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetMilestones
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getPendingLocationChanges operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetPendingLocationChangesRequest
 */
export interface TrialManagementApiGetPendingLocationChangesRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetPendingLocationChanges
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPendingLocationChanges
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPendingLocationChanges
     */
    readonly offset?: number | null

    /**
     * 
     * @type {PendingLocationChangeStatus}
     * @memberof TrialManagementApiGetPendingLocationChanges
     */
    readonly status?: PendingLocationChangeStatus

    /**
     * 
     * @type {PendingLocationChangesOrderBy}
     * @memberof TrialManagementApiGetPendingLocationChanges
     */
    readonly orderBy?: PendingLocationChangesOrderBy

    /**
     * 
     * @type {OrderDirection}
     * @memberof TrialManagementApiGetPendingLocationChanges
     */
    readonly orderDirection?: OrderDirection
}

/**
 * Request parameters for getPublicLocations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetPublicLocationsRequest
 */
export interface TrialManagementApiGetPublicLocationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetPublicLocations
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPublicLocations
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPublicLocations
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetPublicLocations
     */
    readonly searchString?: string
}

/**
 * Request parameters for getPublicTrials operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetPublicTrialsRequest
 */
export interface TrialManagementApiGetPublicTrialsRequest {
    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPublicTrials
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPublicTrials
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetPublicTrials
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for getSummaryTranslations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetSummaryTranslationsRequest
 */
export interface TrialManagementApiGetSummaryTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetSummaryTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getTeamMandates operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetTeamMandatesRequest
 */
export interface TrialManagementApiGetTeamMandatesRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetTeamMandates
     */
    readonly teamId: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetTeamMandates
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetTeamMandates
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getTeams operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetTeamsRequest
 */
export interface TrialManagementApiGetTeamsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetTeams
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetTeams
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetTeams
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getTitleTranslations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetTitleTranslationsRequest
 */
export interface TrialManagementApiGetTitleTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetTitleTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getVolunteerActivity operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteerActivityRequest
 */
export interface TrialManagementApiGetVolunteerActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly researcherId?: string | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly start?: string | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly end?: string | null
}

/**
 * Request parameters for getVolunteerActivityUsers operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteerActivityUsersRequest
 */
export interface TrialManagementApiGetVolunteerActivityUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivityUsers
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerActivityUsers
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerActivityUsers
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivityUsers
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for getVolunteerAnswers operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteerAnswersRequest
 */
export interface TrialManagementApiGetVolunteerAnswersRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly offset?: number | null

    /**
     * 
     * @type {OrderDirection}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly order?: OrderDirection

    /**
     * 
     * @type {UserTrialStatus}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly status?: UserTrialStatus

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly userId?: string | null
}

/**
 * Request parameters for getVolunteerContact operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteerContactRequest
 */
export interface TrialManagementApiGetVolunteerContactRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerContact
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerContact
     */
    readonly userId: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerContact
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerContact
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getVolunteersOverview operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteersOverviewRequest
 */
export interface TrialManagementApiGetVolunteersOverviewRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteersOverview
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteersOverview
     */
    readonly locationId?: string | null

    /**
     * Only patients whose winning cohort is this &#x60;Cohort&#x60;. A patient without a cohort never matches.
     * @type {string}
     * @memberof TrialManagementApiGetVolunteersOverview
     */
    readonly cohortId?: string
}

/**
 * Request parameters for recalculate operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRecalculateRequest
 */
export interface TrialManagementApiRecalculateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRecalculate
     */
    readonly userId: string
}

/**
 * Request parameters for recalculateMany operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRecalculateManyRequest
 */
export interface TrialManagementApiRecalculateManyRequest {
    /**
     * 
     * @type {UsersCacheRegenerationBody}
     * @memberof TrialManagementApiRecalculateMany
     */
    readonly usersCacheRegenerationBody: UsersCacheRegenerationBody
}

/**
 * Request parameters for removeEffect operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRemoveEffectRequest
 */
export interface TrialManagementApiRemoveEffectRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRemoveEffect
     */
    readonly id: string
}

/**
 * Request parameters for removeProdUsers operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRemoveProdUsersRequest
 */
export interface TrialManagementApiRemoveProdUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRemoveProdUsers
     */
    readonly id: string

    /**
     * 
     * @type {RemoveProdUsersBody}
     * @memberof TrialManagementApiRemoveProdUsers
     */
    readonly removeProdUsersBody: RemoveProdUsersBody
}

/**
 * Request parameters for requestBooster operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRequestBoosterRequest
 */
export interface TrialManagementApiRequestBoosterRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRequestBooster
     */
    readonly id: string

    /**
     * 
     * @type {TrialBoosterBody}
     * @memberof TrialManagementApiRequestBooster
     */
    readonly trialBoosterBody: TrialBoosterBody
}

/**
 * Request parameters for requestCriteria operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRequestCriteriaRequest
 */
export interface TrialManagementApiRequestCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRequestCriteria
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaRequestBody}
     * @memberof TrialManagementApiRequestCriteria
     */
    readonly criteriaRequestBody: CriteriaRequestBody
}

/**
 * Request parameters for resetTrialCache operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiResetTrialCacheRequest
 */
export interface TrialManagementApiResetTrialCacheRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiResetTrialCache
     */
    readonly id: string
}

/**
 * Request parameters for respondToVolunteer operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRespondToVolunteerRequest
 */
export interface TrialManagementApiRespondToVolunteerRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRespondToVolunteer
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRespondToVolunteer
     */
    readonly userId: string

    /**
     * 
     * @type {TrialVolunteerFeedbackBody}
     * @memberof TrialManagementApiRespondToVolunteer
     */
    readonly trialVolunteerFeedbackBody: TrialVolunteerFeedbackBody
}

/**
 * Request parameters for restoreTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRestoreTrialRequest
 */
export interface TrialManagementApiRestoreTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRestoreTrial
     */
    readonly id: string
}

/**
 * Request parameters for search operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiSearchRequest
 */
export interface TrialManagementApiSearchRequest {
    /**
     * 
     * @type {GetTrialsBody}
     * @memberof TrialManagementApiSearch
     */
    readonly getTrialsBody: GetTrialsBody
}

/**
 * Request parameters for setAtomicCriteriaActivation operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiSetAtomicCriteriaActivationRequest
 */
export interface TrialManagementApiSetAtomicCriteriaActivationRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiSetAtomicCriteriaActivation
     */
    readonly id: string

    /**
     * 
     * @type {TrialAtomicCriteriaActivationBody}
     * @memberof TrialManagementApiSetAtomicCriteriaActivation
     */
    readonly trialAtomicCriteriaActivationBody: TrialAtomicCriteriaActivationBody
}

/**
 * Request parameters for setCompanionInviteOnly operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiSetCompanionInviteOnlyRequest
 */
export interface TrialManagementApiSetCompanionInviteOnlyRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiSetCompanionInviteOnly
     */
    readonly id: string

    /**
     * 
     * @type {TrialCompanionInviteOnlyBody}
     * @memberof TrialManagementApiSetCompanionInviteOnly
     */
    readonly trialCompanionInviteOnlyBody: TrialCompanionInviteOnlyBody
}

/**
 * Request parameters for setSkipLocationSync operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiSetSkipLocationSyncRequest
 */
export interface TrialManagementApiSetSkipLocationSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiSetSkipLocationSync
     */
    readonly id: string

    /**
     * 
     * @type {TrialSkipLocationSyncBody}
     * @memberof TrialManagementApiSetSkipLocationSync
     */
    readonly trialSkipLocationSyncBody: TrialSkipLocationSyncBody
}

/**
 * Request parameters for suggestAtomicCriterionChange operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiSuggestAtomicCriterionChangeRequest
 */
export interface TrialManagementApiSuggestAtomicCriterionChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiSuggestAtomicCriterionChange
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiSuggestAtomicCriterionChange
     */
    readonly predicateId: string

    /**
     * 
     * @type {TrialAtomicCriterionSuggestionBody}
     * @memberof TrialManagementApiSuggestAtomicCriterionChange
     */
    readonly trialAtomicCriterionSuggestionBody: TrialAtomicCriterionSuggestionBody
}

/**
 * Request parameters for unassignMandate operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiUnassignMandateRequest
 */
export interface TrialManagementApiUnassignMandateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUnassignMandate
     */
    readonly id: string

    /**
     * 
     * @type {UnassignMandateBody}
     * @memberof TrialManagementApiUnassignMandate
     */
    readonly unassignMandateBody: UnassignMandateBody
}

/**
 * Request parameters for updateTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiUpdateTrialRequest
 */
export interface TrialManagementApiUpdateTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUpdateTrial
     */
    readonly id: string

    /**
     * 
     * @type {UpdateTrialBody}
     * @memberof TrialManagementApiUpdateTrial
     */
    readonly updateTrialBody: UpdateTrialBody
}

/**
 * Request parameters for updateUserTrialLocation operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiUpdateUserTrialLocationRequest
 */
export interface TrialManagementApiUpdateUserTrialLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUpdateUserTrialLocation
     */
    readonly id: string

    /**
     * 
     * @type {UpdateUserTrialLocationBody}
     * @memberof TrialManagementApiUpdateUserTrialLocation
     */
    readonly updateUserTrialLocationBody: UpdateUserTrialLocationBody
}

/**
 * Request parameters for updateVolunteerContacted operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiUpdateVolunteerContactedRequest
 */
export interface TrialManagementApiUpdateVolunteerContactedRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUpdateVolunteerContacted
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUpdateVolunteerContacted
     */
    readonly userId: string

    /**
     * 
     * @type {TrialVolunteerContactBody}
     * @memberof TrialManagementApiUpdateVolunteerContacted
     */
    readonly trialVolunteerContactBody: TrialVolunteerContactBody
}

/**
 * Request parameters for validateAll operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiValidateAllRequest
 */
export interface TrialManagementApiValidateAllRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiValidateAll
     */
    readonly id: string
}

/**
 * Request parameters for volunteerReachOut operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiVolunteerReachOutRequest
 */
export interface TrialManagementApiVolunteerReachOutRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiVolunteerReachOut
     */
    readonly id: string

    /**
     * 
     * @type {TrialReachOutBody}
     * @memberof TrialManagementApiVolunteerReachOut
     */
    readonly trialReachOutBody: TrialReachOutBody
}

/**
 * TrialManagementApi - object-oriented interface
 * @export
 * @class TrialManagementApi
 * @extends {BaseAPI}
 */
export class TrialManagementApi extends BaseAPI {
    /**
     * 
     * @summary add CT trial to platform
     * @param {TrialManagementApiAddCTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public addCT(requestParameters: TrialManagementApiAddCTRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).addCT(requestParameters.id, requestParameters.trialAddCTBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set the acceptance flow for a trial (all locations). A trial can have 1 effect and each of its locations can have 1 effect.
     * @param {TrialManagementApiAddEffectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public addEffect(requestParameters: TrialManagementApiAddEffectRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).addEffect(requestParameters.id, requestParameters.trialEffectBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary mark a trial as favorite
     * @param {TrialManagementApiAddFavoriteTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public addFavoriteTrial(requestParameters: TrialManagementApiAddFavoriteTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).addFavoriteTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a sponsor to a trial
     * @param {TrialManagementApiAddSponsorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public addSponsor(requestParameters: TrialManagementApiAddSponsorRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).addSponsor(requestParameters.id, requestParameters.trialAddSponsorBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Non-production only. Fast-forward an enrolled patient to their next milestone (backdates enrollment and fires the milestone email). Used by QA to walk the companion flow without waiting real days.
     * @param {TrialManagementApiAdvanceMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public advanceMilestone(requestParameters: TrialManagementApiAdvanceMilestoneRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).advanceMilestone(requestParameters.id, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set mandate status to paid
     * @param {TrialManagementApiAssignMandateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public assignMandate(requestParameters: TrialManagementApiAssignMandateRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).assignMandate(requestParameters.id, requestParameters.assignMandateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set a trial to the completed status to stop recruitment
     * @param {TrialManagementApiCompleteTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public completeTrial(requestParameters: TrialManagementApiCompleteTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).completeTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a comment to a trial
     * @param {TrialManagementApiCreateCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createComment(requestParameters: TrialManagementApiCreateCommentRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createComment(requestParameters.id, requestParameters.trialCommentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a contact to a trial
     * @param {TrialManagementApiCreateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createContact(requestParameters: TrialManagementApiCreateContactRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createContact(requestParameters.id, requestParameters.trialContactBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a criteria
     * @param {TrialManagementApiCreateCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createCriteria(requestParameters: TrialManagementApiCreateCriteriaRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createCriteria(requestParameters.id, requestParameters.trialCriteriaBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a location to a trial
     * @param {TrialManagementApiCreateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createLocation(requestParameters: TrialManagementApiCreateLocationRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createLocation(requestParameters.id, requestParameters.trialLocationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new milestone for a trial
     * @param {TrialManagementApiCreateMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createMilestone(requestParameters: TrialManagementApiCreateMilestoneRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createMilestone(requestParameters.id, requestParameters.trialMilestoneBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of translations of the summary of a trial
     * @param {TrialManagementApiCreateSummaryTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createSummaryTranslations(requestParameters: TrialManagementApiCreateSummaryTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createSummaryTranslations(requestParameters.id, requestParameters.trialTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of translations of the title of a trial
     * @param {TrialManagementApiCreateTitleTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createTitleTranslations(requestParameters: TrialManagementApiCreateTitleTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createTitleTranslations(requestParameters.id, requestParameters.trialTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new trial
     * @param {TrialManagementApiCreateTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createTrial(requestParameters: TrialManagementApiCreateTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createTrial(requestParameters.trialCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary unmark a trial as favorite
     * @param {TrialManagementApiDeleteFavoriteTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public deleteFavoriteTrial(requestParameters: TrialManagementApiDeleteFavoriteTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).deleteFavoriteTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a sponsor from a trial
     * @param {TrialManagementApiDeleteSponsorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public deleteSponsor(requestParameters: TrialManagementApiDeleteSponsorRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).deleteSponsor(requestParameters.id, requestParameters.trialDeleteSponsorBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary soft delete a trial, it will be restorable for 30 days
     * @param {TrialManagementApiDeleteTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public deleteTrial(requestParameters: TrialManagementApiDeleteTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).deleteTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of patients willing to participate in a trial
     * @param {TrialManagementApiGetAcceptedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getAccepted(requestParameters: TrialManagementApiGetAcceptedRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getAccepted(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.locationId, requestParameters.cohortId, requestParameters.postalCode, requestParameters.onlyActiveLocations, requestParameters.includePending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch paginated activity log of a criteria
     * @param {TrialManagementApiGetActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getActivity(requestParameters: TrialManagementApiGetActivityRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the atomic criteria of a specific trial with their questions and cohorts
     * @param {TrialManagementApiGetAtomicCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getAtomicCriteria(requestParameters: TrialManagementApiGetAtomicCriteriaRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getAtomicCriteria(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a specific trial
     * @param {TrialManagementApiGetContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getContacts(requestParameters: TrialManagementApiGetContactsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getContacts(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of criteria of a specific trial
     * @param {TrialManagementApiGetCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getCriteria(requestParameters: TrialManagementApiGetCriteriaRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getCriteria(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get how the pre-screening patients of a specific trial stand on each of its predicates
     * @param {TrialManagementApiGetCriteriaAnswerCountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getCriteriaAnswerCounts(requestParameters: TrialManagementApiGetCriteriaAnswerCountsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getCriteriaAnswerCounts(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a specific trial
     * @param {TrialManagementApiGetDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getDetails(requestParameters: TrialManagementApiGetDetailsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of the userIds that are enrolled in a trial
     * @param {TrialManagementApiGetEnrolledRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getEnrolled(requestParameters: TrialManagementApiGetEnrolledRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getEnrolled(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.locationId, requestParameters.cohortId, requestParameters.milestoneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all lead sponsors of the trials
     * @param {TrialManagementApiGetLeadSponsorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getLeadSponsors(requestParameters: TrialManagementApiGetLeadSponsorsRequest = {}, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getLeadSponsors(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the countries of the locations of a specific trial
     * @param {TrialManagementApiGetLocationCountriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getLocationCountries(requestParameters: TrialManagementApiGetLocationCountriesRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getLocationCountries(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the locations of a specific trial
     * @param {TrialManagementApiGetLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getLocations(requestParameters: TrialManagementApiGetLocationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.flow, requestParameters.country, requestParameters.facility, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of the userIds that fully matched a trial
     * @param {TrialManagementApiGetMatchesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getMatches(requestParameters: TrialManagementApiGetMatchesRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getMatches(requestParameters.id, requestParameters.showDetails, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.locationId, requestParameters.cohortId, requestParameters.country, requestParameters.postalCode, requestParameters.fromAbroad, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get or create milestone enrollment token for trial
     * @param {TrialManagementApiGetMilestoneTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getMilestoneToken(requestParameters: TrialManagementApiGetMilestoneTokenRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getMilestoneToken(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get milestones for a trial
     * @param {TrialManagementApiGetMilestonesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getMilestones(requestParameters: TrialManagementApiGetMilestonesRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getMilestones(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get pending location changes for a trial
     * @param {TrialManagementApiGetPendingLocationChangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getPendingLocationChanges(requestParameters: TrialManagementApiGetPendingLocationChangesRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getPendingLocationChanges(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.orderBy, requestParameters.orderDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the list of public recruitment locations for a trial
     * @param {TrialManagementApiGetPublicLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getPublicLocations(requestParameters: TrialManagementApiGetPublicLocationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getPublicLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get public details required for requesting access to a trial.
     * @param {TrialManagementApiGetPublicTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getPublicTrials(requestParameters: TrialManagementApiGetPublicTrialsRequest = {}, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getPublicTrials(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of translations of the summary of a trial
     * @param {TrialManagementApiGetSummaryTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getSummaryTranslations(requestParameters: TrialManagementApiGetSummaryTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getSummaryTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get information on mandates of a team
     * @param {TrialManagementApiGetTeamMandatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getTeamMandates(requestParameters: TrialManagementApiGetTeamMandatesRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getTeamMandates(requestParameters.teamId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the teams for a trial
     * @param {TrialManagementApiGetTeamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getTeams(requestParameters: TrialManagementApiGetTeamsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getTeams(requestParameters.id, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of translations of the title of a trial
     * @param {TrialManagementApiGetTitleTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getTitleTranslations(requestParameters: TrialManagementApiGetTitleTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getTitleTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of activities on a funnel page
     * @param {TrialManagementApiGetVolunteerActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteerActivity(requestParameters: TrialManagementApiGetVolunteerActivityRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteerActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.researcherId, requestParameters.start, requestParameters.end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of the users that can be filtered on in the funnel activity list
     * @param {TrialManagementApiGetVolunteerActivityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteerActivityUsers(requestParameters: TrialManagementApiGetVolunteerActivityUsersRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteerActivityUsers(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the answers of a volunteer for a specific volunteer
     * @param {TrialManagementApiGetVolunteerAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteerAnswers(requestParameters: TrialManagementApiGetVolunteerAnswersRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteerAnswers(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.status, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the contact details of a volunteer of a specific trial
     * @param {TrialManagementApiGetVolunteerContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteerContact(requestParameters: TrialManagementApiGetVolunteerContactRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteerContact(requestParameters.id, requestParameters.userId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the overview of volunteers of a specific trial
     * @param {TrialManagementApiGetVolunteersOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteersOverview(requestParameters: TrialManagementApiGetVolunteersOverviewRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteersOverview(requestParameters.id, requestParameters.locationId, requestParameters.cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recalculate the cache of a user
     * @param {TrialManagementApiRecalculateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public recalculate(requestParameters: TrialManagementApiRecalculateRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).recalculate(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recalculate the cache of many users in the background
     * @param {TrialManagementApiRecalculateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public recalculateMany(requestParameters: TrialManagementApiRecalculateManyRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).recalculateMany(requestParameters.usersCacheRegenerationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reset the acceptance flow for the trial to the default
     * @param {TrialManagementApiRemoveEffectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public removeEffect(requestParameters: TrialManagementApiRemoveEffectRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).removeEffect(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To be used in dev only. Remove user trials which were synced from prod to dev
     * @param {TrialManagementApiRemoveProdUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public removeProdUsers(requestParameters: TrialManagementApiRemoveProdUsersRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).removeProdUsers(requestParameters.id, requestParameters.removeProdUsersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request a booster for a trial
     * @param {TrialManagementApiRequestBoosterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public requestBooster(requestParameters: TrialManagementApiRequestBoosterRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).requestBooster(requestParameters.id, requestParameters.trialBoosterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request a new criteria for a trial
     * @param {TrialManagementApiRequestCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public requestCriteria(requestParameters: TrialManagementApiRequestCriteriaRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).requestCriteria(requestParameters.id, requestParameters.criteriaRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Regenerate user trial cache. After changes are made to a trial this endpoint makes sure that the user cache is updated.
     * @param {TrialManagementApiResetTrialCacheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public resetTrialCache(requestParameters: TrialManagementApiResetTrialCacheRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).resetTrialCache(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the status of a user in a trial
     * @param {TrialManagementApiRespondToVolunteerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public respondToVolunteer(requestParameters: TrialManagementApiRespondToVolunteerRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).respondToVolunteer(requestParameters.id, requestParameters.userId, requestParameters.trialVolunteerFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary restore a deleted trial
     * @param {TrialManagementApiRestoreTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public restoreTrial(requestParameters: TrialManagementApiRestoreTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).restoreTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all trials, paginated, searchable. If a user can only see a limited number of trials, then only those are returned.
     * @param {TrialManagementApiSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public search(requestParameters: TrialManagementApiSearchRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).search(requestParameters.getTrialsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary switch atomic criteria of a specific trial off or on for matching and the eligibility chat
     * @param {TrialManagementApiSetAtomicCriteriaActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public setAtomicCriteriaActivation(requestParameters: TrialManagementApiSetAtomicCriteriaActivationRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).setAtomicCriteriaActivation(requestParameters.id, requestParameters.trialAtomicCriteriaActivationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set whether patients join the Companion program only by invitation
     * @param {TrialManagementApiSetCompanionInviteOnlyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public setCompanionInviteOnly(requestParameters: TrialManagementApiSetCompanionInviteOnlyRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).setCompanionInviteOnly(requestParameters.id, requestParameters.trialCompanionInviteOnlyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set skipLocationSync value for a trial
     * @param {TrialManagementApiSetSkipLocationSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public setSkipLocationSync(requestParameters: TrialManagementApiSetSkipLocationSyncRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).setSkipLocationSync(requestParameters.id, requestParameters.trialSkipLocationSyncBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary suggest to Curewiki a change to an atomic criterion of a specific trial
     * @param {TrialManagementApiSuggestAtomicCriterionChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public suggestAtomicCriterionChange(requestParameters: TrialManagementApiSuggestAtomicCriterionChangeRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).suggestAtomicCriterionChange(requestParameters.id, requestParameters.predicateId, requestParameters.trialAtomicCriterionSuggestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set mandate status to active (unpaid)
     * @param {TrialManagementApiUnassignMandateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public unassignMandate(requestParameters: TrialManagementApiUnassignMandateRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).unassignMandate(requestParameters.id, requestParameters.unassignMandateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a trial
     * @param {TrialManagementApiUpdateTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public updateTrial(requestParameters: TrialManagementApiUpdateTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).updateTrial(requestParameters.id, requestParameters.updateTrialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user trial locations from old to new location
     * @param {TrialManagementApiUpdateUserTrialLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public updateUserTrialLocation(requestParameters: TrialManagementApiUpdateUserTrialLocationRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).updateUserTrialLocation(requestParameters.id, requestParameters.updateUserTrialLocationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary indicate the contact date of a  volunteer
     * @param {TrialManagementApiUpdateVolunteerContactedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public updateVolunteerContacted(requestParameters: TrialManagementApiUpdateVolunteerContactedRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).updateVolunteerContacted(requestParameters.id, requestParameters.userId, requestParameters.trialVolunteerContactBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary validate all properties of a trial
     * @param {TrialManagementApiValidateAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public validateAll(requestParameters: TrialManagementApiValidateAllRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).validateAll(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reach out to eligible patients for a trial
     * @param {TrialManagementApiVolunteerReachOutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public volunteerReachOut(requestParameters: TrialManagementApiVolunteerReachOutRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).volunteerReachOut(requestParameters.id, requestParameters.trialReachOutBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Verify the share consent and start partner authorisation, or mark the share ready to ingest
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authoriseRecordShare: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('authoriseRecordShare', 'shareId', shareId)
            const localVarPath = `/users/me/record-shares/{shareId}/authorise`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete the authorisation step with the parameters the partner returned
         * @param {string} shareId 
         * @param {CompleteRecordShareAuthorisationBody} completeRecordShareAuthorisationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRecordShareAuthorisation: async (shareId: string, completeRecordShareAuthorisationBody: CompleteRecordShareAuthorisationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('completeRecordShareAuthorisation', 'shareId', shareId)
            // verify required parameter 'completeRecordShareAuthorisationBody' is not null or undefined
            assertParamExists('completeRecordShareAuthorisation', 'completeRecordShareAuthorisationBody', completeRecordShareAuthorisationBody)
            const localVarPath = `/users/me/record-shares/{shareId}/authorisation/complete`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeRecordShareAuthorisationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete the identity step with the parameters the partner returned
         * @param {string} shareId 
         * @param {CompleteRecordShareIdentityBody} completeRecordShareIdentityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRecordShareIdentity: async (shareId: string, completeRecordShareIdentityBody: CompleteRecordShareIdentityBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('completeRecordShareIdentity', 'shareId', shareId)
            // verify required parameter 'completeRecordShareIdentityBody' is not null or undefined
            assertParamExists('completeRecordShareIdentity', 'completeRecordShareIdentityBody', completeRecordShareIdentityBody)
            const localVarPath = `/users/me/record-shares/{shareId}/identity/complete`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeRecordShareIdentityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a record share with a partner
         * @param {CreateRecordShareBody} createRecordShareBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecordShare: async (createRecordShareBody: CreateRecordShareBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRecordShareBody' is not null or undefined
            assertParamExists('createRecordShare', 'createRecordShareBody', createRecordShareBody)
            const localVarPath = `/users/me/record-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecordShareBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allow user to delete themselves.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allow admin to delete any user
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUser', 'id', id)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-run evaluation for a retrieved share whose pre-screens are not yet current
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateRecordShare: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('evaluateRecordShare', 'shareId', shareId)
            const localVarPath = `/users/me/record-shares/{shareId}/evaluate`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-run evaluation for a patient\'s retrieved share
         * @param {string} id 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateRecordShareAsAdmin: async (id: string, shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('evaluateRecordShareAsAdmin', 'id', id)
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('evaluateRecordShareAsAdmin', 'shareId', shareId)
            const localVarPath = `/users/{id}/record-shares/{shareId}/evaluate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get overview of admins and reviewers on the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/overview/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the authenticated patient\'s shared health record and re-derive their pre-screens
         * @param {IngestRecordBody} ingestRecordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestMyRecord: async (ingestRecordBody: IngestRecordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestRecordBody' is not null or undefined
            assertParamExists('ingestMyRecord', 'ingestRecordBody', ingestRecordBody)
            const localVarPath = `/users/me/ingest-record`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestRecordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a patient\'s shared health record, store it as Facts and re-derive their pre-screens
         * @param {string} id 
         * @param {IngestRecordBody} ingestRecordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestRecord: async (id: string, ingestRecordBody: IngestRecordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ingestRecord', 'id', id)
            // verify required parameter 'ingestRecordBody' is not null or undefined
            assertParamExists('ingestRecord', 'ingestRecordBody', ingestRecordBody)
            const localVarPath = `/users/{id}/ingest-record`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestRecordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Whether the authenticated patient can share a health record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordShareCapability: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me/record-share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record partners the authenticated patient can share from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordShareProviders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me/record-share/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Progress of a record share, for resume and lost-response recovery
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordShareStatus: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('recordShareStatus', 'shareId', shareId)
            const localVarPath = `/users/me/record-shares/{shareId}`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-issue the identity redirect for a share still at its first step
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueRecordShareIdentity: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('reissueRecordShareIdentity', 'shareId', shareId)
            const localVarPath = `/users/me/record-shares/{shareId}/identity`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update display names for users with undefined displayName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDisplayNames: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/update-display-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Verify the share consent and start partner authorisation, or mark the share ready to ingest
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authoriseRecordShare(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authoriseRecordShare(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.authoriseRecordShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete the authorisation step with the parameters the partner returned
         * @param {string} shareId 
         * @param {CompleteRecordShareAuthorisationBody} completeRecordShareAuthorisationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeRecordShareAuthorisation(shareId: string, completeRecordShareAuthorisationBody: CompleteRecordShareAuthorisationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareStatusView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeRecordShareAuthorisation(shareId, completeRecordShareAuthorisationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.completeRecordShareAuthorisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete the identity step with the parameters the partner returned
         * @param {string} shareId 
         * @param {CompleteRecordShareIdentityBody} completeRecordShareIdentityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeRecordShareIdentity(shareId: string, completeRecordShareIdentityBody: CompleteRecordShareIdentityBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareStatusView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeRecordShareIdentity(shareId, completeRecordShareIdentityBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.completeRecordShareIdentity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a record share with a partner
         * @param {CreateRecordShareBody} createRecordShareBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRecordShare(createRecordShareBody: CreateRecordShareBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareStartView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRecordShare(createRecordShareBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.createRecordShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Allow user to delete themselves.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Allow admin to delete any user
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Re-run evaluation for a retrieved share whose pre-screens are not yet current
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateRecordShare(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareEvaluationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateRecordShare(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.evaluateRecordShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Re-run evaluation for a patient\'s retrieved share
         * @param {string} id 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateRecordShareAsAdmin(id: string, shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareEvaluationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateRecordShareAsAdmin(id, shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.evaluateRecordShareAsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get overview of admins and reviewers on the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAdminOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getAdminOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve the authenticated patient\'s shared health record and re-derive their pre-screens
         * @param {IngestRecordBody} ingestRecordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestMyRecord(ingestRecordBody: IngestRecordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestRecordView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestMyRecord(ingestRecordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.ingestMyRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve a patient\'s shared health record, store it as Facts and re-derive their pre-screens
         * @param {string} id 
         * @param {IngestRecordBody} ingestRecordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestRecord(id: string, ingestRecordBody: IngestRecordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestRecordView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestRecord(id, ingestRecordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.ingestRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Whether the authenticated patient can share a health record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordShareCapability(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareCapabilityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordShareCapability(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.recordShareCapability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record partners the authenticated patient can share from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordShareProviders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareProvidersView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordShareProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.recordShareProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Progress of a record share, for resume and lost-response recovery
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordShareStatus(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareStatusView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordShareStatus(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.recordShareStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Re-issue the identity redirect for a share still at its first step
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reissueRecordShareIdentity(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordShareStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reissueRecordShareIdentity(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.reissueRecordShareIdentity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update display names for users with undefined displayName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDisplayNames(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDisplayNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDisplayNames(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateDisplayNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Verify the share consent and start partner authorisation, or mark the share ready to ingest
         * @param {UserApiAuthoriseRecordShareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authoriseRecordShare(requestParameters: UserApiAuthoriseRecordShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordShareStepView> {
            return localVarFp.authoriseRecordShare(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete the authorisation step with the parameters the partner returned
         * @param {UserApiCompleteRecordShareAuthorisationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRecordShareAuthorisation(requestParameters: UserApiCompleteRecordShareAuthorisationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordShareStatusView> {
            return localVarFp.completeRecordShareAuthorisation(requestParameters.shareId, requestParameters.completeRecordShareAuthorisationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete the identity step with the parameters the partner returned
         * @param {UserApiCompleteRecordShareIdentityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRecordShareIdentity(requestParameters: UserApiCompleteRecordShareIdentityRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordShareStatusView> {
            return localVarFp.completeRecordShareIdentity(requestParameters.shareId, requestParameters.completeRecordShareIdentityBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a record share with a partner
         * @param {UserApiCreateRecordShareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecordShare(requestParameters: UserApiCreateRecordShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordShareStartView> {
            return localVarFp.createRecordShare(requestParameters.createRecordShareBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allow user to delete themselves.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allow admin to delete any user
         * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: UserApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-run evaluation for a retrieved share whose pre-screens are not yet current
         * @param {UserApiEvaluateRecordShareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateRecordShare(requestParameters: UserApiEvaluateRecordShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordShareEvaluationView> {
            return localVarFp.evaluateRecordShare(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-run evaluation for a patient\'s retrieved share
         * @param {UserApiEvaluateRecordShareAsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateRecordShareAsAdmin(requestParameters: UserApiEvaluateRecordShareAsAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordShareEvaluationView> {
            return localVarFp.evaluateRecordShareAsAdmin(requestParameters.id, requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get overview of admins and reviewers on the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOverview(options?: RawAxiosRequestConfig): AxiosPromise<ListAdminOverviewView> {
            return localVarFp.getAdminOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the authenticated patient\'s shared health record and re-derive their pre-screens
         * @param {UserApiIngestMyRecordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestMyRecord(requestParameters: UserApiIngestMyRecordRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestRecordView> {
            return localVarFp.ingestMyRecord(requestParameters.ingestRecordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a patient\'s shared health record, store it as Facts and re-derive their pre-screens
         * @param {UserApiIngestRecordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestRecord(requestParameters: UserApiIngestRecordRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestRecordView> {
            return localVarFp.ingestRecord(requestParameters.id, requestParameters.ingestRecordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Whether the authenticated patient can share a health record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordShareCapability(options?: RawAxiosRequestConfig): AxiosPromise<RecordShareCapabilityView> {
            return localVarFp.recordShareCapability(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record partners the authenticated patient can share from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordShareProviders(options?: RawAxiosRequestConfig): AxiosPromise<RecordShareProvidersView> {
            return localVarFp.recordShareProviders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Progress of a record share, for resume and lost-response recovery
         * @param {UserApiRecordShareStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordShareStatus(requestParameters: UserApiRecordShareStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordShareStatusView> {
            return localVarFp.recordShareStatus(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-issue the identity redirect for a share still at its first step
         * @param {UserApiReissueRecordShareIdentityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueRecordShareIdentity(requestParameters: UserApiReissueRecordShareIdentityRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordShareStepView> {
            return localVarFp.reissueRecordShareIdentity(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update display names for users with undefined displayName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDisplayNames(options?: RawAxiosRequestConfig): AxiosPromise<UpdateDisplayNameView> {
            return localVarFp.updateDisplayNames(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for authoriseRecordShare operation in UserApi.
 * @export
 * @interface UserApiAuthoriseRecordShareRequest
 */
export interface UserApiAuthoriseRecordShareRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiAuthoriseRecordShare
     */
    readonly shareId: string
}

/**
 * Request parameters for completeRecordShareAuthorisation operation in UserApi.
 * @export
 * @interface UserApiCompleteRecordShareAuthorisationRequest
 */
export interface UserApiCompleteRecordShareAuthorisationRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiCompleteRecordShareAuthorisation
     */
    readonly shareId: string

    /**
     * 
     * @type {CompleteRecordShareAuthorisationBody}
     * @memberof UserApiCompleteRecordShareAuthorisation
     */
    readonly completeRecordShareAuthorisationBody: CompleteRecordShareAuthorisationBody
}

/**
 * Request parameters for completeRecordShareIdentity operation in UserApi.
 * @export
 * @interface UserApiCompleteRecordShareIdentityRequest
 */
export interface UserApiCompleteRecordShareIdentityRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiCompleteRecordShareIdentity
     */
    readonly shareId: string

    /**
     * 
     * @type {CompleteRecordShareIdentityBody}
     * @memberof UserApiCompleteRecordShareIdentity
     */
    readonly completeRecordShareIdentityBody: CompleteRecordShareIdentityBody
}

/**
 * Request parameters for createRecordShare operation in UserApi.
 * @export
 * @interface UserApiCreateRecordShareRequest
 */
export interface UserApiCreateRecordShareRequest {
    /**
     * 
     * @type {CreateRecordShareBody}
     * @memberof UserApiCreateRecordShare
     */
    readonly createRecordShareBody: CreateRecordShareBody
}

/**
 * Request parameters for deleteUser operation in UserApi.
 * @export
 * @interface UserApiDeleteUserRequest
 */
export interface UserApiDeleteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiDeleteUser
     */
    readonly id: string
}

/**
 * Request parameters for evaluateRecordShare operation in UserApi.
 * @export
 * @interface UserApiEvaluateRecordShareRequest
 */
export interface UserApiEvaluateRecordShareRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiEvaluateRecordShare
     */
    readonly shareId: string
}

/**
 * Request parameters for evaluateRecordShareAsAdmin operation in UserApi.
 * @export
 * @interface UserApiEvaluateRecordShareAsAdminRequest
 */
export interface UserApiEvaluateRecordShareAsAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiEvaluateRecordShareAsAdmin
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof UserApiEvaluateRecordShareAsAdmin
     */
    readonly shareId: string
}

/**
 * Request parameters for ingestMyRecord operation in UserApi.
 * @export
 * @interface UserApiIngestMyRecordRequest
 */
export interface UserApiIngestMyRecordRequest {
    /**
     * 
     * @type {IngestRecordBody}
     * @memberof UserApiIngestMyRecord
     */
    readonly ingestRecordBody: IngestRecordBody
}

/**
 * Request parameters for ingestRecord operation in UserApi.
 * @export
 * @interface UserApiIngestRecordRequest
 */
export interface UserApiIngestRecordRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiIngestRecord
     */
    readonly id: string

    /**
     * 
     * @type {IngestRecordBody}
     * @memberof UserApiIngestRecord
     */
    readonly ingestRecordBody: IngestRecordBody
}

/**
 * Request parameters for recordShareStatus operation in UserApi.
 * @export
 * @interface UserApiRecordShareStatusRequest
 */
export interface UserApiRecordShareStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiRecordShareStatus
     */
    readonly shareId: string
}

/**
 * Request parameters for reissueRecordShareIdentity operation in UserApi.
 * @export
 * @interface UserApiReissueRecordShareIdentityRequest
 */
export interface UserApiReissueRecordShareIdentityRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiReissueRecordShareIdentity
     */
    readonly shareId: string
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Verify the share consent and start partner authorisation, or mark the share ready to ingest
     * @param {UserApiAuthoriseRecordShareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public authoriseRecordShare(requestParameters: UserApiAuthoriseRecordShareRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).authoriseRecordShare(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete the authorisation step with the parameters the partner returned
     * @param {UserApiCompleteRecordShareAuthorisationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public completeRecordShareAuthorisation(requestParameters: UserApiCompleteRecordShareAuthorisationRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).completeRecordShareAuthorisation(requestParameters.shareId, requestParameters.completeRecordShareAuthorisationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete the identity step with the parameters the partner returned
     * @param {UserApiCompleteRecordShareIdentityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public completeRecordShareIdentity(requestParameters: UserApiCompleteRecordShareIdentityRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).completeRecordShareIdentity(requestParameters.shareId, requestParameters.completeRecordShareIdentityBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a record share with a partner
     * @param {UserApiCreateRecordShareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createRecordShare(requestParameters: UserApiCreateRecordShareRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).createRecordShare(requestParameters.createRecordShareBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allow user to delete themselves.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteCurrentUser(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allow admin to delete any user
     * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(requestParameters: UserApiDeleteUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-run evaluation for a retrieved share whose pre-screens are not yet current
     * @param {UserApiEvaluateRecordShareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public evaluateRecordShare(requestParameters: UserApiEvaluateRecordShareRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).evaluateRecordShare(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-run evaluation for a patient\'s retrieved share
     * @param {UserApiEvaluateRecordShareAsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public evaluateRecordShareAsAdmin(requestParameters: UserApiEvaluateRecordShareAsAdminRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).evaluateRecordShareAsAdmin(requestParameters.id, requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get overview of admins and reviewers on the platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getAdminOverview(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getAdminOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the authenticated patient\'s shared health record and re-derive their pre-screens
     * @param {UserApiIngestMyRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public ingestMyRecord(requestParameters: UserApiIngestMyRecordRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).ingestMyRecord(requestParameters.ingestRecordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a patient\'s shared health record, store it as Facts and re-derive their pre-screens
     * @param {UserApiIngestRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public ingestRecord(requestParameters: UserApiIngestRecordRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).ingestRecord(requestParameters.id, requestParameters.ingestRecordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Whether the authenticated patient can share a health record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public recordShareCapability(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).recordShareCapability(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record partners the authenticated patient can share from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public recordShareProviders(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).recordShareProviders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Progress of a record share, for resume and lost-response recovery
     * @param {UserApiRecordShareStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public recordShareStatus(requestParameters: UserApiRecordShareStatusRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).recordShareStatus(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-issue the identity redirect for a share still at its first step
     * @param {UserApiReissueRecordShareIdentityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public reissueRecordShareIdentity(requestParameters: UserApiReissueRecordShareIdentityRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).reissueRecordShareIdentity(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update display names for users with undefined displayName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateDisplayNames(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateDisplayNames(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserPanelsApi - axios parameter creator
 * @export
 */
export const UserPanelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a list of my panels
         * @param {Array<UserTrialStatus>} status 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPanels: async (status: Array<UserTrialStatus>, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getMyPanels', 'status', status)
            const localVarPath = `/panels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a panel detail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPanelDetail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPanelDetail', 'id', id)
            const localVarPath = `/panels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPanelsApi - functional programming interface
 * @export
 */
export const UserPanelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPanelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a list of my panels
         * @param {Array<UserTrialStatus>} status 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyPanels(status: Array<UserTrialStatus>, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserPanelView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyPanels(status, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserPanelsApi.getMyPanels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a panel detail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPanelDetail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPanelDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPanelDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserPanelsApi.getPanelDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserPanelsApi - factory interface
 * @export
 */
export const UserPanelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPanelsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a list of my panels
         * @param {UserPanelsApiGetMyPanelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPanels(requestParameters: UserPanelsApiGetMyPanelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListUserPanelView> {
            return localVarFp.getMyPanels(requestParameters.status, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a panel detail
         * @param {UserPanelsApiGetPanelDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPanelDetail(requestParameters: UserPanelsApiGetPanelDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserPanelDetailView> {
            return localVarFp.getPanelDetail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMyPanels operation in UserPanelsApi.
 * @export
 * @interface UserPanelsApiGetMyPanelsRequest
 */
export interface UserPanelsApiGetMyPanelsRequest {
    /**
     * 
     * @type {Array<UserTrialStatus>}
     * @memberof UserPanelsApiGetMyPanels
     */
    readonly status: Array<UserTrialStatus>

    /**
     * 
     * @type {number}
     * @memberof UserPanelsApiGetMyPanels
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserPanelsApiGetMyPanels
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getPanelDetail operation in UserPanelsApi.
 * @export
 * @interface UserPanelsApiGetPanelDetailRequest
 */
export interface UserPanelsApiGetPanelDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof UserPanelsApiGetPanelDetail
     */
    readonly id: string
}

/**
 * UserPanelsApi - object-oriented interface
 * @export
 * @class UserPanelsApi
 * @extends {BaseAPI}
 */
export class UserPanelsApi extends BaseAPI {
    /**
     * 
     * @summary Get a list of my panels
     * @param {UserPanelsApiGetMyPanelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPanelsApi
     */
    public getMyPanels(requestParameters: UserPanelsApiGetMyPanelsRequest, options?: RawAxiosRequestConfig) {
        return UserPanelsApiFp(this.configuration).getMyPanels(requestParameters.status, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a panel detail
     * @param {UserPanelsApiGetPanelDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPanelsApi
     */
    public getPanelDetail(requestParameters: UserPanelsApiGetPanelDetailRequest, options?: RawAxiosRequestConfig) {
        return UserPanelsApiFp(this.configuration).getPanelDetail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserSurveysApi - axios parameter creator
 * @export
 */
export const UserSurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get survey detail for one of the users surveys
         * @param {Language} language 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySurveyDetail: async (language: Language, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getMySurveyDetail', 'language', language)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMySurveyDetail', 'id', id)
            const localVarPath = `/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of my surveys
         * @param {UserTrialStatus} status 
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySurveys: async (status: UserTrialStatus, language: Language, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getMySurveys', 'status', status)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getMySurveys', 'language', language)
            const localVarPath = `/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the overview of a patient\'s surveys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveysOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/surveys/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject a survey
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMySurvey: async (id: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectMySurvey', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('rejectMySurvey', 'body', body)
            const localVarPath = `/surveys/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start or stop the my surveys flow
         * @param {string} id 
         * @param {UpdateMySurveyBody} updateMySurveyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMySurveyFlow: async (id: string, updateMySurveyBody: UpdateMySurveyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMySurveyFlow', 'id', id)
            // verify required parameter 'updateMySurveyBody' is not null or undefined
            assertParamExists('updateMySurveyFlow', 'updateMySurveyBody', updateMySurveyBody)
            const localVarPath = `/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMySurveyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSurveysApi - functional programming interface
 * @export
 */
export const UserSurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get survey detail for one of the users surveys
         * @param {Language} language 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySurveyDetail(language: Language, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSurveyDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySurveyDetail(language, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.getMySurveyDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of my surveys
         * @param {UserTrialStatus} status 
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySurveys(status: UserTrialStatus, language: Language, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserSurveyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySurveys(status, language, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.getMySurveys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the overview of a patient\'s surveys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveysOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveysOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveysOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.getSurveysOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject a survey
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectMySurvey(id: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectMySurvey(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.rejectMySurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start or stop the my surveys flow
         * @param {string} id 
         * @param {UpdateMySurveyBody} updateMySurveyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMySurveyFlow(id: string, updateMySurveyBody: UpdateMySurveyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMySurveyFlow(id, updateMySurveyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.updateMySurveyFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserSurveysApi - factory interface
 * @export
 */
export const UserSurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSurveysApiFp(configuration)
    return {
        /**
         * 
         * @summary Get survey detail for one of the users surveys
         * @param {UserSurveysApiGetMySurveyDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySurveyDetail(requestParameters: UserSurveysApiGetMySurveyDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSurveyDetailView> {
            return localVarFp.getMySurveyDetail(requestParameters.language, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of my surveys
         * @param {UserSurveysApiGetMySurveysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySurveys(requestParameters: UserSurveysApiGetMySurveysRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListUserSurveyView> {
            return localVarFp.getMySurveys(requestParameters.status, requestParameters.language, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the overview of a patient\'s surveys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveysOverview(options?: RawAxiosRequestConfig): AxiosPromise<SurveysOverviewView> {
            return localVarFp.getSurveysOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject a survey
         * @param {UserSurveysApiRejectMySurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMySurvey(requestParameters: UserSurveysApiRejectMySurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectMySurvey(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start or stop the my surveys flow
         * @param {UserSurveysApiUpdateMySurveyFlowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMySurveyFlow(requestParameters: UserSurveysApiUpdateMySurveyFlowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMySurveyFlow(requestParameters.id, requestParameters.updateMySurveyBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMySurveyDetail operation in UserSurveysApi.
 * @export
 * @interface UserSurveysApiGetMySurveyDetailRequest
 */
export interface UserSurveysApiGetMySurveyDetailRequest {
    /**
     * 
     * @type {Language}
     * @memberof UserSurveysApiGetMySurveyDetail
     */
    readonly language: Language

    /**
     * 
     * @type {string}
     * @memberof UserSurveysApiGetMySurveyDetail
     */
    readonly id: string
}

/**
 * Request parameters for getMySurveys operation in UserSurveysApi.
 * @export
 * @interface UserSurveysApiGetMySurveysRequest
 */
export interface UserSurveysApiGetMySurveysRequest {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserSurveysApiGetMySurveys
     */
    readonly status: UserTrialStatus

    /**
     * 
     * @type {Language}
     * @memberof UserSurveysApiGetMySurveys
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof UserSurveysApiGetMySurveys
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserSurveysApiGetMySurveys
     */
    readonly offset?: number | null
}

/**
 * Request parameters for rejectMySurvey operation in UserSurveysApi.
 * @export
 * @interface UserSurveysApiRejectMySurveyRequest
 */
export interface UserSurveysApiRejectMySurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof UserSurveysApiRejectMySurvey
     */
    readonly id: string

    /**
     * 
     * @type {object}
     * @memberof UserSurveysApiRejectMySurvey
     */
    readonly body: object
}

/**
 * Request parameters for updateMySurveyFlow operation in UserSurveysApi.
 * @export
 * @interface UserSurveysApiUpdateMySurveyFlowRequest
 */
export interface UserSurveysApiUpdateMySurveyFlowRequest {
    /**
     * 
     * @type {string}
     * @memberof UserSurveysApiUpdateMySurveyFlow
     */
    readonly id: string

    /**
     * 
     * @type {UpdateMySurveyBody}
     * @memberof UserSurveysApiUpdateMySurveyFlow
     */
    readonly updateMySurveyBody: UpdateMySurveyBody
}

/**
 * UserSurveysApi - object-oriented interface
 * @export
 * @class UserSurveysApi
 * @extends {BaseAPI}
 */
export class UserSurveysApi extends BaseAPI {
    /**
     * 
     * @summary Get survey detail for one of the users surveys
     * @param {UserSurveysApiGetMySurveyDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public getMySurveyDetail(requestParameters: UserSurveysApiGetMySurveyDetailRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).getMySurveyDetail(requestParameters.language, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of my surveys
     * @param {UserSurveysApiGetMySurveysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public getMySurveys(requestParameters: UserSurveysApiGetMySurveysRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).getMySurveys(requestParameters.status, requestParameters.language, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the overview of a patient\'s surveys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public getSurveysOverview(options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).getSurveysOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject a survey
     * @param {UserSurveysApiRejectMySurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public rejectMySurvey(requestParameters: UserSurveysApiRejectMySurveyRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).rejectMySurvey(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start or stop the my surveys flow
     * @param {UserSurveysApiUpdateMySurveyFlowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public updateMySurveyFlow(requestParameters: UserSurveysApiUpdateMySurveyFlowRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).updateMySurveyFlow(requestParameters.id, requestParameters.updateMySurveyBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserTrialsApi - axios parameter creator
 * @export
 */
export const UserTrialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary return the trial (or research entity) that the patient is currently following the myTrial flow for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentFlow: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trials/current-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get milestone program overview for an enrolled trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMilestoneProgram: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMilestoneProgram', 'id', id)
            const localVarPath = `/trials/{id}/milestone-program`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trial detail for one of the users trials
         * @param {Language} language 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrialDetail: async (language: Language, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getMyTrialDetail', 'language', language)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMyTrialDetail', 'id', id)
            const localVarPath = `/trials/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of locations for a Trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrialLocations: async (id: string, limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMyTrialLocations', 'id', id)
            const localVarPath = `/trials/{id}/locations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of my trials
         * @param {UserTrialStatus} status 
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {GetUserTrialsOrderBy} [orderBy] 
         * @param {string} [country] Only rows whose matched site is in this country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrials: async (status: UserTrialStatus, language: Language, limit?: number | null, offset?: number | null, orderBy?: GetUserTrialsOrderBy, country?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getMyTrials', 'status', status)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getMyTrials', 'language', language)
            const localVarPath = `/trials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of my contacts
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialContacts: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTrialContacts', 'id', id)
            const localVarPath = `/trials/{id}/contacts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the overview of a patient\'s trials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialsOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trials/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Respond to a trial that\'s eligible or active. (Active can only be rejected)
         * @param {string} id 
         * @param {UserTrialFeedbackBody} userTrialFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondWithFeedback: async (id: string, userTrialFeedbackBody: UserTrialFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('respondWithFeedback', 'id', id)
            // verify required parameter 'userTrialFeedbackBody' is not null or undefined
            assertParamExists('respondWithFeedback', 'userTrialFeedbackBody', userTrialFeedbackBody)
            const localVarPath = `/trials/{id}/feedback`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTrialFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start or stop the my trials flow
         * @param {string} id 
         * @param {UpdateMyTrialBody} updateMyTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyTrialFlow: async (id: string, updateMyTrialBody: UpdateMyTrialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMyTrialFlow', 'id', id)
            // verify required parameter 'updateMyTrialBody' is not null or undefined
            assertParamExists('updateMyTrialFlow', 'updateMyTrialBody', updateMyTrialBody)
            const localVarPath = `/trials/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMyTrialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserTrialsApi - functional programming interface
 * @export
 */
export const UserTrialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserTrialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary return the trial (or research entity) that the patient is currently following the myTrial flow for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentFlow(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentFlowView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentFlow(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getCurrentFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get milestone program overview for an enrolled trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMilestoneProgram(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilestoneProgramOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMilestoneProgram(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getMilestoneProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get trial detail for one of the users trials
         * @param {Language} language 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTrialDetail(language: Language, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTrialDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTrialDetail(language, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getMyTrialDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of locations for a Trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTrialLocations(id: string, limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserTrialLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTrialLocations(id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getMyTrialLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of my trials
         * @param {UserTrialStatus} status 
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {GetUserTrialsOrderBy} [orderBy] 
         * @param {string} [country] Only rows whose matched site is in this country.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTrials(status: UserTrialStatus, language: Language, limit?: number | null, offset?: number | null, orderBy?: GetUserTrialsOrderBy, country?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTrials(status, language, limit, offset, orderBy, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getMyTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of my contacts
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialContacts(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListContactView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialContacts(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getTrialContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the overview of a patient\'s trials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialsOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialsOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialsOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getTrialsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Respond to a trial that\'s eligible or active. (Active can only be rejected)
         * @param {string} id 
         * @param {UserTrialFeedbackBody} userTrialFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondWithFeedback(id: string, userTrialFeedbackBody: UserTrialFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTrialFeedBackView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondWithFeedback(id, userTrialFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.respondWithFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start or stop the my trials flow
         * @param {string} id 
         * @param {UpdateMyTrialBody} updateMyTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyTrialFlow(id: string, updateMyTrialBody: UpdateMyTrialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyTrialFlow(id, updateMyTrialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.updateMyTrialFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserTrialsApi - factory interface
 * @export
 */
export const UserTrialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserTrialsApiFp(configuration)
    return {
        /**
         * 
         * @summary return the trial (or research entity) that the patient is currently following the myTrial flow for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentFlow(options?: RawAxiosRequestConfig): AxiosPromise<CurrentFlowView> {
            return localVarFp.getCurrentFlow(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get milestone program overview for an enrolled trial
         * @param {UserTrialsApiGetMilestoneProgramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMilestoneProgram(requestParameters: UserTrialsApiGetMilestoneProgramRequest, options?: RawAxiosRequestConfig): AxiosPromise<MilestoneProgramOverviewView> {
            return localVarFp.getMilestoneProgram(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get trial detail for one of the users trials
         * @param {UserTrialsApiGetMyTrialDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrialDetail(requestParameters: UserTrialsApiGetMyTrialDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserTrialDetailView> {
            return localVarFp.getMyTrialDetail(requestParameters.language, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of locations for a Trial
         * @param {UserTrialsApiGetMyTrialLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrialLocations(requestParameters: UserTrialsApiGetMyTrialLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListUserTrialLocationView> {
            return localVarFp.getMyTrialLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of my trials
         * @param {UserTrialsApiGetMyTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrials(requestParameters: UserTrialsApiGetMyTrialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListUserTrialView> {
            return localVarFp.getMyTrials(requestParameters.status, requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of my contacts
         * @param {UserTrialsApiGetTrialContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialContacts(requestParameters: UserTrialsApiGetTrialContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListContactView> {
            return localVarFp.getTrialContacts(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the overview of a patient\'s trials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialsOverview(options?: RawAxiosRequestConfig): AxiosPromise<TrialsOverviewView> {
            return localVarFp.getTrialsOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Respond to a trial that\'s eligible or active. (Active can only be rejected)
         * @param {UserTrialsApiRespondWithFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondWithFeedback(requestParameters: UserTrialsApiRespondWithFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserTrialFeedBackView> {
            return localVarFp.respondWithFeedback(requestParameters.id, requestParameters.userTrialFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start or stop the my trials flow
         * @param {UserTrialsApiUpdateMyTrialFlowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyTrialFlow(requestParameters: UserTrialsApiUpdateMyTrialFlowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMyTrialFlow(requestParameters.id, requestParameters.updateMyTrialBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMilestoneProgram operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetMilestoneProgramRequest
 */
export interface UserTrialsApiGetMilestoneProgramRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetMilestoneProgram
     */
    readonly id: string
}

/**
 * Request parameters for getMyTrialDetail operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetMyTrialDetailRequest
 */
export interface UserTrialsApiGetMyTrialDetailRequest {
    /**
     * 
     * @type {Language}
     * @memberof UserTrialsApiGetMyTrialDetail
     */
    readonly language: Language

    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetMyTrialDetail
     */
    readonly id: string
}

/**
 * Request parameters for getMyTrialLocations operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetMyTrialLocationsRequest
 */
export interface UserTrialsApiGetMyTrialLocationsRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetMyTrialLocations
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetMyTrialLocations
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetMyTrialLocations
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetMyTrialLocations
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for getMyTrials operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetMyTrialsRequest
 */
export interface UserTrialsApiGetMyTrialsRequest {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly status: UserTrialStatus

    /**
     * 
     * @type {Language}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly offset?: number | null

    /**
     * 
     * @type {GetUserTrialsOrderBy}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly orderBy?: GetUserTrialsOrderBy

    /**
     * Only rows whose matched site is in this country.
     * @type {string}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly country?: string
}

/**
 * Request parameters for getTrialContacts operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetTrialContactsRequest
 */
export interface UserTrialsApiGetTrialContactsRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetTrialContacts
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetTrialContacts
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetTrialContacts
     */
    readonly offset?: number | null
}

/**
 * Request parameters for respondWithFeedback operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiRespondWithFeedbackRequest
 */
export interface UserTrialsApiRespondWithFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiRespondWithFeedback
     */
    readonly id: string

    /**
     * 
     * @type {UserTrialFeedbackBody}
     * @memberof UserTrialsApiRespondWithFeedback
     */
    readonly userTrialFeedbackBody: UserTrialFeedbackBody
}

/**
 * Request parameters for updateMyTrialFlow operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiUpdateMyTrialFlowRequest
 */
export interface UserTrialsApiUpdateMyTrialFlowRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiUpdateMyTrialFlow
     */
    readonly id: string

    /**
     * 
     * @type {UpdateMyTrialBody}
     * @memberof UserTrialsApiUpdateMyTrialFlow
     */
    readonly updateMyTrialBody: UpdateMyTrialBody
}

/**
 * UserTrialsApi - object-oriented interface
 * @export
 * @class UserTrialsApi
 * @extends {BaseAPI}
 */
export class UserTrialsApi extends BaseAPI {
    /**
     * 
     * @summary return the trial (or research entity) that the patient is currently following the myTrial flow for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getCurrentFlow(options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getCurrentFlow(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get milestone program overview for an enrolled trial
     * @param {UserTrialsApiGetMilestoneProgramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getMilestoneProgram(requestParameters: UserTrialsApiGetMilestoneProgramRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getMilestoneProgram(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get trial detail for one of the users trials
     * @param {UserTrialsApiGetMyTrialDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getMyTrialDetail(requestParameters: UserTrialsApiGetMyTrialDetailRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getMyTrialDetail(requestParameters.language, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of locations for a Trial
     * @param {UserTrialsApiGetMyTrialLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getMyTrialLocations(requestParameters: UserTrialsApiGetMyTrialLocationsRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getMyTrialLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of my trials
     * @param {UserTrialsApiGetMyTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getMyTrials(requestParameters: UserTrialsApiGetMyTrialsRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getMyTrials(requestParameters.status, requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of my contacts
     * @param {UserTrialsApiGetTrialContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getTrialContacts(requestParameters: UserTrialsApiGetTrialContactsRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getTrialContacts(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the overview of a patient\'s trials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getTrialsOverview(options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getTrialsOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Respond to a trial that\'s eligible or active. (Active can only be rejected)
     * @param {UserTrialsApiRespondWithFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public respondWithFeedback(requestParameters: UserTrialsApiRespondWithFeedbackRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).respondWithFeedback(requestParameters.id, requestParameters.userTrialFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start or stop the my trials flow
     * @param {UserTrialsApiUpdateMyTrialFlowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public updateMyTrialFlow(requestParameters: UserTrialsApiUpdateMyTrialFlowRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).updateMyTrialFlow(requestParameters.id, requestParameters.updateMyTrialBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhookApi - axios parameter creator
 * @export
 */
export const WebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Process an outbound message event webhook from Postmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPostmarkEvent: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webhooks/postmark`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookApi - functional programming interface
 * @export
 */
export const WebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Process an outbound message event webhook from Postmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processPostmarkEvent(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processPostmarkEvent(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookApi.processPostmarkEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhookApi - factory interface
 * @export
 */
export const WebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookApiFp(configuration)
    return {
        /**
         * 
         * @summary Process an outbound message event webhook from Postmark
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPostmarkEvent(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.processPostmarkEvent(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookApi - object-oriented interface
 * @export
 * @class WebhookApi
 * @extends {BaseAPI}
 */
export class WebhookApi extends BaseAPI {
    /**
     * 
     * @summary Process an outbound message event webhook from Postmark
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public processPostmarkEvent(options?: RawAxiosRequestConfig) {
        return WebhookApiFp(this.configuration).processPostmarkEvent(options).then((request) => request(this.axios, this.basePath));
    }
}



